import { DiffAddedIcon, ListUnorderedIcon, PlusIcon, SearchIcon, XCircleFillIcon, XIcon, TrashIcon, DashIcon } from '@primer/octicons-react';
import React, { Component, useRef, useState } from 'react';
import { Button, ButtonGroup, Col, Form, InputGroup, Overlay, Row, Tab, Tooltip, Nav, Modal, Dropdown } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid'; //unique id
import { CopyToClipboard } from 'react-copy-to-clipboard'; //copy text to clipboard
import { connect } from 'react-redux'
import FeatherIcon from 'feather-icons-react';
import { confirmAlert } from 'react-confirm-alert';
// react-svg-to-image removed: its inlineStyles() writes 300+ computed CSS props to every live
// DOM node then replaces innerHTML — this corrupts React's fiber references causing ~370 MB
// of heap retention that V8 never GCs. Replaced with DOM-safe clone approach below.
import jsPDF from 'jspdf';
import moment from 'moment';
import { PopoverWrapper, TooltipWrapper } from '../../../AddMethods';
// import html2canvas from 'html2canvas';
import * as htmlToImage from 'html-to-image';
import * as XLSX from "xlsx-js-style";

import { alertService } from '../../../../../_services/alert.service';
import { convertUomtoSym, measureConverter, roundOffDecimal, findBrowserType, FindMaxResult, CalculateRatio, replaceSpecialChars, checkColorIsLight, stringtrim, numOfDecimalsLimit, aiSimulationUser } from '../../../../../_services/common.service'; //stringtrim
import { submitCollection } from '../../../../../_services/submit.service';
import { submitSets } from '../../../../UiComponents/SubmitSets';
import { checkAllowToAdd,checkAllowToAddForExpandNumber, getNameorIdorColorofBox, checkOnShelfBox, TooltipWrapperBrandnsubcat, convertWidthPercent } from '../../../AddMethods'; //TooltipWrapper,
import { checkThroughProductsTest } from '../../../../planograms/planDisplayUnit/additionalcontents';
import { ghostOnDrag, removeGhostImage } from '../../../../common_layouts/ghostDragWrapper';
import {  BlockContextMenu, BlockRectangle, DimensionChangedProdComp, NoSimProductsComp, ReplaceProductsTab, RuleWarningsComp, SaleCycleComp, setGuidlineComman } from './EditSimulateCategoryComps' //ImageRectangle
import PreviewImage from '../../../../common_layouts/image_preview/imagePreview.js';
import EditSimulateClipBoard from './EditSimulateClipBoard'
import i18n from "../../../../../_translations/i18n";
import { products } from '../../../SampleData';
import { mpAftersaveFullScreenObjSetAction, MPCategoryChangesSetAction, mpEditStackHistorySetAction,
    // mpsetClipBoardandotherforCatSetAction,
     mpstackableMarkListAction,
     SimulationNewProductSearchDetailsSetAction} from '../../../../../actions/masterPlanogram/masterplanogram_action'
import { setShouldDownloadAfterRefresh } from '../../../../../actions/simulateAllActions'
import loadinggif from '../../../../../assets/img/loading-sm.gif';
import { AcViewModal } from '../../../../UiComponents/AcImports';
import './EditSimulateCategory.css';
import {elmAccordingtoXY, GetContainingProdsByBox, makemapCatObj, makemapFieldObj, makemaProductsObj, makeRatiofromhieghestField,
getSnappingLocation, findRuleAvailableForBrand, getAllRuleWarnings, validateHeirarchyMissings, makemapactualFieldObj,
GetContainingProdGroupByBox,
elmAccordingtoXYForPeg,
findPegRectBoundaries,
isPegsOverlapping,
makePegBoardObj,
makePegProductsObj,
// clipBoardRedrawObj , convertProductstoFullScreen, convertfieldstoFullScreen
 } from '../mpsimCommenMethods'; //exportSimulationToVMP,
import { catRectEnums, catRuleEnums, MPBoxType, prodNotificationType, simulateSnapshotEnums, SimulationTypesFE, notSimulatedReason } from '../../../../../enums/masterPlanogramEnums';
// import Productpreview from '../../../productsview/productdetails/productpreview';
import { compareAndGetFieldProds, compareAndGetFieldProdsWithoutMerge, PrintCoverPageView } from '../../../MPSimulationCommenMethods';
import { FullRenderProdImage, RenderProdImage, RenderProdRectangle, RenderStackProdImage, RenderStackProdImage2, RenderStackProdRectangle } from '../../../renderProdImage';
import { assistant_medium } from '../../../../../assets/fontsjs/Assistant';
import SimEditToolBox from './simEditToolBOx/SimEditToolBox';
import FullScreenEditModal from './fullScreenEditModal/FullScreenEditModal';
import Switch from "react-switch";
import { InfoIcon, ExcelPrintIcon, PDFPrintIcon, NewReplaceProductIcon, Icons, MPWarnIcon, PDFFieldPrintIcon, ExcelPrintFieldWiseIcon } from '../../../../../assets/icons/icons';
import { TakeBackOverlapWarn } from '../../../contimplement/continueimpl';
import { NewProdStrategyApplyModal } from '../../../auisidebar/newproducts/additionalcomps';
import NoIMage from '../../../../../assets/img/noimage.png';
import MpDropProdAlertBox from '../../../alertBox/MpDropProdAlertBox';
import AddNewItemComponent from '../../../../masterdata/products/AddNew/addnew';
import ExportCSV from '../../../../planograms/planDisplayUnit/productcontent/excelexport';
import NewProductsTab from './newProductsTab';
import DataPanelFilter from './dataPanelFilter/dataPanelFilter';
import DataPanelTab from './dataPanelTab/dataPanelTab';
import { DATA_PANEL_ENRICHMENT_FIELDS } from './dataPanelTab/dataPanelFilterOptions.data';
import { StackRenderProdImage } from '../../../renderProdImage';
import PegBoardTab from './pegBoardTab/pegBoardTab';
import { PEG_BOARD_ADD, PEG_BOARD_EDIT, PEG_BOARD_UPDATE } from '../../../../../constants/pegBoardTypes';
import { LabelTranslations } from '../../../../planograms_v2/constants/headers';

import warningImage from '../../../../../assets/img/icons/warn_full.png';
import warningImageRed from '../../../../../assets/img/icons/warn_full_red.png';
import { isOverlapping, multipleProductOverlapChecking } from '../../../../../utils/simulation';
import PortalWrapper from './portalWrapper';
import category from '../../../../masterdata/chainDepartments/AddNew/category';
import DisplayUnitEdit from './displayUnitEdit/DisplayUnitEdit';
import FieldArrayConfirmModal from '../../../../masterdata/fieldArray/components/FieldArrayConfirmModal';

class EditSimulateCategory extends Component {
    constructor(props){
        super(props);
        this.fullscreendiv=React.createRef();
        this.displaydiv = React.createRef();
        this.displaydivNew = React.createRef();
        this.dragPreviewCanvas = React.createRef(); //drag preview canvas
        this.drawSVG = React.createRef(); //svg draw
        this.svgCreatePoint = null;
        this._isMounted = false;
        this.oriPageXY = {isfirefox: false, x: 0, y: 0};
        this._guideTimeout = null;
        this._dragcleartout=null;
        this._nosimulateprodTimeOut = null;
        this._scprodTimeOut = null;
        this._StackablecallTimeout = null;
        this._loadedProdCountRef = 0;
        this._loadedProdCountFlushTimeout = null;
        this._dropposition = {startX: 0, endX: 0};
        this._changingX=0
        this._changingY=0
        //cut drop object
        this._cutDragObj= { shelfobj: null, shelfidx: -1, fieldobj: null };
        this._importedScrollHeight = 0;
        this._nonEProductsCountTimeout = null;

        this.state = {
            svgViewId: "simulation-mainsvg-view",
            wrapperId:"simulation-edit-wrapper",
            isAddProucts:false,
            newProducts:products,
            catDivHeight:360,
            displayUOM: "cm",
            displayRatio:0,
            loadProdList: [], recentProdList: [], filteredProdList: [], pstartpage: 0, ptotalresults: 0, pmaxcount: 5, //loaded products, recently added products and pagination details
            isListViewActive: "LIST",
            isAllowPan: false, activeTool: "drawBlock", zoomXRatio: 0,
            currentDraggableProd: null, checkSaftyMargin: 1.5, saftyMargin: 3, saleSaftyMargin: 1.5,
            isviewcmenu: false, contxtmenu: {xpos:0, ypos: 0, xidx: 0, scatidx: 0},
            isviewcmenu2: false, contxtmenu2: {xpos:0, ypos: 0,},
            removedProductsCounter:[],
            addedProductsCounter:[],
            isselectprodblock: false,isblockmove: false, currentSelectedBlock: null,
            selectedlocobj: null, //debug view
            currentInternalDraggableProd: null, //field inside selected product
            newrectstart: null,
            isshowdash: false, dashrect: { startx:0, starty: 0, x: 0, y: 0, width: 0, height: 0, percentage: 0 },
            selectedblockpos:null,
            showPreviewImageModal:false, productId:0,
            cutArray:[],
            cutNewArray:[],
            isClipboardreload:false,
            //history points
            historyData: { past: [], present: 0, future: [] },
            // Track changes since last refresh for refresh indicator
            hasChangesSinceLastRefresh: false,
            snappinglimitpx:10,
            clipBoardShow:false, productTab: "dataPanel",
            loadinggif:false,
            xrayActive:4,
            svgdrawDiemention:{drawWidth:0,drawHeight:0},
            mapFields: null,
            // isFieldsMatching: false,
            mapproductList: [],
            mapCatRects: [],
            isRuleWarn: {isshow: false, totalcount: 0}, mapRulesList: [],
            clipDragType: "MULTIPLE",
            isContentDragging: false, //triggers when content dragging inside svg or drop into svg
            nonfilteredNonEProducts:[],
            nonfilteredSCProducts:[],
            isNonSimulatedDataReady: false,
            nonSimProductsCount: 0,
            replaceProds:[],
            noSim_filter:"",
            sc_filter:"",
            selectedCatRect: null,
            isShowFullscreen:false,
            fullScreenRatio:0,
            fullscreenObj:null,
            fullscreenheight:0,
            fullscreensvgdrawDiemention:{drawWidth:0,drawHeight:0},
            PrintFullImg: null,
            printHeight: 2480 ,
            printWidth: 0,
            printRatio: 1,
            printonepagewidthinPX: 3508,
            isShowPreviewModal:false,
            isFieldWisePDFPrint: false,
            selectedProduct:null,
            loadedTagsList:[],
            isFirstTimeDrawguid: false, guideProdList: [],
            loadedprodcount:0,
            printloading:false,
            markablestackable:false,
            stackablemarkArray:[],
            stackableCountofmark:"",
            IsShowStackables:true,
            isPrintingInProgress: false,
            isShowNewProds:false,
            loadingstackablecall:false,
            isStackableEdited:false,
            filteredOtherPrds: [],
            //fullscreen edit  modal
            isSetFullScreenEditModal:false,
            // APverAlert:false,
            isSalesCycle:this.props.isSalesCycle,
            isSCycle:this.props.isSCycle,

            fieldsWithAnomaly:[] ,
            isShowTakeBackError: false, takeBackErrorObj: null,
            TouchedCatRcetList:[],
            relogramPlanogramStatus: 'relogram',

            //preview new prods
            isShowPreviewNewProds: false,

            //strategy apply prods
            isShowStrategyModal: false,
            isShowStrategyHelp: false,
            isSaveApply: false,
            selectedSaveProds: [], notAvailableStrategy: 0,

            droppingShelfList: [],
            isNewClipBoardTouched:false,
            AUISideBarGap: (125+20),
            isDisableEDitingwithfullscreen:false,

            viewSimID: uuidv4(),
            //non sim filters
            nonsimFilter_categoryList:[{value:"-1", label:this.props.t("NONE")}],
            selectedNonSimFilterCat:{value:"-1", label:this.props.t("NONE")},
            nonsimFilter_subcategoryList:[{value:"-1", label:this.props.t("NONE")}],
            selectedNonSimFiltersubCat:{value:"-1", label:this.props.t("NONE")},
            nonsimFilter_brandsList:[{value:"-1", label:this.props.t("NONE")}],
            selectedNonSimFilterBrand:{value:"-1", label:this.props.t("NONE")},
            nonsimFilter_supplierList:[{value:"-1", label:this.props.t("NONE")}],
            selectedNonSimFilterSupp:{value:"-1", label:this.props.t("NONE")},
            isProductDropwarn:false,
            dropWarningList:[],
            selectedwarningdropprod:null,

            //sale cycle filters
            scFilter_categoryList:[{value:"-1", label:this.props.t("Any")}],
            selectedScFilterCat:{value:"-1", label:this.props.t("Any")},
            scFilter_subcategoryList:[{value:"-1", label:this.props.t("Any")}],
            selectedScFiltersubcat:{value:"-1", label:this.props.t("Any")},
            scFilter_brandsList:[{value:"-1", label:this.props.t("Any")}],
            selectedScFilterBrand:{value:"-1", label:this.props.t("Any")},
            scFilter_supplierList:[{value:"-1", label:this.props.t("Any")}],
            selectedScFilterSupp:{value:"-1", label:this.props.t("Any")},
            scFilter_statusList:[{value:"-1", label:this.props.t("Any")}],
            selectedScFilterStat:{value:"-1", label:this.props.t("Any")},
            selectedScProductId: -1,

            //fields count
            actualFieldsCounts: [],

            actualFieldStructures:[],

            ghostWrapperObj: null,
            //prod view
            subcategorylist:[{value:"-1", label:"All Sub Categories"}],
            allBrands:[{value:"-1", label:"All Brands"}],
            // productEditWarningsList:[],
            productSearchText:"",
            isSearchprodutDefault:false,
            isDisableEdits:false,

            //imported view
            newProdTab: "newproducts",

            isDisableEdit: false, //disable edit for certain users

            //excel upload list
            paginationMaxCount: 100,

            //excel upload pagination
            excelUploadPagination: {
                totalCount: 0,
                startIndex: 0,
                available: 0,
                notavailable: 0,
                availableBarcodes: [],
                uploadUUID: null,
            },

            spacefromtopsvgdraw:20,

            // keyPressCount: 0,
            // isDisabled: false,
            dataPanelTab:"product",
            productFilter:[
                {value:"all_product", label: this.props.t('DATA_PANEL.allProducts')},
                {value:"simulated_only", label: this.props.t('DATA_PANEL.simulatedOnly')},
                {value:"not_simulated_only", label: this.props.t('DATA_PANEL.notSimulated')},

            ],
            originalDataPanelList: [],
            filteredList: [],
            selectedBrand: '',
            selectedSubCategory: '',
            selectedCategory: '',
            summaryLoadObj: null, summaryViewObj: null,
            categoryPercentages: [], supplierPercentages: [], subCatRecPercentages: [], brandPercentages: [],loadingNow:false,
            isLoadingDataPanelLambda: false,
            actualFieldStructuresNew: [],
            fullscreenobjs:null,
            mapFields2:[],
        //    allmarkablestackable:false
            fieldWiseExcelDataLabel: [],
            groupBarcodeShelfProducts:[],
            // use for group product expand
            isGroupExpand:false,
            groupExpandLeftSideProduct: {},
            groupExpandRightSideProduct: {},
            isGroupContexMenu: false,
            removeGhost:false,
            rightClickXPos:'',
            rightClickYPos:'', 
            pegList : [],
            isPegDrawing: false,
            storePegDrawing:[],
            drawingPeg:"",
            isPegDrawingShowdash: false, 
            pegDashrect: { startx:0, starty: 0, x: 0, y: 0, width: 0, height: 0, percentage: 0 },
            pegRecList:[],
            newPegrectstart: null,
            currentSelectedRecBlock:{},
            enableNextPegBoardSetting : false,
            cursorChangeToPeg:false,
            convertedUOM:'meters',
            isRectDrawingCompleted:false,
            pegProductList:[],
            // peg product drag and drop
            droppedToPegBoard:{
                isDroppedPegBoard: false,
                insideHalfPegBoard: false,
                droppedPegBoard: null,
                droppedX: 0,
                droppedY: 0,
            },
            getWideViewSettings:null,
            getModuleViewSettings:null,
            moduleDetailedData: [],
            mapproductList2:[],
            mapproductList2New:[],
            mapproductList3forPdf:[],
            isPdfPrintClick:false,
            isPdfExporting:false,
            scalePegBoardObj:[],
            CategoryWisescalePegBoardObj:[],
            isExcelPrintClick:false,

            excelExportSaveObj: [],
            isPegBoardOverlapping: false,
            tempCurrentSelectedBlock:null,
            showWarningModal: false,
            toggleAllStackable:false,
            is_hangable:'all',
            searchQuery:[],
            searchFilterList: [],
            formValue: 30,

            // dataPanelExcelData : []

            // SIMULATION-REVAMP-CHANGES 
            categoryPercentages: [], supplierPercentages: [], subCatRecPercentages: [], brandPercentages: [],loadingNow:false,
            // DU EDIT CR
            showDUEditComponent:false,
            distanceFromTop:0,
            isLoadingDataPanelLambda: false,
            topProductHeights: [],
            isDisplayUnitEdited:false,
            isShowShelfDifferentCopyArrangementModal: false,
            isShelfMismatchWarningShown: false,
            setUnsavedChangesModalData: {
                title: '',
                desc: '',
                callBack: () => {}
            },
            deepClonePegList: []
        }
    }

    componentDidMount(){
        this._isMounted = true;

        // Pass processLambdaDataPanelResult reference to parent
        // if (this.props.setProcessLambdaDataPanelResult) {
        //     this.props.setProcessLambdaDataPanelResult(this.processLambdaDataPanelResult);
        // }

        // Add window focus event listener to handle app returning from idle
        // this.isWindowBlurred = false;

        // this.handleWindowBlur = () => {
        //     this.isWindowBlurred = true;
        // };
        
        // this.handleWindowFocus = () => {
        //     // Only run if window was previously blurred (returning from idle)
        //     if (this.isWindowBlurred) {
        //         this.processLambdaDataPanelResult();
        //         this.isWindowBlurred = false;
        //     }
        // };
        
        // window.addEventListener('blur', this.handleWindowBlur);
        // window.addEventListener('focus', this.handleWindowFocus);

        if(this._isMounted){
            // let reduceamount = (this.props.simType !== "AUI" || this.props.isShowFromPreview?150:(this.props.isSetFullScreenEditModal?130:60));
            let reduceamount = 7;
            var ccatDivHeight=this.displaydiv.current ? ((this.displaydiv.current.offsetHeight - reduceamount)) : 0;
            var maxresult = FindMaxResult(ccatDivHeight,106,250)
            // console.log(this.props.mpstate);

            let simProdSearchData = this.props.mpstate?.simulationProductSearchData;
            // console.log(simProdSearchData);
            this.setState({
                isClipboardreload:true,
                pmaxcount:maxresult.maxresultCount<6?5:maxresult.maxresultCount,
                catDivHeight: ccatDivHeight,
                selectedCatRect: this.props.selectedCatRect,
                svgViewId: (this.props.mainViewId?this.props.mainViewId:this.state.svgViewId),
                wrapperId:(this.props.SimWrapperId?this.props.SimWrapperId:this.state.wrapperId),
                isDisableEDitingwithfullscreen:this.props.simType&&this.props.simType===SimulationTypesFE.IsleAllocation,
                isDisableEdits:this.isEditabledisable(),
                productSearchText:(simProdSearchData && simProdSearchData.text)?simProdSearchData.text:this.state.productSearchText,
                // isAddProucts:(this.props.mpstate?.simulationProductSearchData!==null)?true:this.state.isAddProucts,  // mpstate no longer exists in preplan flow
                isSearchprodutDefault:(this.props.mpstate?.simulationProductSearchData!==null)?true:false
            },()=>{
                //if warning prod details available
                if(simProdSearchData && simProdSearchData.warnProd){
                    this.setState({ selectedwarningdropprod: simProdSearchData.warnProd }, () => {
                        this.reloadProdWarnModalDetails(true);
                    });
                }

                //update edit disabled state
                if(typeof this.props.updateSimDisabled === "function"){
                    this.props.updateSimDisabled(this.state.isDisableEdits);
                }

                this.setState({nonfilteredSCProducts:this.props.productsWithAnomaly},()=>{
                    this.props.setSimulationNewProductSearchDetails(null)
                    this.mapobjectsdraw("firsttime");
                    this.getAllTags();
                    this.getbrandsforFilter()
                    this.getAllStatus();
                    this.getAllCategoriesFromDepartment()
                    this.getSupplierList()
                    this.getSubCategoriesnonSimFilter()
                    this.getAllSubCategories();
                    this.loadAllBrands();
                    this.allDataPanelData();
                    this.loadWideViewSettings();
                    this.loadFieldViewSettings();
                    this.loadModuleDetailedData(); //Maccabi
                    this.loadExcelLabelData(); //Load field-wise excel column configuration
                    //this.calculateDrawingobject2()
                    // this.fetchDataPanelExcelData()
                    this.processLambdaDataPanelResult();
                    this.loadImportProdList(true);
                    // Calculate top gap between svg and page top
                    this.calculateTopGap();

                })
                // Recalculate on window resize - Calculate top gap between svg and page top
                window.addEventListener('resize', this.calculateTopGap);
            })

            

            //handle keydown - arrows key actions
            document.addEventListener("keydown", this.typingKeyHandling, false);
            //if firefox
            if(findBrowserType() === "firefox"){
                document.addEventListener("dragover", this.getPageXYCords, false);
            }
            if(this.props.isopenfirsttime) {
                this.warningifnotdefualt()
            }
        }

        if(this.props.simType === "AUI" || this.props.simType === "Normal"){
            if(this.props.mapProducts){
                const filteredOtherProduct = this.props.selectedCatRect.selectedCat?this.props.mapProducts.filter(obj => obj.field_custom_id !== this.props.selectedCatRect.selectedCat.field_custom_id ):this.props.mapProducts;
                this.setState({filteredOtherPrds: filteredOtherProduct});
            }
        }
    }

    componentWillUnmount(){
        this._isMounted = false;

        document.removeEventListener("keydown", this.typingKeyHandling, false);
        document.removeEventListener("dragover", this.getPageXYCords, false);
        window.removeEventListener('blur', this.handleWindowBlur);
        window.removeEventListener('focus', this.handleWindowFocus);
        window.removeEventListener('resize', this.calculateTopHeight);
        if(this._nosimulateprodTimeOut){ clearTimeout(this._nosimulateprodTimeOut) }
        if(this._scprodTimeOut){ clearTimeout(this._scprodTimeOut) }
        if(this._guideTimeout){ clearTimeout(this._guideTimeout) }
        if(this._nonEProductsCountTimeout){ clearTimeout(this._nonEProductsCountTimeout) }

        window.onbeforeunload = undefined
    }

    componentDidUpdate = (prevProps, prevState) => {
        // Process Lambda Data Panel result when simulationObj changes
        if (this.props.simulationObj && prevProps.simulationObj !== this.props.simulationObj) {
            this.processLambdaDataPanelResult();
        }

        // Calling processLambdaDataPanelResult function from parent component - 2025 Oct
        // Pass processLambdaDataPanelResult reference to parent
        if (this.props.setProcessLambdaDataPanelResult) {
            this.props.setProcessLambdaDataPanelResult(this.processLambdaDataPanelResult);
        }

        
        this.props.getUpadtedProductFromEDSC?.(this.state.mapproductList)
        //shows warning changes available when existing from current field
        if (this.state.isStackableEdited) {
        window.onbeforeunload = (e) => {
            e.returnValue = 'wait';
            return false
        }
        } else {
        window.onbeforeunload = undefined
        }

        if(this.props.simType === "AUI" && !this.props.isNewProdSim && this.props.isSalesCycle === false && this.state.productTab === 'saleCycle'){
            this.setState({productTab: 'products', selectedScProductId: -1})
        }

        if(this.props.simType === "AUI" && this.props.isFullscreenEditModal && (this.props.isSalesCycle !== this.state.isSalesCycle)){
            this.setState({isSalesCycle: this.props.isSalesCycle});
        }

        if(this.props.simType === "AUI" && this.props.isNewProdSim && (this.props.isSCycle !== this.state.isSCycle)){
            this.setState({isSCycle: this.props.isSCycle},()=>{
                if(!this.state.isSCycle){
                    this.setState({productTab: 'products', selectedScProductId: -1})
                }
            })
        }

        if(this.props.simType === "Normal" && (this.props.isSCycle !== this.state.isSCycle)){
            this.setState({isSCycle: this.props.isSCycle},()=>{
                if(!this.state.isSCycle){
                    this.setState({productTab: 'products', selectedScProductId: -1})
                }
            })
        }

        if(this.props.isSaleCycleUpdated){
            this.setState({nonfilteredSCProducts: this.props.productsWithAnomaly}, () => {
                this.props.updateIsSaleCycleUpdated(false)
                this.handleFilterSCProducts("",true)
            })
        }

        if (this.props.addedNewPegBoard !== this.state.pegList) {
            // Pass updated pegList to the parent (through callback or directly via props)
            this.props.updateParentPegBoards?.(this.state.pegList);
        }
    }

    // Calculate and update the distance from the top of the page to the top of the SVG element
    calculateTopGap = () => {
        const simulationDiv = document.getElementById(this.state.wrapperId);
        const rect = simulationDiv.getBoundingClientRect();
        const distanceFromTop = rect.top + window.scrollY;
        this.setState({ distanceFromTop });
    }

    isEditabledisable = () => {
        var retunans = false;
        if(
            /* this.props.simType === "AUI" &&
            (
                (!this.props.isShowFromPreview && this.props.isSetFullScreenEditModal &&
                ((this.props.originatedMpId && this.props.originatedMpId === -1) || (this.props.originatedMpId === this.props.defSaveObj.mp_id)) &&
                ((this.props.storeId > -1) || (this.props.storeId === -1 && this.props.selectedTagList.length > 0))) ||

                (!this.props.isShowFromPreview && !this.props.isSetFullScreenEditModal &&
                ((this.props.originatedMpId && this.props.originatedMpId === -1) || (this.props.originatedMpId === this.props.defSaveObj.mp_id)) &&
                ((this.props.storeId > -1) || (this.props.storeId === -1 && this.props.selectedTagList.length > 0)))
            ) */

            this.props.simType === "AUI" && this.props.storeId && this.props.storeId > 0 &&
            this.props.originatedMpId > -1 && this.props.isStoreReset === false
        ){
            retunans = true;
        }

        return retunans;
    }

    // fetchDataPanelExcelData = () => {
    //     submitSets(submitCollection.dataPanalExcelReportData_v2, {
    //         editionId: 216,
    //         fieldArrayId: 246
    //     }, false)
    //     .then(res => {
    //         if(res && res.status){
    //             console.log(res.extra)
    //             this.setState({dataPanelExcelData : res.extra })
    //         }
    //     })
    // }


    loadWideViewSettings = () => {
        submitSets(submitCollection.getWideViewSettings, null, false)
        .then(res => {
            if(res && res.status){
                this.setState({getWideViewSettings: res.extra})
            }
        })
    }

    loadFieldViewSettings = () => {
        submitSets(submitCollection.getFieldViewSettings, null, false)
        .then(res => {
            if(res && res.status){
                this.setState({getModuleViewSettings: res.extra})
            }
        })
    }

    // loadModuleDetailedData Maccabi
    loadModuleDetailedData = () => {
        submitSets(submitCollection.getModuleDetailedData, null, false)
            .then((res) => {
                if (res && res.status) {
                    this.setState({ moduleDetailedData: res.extra });
                }
            });
    }

    // Function to call submitSets and update state
    loadExcelLabelData = () => {

    submitSets(submitCollection.getModuleDetailedExcelData, null)
      .then(res => {
        if (res && res.status === true && res.extra) {
         const filteredData = res.extra.filter(item => item.status === "online"); // filter to get only online status values
         this.setState({
            fieldWiseExcelDataLabel: filteredData
         })
        }
      })
     
  };
    loadAllBrands = () =>{
        let sobj = {isReqPagination:false}
        submitSets(submitCollection.searchBrand, sobj, false).then(res => {
            var cdata = [{value:0, label:""}];
            if(res && res.status){
                for (let i = 0; i < res.extra.length; i++) {
                    cdata.push({value:res.extra[i].brandId, label:res.extra[i].brandName});
                }
                this.setState({allBrands:cdata});
            }
        });
    }
    getAllSubCategories = () =>{
        var obj = {isReqPagination:false};
        submitSets(submitCollection.getFullListOfSubCategories, obj, false).then(resp => {
            let arr = [{value:0, label:""}];
            if(resp && resp.status){
                for (let i = 0; i < resp.extra.length; i++) {
                    arr.push({
                        value:resp.extra[i].subCategoryId,
                        label:resp.extra[i].subCategoryName,
                    });

                }
                this.setState({subcategorylist:arr});
            }
        });
    }

    getAllStatus = () =>{

        let arr = [{value:0, label:""}];

        let statArr = ["Normal","High","Low","No Sales"];
        let enumArr = ["no","high","low","no_data"];

        for(let i=0; i<statArr.length; i++){
            let obj = {
                value: enumArr[i],
                label: statArr[i]
            }
            arr.push(obj);
        }

        this.setState({scFilter_statusList: arr})
    }

    // OLD FUNCTION
    // TouchedCatListUpdate=(catid,isrest)=>{
    //     if(isrest){
    //         this.setState({TouchedCatRcetList:[]})
    //     }else{
    //         var alreadyhave=this.state.TouchedCatRcetList.includes(catid)
    //         var array=this.state.TouchedCatRcetList
    //         if(!alreadyhave){
    //             array.push(catid);
    //             this.setState({TouchedCatRcetList:array})
    //         }
    //     }
    // }
    // OLD FUNCTION
    // NEW FUNCTION
    TouchedCatListUpdate = (catid, isReset) => {
        if (isReset) {
            this.setState({ TouchedCatRcetList: [] });
        } else {
            this.setState(prevState => {
                if (!prevState.TouchedCatRcetList.includes(catid)) {
                    return { TouchedCatRcetList: [...prevState.TouchedCatRcetList, catid] };
                }
                return null;
            });
        }
    };
    // NEW FUNCTION
    //show warning if sim count not equal to defualt or select any tag or branch
    warningifnotdefualt=()=>{
        var srobj=this.props.simulateSearchObj

        if(srobj && ((srobj.fieldCount!==this.props.bottomFieldCount)) && this.props.isopenfirsttime){
            // this.showvmpbackWarning()
            this.props.toggleopenfirsttime(false)
        }
    }
    showvmpbackWarning=()=>{
        confirmAlert({
            title: this.props.t('WARNING_S'),
            message: this.props.t("THIS_CHANGES_MAYBE_CANNOT_BACKTO_VMP"),
            overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
            buttons: [{
                label: this.props.t('OKAY'),
                onClick: () => {
                    return false;
                }
            }]
        });
    }
    //load all tags
    getAllTags = () => {
        let sobj = {isReqPagination: false, type:"store", tagName: ""}
        submitSets(submitCollection.searchTags, sobj).then(res => {
            if(res && res.status && res.extra){
                this.setState({
                    loadedTagsList: res.extra,
                });
            }
        });
    }
    mapobjectsdraw=(type, skipPegProduct = false)=>{
        let simLoadedObj = this.props.allCategoryData;
        let actualFieldsCounts = (simLoadedObj?simLoadedObj.actualFieldStructures:[]);
        var cobj = JSON.parse(JSON.stringify(this.state.selectedCatRect));

        // find selected cluster details from filtered cluster list
        const cluster = this.props.clusterData.find(
            (item) => item.id === this.props.selectedClusterId
        );

        // find fieldList of selected field array - 2025 NOV
        const actualDisplayUnits = cluster?.clusterFieldArrays.find(
            (item) => item.fieldArrayId === this.props.selectFieldArrayId)?.fieldArray?.fieldsArrayHasFields;

        if(cobj && cobj.fieldList){
            var cfieldList=cobj.fieldList
            var cproductList=cobj.products
            var cCatList=cobj.categoryList
            const actualFieldStructures  = cobj?.actualFieldStructures || simLoadedObj?.actualFieldStructures;
            // var disabledFeildList = disableFieldShelves(cfieldList,cobj)
            // cfieldList = disabledFeildList.fieldlist;;
            var dimention = makeRatiofromhieghestField(cfieldList, this.state.displayUOM, (this.state.catDivHeight - this.state.spacefromtopsvgdraw)); //- this.state.spacefromtopsvgdraw
            this.setState({ displayRatio: dimention }, () => {
                var mapF=makemapFieldObj(cfieldList,this.state.displayUOM,this.state.displayRatio,this.state.catDivHeight, actualFieldsCounts, actualDisplayUnits);
                var cmapfieldObj= mapF.mapfieldObj;
                var cactualFieldStructures=makemapactualFieldObj(structuredClone(this.props.actualFieldStructures),this.state.displayUOM,this.state.displayRatio,this.state.catDivHeight, actualFieldsCounts);
                var cactualFieldStructures2=makemapactualFieldObj(structuredClone(actualFieldStructures),this.state.displayUOM,this.state.displayRatio,this.state.catDivHeight, actualFieldStructures);
                let previewobj = this.props.selectedSimPreviewObj;
                let previewProdList = (previewobj && previewobj.selectedProds && previewobj.selectedProds.length > 0?previewobj.selectedProds:[]);

                var cmapproductsObj=makemaProductsObj(cproductList,this.state.displayUOM,this.state.displayRatio,cmapfieldObj, this.props.isShowFromPreview, previewProdList);

                var cmapCatList=makemapCatObj(cCatList,this.state.displayUOM,this.state.displayRatio,cmapfieldObj)

                let catRulesList = (cobj.rulesList?cobj.rulesList:[]);
                let cruleWarnings = getAllRuleWarnings(cmapCatList, catRulesList, cmapproductsObj, true);
                let cnotsimprods = (cobj && cobj.non_sim_prodlist?cobj.non_sim_prodlist:[]);
                let replaceProds= (cobj && cobj.replaceProdList?cobj.replaceProdList:[]);
                // var OriprevClipBoardnOtherArray=(this.props.mpstate.mpClipoardnOther.length>0)&&this.props.mpstate.mpClipoardnOther.find(x=>x.mp_id===this.props.defSaveObj.mp_id)
                // var prevClipBoardnOtherArray=OriprevClipBoardnOtherArray?clipBoardRedrawObj(OriprevClipBoardnOtherArray,this.state.displayRatio):undefined
                
                if(replaceProds.length > 0){
                    replaceProds = replaceProds.sort((a, b) => (a.replacedProducts[0].barcode - b.replacedProducts[0].barcode));
                }
                var fullscreenobjs={
                    fields: mapF.mapfieldObj,
                    products: cmapproductsObj
                }

                //initialize peg board list
                let cpegBoardList = makePegBoardObj(this.state.isDisplayUnitEdited ? this.state.deepClonePegList : this.props.mapPegBoard, this.state.displayUOM, this.state.displayRatio);

                // Update shelfIDs for existing pegboards that intersect with shelves
                cpegBoardList = this.updatePegBoardShelfIDs(cpegBoardList, cmapfieldObj);

                let cpegProductList = makePegProductsObj(this.props.mapPegProducts, this.state.displayUOM, this.state.displayRatio, cpegBoardList, false, this.props.pegProductOriginalList)
                // Add peg products to cmapproductsObj
                if(cpegProductList && cpegProductList.length > 0 && !skipPegProduct){
                    cmapproductsObj = cmapproductsObj.concat(cpegProductList);
                }
                if(this.state.pegProductList && skipPegProduct){
                    // In case of skipPegProduct is true, it means we are redrawing the peg products from state (like after editing display unit), 
                    // so we need to add those peg products from state to cmapproductsObj
                    cmapproductsObj = cmapproductsObj.concat(this.state.pegProductList);
                }


                this.setState({
                    //fullscreenobjs:fullscreenobjs,
                    actualFieldStructures:cactualFieldStructures.mapfieldObj,
                    //actualFieldStructuresNew: cactualFieldStructures2,
                    actualFieldsCounts: actualFieldsCounts,
                    nonfilteredNonEProducts: cnotsimprods,
                    // productEditWarningsList:cobj.productEditWarningsList?cobj.productEditWarningsList:[],
                    replaceProds:replaceProds,
                    svgdrawDiemention:{drawWidth:mapF.svgWidth,drawHeight:0},
                    mapFields:cmapfieldObj,
                    //mapFields2:mapF,
                    // isFieldsMatching: disabledFeildList.isfieldsmatching,
                    mapproductList:cmapproductsObj,
                    mapCatRects:cmapCatList,

                    isRuleWarn: cruleWarnings.iswarn,
                    mapRulesList: cruleWarnings.rulelist,

                    historyData: { past: [], present: 0, future: [] },
                    currentInternalDraggableProd: null,
                    currentSelectedBlock: null,
                    contxtmenu: { isexpand: false },
                    productTab: "dataPanel",
                    xrayActive: 4,
                    pegList:cpegBoardList?cpegBoardList:[],
                    pegProductList: cpegProductList ? cpegProductList : [],
                    tempCurrentSelectedBlock:null
                    //pegList:this.props.simulationObj?.pegBoards

                    //clip board cache set commenting
                    // cutArray:prevClipBoardnOtherArray?prevClipBoardnOtherArray.cutpastelist:this.state.cutArray,
                    // removedProductsCounter:prevClipBoardnOtherArray?prevClipBoardnOtherArray.removeprodlist:this.state.removedProductsCounter,
                    // addedProductsCounter:prevClipBoardnOtherArray?prevClipBoardnOtherArray.addprodlist:this.state.addedProductsCounter,
                },()=>{
                    
                    if(this.state.isSearchprodutDefault){
                        this.handleFilterProducts({target:{value:this.state.productSearchText},nativeEvent:{which: 13}},true)
                    }
                    if(type==="firsttime"&&(this.props.isFullScreenEdit)){
                        if(this.props?.mpstate?.mpStackableProdList){
                            var prodlist=this.state.mapproductList
                            //mark show products stack boolean
                            for (let i = 0; i < prodlist.length; i++) {
                                const prod = prodlist[i];
                                var have=this.props.mpstate.mpStackableProdList.find(x=>x.productId===prod.productId)
                                if(have){
                                    prod.isStackable=have.isStackable
                                }
                            }
                            this.setState({mapproductList:prodlist},()=>{
                                this.props.setMpEditStackHistory(null)
                                this.initSVGCreatePoint();
                            })
                        }else{
                            this.props.setMpEditStackHistory(null)
                            this.initSVGCreatePoint();
                        }
                    } else{
                        this.props.setMpEditStackHistory(null)
                        this.initSVGCreatePoint();
                    }

                    if(type === "firsttime"){
                        //if print pending
                        // if(this.props.isPrintPending){
                        //     this.setState({ isFieldWisePDFPrint: this.props.isFieldWisePDFPrint }, () => {
                        //     console.log("11")
                        //         this.excelPrint();
                        //     });
                        // }

                        if(this.props.isPDFPrintPending){
                            this.setState({ isFieldWisePDFPrint: this.props.isFieldWisePDFPrint }, () => {
                                this.gotprintStart();
                            });
                        }

                        if (this.props.isExcelPrintClick) {
                            this.setState({ isFieldWisePDFPrint: this.props.isFieldWisePDFPrint }, () => {
                                this.gotPrintExcel()
                            
                        });
                        }

                        if(this.props.isPdfPrintClick){
                            // console.log("first")
                            this.setState({ isFieldWisePDFPrint: this.props.isFieldWisePDFPrint }, () => {
                                this.gotprintStart();
                            });
                        }

                        this.props.togglePrintPending(null, false, true);
                    }

                    // flag to call groupByProduct2 after groupByProduct completes
                    this._callGroupByProduct2After = true;
                    this.groupByProduct();
                    if(this.state.pegList && this.state.pegList?.length > 0){
                        this.setState({
                            enableNextPegBoardSetting:true
                        })
                    }

                    // after copy arrangement shelf mismatch then show alert once - 2026 FEB - DU EDIT CR
                    this.checkAndShowCopyArrangementShelfMismatch();
 
                })

                this.drawClipboardfromback()                
            })
        }


    }

    //get pagexy cords
    getPageXYCords = (evt) => {
        this.oriPageXY = {isfirefox: true, x: evt.clientX, y: evt.clientY};
    }
    // shortcuts and arrow key handlers
    // old method
    typingKeyHandling = (evt) => {
        var ecode = evt.keyCode; //current key code
        if (ecode === 37) { //left arrow
            if (this.state.contxtmenu) {
                evt.preventDefault();
                const haveHanggedProduts = this.checkSelectedMovingProductBlockHaveHanggedProducts(this.state.currentSelectedBlock);
                if(haveHanggedProduts === "HANGED_PRDUCTS_ONLY"){
                    // handle hangable products movements
                    this.handlePegProductMovement("left");
                }else if(haveHanggedProduts === "MIXING_PRODUCTS"){
                    // return if select both products
                    alertService.error(this.props.t('CANNOT_MOVE_MIXING_PRODUCTS'),4000);
                    return;
                }else{
                    // handle normal products movements
                    this.dragmultiplyProducts("left");
                }
            }
        } else if (ecode === 39) { //right arrow
            if (this.state.contxtmenu) {
                evt.preventDefault();
                const haveHanggedProduts = this.checkSelectedMovingProductBlockHaveHanggedProducts(this.state.currentSelectedBlock);
                if(haveHanggedProduts === "HANGED_PRDUCTS_ONLY"){
                    // handle hangable products movements
                    this.handlePegProductMovement("right");
                }else if(haveHanggedProduts === "MIXING_PRODUCTS"){
                    // return if select both products
                    alertService.error(this.props.t('CANNOT_MOVE_MIXING_PRODUCTS'),4000);
                    return;
                }else{
                    // handle normal products movements
                    this.dragmultiplyProducts("right");
                }
            }
        } else if(ecode === 38){ // up arrow
            if (this.state.contxtmenu) {
                evt.preventDefault();
                const haveHanggedProduts = this.checkSelectedMovingProductBlockHaveHanggedProducts(this.state.currentSelectedBlock);
                if(haveHanggedProduts === "HANGED_PRDUCTS_ONLY"){
                    // handle hangable products movements
                    this.handlePegProductMovement("up");
                }else if(haveHanggedProduts === "MIXING_PRODUCTS"){
                    // return if select both products
                    alertService.error(this.props.t('CANNOT_MOVE_MIXING_PRODUCTS'),4000);
                    return;
                }
            }
        } else if(ecode === 40){ // down arrow
            if (this.state.contxtmenu) {
                evt.preventDefault();
                const haveHanggedProduts = this.checkSelectedMovingProductBlockHaveHanggedProducts(this.state.currentSelectedBlock);
                if(haveHanggedProduts === "HANGED_PRDUCTS_ONLY"){
                    // handle hangable products movements
                    this.handlePegProductMovement("down");
                }else if(haveHanggedProduts === "MIXING_PRODUCTS"){
                    // return if select both products
                    alertService.error(this.props.t('CANNOT_MOVE_MIXING_PRODUCTS'),4000);
                    return;
                }
            }
        }
        else if (ecode === 46) {
            this.pressShortcuts("delete")

        } else if ((evt.ctrlKey || evt.metaKey) && ecode === 88) {
            this.pressShortcuts("cut")
        } else if ((evt.ctrlKey || evt.metaKey) && ecode === 67) {
            this.pressShortcuts("copy")
        } else if ((evt.ctrlKey || evt.metaKey) && ecode === 90) {
            this.pressShortcuts("undo")
        } else if ((evt.ctrlKey || evt.metaKey) && ecode === 89) {
            this.pressShortcuts("redo")
        } else if (ecode === 27) { // ESC key
            if (this.state.showDUEditComponent) {
                // If DU edit panel is open, don't handle ESC here - let DisplayUnitEdit handle it
                return;
            } else if (this.props.isFullScreenEdit) {
                evt.preventDefault();
                this.onHideCheck();
            }
        }
        else {


        }
    }

    // new method
    // typingKeyHandling = (evt) => {
    //     const ecode = evt.keyCode;

    //     // Process only left and right arrow keys
    //     if (ecode === 37 || ecode === 39) {
    //         evt.preventDefault();

    //         // If already disabled, don't process further
    //         if (this.state.isDisabled) {
    //             return;
    //         }

    //         const now = Date.now();

    //         // Initialize lastKeyPressTime if it doesn't exist
    //         if (!this.lastKeyPressTime) {
    //             this.lastKeyPressTime = now;
    //         }

    //         // Calculate time difference
    //         const timeDiff = now - this.lastKeyPressTime;

    //         // Update state
    //         this.setState(prevState => {
    //             let newCount = prevState.keyPressCount;
    //             let newIsDisabled = prevState.isDisabled;

    //             // If it's been less than 1 second since the last key press, increment the count
    //             if (timeDiff < 1000) {
    //                 newCount += 1;

    //                 // If count reaches 10, disable input
    //                 if (newCount >= 10) {
    //                     newIsDisabled = true;
    //                     alertService.error(this.props.t('TOO_MANY_KEY_PRESS_ERROR'));

    //                     // Set a timeout to re-enable input after 0.5 second
    //                     setTimeout(() => {
    //                         this.setState({
    //                             isDisabled: false,
    //                             keyPressCount: 0
    //                         });
    //                         this.lastKeyPressTime = null;
    //                     }, 500);
    //                 }
    //             } else {
    //                 // If it's been more than 1 second, reset the count
    //                 newCount = 1;
    //             }

    //             // Update lastKeyPressTime
    //             this.lastKeyPressTime = now;

    //             return {
    //                 keyPressCount: newCount,
    //                 isDisabled: newIsDisabled
    //             };
    //         });

    //         // Process the key press if not disabled
    //         if (!this.state.isDisabled && this.state.contxtmenu) {
    //             if (ecode === 37) {
    //                 this.dragmultiplyProducts("left");
    //             } else if (ecode === 39) {
    //                 this.dragmultiplyProducts("right");
    //             }
    //         }
    //     } else {
    //         // Handle other key presses as before
    //         if (ecode === 46) {
    //             this.pressShortcuts("delete");
    //         } else if ((evt.ctrlKey || evt.metaKey) && ecode === 88) {
    //             this.pressShortcuts("cut");
    //         } else if ((evt.ctrlKey || evt.metaKey) && ecode === 67) {
    //             this.pressShortcuts("copy");
    //         } else if ((evt.ctrlKey || evt.metaKey) && ecode === 90) {
    //             this.pressShortcuts("undo");
    //         } else if ((evt.ctrlKey || evt.metaKey) && ecode === 89) {
    //             this.pressShortcuts("redo");
    //         }
    //     }
    // };
    pressShortcuts=(type)=>{
        if(!(this.state.isviewcmenu||this.state.isviewcmenu2)){
            var selcurobj = this.state.currentInternalDraggableProd;
            if(selcurobj&&this.state.currentSelectedBlock){
                if(type==="delete"){
                    this.handleBlockCut(false,true)
                }else if(type==="cut"){
                    this.handleBlockCut(false,false)
                }else if(type==="copy"){
                    this.handleBlockCut(true,false)
                }
            }
            if(type==="undo"){
                if(this.state.historyData.past.length>0 ){
                    this.fieldHistoryUndo()
                }
            }else{
                if(type==="redo"){
                    if(this.state.historyData.future.length>0 ){
                        this.fieldHistoryRedo()
                    }
                }
            }
        }
    }
    // cacheClipboardandOther=()=>{
    //     let removeprodlist = JSON.parse(JSON.stringify(this.state.removedProductsCounter));
    //     let addprodlist = JSON.parse(JSON.stringify(this.state.addedProductsCounter));
    //     let cutpastelist = JSON.parse(JSON.stringify(this.state.cutArray));
    //     var prevclipboardarray=this.props.mpstate.mpClipoardnOther
    //     // var filteredPrevclipboardarray=(prevclipboardarray.length>0)?prevclipboardarray.filter(x=>x.catId!==this.state.selectedCatRect.selectedCat.id):[]
    //     var filteredPrevclipboardarray=(prevclipboardarray.length>0)?prevclipboardarray.filter(x=>x.mp_id!==this.props.defSaveObj.mp_id):[]

    //     var obj={
    //         // catId:this.state.selectedCatRect.selectedCat.id,
    //         mp_id:this.props.defSaveObj.mp_id,
    //         addprodlist:addprodlist,
    //         removeprodlist:removeprodlist,
    //         cutpastelist:cutpastelist,
    //     }
    //     filteredPrevclipboardarray.push(obj)

    //     this.props.setMpClipBoardsforCats(filteredPrevclipboardarray)
    // }
    // cacheClipboardandOtherOnlyCutProdsReplace=()=>{
    //     let cutpastelist =this.state.cutArray;
    //     var prevclipboardarray=this.props.mpstate.mpClipoardnOther
    //     // var filteredPrevclipboardarray=(prevclipboardarray.length>0)?prevclipboardarray.filter(x=>x.catId!==this.state.selectedCatRect.selectedCat.id):[]
    //     // var havesamecat=(prevclipboardarray.length>0)?prevclipboardarray.find(y=>y.catId===this.state.selectedCatRect.selectedCat.id):undefined
    //     var filteredPrevclipboardarray=(prevclipboardarray.length>0)?prevclipboardarray.filter(x=>x.mp_id!==this.props.defSaveObj.mp_id):[]
    //     var havesamecat=(prevclipboardarray.length>0)?prevclipboardarray.find(y=>y.mp_id===this.props.defSaveObj.mp_id):undefined
    //     var obj={
    //         // catId:this.state.selectedCatRect.selectedCat.id,
    //         mp_id:this.props.defSaveObj.mp_id,
    //         addprodlist:[],
    //         removeprodlist:[],
    //         cutpastelist:cutpastelist,
    //     }
    //     if(havesamecat){
    //         var obj2=havesamecat
    //         obj2["cutpastelist"]=cutpastelist
    //         filteredPrevclipboardarray.push(obj2)

    //     }else{
    //         filteredPrevclipboardarray.push(obj)
    //     }


    //     this.props.setMpClipBoardsforCats(filteredPrevclipboardarray)
    // }
    //manage changes history
    fieldHistoryAdd = (csobj, type) => {
        ///type=1 add item, type=2 delete item, type=3 move item
        const MAX_HISTORY_STEPS = 40;

        let removeprodlist = JSON.parse(JSON.stringify(this.state.removedProductsCounter));
        let addprodlist = JSON.parse(JSON.stringify(this.state.addedProductsCounter));
        // let cutpastelist = JSON.parse(JSON.stringify(this.state.cutArray));
        let cutnewpastelist = JSON.parse(JSON.stringify(this.state.cutNewArray));
        let rulelist = JSON.parse(JSON.stringify(this.state.mapRulesList));
        let isrulewarn = JSON.parse(JSON.stringify(this.state.isRuleWarn));
        let nonrelateprods = JSON.parse(JSON.stringify(this.state.nonfilteredNonEProducts));
        let pegList = JSON.parse(JSON.stringify(this.state.pegList));

        var chobj   = this.state.historyData;

        var phistry = (chobj.past?chobj.past:[]);

        pegList = pegList?.filter((obj=> obj.savePegBoard === true || obj.savePegBoard === undefined));

        phistry.push({ type:type, obj:csobj, removeprodlist: removeprodlist, addprodlist: addprodlist,
            // cutarray: cutpastelist,
            cutarray: cutnewpastelist,
            rulelist: rulelist, isrulewarn: isrulewarn,
            nonrelateprods: nonrelateprods,
            pegList:pegList
        });
       
        if (phistry.length > MAX_HISTORY_STEPS) {
            phistry.shift();
        }

        chobj["present"] = 0;
        chobj["past"] = phistry; chobj["future"] = [];
        if(this.state.selectedCatRect.selectedCat){
            // chobj["CatId"]=this.state.selectedCatRect.selectedCat.id
            chobj["mp_id"]=this.props.defSaveObj.mp_id
        }

        this.setState({ historyData: chobj },()=>{
            // COMMENT FOR TEMPORLY SOLUTION FOR TAB CRASH ISSUE
            // this.props.setMpEditStackHistory(this.state.historyData);
            if(this.state.historyData.past.length >= 0){
                this.props.setMpEditStackHistory({past:this.state.historyData.past.length});
            }
            this.markChangesForRefresh();
        });
    }
    readandmarkStackblefromredux=()=>{
        if(this.props.mpstate?.mpStackableProdList!==null&&this.props.mpstate?.mpStackableProdList?.length>0){
            var prodlist=this.state.mapproductList
            //mark show products stack boolean
            for (let i = 0; i < prodlist.length; i++) {
                const prod = prodlist[i];
                var have=this.props.mpstate.mpStackableProdList.find(x=>x.productId===prod.productId)
                if(have){
                    prod.isStackable=have.isStackable
                }
            }
            this.setState({mapproductList:prodlist},()=>{
            })
        }
    }
    //remark stackables in redo undo
    //undo changes hisory
    fieldHistoryUndo = () => {
        let removeprodlist = JSON.parse(JSON.stringify(this.state.removedProductsCounter));
        let addprodlist = JSON.parse(JSON.stringify(this.state.addedProductsCounter));
        let cutnewpastelist = JSON.parse(JSON.stringify(this.state.cutNewArray));
        let rulelist = JSON.parse(JSON.stringify(this.state.mapRulesList));
        let isrulewarn = JSON.parse(JSON.stringify(this.state.isRuleWarn));
        let nonrelateprods = JSON.parse(JSON.stringify(this.state.nonfilteredNonEProducts));
        let pegList = JSON.parse(JSON.stringify(this.state.pegList));

        var chobj   = this.state.historyData;
        var backidx = (chobj.present>0?(chobj.present - 1):(chobj.past.length - 1));
        var getsobj = chobj.past[backidx];

        var cfutureobj = { type:getsobj.type, obj:JSON.parse(JSON.stringify(this.state.mapproductList)), removeprodlist: removeprodlist, addprodlist: addprodlist,
            cutarray:cutnewpastelist,
             rulelist: rulelist, isrulewarn: isrulewarn,
            nonrelateprods: nonrelateprods,
            pegList : pegList
        };

        chobj.future.push(cfutureobj);
        chobj.past.splice(-1,1);
        
        this.setState({currentSelectedRecBlock: {}}); // temporary added for prod release

        // chobj["CatId"]=this.state.selectedCatRect.selectedCat.id

        chobj["mp_id"] = this.props.defSaveObj?.mp_id;

        this.setState({ mapproductList: null,  pegList : []}, () => {
            this.setState({
                mapproductList: getsobj.obj, historyData: chobj,
                removedProductsCounter: getsobj.removeprodlist, addedProductsCounter: getsobj.addprodlist,
                cutNewArray:getsobj.cutarray,
                mapRulesList: getsobj.rulelist, isRuleWarn: getsobj.isrulewarn, currentInternalDraggableProd: null, currentSelectedBlock: null, contxtmenu: { isexpand: false },
                nonfilteredNonEProducts: getsobj.nonrelateprods,
                pegList:getsobj.pegList
            }, () => {
                if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                    // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                    const combinedPrds = this.state.mapproductList?.filter(prd=>prd.isDelete !== true)
                    this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
                }

                // COMMENT FOR TEMPORLY SOLUTION FOR TAB CRASH ISSUE
                // this.props.setMpEditStackHistory(this.state.historyData)
                if(this.state.historyData.past.length >= 0){
                    this.props.setMpEditStackHistory({past:this.state.historyData.past.length});
                }

                // this.cacheClipboardandOther()
                this.handleFilterNoEProducts("");
                //remark stackable to display
                this.readandmarkStackblefromredux();
                //reload imported product update
                this.compareImportedProds();

                this.nonSimProddropremoveCounterupdate();

                // update actual field list spacing after deleted products
                this.updateActualFieldListSpacing();

                // mark changes for refresh after undo (due to refreshed data being irrelevant to original state))
                this.markChangesForRefresh();

            });
        });

    }
    //redo changes hisory
    fieldHistoryRedo = () => {

        let removeprodlist = JSON.parse(JSON.stringify(this.state.removedProductsCounter));
        let addprodlist = JSON.parse(JSON.stringify(this.state.addedProductsCounter));
        // let cutpastelist = JSON.parse(JSON.stringify(this.state.cutArray));
        let cutnewpastelist = JSON.parse(JSON.stringify(this.state.cutNewArray));
        let rulelist = JSON.parse(JSON.stringify(this.state.mapRulesList));
        let isrulewarn = JSON.parse(JSON.stringify(this.state.isRuleWarn));
        let nonrelateprods = JSON.parse(JSON.stringify(this.state.nonfilteredNonEProducts));
        let pegList = JSON.parse(JSON.stringify(this.state.pegList));

        var chobj = this.state.historyData;
        // var chobj =this.props.mpstate.mpstackHistory
        var backidx = (chobj.present>0?(chobj.present + 1):(chobj.future.length - 1));
        var getsobj = chobj.future[backidx];

        var cpastobj = { type:getsobj.type, obj:JSON.parse(JSON.stringify(this.state.mapproductList)), removeprodlist: removeprodlist, addprodlist: addprodlist,
            // cutarray: cutpastelist,
            cutarray:cutnewpastelist,
             rulelist: rulelist, isrulewarn: isrulewarn,
            nonrelateprods: nonrelateprods,
            pegList : pegList
        };

        chobj.past.push(cpastobj);
        chobj.future.splice(-1,1);
        
        // chobj["CatId"]=this.state.selectedCatRect.selectedCat.id
        chobj["mp_id"]=this.props.defSaveObj?.mp_id
        this.setState({ mapproductList: null }, () => {
            this.setState({ mapproductList: getsobj.obj, historyData: chobj,
                removedProductsCounter: getsobj.removeprodlist, addedProductsCounter: getsobj.addprodlist,
                // cutArray: getsobj.cutarray,
                cutNewArray:getsobj.cutarray,
                mapRulesList: getsobj.rulelist, isRuleWarn: getsobj.isrulewarn, currentInternalDraggableProd: null, currentSelectedBlock: null, contxtmenu: { isexpand: false },
                nonfilteredNonEProducts: getsobj.nonrelateprods,
                pegList:getsobj.pegList
            }, () => {
                if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                    // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                    const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                    this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
                }

                // COMMENT FOR TEMPORLY SOLUTION FOR TAB CRASH ISSUE
                // this.props.setMpEditStackHistory(this.state.historyData)
                if(this.state.historyData.past.length >= 0){
                    this.props.setMpEditStackHistory({past:this.state.historyData.past.length});
                }
                // this.cacheClipboardandOther()
                this.handleFilterNoEProducts("");
                //remark stackable to display
                this.readandmarkStackblefromredux();
                //reload imported product update
                this.compareImportedProds();
                // Call nonSimProddropremoveCounterupdate to sync products
                this.nonSimProddropremoveCounterupdate();
                // update actual field list spacing after deleted products
                this.updateActualFieldListSpacing();
                // sync hasChangesSinceLastRefresh with save button state
                this.markChangesForRefresh();
            });
        });
    }
    fieldHistoryReset=(type,isFullSCEdit)=>{
        // let removeprodlist = JSON.parse(JSON.stringify(this.state.removedProductsCounter));
        // let addprodlist = JSON.parse(JSON.stringify(this.state.addedProductsCounter));
        // let cutpastelist = JSON.parse(JSON.stringify(this.state.cutArray));
        // let rulelist = JSON.parse(JSON.stringify(this.state.mapRulesList));
        // let isrulewarn = JSON.parse(JSON.stringify(this.state.isRuleWarn));
        // let nonrelateprods = JSON.parse(JSON.stringify(this.state.nonfilteredNonEProducts));

        var chobj = this.state.historyData;
        // var chobj =this.props.mpstate.mpstackHistory
        var getsobj = chobj.past[0];
        // var cfutureobj = { type:getsobj.type, obj:JSON.parse(JSON.stringify(this.state.mapproductList)), removeprodlist: removeprodlist, addprodlist: addprodlist, cutarray: cutpastelist, rulelist: rulelist, isrulewarn: isrulewarn,
        //     nonrelateprods: nonrelateprods };

        chobj.future=[]
        chobj.past=[]
        this.setState({ mapproductList: null }, () => {
            this.setState({
                mapproductList: getsobj.obj, historyData: chobj,
                removedProductsCounter: getsobj.removeprodlist, addedProductsCounter: getsobj.addprodlist,
                // cutArray: getsobj.cutarray,
                cutNewArray:getsobj.cutarray,
                 mapRulesList: getsobj.rulelist, isRuleWarn: getsobj.isrulewarn, currentInternalDraggableProd: null, currentSelectedBlock: null, contxtmenu: { isexpand: false },
                nonfilteredNonEProducts: getsobj.nonrelateprods,
                pegList:getsobj.pegList,
                hasChangesSinceLastRefresh: false
            }, () => {
                if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                    // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                    const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                    this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
                }

                if(type==="switchfullSCEdit"){
                    this.handleFullscreenEditMethodcall(isFullSCEdit)
                }

                // COMMENT FOR TEMPORLY SOLUTION FOR TAB CRASH ISSUE
                // this.props.setMpEditStackHistory(this.state.historyData)
                this.handleFilterNoEProducts("");
                //remark stackable to display
                this.readandmarkStackblefromredux();
                //reload imported product update
                this.compareImportedProds();
            });
        });
    }
    //#MP-SML-E-03
    dragmultiplyProducts = (angle) => {
        const { contxtmenu, mapproductList, currentInternalDraggableProd, currentSelectedBlock, mapFields, isPegBoardOverlapping } = this.state;

        if (!contxtmenu || !currentInternalDraggableProd || isPegBoardOverlapping) return;

        let currentlySelectedProd = currentSelectedBlock?.drawingProducts[0]; 
        //let currentlySelectedProd = mapproductList[currentInternalDraggableProd.prodidx];

        if (!currentlySelectedProd) return;
        
        let selectedField = mapFields[currentlySelectedProd.field_custom_id];

        let cshelf = selectedField.shelf.find(x => x.rank === currentlySelectedProd.shelfrank);
        
        let groupWiseProduct = mapproductList.filter(x => x.groupId === currentlySelectedProd.groupId && x.isDelete === false);

        groupWiseProduct = groupWiseProduct.sort((a,b) => a.x - b.x);

        let selectedGroupLastProduct  = groupWiseProduct[groupWiseProduct.length - 1];

        let selectedGroupStartProduct = groupWiseProduct[0];

        // let newProd = {
        //     ...currentlySelectedProd,
        //     id: uuidv4(),
        //     isNew: true,
        //     x: angle === "left" ? currentlySelectedProd.x - (contxtmenu.isexpand ? currentlySelectedProd.drawWidth : 1)
        //         : currentlySelectedProd.x + (contxtmenu.isexpand ? currentlySelectedProd.drawWidth : 1),
        //     y: currentlySelectedProd.y
        // };
        let newProd = {
            ...currentlySelectedProd,
            id: uuidv4(),
            isNew: true,
            x: angle === "left" ? selectedGroupStartProduct.x - (contxtmenu.isexpand ? currentlySelectedProd.drawWidth : 1)
                : selectedGroupLastProduct.x + (contxtmenu.isexpand ? currentlySelectedProd.drawWidth : 1), // Commented for fix bug id #30280
            // x: selectedGroupLastProduct.x + (contxtmenu.isexpand ? currentlySelectedProd.drawWidth : 1),
            y: currentlySelectedProd.y
        };

        /* let nextShelf = null;
        const targetY = roundOffDecimal(cshelf.y + cshelf.height, 2); // Reference y position of the current shelf
        Object.keys(mapFields).forEach((fieldId) => {
            const field = mapFields[fieldId];
            field.shelf.forEach((shelf) => {
                if (roundOffDecimal((shelf.y + shelf.height),2)  === targetY && shelf.field_custom_id !== cshelf.field_custom_id) {
                    nextShelf = shelf;
                }
            });
        });*/


        if (!contxtmenu.isexpand && currentSelectedBlock && Object.keys(currentSelectedBlock).length > 0) {
            // console.log("MOVEING 1")
            this.changeBlockPosition(cshelf, angle);
        } else {
            if (contxtmenu.isexpand) {
                this.multiplyProductToDropZone(cshelf, newProd, currentlySelectedProd);
            } else {
                // console.log("MOVEING 2")
                this.changeProdPosition(cshelf, newProd, currentlySelectedProd, angle);
            }
        }
    };
    // OLD METHOD --------------
    // dragmultiplyProducts = (angle) => {
    //     var cprodlist = JSON.parse(JSON.stringify(this.state.mapproductList));
    //     var cisexpand = (this.state.contxtmenu && this.state.contxtmenu.isexpand?true:false);
    //     var selcurobj = this.state.currentInternalDraggableProd; //get current selected prod
    //     let selecteBlockobj = this.state.currentSelectedBlock;

    //     //is it selected
    //     let cshelf = null;
    //     if(cprodlist && selcurobj){
    //         var currentlySelectedProd = cprodlist[selcurobj.prodidx];

    //         if (currentlySelectedProd) {
    //             let selectedfield = this.state.mapFields[currentlySelectedProd.field_custom_id];
    //             cshelf = selectedfield.shelf.find(x => x.rank === currentlySelectedProd.shelfrank);

    //             //create new product object to check object
    //             var newProd = JSON.parse(JSON.stringify(currentlySelectedProd));

    //             newProd.id = uuidv4();
    //             newProd.productId = currentlySelectedProd.productId;
    //             newProd.isNew = true;

    //             if (angle === "left") {
    //                 newProd.x = currentlySelectedProd.x - (cisexpand?currentlySelectedProd.drawWidth:1);
    //                 newProd.y = currentlySelectedProd.y;

    //             } else if (angle === "right") {
    //                 newProd.x = currentlySelectedProd.x + (cisexpand?currentlySelectedProd.drawWidth:1);
    //                 newProd.y = currentlySelectedProd.y;

    //             }

    //             if (newProd) {
    //                 //block change position otherwise
    //                 if(selecteBlockobj && Object.keys(selecteBlockobj).length > 0){
    //                     this.changeBlockPosition(cshelf, angle);
    //                     //move by arrows
    //                 } else{
    //                     if(this.state.contxtmenu && this.state.contxtmenu.isexpand){
    //                         //expand by arows
    //                         this.multiplyProductToDropZone(cshelf, newProd, currentlySelectedProd);
    //                     } else{
    //                         this.changeProdPosition(cshelf, newProd, currentlySelectedProd, angle);
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }
    // OLD METHOD --------------
    //change selected block position
    changeBlockPosition = (shelf, changeangle) => {
        const { currentSelectedBlock: selectedBlock, mapproductList: productList, checkSaftyMargin } = this.state;

        if (!selectedBlock || !selectedBlock.selectedshelves || selectedBlock.selectedshelves.length !== 1) {
            return alertService.error(this.props.t("CANNOT_CHANGEPOSITION_OF_MORETHANONE_SHELF"));
        }

        const shelfProductList = productList.filter(x => !x.isDelete && x.shelfrank === shelf.rank);
        const reduceAmount = changeangle === "left" ? -1 : 1;

        let newXa = roundOffDecimal(selectedBlock.x + reduceAmount, 2);
        let newXb = roundOffDecimal(newXa + selectedBlock.drawWidth, 2);

        const ya = roundOffDecimal(selectedBlock.y, 2);
        const yb = roundOffDecimal(ya + selectedBlock.drawHeight, 2);

        let shelfCheck = checkOnShelfBox(newXa, ya, newXb, yb, shelf, selectedBlock.drawWidth, selectedBlock.drawHeight, checkSaftyMargin);

        if (!shelfCheck.boxAllow) {
            const blockAdjustment = this.adjustBlockPositionIfNeeded(shelf, selectedBlock, changeangle, newXa, newXb);
            if (blockAdjustment) {
                newXa = blockAdjustment.newXa;
                newXb = blockAdjustment.newXb;
                shelfCheck.boxAllow = true;
            }
        }

        if (!shelfCheck.boxAllow) return;

        // check if new x & y cross with any pegboard
        const pegBoardCrossCheker = this.checkPegboardWithNewXYCoordinations(newXa, newXb, ya, yb, this.state.pegList, 3);
        if(pegBoardCrossCheker){
            alertService.error(this.props.t("PEG_BOARD_OVERLAP"));
            return;
        }

        if (this.canMoveBlock(shelfProductList, selectedBlock, newXa, newXb, ya, yb)) {
            this.batchUpdateBlockPosition(newXa, reduceAmount);
        }
    };

    adjustBlockPositionIfNeeded = (shelf, selectedBlock, changeangle, newXa, newXb) => {
        const shelfEndX = shelf.x + shelf.drawWidth;
        const blockEndX = selectedBlock.x + selectedBlock.drawWidth;

        if (changeangle === "right" && shelfEndX - blockEndX > 0 && shelfEndX - blockEndX <= 1) {
            return { newXa: newXa + (shelfEndX - blockEndX), newXb: newXb + (shelfEndX - blockEndX) };
        } else if (changeangle === "left" && selectedBlock.x - shelf.x > 0 && selectedBlock.x - shelf.x <= 1) {
            const adjustAmount = selectedBlock.x - shelf.x;
            return { newXa: newXa - adjustAmount, newXb: newXb - adjustAmount };
        }
        return null;
    };

    canMoveBlock = (shelfProductList, selectedBlock, newXa, newXb, ya, yb) => {
        return shelfProductList.every(product => {
            const isNotSelected = selectedBlock.newDrawingProducts.every(z => z.id !== product.id);
            if (isNotSelected) {
                const x1 = roundOffDecimal(product.x, 2);
                const y1 = roundOffDecimal(product.y, 2);
                const x2 = roundOffDecimal(x1 + product.drawWidth, 2);
                const y2 = roundOffDecimal(y1 + product.drawHeight, 2);

                return checkThroughProductsTest(newXa, ya, newXb, yb, x1, y1, x2, y2);
            }
            return true;
        });
    };

    batchUpdateBlockPosition = (newXa, reduceAmount) => {
        this.setState(prevState => {
            const { currentSelectedBlock, mapproductList , historyData } = prevState;
            currentSelectedBlock.newDrawingProducts.forEach(prod => {
                mapproductList[prod.prodidx].x += reduceAmount;
            });
            currentSelectedBlock.x += reduceAmount;

            // save history data
            this.fieldHistoryAdd(JSON.parse(JSON.stringify(mapproductList)), 3);
            this.TouchedCatListUpdate(currentSelectedBlock?.newDrawingProducts[0] && currentSelectedBlock?.newDrawingProducts[0]?.categoryRectId);
            // update the group
            this.groupByProduct();
            return { currentSelectedBlock, mapproductList };
        }, () => {
            if (["AUI", "Normal"].includes(this.props.simType)) {
                this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, this.state.mapproductList);
            }
            this.props.handlehaveChnagesinCat(true);
        });
    };

    // OLD METHOD ---------------
    // changeBlockPosition = (shelf, changeangle) => {
    //     let selecteBlockobj = this.state.currentSelectedBlock;
    //     let mapprodList = this.state.mapproductList;

    //     if(selecteBlockobj){
    //         let reduceamount = (changeangle === "left"?-1:1)

    //         if(selecteBlockobj.selectedshelves && selecteBlockobj.selectedshelves.length === 1){
    //             let shelfcontainlist = mapprodList.filter(x => !x.isDelete && x.shelfrank === shelf.rank);

    //             //check through products
    //             var allowToAdd = true;

    //             var xa1 = roundOffDecimal((selecteBlockobj.x + reduceamount),2);
    //             var ya1 = roundOffDecimal(selecteBlockobj.y,2);
    //             var xb1 = roundOffDecimal((selecteBlockobj.x + selecteBlockobj.drawWidth + reduceamount),2);
    //             var yb1 = roundOffDecimal((selecteBlockobj.y + selecteBlockobj.drawHeight),2);

    //             //check on box
    //             var shelveCheck = checkOnShelfBox(xa1, ya1, xb1, yb1, shelf, selecteBlockobj.drawWidth, selecteBlockobj.drawHeight, this.state.checkSaftyMargin);
    //             // console.log(shelveCheck);

    //             if(!shelveCheck.boxAllow){
    //                 let shelftx2 = (shelf.x + shelf.drawWidth);
    //                 let blockx2 = (selecteBlockobj.x + selecteBlockobj.drawWidth);

    //                 if((changeangle === "right" && (shelftx2 - blockx2) > 0 && (shelftx2 - blockx2) <= 1)){
    //                     reduceamount = (shelftx2 - blockx2);

    //                     xa1 = roundOffDecimal((xa1 + reduceamount),2);
    //                     xb1 = roundOffDecimal((xb1 + reduceamount),2);

    //                     shelveCheck.boxAllow = true;
    //                     // console.log(changeangle, reduceamount);
    //                 }

    //                 if((changeangle === "left" && (selecteBlockobj.x - shelf.x) > 0 && (selecteBlockobj.x - shelf.x) <= 1)){
    //                     reduceamount = (selecteBlockobj.x - shelf.x);

    //                     xa1 = roundOffDecimal((selecteBlockobj.x - reduceamount),2);
    //                     xb1 = roundOffDecimal(((selecteBlockobj.x + selecteBlockobj.drawWidth) - reduceamount),2);

    //                     shelveCheck.boxAllow = true;
    //                     // console.log(changeangle, reduceamount);

    //                     reduceamount = (reduceamount * -1);
    //                 }
    //             }

    //             if (shelveCheck.boxAllow) {
    //                 //check it's allow to move to that direction - see any products overlapping
    //                 for (let k = 0; k < shelfcontainlist.length; k++) {
    //                     const productLocation = shelfcontainlist[k];

    //                     //if not current product
    //                     let isidnotfound = selecteBlockobj.newDrawingProducts.findIndex(z => z.id === productLocation.id);
    //                     if (isidnotfound === -1) {
    //                         var x1 = roundOffDecimal(productLocation.x,2);
    //                         var y1 = roundOffDecimal(productLocation.y,2);
    //                         var x2 = roundOffDecimal((x1 + productLocation.drawWidth),2);
    //                         var y2 = roundOffDecimal((y1 + productLocation.drawHeight),2);

    //                         var checkProdOverlapping = checkThroughProductsTest(xa1, ya1, xb1, yb1, x1, y1, x2, y2)
    //                         if (!checkProdOverlapping) {
    //                             allowToAdd = false;

    //                             //if snapping missing from small space in products
    //                             let blockx2 = (selecteBlockobj.x + selecteBlockobj.drawWidth);

    //                             if((changeangle === "right" && (x1 - blockx2) > 0 && (x1 - blockx2) <= 1)){
    //                                 reduceamount = (x1 - blockx2);

    //                                 xa1 = roundOffDecimal((xa1 + reduceamount),2);
    //                                 xb1 = roundOffDecimal((xb1 + reduceamount),2);

    //                                 allowToAdd = true;
    //                                 // console.log(changeangle, reduceamount);
    //                             }

    //                             if((changeangle === "left" && (selecteBlockobj.x - x2) > 0 && (selecteBlockobj.x - x2) <= 1)){
    //                                 reduceamount = (selecteBlockobj.x - x2);

    //                                 xa1 = roundOffDecimal((xa1 - reduceamount),2);
    //                                 xb1 = roundOffDecimal((xb1 - reduceamount),2);

    //                                 allowToAdd = true;
    //                                 // console.log(changeangle, reduceamount);

    //                                 reduceamount = (reduceamount * -1);
    //                             }

    //                             break;
    //                         }
    //                     }
    //                 }

    //                 if (allowToAdd) {
    //                     this.TouchedCatListUpdate(selecteBlockobj.newDrawingProducts[0].categoryRectId)
    //                     this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),3);

    //                     for (let i = 0; i < selecteBlockobj.newDrawingProducts.length; i++) {
    //                         const newdrawprod = selecteBlockobj.newDrawingProducts[i];
    //                         mapprodList[newdrawprod.prodidx].x = (mapprodList[newdrawprod.prodidx].x + reduceamount);
    //                     }

    //                     selecteBlockobj.x = (selecteBlockobj.x + reduceamount);

    //                     this.setState({ currentSelectedBlock: selecteBlockobj, mapproductList: mapprodList },()=>{
    //                         if(this.props.simType === "AUI" || this.props.simType === "Normal"){
    //                             // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds)
    //                             const combinedPrds = this.state.mapproductList
    //                             this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
    //                         }
    //                     });
    //                     this.props.handlehaveChnagesinCat(true);
    //                 }
    //             }

    //         } else{
    //             alertService.error(this.props.t("CANNOT_CHANGEPOSITION_OF_MORETHANONE_SHELF"));
    //         }
    //     }

    // }
    // OLD METHOD ---------------

    //change product position
    changeProdPosition = (shelf, changeLocation, selctedProd, changeangle) => {
        if (shelf && changeLocation) {
            var xa1 = roundOffDecimal(changeLocation.x,2);
            var ya1 = roundOffDecimal(changeLocation.y,2);
            var xb1 = roundOffDecimal((changeLocation.x + changeLocation.drawWidth),2);
            var yb1 = roundOffDecimal((changeLocation.y + changeLocation.drawHeight),2);

            //check on box
            var shelveCheck = checkOnShelfBox(xa1, ya1, xb1, yb1, shelf, changeLocation.drawWidth, changeLocation.drawHeight, this.state.checkSaftyMargin);

            if(!shelveCheck.boxAllow){
                let shelftx2 = (shelf.x + shelf.drawWidth);
                let prodx2 = (changeLocation.x + changeLocation.drawWidth);

                if((changeangle === "right" && (shelftx2 - prodx2) > 0 && (shelftx2 - prodx2) <= 1)){
                    let canSnapAmount = (shelftx2 - prodx2);

                    xa1 = roundOffDecimal((xa1 + canSnapAmount),10);
                    xb1 = roundOffDecimal((xb1 + canSnapAmount),10);

                    shelveCheck.boxAllow = true;
                    // console.log(changeangle, canSnapAmount);
                }

                if((changeangle === "left" && (changeLocation.x - shelf.x) > 0 && (changeLocation.x - shelf.x) <= 1)){
                    let canSnapAmount = (changeLocation.x - shelf.x);

                    xa1 = roundOffDecimal((xa1 - canSnapAmount),10);
                    xb1 = roundOffDecimal((xb1 - canSnapAmount),10);

                    shelveCheck.boxAllow = true;
                    // console.log(changeangle, canSnapAmount);
                }
            }

            if (shelveCheck.boxAllow) {
                let cprodlist = JSON.parse(JSON.stringify(this.state.mapproductList));

                let shelfcontainlist = cprodlist.filter(x => !x.isDelete && x.shelfrank === shelf.rank);

                //check through products
                var allowToAdd = true;

                //check it's allow to move to that direction - see any products overlapping
                for (let k = 0; k < shelfcontainlist.length; k++) {
                    const productLocation = shelfcontainlist[k];

                    //if not current product
                    if (productLocation.id !== selctedProd.id) {
                        var x1 = roundOffDecimal(productLocation.x,2);
                        var y1 = roundOffDecimal(productLocation.y,2);
                        var x2 = roundOffDecimal((x1 + productLocation.drawWidth),2);
                        var y2 = roundOffDecimal((y1 + productLocation.drawHeight),2);

                        var checkProdOverlapping = checkThroughProductsTest(xa1, ya1, xb1, yb1, x1, y1, x2, y2)
                        if (!checkProdOverlapping) {
                            allowToAdd = false;

                            //if snapping missing from small space in products
                            let prodx2 = (changeLocation.x + changeLocation.drawWidth);

                            if((changeangle === "right" && (x1 - prodx2) > 0 && (x1 - prodx2) <= 1)){
                                let canSnapAmount = (x1 - prodx2);

                                xa1 = roundOffDecimal((xa1 + canSnapAmount),10);
                                xb1 = roundOffDecimal((xb1 + canSnapAmount),10);

                                allowToAdd = true;
                                // console.log(changeangle, canSnapAmount);
                            }

                            if((changeangle === "left" && (productLocation.x - x2) > 0 && (productLocation.x - x2) <= 1)){
                                let canSnapAmount = (productLocation.x - x2);

                                xa1 = roundOffDecimal((xa1 - canSnapAmount),10);
                                xb1 = roundOffDecimal((xb1 - canSnapAmount),10);

                                allowToAdd = true;
                                // console.log(changeangle, canSnapAmount);
                            }

                            break;
                        }
                    }
                }

                if (allowToAdd) {
                    this.TouchedCatListUpdate(selctedProd.categoryRectId)
                    this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),3);

                    var cselprod = this.state.currentInternalDraggableProd;
                    var changeprod = cprodlist[cselprod.prodidx];

                    //update change location x,y
                    if(changeprod){
                        changeprod.x = xa1;
                        changeprod.y = changeLocation.y;
                    }

                    this.setState({ mapproductList: cprodlist },()=>{
                        if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                            // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds)
                            const combinedPrds = this.state.mapproductList
                            this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
                        }
                    });
                    //update group
                    this.groupByProduct();
                    this.props.handlehaveChnagesinCat(true);
                }
            }
        }
    }
    //multiply product validations
    // multiplyProductToDropZone = (shelf, addingProduct, changeProduct) => {
    //     if (shelf && addingProduct) {
    //             var cprodlist = JSON.parse(JSON.stringify(this.state.mapproductList));
    //             let fieldobj = this.state.mapFields[shelf.field_custom_id];

    //             //create x,y box of current product
    //             var xa1 = roundOffDecimal(addingProduct.x,2)
    //             var ya1 = roundOffDecimal(addingProduct.y,2)

    //             //check allow to add that location - retuns boolean
    //             let allowToAdd = checkAllowToAdd(null, shelf, addingProduct, xa1, ya1, this.state.checkSaftyMargin);
    //             //if allow to multiply product
    //             if (allowToAdd.allowToAdd) {
    //                 let findsameShelftItems = cprodlist.filter(z => !z.isDelete && z.shelfrank === shelf.rank);
                    
    //                 let checkx1 = roundOffDecimal((xa1 + this.state.checkSaftyMargin), 2);
    //                 let boxx2 = roundOffDecimal((xa1 + addingProduct.drawWidth - this.state.checkSaftyMargin),2);
    //                 let boxy2 = roundOffDecimal((ya1 + addingProduct.drawHeight),2);

    //                 var containProds = GetContainingProdsByBox(checkx1, ya1, boxx2, boxy2, findsameShelftItems, fieldobj);
    //                 console.log('containProds->', containProds);
    //                 // console.log("loc 4",checkx1, ya1, boxx2, boxy2, findsameShelftItems, fieldobj)
    //                 if(containProds.selectedProds && containProds.selectedProds.length === 0){
    //                     this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),1);

    //                     //get current product details
    //                     var csprodobj = this.state.currentInternalDraggableProd;

    //                     var plocobj = addingProduct;
    //                     plocobj.x = xa1;
    //                     plocobj.y = ya1;

    //                     //if is item sub cat is rule
    //                     let isruleupdating = false;
    //                     if(plocobj.subcategory && plocobj.subcategory.type === catRectEnums.rule){
    //                         //find if rule brand available
    //                         let scatruleid = getNameorIdorColorofBox(plocobj.subcategory, "num");
    //                         let scatrulelevel = (plocobj.subcategory.rule?plocobj.subcategory.rule.level:null);

    //                         let findfromrules = findRuleAvailableForBrand(scatruleid, true, scatrulelevel, this.state.mapRulesList);
    //                         // console.log(findfromrules);

    //                         if(findfromrules.isavailable){
    //                             isruleupdating = {parentidx: findfromrules.ruleparentidx, ruleidx: findfromrules.ruleidx};
    //                         }
    //                     }

    //                     cprodlist.push(plocobj);

    //                     csprodobj.prodidx = (cprodlist.length - 1);
    //                     csprodobj.prod = plocobj;

    //                     this.setState({ mapproductList: cprodlist, currentInternalDraggableProd: csprodobj }, () => {
    //                         //check non sim render count and display mange
    //                         this.nonSimProddropremoveCounterupdate("DropfromClipboard")
    //                         this.TouchedCatListUpdate(plocobj.categoryRectId)
    //                         //update rule list if item sub cat is rule

    //                         if(this.props.simType === "AUI" || this.props.simType === "Normal"){
    //                             // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds)
    //                             const combinedPrds = this.state.mapproductList.filter(prd => prd.isDelete !== true)
    //                             this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
    //                         }

    //                         if(isruleupdating){
    //                             let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, true, isruleupdating);
    //                             // console.log(updaterulelist);

    //                             this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
    //                         }

    //                         //reload imported product update
    //                         this.compareImportedProds();
    //                     });
    //                     //update groupPeghandleAddProductCounter(addingProduct, 1);
    //                     }
    //                 } else{
    //                     alertService.error(this.props.t("CANNOT_EXPAND_PROD_ANOTHER_EXIST"));
    //                 }
    //             }
    //     }

    // }
    multiplyProductToDropZone = (shelf, addingProduct, changeProduct , isStacking = false) => {
        if (shelf && addingProduct) {
            const { mapFields, currentSelectedBlock, isPegBoardOverlapping} = this.state;
            let currentSelectedBlockObj = structuredClone(currentSelectedBlock);
            let currentSelectedBlockData = currentSelectedBlockObj;

            if(isPegBoardOverlapping){
                alertService.error(this.props.t('PEG_BOARD_OVERLAP'),4000);
                return;
            }
            var cprodlist = JSON.parse(JSON.stringify(this.state.mapproductList));
            let originalProdList = structuredClone(cprodlist);
            const isruleupdating = false;
            //adding new prodidx
            addingProduct.prodidx = cprodlist.length;

            //create x,y box of current product
            //var xa1 = roundOffDecimal(addingProduct.x,2)
            //var ya1 = roundOffDecimal(addingProduct.y,2)

            //var plocobj = addingProduct;
            //plocobj.x = xa1;
            //plocobj.y = ya1;
            
            // get similer shelf from selected shelf y+drawheight
            let similarLevelShelves = this.getSimilarLevelShelves(shelf, mapFields);

            let productList = JSON.parse(JSON.stringify(this.state.mapproductList));
            //find similar shelves product list
            let exisitingProductList = this.getSelectedProducts(productList, similarLevelShelves, currentSelectedBlockData, true);

            let exisitingTotalProductWidth = 0;
            exisitingProductList?.forEach((product) => {
                exisitingTotalProductWidth += product?.drawWidth;
            });

            let totalShelfWidth = 0;
            similarLevelShelves?.forEach((shelf) => {
                totalShelfWidth += shelf.drawWidth;
            });

            let existingFreeSpace = (totalShelfWidth - exisitingTotalProductWidth);

            //add expand product list
            //expandProductList.push(addingProduct);
            // let expandProductsTotalWidth = 0;
            // expandProductList?.forEach((product) => {
            //     expandProductsTotalWidth += product?.drawWidth;
            // })
            

            let notDeletedProds = [...currentSelectedBlockData.drawingProducts, addingProduct];

            // sort the notDeletedProds
            notDeletedProds = notDeletedProds.sort((a, b) => a.x - b.x);

            //calculate total width after adding new product to group
            let totalGroupWidth = 0;
            notDeletedProds.forEach(product => {
                totalGroupWidth += product?.drawWidth;
            });

            currentSelectedBlockData.drawingProducts    = notDeletedProds;

            currentSelectedBlockData.newDrawingProducts = notDeletedProds;

            currentSelectedBlockData.selectedshelves[0].selectedProducts = notDeletedProds;

            currentSelectedBlockData.drawWidth = totalGroupWidth;

            // get lowest x coordinate and assign to ghoost object
            let lowestX = Math.min(
                ...notDeletedProds
                .filter(prod => typeof prod.x === 'number')
                .map(prod => prod.x)
            );
            currentSelectedBlockData.x = lowestX;



            const roundedExistingFreeSpace        = Number(existingFreeSpace.toFixed(2));
            const roundedexpandProductsTotalWidth = Number(totalGroupWidth.toFixed(2));

            const isAllowToDrop = (roundedExistingFreeSpace >= roundedexpandProductsTotalWidth);
        
            if(!isAllowToDrop && !isStacking){
                alertService.error(this?.props?.t('NO_SPACE_AVALIBLE_FOR_DROPPED_PRODUCT_SET'),4000);
                this.setPreviewGuid(true, null, null, true, []);
                this.setState({ currentSelectedBlock: null});
                clearTimeout(this._guideTimeout); 
                return;
            }
                
            let droppedFiledCustomId      = shelf?.field_custom_id;

            let droppedFieldMasterFieldId = mapFields[droppedFiledCustomId]?.masterFieldId;

            // check if neadding products is inside of the shelf
            let isOutSideOfShelf = this.checkProductOverlapWithShelf(similarLevelShelves,notDeletedProds);
            if(isOutSideOfShelf){
                alertService.error(this.props.t('OUTSIDE_OF_THE_FIELD'),4000);
                this.setState({ currentSelectedBlock: null});
                return;
            }

            let reArrangeProducts = structuredClone(this.state.mapproductList);
            let originalProductsList = structuredClone(this.state.mapproductList);
            let newReArrangeProducts = reArrangeProducts;

            const {needToReArrange, updatedProducts} = this.filterInlineShelfProductSet(notDeletedProds[0]?.x, notDeletedProds[0]?.y, similarLevelShelves, newReArrangeProducts, notDeletedProds, currentSelectedBlockData, this.state.checkSaftyMargin, droppedFiledCustomId, droppedFieldMasterFieldId, true, true);

            if(needToReArrange){
                const updatingProductIds = new Set(updatedProducts.map(product => product.id));

                const filteredUpdatedProducts = newReArrangeProducts.filter(
                    product => !updatingProductIds.has(product.id)
                ); 
                
                newReArrangeProducts = [...filteredUpdatedProducts, ...updatedProducts];

                // PEG CR - 2025 March
                // check if any product cross the peg board
                const {isPegBoardOverlap} = this.productOverlapCheckerWithPegBoard(this.state.pegList, newReArrangeProducts);

                if(isPegBoardOverlap){
                    alertService.error(this.props.t('PEG_BOARD_OVERLAP'),4000);
                    newReArrangeProducts = [...newReArrangeProducts];
                    this.setPreviewGuid(false, null, null, true);
                    this.setState({isPegBoardOverlapping:true, currentSelectedBlock: null, mapproductList: originalProductsList });
                    //after expan update group id
                    this.groupByProduct();
                    return;
                }

            }else{
                newReArrangeProducts = [...newReArrangeProducts, addingProduct];

                // PEG CR - 2025 March
                // check if any product cross the peg board
                const {isPegBoardOverlap} = this.productOverlapCheckerWithPegBoard(this.state.pegList, newReArrangeProducts);

                if(isPegBoardOverlap){
                    alertService.error(this.props.t('PEG_BOARD_OVERLAP'),4000);
                    this.setPreviewGuid(false, null, null, true);
                    this.setState({isPegBoardOverlapping:true, currentSelectedBlock: null,  mapproductList: originalProductsList });
                    //after expan update group id
                    this.groupByProduct();
                    return;
                }
            }

            //this.updateProductList(reArrangeProducts, isruleupdating, true);
            //this.setState({selectBlockObj:null})
            
            this.fieldHistoryAdd(JSON.parse(JSON.stringify(originalProdList)),1);

            if(addingProduct.subcategory && addingProduct.subcategory.type === catRectEnums.rule){
                //find if rule brand available
                let scatruleid = getNameorIdorColorofBox(addingProduct.subcategory, "num");
                let scatrulelevel = (addingProduct.subcategory.rule?addingProduct.subcategory.rule.level:null);

                let findfromrules = findRuleAvailableForBrand(scatruleid, true, scatrulelevel, this.state.mapRulesList);

                if(findfromrules.isavailable){
                    isruleupdating = {parentidx: findfromrules.ruleparentidx, ruleidx: findfromrules.ruleidx};
                }
            }
            //get current product details
            const newCurrentInternalDraggableProd = {
                prodidx : addingProduct.prodidx,
                prod    : addingProduct
            }

            // Get latest x for ghoost object
            lowestX = Math.min(
            ...notDeletedProds
                .map(sel => newReArrangeProducts.find(p => p.id === sel.id))
                .filter(p => p && typeof p.x === 'number')
                .map(p => p.x)
            );

            currentSelectedBlockData.x = lowestX;

            this.setState({
                mapproductList: newReArrangeProducts, 
                currentInternalDraggableProd: newCurrentInternalDraggableProd, 
                isContentDragging: false, 
                removeGhost: true,
                currentSelectedBlock: currentSelectedBlockData,
            }, () => {
                
                //check non sim render count and display mange
                this.nonSimProddropremoveCounterupdate("DropfromClipboard")
                this.TouchedCatListUpdate(addingProduct.categoryRectId)
                    //update rule list if item sub cat is rule
                if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                    // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                    const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                    this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
                }
                this.nonSimProddropremoveCounterupdate("updateprodList")
                //update rule list if item sub cat is rule
                if(isruleupdating){
                    let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, false);
                    this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
                }
                //after expan update group id
                this.groupByProduct();
                //reload imported product update
                this.compareImportedProds();
            });

            this.props.handlehaveChnagesinCat(true);

            if(changeProduct.isDropNew){
                this.handleAddProductCounter(addingProduct, 1);
            }
            //------------------------------ OLD CODE -----------------------------------------------------------------------
            //check allow to add that location - retuns boolean
            /*let allowToAdd = checkAllowToAddForExpandNumber(null, shelf, addingProduct, xa1, ya1, this.state.checkSaftyMargin);
                //if allow to multiply product
                if (allowToAdd.allowToAdd) {
                    let findsameShelftItems = cprodlist.filter(z => !z.isDelete && z.shelfrank === shelf.rank);

                    let checkx1 = roundOffDecimal((xa1 + this.state.checkSaftyMargin), 2);
                    let boxx2   = roundOffDecimal((xa1 + addingProduct.drawWidth - this.state.checkSaftyMargin),2);
                    let boxy2   = roundOffDecimal((ya1 + addingProduct.drawHeight),2);

                    var containProds = GetContainingProdsByBox(checkx1, ya1, boxx2, boxy2, findsameShelftItems, fieldobj);
                    // console.log("loc 4",checkx1, ya1, boxx2, boxy2, findsameShelftItems, fieldobj)
                    if(containProds.selectedProds && containProds.selectedProds.length === 0){
                        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),1);

                        //get current product details
                        var csprodobj = this.state.currentInternalDraggableProd;

                        var plocobj = addingProduct;
                        plocobj.x = xa1;
                        plocobj.y = ya1;

                        //if is item sub cat is rule
                        let isruleupdating = false;
                        if(plocobj.subcategory && plocobj.subcategory.type === catRectEnums.rule){
                            //find if rule brand available
                            let scatruleid = getNameorIdorColorofBox(plocobj.subcategory, "num");
                            let scatrulelevel = (plocobj.subcategory.rule?plocobj.subcategory.rule.level:null);

                            let findfromrules = findRuleAvailableForBrand(scatruleid, true, scatrulelevel, this.state.mapRulesList);
                            // console.log(findfromrules);

                            if(findfromrules.isavailable){
                                isruleupdating = {parentidx: findfromrules.ruleparentidx, ruleidx: findfromrules.ruleidx};
                            }
                        }

                        cprodlist.push(plocobj);

                        csprodobj.prodidx = (cprodlist.length - 1);
                        csprodobj.prod = plocobj;

                        this.setState({ mapproductList: cprodlist, currentInternalDraggableProd: csprodobj}, () => {
                            //check non sim render count and display mange
                            this.nonSimProddropremoveCounterupdate("DropfromClipboard")
                            this.TouchedCatListUpdate(plocobj.categoryRectId)
                            //update rule list if item sub cat is rule

                            if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                                // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds)
                                const combinedPrds = this.state.mapproductList.filter(prd => prd.isDelete !== true)
                                this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
                            }

                            if(isruleupdating){
                                let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, true, isruleupdating);

                                this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
                            }

                            //reload imported product update
                            this.compareImportedProds();

                        });
                        this.props.handlehaveChnagesinCat(true);

                        if(changeProduct.isDropNew){
                            this.handleAddProductCounter(addingProduct, 1);
                        }
                    } else{
                        alertService.error(this.props.t("CANNOT_EXPAND_PROD_ANOTHER_EXIST"));
                    }
                }*/
        }
    }

    multiplyProductToDropZoneStacking = (shelf, addingProduct, changeProduct , isStacking = false) => {
        if (shelf && addingProduct) {
            const { mapFields, currentSelectedBlock} = this.state;
            var cprodlist = JSON.parse(JSON.stringify(this.state.mapproductList));
            const isruleupdating = false;
            //adding new prodidx
            addingProduct.prodidx = cprodlist.length;

            // get similer shelf from selected shelf y+drawheight
            let similarLevelShelves = this.getSimilarLevelShelves(shelf, mapFields);

            let productList = JSON.parse(JSON.stringify(this.state.mapproductList));
            //find similar shelves product list
            let exisitingProductList = this.getSelectedProducts(productList, similarLevelShelves, currentSelectedBlock, true);

            let exisitingTotalProductWidth = 0;
            exisitingProductList?.forEach((product) => {
                exisitingTotalProductWidth += product?.drawWidth;
            });

            let totalShelfWidth = 0;
            similarLevelShelves?.forEach((shelf) => {
                totalShelfWidth += shelf.drawWidth;
            });

            let existingFreeSpace = (totalShelfWidth - exisitingTotalProductWidth);

            const roundedExistingFreeSpace        = Number(existingFreeSpace.toFixed(2));
            const roundedexpandProductsTotalWidth = Number(addingProduct?.drawWidth.toFixed(2));
        
            const isAllowToDrop = (roundedExistingFreeSpace >= roundedexpandProductsTotalWidth);
        
            if(!isAllowToDrop && !isStacking){
                alertService.error(this?.props?.t('NO_SPACE_AVALIBLE_FOR_DROPPED_PRODUCT_SET'),4000);
                this.setPreviewGuid(true, null, null, true, []);
                clearTimeout(this._guideTimeout); 
                return;
            }

            //const notDeletedProds = [...currentSelectedBlock.drawingProducts, addingProduct]; // OLD CODE CHANGE

            const notDeletedProds = [...currentSelectedBlock.drawingProducts]; // NEW CODE CHANGE - 2025 OCT

            //calculate total width after adding new product to group
            let totalGroupWidth = 0;
            notDeletedProds.forEach(product => {
                totalGroupWidth += product?.drawWidth;
            });

            currentSelectedBlock.drawingProducts    = notDeletedProds;

            currentSelectedBlock.newDrawingProducts = notDeletedProds;

            currentSelectedBlock.selectedshelves[0].selectedProducts = notDeletedProds;

            currentSelectedBlock.drawWidth = totalGroupWidth;
                            
            let droppedFiledCustomId      = shelf?.field_custom_id;

            let droppedFieldMasterFieldId = mapFields[droppedFiledCustomId]?.masterFieldId;

            //Rearrange existing groups

            this.fieldHistoryAdd(structuredClone(this.state.mapproductList),1);

            let reArrangeProducts = JSON.parse(JSON.stringify(this.state.mapproductList));

            const {needToReArrange, updatedProducts} = this.filterInlineShelfProductSet(notDeletedProds[0]?.x, notDeletedProds[0]?.y, similarLevelShelves, reArrangeProducts, notDeletedProds, currentSelectedBlock, this.state.checkSaftyMargin, droppedFiledCustomId, droppedFieldMasterFieldId);

            if(needToReArrange){
                const updatingProductIds = new Set(updatedProducts.map(product => product.id));

                const filteredUpdatedProducts = reArrangeProducts.filter(
                    product => !updatingProductIds.has(product.id)
                ); 
                
                reArrangeProducts = [...filteredUpdatedProducts, ...updatedProducts];
            }
            
            // PEG CR - 2025 March
            // check if any product cross the peg board
            const {isPegBoardOverlap} = this.productOverlapCheckerWithPegBoard(this.state.pegList, reArrangeProducts)
            if(isPegBoardOverlap){
                alertService.error(this.props.t('PEG_BOARD_OVERLAP'),4000);
                this.setPreviewGuid(false, null, null, true);
                return;
            }

            
            this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),1);

            if(addingProduct.subcategory && addingProduct.subcategory.type === catRectEnums.rule){
                //find if rule brand available
                let scatruleid = getNameorIdorColorofBox(addingProduct.subcategory, "num");
                let scatrulelevel = (addingProduct.subcategory.rule?addingProduct.subcategory.rule.level:null);

                let findfromrules = findRuleAvailableForBrand(scatruleid, true, scatrulelevel, this.state.mapRulesList);

                if(findfromrules.isavailable){
                    isruleupdating = {parentidx: findfromrules.ruleparentidx, ruleidx: findfromrules.ruleidx};
                }
            }
            //get current product details
            const newCurrentInternalDraggableProd = {
                prodidx : addingProduct.prodidx,
                prod    : addingProduct
            }
            
            this.setState({mapproductList:reArrangeProducts, currentInternalDraggableProd: newCurrentInternalDraggableProd, isContentDragging: false, removeGhost:true}, () => {
                
                //check non sim render count and display mange
                this.nonSimProddropremoveCounterupdate("DropfromClipboard")
                this.TouchedCatListUpdate(addingProduct.categoryRectId)
                    //update rule list if item sub cat is rule
                if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                    // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                    const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                    this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
                }
                this.nonSimProddropremoveCounterupdate("updateprodList")
                //update rule list if item sub cat is rule
                if(isruleupdating){
                    let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, false);
                    this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
                }
                //after expan update group id
                this.groupByProduct();
                //reload imported product update
                this.compareImportedProds();
                //reset the select block obj data
                this.resetSelectBlockObjData();
            });

            this.props.handlehaveChnagesinCat(true);

            if(changeProduct.isDropNew){
                this.handleAddProductCounter(addingProduct, 1);
            }
            
        }
    }
    //changing screens of search and drop product panel and show log
    toggleprodAddNProdpanel=()=>{
        this.setState({isAddProucts:!this.state.isAddProucts, filteredProdList: [], productSearchText: ''})
    }
    //click add product
    handleAddProduct=()=>{
        if(this.state.isStackableEdited){
            this.sendmarkStackableCall()
        }
        this.toggleprodAddNProdpanel();
    }
    //init svg create point
    initSVGCreatePoint = () => {
        if(this.drawSVG && this.drawSVG.createSVGPoint){
            this.svgCreatePoint = this.drawSVG.createSVGPoint();
        }
    }
    //onenter search prod list
    handleFilterProducts = (evt,isdefualt) => {

        var ctxt = evt.target.value;
        this.setState({productSearchText:ctxt})
        if(evt.nativeEvent.which === 13){
            this.setState({filteredProdList: [], pstartpage: 1,}, () => {
                this.searchProdList(ctxt,0,isdefualt);
            });
        }
    }
     //onenter search prod list
     // debounced method to update count for display
     updateNonSimProductsCount = () => {
        if (this._nonEProductsCountTimeout) {
            clearTimeout(this._nonEProductsCountTimeout);
        }

        this._nonEProductsCountTimeout = setTimeout(() => {
            const count = this.state.nonfilteredNonEProducts.filter(
                x => x.isAdded !== true && x.isFilterd !== true && x.barcode && x.productName
            ).length;
            this.setState({ nonSimProductsCount: count });
        }, 1000);
    }

     handleFilterNoEProducts = (ctxt,isReSerach) => {
        let searchTxt = (ctxt && ctxt.length > 0?ctxt:"");

        this.setState({ noSim_filter: isReSerach?this.state.noSim_filter:searchTxt },()=>{
            if(this._nosimulateprodTimeOut){ clearTimeout(this._nosimulateprodTimeOut); }

            this._nosimulateprodTimeOut = setTimeout(() => {
                var nonladpros = JSON.parse(JSON.stringify(this.state.nonfilteredNonEProducts));

                for (let i = 0; i < nonladpros.length; i++) {
                    const nonladprod = nonladpros[i];
                    let nonSearchQuery = ((nonladprod.barcode?nonladprod.barcode.toLowerCase():"")+" "+(nonladprod.productName?nonladprod.productName.toLowerCase():""));
                    // nonladprod.isFilterd = !((nonladprod.productName.toLowerCase().includes(ctxt.toLowerCase()))||nonladprod.barcode.toLowerCase().includes(ctxt.toLowerCase()));
                    let isnotfiltered=(nonSearchQuery.includes(this.state.noSim_filter.toLowerCase())
                    && (parseInt(this.state.selectedNonSimFilterCat.value)===-1?true:nonladprod.categoryId===this.state.selectedNonSimFilterCat.value)
                    && (parseInt(this.state.selectedNonSimFiltersubCat.value)===-1?true:nonladprod.subCategoryId===this.state.selectedNonSimFiltersubCat.value)
                    && (parseInt(this.state.selectedNonSimFilterBrand.value)===-1?true:nonladprod.brandId===this.state.selectedNonSimFilterBrand.value)
                    && (parseInt(this.state.selectedNonSimFilterSupp.value)===-1?true:nonladprod.supplierId===this.state.selectedNonSimFilterSupp.value)
                    );

                    nonladprod.isFilterd = !isnotfiltered
                }

              // filteredNonEProducts:this.props.non_sim_prodlist
              this.setState({nonfilteredNonEProducts:nonladpros}, () => {
                this.updateNonSimProductsCount();
              })
             }, 200);

        })

    }
     handleFilterSCProducts = (ctxt,isReSerach) => {
        let searchTxt = (ctxt && ctxt.length > 0?ctxt:"");

        this.setState({ sc_filter: isReSerach?this.state.sc_filter:searchTxt },()=>{
            if(this._scprodTimeOut){ clearTimeout(this._scprodTimeOut); }

            this._scprodTimeOut = setTimeout(() => {
                var scladprods = JSON.parse(JSON.stringify(this.props.productsWithAnomaly));

                for (let i = 0; i < scladprods.length; i++) {
                    const scladprod = scladprods[i];
                    let nonSearchQuery = ((scladprod.productBarcode?scladprod.productBarcode.toLowerCase():"")+" "+(scladprod.productName?scladprod.productName.toLowerCase():""));
                    let isnotfiltered=(nonSearchQuery.includes(this.state.sc_filter.toLowerCase())
                    && (parseInt(this.state.selectedScFilterCat.value)===-1?true:scladprod.categoryId===this.state.selectedScFilterCat.value)
                    && (parseInt(this.state.selectedScFiltersubcat.value)===-1?true:scladprod.subCategoryId===this.state.selectedScFiltersubcat.value)
                    && (parseInt(this.state.selectedScFilterBrand.value)===-1?true:scladprod.brandId===this.state.selectedScFilterBrand.value)
                    && (parseInt(this.state.selectedScFilterSupp.value)===-1?true:scladprod.supplierId===this.state.selectedScFilterSupp.value)
                    && (parseInt(this.state.selectedScFilterStat.value)===-1?true:scladprod.anomaly===this.state.selectedScFilterStat.value)
                    );

                    scladprod.isFilterd = !isnotfiltered
                }

                scladprods = scladprods.filter(x=>x.isFilterd===false);

                scladprods.sort((a, b) =>  b.salesCycle - a.salesCycle );

              this.setState({nonfilteredSCProducts:scladprods})
             }, 200);

        })

    }

    showSelectedSCProduct = (id) => {
        if(id === this.state.selectedScProductId){
            this.setState({selectedScProductId: -1});
        }else{
            this.setState({selectedScProductId: id});
        }
    }

    //search products list view
    searchProdList = (ctxt,startidx,isdefualt) => { 
        // let defSaveObj = this.props.defSaveObj;
        let allcatrects = this.state.mapCatRects;
        
        // if(allcatrects && Object.keys(allcatrects).length > 0){

            let psobj = {
                productName: ctxt,
                isReqPagination: true,
                startIndex: startidx,
                maxResult: this.state.pmaxcount,
                withImageUrl: true,
                // departmentId: (defSaveObj && defSaveObj.department?(defSaveObj.department.department_id?defSaveObj.department.department_id:defSaveObj.department.id):-1),//no need of this to new call
                // category_id: selcatid,
                // isRuleBased: isrulebased,
                // rule: ruleobj
            }


            this.setState({srchprodsloading: true});
            // submitSets(submitCollection.findProdByCategoryLevel, psobj, true).then(res => {
            submitSets(submitCollection.getProductList, psobj, true).then(res => {
                var cdata = this.state.filteredProdList;
                this.setState({srchprodsloading: false,isSearchprodutDefault:isdefualt?false:this.state.isSearchprodutDefault});
                if(res && res.status){
                    for (var i = 0; i < res.extra.length; i++) {
                        cdata.push(res.extra[i]);
                    }
                    this.setState({ filteredProdList: cdata, pstartpage: startidx });
                    if(startidx === 0){
                        this.setState({ptotalresults: res.count});
                    }
                } else{
                    alertService.error(this.props.t('NO_RESULT_FOUND'));
                    this.setState({ filteredProdList: cdata });
                }
            });
        // }
    }
     //copy barcode to clipboard message show
    copyToClipboard = (ctxt) => {
        alertService.info(this.props.t("COPIED_TO_CLIP_BOARD"));
    }
    //toggle products view
    toggleProdListView = (cstat) => {
        this.setState({isListViewActive: null}, () => {
            setTimeout(() => {
                this.setState({isListViewActive: cstat});
            }, 200);
        });
    }
    //onclick load more button in search
    loadMoreProds = () => {
        //add maxcount to current start index
        var cstarttxt = (this.state.pstartpage === 0?(this.state.pmaxcount):(this.state.pstartpage + this.state.pmaxcount));
        var ctxt = document.getElementById("filterprodtxt").value; //get filter typed value
        this.searchProdList(ctxt,cstarttxt);
    }
    //
    loadAGAINProds = () => {
        //add maxcount to current start index
        // var cstarttxt = (this.state.pstartpage === 0?(this.state.pmaxcount):(this.state.pstartpage + this.state.pmaxcount));
        var ctxt = document.getElementById("filterprodtxt").value; //get filter typed value
        this.setState({filteredProdList: []}, () => {
            this.searchProdList(ctxt,this.state.pstartpage);
            })
    }
    //draws green box with mouse when dragging product to indicate product size according to field size
    drawRectCanvas = (cprod,iscutsingle) => {
        const canvele = this.dragPreviewCanvas.current;
        var draggingProduct = cprod;  //get dragging product
        var ctx = canvele.getContext("2d");

        canvele.width = 1;
        canvele.height = 1;
        ctx.fillStyle = "white";
        ctx.fillRect(0,0,canvele.width,canvele.height);

        //convert canvas to data image object
        var canimg = this.dragPreviewCanvas.current.toDataURL("image/png");
        //create new image and se that image src data image object
        var img = new Image();
        img.src = canimg;
        this.dragPreviewImage = img; //and set that image to ref image

        //update state
        var currprod = {productInfo:draggingProduct};
        this.setState({ view: { currentDeleteProd: currprod }, isviewcmenu: false,isviewcmenu2:false,});
    }
    //triggers on product drag start
    dragStart = (e, productObj, isd3move, cutidx, iscutsingle, singleidx,cutshelfidx,clipprodid,clipShelfrank,clipGroupid, groupItems = null) => {
        const allProducts = productObj?.shelf?.flatMap(s => s.products);
        let isDel = false;
        allProducts?.forEach((item) => {
            if (item.isProductDelete) {
                isDel = true;
            }
        })

        if(isDel){
            return;
        }
        let productList = groupItems;
        productList = productList?.map((prod) => ({
            ...prod,
            id: uuidv4(),
            uuid: uuidv4(),
        }));

        if(!isd3move){
            e.dataTransfer.setDragImage(this.dragPreviewImage, 0,0); //set drag image we generated with canvas
        }
        if(productObj){
            // console.log("productObj",productObj)
            var draggingProduct = JSON.parse(JSON.stringify(productObj));
            draggingProduct.cutidx = cutidx;
            draggingProduct["isSingleCut"] = iscutsingle;
            draggingProduct["singleidx"] = singleidx;
            draggingProduct["cutshelfidx"] = cutshelfidx;
            if(clipprodid){
                draggingProduct["clipprodid"] = clipprodid;
                draggingProduct["clipShelfrank"] = clipShelfrank;
                draggingProduct["clipGroupid"] = clipGroupid;
            }
            
            if(draggingProduct.is_cutitem){
                var cdraggingProduct=draggingProduct
                let totalDrawWidth  = 0;
                let totalDrawHeight = 0;

                this.state.clipDragType === "SINGLE" && groupItems && groupItems?.map((prod, i) => {
                    totalDrawWidth  += prod.drawWidth;
                    totalDrawHeight = prod.drawHeight;
                });

                if(this.state.clipDragType === "SINGLE"){
                    cdraggingProduct.width  = totalDrawWidth;
                    cdraggingProduct.height = totalDrawHeight
                }

                if(this.state.clipDragType === "SINGLE"){
                    const shelfObj = [{
                        height : totalDrawHeight,
                        id:uuidv4(),
                        products: productList,
                        shelfrank: clipShelfrank,
                        selectedProducts:productList,
                        width: totalDrawWidth,
                        drawWidth: productList[0].drawWidth,
                        drawHeight:productList[0].drawHeight,
                    }]
                    draggingProduct.shelf = shelfObj;
                }else{
                    cdraggingProduct?.shelf?.forEach(slf => {
                        //if(this.state.clipDragType !== "SINGLE"){
                        //     slf.products = groupItems;
                        //     slf.selectedProducts = groupItems;
                        //     slf.width = totalDrawWidth;
                        //     slf.height = totalDrawHeight;
                        //     slf.drawWidth = slf.width;
                        //     slf.drawHeight = slf.height;
                        // }else{

                           // update sheld product id list
                           slf.products.map((prod, i) =>{
                            prod.id = uuidv4();
                            prod.uuid = uuidv4();
                           })

                            slf.selectedProducts = slf.products
                        //} 
                    });
                }

                
                //console.log('draggingProductShelf==>', draggingProduct.shelf);
                //let draggingProductShelf = [];
                // if(this.state.clipDragType === "SINGLE"){
                //    let selectedGroupShelf  = draggingProduct?.shelf.filter(x => x.shelfRank === clipShelfrank);
                //    draggingProductShelf    = selectedGroupShelf;
                // }else{
                //     draggingProductShelf = draggingProduct.shelf;
                // }
                cdraggingProduct.shelf = draggingProduct.shelf
                cdraggingProduct.selectedshelves = draggingProduct.shelf
                cdraggingProduct.drawWidth=cdraggingProduct.width
                cdraggingProduct.drawHeight=cdraggingProduct.height

            }
            // console.log('draggingProduct=====>', draggingProduct);
            //set state
            this.setState({ currentDraggableProd: draggingProduct, isContentDragging: true });
        }
        this.removeExpandOpts();
    }
    //draw dragging product rect
    dragProdView = (e, prod) => {
        if((!this.state.isDisableEDitingwithfullscreen&&!this.state.isDisableEdits)){
            var draggingProduct = JSON.parse(JSON.stringify(prod));  //get dragging product
            var curwidth = (draggingProduct.rotatewidth?draggingProduct.rotatewidth:draggingProduct.width);
            var curheight = (draggingProduct.rotateheight?draggingProduct.rotateheight:draggingProduct.height);
            let drawzoomx = this.state.zoomXRatio;
            let prodwidth = (measureConverter(draggingProduct.uom,this.state.displayUOM,curwidth) * this.state.displayRatio);
            let prodheight = (measureConverter(draggingProduct.uom,this.state.displayUOM,curheight) * this.state.displayRatio);

            draggingProduct["drawWidth"] = prodwidth * (drawzoomx > 0?(drawzoomx * 2):1);
            draggingProduct["drawHeight"] = prodheight * (drawzoomx > 0?(drawzoomx * 2):1);

            // If product has price tag, add price tag height + gap to ghost box height
            const hasPriceTag = draggingProduct?.product?.hasPriceTagLatest || draggingProduct?.hasPriceTagLatest;
            if (hasPriceTag) {
                const priceTagHeightPx = (draggingProduct?.product?.priceTagHeightLatest || draggingProduct?.priceTagHeightLatest || 0) * this.state.displayRatio;
                const gapPx = (draggingProduct?.product?.priceTagGapLatest || draggingProduct?.priceTagGapLatest || 0) * this.state.displayRatio;
                draggingProduct["drawHeight"] += priceTagHeightPx + gapPx;
            }

            ghostOnDrag(e, draggingProduct, this.oriPageXY);
        }
    }
    //trigger on product drag stops
    dragEnd = (e, shelfObj, shelfRef, isinsidemove, moveobj, isdrop, selectedShelfidx, fieldobj) => {

        if((!this.state.isDisableEDitingwithfullscreen&&!this.state.isDisableEdits)){
            if(!shelfObj.isDisable && (this.state.currentDraggableProd || this.state.currentInternalDraggableProd)){
                if(findBrowserType() === "firefox"){
                    this.getPageXYCords(e);
                }
                var xa = 0;
                var ya = 0;
                var Cwidth = 0;
                var Cheight = 0;
                var acutualX = 0;
                var actualY = 0;

                let viewboxcoords = (!isinsidemove&&!moveobj)?this.getScreenPointer(e):null;
                var draggingProduct = moveobj?moveobj:isinsidemove?this.state.selectedlocobj:this.state.currentDraggableProd; //get draging product

                //set pruduct paste x,y locations
                if(draggingProduct.is_cutitem){
                    e.stopPropagation();
                    e.preventDefault();

                    //if drag from clip board
                    xa = viewboxcoords.x;
                    ya = viewboxcoords.y//(shelfObj.y + shelfObj.drawHeight) - (Cheight + this.state.checkSaftyMargin); //get bottom y point
                    acutualX = viewboxcoords.x;
                    actualY = viewboxcoords.y;
                    Cwidth = draggingProduct.width;
                    Cheight = draggingProduct.height;

                    var cdraggingProduct = structuredClone(draggingProduct);

                    if(this.state.clipDragType === "SINGLE"){
                        let x = 0;
                        cdraggingProduct.selectedshelves[0]?.selectedProducts?.forEach((prod) => {
                            if(prod){
                                prod['x'] = x;
                                prod['xCoppy'] = x;
                                x += prod?.drawWidth ?? 0;
                            }
                        });
                    }

                    cdraggingProduct.x = xa;
                    cdraggingProduct.y = ya;
                    var filtereddraggingshelves=cdraggingProduct.selectedshelves.filter(q=>q.isDelete!==true)
                    for (let i = 0; i < filtereddraggingshelves.length; i++) {
                        const shelfitem = filtereddraggingshelves[i];
                        for (let j = 0; j < shelfitem.selectedProducts.length; j++) {
                            const proditem = shelfitem.selectedProducts[j];
                            proditem.x = (parseFloat(xa) + parseFloat(proditem.x));
                            // proditem.y = roundOffDecimal((parseFloat(ya) + parseFloat(proditem.y)),2);
                        }
                    }

                    if(this._changingX > 0 || this._changingY > 0){
                        let x1margin = (this._changingX - this.state.saftyMargin);
                        let x2margin = (this._changingX + this.state.saftyMargin);

                        let y1margin = (this._changingY - this.state.saftyMargin);
                        let y2margin = (this._changingY + this.state.saftyMargin);

                        if(x1margin > xa || x2margin < xa || y1margin > ya || y2margin < ya){
                            //if drag from clip board

                            var coppycdraggingProduct=cdraggingProduct
                            coppycdraggingProduct.selectedshelves=filtereddraggingshelves

                            let props = {
                                cx: structuredClone(xa),
                                cy: structuredClone(ya),
                                // selectBlockObj: cdraggingProduct,
                                selectBlockObj: coppycdraggingProduct,
                                mapFields: this.state.mapFields,
                                mapCatRects: this.state.mapCatRects,
                                mapproductList: this.state.mapproductList,
                                setPreviewGuid: this.setPreviewGuid,
                                updateGhostObjDetails:this.updateGhostObjDetails,
                                actualFieldStructuresNew:this.state.actualFieldStructures
                            }

                            this._changingX = props.cx;
                            this._changingY = props.cy;

                            this.guideLineDrawContinue(props, shelfObj, selectedShelfidx, fieldobj);
                        }
                    } else{
                        this._changingX = xa;
                        this._changingY = ya;
                    }

                    //scroll parent with drag
                    this.scrollParentWithDrag(cdraggingProduct);

                    // PEG CR --------------------------
                    // PEG CR - 2025 March
                    let isInsidePeg = false;
                    let insideHalfPegBoard = false;
                    let droppedPegBoard = null;
                    let pegBoardData = this.state.droppedToPegBoard;
                    let x = acutualX;
                    let x2 = acutualX+Cwidth;
                    let y = actualY;
                    let y2 = actualY+Cheight;
                    
                    // check is it inside the peg boards
                    if(this.state.pegList){
                        for (let i = 0; i < this.state.pegList.length; i++) {
                            const {pegDrawingRect} = this.state.pegList[i];

                            let pegBoardStartX = pegDrawingRect.drawX;
                            let pegBoardStartY = pegDrawingRect.drawY;
              
                            let pegBoardEndX = pegDrawingRect.drawX + pegDrawingRect.drawRectWidth;
                            let pegBoardEndY = pegDrawingRect.drawY + pegDrawingRect.drawRectHeight;
                            
                            if(pegBoardStartX < x && pegBoardEndX > x2 && pegBoardStartY < y && pegBoardEndY > y2){
                                isInsidePeg = true;
                                insideHalfPegBoard = false;
                                droppedPegBoard = this.state.pegList[i];
                                // console.log("CUT INSIDE PEG BOARD!")
                                break;
                            }
                            // Check if at least 3% of the product's width or height is inside the peg board
                            else if (
                                (x < pegBoardEndX && x2 > pegBoardStartX) && // Horizontally overlapping
                                (y < pegBoardEndY && y2 > pegBoardStartY) // Vertically overlapping
                            ) {
                                let productWidth = Cwidth;
                                let productHeight = Cheight;

                                let overlapWidth = Math.min(x2, pegBoardEndX) - Math.max(x, pegBoardStartX);
                                let overlapHeight = Math.min(y2, pegBoardEndY) - Math.max(y, pegBoardStartY);

                                // Calculate percentage of product width and height overlapping with peg board
                                let widthOverlapPercent = (overlapWidth / productWidth) * 100;
                                let heightOverlapPercent = (overlapHeight / productHeight) * 100;

                                // If at least 3% of the width or height is inside the peg board, set insideHalfPegBoard to true
                                if (widthOverlapPercent >= 3 || heightOverlapPercent >= 3) {
                                    isInsidePeg = false; 
                                    insideHalfPegBoard = true; // Set true if at least 3% of product is inside
                                    break;
                                    // console.log("HALF INSIDE PEG BOARD!")
                                }
                            }else{
                                isInsidePeg = false;
                                droppedPegBoard = null;
                                insideHalfPegBoard = false;
                            }
                        }
                    }

                    // set to state
                    pegBoardData.droppedPegBoard = droppedPegBoard;
                    pegBoardData.isDroppedPegBoard = isInsidePeg;
                    pegBoardData.insideHalfPegBoard = insideHalfPegBoard;
                    pegBoardData.droppedX = acutualX;
                    pegBoardData.droppedY = actualY;
                    // PEG CR --------------------------

                }else{

                    if(moveobj){
                        xa =e.x;
                        ya = (shelfObj.y + shelfObj.drawHeight)-(moveobj.drawHeight+ this.state.checkSaftyMargin);
                        Cwidth=moveobj.drawWidth;
                        Cheight=moveobj.drawHeight;

                    }else if(isinsidemove){
                        xa =e.x;
                        ya = (shelfObj.y + shelfObj.drawHeight)-(this.state.selectedlocobj.drawHeight+ this.state.checkSaftyMargin);
                        Cwidth=this.state.selectedlocobj.drawWidth;
                        Cheight=this.state.selectedlocobj.drawHeight;

                    }else{
                        if(draggingProduct.is_cutitem){
                            Cwidth = draggingProduct.width;
                            Cheight = draggingProduct.height;
                        } else{
                            Cwidth=measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.width) * this.state.displayRatio;
                            Cheight=measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.height) * this.state.displayRatio;
                        }

                        xa = viewboxcoords.x;
                        acutualX = viewboxcoords.x;
                        actualY = viewboxcoords.y;
                        ya = (shelfObj.y + shelfObj.drawHeight) - (Cheight + this.state.checkSaftyMargin); //get bottom y point
                    }

                    draggingProduct.drawHeight=Cheight
                    draggingProduct.drawWidth=Cwidth
                    draggingProduct["x"] = xa;
                    draggingProduct["y"] = ya;
                    var allowToAdd = false;
                    var checkshelfobj=null;

                    // PEG CR --------------------------
                    // PEG CR - 2025 March
                    let isInsidePeg = false;
                    let insideHalfPegBoard = false;
                    let droppedPegBoard = null;
                    let pegBoardData = this.state.droppedToPegBoard;
                    let x = acutualX;
                    let x2 = acutualX+Cwidth;
                    let y = actualY;
                    let y2 = actualY+Cheight;
                    
                    // check is it inside the peg boards
                    if(this.state.pegList){
                        for (let i = 0; i < this.state.pegList.length; i++) {
                            const {pegDrawingRect} = this.state.pegList[i];

                            let pegBoardStartX = pegDrawingRect.drawX;
                            let pegBoardStartY = pegDrawingRect.drawY;
              
                            let pegBoardEndX = pegDrawingRect.drawX + pegDrawingRect.drawRectWidth;
                            let pegBoardEndY = pegDrawingRect.drawY + pegDrawingRect.drawRectHeight;
                            
                            if(pegBoardStartX < x && pegBoardEndX > x2 && pegBoardStartY < y && pegBoardEndY > y2){
                                isInsidePeg = true;
                                insideHalfPegBoard = false;
                                droppedPegBoard = this.state.pegList[i];
                                // console.log("INSIDE PEG BOARD!")
                                break;
                            }
                            // Check if at least 3% of the product's width or height is inside the peg board
                            else if (
                                (x < pegBoardEndX && x2 > pegBoardStartX) && // Horizontally overlapping
                                (y < pegBoardEndY && y2 > pegBoardStartY) // Vertically overlapping
                            ){
                                let productWidth = Cwidth;
                                let productHeight = Cheight;

                                let overlapWidth = Math.min(x2, pegBoardEndX) - Math.max(x, pegBoardStartX);
                                let overlapHeight = Math.min(y2, pegBoardEndY) - Math.max(y, pegBoardStartY);

                                // Calculate percentage of product width and height overlapping with peg board
                                let widthOverlapPercent = (overlapWidth / productWidth) * 100;
                                let heightOverlapPercent = (overlapHeight / productHeight) * 100;

                                // If at least 3% of the width or height is inside the peg board, set insideHalfPegBoard to true
                                if (widthOverlapPercent >= 3 || heightOverlapPercent >= 3) {
                                    isInsidePeg = false; 
                                    insideHalfPegBoard = true; // Set true if at least 3% of product is inside
                                    // console.log("HALF INSIDE PEG BOARD!")
                                    break;
                                }
                            }else{
                                isInsidePeg = false;
                                droppedPegBoard = null;
                                insideHalfPegBoard = false;
                            }
                        }
                    }

                    // set to state
                    pegBoardData.droppedPegBoard = droppedPegBoard;
                    pegBoardData.isDroppedPegBoard = isInsidePeg;
                    pegBoardData.insideHalfPegBoard = insideHalfPegBoard;
                    pegBoardData.droppedX = acutualX;
                    pegBoardData.droppedY = actualY;
                    // PEG CR --------------------------

                    if(isdrop){
                        checkshelfobj = shelfObj;
                    }else{
                        if(this.state.currentInternalDraggableProd.shelveidx === selectedShelfidx){
                            //filter draw product array except not inside block selected
                            checkshelfobj = structuredClone(shelfObj);

                            var exprods = checkshelfobj.brand[this.state.currentInternalDraggableProd.brandidx].drawingProducts;
                            var toRemoveprods = this.state.currentSelectedBlock.drawingProducts;
                            var filterdprods = exprods.filter(ar => !toRemoveprods.find(rm => (rm.uuid === ar.uuid ) ));

                            checkshelfobj.brand[this.state.currentInternalDraggableProd.brandidx].drawingProducts = filterdprods;
                        } else{
                            checkshelfobj = shelfObj;
                        }
                    }
                    //console.log(checkshelfobj);

                    //prevent browser events
                    if(!isinsidemove){
                        e.stopPropagation();
                        e.preventDefault();
                    }

                    let bkpxa = structuredClone(xa);
                    let bkpxb = structuredClone((xa + Cwidth));

                    if(xa !== this._dropposition.startX && (xa + Cwidth) !== this._dropposition.endX){
                        // let isRightOverlapFixed = false;
                        if(draggingProduct !== undefined || draggingProduct !== null){
                            allowToAdd = checkAllowToAdd(e, checkshelfobj, draggingProduct, xa, ya, this.state.checkSaftyMargin); //check allow to add that location - retuns boolean
                            // console.log(allowToAdd);

                            //if cannot add to shelf and is inside shelf and overlapping from right side
                            let checkshelfy2 = (checkshelfobj.y + checkshelfobj.drawHeight + checkshelfobj.drawGap);
                            let checkshelfx2 = (checkshelfobj.x + checkshelfobj.drawWidth);

                            if(!allowToAdd.allowToAdd && checkshelfobj.y <= ya && (ya + Cheight) <= checkshelfy2 && xa < checkshelfx2 && (xa + Cwidth) > checkshelfx2){
                                // isRightOverlapFixed = true;

                                allowToAdd = { allowToAdd: true, shelfAllow: true };
                                xa = ((checkshelfx2 - Cwidth));
                            }
                        }

                        //reset shelf highlight
                        /* for (let l = 0; l < document.getElementsByClassName("sftrect-notdis").length; l++) {
                            const element = document.getElementsByClassName("sftrect-notdis")[l];
                            element.style.fill = 'transparent';
                        } */

                        if(allowToAdd.allowToAdd && shelfRef) {
                            // shelfRef.style.fill = 'rgba(144, 255, 173, 0.5)'; //highlights shelve background color

                            //show drop guidelines of shelf
                            if(this._guideTimeout){
                                clearTimeout(this._guideTimeout);

                                if(this.state.isFirstTimeDrawguid){
                                    this.setPreviewGuid(false, null, null, true);
                                }
                            }

                            this._guideTimeout = setTimeout(() => {
                                let droppingXProd = null;
                                let notDeletedProds = this.state.mapproductList.filter(f =>
                                    !f.isDelete && f.field_custom_id === fieldobj.field_custom_id && f.shelfrank === checkshelfobj.rank
                                );
                                // console.log(notDeletedProds);

                                for (let p = 0; p < notDeletedProds.length; p++) {
                                    const prod = notDeletedProds[p];

                                    if(prod.id !== draggingProduct.id){
                                        let prodstartx = (prod.x);
                                        let checkprodwidth = (((prod.drawWidth / 3) > 8)?(prod.drawWidth / 3):(prod.drawWidth / 2));
                                        let prodmiddlex = (prod.x + checkprodwidth);

                                        if(xa > prodstartx && xa < prodmiddlex){
                                            xa = prod.x;
                                        }

                                        if(prod.x <= xa && xa <= roundOffDecimal((prod.x + prod.drawWidth),2)){
                                            droppingXProd = prod;
                                        }
                                    }
                                }

                                if(!droppingXProd){
                                    xa = getSnappingLocation(xa, fieldobj, this.state.mapproductList, draggingProduct, [shelfObj]);
                                }

                                shelfObj.previewguid = {startX: xa, endX: (xa + Cwidth)};

                                let previewShelves = [shelfObj];
                                let selectingField = (shelfObj.field_custom_id?this.state.mapFields[shelfObj.field_custom_id]:null);

                                if(selectingField){
                                    selectingField["key"] = shelfObj.field_custom_id;
                                    this.setPreviewGuid(false, previewShelves, selectingField);
                                }
                            }, 200);
                        } else{
                            if(this.state.isFirstTimeDrawguid){
                                this.setPreviewGuid(false, null, null, true);
                            }
                        }
                    }

                    this._dropposition = {startX: bkpxa, endX: bkpxb};

                    if(isinsidemove||moveobj){
                        return allowToAdd;
                    }

                    //scroll parent with drag
                    this.scrollParentWithDrag(draggingProduct);
                }

            } else{
                for (let l = 0; l < document.getElementsByClassName("sftrect-notdis").length; l++) {
                    const element = document.getElementsByClassName("sftrect-notdis")[l];
                    element.style.fill = 'transparent';
                }

                if(this.state.isFirstTimeDrawguid){
                    this.setPreviewGuid(false, null, null, true);
                }
            }
        }
    }

    //scroll parent handle
    scrollParentWithDrag = (evt) => {
        let saftyMargin = 20;
        let saftyOverlapMargin = 40;

        //scroll parent div with d3 drag
        let parent = document.getElementById(this.state.wrapperId);
        let zoomXRatio = this.state.zoomXRatio;

        let w = parent.offsetWidth;
        let h = parent.offsetHeight;
        let sL = parent.scrollLeft;
        let sT = parent.scrollTop;

        let movewidth = (evt.drawWidth + (zoomXRatio > 0?(zoomXRatio + 1):1));
        let moveheight = (evt.drawHeight + (zoomXRatio > 0?(zoomXRatio + 1):1));

        let x = ((evt.x > 0?(evt.x - saftyMargin):0) * (zoomXRatio > 0?(zoomXRatio + 1):1));
        let x2 = (((evt.x + saftyMargin) * (zoomXRatio > 0?(zoomXRatio + 1):1)) + movewidth);
        let y = ((evt.y > 0?(evt.y - saftyMargin):0) * (zoomXRatio > 0?(zoomXRatio + 1):1));
        let y2 = (((evt.y + saftyMargin) * (zoomXRatio > 0?(zoomXRatio + 1):1)) + moveheight);

        //if dragging horizontal
        if (((w + sL) + saftyOverlapMargin) > x2 && x2 > (w + sL)) {
            parent.scrollLeft = (x2 - w);
        } else if (x < sL) {
            parent.scrollLeft = (x);
        }

        //if dragging vertical
        if (y2 > h + sT) {
          parent.scrollTop = (y2 - h);
        } else if (y < sT) {
          parent.scrollTop = (y);
        }
    }


    //guideline draw continue
    guideLineDrawContinue = (props, shelfobj, shelfidx, fieldobj) => {
        if(this._guideTimeout){
            clearTimeout(this._guideTimeout);

            if(this.state.isFirstTimeDrawguid){
                this.setPreviewGuid(false, null, null, true, []);
            }
        }

        this._cutDragObj = { shelfobj: shelfobj, shelfidx: shelfidx, fieldobj };

        this._guideTimeout = setTimeout(() => {
            // console.log(this._changingX+" !== "+props.cx, this._changingY+" !== "+props.cy);
            setGuidlineComman(props);
        }, 150);
    }

    //clear drag out - removes green fill in shelves when can drop products to shelve(y edit)
    dragClear = (e, shelfObj, shelfRef) => {
        if(!shelfObj.isDisable && this.state.xrayActive === 1){
            shelfRef.style.fill = 'transparent';
        }

        if(this._dragcleartout){ clearTimeout(this._dragcleartout); }

        this._dragcleartout = setTimeout(() => {
            this.setPreviewGuid(false,null,null,true);
        }, 300);

        // this.setState({ isContentDragging: false });
    }
    //#MP-SML-E-DP-01
    //triggers on drop product to shelve
    dropproduct = (e, shelfObj, shelfRef, shelfIdx, isxpand, fieldobj) => {
        e.preventDefault(); //fixes firefox image dragging issue
        let viewboxcoords = this.xyChangeCoords(e);
        var xa = viewboxcoords.x;
        var draggingProduct = JSON.parse(JSON.stringify(this.state.currentDraggableProd)); //get current dragging product
        //checking drop validation
        let departmentId = (this.props.defSaveObj && this.props.defSaveObj.department?((this.props.simType === "AUI")?this.props.defSaveObj.department.id:this.props.defSaveObj.department.department_id):null);
        let departmentname = (this.props.defSaveObj && this.props.defSaveObj.department?(((this.props.simType === "AUI")?this.props.defSaveObj.department.name:this.props.defSaveObj.department.department_name)+" "+this.props.t("department")):"-");
        // console.log(deptObj);

        if(!draggingProduct.isSingleCut){
            var validateList = validateHeirarchyMissings(draggingProduct, departmentId, departmentname);

            /* if(!draggingProduct.width || !draggingProduct.height || !draggingProduct.uom || draggingProduct.uom === "" || !draggingProduct.depth){
                validateList.push({type:"Dimension",text:this.props.t('PROD_DIMENTIONS_NOTAVAILABLE')})
                // alertService.warn(this.props.t('PROD_DIMENTIONS_NOTAVAILABLE'));
                // return false;
            } if(!draggingProduct.imageUrl || draggingProduct.imageUrl === ""){
                validateList.push({type:"image",text:this.props.t('PROD_IMAGE_NOTFOUND')})
            } if(draggingProduct.hierarchyCompleteStatus==="HaveIssues"){
                validateList.push({type:"Hierarchy_Issue",text:this.props.t('Hierarchy_Issue')})
            } if(draggingProduct.mpUsageStatus==="Archived" ){
                validateList.push({type:"Archived",text:this.props.t('Product_is_Archived')})
            } if(draggingProduct.mpUsageStatus==="New" ){
                validateList.push({type:"New",text:this.props.t('Product_is_NewProduct')})
            } if(draggingProduct.mpUsageStatus==="None" ){
                validateList.push({type:"None",text:this.props.t('product_Didnt_sendto_dep')})
            } */

            if(validateList.length > 0){
                this.setState({
                    dropWarningList: validateList,
                    selectedwarningdropprod: draggingProduct
                },()=>{
                    this.cannotDropWarningHandle()
                })
                return false;
            }
        }

        draggingProduct.drawHeight=measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.height) * this.state.displayRatio;
        draggingProduct.drawWidth=measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.width) * this.state.displayRatio;
        //check dragging product available
        if (draggingProduct === undefined || draggingProduct === null) {
            alertService.warn(this.props.t('PRODUCT_NOT_SELECTED'))
            return;
        }

        //if isexpand
        if(isxpand && draggingProduct){
            xa = xa - ((measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.width) * this.state.displayRatio) / 2);
        }

        //check dragging product available and allowed to add
        if (draggingProduct && draggingProduct != null) { // && allowToAdd
            this.setState({ isviewcmenu: false,isviewcmenu2:false });
            //set product y position
            var newy = (shelfObj.y + shelfObj.drawHeight) - ((measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.height) * this.state.displayRatio)); //get bottom y point
            let checknewy = (newy + this.state.checkSaftyMargin)

            //find is product can added to bottom of shelve
            var allowToAddBottom = null;

            //is it allow to drop to bottom of shelve
            draggingProduct["isNew"] = true;
            draggingProduct["isDelete"] = false;

            // var cdrgprod = {shelveidx: shelfIdx, brandidx: null, prodidx: null, prod: null};

            // let isRightOverlapFixed = false;
            if(draggingProduct !== undefined || draggingProduct !== null){
                allowToAddBottom = checkAllowToAdd(e, shelfObj, draggingProduct, xa, checknewy, this.state.checkSaftyMargin); //check allow to add that location - retuns boolean
                // console.log(allowToAddBottom);

                //if cannot add to shelf and is inside shelf and overlapping from right side
                let checkshelfy2 = (shelfObj.y + shelfObj.drawHeight + shelfObj.drawGap);
                let checkshelfx2 = (shelfObj.x + shelfObj.drawWidth);

                if(!allowToAddBottom.allowToAdd && shelfObj.y <= newy && (newy + draggingProduct.drawHeight) <= checkshelfy2 && xa < checkshelfx2 && (xa + draggingProduct.drawWidth) > checkshelfx2){
                    // isRightOverlapFixed = true;

                    allowToAddBottom = { allowToAdd: true, shelfAllow: true };
                    xa = ((checkshelfx2 - draggingProduct.drawWidth));
                }
            }

            //if product can add to bottom of shelve
            if (allowToAddBottom.allowToAdd && shelfRef) {
                this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),1);

                let isruleupdating = false;

                //get current products list
                let prodlist = this.state.mapproductList;

                let brandobj = null;
                let subcatobj = null;

                if(draggingProduct.isSingleCut){
                    brandobj = draggingProduct.brand;

                    subcatobj = draggingProduct.subcategory;

                    if(subcatobj.type === catRectEnums.rule){
                        //find if rule brand available
                        let brandid = getNameorIdorColorofBox(subcatobj, "num");
                        let rulelevel = subcatobj.rule.level;

                        let findfromrules = findRuleAvailableForBrand(brandid, true, rulelevel, this.state.mapRulesList);
                        // console.log(findfromrules);

                        if(findfromrules.isavailable){
                            isruleupdating = {parentidx: findfromrules.ruleparentidx, ruleidx: findfromrules.ruleidx};
                        }
                    }
                } else {

                    if (draggingProduct.brandId && draggingProduct.brandId > 0) {

                        let brandsupobj = (draggingProduct.supplierId && draggingProduct.supplierId > 0 ? { supplierId: draggingProduct.supplierId, supplierName: draggingProduct.supplierName } : {supplierId: draggingProduct?.supplierId, supplierName: draggingProduct.supplierName});
                        brandobj = {
                            brand: {
                                brandName: draggingProduct.brandName,
                                color: draggingProduct.brandColor,
                                brandId: draggingProduct.brandId,
                                posCode: draggingProduct.brandCode || draggingProduct.brand?.posCode || draggingProduct.productBrand?.posCode,
                                supplier: brandsupobj,
                            },
                            type: catRectEnums.default,
                            rule: null
                        }
                    }

                    if(draggingProduct.subCategoryId && draggingProduct.subCategoryId > 0){
                        subcatobj = {
                            sub_category: {
                                subCategoryName: draggingProduct.subCategoryName,
                                color: draggingProduct.subCategoryColor,
                                subCategoryId: draggingProduct.subCategoryId,
                                posCode: draggingProduct.subcategoryCode || draggingProduct.subcategory?.posCode || draggingProduct.subcategory?.sub_category?.posCode
                            },
                            type: catRectEnums.default,
                            rule: null
                        }

                        //find if rule supplier available
                        let supplierid = draggingProduct.supplierId;
                        if(supplierid > 0){
                            let findsupfromrules = findRuleAvailableForBrand(supplierid, true, catRuleEnums.sup, this.state.mapRulesList);
                            // console.log(findsupfromrules);

                            if(findsupfromrules.isavailable){
                                subcatobj = {
                                    sub_category: null,
                                    type: catRectEnums.rule,
                                    rule: {
                                        id: findsupfromrules.ruleobj.id,
                                        level: findsupfromrules.ruleobj.level,
                                        supplier: (findsupfromrules.ruleobj.level === catRuleEnums.sup?findsupfromrules.ruleobj.supplier:{}),
                                        brand: (findsupfromrules.ruleobj.level === catRuleEnums.brand?findsupfromrules.ruleobj.brand:{}),
                                    }
                                }

                                isruleupdating = {parentidx: findsupfromrules.ruleparentidx, ruleidx: findsupfromrules.ruleidx};
                            }
                        }

                        //find if rule brand available
                        let brandid = getNameorIdorColorofBox(brandobj, "num");

                        let findfromrules = findRuleAvailableForBrand(brandid, false, null, this.state.mapRulesList);

                        if(findfromrules.isavailable){ // && findfromrules.ruleobj.ruleState !== "default"
                            subcatobj = {
                                sub_category: null,
                                type: catRectEnums.rule,
                                rule: {
                                    id: findfromrules.ruleobj.id,
                                    level: findfromrules.ruleobj.level,
                                    supplier: (findfromrules.ruleobj.level === catRuleEnums.sup?findfromrules.ruleobj.supplier:{}),
                                    brand: (findfromrules.ruleobj.level === catRuleEnums.brand?findfromrules.ruleobj.brand:{}),
                                }
                            }

                            isruleupdating = {parentidx: findfromrules.ruleparentidx, ruleidx: findfromrules.ruleidx};
                        }
                    }
                }
                //checking

                    var cisStackable=false
                    var drgprodid=draggingProduct.isSingleCut?draggingProduct.productId:draggingProduct.id
                    var drgprodisstack=draggingProduct.isSingleCut?draggingProduct.isStackable:draggingProduct.isStackable
                    for (let k = 0; k < this.state.mapproductList.length; k++) {
                        const oprod = this.state.mapproductList[k];
                        //console.log(oprod.productId,drgprodid);
                        if(oprod.productId===drgprodid){
                            cisStackable=oprod.isStackable
                            break
                        }else{
                            if(k===this.state.mapproductList.length){
                                cisStackable=drgprodisstack
                            }
                        }

                    }

                //finddragging product drop to wich box
                let movingObj = JSON.parse(JSON.stringify(draggingProduct));

                var containElem = elmAccordingtoXY(xa,newy,movingObj.drawWidth,movingObj.drawHeight,this.state.mapFields,this.state.mapCatRects)
                //end
                //define location object

                // Calculate the starting point
                let prodfield = this.state.mapFields[fieldobj.field_custom_id];
                let prodstartpoint = ((xa - prodfield?.x) / this.state.displayRatio);
                const match = prodstartpoint.toString().match(/^-?\d+\.\d{0,9}/);
                prodstartpoint = match ? match[0] : prodstartpoint.toString();

                var plocobj = {
                    id: uuidv4(),
                    x: xa, 
                    y: newy,
                    width: draggingProduct.width, 
                    height: draggingProduct.height, 
                    depth: draggingProduct.depth,
                    drawWidth: measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.width) * this.state.displayRatio,
                    drawHeight: measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.height) * this.state.displayRatio,
                    imageUrl: draggingProduct.imageUrl,
                    barcode: draggingProduct.barcode,
                    productId: (draggingProduct.isSingleCut || draggingProduct?.category === 'simulated' ? (draggingProduct?.productId ?? draggingProduct.id) : draggingProduct.id),
                    name: (draggingProduct.isSingleCut?draggingProduct.name:draggingProduct.productName ?? draggingProduct.name),
                    uom: draggingProduct.uom,
                    field_custom_id: fieldobj.field_custom_id,
                    virtualBoxId: fieldobj.virtualBoxId,
                    fuuid: uuidv4(),
                    shelfrank: shelfObj.rank,
                    startingPoint: prodstartpoint,
                    department: draggingProduct.department || draggingProduct.departmentData,
                    departmentName: draggingProduct.departmentName || draggingProduct.department?.name || draggingProduct.departmentData?.name,
                    departmentCode: draggingProduct.departmentCode || draggingProduct.department?.posCode || draggingProduct.department?.code || draggingProduct.departmentData?.posCode || draggingProduct.departmentData?.code || draggingProduct.prePlanData?.departmentCode || draggingProduct.preplanData?.departmentCode,
                    brand: brandobj,
                    subcategory: subcatobj,
                    category: draggingProduct.category,
                    categoryName: draggingProduct.categoryName || draggingProduct.category?.name || draggingProduct.category?.categoryName,
                    categoryId: draggingProduct.categoryId || draggingProduct.category?.id,
                    categoryCode: draggingProduct.categoryCode || draggingProduct.category?.posCode || draggingProduct.category?.importRefCode || draggingProduct.prePlanData?.categoryCode || draggingProduct.preplanData?.categoryCode,
                    subCategoryName: draggingProduct.subCategoryName || draggingProduct.subcategory?.name || draggingProduct.subcategory?.sub_category?.subCategoryName,
                    subCategoryId: draggingProduct.subCategoryId || draggingProduct.subcategory?.id || draggingProduct.subcategory?.sub_category?.subCategoryId,
                    subcategoryCode: draggingProduct.subcategoryCode || draggingProduct.subcategory?.posCode || draggingProduct.subcategory?.sub_category?.posCode || draggingProduct.prePlanData?.subCategoryCode || draggingProduct.preplanData?.subCategoryCode,
                    brandName: draggingProduct.brandName || draggingProduct.brand?.name || draggingProduct.brand?.brand?.brandName || draggingProduct.productBrand?.brandName,
                    brandId: draggingProduct.brandId || draggingProduct.brand?.id || draggingProduct.brand?.brand?.brandId || draggingProduct.productBrand?.brandId,
                    brandCode: draggingProduct.brandCode || draggingProduct.brand?.posCode || draggingProduct.brand?.brand?.posCode || draggingProduct.productBrand?.posCode || draggingProduct.prePlanData?.brandCode || draggingProduct.preplanData?.brandCode,
                    supplierName: draggingProduct.supplierName || draggingProduct.supplier?.name || draggingProduct.supplier?.supplierName || draggingProduct.productBrand?.supplier?.supplierName,
                    supplierId: draggingProduct.supplierId || draggingProduct.supplier?.id || draggingProduct.supplier?.supplierId || draggingProduct.productBrand?.supplier?.supplierId,
                    supplierCode: draggingProduct.supplierCode || draggingProduct.supplier?.posCode || draggingProduct.supplier?.supplierCode || draggingProduct.productBrand?.supplier?.posCode || draggingProduct.prePlanData?.supplierCode || draggingProduct.preplanData?.supplierCode,
                    productBrand: draggingProduct.productBrand,
                    prodidx: (prodlist.length),
                    isDropNew: (!draggingProduct.isSingleCut),
                    isNew: true,
                    isDelete: false,
                    brandRectId: -1,
                    subcategoryRectId: -1,
                    categoryRectId:  containElem.catrect.catrectId,
                    isStackable:cisStackable,//add droping product stackable
                    maxStackableCount:draggingProduct.maxStackableCount,
                    masterFieldId:draggingProduct.masterFieldId, // add missing master filed id from drag product from Data Panel
                    // category:draggingProduct.category,
                    // department:draggingProduct.department,
                    // isDimensionsChange:draggingProduct.isDimensionsChange,
                    // isNewReplaced:draggingProduct.isNewReplaced,
                    // isPreviewNewProd:draggingProduct.isPreviewNewProd,
                    // previousShelfHeight:draggingProduct.previousShelfHeight,
                    // previousShelfUom:draggingProduct.previousShelfUom,
                    // productBrand:draggingProduct.productBrand,
                    // qty:draggingProduct.qty,
                    // recValue:draggingProduct.recValue,
                    // sell_price:draggingProduct.sell_price,
                    // subCategoryId:draggingProduct.subCategoryId
                    hasPriceTag: draggingProduct?.product?.hasPriceTagLatest||draggingProduct?.hasPriceTagLatest || draggingProduct?.hasPriceTag,
                    priceTagGap: draggingProduct?.product?.priceTagGapLatest||draggingProduct?.priceTagGapLatest || draggingProduct?.priceTagGap,
                    priceTagHeight: draggingProduct?.product?.priceTagHeightLatest|| draggingProduct?.priceTagHeightLatest || draggingProduct?.priceTagHeight,


                };

                let lowestprodx = xa;
                let droppingXProd = null; //to find prod available in dropping x1 position
                //new adition
                // lowestprodx = getSnappingLocation(lowestprodx, fieldobj, prodlist, plocobj, [shelfObj]);
                // plocobj.x = lowestprodx;

                //find product is overlapping other product
                var containProds = GetContainingProdsByBox(plocobj.x, plocobj.y, (plocobj.x + plocobj.drawWidth), (plocobj.y + plocobj.drawHeight), prodlist, fieldobj);
                // console.log("loc 5",plocobj.x, plocobj.y, (plocobj.x + plocobj.drawWidth), (plocobj.y + plocobj.drawHeight), prodlist, fieldobj);

                let cutshelfs = [];
                if(containProds.selectedProds && containProds.selectedProds.length > 0){
                    var notDeletedContainProds = containProds.selectedProds.filter(f => !f.isDelete && f.shelfrank === shelfObj.rank);

                    for (let j = 0; j < notDeletedContainProds.length; j++) {
                        const selcutitem = notDeletedContainProds[j];

                        let checkprodwidth = (((selcutitem.drawWidth / 3) > 8)?(selcutitem.drawWidth / 3):(selcutitem.drawWidth / 2));
                        let prodmiddlex = (selcutitem.x + checkprodwidth);

                        let findshelfitemidx = cutshelfs.findIndex(x => x.rank === selcutitem.shelfrank);
                        if(findshelfitemidx > -1){
                            cutshelfs[findshelfitemidx].prods.push(selcutitem);
                        } else{
                            cutshelfs.push({ rank: selcutitem.shelfrank, prods: [selcutitem] });
                        }

                        prodlist[selcutitem.prodidx]["isDelete"] = true;

                        if(lowestprodx > selcutitem.x && lowestprodx < prodmiddlex){
                            lowestprodx = selcutitem.x;
                        }

                        if(selcutitem.x <= lowestprodx && lowestprodx <= roundOffDecimal((selcutitem.x + selcutitem.drawWidth),2)){
                            droppingXProd = selcutitem;
                        }
                    }
                }

                //if dropping position x not have product find last left product x to drop(need to check want o not)
                // console.log(droppingXProd);
                if(!droppingXProd){
                    lowestprodx = getSnappingLocation(lowestprodx, fieldobj, prodlist, plocobj, [shelfObj]);
                }

                plocobj.x = lowestprodx;

                prodlist.push(plocobj);
                this.TouchedCatListUpdate(plocobj.categoryRectId)
                //check non sim render count and display mange
                this.nonSimProddropremoveCounterupdate()

                //new product add counts change
                let cdrgprod = null;
                if(!draggingProduct.isSingleCut){
                    this.handleAddProductCounter(plocobj, 1);

                    cdrgprod =  { prodidx: (prodlist.length - 1), prod: plocobj};
                }
                /* OLD ONE : currentInternalDraggableProd: cdrgprod */
                this.setState({ mapproductList: prodlist,  currentInternalDraggableProd: null, currentSelectedBlock: null, contxtmenu: { isexpand: true }},() => {
                    if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                        //console.log(this.state.mapproductList)
                        // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                        const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                        this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
                    }
                    //reload imported product update
                    this.compareImportedProds();

                    this.props.handlehaveChnagesinCat(true);

                    if(draggingProduct.isSingleCut){
                        //uncomment to remove single clip boad drop remove clip board coppy

                        this.updateSingleCutProduct(draggingProduct);
                    } else{
                        this.updateRecentProdList(draggingProduct);
                    }

                    if(isruleupdating){
                        let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, true, isruleupdating);
                        // console.log(updaterulelist);

                        this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
                    }
                    //making new clip board obj
                    if(cutshelfs.length>0){
                        var selfield=this.state.mapFields[cutshelfs[0].prods[0].field_custom_id]
                        var cshelfs=[{shelfrank:cutshelfs[0].rank,products:cutshelfs[0].prods}]
                        var objtopass={
                            groupUUID: uuidv4(),isNew:true, isDelete: false, mode: "cut" ,uom:selfield.uom,shelf:cshelfs
                        }
                        setTimeout(() => {
                            this.updateCutList(objtopass);
                        }, 300);
                    }
                });

            } else {
                alertService.error(this.props.t("CANNOT_ADD_TO_BOTTOM"));
            }

            //end drop
            if(shelfRef){
                shelfRef.style.fill = 'transparent';
            }

            setTimeout(() => {
                this.setPreviewGuid(true);
            }, 500);          
        }
    }

    // New CR - 2025 Jan 16 
    // As of this CR, user new dropped product need to validate before the drop if perticuler shelf have enough space or not
    // if space have, need to left align products and drop the product
    // if space doesn't have, give the alert 
    dropproductV2 = (e, shelfObj, shelfRef, shelfIdx, isxpand, fieldobj) => {
        e.preventDefault(); //fixes firefox image dragging issue
        let viewboxcoords = this.xyChangeCoords(e);
        var xa = viewboxcoords.x;
        var draggingProduct = JSON.parse(JSON.stringify(this.state.currentDraggableProd)); 
        // console.log('draggingProduct_', draggingProduct);
        //get current dragging product
        //checking drop validation
        let departmentId = (this.props.defSaveObj && this.props.defSaveObj.department?((this.props.simType === "AUI")?this.props.defSaveObj.department.id:this.props.defSaveObj.department.department_id):null);
        let departmentname = (this.props.defSaveObj && this.props.defSaveObj.department?(((this.props.simType === "AUI")?this.props.defSaveObj.department.name:this.props.defSaveObj.department.department_name)+" "+this.props.t("department")):"-");
        // console.log(deptObj);

        if(!draggingProduct.isSingleCut){
            var validateList = validateHeirarchyMissings(draggingProduct, departmentId, departmentname);

            /* if(!draggingProduct.width || !draggingProduct.height || !draggingProduct.uom || draggingProduct.uom === "" || !draggingProduct.depth){
                validateList.push({type:"Dimension",text:this.props.t('PROD_DIMENTIONS_NOTAVAILABLE')})
                // alertService.warn(this.props.t('PROD_DIMENTIONS_NOTAVAILABLE'));
                // return false;
            } if(!draggingProduct.imageUrl || draggingProduct.imageUrl === ""){
                validateList.push({type:"image",text:this.props.t('PROD_IMAGE_NOTFOUND')})
            } if(draggingProduct.hierarchyCompleteStatus==="HaveIssues"){
                validateList.push({type:"Hierarchy_Issue",text:this.props.t('Hierarchy_Issue')})
            } if(draggingProduct.mpUsageStatus==="Archived" ){
                validateList.push({type:"Archived",text:this.props.t('Product_is_Archived')})
            } if(draggingProduct.mpUsageStatus==="New" ){
                validateList.push({type:"New",text:this.props.t('Product_is_NewProduct')})
            } if(draggingProduct.mpUsageStatus==="None" ){
                validateList.push({type:"None",text:this.props.t('product_Didnt_sendto_dep')})
            } */

            if(validateList.length > 0){
                this.setState({
                    dropWarningList: validateList,
                    selectedwarningdropprod: draggingProduct
                },()=>{
                    this.cannotDropWarningHandle()
                })
                return false;
            }
        }

        draggingProduct.drawHeight=measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.height) * this.state.displayRatio;
        draggingProduct.drawWidth=measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.width) * this.state.displayRatio;
        //check dragging product available
        if (draggingProduct === undefined || draggingProduct === null) {
            alertService.warn(this.props.t('PRODUCT_NOT_SELECTED'))
            return;
        }

        //if isexpand
        if(isxpand && draggingProduct){
            xa = xa - ((measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.width) * this.state.displayRatio) / 2);
        }

        //check dragging product available and allowed to add
        if (draggingProduct && draggingProduct != null) { // && allowToAdd
            this.setState({ isviewcmenu: false,isviewcmenu2:false });
            //set product y position
            var newy = (shelfObj.y + shelfObj.drawHeight) - ((measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.height) * this.state.displayRatio)); //get bottom y point
            let checknewy = (newy + this.state.checkSaftyMargin)

            //find is product can added to bottom of shelve
            var allowToAddBottom = null;

            //is it allow to drop to bottom of shelve
            draggingProduct["isNew"] = true;
            draggingProduct["isDelete"] = false;

            // var cdrgprod = {shelveidx: shelfIdx, brandidx: null, prodidx: null, prod: null};

            // let isRightOverlapFixed = false;
            if(draggingProduct !== undefined || draggingProduct !== null){
                allowToAddBottom = checkAllowToAdd(e, shelfObj, draggingProduct, xa, checknewy, this.state.checkSaftyMargin); //check allow to add that location - retuns boolean
                // console.log(allowToAddBottom);

                //if cannot add to shelf and is inside shelf and overlapping from right side
                let checkshelfy2 = (shelfObj.y + shelfObj.drawHeight + shelfObj.drawGap);
                let checkshelfx2 = (shelfObj.x + shelfObj.drawWidth);

                if(!allowToAddBottom.allowToAdd && shelfObj.y <= newy && (newy + draggingProduct.drawHeight) <= checkshelfy2 && xa < checkshelfx2 && (xa + draggingProduct.drawWidth) > checkshelfx2){
                    // isRightOverlapFixed = true;

                    allowToAddBottom = { allowToAdd: true, shelfAllow: true };
                    xa = ((checkshelfx2 - draggingProduct.drawWidth));
                }
            }

            //if product can add to bottom of shelve
            if (allowToAddBottom.allowToAdd && shelfRef) {
                this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),1);

                let isruleupdating = false;

                //get current products list
                let prodlist = this.state.mapproductList;
                let catObj = null;
                let brandobj = null;
                let subcatobj = null;

                if(draggingProduct.isSingleCut){
                    brandobj = draggingProduct.brand;

                    subcatobj = draggingProduct.subcategory;

                    if(subcatobj.type === catRectEnums.rule){
                        //find if rule brand available
                        let brandid = getNameorIdorColorofBox(subcatobj, "num");
                        let rulelevel = subcatobj.rule.level;

                        let findfromrules = findRuleAvailableForBrand(brandid, true, rulelevel, this.state.mapRulesList);
                        // console.log(findfromrules);

                        if(findfromrules.isavailable){
                            isruleupdating = {parentidx: findfromrules.ruleparentidx, ruleidx: findfromrules.ruleidx};
                        }
                    }
                } else {

                    if (draggingProduct.brandId && draggingProduct.brandId > 0) {

                        let brandsupobj = (draggingProduct.supplierId && draggingProduct.supplierId > 0 ? { supplierId: draggingProduct.supplierId, supplierName: draggingProduct.supplierName } : {supplierId: draggingProduct?.supplierId || draggingProduct?.productBrand?.supplier?.supplierId, supplierName: draggingProduct.supplierName || draggingProduct?.productBrand?.supplier?.supplierName});
                        brandobj = {
                            brand: {
                                brandName: draggingProduct.brandName,
                                color: draggingProduct.brandColor,
                                brandId: draggingProduct.brandId,
                                posCode: draggingProduct.brandCode || draggingProduct.brand?.posCode || draggingProduct.productBrand?.posCode,
                                supplier: brandsupobj,
                            },
                            type: catRectEnums.default,
                            rule: null
                        }
                    }

                    let subCatId = draggingProduct.subCategoryId || draggingProduct.subcategoryId;
                    let subCatName = draggingProduct.subCategoryName || draggingProduct.subcategoryName;
                    let subCatColor = draggingProduct.subCategoryColor || draggingProduct.subcategoryColor;
                    if(subCatId && subCatId > 0){
                        subcatobj = {
                            sub_category: {
                                subCategoryName: subCatName,
                                color: subCatColor,
                                subCategoryId: subCatId,
                                posCode: draggingProduct.subcategoryCode || draggingProduct.subcategory?.posCode || draggingProduct.subcategory?.sub_category?.posCode
                            },
                            type: catRectEnums.default,
                            rule: null
                        }

                        //find if rule supplier available
                        let supplierid = draggingProduct.supplierId || draggingProduct?.productBrand?.supplier?.supplierId;
                        if(supplierid > 0){
                            let findsupfromrules = findRuleAvailableForBrand(supplierid, true, catRuleEnums.sup, this.state.mapRulesList);
                            // console.log(findsupfromrules);

                            if(findsupfromrules.isavailable){
                                subcatobj = {
                                    sub_category: null,
                                    type: catRectEnums.rule,
                                    rule: {
                                        id: findsupfromrules.ruleobj.id,
                                        level: findsupfromrules.ruleobj.level,
                                        supplier: (findsupfromrules.ruleobj.level === catRuleEnums.sup?findsupfromrules.ruleobj.supplier:{}),
                                        brand: (findsupfromrules.ruleobj.level === catRuleEnums.brand?findsupfromrules.ruleobj.brand:{}),
                                    }
                                }

                                isruleupdating = {parentidx: findsupfromrules.ruleparentidx, ruleidx: findsupfromrules.ruleidx};
                            }
                        }

                        //find if rule brand available
                        let brandid = getNameorIdorColorofBox(brandobj, "num");

                        let findfromrules = findRuleAvailableForBrand(brandid, false, null, this.state.mapRulesList);

                        if(findfromrules.isavailable){ // && findfromrules.ruleobj.ruleState !== "default"
                            subcatobj = {
                                sub_category: null,
                                type: catRectEnums.rule,
                                rule: {
                                    id: findfromrules.ruleobj.id,
                                    level: findfromrules.ruleobj.level,
                                    supplier: (findfromrules.ruleobj.level === catRuleEnums.sup?findfromrules.ruleobj.supplier:{}),
                                    brand: (findfromrules.ruleobj.level === catRuleEnums.brand?findfromrules.ruleobj.brand:{}),
                                }
                            }

                            isruleupdating = {parentidx: findfromrules.ruleparentidx, ruleidx: findfromrules.ruleidx};
                        }
                    }
                }
                //checking

                    var cisStackable=false
                    // check if dragging product is from clipboard or data penl for apply stackable status
                   
                    var drgprodid=draggingProduct.isSingleCut?draggingProduct.productId:draggingProduct.id
                    var drgprodisstack=draggingProduct.isSingleCut?draggingProduct.isStackable:draggingProduct.isStackable
                    for (let k = 0; k < this.state.mapproductList.length; k++) {
                        const oprod = this.state.mapproductList[k];
                        //console.log(oprod.productId,drgprodid);
                        if(oprod.productId===drgprodid){
                            cisStackable=oprod.isStackable
                            break
                        }else{
                            if(k===this.state.mapproductList.length){
                                cisStackable=drgprodisstack
                            }
                        }

                    }

                    if(!draggingProduct?.isSingleCut){
                        cisStackable = draggingProduct.isStackable;
                    }

                //finddragging product drop to wich box
                let movingObj = JSON.parse(JSON.stringify(draggingProduct));

                var containElem = elmAccordingtoXY(xa,newy,movingObj.drawWidth,movingObj.drawHeight,this.state.mapFields,this.state.mapCatRects)
                //end
                //define location object

                catObj = {
                    categoryName: draggingProduct?.categoryName || draggingProduct?.category?.name || draggingProduct?.category?.categoryName,
                    id: draggingProduct?.categoryId || draggingProduct?.category?.id,
                    posCode: draggingProduct?.categoryCode || draggingProduct?.category?.posCode || draggingProduct?.category?.importRefCode,
                    isDelete: false,
                    isDepartmentResolved: false,
                    isNew: false,
                    subCategory: []
                }

                // Calculate the starting point
                let prodfield = this.state.mapFields[draggingProduct?.field_custom_id];
                let prodstartpoint = ((draggingProduct?.x - prodfield?.x) / this.state.displayRatio);
                const match = prodstartpoint.toString().match(/^-?\d+\.\d{0,9}/);
                prodstartpoint = match ? match[0] : prodstartpoint.toString();

                var plocobj = {
                    id: uuidv4(),
                    x: xa, 
                    y: newy,
                    startingPoint: prodstartpoint,
                    width: draggingProduct.width, 
                    height: draggingProduct.height, 
                    depth: draggingProduct.depth,
                    drawWidth: measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.width) * this.state.displayRatio,
                    drawHeight: measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.height) * this.state.displayRatio,
                    isHangable: draggingProduct.isHangable,
                    haggingHorizontal: draggingProduct.haggingHorizontal,
                    haggingVertical: draggingProduct.haggingVertical,
                    drawHaggingHorizontal: measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.haggingHorizontal) * this.state.displayRatio,
                    drawHaggingVertical: measureConverter(draggingProduct.uom,this.state.displayUOM,draggingProduct.haggingVertical) * this.state.displayRatio,
                    imageUrl: draggingProduct.imageUrl,
                    barcode: draggingProduct.barcode,
                //  productId: (draggingProduct.isSingleCut || draggingProduct?.category === 'simulated' ? (draggingProduct?.productId ?? draggingProduct.id) : draggingProduct.id),
                    productId:draggingProduct.productId, // 2025-07-31 - production bug fixed - new update - mapping productId to draggingProduct.productId
                    name: (draggingProduct.isSingleCut?draggingProduct.name:draggingProduct.productName ?? draggingProduct.name),
                    uom: draggingProduct.uom,
                    field_custom_id: fieldobj.field_custom_id,
                    virtualBoxId: fieldobj.virtualBoxId,
                    fuuid: uuidv4(),
                    shelfrank: shelfObj.rank,
                    department: draggingProduct.department || draggingProduct.departmentData,
                    departmentName: draggingProduct.departmentName || draggingProduct.department?.name || draggingProduct.departmentData?.name,
                    departmentCode: draggingProduct.departmentCode || draggingProduct.department?.posCode || draggingProduct.department?.code || draggingProduct.departmentData?.posCode || draggingProduct.departmentData?.code || draggingProduct.prePlanData?.departmentCode || draggingProduct.preplanData?.departmentCode,
                    category: catObj,
                    brand: brandobj,
                    subcategory: subcatobj,
                    categoryName: draggingProduct.categoryName || draggingProduct.category?.name || draggingProduct.category?.categoryName,
                    categoryId: draggingProduct.categoryId || draggingProduct.category?.id,
                    categoryCode: draggingProduct.categoryCode || draggingProduct.category?.posCode || draggingProduct.category?.importRefCode || draggingProduct.prePlanData?.categoryCode || draggingProduct.preplanData?.categoryCode,
                    subCategoryName: draggingProduct.subCategoryName || draggingProduct.subcategory?.name || draggingProduct.subcategory?.sub_category?.subCategoryName,
                    subCategoryId: draggingProduct.subCategoryId || draggingProduct.subcategory?.id || draggingProduct.subcategory?.sub_category?.subCategoryId,
                    subcategoryCode: draggingProduct.subcategoryCode || draggingProduct.subcategory?.posCode || draggingProduct.subcategory?.sub_category?.posCode || draggingProduct.prePlanData?.subCategoryCode || draggingProduct.preplanData?.subCategoryCode,
                    brandName: draggingProduct.brandName || draggingProduct.brand?.name || draggingProduct.brand?.brand?.brandName || draggingProduct.productBrand?.brandName,
                    brandId: draggingProduct.brandId || draggingProduct.brand?.id || draggingProduct.brand?.brand?.brandId || draggingProduct.productBrand?.brandId,
                    brandCode: draggingProduct.brandCode || draggingProduct.brand?.posCode || draggingProduct.brand?.brand?.posCode || draggingProduct.productBrand?.posCode || draggingProduct.prePlanData?.brandCode || draggingProduct.preplanData?.brandCode,
                    supplierName: draggingProduct.supplierName || draggingProduct.supplier?.name || draggingProduct.supplier?.supplierName || draggingProduct.productBrand?.supplier?.supplierName,
                    supplierId: draggingProduct.supplierId || draggingProduct.supplier?.id || draggingProduct.supplier?.supplierId || draggingProduct.productBrand?.supplier?.supplierId,
                    supplierCode: draggingProduct.supplierCode || draggingProduct.supplier?.posCode || draggingProduct.supplier?.supplierCode || draggingProduct.productBrand?.supplier?.posCode || draggingProduct.prePlanData?.supplierCode || draggingProduct.preplanData?.supplierCode,
                    productBrand: draggingProduct.productBrand,
                    prodidx: (prodlist.length),
                    isDropNew: (!draggingProduct.isSingleCut),
                    isNew: true,
                    isHanged: false,
                    isDelete: false,
                    brandRectId: -1,
                    subcategoryRectId: -1,
                    categoryRectId:  containElem?.catrect?.catrectId ?? -1,
                    isStackable:cisStackable,//add droping product stackable
                    maxStackableCount:draggingProduct.maxStackableCount,
                    masterFieldId:draggingProduct.masterFieldId, // add missing master filed id from drag product from Data Panel
                    // category:draggingProduct.category,
                    // department:draggingProduct.department,
                    // isDimensionsChange:draggingProduct.isDimensionsChange,
                    // isNewReplaced:draggingProduct.isNewReplaced,
                    // isPreviewNewProd:draggingProduct.isPreviewNewProd,
                    // previousShelfHeight:draggingProduct.previousShelfHeight,
                    // previousShelfUom:draggingProduct.previousShelfUom,
                    // productBrand:draggingProduct.productBrand,
                    // qty:draggingProduct.qty,
                    recValue:draggingProduct.recValue,
                    // sell_price:draggingProduct.sell_price,
                    // subCategoryId:draggingProduct.subCategoryId
                    prePlanData: draggingProduct.prePlanData ?? {},
                    hasPriceTag: draggingProduct?.product?.hasPriceTagLatest||draggingProduct?.hasPriceTagLatest || draggingProduct?.hasPriceTag,
                    priceTagGap: draggingProduct?.product?.priceTagGapLatest|| draggingProduct?.priceTagGapLatest ||draggingProduct?.priceTagGap,
                    priceTagHeight: draggingProduct?.product?.priceTagHeightLatest||draggingProduct?.priceTagHeightLatest || draggingProduct?.priceTagHeight,
                };

                // console.log('plocobj_', plocobj);

                // let lowestprodx = xa;
                // let droppingXProd = null; //to find prod available in dropping x1 position
                // //new adition
                // // lowestprodx = getSnappingLocation(lowestprodx, fieldobj, prodlist, plocobj, [shelfObj]);
                // // plocobj.x = lowestprodx;

                // //find product is overlapping other product
                // var containProds = GetContainingProdsByBox(plocobj.x, plocobj.y, (plocobj.x + plocobj.drawWidth), (plocobj.y + plocobj.drawHeight), prodlist, fieldobj);
                // // console.log("loc 5",plocobj.x, plocobj.y, (plocobj.x + plocobj.drawWidth), (plocobj.y + plocobj.drawHeight), prodlist, fieldobj);

                // let cutshelfs = [];
                // if(containProds.selectedProds && containProds.selectedProds.length > 0){
                //     var notDeletedContainProds = containProds.selectedProds.filter(f => !f.isDelete && f.shelfrank === shelfObj.rank);

                //     for (let j = 0; j < notDeletedContainProds.length; j++) {
                //         const selcutitem = notDeletedContainProds[j];

                //         let checkprodwidth = (((selcutitem.drawWidth / 3) > 8)?(selcutitem.drawWidth / 3):(selcutitem.drawWidth / 2));
                //         let prodmiddlex = (selcutitem.x + checkprodwidth);

                //         let findshelfitemidx = cutshelfs.findIndex(x => x.rank === selcutitem.shelfrank);
                //         if(findshelfitemidx > -1){
                //             cutshelfs[findshelfitemidx].prods.push(selcutitem);
                //         } else{
                //             cutshelfs.push({ rank: selcutitem.shelfrank, prods: [selcutitem] });
                //         }

                //         prodlist[selcutitem.prodidx]["isDelete"] = true;

                //         if(lowestprodx > selcutitem.x && lowestprodx < prodmiddlex){
                //             lowestprodx = selcutitem.x;
                //         }

                //         if(selcutitem.x <= lowestprodx && lowestprodx <= roundOffDecimal((selcutitem.x + selcutitem.drawWidth),2)){
                //             droppingXProd = selcutitem;
                //         }
                //     }
                // }

                // //if dropping position x not have product find last left product x to drop(need to check want o not)
                // // console.log(droppingXProd);
                // if(!droppingXProd){
                //     lowestprodx = getSnappingLocation(lowestprodx, fieldobj, prodlist, plocobj, [shelfObj]);
                // }

                // plocobj.x = lowestprodx;

                //-----------------------------------------------------
                // New CR - 2025 Jan 16
                // product re arrange validation part
                var draggingProduct = JSON.parse(JSON.stringify(this.state.currentDraggableProd)); 
                // console.log("KKKKKKKKKKKKKKKKKKK shelfObj -----", shelfObj)
                // console.log("KKKKKKKKKKKKKKKKKKK fieldobj -----", fieldobj)
                // console.log("KKKKKKKKKKKKKKKKKKK draggingProduct -----", draggingProduct)
                // console.log("KKKKKKKKKKKKKKKKKKK xa ----- ", xa)
                // console.log("KKKKKKKKKKKKKKKKKKK newy ----- ", newy)
                // console.log("KKKKKKKKKKKKKKKKKKK checknewy ----- ", checknewy)

                // get similer shelf from selected shelf y+drawheight
                let similarLevelShelves = this.getSimilarLevelShelves(shelfObj, this.state.mapFields);
                // console.log("KKKKKKKKKKKKKKKKKKK similarLevelShelves -----",similarLevelShelves)
            
                let selectedShelfSet = [];
                // selectedShelfSet.push(shelfObj);
                selectedShelfSet = selectedShelfSet.concat(similarLevelShelves);

    
                let productList = JSON.parse(JSON.stringify(this.state.mapproductList));
                let exisitingProductList = this.getSelectedProducts(productList, selectedShelfSet, draggingProduct);
                // console.log("KKKKKKKKKKKKKKKKKKK exisitingProductList-------",exisitingProductList)


                // get exiting product total width
                let totalProductWidth = 0;
                exisitingProductList.forEach(product => {
                    totalProductWidth += product?.drawWidth;
                });
                
                // get total width of selected shelf
                let totalShelfWidth = 0;
                selectedShelfSet.forEach(shelf => {
                    totalShelfWidth += shelf?.drawWidth;
                });
                let restSpace = totalShelfWidth - totalProductWidth;
                // get moving product block width
                let movingProductBlockWidth = draggingProduct?.drawWidth;
                let droppedFiledCustomId = fieldobj.field_custom_id;
                let droppedFieldMasterFieldId = fieldobj.masterFieldId;

                const roundedRestSpace = Number(restSpace.toFixed(2));
                const roundedMovingProductBlockWidth = Number(movingProductBlockWidth.toFixed(2));

                const isAllowToDrop = roundedRestSpace >= roundedMovingProductBlockWidth;
        
    
                // console.log("XXXXXXXXXXXX totalProductWidth --------", roundOffDecimal(totalProductWidth,2))
                // console.log("XXXXXXXXXXXX totalShelfWidth --------", roundOffDecimal(totalShelfWidth,2))
                // console.log("XXXXXXXXXXXX restSpace --------", roundedRestSpace)
                // console.log("XXXXXXXXXXXX roundedMovingProductBlockWidth --------", roundedMovingProductBlockWidth)
                // console.log("XXXXXXXXXXXX isAllowToDrop --------", isAllowToDrop)
                // console.log("XXXXXXXXXXXX selectedShelfSet --------", selectedShelfSet)

                if(!isAllowToDrop){
                    alertService.error(this?.props?.t('NO_SPACE_AVALIBLE_FOR_DROPPED_PRODUCT_SET'),4000);
                    this.setPreviewGuid(true, null, null, true, []);
                    clearTimeout(this._guideTimeout); 
                    return
                }
                const movingProductSet = structuredClone(plocobj);
                let reArrangeProducts = JSON.parse(JSON.stringify(this.state.mapproductList));
                let movingProductObj = structuredClone(plocobj);
                const {needToReArrange, updatedProducts} = this.filterInlineShelfProductSet(xa, newy, selectedShelfSet, reArrangeProducts, movingProductSet, movingProductObj, this.state.checkSaftyMargin, droppedFiledCustomId, droppedFieldMasterFieldId);
                
                if(needToReArrange){
                    const updatingProductIds = new Set(updatedProducts.map(product => product.id));
       
                    const filteredUpdatedProducts = reArrangeProducts.filter(
                        product => !updatingProductIds.has(product.id)
                    ); 
       
                    reArrangeProducts = [...filteredUpdatedProducts, ...updatedProducts];
                }else{
                    reArrangeProducts = [...reArrangeProducts, movingProductObj];
                }
                //-----------------------------------------------------

                // PEG CR - 2025 March
                // check if any product cross the peg board
                const {isPegBoardOverlap} = this.productOverlapCheckerWithPegBoard(this.state.pegList, reArrangeProducts)
                if(isPegBoardOverlap){
                    alertService.error(this.props.t('PEG_BOARD_OVERLAP'),4000);
                    this.setState({isPegBoardOverlapping:true, currentSelectedBlock: null});
                    this.setPreviewGuid(false, null, null, true);
                    return;
                }
                

                prodlist.push(plocobj);
                this.TouchedCatListUpdate(plocobj.categoryRectId)
                //check non sim render count and display mange
                this.nonSimProddropremoveCounterupdate()

                //new product add counts change
                let cdrgprod = null;
                if(!draggingProduct.isSingleCut){
                    this.handleAddProductCounter(plocobj, 1);

                    cdrgprod =  { prodidx: (prodlist.length - 1), prod: plocobj};
                }
                // console.log('reArrangeProducts_', reArrangeProducts);
                /* OLD ONE : currentInternalDraggableProd: cdrgprod */
                this.setState({ mapproductList: reArrangeProducts,   currentInternalDraggableProd: null, currentSelectedBlock: null, contxtmenu: { isexpand: false }},() => {
                    if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                        //console.log(this.state.mapproductList)
                        // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                        const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                        this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
                    }
                    //reload imported product update
                    this.compareImportedProds();

                    this.props.handlehaveChnagesinCat(true);

                    if(draggingProduct.isSingleCut){
                        //uncomment to remove single clip boad drop remove clip board coppy

                        this.updateSingleCutProduct(draggingProduct);
                    } else{
                        this.updateRecentProdList(draggingProduct);
                    }

                    if(isruleupdating){
                        let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, true, isruleupdating);
                        // console.log(updaterulelist);

                        this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
                    }
                    //making new clip board obj
                    // if(cutshelfs.length>0){
                    //     var selfield=this.state.mapFields[cutshelfs[0].prods[0].field_custom_id]
                    //     var cshelfs=[{shelfrank:cutshelfs[0].rank,products:cutshelfs[0].prods}]
                    //     var objtopass={
                    //         groupUUID: uuidv4(),isNew:true, isDelete: false, mode: "cut" ,uom:selfield.uom,shelf:cshelfs
                    //     }
                    //     setTimeout(() => {
                    //         this.updateCutList(objtopass);
                    //     }, 300);
                    // }

                    // update group ids - call groupByProduct2 after groupByProduct completes
                    this._callGroupByProduct2After = true;
                    this.groupByProduct();
                });

            } else {
                alertService.error(this.props.t("CANNOT_ADD_TO_BOTTOM"));
            }

            //end drop
            if(shelfRef){
                shelfRef.style.fill = 'transparent';
            }

            setTimeout(() => {
                this.setPreviewGuid(true);
            }, 500);          
        }
    }


    // This function returns the similar level shelves
    getSimilarLevelShelves(currentMovingSelectedShelf, mapFields) {
        // console.log("AAAAAAA-currentMovingSelectedShelf",currentMovingSelectedShelf)
        // console.log("AAAAAAA-mapFields",mapFields)
        // const result = [];
        // if(!currentMovingSelectedShelf) return result;
        // const currentFieldCustomId = currentMovingSelectedShelf.field_custom_id;
        // const currentY = currentMovingSelectedShelf.y;
        // const currentHeight = currentMovingSelectedShelf.drawHeight;

        // for (const fieldId in mapFields) {
        //     // Skip the same field_custom_id
        //     if (fieldId === currentFieldCustomId) continue;

        //     const field = mapFields[fieldId];
        //     const shelves = field.shelf;

        //     for (const shelf of shelves) {
        //         const shelfY = shelf.y;
        //         const shelfHeight = shelf.drawHeight;

        //         // Check if the shelf is at a similar level
        //         // if (
        //         //     (shelfY + shelfHeight > currentY &&
        //         //     shelfY < currentY + currentHeight) // Overlap condition
        //         // ) {
        //         if (roundOffDecimal(shelfY + shelfHeight, 2) === roundOffDecimal(currentY + currentHeight, 2)) {
        //             result.push(shelf);
        //         }
        //     }
        // }

        // return result;

        // Version 2 - Added x nearest x coordination shelf picking changes
        const currentFieldCustomId = currentMovingSelectedShelf.field_custom_id;
        const currentY = currentMovingSelectedShelf.y;
        const currentHeight = currentMovingSelectedShelf.drawHeight;
        const currentX = currentMovingSelectedShelf.x;
        const currentDrawWidth = currentMovingSelectedShelf.drawWidth;
    
        let shelvesAtSameLevel = [];

        // Collect shelves that are at the same Y level
        for (const fieldId in mapFields) {
            // if (fieldId === currentFieldCustomId) continue;

            const field = mapFields[fieldId];
            const shelves = field.shelf;

            for (const shelf of shelves) {
                const shelfY = shelf.y;
                const shelfHeight = shelf.drawHeight;

                // Check if the shelf is at the same level (y + height match)
                if (roundOffDecimal(shelfY + shelfHeight, 2) === roundOffDecimal(currentY + currentHeight, 2)) {
                    shelvesAtSameLevel.push(shelf);
                }
            }
        }

        // Sort shelves by x position
        shelvesAtSameLevel.sort((a, b) => a.x - b.x);

        // Find the selected shelf in the sorted list
        let selectedShelf = shelvesAtSameLevel.find(shelf => shelf.x === currentX && shelf.drawWidth === currentDrawWidth);
        if (!selectedShelf) {
            return [];
        }

        // Initialize merged shelves with the selected shelf
        let mergedShelves = [selectedShelf];

        // Check backward for connected shelves
        for (let i = shelvesAtSameLevel.indexOf(selectedShelf) - 1; i >= 0; i--) {
            if (shelvesAtSameLevel[i].x + shelvesAtSameLevel[i].drawWidth === mergedShelves[0].x) {
                mergedShelves.unshift(shelvesAtSameLevel[i]); // Add to the beginning
            } else {
                break;
            }
        }

        // Check forward for connected shelves
        for (let i = shelvesAtSameLevel.indexOf(selectedShelf) + 1; i < shelvesAtSameLevel.length; i++) {
            if (shelvesAtSameLevel[i].x === mergedShelves[mergedShelves.length - 1].x + mergedShelves[mergedShelves.length - 1].drawWidth) {
                mergedShelves.push(shelvesAtSameLevel[i]); // Add to the end
            } else {
                break;
            }
        }
        return mergedShelves;
    }

    // this function return the product list which is in the selected shelfs and similar level shelfs
    getSelectedProducts(existingProducts, selectedShelfSet, selectedProductBlock, droppingFromClipboard = false) {
    // // Create a Set of IDs from selectedProductBlock for quick lookup
    // const selectedProductIds = new Set(selectedProductBlock.map(product => product.id));
    // Filter products based on the conditions and exclude products in selectedProductBlock
        let movingProductIds = new Set(
            Array.isArray(selectedProductBlock?.drawingProducts) ? selectedProductBlock?.drawingProducts.map(product => product?.id) : []
        );

        return existingProducts.filter(product => {
            const isInSelectedShelf = selectedShelfSet.some(shelf =>
                product?.shelfrank == shelf?.rank &&
                product?.field_custom_id == shelf?.field_custom_id &&
                (product?.isDelete === undefined || product?.isDelete === false) &&
                 // remove hangged products
                (product?.isHanged === undefined || product?.isHanged === false)
            );

            // this one use for handle product dropping from clipboard
            if(droppingFromClipboard){
                return isInSelectedShelf && !movingProductIds.has(product.id);;
            }else{
                // this one use for handle products from data pannel
                const isNotInSelectedBlock = selectedProductBlock?.id;
                return isInSelectedShelf && isNotInSelectedBlock;
            }
        });
    }

    // Verify and correct product x positions to ensure proper alignment
    // Only fixes overlaps, preserves intentional spacing
    verifyAndCorrectProductPositions = (movingProductSet) => {
      if (!movingProductSet || movingProductSet.length === 0) {
        return movingProductSet;
      }

      // Sort products by their x position to ensure correct order
      let sortedProducts = [...movingProductSet].sort((a, b) => a.x - b.x);

      // Only fix overlaps, not gaps
      for (let i = 0; i < sortedProducts.length - 1; i++) {
        const currentProduct = sortedProducts[i];
        const nextProduct = sortedProducts[i + 1];

        // Calculate where current product ends
        const currentProductEnd = roundOffDecimal(currentProduct.x + currentProduct.drawWidth, 2);
        const nextProductStart = roundOffDecimal(nextProduct.x, 2);

        // Only fix if there's an overlap (next product starts before current ends)
        // Allow a small tolerance for floating point errors
        const tolerance = 0.01;
        if (nextProductStart < (currentProductEnd - tolerance)) {
          // There's an overlap, move the next product to start after current
          nextProduct.x = currentProductEnd;
          nextProduct.startingPoint = nextProduct.x / this.state.displayRatio;
          
          // Cascade the fix to subsequent products if needed
          for (let j = i + 1; j < sortedProducts.length - 1; j++) {
            const prod = sortedProducts[j];
            const nextProd = sortedProducts[j + 1];
            const prodEnd = roundOffDecimal(prod.x + prod.drawWidth, 2);
            const nextProdStart = roundOffDecimal(nextProd.x, 2);
            
            if (nextProdStart < (prodEnd - tolerance)) {
              nextProd.x = prodEnd;
              nextProd.startingPoint = nextProd.x / this.state.displayRatio;
            } else {
              // No more overlaps in the chain
              break;
            }
          }
        }
      }

      return sortedProducts;
    }

    // filter product set which is in selected inline shelf
    filterInlineShelfProductSet(cx, cy, inlineShelfSet, productSet, movingProductSet , movingObj, checkSaftyMargin, droppedFiledCustomId, droppedFieldMasterFieldId, droppingFromClipboard = false, isFromExpand = false){
      let sortedInlineShelfSet = inlineShelfSet.sort((a, b) => a.x - b.x);
      let  movingProducts = movingProductSet;
      let  changingShelfRank = sortedInlineShelfSet[0]?.rank;
      let  changingShelfHeight = sortedInlineShelfSet[0]?.y + sortedInlineShelfSet[0]?.drawHeight;
    
      let movingProductIds = new Set(
         Array.isArray(movingProducts) ? movingProducts.map(product => product?.id) : []
      );
    

      // Filter productSet based on the conditions
      let existingProductSet =  productSet.filter(product => {
            const matchingShelf = sortedInlineShelfSet.find(
                shelf => shelf.rank === product.shelfrank && shelf.field_custom_id === product.field_custom_id
            );
           // Include only products that match the shelf and are NOT in movingProductSet
            return matchingShelf && !movingProductIds.has(product.id) && !product.isDelete && !product.isHanged;
      });

      var MOStartX = roundOffDecimal(cx,2);
      var MOEndX   = roundOffDecimal((cx + movingObj.drawWidth),2);

      // Check if any product crosses MOStartX to MOEndX
      let needToReArrange = existingProductSet
      .filter(product => !product.isDelete)
      .filter(product => !product.isHanged) // Exclude hanged products
      .some(product => {
        const productStart = product.x;
        const productEnd   = product.x + product.drawWidth;
        // Check if the product overlaps with the MOStartX to MOEndX area
        return productStart-checkSaftyMargin < MOEndX && productEnd+checkSaftyMargin > MOStartX;
      });

      if(needToReArrange){
          // ---------------------------------------------------------------------
          // ---------------------------------------------------------------------
          // AUTO ALIGN WITH MINUMUM PRODUCT MOVEMENT ----------------------------
          // New Version - 2025 Jan 29 -------------------------------------------
          // ---------------------------------------------------------------------
          // Create a Set of product IDs from movingProductSet for quick lookup
        let movingProductIds = [];

        if(isFromExpand){
            movingProductIds = new Set(movingProductSet.map(product => product.id));
        }

          // Group products by groupId
          const groupedProducts = existingProductSet
              .filter(product => !product.isDelete ) // Remove products with isDelete = true
              .filter(product => isFromExpand ? !movingProductIds.has(product.id) : true) // Remove movingObj products
              .reduce((acc, product) => {
                  if (!acc[product.groupId]) {
                      acc[product.groupId] = [];
                  }
                  acc[product.groupId].push(product);
                  return acc;
              }, {});

          // Separate products into left and right side sets based on group logic
          let leftSideProductSet = [];
          let rightSideProductSet = [];

          Object.values(groupedProducts).forEach(group => {
              // Check the position of the first product in the group
              if (group.some(product => product.x < MOStartX)) {
                  // If any product in the group goes to the left side, all go to the left side
                  leftSideProductSet.push(...group);
              // } else if (group.some(product => product.x >= MOEndX)) {
              } else if (group.some(product => product.x >= MOStartX)) {
                  // If any product in the group goes to the right side, all go to the right side
                  rightSideProductSet.push(...group);
              }
          });

          let sortedLeftSideProductSet = leftSideProductSet.sort((a, b) => a.x - b.x);
          let sortedRightSideProductSet = rightSideProductSet.sort((a, b) => a.x - b.x);

          let newChangedSpaceAmount = 0;
          let currentX = 0;
          let howMuchSpaceWant = movingObj.drawWidth;
          let getSpacingDirection = 'BOTH';

          let shelfStartX = sortedInlineShelfSet[0]?.x;
          let shelfEndX = sortedInlineShelfSet[sortedInlineShelfSet.length - 1]?.x + sortedInlineShelfSet[sortedInlineShelfSet.length - 1]?.drawWidth;
          let shelfTotalWidth = sortedInlineShelfSet.reduce((sum, obj) => sum + obj.drawWidth, 0);

          let spacingAmount = this.getDirectionToOptimizedTheGetProductSpacing(cx, movingObj.drawWidth, shelfStartX, shelfTotalWidth, sortedLeftSideProductSet, sortedRightSideProductSet);

          if(spacingAmount?.direction === "LEFT"){
            let leftSideLastProductX = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
             // validation for not over the shelf width
             if(leftSideLastProductX + movingObj.drawWidth <  shelfStartX + shelfTotalWidth ){
                let diff = leftSideLastProductX - cx;
                
                if(spacingAmount?.leftSpace > diff){
                getSpacingDirection = 'LEFT';
                howMuchSpaceWant =  diff;
                }
                // comment out for prevent inverse side spacing optimazation
                // else if(spacingAmount?.rightSpace > diff){
                // getSpacingDirection = 'RIGHT';
                // howMuchSpaceWant =  diff;
                // } 
            }
          }

          if(spacingAmount?.direction === "RIGHT"){
            let movingProductEndX = cx + movingObj.drawWidth;
            let righSideFirstProductX = sortedRightSideProductSet[0].x; 
            let diff = movingProductEndX - righSideFirstProductX;

            if(spacingAmount?.rightSpace > diff){
              getSpacingDirection = 'RIGHT';
              howMuchSpaceWant =  diff;
            }
            // comment out for prevent inverse side spacing optimazation
            // else if(spacingAmount?.leftSpace > diff){
            //   getSpacingDirection = 'LEFT';
            //   howMuchSpaceWant =  diff;
            // }
          }

          // Handle Left side spacing 
          if(getSpacingDirection === "BOTH"){
                let needToAdjustLeftProducts = [];
                if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedLeftSideProductSet?.length > 0) {

                    for (let i = sortedLeftSideProductSet.length - 1; i >= 0; i--) {
                        let adjustableSpace = 0;
                        const currentProduct = sortedLeftSideProductSet[i];
                        const previousProduct = sortedLeftSideProductSet[i - 1] || null;

                        if(previousProduct){
                            if(i === sortedLeftSideProductSet.length - 1 && sortedRightSideProductSet.length > 0){
                                let righSideProdX = sortedRightSideProductSet[0].x;
                                let avalibleSpace = (righSideProdX - movingObj.drawWidth) - currentProduct.x;
                                let rightSideAllProductsWidth = 0;
                                let leftSideLastProdXandWidth = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
                                if(sortedRightSideProductSet.length > 0){
                                    rightSideAllProductsWidth = sortedRightSideProductSet.reduce((sum, obj) => sum + obj.drawWidth, 0);
                                }
                                if(avalibleSpace + movingObj.drawWidth > howMuchSpaceWant && leftSideLastProdXandWidth + movingObj.drawWidth + rightSideAllProductsWidth <= shelfEndX){
                                    break;
                                }else{
                                    adjustableSpace = currentProduct.x - (previousProduct.x + previousProduct.drawWidth);
                                }
                            }else{
                                adjustableSpace = currentProduct.x - (previousProduct.x + previousProduct.drawWidth);
                            }
                            // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                            // handle the space optimization before the assign shelf start x
                            // if(adjustableSpace > howMuchSpaceWant && cx + movingObj.drawWidth < shelfXWithWidth){
                            // handle long space avalible in the left side last product with the moving product
                            // let righSideStartX = sortedRightSideProductSet[0].x;
                            
                            if(newChangedSpaceAmount + adjustableSpace > howMuchSpaceWant){
                                adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount;
                            }
                        }else{
                            // align to shelf x coordnate
                            let shelfX = this.getShelfXPosition(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                            // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                            if(shelfX < currentProduct.x){
                              adjustableSpace = currentProduct.x - shelfX;
                              // adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                              // handle the space optimization before the assign shelf start x
                              // if(adjustableSpace > howMuchSpaceWant && roundOffDecimal(cx + movingObj.drawWidth,2) < roundOffDecimal(shelfXWithWidth,2)){
                              if(adjustableSpace > howMuchSpaceWant){
                                adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                              }
                              
                              if(isFromExpand){
                                adjustableSpace = currentProduct.x - shelfX;
                              }
                            }
                        }

                        // push to updating array
                        needToAdjustLeftProducts.push({product: currentProduct, reduceSpace: adjustableSpace });
                        newChangedSpaceAmount += adjustableSpace;

                        if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                    }
                    // update the new x values
                    for (let i = 0; i < needToAdjustLeftProducts.length; i++) {
                        const product = needToAdjustLeftProducts[i].product;
                
                        // need to assign total x value to get correct coordinate
                        const sumValue = needToAdjustLeftProducts
                        .slice(i) // Take the current and subsequent objects
                        .reduce((sum, item) => sum + item.reduceSpace, 0);

                        product.x = product.x - sumValue;
                        product.startingPoint = product.x / this.state.displayRatio;
                    }

                    // update update product set to sortedLeftSideProductSet
                    const productObjects = needToAdjustLeftProducts.map(item => item.product); 
                    const updatingProductIds = new Set(productObjects.map(product => product.id));
                    const filteredUpdatedProducts = sortedLeftSideProductSet.filter(
                        product => !updatingProductIds.has(product.id)
                    );
                    sortedLeftSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                    sortedLeftSideProductSet = sortedLeftSideProductSet.sort((a, b) => a.x - b.x);
                }

                if(leftSideProductSet.length === 0){
                    currentX = this.getShelfXPosition(sortedInlineShelfSet, changingShelfRank, droppedFiledCustomId);
                    if(currentX < cx && sortedRightSideProductSet.length > 0){
                        let righSideProdX = sortedRightSideProductSet[0].x;
                        let avalibleSpace = (righSideProdX - movingObj.drawWidth) - currentX;
                        if(avalibleSpace + movingObj.drawWidth > howMuchSpaceWant){
                        currentX = righSideProdX - movingObj.drawWidth;
                        }
                    }
                }else{
                    // Adjust movingProductSet product set
                    let leftSideLastProdXandWidth = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
                    currentX = leftSideLastProdXandWidth;
                    if(currentX < cx && sortedRightSideProductSet.length > 0 && needToAdjustLeftProducts.length === 0){
                        let righSideProdX = sortedRightSideProductSet[0].x;
                        let avalibleSpace = (righSideProdX - movingObj.drawWidth) - leftSideLastProdXandWidth;
                        if(avalibleSpace + movingObj.drawWidth > howMuchSpaceWant){
                        currentX = righSideProdX - movingObj.drawWidth;
                        }
                    }
                }

                // Update the moving product x coordinate
                if(droppingFromClipboard && movingProducts.length > 0){
                        movingProducts = movingProducts.sort((a, b) => a.x - b.x);
                        // Sort right side products by x
                        movingProducts.sort((a, b) => a.x - b.x);
                        // Adjust movingProductSet product set
                        for (let i = 0; i < movingProducts.length; i++){
                            const prod = movingProducts[i];
                            prod.x = currentX;
                            prod.shelfrank = changingShelfRank;
                            prod.field_custom_id = droppedFiledCustomId;
                            prod.masterFieldId = droppedFieldMasterFieldId;
                            prod.y = changingShelfHeight - prod.drawHeight;
                            prod.startingPoint = 0;
                            prod.isHanged = false;
                            // prod.startingPoint = prod.x / this.state.displayRatio;
                            currentX = prod.x + prod.drawWidth;
                            newChangedSpaceAmount = newChangedSpaceAmount + prod.drawWidth;
                        }
                        // Set currentX to the last product's x + drawWidth in movingProducts
                        if (movingProducts.length > 0) {
                            currentX = movingProducts[movingProducts.length - 1].x + 
                                    movingProducts[movingProducts.length - 1].drawWidth;
                        } else {
                            currentX = MOEndX; // Fallback to MOEndX if movingProducts is empty
                        }
                }else{
                    // handle one product dropping from data pannel
                    movingProducts.x = currentX;
                    movingProducts.y = changingShelfHeight - movingProducts.drawHeight;
                    movingProducts.startingPoint = 0;
                    // movingProducts.startingPoint = movingProducts.x / this.state.displayRatio;
                    movingProducts.field_custom_id = droppedFiledCustomId;
                    movingProducts.masterFieldId = droppedFieldMasterFieldId;
                    currentX = movingProducts.x + movingProducts.drawWidth;
                    newChangedSpaceAmount = newChangedSpaceAmount + movingProducts.drawWidth;
                }

                let needToAdjustRightProducts = [];
                // check the RIGHT side spacing if avaiable
                if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedRightSideProductSet?.length > 0) {

                    for (let i = 0; i < sortedRightSideProductSet.length; i++) {
                        const currentProduct = sortedRightSideProductSet[i];
                        const nextProduct = sortedRightSideProductSet[i + 1] || null;
                        let adjustableSpace = 0;

                        if(nextProduct){
                            adjustableSpace = nextProduct.x - (currentProduct.x + currentProduct.drawWidth);
                        }else{
                            // align to shelf x end coordnate
                            let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, sortedRightSideProductSet[0]?.shelfrank, sortedRightSideProductSet[0]?.field_custom_id);
                            if(shelfXWithWidth > currentProduct.x + currentProduct.drawWidth){
                                adjustableSpace = shelfXWithWidth - (currentProduct.x + currentProduct.drawWidth);
                            }
                        }

                        // push to updating array
                        needToAdjustRightProducts.push({product: currentProduct, plusSpace: adjustableSpace });
                        newChangedSpaceAmount += adjustableSpace;

                        if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                    }
                    for (let i = 0; i < needToAdjustRightProducts.length; i++) {
                        const product = needToAdjustRightProducts[i].product;

                        // Update product.x and startingPoint - chain products properly
                        product.x = currentX;
                        product.startingPoint = product.x / this.state.displayRatio;
                        currentX = product.x + product.drawWidth;
                    }

                    // update update product set to sortedRightSideProductSet
                    const productObjects = needToAdjustRightProducts.map(item => item.product);

                    const updatingProductIds = new Set(productObjects.map(product => product.id));
                    const filteredUpdatedProducts = sortedRightSideProductSet.filter(
                        product => !updatingProductIds.has(product.id)
                    );
                    sortedRightSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                    sortedRightSideProductSet = sortedRightSideProductSet.sort((a, b) => a.x - b.x);

                }else{
                    // this condition only apply, moving product last product overlap the right side products
                    if( sortedRightSideProductSet?.length > 0){
                        sortedRightSideProductSet = sortedRightSideProductSet.sort((a, b) => a.x - b.x);
                        if(currentX > sortedRightSideProductSet[0].x){
                        let startingX = currentX;
                        for (let i = 0; i < sortedRightSideProductSet.length; i++) {
                            const prod = sortedRightSideProductSet[i]; 
                            const nextProd = sortedRightSideProductSet[i+1] || null; 
                            prod.x = currentX;
                            prod.startingPoint = prod.x / this.state.displayRatio;
                            currentX = prod.x + prod.drawWidth;
                            if(!isFromExpand && currentX > startingX && nextProd){
                                if(nextProd.x > currentX){
                                    // this one prevent all right side products updating
                                    break;
                                }
                            }
                        } 
                        }
                    }
                }
          }

          // Handle Left side spacing
          if(getSpacingDirection === "LEFT"){

                if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedLeftSideProductSet?.length > 0) {
                    let needToAdjustProducts = [];
                
                    for (let i = sortedLeftSideProductSet.length - 1; i >= 0; i--) {
                    let adjustableSpace = 0;
                    const currentProduct = sortedLeftSideProductSet[i];
                    const previousProduct = sortedLeftSideProductSet[i - 1] || null;

                    if(previousProduct){
                        adjustableSpace = currentProduct.x - (previousProduct.x + previousProduct.drawWidth);
                        // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                        // handle the space optimization before the assign shelf start x
                        // if(adjustableSpace > howMuchSpaceWant && cx + movingObj.drawWidth < shelfXWithWidth){
                        if(adjustableSpace > howMuchSpaceWant){
                            adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount;
                        }
                    }else{
                        // align to shelf x coordnate
                        let shelfX = this.getShelfXPosition(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                        // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                        if(shelfX < currentProduct.x){
                            // adjustableSpace = currentProduct.x - shelfX;
                            adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                            // handle the space optimization before the assign shelf start x
                            // if(adjustableSpace > howMuchSpaceWant && roundOffDecimal(cx + movingObj.drawWidth,2) < roundOffDecimal(shelfXWithWidth,2)){
                            //   adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                            // }
                        }
                    }

                    // push to updating array
                    needToAdjustProducts.push({product: currentProduct, reduceSpace: adjustableSpace });
                    newChangedSpaceAmount += adjustableSpace;

                    if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                    }

                    // update the new x values
                    for (let i = 0; i < needToAdjustProducts.length; i++) {
                    const product = needToAdjustProducts[i].product;
            
                    // need to assign total x value to get correct coordinate
                    const sumValue = needToAdjustProducts
                        .slice(i) // Take the current and subsequent objects
                        .reduce((sum, item) => sum + item.reduceSpace, 0);

                    product.x = product.x - sumValue;
                    product.startingPoint = product.x / this.state.displayRatio;
                    }

                    // update update product set to sortedLeftSideProductSet
                    const productObjects = needToAdjustProducts.map(item => item.product);
                    // console.log("LEFT productObjects - ", productObjects)
                    const updatingProductIds = new Set(productObjects.map(product => product.id));
                    const filteredUpdatedProducts = sortedLeftSideProductSet.filter(
                        product => !updatingProductIds.has(product.id)
                    );
                    sortedLeftSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                    sortedLeftSideProductSet = sortedLeftSideProductSet.sort((a, b) => a.x - b.x);
                } 


                if(leftSideProductSet.length === 0){
                    currentX = this.getShelfXPosition(sortedInlineShelfSet, changingShelfRank, droppedFiledCustomId);
                }else{
                    // Adjust movingProductSet product set
                    currentX = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
                }

                // Update the moving product x coordinate
                if(droppingFromClipboard && movingProducts.length > 0){
                        movingProducts = movingProducts.sort((a, b) => a.x - b.x);
                        // Sort right side products by x
                        movingProducts.sort((a, b) => a.x - b.x);
                        // Adjust movingProductSet product set
                        for (let i = 0; i < movingProducts.length; i++){
                            const prod = movingProducts[i];
                            prod.x = currentX;
                            prod.shelfrank = changingShelfRank;
                            prod.field_custom_id = droppedFiledCustomId;
                            prod.masterFieldId = droppedFieldMasterFieldId;
                            prod.y = changingShelfHeight - prod.drawHeight;
                            prod.startingPoint = 0;
                            prod.isHanged = false;
                            // prod.startingPoint = prod.x / this.state.displayRatio;
                            currentX = prod.x + prod.drawWidth; 
                            newChangedSpaceAmount = newChangedSpaceAmount + prod.drawWidth;
                        }
                        // Set currentX to the last product's x + drawWidth in movingProducts
                        if (movingProducts.length > 0) {
                            currentX = movingProducts[movingProducts.length - 1].x + 
                                    movingProducts[movingProducts.length - 1].drawWidth;
                        } else {
                            currentX = MOEndX; // Fallback to MOEndX if movingProducts is empty
                        }
                }else{
                    // handle one product dropping from data pannel
                    movingProducts.x = currentX;
                    movingProducts.y = changingShelfHeight - movingProducts.drawHeight;
                    movingProducts.startingPoint = 0;
                    // movingProducts.startingPoint = movingProducts.x / this.state.displayRatio;
                    movingProducts.field_custom_id = droppedFiledCustomId;
                    movingProducts.masterFieldId = droppedFieldMasterFieldId;
                    currentX = movingProducts.x + movingProducts.drawWidth;
                    newChangedSpaceAmount = newChangedSpaceAmount + movingProducts.drawWidth;
                }
          }

          // Handle Right side spacing 
          if(getSpacingDirection === "RIGHT"){
            if(sortedLeftSideProductSet.length === 0){
              currentX = cx;
            }else{
              let leftSideLastProduct = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
              if(cx > leftSideLastProduct){
                currentX = cx;
              }else{
                currentX = leftSideLastProduct;
              }
            }

            // Update the moving product x coordinate
            if(droppingFromClipboard && movingProducts.length > 0){
                movingProducts = movingProducts.sort((a, b) => a.x - b.x);
                // Sort right side products by x
                movingProducts.sort((a, b) => a.x - b.x);
                // Adjust movingProductSet product set
                for (let i = 0; i < movingProducts.length; i++){
                    const prod = movingProducts[i];
                    prod.x = currentX;
                    prod.shelfrank = changingShelfRank;
                    prod.field_custom_id = droppedFiledCustomId;
                    prod.masterFieldId = droppedFieldMasterFieldId;
                    prod.y = changingShelfHeight - prod.drawHeight;
                    prod.startingPoint = 0;
                    prod.isHanged = false;
                    // prod.startingPoint = prod.x / this.state.displayRatio;
                    currentX = prod.x + prod.drawWidth; 
                    // newChangedSpaceAmount = newChangedSpaceAmount + prod.drawWidth;
                }
                // Set currentX to the last product's x + drawWidth in movingProducts
                if (movingProducts.length > 0) {
                    currentX = movingProducts[movingProducts.length - 1].x + 
                            movingProducts[movingProducts.length - 1].drawWidth;
                } else {
                    currentX = MOEndX; // Fallback to MOEndX if movingProducts is empty
                }
            }else{
                // handle one product dropping from data pannel
                movingProducts.x = currentX;
                movingProducts.y = changingShelfHeight - movingProducts.drawHeight;
                movingProducts.startingPoint = 0;
                // movingProducts.startingPoint = movingProducts.x / this.state.displayRatio;
                movingProducts.field_custom_id = droppedFiledCustomId;
                movingProducts.masterFieldId = droppedFieldMasterFieldId;
                currentX = movingProducts.x + movingProducts.drawWidth;
                // newChangedSpaceAmount = newChangedSpaceAmount + movingProducts.drawWidth;
            }

            // check the RIGHT side spacing if avaiable
            if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedRightSideProductSet?.length > 0) {
                let needToAdjustProducts = [];

                for (let i = 0; i < sortedRightSideProductSet.length; i++) {
                  const currentProduct = sortedRightSideProductSet[i];
                  const nextProduct = sortedRightSideProductSet[i + 1] || null;
                  let adjustableSpace = 0;

                  if(nextProduct){
                    adjustableSpace = nextProduct.x - (currentProduct.x + currentProduct.drawWidth);
                  }else{
                    // align to shelf x end coordnate
                    let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, sortedRightSideProductSet[0]?.shelfrank, sortedRightSideProductSet[0]?.field_custom_id);
                    if(shelfXWithWidth > currentProduct.x + currentProduct.drawWidth){
                      adjustableSpace = shelfXWithWidth - (currentProduct.x + currentProduct.drawWidth);
                    }
                  }

                  // push to updating array
                  needToAdjustProducts.push({product: currentProduct, plusSpace: adjustableSpace });
                  newChangedSpaceAmount += adjustableSpace;

                  if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                }

                for (let i = 0; i < needToAdjustProducts.length; i++) {
                  const product = needToAdjustProducts[i].product;
                  const plusSpace = needToAdjustProducts[i].plusSpace;

                  // Update product.x and startingPoint
                  product.x = currentX;
                  product.startingPoint = product.x / this.state.displayRatio;
                  currentX = product.x  +  product.drawWidth;
                }

                // update update product set to sortedRightSideProductSet
                const productObjects = needToAdjustProducts.map(item => item.product);

                const updatingProductIds = new Set(productObjects.map(product => product.id));
                const filteredUpdatedProducts = sortedRightSideProductSet.filter(
                    product => !updatingProductIds.has(product.id)
                );
                sortedRightSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                sortedRightSideProductSet = sortedRightSideProductSet.sort((a, b) => a.x - b.x);
            }
          }


        let updatedArray = sortedLeftSideProductSet.concat(sortedRightSideProductSet);
        updatedArray = updatedArray.concat(movingProducts);
        
        // Verify and correct all product positions to ensure no overlaps
        updatedArray = this.verifyAndCorrectProductPositions(updatedArray);
        
        return {needToReArrange, updatedProducts:updatedArray};


        // ---------------------------------------------------------------------
        // ---------------------------------------------------------------------
        // AUTO LEFT ALIGN ALL PRODUCTS ----------------------------------------
        // OLD Version ---------------------------------------------------------
        // ---------------------------------------------------------------------
        
        //   // Group products by groupId
        //   const groupedProducts = existingProductSet
        //       .filter(product => !product.isDelete) // Remove products with isDelete = true
        //       .reduce((acc, product) => {
        //           if (!acc[product.groupId]) {
        //               acc[product.groupId] = [];
        //           }
        //           acc[product.groupId].push(product);
        //           return acc;
        //       }, {});

        //   // Separate products into left and right side sets based on group logic
        //   let leftSideProductSet = [];
        //   let rightSideProductSet = [];


        //   Object.values(groupedProducts).forEach(group => {
        //       // Check the position of the first product in the group
        //       if (group.some(product => product.x < MOStartX)) {
        //           // If any product in the group goes to the left side, all go to the left side
        //           leftSideProductSet.push(...group);
        //       // } else if (group.some(product => product.x >= MOEndX)) {
        //       } else if (group.some(product => product.x >= MOStartX)) {
        //           // If any product in the group goes to the right side, all go to the right side
        //           rightSideProductSet.push(...group);
        //       }
        //   });

        // //   console.log("Left Side Product Set:", leftSideProductSet);
        // //   console.log("Right Side Product Set:", rightSideProductSet);

        //   // Sort left side products by x
        //   leftSideProductSet.sort((a, b) => a.x - b.x);
        
        //   // Adjust left side products
        //   let currentX = 0;

        //   if(leftSideProductSet.length > 0){
        //     currentX = this.getShelfXPosition(sortedInlineShelfSet, leftSideProductSet[0]?.shelfrank, leftSideProductSet[0]?.field_custom_id)
        //   }

        //   for (let i = 0; i < leftSideProductSet.length; i++) {
        //       const prod = leftSideProductSet[i]; 
        //       prod.x = currentX; // Adjust x to start after MOEndX 
        //       currentX = prod.x + prod.drawWidth; // Update for next product
        //       prod.startingPoint = prod.x / this.props.displayratio; // Update startingPoint
        //   }

        //   // Set currentX to the last product's x + drawWidth in the left array
        //   if (leftSideProductSet.length > 0) {
        //     currentX = leftSideProductSet[leftSideProductSet.length - 1].x + 
        //               leftSideProductSet[leftSideProductSet.length - 1].drawWidth;
        //   } else {
        //     currentX = MOStartX; // Fallback to MOStartX if left array is empty
        //   }

        //   if(leftSideProductSet.length === 0 && movingProducts){
        //     currentX = this.getShelfXPosition(sortedInlineShelfSet, changingShelfRank, droppedFiledCustomId)
        //   }

        //   // handle products set dropping from clipboard
        //   if(droppingFromClipboard && movingProducts.length > 0){
        //        // Sort right side products by x
        //         movingProducts.sort((a, b) => a.x - b.x);
        //         // Adjust movingProductSet product set
        //         for (let i = 0; i < movingProducts.length; i++){
        //             const prod = movingProducts[i];
        //             prod.x = currentX;
        //             prod.shelfrank = changingShelfRank;
        //             prod.field_custom_id = droppedFiledCustomId;
        //             prod.masterFieldId = droppedFieldMasterFieldId;
        //             prod.y = changingShelfHeight - prod.drawHeight;
        //             prod.startingPoint = prod.x / this.props.displayratio;
        //             currentX = prod.x + prod.drawWidth; 
        //         }
        //         // Set currentX to the last product's x + drawWidth in movingProducts
        //         if (movingProducts.length > 0) {
        //             currentX = movingProducts[movingProducts.length - 1].x + 
        //                     movingProducts[movingProducts.length - 1].drawWidth;
        //         } else {
        //             currentX = MOEndX; // Fallback to MOEndX if movingProducts is empty
        //         }
        //   }else{
        //     // handle one product dropping from data pannel
        //     movingProducts.x = currentX;
        //     movingProducts.y = changingShelfHeight - movingProducts.drawHeight;
        //     movingProducts.startingPoint = movingProducts.x / this.props.displayratio;
        //     movingProducts.field_custom_id = droppedFiledCustomId;
        //     movingProducts.masterFieldId = droppedFieldMasterFieldId;
        //     currentX = movingProducts.x + movingProducts.drawWidth;
        //   } 

        //   // Sort right side products by x
        //   rightSideProductSet.sort((a, b) => a.x - b.x);

        //   for (let i = 0; i < rightSideProductSet.length; i++) {
        //       const prod = rightSideProductSet[i]; 
        //       prod.x = currentX; // Adjust x to start after MOEndX 
        //       currentX = prod.x + prod.drawWidth; // Update for next product
        //       prod.startingPoint = prod.x / this.props.displayratio; // Update startingPoint
        //   }

        // //   console.log("LEFT:", leftSideProductSet);
        // //   console.log("RIGHT:", rightSideProductSet);
        // //   console.log("MOVING:", movingProducts);
        //   let updatedArray = leftSideProductSet.concat(rightSideProductSet);
        //   // needs to update the product ids when dropping from the clipboard
        //   if(droppingFromClipboard){
        //     for (let i = 0; i < movingProducts.length; i++) {
        //         movingProducts[i].id = uuidv4();
        //         movingProducts.isNew = true;
        //     }
        //   }
        //   updatedArray = updatedArray.concat(movingProducts);
        // //   console.log("ALL ARRAY:", updatedArray);
        //   return {needToReArrange, updatedProducts:updatedArray};
        // ---------------------------------------------------------------------
        // ---------------------------------------------------------------------
        // AUTO LEFT ALIGN ALL PRODUCTS ----------------------------------------
        // ---------------------------------------------------------------------
        // ---------------------------------------------------------------------
        
      }
      return {needToReArrange};
    }

    getShelfXPosition(inlineShelfSet, prodShelfRank, prodFiledCustomId) {
         const matchingShelf = inlineShelfSet.find(shelf => 
            shelf.rank === prodShelfRank
        );
    
        return matchingShelf ? matchingShelf.x : 0;
    }

    getShelfXPositionWithShelfWidth(inlineShelfSet, prodShelfRank, prodFiledCustomId) {
        const matchingShelf = inlineShelfSet.find(shelf => 
            shelf.rank === prodShelfRank &&
            shelf.field_custom_id === prodFiledCustomId
        );
        return matchingShelf ? (matchingShelf.x + matchingShelf.drawWidth) : 0;
    }

     // find the direction to optimized the spacing
     getDirectionToOptimizedTheGetProductSpacing(cx, movingObjectWidth, shelfStartX, shelfTotalWidth, leftProducts, rightProducts){
        const movingEndX = cx + movingObjectWidth;
        let crossesLeft = false;
        let crossesRight = false;

        // Check if it crosses left products
        for (const product of leftProducts) {
            const productStartX = product.x;
            const productEndX = product.x + product.drawWidth;
            if (movingEndX > productStartX && cx < productEndX) {
                crossesLeft = true;
                break;
            }
        }

        // Check if it crosses right products
        for (const product of rightProducts) {
            const productStartX = product.x;
            const productEndX = product.x + product.drawWidth;
            if (movingEndX > productStartX && cx < productEndX) {
                crossesRight = true;
                break;
            }
        }

        let leftSpace = 0;
        let rightSpace = 0;

        let totalLeftProductWidth = 0;
        for (const product of leftProducts) {
            totalLeftProductWidth += product.drawWidth;
        }
        // console.log("LEFT PROD", totalLeftProductWidth)
        leftSpace = (cx - shelfStartX) - totalLeftProductWidth;
        if (leftSpace < 0) leftSpace = 0;
        // console.log("LEFT REST", leftSpace)

        let totalRightProductWidth = 0;
        for (const product of rightProducts) {
            totalRightProductWidth += product.drawWidth;
        }
        // console.log("RIGHT PROD", totalRightProductWidth)
        rightSpace =((shelfStartX + shelfTotalWidth) - (cx + movingObjectWidth)) - totalRightProductWidth;
        if (rightSpace < 0) rightSpace = 0;
        // console.log("RIGHT REST", rightSpace)

        let direction = "NONE";
        if (crossesLeft && crossesRight) {
            direction = "BOTH";
        } else if (crossesLeft) {
            direction = "LEFT";
        } else if (crossesRight) {
            direction = "RIGHT";
        }

        return { direction, leftSpace, rightSpace };
    }

    /**
     * Extracts subcategory information from a product object
     * Handles multiple data structure variations
     * @param {Object} prod - Product object
     * @returns {Object} Subcategory object with subCategoryName, color, and subCategoryId
     */
    getSubcategoryFromProduct = (prod) => {
        if (!prod) {
            return {
                subCategoryName: null,
                color: null,
                subCategoryId: null
            };
        }

        // Priority 1: Direct subcategory properties
        if (prod?.subcategoryName !== undefined) {
            return {
                subCategoryName: prod?.subcategoryName,
                color: prod?.subcategoryColor,
                subCategoryId: prod?.subcategoryId
            };
        }

        // Priority 2: Nested subcategory.sub_category object
        if (prod?.subcategory?.sub_category) {
            return {
                subCategoryName: prod?.subcategory?.sub_category?.subCategoryName,
                color: prod?.subcategory?.sub_category?.color,
                subCategoryId: prod?.subcategory?.sub_category?.subCategoryId
            };
        }

        if (prod?.subcategory) {
            return {
                subCategoryName: prod?.subcategory?.name,
                color: prod?.subcategory?.color,
                subCategoryId: prod?.subcategory?.id
            };
        }

        // Priority 3: Direct subCategory properties (alternative naming)
        if (prod?.subCategoryName !== undefined) {
            return {
                subCategoryName: prod?.subCategoryName,
                color: prod?.subCategoryColor,
                subCategoryId: prod?.subCategoryId
            };
        }

        // Fallback: return null values
        return {
            subCategoryName: null,
            color: null,
            subCategoryId: null
        };
    };
  

    // PEG CR - 2025 March
    handleProductsDropInsidePegBoard = (evt, shelfObj, fieldobj, cutItem = false) =>{
        let cx = this.state.droppedToPegBoard.droppedX;
        let cy = this.state.droppedToPegBoard.droppedY;
        let draggingProductSet = JSON.parse(JSON.stringify(this.state.currentDraggableProd));
        // console.log("draggingProductSet",draggingProductSet)
        
        let currentSelectedBlock = JSON.parse(JSON.stringify(this.state.currentSelectedBlock)); 

        let mapproductList = this.state.mapproductList; 
        let pegProductList = this.state.pegProductList;
        let pegBoard = this.state.droppedToPegBoard.droppedPegBoard;

        let products = [];
        let newProductList = [];
        let missedProductList = [];
        let errorMessagesList = [];
        // filter is hangged product list which is selected pegboard
        let filteredPegProductList = mapproductList.filter(prod => prod.pegBoardIndex === pegBoard.pegBoardIndex);
         // filtered filteredPegProductList from is delete false products
        filteredPegProductList = filteredPegProductList.filter(prod => !prod.isDelete);
        // drop x & y
        let dropX = cx;
        let dropY = cy;

        // handle if the cut item path
        if(cutItem){
            // handle if more shelf produts block dropping
            draggingProductSet?.shelf.forEach((shelf) => {
                shelf.products.forEach((prod) => {
                    products.push(prod);
                });
            });
        }else{
            // new product section drop 
            products.push(draggingProductSet); 
        }

        // check all products in same group or not, 
        if(products.length > 1){
            const firstProduct = products[0];
            // check if all products in same barcode
            const allSameBarcode = products.every(prod => prod?.barcode === firstProduct?.barcode);
            if(!allSameBarcode){
                alertService.error(this.props.t("MULTIPLE_GROUP_DROP_NOT_ALLOWED"), 4000);
                return;
            }
        }

        products.forEach((prod)=>{
            // check if have not hangable product
            if(!prod?.isHangable){
                // alertService.error(i18n.t("NOT_HANGABLE_PRODUCT"),4000);
                errorMessagesList.push({errorCode: "NOT_HANGABLE_PRODUCT"});
                return;
            }

            const productHoleXPos = (measureConverter(prod?.uom ,"cm",prod?.haggingHorizontal)*this.state.displayRatio);
            const productHoleYPos = (measureConverter(prod?.uom ,"cm",prod?.haggingVertical)*this.state.displayRatio);

            const convertGapH = pegBoard?.drawGapH;
            const convertGapV = pegBoard?.drawGapW;

            // For products with price tag, calculate hole position from center (price tag center on peg hole)
            // For products without price tag, use hanging hole position
            const productHoleX = dropX + productHoleXPos;
            const productHoleY = dropY + productHoleYPos;
            

            // check if some product overlap
            const {isOverlap, issueType} =  this.productOverlapChecker(pegBoard, [...filteredPegProductList, ...newProductList], prod, dropX, dropY);
            if(isOverlap){
                // alertService.error(i18n.t("HANGABLE_PRODUCT_OVERLAP"),4000);
                // this.setState({currentDraggableProd:null})
                if(issueType === "HANGABLE_PRODUCT_OVERLAP"){
                    errorMessagesList.push({errorCode: "HANGABLE_PRODUCT_OVERLAP"});
                }else if(issueType ==="PEG_BOARD_OVERLAP"){
                    errorMessagesList.push({errorCode: "PEG_BOARD_OVERLAP"});
                }
                // push to missing product list 
                missedProductList.push(prod)
                return;
            }

            let nearestPeg = null;
            // find the nearest peg within acceptable range (1.5x gap for tolerance)
            const maxThresholdX = convertGapH * 1.5;
            const maxThresholdY = convertGapV * 1.5;
            nearestPeg = this.findNearestPeg(pegBoard?.pegCoordinations, productHoleX, productHoleY, maxThresholdX, maxThresholdY, prod);

    
            if(nearestPeg === null){
                // alertService.error(i18n.t("CANNOT_FIND_THE_FREE_PEG_HOLE"),4000);
                // this.setState({currentDraggableProd:null})
                errorMessagesList.push({errorCode: "CANNOT_FIND_THE_FREE_PEG_HOLE"});
                // push to missing product list 
                missedProductList.push(prod)
                return;
            }

            // update the product x and y position according to the peg hole
            if(nearestPeg){
                const updatedProductX = nearestPeg.drawX - productHoleXPos;
                const updatedProductY = nearestPeg.drawY - productHoleYPos;

                let catObj = null;
                let subcatobj = null;
                let brandobj = null;
                let brandsupobj = prod?.supplierId != undefined ? { supplierId: prod.supplierId, supplierName: prod.supplierName } : {supplierId: prod?.productBrand?.supplier?.supplierId, supplierName: prod?.productBrand?.supplier?.supplierName};
                catObj ={
                    categoryName: prod.categoryName || prod.category?.categoryName,
                    id: prod.categoryId || prod.category?.id,
                    isDelete: false,
                    isDepartmentResolved: false,
                    isNew: false,
                    subCategory: []
                }
                // Instead of your current nested ternary code:
                const subcategory = this.getSubcategoryFromProduct(prod);
                subcatobj = {
                    sub_category: {
                        subCategoryName: subcategory?.subCategoryName,
                        color: subcategory?.color,
                        subCategoryId: subcategory?.subCategoryId,
                        posCode: prod.subcategoryCode || prod.subcategory?.posCode || prod.subcategory?.sub_category?.posCode || prod.subCategoryImportRefCode || prod.subCategory?.importRefCode || prod.prePlanData?.subCategoryCode || prod.preplanData?.subCategoryCode,
                    },
                    type: catRectEnums.default,
                    rule: null
                };
                // subcatobj = {
                //     sub_category: {
                //         subCategoryName: prod?.subcategoryName != undefined ? prod?.subcategoryName : prod?.subcategory != undefined ? prod?.subcategory?.sub_category?.subCategoryName : prod?.subCategoryName != undefined ? prod?.subCategoryName : prod.subcategory?.sub_category?.subCategoryName,
                //         color: prod?.subcategoryName != undefined ? prod?.subcategoryColor : prod?.subcategory != undefined ? prod?.subcategory?.sub_category?.color : prod?.subCategoryColor != undefined ? prod?.subCategoryColor : prod.subcategory?.sub_category?.color,
                //         subCategoryId: prod?.subcategoryName != undefined ? prod?.subcategoryId : prod?.subcategory != undefined ? prod?.subcategory?.sub_category?.subCategoryId : prod?.subCategoryId != undefined ? prod?.subCategoryId : prod.subcategory?.sub_category?.subCategoryId,
                //     },
                //     type: catRectEnums.default,
                //     rule: null
                // }
                brandobj = {
                    brand: {
                        brandName: prod.brandName != undefined ? prod.brandName : prod?.brand?.brand?.brandName,
                        color: prod.brandColor != undefined ? prod.brandColor : prod?.brand?.brand?.color,
                        brandId: prod.brandId != undefined ? prod.brandId : prod?.brand?.brand?.brandId,
                        supplier: brandsupobj,
                    },
                    type: catRectEnums.default,
                    rule: null
                }

                //get current products list
                let prodlist = this.state.mapproductList;

                var plocobj = {
                    id: uuidv4(),
                    x: updatedProductX, 
                    y: updatedProductY,
                    width: prod.width, 
                    height: prod.height, 
                    depth: prod.depth,
                    drawWidth: measureConverter(prod.uom,this.state.displayUOM,prod.width) * this.state.displayRatio,
                    drawHeight: measureConverter(prod.uom,this.state.displayUOM,prod.height) * this.state.displayRatio,
                    isHangable: prod.isHangable,
                    haggingHorizontal: prod.haggingHorizontal,
                    haggingVertical: prod.haggingVertical,
                    drawHaggingHorizontal: measureConverter(prod.uom,this.state.displayUOM,prod.haggingHorizontal) * this.state.displayRatio,
                    drawHaggingVertical: measureConverter(prod.uom,this.state.displayUOM,prod.haggingVertical) * this.state.displayRatio,
                    imageUrl: prod.imageUrl,
                    barcode: prod.barcode,
                    productId: (prod.isSingleCut || prod?.category === 'simulated' ? (prod?.productId ?? prod?.productId) : prod?.productId),
                    name: (prod.isSingleCut?prod.name:prod.productName ?? prod.name),
                    uom: prod.uom,
                    field_custom_id: fieldobj.field_custom_id,
                    virtualBoxId: fieldobj.virtualBoxId,
                    fuuid: uuidv4(),
                    // shelfrank: shelfObj.rank,
                    shelfrank: 1,
                    startingPoint: updatedProductX / this.state.displayRatio,
                    department: prod.department || prod.departmentData,
                    brand: { ...brandobj, posCode: prod.brandLambdaData?.brandCode},
                    subcategory: { ...subcatobj},
                    category: { ...catObj, posCode: prod.categoryLambdaData?.categoryCode},
                    supplier: prod.supplier,
                    prodidx: (prodlist.length),
                    isDropNew: (!prod.isSingleCut),
                    isNew: true,
                    isDelete: false,
                    brandRectId: -1,
                    subcategoryRectId: -1,
                    // categoryRectId:  containElem.catrect.catrectId,
                    isStackable:false,
                    maxStackableCount:prod.maxStackableCount,
                    masterFieldId:prod.masterFieldId, 
                    // peg details
                    pegBoardId: pegBoard.id,
                    pegBoardIndex: pegBoard.pegBoardIndex,
                    pegBoardName: pegBoard.name,
                    isHanged: true,
                    pegRefCode: nearestPeg.refCode,
                    pegX: nearestPeg.x,
                    pegDrawX: nearestPeg.drawX,
                    pegY: nearestPeg.y,
                    pegDrawY: nearestPeg.drawY,
                    pegProductId: uuidv4(),
                    prePlanData: prod.prePlanData || prod.preplanData || {},
                    normalizedData: prod.normalizedData || {},
                    isBlock: prod.isBlock || false,
                    isArchived: prod.isArchived || false,
                    isMandatoryProduct: prod.isMandatoryProduct || false,
                    recValue: prod.recValue || 0,
                    facing: prod.facing || 0,
                    categoryId: prod?.categoryId || prod?.category?.id || prod?.subcategory?.sub_category?.categoryId,
                    subCategoryId: prod?.subCategoryId || subcatobj?.sub_category?.subCategoryId || prod?.subcategory?.sub_category?.subCategoryId,
                    brandId: prod?.brandId || brandobj?.brand?.brandId || prod?.productBrand?.brandId,
                    hasPriceTag: prod?.product?.hasPriceTagLatest || prod?.hasPriceTagLatest,
                    priceTagGap: prod?.product?.priceTagGapLatest || prod?.priceTagGapLatest,
                    priceTagHeight: prod?.product?.priceTagHeightLatest || prod?.priceTagHeightLatest,
                    hasPriceTagLatest: prod?.product?.hasPriceTagLatest || prod?.hasPriceTagLatest ,
                    priceTagGapLatest: prod?.product?.priceTagGapLatest || prod?.priceTagGapLatest ,
                    priceTagHeightLatest: prod?.product?.priceTagHeightLatest || prod?.priceTagHeightLatest,
                    product:{...prod.product,
                        hasPriceTag: prod?.product?.hasPriceTagLatest,
                        priceTagGap: prod?.product?.priceTagGapLatest,
                        priceTagHeight: prod?.product?.priceTagHeightLatest,
                        hasPriceTagLatest: prod?.product?.hasPriceTagLatest || prod?.hasPriceTagLatest ,
                        priceTagGapLatest: prod?.product?.priceTagGapLatest || prod?.priceTagGapLatest ,
                        priceTagHeightLatest: prod?.product?.priceTagHeightLatest || prod?.priceTagHeightLatest,
                    }
                    
                };
                // console.log("prod",prod)
                // check if some product overlap
                // Pass nearestPeg.drawX and nearestPeg.drawY as the peg center for price tag calculation
                const {isOverlap, issueType} =  this.productOverlapChecker(pegBoard, filteredPegProductList, plocobj, updatedProductX, updatedProductY, nearestPeg.drawY, nearestPeg.drawX);

                if(isOverlap){
                    // alertService.error(i18n.t("HANGABLE_PRODUCT_OVERLAP"),4000);
                    // this.setState({currentDraggableProd:null})
                    if(issueType === "HANGABLE_PRODUCT_OVERLAP"){
                        errorMessagesList.push({errorCode: "HANGABLE_PRODUCT_OVERLAP"});
                    }else if(issueType ==="PEG_BOARD_OVERLAP"){
                        errorMessagesList.push({errorCode: "PEG_BOARD_OVERLAP"});
                    }
                    // push to missing product list 
                    missedProductList.push(prod)
                    return;
                }

                newProductList.push(plocobj);
                // update drop x & y
                // dropX = nearestPeg.drawX + productHoleXPos + convertGapV/2; // OLD METHOD
                dropX = nearestPeg.drawX + prod.drawWidth;
                dropY = cy;
            }


        });

        // check if have some error messages 
        if(errorMessagesList.length > 0){
            // remove duplicate error codes
            errorMessagesList = errorMessagesList.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.errorCode === value.errorCode
                ))
            );
            
            // show error messages
            let errorMessage = errorMessagesList.map((error) => {
                if(error.errorCode === "NOT_HANGABLE_PRODUCT"){
                    return i18n.t("NOT_HANGABLE_PRODUCT");
                }else if(error.errorCode === "HANGABLE_PRODUCT_OVERLAP"){
                    return i18n.t("HANGABLE_PRODUCT_OVERLAP");
                }else if(error.errorCode === "CANNOT_FIND_THE_FREE_PEG_HOLE"){
                    return i18n.t("CANNOT_FIND_THE_FREE_PEG_HOLE");
                }else if(error.errorCode === "PEG_BOARD_OVERLAP"){
                    return i18n.t("PEG_BOARD_OVERLAP");
                }
            });
            alertService.error(errorMessage,4000);
        };

        // Save history BEFORE updating clipboard so undo can restore clipboard state
        let existingProducts = JSON.parse(JSON.stringify(mapproductList));
        let existingPegProducts = JSON.parse(JSON.stringify(pegProductList));

        let historydata=JSON.parse(JSON.stringify(this.state.mapproductList));
        this.fieldHistoryAdd(historydata,1);

        if(cutItem && newProductList.length > 0){
            // update the clipboard
            if(this.state.clipDragType==="SINGLE"){
                this.updateSingleCutProduct(draggingProductSet, false, draggingProductSet.cutidx, draggingProductSet.groupUUID);
            }else{
                this.updateSingleCutProduct(null, true, draggingProductSet.cutidx, draggingProductSet.groupUUID);
            }
        }

        // push missing products to cliboard
        if(missedProductList.length > 0 && newProductList.length > 0){
            let updatedClipboardObj = this.filterDraggingProductSetByMissedList(draggingProductSet, missedProductList);
            // update the groupUUID
            updatedClipboardObj.groupUUID = uuidv4();
            // update the clibpard
            this.updateCutList(updatedClipboardObj);
        }

        const newProductIds = new Set(newProductList.map(p => p.productId).filter(Boolean));
        const cleanedPegProducts = newProductIds.size > 0
            ? existingPegProducts.filter(p => !p.productId || !newProductIds.has(p.productId))
            : existingPegProducts;
        this.handlePegProductAdd([...cleanedPegProducts, ...newProductList], () => {
            // compare imported pegproducts to highlight added ones
            this.compareImportedProds();
        });
        this.updateProductList([...existingProducts, ...newProductList],false);

        // update the data panel
        this.nonSimProddropremoveCounterupdate();

    }

    // PEG CR - 2025 March
    // this function will compare dragging product object with missing product set
    filterDraggingProductSetByMissedList = (draggingProductSet, missedProductList) => {
        let draggingProduct = JSON.parse(JSON.stringify(draggingProductSet));
        // check missedProductList
        if(!missedProductList || missedProductList.length === 0){
            return draggingProduct; // No missed products, return original draggingProductSet
        }
        let draggingProductSetCopy = structuredClone(draggingProduct);
        // Step 1: Get missed product IDs
        const missedProductIds = new Set(missedProductList.map(prod => prod.id));
    
        // Step 2: Filter shelves in draggingProductSet
        draggingProductSetCopy.shelf = draggingProductSetCopy.shelf.map(shelf => {
            // Keep only products that match missedProductIds
            const filteredProducts = shelf.products.filter(prod => missedProductIds.has(prod.id));
            return {
                ...shelf,
                products: filteredProducts
            };
        });
    
        // Step 3: Remove empty shelves
        draggingProductSetCopy.shelf = draggingProductSetCopy.shelf.filter(shelf => shelf.products.length > 0);
    
        // Step 4: Update selectedProducts to match filtered products
        draggingProductSetCopy.shelf.forEach(shelf => {
            shelf.selectedProducts = shelf.products;
        });
    
        // Step 5: Update selectedshelves to match shelf
        draggingProductSetCopy.selectedshelves = draggingProductSetCopy.shelf;
    
        return draggingProductSetCopy;
    }


    // PEG CR - 2025 March
    // This function will return if product overlap in the exiting product set int peg board
    // newPegDrawY is the peg center Y for the new product being moved (optional, used for price tag calculation)
    // newPegDrawX is the peg center X for the new product being moved (optional, used for price tag X calculation)
    productOverlapChecker = (pegBoard, existingProductList, newProduct, cx, cy, newPegDrawY = null, newPegDrawX = null) => {
        // console.log("pegBoard",pegBoard)
        // remove the dropping product if avaliable the
        let existingPegProducts = existingProductList.filter((prod)=>prod.id != newProduct.id);
        // remove the other peg boards products
        existingPegProducts = existingPegProducts.filter((prod)=>prod?.pegBoardIndex == pegBoard?.pegBoardIndex || prod?.pegBoardId == pegBoard?.id);

        const productWidth = newProduct?.drawWidth;
        // Calculate total height including price tag if hasPriceTag is true for new product
        const newPriceTagHeightPx = newProduct?.hasPriceTag ? (newProduct?.priceTagHeight * this.state.displayRatio) : 0;
        const newGapPx = newProduct?.hasPriceTag ? (newProduct?.priceTagGap * this.state.displayRatio) : 0;
        const productHeight = newProduct?.hasPriceTag
            ? newPriceTagHeightPx + newGapPx + newProduct?.drawHeight
            : newProduct?.drawHeight;
        // For new product with price tag, Y starts at pegDrawY - (priceTagHeight/2)
        // Use newPegDrawY if provided, otherwise fall back to cy
        const newProductY = (newProduct?.isHanged && newProduct?.hasPriceTag && newPegDrawY)
            ? newPegDrawY - (newPriceTagHeightPx / 2)
            : cy;
        // For new product with price tag, X is centered on peg hole: pegDrawX - (drawWidth/2)
        const newProductX = (newProduct?.isHanged && newProduct?.hasPriceTag && newPegDrawX)
            ? newPegDrawX - (productWidth / 2)
            : cx;

        // console.log("existingPegProducts=====>",existingPegProducts)
        // Check for overlap with any existing products on the peg board
        for (let existingProduct of existingPegProducts) {
            // For existing products with price tag, X is centered on peg hole: pegDrawX - (drawWidth/2)
            const existingWidth = existingProduct?.drawWidth;
            const existingX = (existingProduct?.isHanged && existingProduct?.hasPriceTag && existingProduct?.pegDrawX !== undefined)
                ? existingProduct.pegDrawX - (existingWidth / 2)
                : existingProduct?.x;
            // Calculate total height including price tag if hasPriceTag is true for existing product
            const existingPriceTagHeightPx = existingProduct?.hasPriceTag ? (existingProduct?.priceTagHeight * this.state.displayRatio) : 0;
            const existingGapPx = existingProduct?.hasPriceTag ? (existingProduct?.priceTagGap * this.state.displayRatio) : 0;
            const existingHeight = (existingProduct?.isHanged && existingProduct?.hasPriceTag)
                ? existingPriceTagHeightPx + existingGapPx + existingProduct?.drawHeight
                : existingProduct?.drawHeight;
            // For products with price tag, Y starts at top of price tag (pegDrawY - priceTagHeight/2), otherwise use product.y
            const existingY = (existingProduct?.isHanged && existingProduct?.hasPriceTag && existingProduct?.pegDrawY !== undefined)
                ? existingProduct.pegDrawY - (existingPriceTagHeightPx / 2)
                : existingProduct?.y;

            // check if the products is delete ture then skip the products
            if(existingProduct?.isDelete){
                continue;
            }

            const isOverlap = !(
                newProductX + productWidth <= existingX || // New product is entirely left of the existing product
                newProductX >= existingX + existingWidth || // New product is entirely right of the existing product
                newProductY + productHeight <= existingY || // New product is entirely above the existing product
                newProductY >= existingY + existingHeight // New product is entirely below the existing product
            );

            if (isOverlap) {
                // console.log("Overlap detected with product: ", existingProduct);
                return {isOverlap:true, issueType: "HANGABLE_PRODUCT_OVERLAP"};
                // need to make the function to move exisitng product and get space
            }
        }

        // check if product is in outside the peg board
        const pegBoardStartX = pegBoard?.pegDrawingRect?.drawX;
        const pegBoardStartY = pegBoard?.pegDrawingRect?.drawY;
        const pegBoardEndX = pegBoard?.pegDrawingRect?.drawX + pegBoard?.pegDrawingRect?.drawRectWidth;
        const pegBoardEndY = pegBoard?.pegDrawingRect?.drawY + pegBoard?.pegDrawingRect?.drawRectHeight;

        if (newProductX + productWidth > pegBoardEndX || newProductX < pegBoardStartX ||
            newProductY + productHeight > pegBoardEndY || newProductY < pegBoardStartY) {
            return {isOverlap:true, issueType: "PEG_BOARD_OVERLAP"};
        }
        

        // No overlap, product can be dropped at the original position
        // console.log("No overlap detected, product can be placed at the selected position.");
        return {isOverlap:false};  // No overlap, return null or appropriate result
    };

    // PEG CR - 2025 March
    // this function will return the nearest peg hole
    // prod is optional - for price tag products, converts hanging hole position to price tag center
    findNearestPeg = (pegCoordinations, productHoleX, productHoleY, thresholdX, thresholdY, prod = null) => {
        let nearestPeg = null;
        let minDistance = Infinity;

        let searchX = productHoleX;
        let searchY = productHoleY;
        const hasPriceTag = prod?.product?.hasPriceTagLatest || prod?.hasPriceTagLatest;
        if (hasPriceTag) {
            // productHoleX = dropX + productHoleXPos, need to replace offset with price tag center
            const productHoleXPos = measureConverter(prod?.uom, "cm", prod?.haggingHorizontal) * this.state.displayRatio;
            const productHoleYPos = measureConverter(prod?.uom, "cm", prod?.haggingVertical) * this.state.displayRatio;
            const productDrawWidth = measureConverter(prod?.uom, this.state.displayUOM, prod?.width) * this.state.displayRatio;
            const priceTagHeightPx = (prod?.product?.priceTagHeightLatest || prod?.priceTagHeightLatest || prod?.priceTagHeight || 0) * this.state.displayRatio;
            // Replace hanging hole offset with price tag center offset
            searchX = productHoleX - productHoleXPos + (productDrawWidth / 2);
            searchY = productHoleY - productHoleYPos + (priceTagHeightPx / 2);
        }

        for (const peg of pegCoordinations) {
            const deltaX = Math.abs(peg.drawX - searchX);
            const deltaY = Math.abs(peg.drawY - searchY);

            // Check if peg is within threshold
            if (deltaX <= thresholdX && deltaY <= thresholdY) {
            // Calculate Euclidean distance
            const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

            // Update if this is the nearest peg so far
            if (distance < minDistance) {
                minDistance = distance;
                nearestPeg = peg;
            }
            }
        }

        return nearestPeg;
    }


    //update recent added prod list
    updateRecentProdList = (prodobj) => {
        let recentList = this.state.recentProdList;
        let isalreadyadded = recentList.findIndex(x => x.id === prodobj.id);

        if(isalreadyadded === -1){
            recentList.push(prodobj);
        }

        this.setState({ recentProdList: recentList });
    }

    fetchUpdatedCategoryData = async (products, actualFieldStructures, pegProducts, pegBoards) => {
        let svobj = {
            products: products,
            actualFieldStructures: actualFieldStructures,
            pegProducts: pegProducts,
            pegBoards: pegBoards,
        };

        this.setState({ loadingNow: true });
    
        try {
            const response = await submitSets(submitCollection.mpCategoryNowValue, svobj);
           
            this.setState({ loadingNow: false });
            return response.extra;
        } catch (error) {
           
            this.setState({ loadingNow: false });
            return null; 
        }
    }

    // Mark that changes have been made since last refresh
    markChangesForRefresh = () => {
        if (!this.state.hasChangesSinceLastRefresh) {
            this.setState({ hasChangesSinceLastRefresh: true });
        }
    }

    // Process Lambda Data Panel API result
    processLambdaDataPanelResult = async (isRefresh = false) => {
        const simulationObjData = this.props.simulationObj;
        
        if (!simulationObjData) {
            return;
        }

        this.setState({ isLoadingDataPanelLambda: true });

        try {
            let payload;
            const mapFieldArray = this.state.isDisplayUnitEdited ? Object.values(this.state.mapFields).map(field => ({
                ...field
            })) : simulationObjData.fieldList;
            
            if (isRefresh) {
                // When called as refresh, use current state data
                let cprodlist = JSON.parse(JSON.stringify(this.state.mapproductList));
                let notrelatedprods = JSON.parse(JSON.stringify(this.props.notReleatedProdList));
                let currentNonSimulatedProducts = JSON.parse(JSON.stringify(this.state.nonfilteredNonEProducts));
                // Strip fe lambda data added to non sim prod objs for API payload
                currentNonSimulatedProducts = currentNonSimulatedProducts.map(prod => {
                    DATA_PANEL_ENRICHMENT_FIELDS.forEach(field => delete prod[field]);
                    // Reconstruct category object if overwritten to string by normalizeDataPaneltData
                    if (typeof prod.category === 'string') {
                        prod.category = {
                            id: prod.categoryId,
                            categoryName: prod.categoryName,
                            name: prod.categoryName,
                            posCode: prod.categoryCode
                        };
                    }
                    return prod;
                });
                cprodlist = cprodlist.filter((prod) => prod?.isHanged != true);
                
                let exportprodlist = [];
                let mapFields = this.state.mapFields;
                
                for (let i = 0; i < cprodlist.length; i++) {
                    const proditem = cprodlist[i];
                    let prodfield = mapFields[proditem.field_custom_id];
                    let prodstartpoint = ((proditem.x - prodfield.x) / this.state.displayRatio);

                    const match = prodstartpoint.toString().match(/^-?\d+\.\d{0,9}/);
                    prodstartpoint = match ? match[0] : prodstartpoint.toString();

                    proditem["startingPoint"] = prodstartpoint;
                    proditem["isDelete"] = (proditem.isDelete ? proditem.isDelete : false);
                    proditem["isNew"] = ((proditem.isNew || proditem.isDropNew) ? proditem.isNew : false);

                    if (!proditem.isNew || (proditem.isNew && !proditem.isDelete)) {
                        exportprodlist.push(proditem);
                    }
                }
                
                payload = {
                    products: notrelatedprods.concat(exportprodlist),
                    hierarchy: simulationObjData.hierarchy || {},
                    nonSimulateProducts: currentNonSimulatedProducts,
                    actualFieldStructures: simulationObjData.actualFieldStructures || [],
                    fieldList: mapFieldArray || [],
                    pegProductList: this.state.pegProductList || [],
                    pegBoards: this.state.pegList || []
                };
            } else {
                // Initial load - use simulationObj data
                payload = {
                    products: simulationObjData.products || [],
                    hierarchy: simulationObjData.hierarchy || {},
                    nonSimulateProducts: simulationObjData.nonSimulateProducts || [],
                    actualFieldStructures: simulationObjData.actualFieldStructures || [],
                    fieldList: mapFieldArray || [],
                    pegProductList: simulationObjData.pegProductList || [],
                    pegBoards: simulationObjData.pegBoards || []
                };
            }

            let lambdaData = await submitSets(submitCollection.dataPanelDataLambda, payload, false);

            if (lambdaData.extra && typeof lambdaData.extra === 'object') {
                lambdaData = lambdaData.extra;
            }

            // If this is initial load (not refresh), make an additional call with isRefresh payload to get hierachy dataPanelData obj
            // if (!isRefresh) {
            //     await this.processLambdaDataPanelResult(true);
            //     return;
            // }
            
            if (!lambdaData) {
                return;
            }
        
        
        // Transform Lambda products data for easier matching
        let lambdaProductsData = [];
        if (lambdaData.products && lambdaData.products.length > 0) {
            lambdaProductsData = lambdaData.products.map(product => ({
                barcode: product.barcode,
                preplanData: {
                    ...product.preplanData || product.prePlanData || {},
                    // Root level data from product structure
                    departmentCode: product.department?.posCode || product.department?.code || product?.prePlanData?.departmentCode,
                    departmentName: product.department?.name || this.props.departmentName,
                    categoryCode: product.category?.posCode || product.category?.importRefCode || product?.prePlanData?.categoryCode,
                    categoryName: product.category?.name || product.category?.categoryName,
                    subcategoryCode: product.subcategory?.sub_category?.posCode || product.subcategory?.posCode || product.subcategory?.importRefCode || product?.prePlanData?.subCategoryCode,
                    subcategoryName: product.subcategory?.sub_category?.subCategoryName || product.subcategory?.name,
                    brandCode: product.brand?.brand?.posCode || product.productBrand?.posCode || product.brand?.posCode || product?.prePlanData?.brandCode,
                    brandName: product.brand?.brand?.name || product.brand?.brand?.brandName || product.productBrand?.brandName,
                    supplierCode: product.supplier?.posCode || product.supplier?.supplierCode || product.brand?.brand?.supplier?.posCode || product.productBrand?.supplier?.posCode || product?.prePlanData?.supplierCode,
                    supplierName: product.supplier?.name || product.supplier?.supplierName || product.brand?.brand?.supplier?.supplierName || product.productBrand?.supplier?.supplierName,
                    barcode: product.barcode,
                    name: product.name,
                    subBrandCode: product.subBrandCode,
                    recValue: product.recValue,
                    stackCount: product.stackCount,
                    isHangable: product.isHangable ?? product.prePlanData?.hangable,
                    isMandatoryProduct: product.isMandatoryProduct ?? product.isMandatory ?? product.prePlanData?.isMandatoryProduct ?? product.prePlanData?.mandatory,
                    isNewProduct: product.isNewProduct ?? product.isNew ?? product.prePlanData?.isNew ?? product.prePlanData?.isNewProduct,
                    isArchived: product.isArchived,
                    isBlock: product.isBlock ?? product?.isBlocked ?? false
                },
                normalizedData: { ...(product.normalizedData || {}), ...(product.dataPanelData?.normalized || {}) },
                dataPanelData: product.dataPanelData || {}
            }));
        }
        
        // Transform Lambda non-simulate products data
        let lambdaNonSimulateProductsData = [];
        if (lambdaData.nonSimulatedProducts && lambdaData.nonSimulatedProducts.length > 0) {
            lambdaNonSimulateProductsData = lambdaData.nonSimulatedProducts.map(product => ({
                barcode: product.barcode,
                preplanData: {
                    ...product.preplanData || product.prePlanData || {},
                    // Root level data from product structure
                    departmentCode: product.department?.posCode || product.department?.code || product.departmentData?.posCode || product.departmentData?.code,
                    departmentName: product.departmentName || product.department?.name || product.departmentData?.name || this.props.departmentName,
                    categoryCode: product.prePlanData?.categoryCode || product.preplanData?.categoryCode || product.category?.posCode || product.category?.importRefCode || product.categoryCode || product.categoryPosCode,
                    categoryName: product.category?.name || product.category?.categoryName || product.categoryName,
                    subcategoryCode: product.subcategory?.posCode || product.subcategory?.sub_category?.posCode,
                    subcategoryName: product.subcategory?.name || product.subcategory?.sub_category?.subCategoryName || product.subCategoryName,
                    brandCode: product.brand?.posCode || product.productBrand?.posCode,
                    brandName: product.brand?.name || product.brandName || product.productBrand?.brandName,
                    supplierCode: product.supplier?.posCode || product.supplier?.supplierCode,
                    supplierName: product.supplier?.name || product.supplierName || product.supplier?.supplierName,
                    barcode: product.barcode,
                    name: product.name || product?.productName,
                    subBrandCode: product.subBrandCode,
                    recValue: product.recValue,
                    stackCount: product.stackCount,
                    isHangable: product.isHangable ?? product.prePlanData?.hangable,
                    isMandatoryProduct: product.isMandatoryProduct ?? product.isMandatory,
                    isNewProduct: product.isNewProduct ?? product.isNew ?? product.prePlanData?.isNew ?? product.prePlanData?.isNewProduct,
                    isArchived: product.isArchived,
                    isBlock: product.isBlock ?? product?.isBlocked ?? false
                },
                normalizedData: { ...(product.normalizedData || {}), ...(product.dataPanelData?.normalized || {}) },
                dataPanelData: product.dataPanelData || {}
            }));
        }

        // Transform Lambda pegproducts data
        let lambdaPegProductsData = [];
        if (lambdaData.pegProductList && lambdaData.pegProductList.length > 0) {
            lambdaPegProductsData = lambdaData.pegProductList.map(product => ({
                barcode: product.product?.barcode || product.barcode,
                preplanData: {
                    ...product.preplanData || product.prePlanData || product.product?.preplanData || product.product?.prePlanData || {},
                    // Root level data from product structure
                    departmentCode: product.department?.importRefCode || product.category?.importDepRefCode || product.departmentImportRefCode || product.departmentOriginalImportRefCode || product.department?.posCode || product.department?.code,
                    departmentName: product.department?.name || this.props.departmentName,
                    categoryCode: product.category?.importRefCode || product.category?.posCode || product.categoryImportRefCode || product.categoryOriginalImportRefCode,
                    categoryName: product.category?.name || product.category?.categoryName,
                    subcategoryCode: product.subCategory?.importRefCode || product.subcategory?.sub_category?.posCode || product.subcategory?.posCode || product.subCategoryImportRefCode || product.subCategoryOriginalImportRefCode,
                    subcategoryName: product.subCategory?.name || product.subcategory?.sub_category?.subCategoryName || product.subcategory?.name,
                    brandCode: product.brand?.importRefCode || product.brand?.brand?.posCode || product.productBrand?.posCode || product.brand?.posCode || product.brandImportRefCode,
                    brandName: product.brand?.name || product.brand?.brand?.name || product.brand?.brand?.brandName || product.productBrand?.brandName || product.product?.productBrand?.brandName,
                    supplierCode: product.brand?.supplier?.code || product.supplier?.posCode || product.supplier?.supplierCode || product.brand?.brand?.supplier?.posCode || product.productBrand?.supplier?.posCode || product.product?.productBrand?.supplier?.supplierCode || product.supplierImportRefCode || product.brand?.supplier?.importRefCode,
                    supplierName: product.brand?.supplier?.name || product.supplier?.name || product.supplier?.supplierName || product.brand?.brand?.supplier?.supplierName || product.productBrand?.supplier?.supplierName || product.product?.productBrand?.supplier?.supplierName,
                    barcode: product.product?.barcode || product.barcode,
                    name: product.product?.name || product.name,
                    subBrandCode: product.subBrandCode,
                    recValue: product.recValue,
                    stackCount: product.stackCount,
                    isHangable: product.product?.isHangable ?? product.isHanged ?? product.isHangable,
                    isMandatoryProduct: product.isMandatory ?? product.product?.isMandatory ?? product.isMandatoryProduct ?? false,
                    isNewProduct: product.isNewProduct ?? product.isNew ?? product.prePlanData?.isNew ?? product.prePlanData?.isNewProduct,
                    isArchived: product.product?.isArchived ?? product.isArchived,
                    isBlock: product.isBlock ?? product?.isBlocked ?? product.product?.isBlock ?? false
                },
                normalizedData: { ...(product.normalizedData || product.product?.normalizedData || {}), ...(product.dataPanelData?.normalized || product.product?.dataPanelData?.normalized || {}) },
                dataPanelData: product.dataPanelData || product.product?.dataPanelData  || {}
            }));
        }
        
        // Combine both arrays for easier lookup
        const combinedLambdaData = [...lambdaProductsData, ...lambdaNonSimulateProductsData, ...lambdaPegProductsData];
        
        // Extract hierarchy data for aggregated tabs
        const hierarchyData = this.extractHierarchyData(lambdaData.hierarchy);
        
        // Update parent component with new hierarchy data
        if(this.props.getUpdatedHierarchy  ){
          await this.props.getUpdatedHierarchy(hierarchyData);  
        }
        
            const stateUpdate = { 
                lambdaProductsData: combinedLambdaData,
                hierarchyData: hierarchyData,
                isLoadingDataPanelLambda: false
            };
            
            // If this was a refresh call, reset the refresh indicator
            if (isRefresh) {
                stateUpdate.hasChangesSinceLastRefresh = false;
            }
            
            this.setState(stateUpdate, () => {
                // Refresh the filtered list with new Lambda data
                this.setInitialFilteredList();
                this.updateNonSimProductsCount();
            });
        } catch (error) {
            console.error('Error calling dataPanelDataLambda endpoint:', error);
            this.setState({ isLoadingDataPanelLambda: false });
        }
    }

    // Extract hierarchy data into lookup maps for efficient access
    extractHierarchyData = (hierarchy) => {
        if (!hierarchy || !hierarchy.categories) return null;

        const categoryMap = new Map();
        const subcategoryMap = new Map(); 
        const supplierMap = new Map();
        const brandMap = new Map();

        // Iterate through hierarchy to build lookup maps
        hierarchy.categories.forEach(category => {
            // Store category data using categoryId as key
            categoryMap.set(category.categoryId, {
                ...category,
                lambdaData: {
                    // Category data mapping based on actual hierarchy structure
                    allocatedShareCategory: category.allocatedShareCategory,
                    weightedShareCategory: category.weightedShareCategory,
                    avgPricePerProduct: category.avgPricePerProduct,
                    salesUnits: category.salesUnits,
                    salesCurrency: category.salesCurrency,
                    profitCurrency: category.profitCurrency,
                    profitabilityPercent: category.profitabilityPercent,
                    dailySalesRateCurrency: category.dailySalesRateCurrency,
                    dailySalesRateUnits: category.dailySalesRateUnits,
                    // Hierarchical context for category level
                    categoryName: category.categoryName,
                    categoryId: category.categoryId,
                    categoryCode: category.posCode,
                    departmentId: hierarchy.departmentId, // From parent hierarchy
                    barcodeCount: category.barcodeCount || category.dataPanelData?.barcodeCountAll
                },
                normalizedLambdaData: { ...(category.normalizedData || {}), ...(category.dataPanelData?.normalized || {}) },
                dataPanelData: {
                    ...category.dataPanelData,
                    actualSharePlanogram: category.dataPanelData?.actualSharePlanogram,
                    weightedSharePlanogram: category.dataPanelData?.weightedSharePlanogram,

                    totalAllocatedWidth: category.dataPanelData?.totalAllocatedWidth,
                    shelfCapacity: category.dataPanelData?.shelfCapacity,
                    salesPerFacing: category.dataPanelData?.salesPerFacing,
                    totalFacing: category.dataPanelData?.totalFacing,
                    unitsPerFacing: category.dataPanelData?.unitsPerFacing,
                    salesPerMeter: category.dataPanelData?.salesPerMeter,
                    unitsPerMeter: category.dataPanelData?.unitsPerMeter,
                    shareOfSaleCurrency: category.dataPanelData?.shareOfSaleCurrency,
                    shareOfSaleUnit: category.dataPanelData?.shareOfSaleUnit,
                    shareOfSaleProfit: category.dataPanelData?.shareOfSaleProfit,
                    // Keep legacy fields for fallback
                    actualShare: category.allocatedShare || category.dataPanelData?.actualSharePlanogram,
                    weightedShare: category.weightedShare || category.dataPanelData?.weightedSharePlanogram
                }
            });

            // Process subcategories
            if (category.subcategories) {
                category.subcategories.forEach(subcategory => {
                    subcategoryMap.set(subcategory.subCategoryId, {
                        ...subcategory,
                        lambdaData: {
                            // Subcategory data mapping based on actual hierarchy structure
                            allocatedShareSubcategory: subcategory.allocatedShareSubcategory,
                            weightedShareSubcategory: subcategory.weightedShareSubcategory,
                            avgPricePerProduct: subcategory.avgPricePerProduct,
                            salesUnits: subcategory.salesUnits,
                            salesCurrency: subcategory.salesCurrency,
                            profitCurrency: subcategory.profitCurrency,
                            profitabilityPercent: subcategory.profitabilityPercent,
                            dailySalesRateCurrency: subcategory.dailySalesRateCurrency,
                            dailySalesRateUnits: subcategory.dailySalesRateUnits,
                            // Hierarchical context for subcategory level
                            subcategoryName: subcategory.subcategoryName,
                            subCategoryId: subcategory.subCategoryId,
                            subcategoryCode: subcategory.posCode,
                            categoryName: category.categoryName, // From parent category
                            categoryId: category.categoryId,     // From parent category
                            categoryCode: category.posCode, // From parent category
                            departmentId: hierarchy.departmentId, // From root hierarchy
                            barcodeCount: subcategory.barcodeCount || subcategory.dataPanelData?.barcodeCountAll
                        },
                        normalizedLambdaData: { ...(subcategory.normalizedData || {}), ...(subcategory.dataPanelData?.normalized || {}) },
                        dataPanelData: {
                            ...subcategory.dataPanelData,
                            actualSharePlanogram: subcategory.dataPanelData?.actualSharePlanogram,
                            weightedSharePlanogram: subcategory.dataPanelData?.weightedSharePlanogram,
                            actualShareCategory: subcategory.dataPanelData?.actualShareCategory,
                            weightedShareCategory: subcategory.dataPanelData?.weightedShareCategory,

                            totalAllocatedWidth: subcategory.dataPanelData?.totalAllocatedWidth,
                            shelfCapacity: subcategory.dataPanelData?.shelfCapacity,
                            salesPerFacing: subcategory.dataPanelData?.salesPerFacing,
                            totalFacing: subcategory.dataPanelData?.totalFacing,
                            unitsPerFacing: subcategory.dataPanelData?.unitsPerFacing,
                            salesPerMeter: subcategory.dataPanelData?.salesPerMeter,
                            unitsPerMeter: subcategory.dataPanelData?.unitsPerMeter,
                            shareOfSaleCurrency: subcategory.dataPanelData?.shareOfSaleCurrency,
                            shareOfSaleUnit: subcategory.dataPanelData?.shareOfSaleUnit,
                            shareOfSaleProfit: subcategory.dataPanelData?.shareOfSaleProfit,
                            // Keep legacy fields for fallback
                            actualShare: subcategory.allocatedShare || subcategory.dataPanelData?.actualSharePlanogram,
                            weightedShare: subcategory.weightedShare || subcategory.dataPanelData?.weightedSharePlanogram,
                        }
                    });

                    // Process suppliers
                    if (subcategory.suppliers) {
                        subcategory.suppliers.forEach(supplier => {
                            // Create supplier key as supplierId+subCategoryId combination for uniqueness
                            const supplierKey = `${supplier.supplierId}-${subcategory.subCategoryId}`;
                            supplierMap.set(supplierKey, {
                                ...supplier,
                                lambdaData: {
                                    // Supplier data mapping based on actual hierarchy structure
                                    actualShareSupplier: supplier.actualShareSupplier,
                                    allocatedShareSupplier: supplier.allocatedShareSupplier,
                                    weightedShareSupplier: supplier.weightedShareSupplier,
                                    avgPricePerProduct: supplier.avgPricePerProduct,
                                    salesUnits: supplier.salesUnits,
                                    salesCurrency: supplier.salesCurrency,
                                    profitCurrency: supplier.profitCurrency,
                                    profitabilityPercent: supplier.profitabilityPercent,
                                    dailySalesRateCurrency: supplier.dailySalesRateCurrency,
                                    dailySalesRateUnits: supplier.dailySalesRateUnits,
                                    // Hierarchical context for supplier level
                                    supplierName: supplier.supplierName,
                                    supplierId: supplier.supplierId,
                                    supplierCode: supplier.posCode,
                                    subcategoryName: subcategory.subcategoryName, // From parent subcategory
                                    subCategoryId: subcategory.subCategoryId,     // From parent subcategory
                                    subcategoryCode: subcategory.subcategoryCode, // From parent subcategory
                                    categoryName: category.categoryName,         // From grandparent category
                                    categoryId: category.categoryId,             // From grandparent category
                                    categoryCode: category.categoryCode,   // From grandparent category
                                    departmentId: hierarchy.departmentId,        // From root hierarchy
                                    barcodeCount: supplier.barcodeCount || supplier.dataPanelData?.barcodeCountAll
                                },
                                normalizedLambdaData: { ...(supplier.normalizedData || {}), ...(supplier.dataPanelData?.normalized || {}) },
                                dataPanelData: {
                                    ...supplier.dataPanelData,

                                    actualShareCategory: supplier.dataPanelData?.actualShareCategory,
                                    weightedShareCategory: supplier.dataPanelData?.weightedShareCategory,
                                    actualShareSubCategory: supplier.dataPanelData?.actualShareSubCategory || supplier.dataPanelData?.actualShareSubcategory,
                                    weightedShareSubCategory: supplier.dataPanelData?.weightedShareSubCategory || supplier.dataPanelData?.weightedShareSubcategory,
                                    actualSharePlanogram: supplier.dataPanelData?.actualSharePlanogram,
                                    weightedSharePlanogram: supplier.dataPanelData?.weightedSharePlanogram,

                                    totalAllocatedWidth: supplier.dataPanelData?.totalAllocatedWidth,
                                    shelfCapacity: supplier.dataPanelData?.shelfCapacity,
                                    salesPerFacing: supplier.dataPanelData?.salesPerFacing,
                                    totalFacing: supplier.dataPanelData?.totalFacing,
                                    unitsPerFacing: supplier.dataPanelData?.unitsPerFacing,
                                    salesPerMeter: supplier.dataPanelData?.salesPerMeter,
                                    unitsPerMeter: supplier.dataPanelData?.unitsPerMeter,
                                    shareOfSaleCurrency: supplier.dataPanelData?.shareOfSaleCurrency,
                                    shareOfSaleUnit: supplier.dataPanelData?.shareOfSaleUnit,
                                    shareOfSaleProfit: supplier.dataPanelData?.shareOfSaleProfit,
                                    // Keep legacy fields for fallback
                                    actualShare: supplier.allocatedShare || supplier.dataPanelData?.actualSharePlanogram,
                                    weightedShare: supplier.weightedShare || supplier.dataPanelData?.weightedSharePlanogram
                                }
                            });

                            // Process brands  
                            if (supplier.brands) {
                                supplier.brands.forEach(brand => {
                                    // Create brand key as brandId+subCategoryId combination for uniqueness
                                    const brandKey = `${brand.brandId}-${subcategory.subCategoryId}`;
                                    brandMap.set(brandKey, {
                                        ...brand,
                                        subcategoryName: subcategory.subcategoryName,
                                        lambdaData: {
                                            // Brand data mapping based on actual hierarchy structure
                                            actualShareBrand: brand.actualShareBrand,
                                            allocatedShareBrand: brand.allocatedShareBrand,
                                            weightedShareBrand: brand.weightedShareBrand,
                                            avgPricePerProduct: brand.avgPricePerProduct,
                                            salesUnits: brand.salesUnits,
                                            salesCurrency: brand.salesCurrency,
                                            profitCurrency: brand.profitCurrency,
                                            profitabilityPercent: brand.profitabilityPercent,
                                            dailySalesRateCurrency: brand.dailySalesRateCurrency,
                                            dailySalesRateUnits: brand.dailySalesRateUnits,
                                            // Hierarchical context for brand level
                                            brandName: brand.brandName,
                                            brandId: brand.brandId,
                                            brandCode: brand.posCode,
                                            supplierName: supplier.supplierName,         // From parent supplier
                                            supplierId: supplier.supplierId,             // From parent supplier
                                            supplierCode: supplier.posCode,   // From parent supplier
                                            subcategoryName: subcategory.subcategoryName, // From grandparent subcategory
                                            subCategoryId: subcategory.subCategoryId,     // From grandparent subcategory
                                            subcategoryCode: subcategory.subcategoryCode, // From grandparent subcategory
                                            categoryName: category.categoryName,         // From great-grandparent category
                                            categoryId: category.categoryId,             // From great-grandparent category
                                            categoryCode: category.categoryCode,   // From great-grandparent category
                                            departmentId: hierarchy.departmentId,         // From root hierarchy
                                            barcodeCount: brand.barcodeCount || brand.dataPanelData?.barcodeCountAll
                                        },
                                        normalizedLambdaData: { ...(brand.normalizedData || {}), ...(brand.dataPanelData?.normalized || {}) },
                                        dataPanelData: {
                                            ...brand.dataPanelData,

                                            actualShareCategory: brand.dataPanelData?.actualShareCategory,
                                            weightedShareCategory: brand.dataPanelData?.weightedShareCategory,
                                            actualShareSubCategory: brand.dataPanelData?.actualShareSubCategory || brand.dataPanelData?.actualShareSubcategory,
                                            weightedShareSubCategory: brand.dataPanelData?.weightedShareSubCategory || brand.dataPanelData?.weightedShareSubcategory,
                                            actualSharePlanogram: brand.dataPanelData?.actualSharePlanogram,
                                            weightedSharePlanogram: brand.dataPanelData?.weightedSharePlanogram,

                                            totalAllocatedWidth: brand.dataPanelData?.totalAllocatedWidth,
                                            shelfCapacity: brand.dataPanelData?.shelfCapacity,
                                            salesPerFacing: brand.dataPanelData?.salesPerFacing,
                                            totalFacing: brand.dataPanelData?.totalFacing,
                                            unitsPerFacing: brand.dataPanelData?.unitsPerFacing,
                                            salesPerMeter: brand.dataPanelData?.salesPerMeter,
                                            unitsPerMeter: brand.dataPanelData?.unitsPerMeter,
                                            shareOfSaleCurrency: brand.dataPanelData?.shareOfSaleCurrency,
                                            shareOfSaleUnit: brand.dataPanelData?.shareOfSaleUnit,
                                            shareOfSaleProfit: brand.dataPanelData?.shareOfSaleProfit,
                                            // Keep legacy fields for fallback
                                            actualShare: brand.allocatedShare || brand.dataPanelData?.actualSharePlanogram,
                                            weightedShare: brand.weightedShare || brand.dataPanelData?.weightedSharePlanogram
                                        }
                                    });
                                });
                            }
                        });
                    }
                });
            }
        });

        return {
            categories: categoryMap,
            subcategories: subcategoryMap,
            suppliers: supplierMap,
            brands: brandMap,
            // Add noproduct datasets that contain ALL hierarchy items from endpoint
            noproductCategories: [...categoryMap.values()],
            noproductSubcategories: [...subcategoryMap.values()],
            noproductSuppliers: [...supplierMap.values()],
            noproductBrands: [...brandMap.values()]
        };
    }

    // Enrich product with Lambda data based on barcode matching
    enrichWithLambdaData = (product) => {
        if (!this.state.lambdaProductsData || this.state.lambdaProductsData.length === 0) {
            return {}; // Return empty object if no Lambda data
        }
        
        // Find matching product in Lambda data by barcode
        const lambdaProduct = this.state.lambdaProductsData.find(lambdaProd => 
            lambdaProd.barcode === product.barcode
        );
        
        if (!lambdaProduct || !lambdaProduct.preplanData) {
            return {}; // Return empty object if no match found
        }
        
        // Return preplanData, normalizedData, and dataPanelData fields to be merged into the product
        return {
            lambdaData: lambdaProduct.preplanData, // Store preplanData under lambdaData key for easy access
            normalizedLambdaData: lambdaProduct.normalizedData, // Store normalizedData separately
            dataPanelData: lambdaProduct.dataPanelData // Store dataPanelData for additional fields
        };
    }

    // Get hierarchy data for different card types using pre-calculated Lambda hierarchy
    enrichWithAggregatedLambdaData = (sourceProduct, allProducts) => {        
        if (!this.state.hierarchyData) {
            return {}; // Return empty object if no hierarchy data
        }

        const { categories, subcategories, suppliers, brands } = this.state.hierarchyData;
        
        const brandId = sourceProduct?.productBrand?.brandId || sourceProduct?.brandId || sourceProduct?.brand?.brandId || sourceProduct?.brand?.brand?.brandId;
        const subCategoryId = sourceProduct?.subcategory?.sub_category?.subCategoryId || sourceProduct?.subCategoryId || sourceProduct?.subCat?.subCategoryid || sourceProduct?.subcategory?.subCategoryId || sourceProduct?.subCategory?.subCategoryId || sourceProduct?.subcategory?.id;
        const supplierId = sourceProduct?.supplier?.supplierId || sourceProduct?.productBrand?.supplier?.supplierId || sourceProduct?.brand?.brand?.supplier?.supplierId || sourceProduct?.supplierId || sourceProduct?.supplier?.id;
        const categoryId = sourceProduct?.categoryId || sourceProduct?.category?.categoryId || sourceProduct?.category?.id;
        

        // Create keys matching the ID-based hierarchy structure
        const brandKey = brandId && subCategoryId ? `${brandId}-${subCategoryId}` : null;
        const supplierKey = supplierId && subCategoryId ? `${supplierId}-${subCategoryId}` : null;
        const categoryKey = categoryId;
        const subCategoryKey = subCategoryId;

        // Get hierarchy data for each level (only if keys are valid)
        const brandHierarchyData = brandKey ? brands.get(brandKey) : null;
        const supplierHierarchyData = supplierKey ? suppliers.get(supplierKey) : null;
        const categoryHierarchyData = categoryKey ? categories.get(categoryKey) : null;
        const subCategoryHierarchyData = subCategoryKey ? subcategories.get(subCategoryKey) : null;
        

        return {
            // Individual product Lambda data (already exists from enrichWithLambdaData)
            lambdaData: sourceProduct.lambdaData,
            normalizedLambdaData: sourceProduct.normalizedLambdaData,
            dataPanelData: sourceProduct.dataPanelData,
            
            // Brand aggregated data from hierarchy
            brandLambdaData: brandHierarchyData?.lambdaData || {},
            brandNormalizedLambdaData: brandHierarchyData?.normalizedLambdaData || {},
            brandDataPanelData: brandHierarchyData?.dataPanelData || {},
            
            // Supplier aggregated data from hierarchy
            supplierLambdaData: supplierHierarchyData?.lambdaData || {},
            supplierNormalizedLambdaData: supplierHierarchyData?.normalizedLambdaData || {},
            supplierDataPanelData: supplierHierarchyData?.dataPanelData || {},
            
            // Category aggregated data from hierarchy
            categoryLambdaData: categoryHierarchyData?.lambdaData || {},
            categoryNormalizedLambdaData: categoryHierarchyData?.normalizedLambdaData || {},
            categoryDataPanelData: categoryHierarchyData?.dataPanelData || {},
            
            // Sub-category aggregated data from hierarchy
            subCategoryLambdaData: subCategoryHierarchyData?.lambdaData || {},
            subCategoryNormalizedLambdaData: subCategoryHierarchyData?.normalizedLambdaData || {},
            subCategoryDataPanelData: subCategoryHierarchyData?.dataPanelData || {}
        };
    }

     //update nonsim prods remove and add
    nonSimProddropremoveCounterupdate = async () => {

        // Call processLambdaDataPanelResult to refresh Lambda data with current simulation state
        // await this.processLambdaDataPanelResult(true);

        // let actualFieldStructures = this.props.actualFieldStructures;
        // let productsToUpdate = this.state.mapproductList
        // let pegProductsToUpdate = this.state.mapproductList.filter(prod => prod?.isHanged === true);
        // let pegBoardsToUpdate = this.state.pegList;
        // let updatedData = await this.fetchUpdatedCategoryData(productsToUpdate, actualFieldStructures, pegProductsToUpdate, pegBoardsToUpdate);
        // Clone product lists
        var nonesimProds = JSON.parse(JSON.stringify(this.state.nonfilteredNonEProducts));
        var cprodlist = JSON.parse(JSON.stringify(this.state.mapproductList));
        var updatedDataPanelList = JSON.parse(JSON.stringify(this.state.originalDataPanelList)); // Clone the data panel list

        // Iterate over all products in the data panel
        for (let index = 0; index < updatedDataPanelList.length; index++) {
            const product = updatedDataPanelList[index];

            // Count instances of the product in the drawing
            var productCount = cprodlist.filter(a => a.isDelete !== true && a.barcode === product.barcode).length;

            // Update the "Now" value for simulated products
            updatedDataPanelList[index].now = productCount;

            // For non-simulated products, move to simulated if count > 0
            if (product.category === 'non-simulated' && productCount > 0) {
                updatedDataPanelList[index].category = 'simulated';
            }

            // If the product count drops to zero, reset its category to 'non-simulated'
            if (productCount === 0 && product.category === 'simulated') {
                updatedDataPanelList[index].category = 'non-simulated';
                if (!updatedDataPanelList[index].notSimulatedReason) {
                    updatedDataPanelList[index].notSimulatedReason = notSimulatedReason.none;
                }
            }

            // if (updatedData) {
            //     // Update subCategories and brands based on response
            //
            //     updatedDataPanelList.forEach((product, index) => {
            //         const brand = updatedData.brands.find(b => b.brandId === product.brand.brandid && b.subCategoryId === product.subCat.subCategoryid);
            //         const subCat = updatedData.subCategories.find(sc => sc.subCategoryId === product.subCat.subCategoryid);
            //         const cat = updatedData.categories.find(c => c.categoryId === product.categoryId);
            //         const supplier = updatedData.suppliers.find(s => s.supplierId === product.supplierId);
            //
            //         updatedDataPanelList[index].brandNow = brand ? brand.brandNow : 0;
            //         updatedDataPanelList[index].subCatNow = subCat ? subCat.subCategoryNow : 0;
            //         updatedDataPanelList[index].categoryNow = cat ? cat.categoryNow : 0;
            //         updatedDataPanelList[index].supplierNow = supplier ? supplier.supplierNow : 0;
            //     });
            // }
        }

        // Rebuild non-simulated products list from the updated data panel to reflect
        // products that transitioned to non-simulated (e.g., deleted from simulation)
        // Merge with previous list to avoid resetting to only the latest deleted item
        const prevNonSimByBarcode = nonesimProds.reduce((acc, p) => {
            if (p && p.barcode) acc[String(p.barcode)] = p;
            return acc;
        }, {});

        const nowCountByBarcode = updatedDataPanelList.reduce((acc, p) => {
            if (p && p.barcode) acc[String(p.barcode)] = (p.now || 0);
            return acc;
        }, {});

        const dpNowZeroProducts = updatedDataPanelList.filter(dpProd => dpProd && (dpProd.now || 0) === 0);

        // Separate newly deleted (not previously in non-sim list) vs existing non-sim
        const newlyDeleted = dpNowZeroProducts.filter(p => !prevNonSimByBarcode[String(p?.barcode || '')]);
        const alreadyNonSim = dpNowZeroProducts.filter(p => prevNonSimByBarcode[String(p?.barcode || '')]);

        const mapDPToNonSim = (dpProd) => {
            const key = String(dpProd.barcode || '');
            const prev = prevNonSimByBarcode[key] || {};
            const productExistInDrawing = cprodlist.some(a => a.isDelete !== true && a.barcode === dpProd.barcode);
            return {
                ...prev,
                ...dpProd,
                productName: dpProd.productName || dpProd.name || prev.productName || '',
                isFilterd: false,
                isAdded: productExistInDrawing,
                // isDelete: !productExistInDrawing, 
                // isDeletedSimProdForDataPanel: !productExistInDrawing, 
                // isProductDelete: !productExistInDrawing,
                notSimulatedReason: prev.notSimulatedReason !== undefined ? prev.notSimulatedReason : (productExistInDrawing ? prev.notSimulatedReason : notSimulatedReason.none)
            };
        };

        const mergedNewlyDeleted = newlyDeleted.map(mapDPToNonSim);
        const mergedExistingNonSim = alreadyNonSim.map(mapDPToNonSim);

        const keptExisting = nonesimProds.filter(p => {
            const key = String(p?.barcode || '');
            const nowVal = nowCountByBarcode.hasOwnProperty(key) ? nowCountByBarcode[key] : undefined;
            return nowVal === undefined || nowVal === 0;
        });

        // Combine with order: newly deleted first, then existing updated, then previously kept
        const rebuiltNonSimProds = [...mergedNewlyDeleted, ...mergedExistingNonSim, ...keptExisting].reduce((acc, prod) => {
            if (!prod || !prod.barcode) return acc;
            const key = String(prod.barcode);
            if (!acc.find(p => String(p.barcode) === key)) acc.push(prod);
            return acc;
        }, []);

        //update data panel product list after adding hangable filter & adding peg product
        const filterdDataPanelList = updatedDataPanelList.filter(product => {
            if(this.state.is_hangable === true){
                return product?.isHangable === true;
            }
            if(this.state.is_hangable === false){
                return product?.isHangable === false;
            }
            return product;
        });

        // Set updated state
        this.setState({
            nonfilteredNonEProducts: rebuiltNonSimProds,
            originalDataPanelList: updatedDataPanelList,
            filteredList: filterdDataPanelList,
            isNonSimulatedDataReady: true,
        }, () => {
            this.updateNonSimProductsCount();

            // Reapply the filter after updating the state
            if (this.state.currentBrandFilter !== undefined && this.state.currentFilterType !== undefined) {
                this.handleBrandFilterChange(this.state.currentBrandFilter, this.state.currentFilterType);
            }
        });
    };


    //#MP-SML-E-BCU2
    dropCutblock=(e, shelfObj, shelfRef, shelfIdx, cutobj, cutidx, fieldobj) => {
        let viewboxcoords = this.xyChangeCoords(e);
        // console.log(viewboxcoords);

        var xa = viewboxcoords.x;
        var draggingProduct = this.state.currentDraggableProd; //get current dragging product
        let droppingShelfList = this.state.droppingShelfList;

        draggingProduct.drawHeight = draggingProduct.height;
        draggingProduct.drawWidth = draggingProduct.width;

        //check dragging product available and allowed to add
        if (droppingShelfList && draggingProduct && draggingProduct != null) { // && allowToAdd
            this.setState({ isviewcmenu: false, isviewcmenu2: false });

            let noShelfAvailable = false;
            let notAllowBottom = false;

            let isruleupdating = false;
            let cutshelfs = {groupUUID: uuidv4(), isNew:true, isDelete: false, mode:"cut" , uom: this.state.displayUOM, shelf: []};
            let cProdList = structuredClone(this.state.mapproductList);

            var  filterddraggingProductshelfs = draggingProduct.shelf.filter(q=>q.isDelete!==true)

            for (let l = 0; l < filterddraggingProductshelfs.length; l++) {
                const cutShelfObj = filterddraggingProductshelfs[l];

                let dropshelf = droppingShelfList[l];
                if(dropshelf){
                    let selectedDropShelf = fieldobj.shelf.find(findshelf => findshelf.rank === dropshelf.rank);
                    cutshelfs.uom = selectedDropShelf.uom;

                    //temp set draw width/height
                    cutShelfObj["drawWidth"] = cutShelfObj.width;
                    cutShelfObj["drawHeight"] = cutShelfObj.height;

                    //set product y position
                    var newy = (selectedDropShelf.y + selectedDropShelf.drawHeight) - (cutShelfObj.drawHeight + this.state.checkSaftyMargin); //get bottom y point

                    cutShelfObj["x"] = xa;
                    cutShelfObj["y"] = newy;

                    //find is product can added to bottom of shelve
                    var allowToAddBottom = checkAllowToAdd(e, selectedDropShelf, cutShelfObj, xa, newy, this.state.checkSaftyMargin);
                    // console.log(allowToAddBottom);

                    //if cannot add to shelf and is inside shelf and overlapping from right side
                    let checkshelfy2 = (selectedDropShelf.y + selectedDropShelf.drawHeight + selectedDropShelf.drawGap);
                    let checkshelfx2 = (selectedDropShelf.x + selectedDropShelf.drawWidth);
                    if(!allowToAddBottom.allowToAdd && selectedDropShelf.y <= newy && (newy + cutShelfObj.drawHeight) <= checkshelfy2 && xa < checkshelfx2 && (xa + draggingProduct.drawWidth) > checkshelfx2){
                        allowToAddBottom = { allowToAdd: true, shelfAllow: true };
                        xa = (checkshelfx2 - cutShelfObj.drawWidth);
                    }
                    //finddragging draging box drop to which box
                    let movingObj = structuredClone(cutShelfObj);

                    var containElem = elmAccordingtoXY(xa,newy,movingObj.drawWidth,movingObj.drawHeight,this.state.mapFields,this.state.mapCatRects)

                    //end
                    //if product can add to bottom of shelve
                    if(allowToAddBottom.allowToAdd) {
                        this.TouchedCatListUpdate(containElem.catrect.catrectId)
                        this.fieldHistoryAdd(structuredClone(this.state.mapproductList),1);

                        let stratXpoint = 0;
                        let lowestprodx = xa;

                        //find product is overlapping other product
                        let boxx1 = roundOffDecimal(lowestprodx,2);
                        let boxy1 = roundOffDecimal(newy,2);
                        let boxx2 = roundOffDecimal((lowestprodx + cutShelfObj.width),2);
                        let boxy2 = roundOffDecimal((newy + cutShelfObj.height),2);

                        //find remove drop items from list
                        var containProds = GetContainingProdsByBox(boxx1, boxy1, boxx2, boxy2, cProdList, fieldobj);
                        // console.log("loc 1",boxx1, boxy1, boxx2, boxy2, cProdList, fieldobj)

                        let droppingXProd = null; //to find prod available in dropping x1 positionj 
                        if(containProds.selectedProds && containProds.selectedProds.length > 0){
                            let notDeletedContainProds = containProds.selectedProds.filter(f => !f.isDelete);

                            for (let j = 0; j < notDeletedContainProds.length; j++) {
                                const selcutitem = notDeletedContainProds[j];

                                var ishaveinSlectedshleves = cutShelfObj.products.find(x=>x.id === selcutitem.id)
                                //check save moving produtcs not cutting
                                if(ishaveinSlectedshleves === undefined){
                                    let prodstartx = (selcutitem.x);
                                    let checkprodwidth = (((selcutitem.drawWidth / 3) > 8)?(selcutitem.drawWidth / 3):(selcutitem.drawWidth / 2));
                                    let prodmiddlex = (selcutitem.x + checkprodwidth);

                                    if(lowestprodx > prodstartx && lowestprodx < prodmiddlex){
                                        lowestprodx = selcutitem.x;
                                    }

                                    if(selcutitem.x <= xa && xa <= roundOffDecimal((selcutitem.x + selcutitem.drawWidth),2)){
                                        droppingXProd = selcutitem;
                                      }

                                }
                            }
                        }

                        if(!droppingXProd){
                            lowestprodx = getSnappingLocation(xa, fieldobj, cProdList, cutShelfObj, [selectedDropShelf]);
                            // console.log(xa,lowestprodx);
                        }

                        var maxEndX = 0;
                        stratXpoint = lowestprodx;

                        for (let j = 0; j < cutShelfObj.products.length; j++) {
                            const cutprod = cutShelfObj.products[j];
                            var cisStackable=false
                            for (let k = 0; k < this.state.mapproductList.length; k++) {
                                const oprod = this.state.mapproductList[k];
                                if(oprod.productId===cutprod.productId){
                                    cisStackable=oprod.isStackable
                                    break
                                }else{
                                    if(k===this.state.mapproductList.length){
                                        cisStackable=cutprod.isStackable
                                    }
                                }

                            }
                            cutprod.id = uuidv4();
                            cutprod.x = stratXpoint;
                            cutprod.y = ((selectedDropShelf.y + selectedDropShelf.drawHeight) - cutprod.drawHeight);
                            cutprod.uuid = uuidv4();
                            cutprod.shelfrank = selectedDropShelf.rank;
                            cutprod.field_custom_id = fieldobj.field_custom_id;
                            cutprod.categoryRectId=  containElem.catrect.catrectId;
                            cutprod.isNew = true;
                            cutprod.isDelete = cutprod.isDelete?cutprod.isDelete:false;
                            // cutprod.isDelete = false;
                            cutprod.isStackable =cisStackable

                            stratXpoint = stratXpoint + cutprod.drawWidth;

                            let curprodendx = (cutprod.x + cutprod.drawWidth);
                            if(curprodendx > maxEndX){
                                maxEndX = curprodendx
                            }

                            if(cutprod.subcategory && cutprod.subcategory.type === catRectEnums.rule){
                                isruleupdating = true;
                            }
                        }

                        //remove drop items from list
                        let newMOEndX     = roundOffDecimal((stratXpoint - this.state.checkSaftyMargin),2);
                        var ccontainProds = GetContainingProdsByBox(boxx1, boxy1, newMOEndX, boxy2, this.state.mapproductList, fieldobj);
                        // console.log("loc 2",boxx1, boxy1, newMOEndX, boxy2, this.state.mapproductList, fieldobj)

                        if(ccontainProds.selectedProds && ccontainProds.selectedProds.length > 0){
                            let notDeletedContainProds = ccontainProds.selectedProds.filter(f => !f.isDelete && f.shelfrank === selectedDropShelf.rank);
                            for (let j = 0; j < notDeletedContainProds.length; j++) {
                                const selcutitem = notDeletedContainProds[j];

                                let findshelfitemidx = cutshelfs.shelf.findIndex(x => x.rank === selcutitem.shelfrank);
                                if(findshelfitemidx > -1){
                                    cutshelfs.shelf[findshelfitemidx].products.push(selcutitem);
                                } else{
                                    cutshelfs.shelf.push({ rank: selcutitem.shelfrank, products: [selcutitem] });
                                }
                                // console.log('selcutitem.prodidx====>', selcutitem.prodidx);
                                cProdList[selcutitem.prodidx]["isDelete"] = true;

                                if(cProdList[selcutitem.prodidx].subcategory && cProdList[selcutitem.prodidx].subcategory.type === catRectEnums.rule){
                                    isruleupdating = true;
                                }
                            }
                        }
                        var filteredporducts=cutShelfObj.products.filter(x=>x.isDelete!==true)
                        cProdList.push(...filteredporducts);
                        // cProdList.push(...cutShelfObj.products);

                    } else {
                        notAllowBottom = true;
                    }
                } else{
                    noShelfAvailable = true;
                }

            }

            if(noShelfAvailable){
                alertService.warn(this.props.t("DROP_SHELF_NOT_AVAILABLE"));
            } else{
                if(notAllowBottom){
                    alertService.warn(this.props.t("CANNOT_ADD_TO_BOTTOM"));
                } else{
                    var newCutarray = this.state.cutArray;

                    //uncomment this to multiple clip board remove after drop
                    // newCutarray.splice(cutidx,1)
                    //end on comment
                    // console.log(newCutarray);
                    this.setState({
                        mapproductList: cProdList,
                        cutArray: newCutarray,
                        currentSelectedBlock: null, currentInternalDraggableProd: null
                    }, () => {
                        // console.log(this.state.cutArray);
                        if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                            // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                            const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                            this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
                        }

                        //reload imported product update
                        this.compareImportedProds();

                        //update cut products when clipDragType equal to SINGLE or MULTIPLE
                        if(this.state.clipDragType==="SINGLE"){
                            this.updateSingleCutProduct(draggingProduct, false, cutidx, draggingProduct.groupUUID);
                        }else{
                            this.updateSingleCutProduct(null, true, cutidx, draggingProduct.groupUUID);
                        }
                        if(cutshelfs.shelf.length > 0){
                            this.updateCutList(cutshelfs);
                        }

                        //check non sim render count and display mange
                        this.nonSimProddropremoveCounterupdate("cutdropBlock");

                        //update rule list if item sub cat is rule
                        if(isruleupdating){
                            let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, false);
                            // console.log(updaterulelist);

                            this.setState({
                                mapRulesList: updaterulelist.rulelist,
                                isRuleWarn: updaterulelist.iswarn
                            });
                        }
                    });
                }
            }

            //end drop
            if(shelfRef){
                shelfRef.style.fill = 'transparent';
            }
            setTimeout(() => {
                this.setPreviewGuid(true);
            }, 500);
        }
    }

    // NEW CR - 2025 Jan 21
    dropCutblockV2=(e, shelfObj, shelfRef, shelfIdx, cutobj, cutidx, fieldobj) => {
        let viewboxcoords = this.xyChangeCoords(e);

        var xa = viewboxcoords.x;
        var draggingProduct = this.state.currentDraggableProd; //get current dragging product
        let droppingShelfList = this.state.droppingShelfList;

        draggingProduct.drawHeight = draggingProduct.height;
        draggingProduct.drawWidth = draggingProduct.width;

        //check dragging product available and allowed to add
        if (droppingShelfList && draggingProduct && draggingProduct != null) { // && allowToAdd
            this.setState({ isviewcmenu: false, isviewcmenu2: false });

            let noShelfAvailable = false;
            let notAllowBottom = false;
            let isruleupdating = false;
            let cutshelfs = {
                groupUUID: uuidv4(), 
                isNew:true, 
                isDelete: false, 
                mode:"cut" , 
                uom: this.state.displayUOM, 
                shelf: []
            };
            let cProdList = structuredClone(this.state.mapproductList);

            var  filterddraggingProductshelfs = draggingProduct.shelf.filter(q=>q.isDelete!==true)

            // handle if more than 1 shelf product block dropping
            if(draggingProduct?.shelf.length > 1){
                for (let l = 0; l < filterddraggingProductshelfs.length; l++) {
                    const cutShelfObj = filterddraggingProductshelfs[l];

                    let dropshelf = droppingShelfList[l];
                    if(dropshelf){
                        let selectedDropShelf = fieldobj.shelf.find(findshelf => findshelf.rank === dropshelf.rank);
                        cutshelfs.uom = selectedDropShelf.uom;

                        //temp set draw width/height
                        cutShelfObj["drawWidth"] = cutShelfObj.width;
                        cutShelfObj["drawHeight"] = cutShelfObj.height;

                        //set product y position
                        var newy = (selectedDropShelf.y + selectedDropShelf.drawHeight) - (cutShelfObj.drawHeight + this.state.checkSaftyMargin); //get bottom y point

                        cutShelfObj["x"] = xa;
                        cutShelfObj["y"] = newy;

                        /**OLD METHOD FOR CHECKING  ******PRODUCT CAN ADD BOTTOM OF SHELF****** */
                        //find is product can added to bottom of shelve
                        //var allowToAddBottom = checkAllowToAddForExpandNumber(e, selectedDropShelf, cutShelfObj, xa, newy, this.state.checkSaftyMargin);

                        //if cannot add to shelf and is inside shelf and overlapping from right side
                        let checkshelfy2 = (selectedDropShelf.y + selectedDropShelf.drawHeight + selectedDropShelf.drawGap);
                        let checkshelfx2 = (selectedDropShelf.x + selectedDropShelf.drawWidth);
                        /**OLD METHOD FOR CHECKING  ******PRODUCT CAN ADD BOTTOM OF SHELF****** 
                        if(!allowToAddBottom.allowToAdd && selectedDropShelf.y <= newy && (newy + cutShelfObj.drawHeight) <= checkshelfy2 && xa < checkshelfx2 && (xa + draggingProduct.drawWidth) > checkshelfx2){
                           allowToAddBottom = { allowToAdd: true, shelfAllow: true };
                           xa = (checkshelfx2 - cutShelfObj.drawWidth);
                        }
                        */
                        // if(selectedDropShelf.y <= newy && (newy + cutShelfObj.drawHeight) <= checkshelfy2 && xa < checkshelfx2 && (xa + draggingProduct.drawWidth) > checkshelfx2){
                        //     xa = (checkshelfx2 - cutShelfObj.drawWidth);
                        // }

                        //finddragging draging box drop to which box
                        let movingObj = structuredClone(cutShelfObj);

                        var containElem = elmAccordingtoXY(xa,newy,movingObj.drawWidth,movingObj.drawHeight,this.state.mapFields,this.state.mapCatRects)

                        //if product can add to bottom of shelve
                        //if(allowToAddBottom.allowToAdd) {
                            this.TouchedCatListUpdate(containElem?.catrect?.catrectId)
                            this.fieldHistoryAdd(structuredClone(this.state.mapproductList),1);

                            let stratXpoint = 0;
                            let lowestprodx = xa;

                            //find product is overlapping other product
                            let boxx1 = roundOffDecimal(lowestprodx,2);
                            let boxy1 = roundOffDecimal(newy,2);
                            let boxx2 = roundOffDecimal((lowestprodx + cutShelfObj.width),2);
                            let boxy2 = roundOffDecimal((newy + cutShelfObj.height),2);

                            //find remove drop items from list
                            var containProds = GetContainingProdsByBox(boxx1, boxy1, boxx2, boxy2, cProdList, fieldobj);

                            let droppingXProd = null; //to find prod available in dropping x1 positionj 
                            if(containProds.selectedProds && containProds.selectedProds.length > 0){
                                let notDeletedContainProds = containProds.selectedProds.filter(f => !f.isDelete);

                                for (let j = 0; j < notDeletedContainProds.length; j++) {
                                    const selcutitem = notDeletedContainProds[j];

                                    var ishaveinSlectedshleves = cutShelfObj.products.find(x=>x.id === selcutitem.id)
                                    //check save moving produtcs not cutting
                                    if(ishaveinSlectedshleves === undefined){
                                        let prodstartx = (selcutitem.x);
                                        let checkprodwidth = (((selcutitem.drawWidth / 3) > 8)?(selcutitem.drawWidth / 3):(selcutitem.drawWidth / 2));
                                        let prodmiddlex = (selcutitem.x + checkprodwidth);

                                        // if(lowestprodx > prodstartx && lowestprodx < prodmiddlex){
                                        //     lowestprodx = selcutitem.x;
                                        // }

                                        if(selcutitem.x <= xa && xa <= roundOffDecimal((selcutitem.x + selcutitem.drawWidth),2)){
                                            droppingXProd = selcutitem;
                                          }

                                    }
                                }
                            }

                            // if(!droppingXProd){
                            //     lowestprodx = getSnappingLocation(xa, fieldobj, cProdList, cutShelfObj, [selectedDropShelf]);
                            // }

                            var maxEndX = 0;
                            stratXpoint = lowestprodx;

                            for (let j = 0; j < cutShelfObj.products.length; j++) {
                                const cutprod = cutShelfObj.products[j];
                                var cisStackable=false
                                for (let k = 0; k < this.state.mapproductList.length; k++) {
                                    const oprod = this.state.mapproductList[k];
                                    if(oprod.productId===cutprod.productId){
                                        cisStackable=oprod.isStackable
                                        break
                                    }else{
                                        if(k===this.state.mapproductList.length){
                                            cisStackable=cutprod.isStackable
                                        }
                                    }

                                }
                                cutprod.id = uuidv4();
                                cutprod.x = stratXpoint;
                                cutprod.y = ((selectedDropShelf.y + selectedDropShelf.drawHeight) - cutprod.drawHeight);

                                // Calculate the starting point
                                let prodfield = this.state.mapFields[cutprod?.field_custom_id];
                                let prodstartpoint = ((cutprod.x - prodfield.x) / this.state.displayRatio);
                                const match = prodstartpoint.toString().match(/^-?\d+\.\d{0,9}/);
                                prodstartpoint = match ? match[0] : prodstartpoint.toString();

                                cutprod.startingPoint = prodstartpoint;
                                cutprod.uuid = uuidv4();
                                cutprod.shelfrank = selectedDropShelf.rank;
                                cutprod.field_custom_id = fieldobj.field_custom_id;
                                cutprod.categoryRectId=  containElem.catrect.catrectId;
                                cutprod.isNew = true;
                                cutprod.isHanged = false;
                                cutprod.isDelete = cutprod.isDelete?cutprod.isDelete:false;
                                // cutprod.isDelete = false;
                                cutprod.isStackable =cisStackable

                                stratXpoint = stratXpoint + cutprod.drawWidth;

                                let curprodendx = (cutprod.x + cutprod.drawWidth);
                                if(curprodendx > maxEndX){
                                    maxEndX = curprodendx
                                }

                                if(cutprod.subcategory && cutprod.subcategory.type === catRectEnums.rule){
                                    isruleupdating = true;
                                }
                            }

                            //remove drop items from list
                            let newMOEndX     = roundOffDecimal((stratXpoint - this.state.checkSaftyMargin),2);
                            var ccontainProds = GetContainingProdsByBox(boxx1, boxy1, newMOEndX, boxy2, this.state.mapproductList, fieldobj);

                            // console.log("loc 2",boxx1, boxy1, newMOEndX, boxy2, this.state.mapproductList, fieldobj)
                            if(ccontainProds.selectedProds && ccontainProds.selectedProds.length > 0){
                                let notDeletedContainProds = ccontainProds.selectedProds.filter(f => !f.isDelete && f.shelfrank === selectedDropShelf.rank);
                                for (let j = 0; j < notDeletedContainProds.length; j++) {
                                    const selcutitem = notDeletedContainProds[j];

                                    let findshelfitemidx = cutshelfs.shelf.findIndex(x => x.rank === selcutitem.shelfrank);
                                    if(findshelfitemidx > -1){
                                        cutshelfs.shelf[findshelfitemidx].products.push(selcutitem);
                                    } else{
                                        cutshelfs.shelf.push({
                                            shelfrank : selcutitem.shelfrank, 
                                            rank: selcutitem.shelfrank, 
                                            products: [selcutitem]
                                        });
                                    }
                                    cProdList[selcutitem.prodidx]["isDelete"] = true;

                                    if(cProdList[selcutitem.prodidx].subcategory && cProdList[selcutitem.prodidx].subcategory.type === catRectEnums.rule){
                                        isruleupdating = true;
                                    }
                                }
                            }
                            // Check dropped product place in the field
                            let shelfX1 = selectedDropShelf.x;
                            let shelfX2 = selectedDropShelf.x + selectedDropShelf.drawWidth;
                            let shelfY1 = selectedDropShelf.y;
                            let shelfY2 = selectedDropShelf.y + selectedDropShelf.drawHeight + selectedDropShelf.drawGap;
                            var filteredporducts = cutShelfObj.products.filter(x => {
                                if(x.isDelete === true) return false;
                                let prodX1 = x.x;
                                let prodX2 = x.x + x.drawWidth;
                                let prodY1 = x.y;
                                let prodY2 = x.y + x.drawHeight;
                                let isWithinShelf = prodX1 >= shelfX1 && prodX2 <= shelfX2 && prodY1 >= shelfY1 && prodY2 <= shelfY2;
                                return isWithinShelf;
                            });
                            cProdList.push(...filteredporducts);
                            // cProdList.push(...cutShelfObj.products);
                        //} else {
                        //    notAllowBottom = true;
                        //}
                    } else{
                        noShelfAvailable = true;
                    }

                }
            }
            // handle if 1 shelf produts block dropping
            if(draggingProduct?.shelf.length === 1){
                let draggingProductSet = JSON.parse(JSON.stringify(this.state.currentDraggableProd)); 
                // get similer shelf from selected shelf y+drawheight
                let similarLevelShelves = this.getSimilarLevelShelves(shelfObj, this.state.mapFields);
                let selectedShelfSet = [];
                // selectedShelfSet.push(shelfObj);
                selectedShelfSet = selectedShelfSet.concat(similarLevelShelves);
                
                let productList = JSON.parse(JSON.stringify(this.state.mapproductList));

                // assume only 1 shelf product dragged
                draggingProductSet = draggingProductSet?.shelf[0]?.products;
                draggingProductSet = this.verifyAndCorrectProductPositions(draggingProductSet);

                let exisitingProductList = this.getSelectedProducts(productList, selectedShelfSet, draggingProductSet, true);

                // get exiting product total width
                let totalProductWidth = 0;
                exisitingProductList.forEach(product => {
                    totalProductWidth += product?.drawWidth;
                });
                
                // get total width of selected shelf
                let totalShelfWidth = 0;
                selectedShelfSet.forEach(shelf => {
                    totalShelfWidth += shelf?.drawWidth;
                });
                let restSpace = totalShelfWidth - totalProductWidth;
                // get moving product block width

                let movingProductBlockWidth = 0;
                // let movingProductBlockWidth = draggingProductSet?.drawWidth;
                for (let i = 0; i < draggingProductSet.length; i++) {
                    movingProductBlockWidth += draggingProductSet[i].drawWidth;
                }
                let droppedFiledCustomId = fieldobj.field_custom_id;
                let droppedFieldMasterFieldId = fieldobj.masterFieldId;

                const roundedRestSpace = Number(restSpace.toFixed(2));
                const roundedMovingProductBlockWidth = Number(movingProductBlockWidth.toFixed(2));

                const isAllowToDrop = roundedRestSpace >= roundedMovingProductBlockWidth;

                if(!isAllowToDrop){
                    alertService.error(this?.props?.t('NO_SPACE_AVALIBLE_FOR_DROPPED_PRODUCT_SET'),4000);
                    this.setPreviewGuid(true, null, null, true, []);
                    clearTimeout(this._guideTimeout); 
                    return
                }
                this.fieldHistoryAdd(structuredClone(this.state.mapproductList),1);

                let reArrangeProducts = JSON.parse(JSON.stringify(this.state.mapproductList));

                // filter isDeletedProduct set
                let deleteProductSet = reArrangeProducts.filter(product => product.isDelete === true);

                const {needToReArrange, updatedProducts} = this.filterInlineShelfProductSet(xa, newy, selectedShelfSet, reArrangeProducts, draggingProductSet, draggingProduct, this.state.checkSaftyMargin, droppedFiledCustomId, droppedFieldMasterFieldId, true);

                if(needToReArrange){
                    const updatingProductIds = new Set(updatedProducts.map(product => product.id));
                    const filteredUpdatedProducts = reArrangeProducts.filter(
                        product => !updatingProductIds.has(product.id)
                    ); 
    
                    reArrangeProducts = [...filteredUpdatedProducts, ...updatedProducts, ...deleteProductSet];

                    // remove duplicate products
                    reArrangeProducts = reArrangeProducts.filter(
                        (product, index, self) => 
                            index === self.findIndex(p => p.id === product.id)
                    );

                    cProdList = reArrangeProducts;
                }else{
                    // handle one shelf products move to fileds with not overlapping scenario
                    for (let l = 0; l < filterddraggingProductshelfs.length; l++) {
                        const cutShelfObj = filterddraggingProductshelfs[l];
    
                        let dropshelf = droppingShelfList[l];
                        if(dropshelf){
                            let selectedDropShelf = fieldobj.shelf.find(findshelf => findshelf.rank === dropshelf.rank);
                            cutshelfs.uom = selectedDropShelf.uom;
    
                            //temp set draw width/height
                            cutShelfObj["drawWidth"] = cutShelfObj.width;
                            cutShelfObj["drawHeight"] = cutShelfObj.height;
    
                            //set product y position
                            var newy = (selectedDropShelf.y + selectedDropShelf.drawHeight) - (cutShelfObj.drawHeight + this.state.checkSaftyMargin); //get bottom y point
    
                            cutShelfObj["x"] = xa;
                            cutShelfObj["y"] = newy;
    
                            //find is product can added to bottom of shelve
                            //var allowToAddBottom = checkAllowToAdd(e, selectedDropShelf, cutShelfObj, xa, newy, this.state.checkSaftyMargin);
    
                            //if cannot add to shelf and is inside shelf and overlapping from right side
                            let checkshelfy2 = (selectedDropShelf.y + selectedDropShelf.drawHeight + selectedDropShelf.drawGap);
                            let checkshelfx2 = (selectedDropShelf.x + selectedDropShelf.drawWidth);
                            //old condition check**********
                            // if(!allowToAddBottom.allowToAdd && selectedDropShelf.y <= newy && (newy + cutShelfObj.drawHeight) <= checkshelfy2 && xa < checkshelfx2 && (xa + draggingProduct.drawWidth) > checkshelfx2){
                            //     allowToAddBottom = { allowToAdd: true, shelfAllow: true };
                            //     xa = (checkshelfx2 - cutShelfObj.drawWidth);
                            //}
                            // if(selectedDropShelf.y <= newy && (newy + cutShelfObj.drawHeight) <= checkshelfy2 && xa < checkshelfx2 && (xa + draggingProduct.drawWidth) > checkshelfx2){
                            //     xa = (checkshelfx2 - cutShelfObj.drawWidth);
                            // }
                            //finddragging draging box drop to which box
                            let movingObj = structuredClone(cutShelfObj);

                            var containElem = elmAccordingtoXY(xa,newy,movingObj.drawWidth,movingObj.drawHeight,this.state.mapFields,this.state.mapCatRects)
                            //if product can add to bottom of shelve
                            //if(allowToAddBottom.allowToAdd) {
                                this.TouchedCatListUpdate(containElem?.catrect?.catrectId)
                                this.fieldHistoryAdd(structuredClone(this.state.mapproductList),1);
    
                                let stratXpoint = 0;
                                let lowestprodx = xa;

                                //find product is overlapping other product
                                let boxx1 = roundOffDecimal(lowestprodx,2);
                                let boxy1 = roundOffDecimal(newy,2);
                                let boxx2 = roundOffDecimal((lowestprodx + cutShelfObj.width),2);
                                let boxy2 = roundOffDecimal((newy + cutShelfObj.height),2);
    
                                //find remove drop items from list
                                var containProds = GetContainingProdsByBox(boxx1, boxy1, boxx2, boxy2, cProdList, fieldobj);
    
                                let droppingXProd = null; //to find prod available in dropping x1 positionj 
                                if(containProds.selectedProds && containProds.selectedProds.length > 0){
                                    let notDeletedContainProds = containProds.selectedProds.filter(f => !f.isDelete);
    
                                    for (let j = 0; j < notDeletedContainProds.length; j++) {
                                        const selcutitem = notDeletedContainProds[j];
    
                                        var ishaveinSlectedshleves = cutShelfObj.products.find(x=>x.id === selcutitem.id)
                                        //check save moving produtcs not cutting
                                        if(ishaveinSlectedshleves === undefined){
                                            let prodstartx = (selcutitem.x);
                                            let checkprodwidth = (((selcutitem.drawWidth / 3) > 8)?(selcutitem.drawWidth / 3):(selcutitem.drawWidth / 2));
                                            let prodmiddlex = (selcutitem.x + checkprodwidth);
    
                                            // if(lowestprodx > prodstartx && lowestprodx < prodmiddlex){
                                            //     lowestprodx = selcutitem.x;
                                            // }
    
                                            if(selcutitem.x <= xa && xa <= roundOffDecimal((selcutitem.x + selcutitem.drawWidth),2)){
                                                droppingXProd = selcutitem;
                                              }
    
                                        }
                                    }
                                }
    
                                // if(!droppingXProd){
                                //     lowestprodx = getSnappingLocation(xa, fieldobj, cProdList, cutShelfObj, [selectedDropShelf]);
                                // }
    
                                var maxEndX = 0;
                                stratXpoint = lowestprodx;
    
                                for (let j = 0; j < cutShelfObj.products.length; j++) {
                                    const cutprod = cutShelfObj.products[j];
                                    var cisStackable=false
                                    for (let k = 0; k < this.state.mapproductList.length; k++) {
                                        const oprod = this.state.mapproductList[k];
                                        if(oprod.productId===cutprod.productId){
                                            cisStackable=oprod.isStackable
                                            break
                                        }else{
                                            if(k===this.state.mapproductList.length){
                                                cisStackable=cutprod.isStackable
                                            }
                                        }
    
                                    }
                                    cutprod.id = uuidv4();
                                    cutprod.x = stratXpoint;
                                    cutprod.y = ((selectedDropShelf.y + selectedDropShelf.drawHeight) - cutprod.drawHeight);
                                    cutprod.uuid = uuidv4();
                                    cutprod.shelfrank = selectedDropShelf.rank;
                                    cutprod.field_custom_id = fieldobj.field_custom_id;
                                    cutprod.categoryRectId=  containElem?.catrect?.catrectId;
                                    cutprod.isNew = true;
                                    cutprod.isHanged = false;
                                    cutprod.isDelete = cutprod.isDelete?cutprod.isDelete:false;
                                    // cutprod.isDelete = false;
                                    cutprod.isStackable =cisStackable
                                    // Calculate the starting point
                                    let prodfield = this.state.mapFields[cutprod?.field_custom_id];
                                    let prodstartpoint = ((cutprod.x - prodfield.x) / this.state.displayRatio);
                                    const match = prodstartpoint.toString().match(/^-?\d+\.\d{0,9}/);
                                    prodstartpoint = match ? match[0] : prodstartpoint.toString();

                                    cutprod.startingPoint = prodstartpoint;
    
                                    stratXpoint = stratXpoint + cutprod.drawWidth;
    
                                    let curprodendx = (cutprod.x + cutprod.drawWidth);
                                    if(curprodendx > maxEndX){
                                        maxEndX = curprodendx
                                    }
    
                                    if(cutprod.subcategory && cutprod.subcategory.type === catRectEnums.rule){
                                        isruleupdating = true;
                                    }
                                }
                                //remove drop items from list
                                let newMOEndX     = roundOffDecimal((stratXpoint - this.state.checkSaftyMargin),2);
                                var ccontainProds = GetContainingProdsByBox(boxx1, boxy1, newMOEndX, boxy2, this.state.mapproductList, fieldobj);
    
                                if(ccontainProds.selectedProds && ccontainProds.selectedProds.length > 0){
                                    let notDeletedContainProds = ccontainProds.selectedProds.filter(f => !f.isDelete && f.shelfrank === selectedDropShelf.rank);
                                    for (let j = 0; j < notDeletedContainProds.length; j++) {
                                        const selcutitem = notDeletedContainProds[j];
    
                                        let findshelfitemidx = cutshelfs.shelf.findIndex(x => x.rank === selcutitem.shelfrank);
                                        if(findshelfitemidx > -1){
                                            cutshelfs.shelf[findshelfitemidx].products.push(selcutitem);
                                        } else{
                                            cutshelfs.shelf.push({ shelfrank:selcutitem.shelfrank, rank: selcutitem.shelfrank, products: [selcutitem] });
                                        }
                                        cProdList[selcutitem.prodidx]["isDelete"] = true;
    
                                        if(cProdList[selcutitem.prodidx].subcategory && cProdList[selcutitem.prodidx].subcategory.type === catRectEnums.rule){
                                            isruleupdating = true;
                                        }
                                    }
                                }
                                var filteredporducts=cutShelfObj.products.filter(x=>x.isDelete!==true)
                                cProdList.push(...filteredporducts);
                                // cProdList.push(...cutShelfObj.products);
                            //} else {
                            //    notAllowBottom = true;
                            //}
                        } else{
                            noShelfAvailable = true;
                        }
                    }
                }
            }

            if(noShelfAvailable){
                alertService.warn(this.props.t("DROP_SHELF_NOT_AVAILABLE"));
            } else{
                if(notAllowBottom){
                    alertService.warn(this.props.t("CANNOT_ADD_TO_BOTTOM"));
                } else{
                    var newCutarray = this.state.cutArray;

                    // PEG CR - 2025 March
                    // check if any product cross the peg board
                    const {isPegBoardOverlap} = this.productOverlapCheckerWithPegBoard(this.state.pegList, cProdList)
                    if(isPegBoardOverlap){
                        alertService.error(this.props.t('PEG_BOARD_OVERLAP'),4000);
                        this.setState({isPegBoardOverlapping:true, currentSelectedBlock: null});
                        this.setPreviewGuid(false, null, null, true);
                        return;
                    }

                    this.setState({
                        mapproductList: cProdList,
                        cutArray: newCutarray,
                        currentSelectedBlock: null, currentInternalDraggableProd: null
                    }, () => {
                        // console.log(this.state.cutArray);
                        if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                            // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                            const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                            this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
                        }

                        //reload imported product update
                        this.compareImportedProds();

                        //update cut products when clipDragType equal to SINGLE or MULTIPLE
                        if(this.state.clipDragType==="SINGLE"){
                            this.updateSingleCutProduct(draggingProduct, false, cutidx, draggingProduct.groupUUID);
                        }else{
                            this.updateSingleCutProduct(null, true, cutidx, draggingProduct.groupUUID);
                        }
                        if(cutshelfs.shelf.length > 0){
                            this.updateCutList(cutshelfs);
                        }

                        //check non sim render count and display mange
                        this.nonSimProddropremoveCounterupdate("cutdropBlock");

                        
                        // update actual field list spacing after deleted products
                        this.updateActualFieldListSpacing();

                        //update rule list if item sub cat is rule
                        if(isruleupdating){
                            let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, false);
                            // console.log(updaterulelist);

                            this.setState({
                                mapRulesList: updaterulelist.rulelist,
                                isRuleWarn: updaterulelist.iswarn
                            });
                        }
                        //call product group
                        this.groupByProduct();
                    });
                }
            }

            //end drop
            if(shelfRef){
                shelfRef.style.fill = 'transparent';
            }
            setTimeout(() => {
                this.setPreviewGuid(true);
            }, 500);
        }
    }

    //triggers on drop product to shelve
    droppedNew = (e, shelfObj, shelfRef, shelfIdx, isxpand, fieldobj) => {
        if((!this.state.isDisableEDitingwithfullscreen&&!this.state.isDisableEdits)){
            //fixes firefox image dragging issue
            e.preventDefault();
            // prevent when product half inside the pegboard
            if(this.state.droppedToPegBoard.insideHalfPegBoard){
                alertService.error(i18n.t("PRODUCT_HALF_INSIDE_THE_PEGBOARD"),4000);
                this.setState({currentDraggableProd:null})
                return;
            }
            if(this.state.droppedToPegBoard.isDroppedPegBoard && this.state.droppedToPegBoard.droppedPegBoard != null){
                this.handleProductsDropInsidePegBoard(e, shelfObj, fieldobj, this.state.currentDraggableProd.is_cutitem);
            }else{
                if(this.state.currentDraggableProd.is_cutitem){
                    // this.dropCutblock(e, shelfObj, shelfRef, shelfIdx, this.state.currentDraggableProd, this.state.currentDraggableProd.cutidx, fieldobj)
                    this.dropCutblockV2(e, shelfObj, shelfRef, shelfIdx, this.state.currentDraggableProd, this.state.currentDraggableProd.cutidx, fieldobj)
                }else{
                    // this.dropproduct(e, shelfObj, shelfRef, shelfIdx, isxpand, fieldobj)
                    this.dropproductV2(e, shelfObj, shelfRef, shelfIdx, isxpand, fieldobj)
                }
            }

            this.setState({ isContentDragging: false });
            removeGhostImage();
            // Mark changes for refresh indicator
            this.markChangesForRefresh();
        }
    }
    //remove expand
    removeExpandOpts = () => {
        this.setState({ isviewcmenu: false, contxtmenu: null});
    }
    //expand click
    handleExpandProd = () => {
        var cxobj = this.state.contxtmenu;
        this.setState({ isviewcmenu: false, contxtmenu: {xpos: cxobj.xpos, ypos: cxobj.ypos, isexpand: !cxobj.isexpand}/*,currentSelectedBlock: null */});
    }
    //toggle context menu
    handleContextMenu = (isshow, citem,prodidx,e) => {
        //Get right click cursor point
        let normalize_pointer = this.getScreenPointer(e);

        let newoffx = normalize_pointer.x;
        let newoffy = normalize_pointer.y;

        // let editwrapper = document.getElementById(this.state.wrapperId);
        // let viewboxcoords = this.xyChangeCoords(e);

        // let zoomXRatio = this.state.zoomXRatio;
        // let reducescrolledgap = ((citem.x * zoomXRatio) - editwrapper.scrollLeft);
        // console.log(e.pageX, e.pageY, e.clientX, e.clientY);

        // var cobj = {xpos: this.props.isRTL?(reducescrolledgap + 40):(reducescrolledgap + 50),

        var isAuismallScreen = ((!this.props.isShowFromPreview && !this.props.isFullscreenEditModal)&&(this.props.simType==="AUI"))?true:false
        var redY = 0
        var contextX = e.clientX
        //set right click cursor position x & y
        this.setState({rightClickXPos:e.clientX, rightClickYPos: e.clientY});

        if(isAuismallScreen){
            var auiscroll = document.getElementById("aui-sim-scroll-main")
            redY=auiscroll.scrollTop
            contextX=this.props.isRTL === "rtl" ?(e.clientX-this.state.AUISideBarGap)-230:e.clientX-this.state.AUISideBarGap
        }
        var cobj = {
            xpos   : contextX,
            ypos   : (e.clientY+redY)-110, //citem.y + 150
            prodidx: prodidx, 
            citem  : citem
        };

        // let filterProductList = this.state.mapproductList.filter(x => !x.isDelete);
        
        // add "prodidx" property in to every object in the product list
        // for (let i = 0; i < filterProductList.length; i++) {
        //     filterProductList[i].prodidx = i;
        // }

        // this.setState({
        //     mapproductList: filterProductList,
        // });

        //make temp dash rect
        var prod=JSON.parse(JSON.stringify(this.state.mapproductList[prodidx]))
        prod["prodidx"]=prodidx

        //find group id related products
        const prods = this.state.mapproductList.filter(prd=>prd.groupId === prod.groupId && prd.isDelete !== true);

        var positionobj = elmAccordingtoXY(prod.x,prod.y, prod.drawWidth,prod.drawHeight,this.state.mapFields,this.state.mapCatRects);
        var drawingDetails = ((Object.keys(positionobj).length > 0)?positionobj:null);
        let tempdashrect= { drawingDetails:drawingDetails, startx: newoffx, starty: newoffy, x: newoffx, y:newoffy, width: 0, height: 0, percentage: 0 }
    
        this.setState({ isviewcmenu: isshow, contxtmenu: cobj, currentSelectedBlock: null, },()=>{
            this.setState({selectedblockpos:tempdashrect},()=>{
                this.setSelectedblock(true,prods)
            })

        });
    }
    //mark stackble products tempory before send call
    markingtempStackableprods=(e,mainitem,prodidx)=>{
        var prodlist=this.state.mapproductList
        var selectedprod=this.state.mapproductList[prodidx]
        var stackablemarkArray=this.state.stackablemarkArray
        var stackblebool=false
        //mark show products stack boolean
        for (let i = 0; i < prodlist.length; i++) {
            const prod = prodlist[i];
            if(selectedprod.productId===prod.productId){
                prod.isStackable=!prod.isStackable
                stackblebool=prod.isStackable
            }
        }
        //check selected product is in stack array
        var haveselectedproductinarray=stackablemarkArray.find(x=>x.productId===selectedprod.productId)
        if(haveselectedproductinarray){
            //remove from array
            var filterarray=stackablemarkArray.filter(x=>x.productId!==selectedprod.productId)
            stackablemarkArray=filterarray

            // for (let f = 0; f < stackablemarkArray.length; f++) {
            //     const ele = stackablemarkArray[f];
            //     ele.productId=selectedprod.productId
            //     if(ele.productId===selectedprod.productId){
            //         ele.isStackable=!ele.isStackable
            //     }
            // }
        }else{
            //add to array
            var obj={
                IsFromFE:true,
                productId : selectedprod.productId,
                isStackable : stackblebool,
                maxStackableCount : this.state.stackableCountofmark===""?0:parseInt(this.state.stackableCountofmark)
            }
            stackablemarkArray.push(obj)
        }

        if(this.props.simType === "AUI" || this.props.simType === "Normal"){
            // const combinedPrds = prodlist.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
            const combinedPrds = prodlist.filter(prd=>prd.isDelete !== true)
            this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
        }

        this.setState({stackablemarkArray:stackablemarkArray},()=>{
            this.sendmarkStackableArray()
        })
        // console.log(haveselectedproductinarray);
    }
    handleMouseClick = (e,mainitem,prodidx) => {
        // console.log("________hello", this.state.isDisableEdits,"_____this.state.isDisableEdits", this.state.isDisableEDitingwithfullscreen,"____this.state.isDisableEDitingwithfullscreen")
        // Reset Peg Board Overlap
        this.resetPegBoardOverlap();

        if((!this.state.isDisableEDitingwithfullscreen&&!this.state.isDisableEdits)){
            // console.log("first");
            //if stackable is on
            if(this.state.markablestackable){
                // if(this._StackablecallTimeout){
                //     clearTimeout(this._StackablecallTimeout);
                // }

                // this._StackablecallTimeout = setTimeout(() => {
                // this.sendmarkStackableArray()
                //     }, 1500);
                this.markingtempStackableprods(e,mainitem,prodidx)
            }
            //end of stackble is on
            //set dragging product
            var cdrgprod =  { prodidx:prodidx, prod: mainitem};

            this.setState({
                isblockmove:false,
                // selectedlocobj:JSON.parse(JSON.stringify(mainitem)),
                currentInternalDraggableProd: cdrgprod,
                isviewcmenu: false,isviewcmenu2:false, contxtmenu: {isexpand: false},
            });
            if(e.nativeEvent.which === 1){//left click

            } else if(e.nativeEvent.which === 3){ //right click
                this.handleContextMenu(true, mainitem,prodidx, e);
            }
        }
        // Reset AI Manipulation
        this.setState({
            manipulationDoneStatus: false
        })
    }
    //#MP-SML-E-02
    //delete umoverlap products
    handleDeleteProd=()=>{
        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),2);

        var cmenu = this.state.contxtmenu;
        var cMapProdList = JSON.parse(JSON.stringify(this.state.mapproductList))
        cMapProdList[cmenu.prodidx]["isDelete"] = true;

        let plocobj = cMapProdList[cmenu.prodidx];
        //toched cat list added
        this.TouchedCatListUpdate(plocobj.categoryRectId)
        //if is item sub cat is rule
        let isruleupdating = false;
        if(plocobj.subcategory && plocobj.subcategory.type === catRectEnums.rule){
            //find if rule brand available
            let scatruleid = getNameorIdorColorofBox(plocobj.subcategory, "num");
            let scatrulelevel = (plocobj.subcategory.rule?plocobj.subcategory.rule.level:null);

            let findfromrules = findRuleAvailableForBrand(scatruleid, true, scatrulelevel, this.state.mapRulesList);
            // console.log(findfromrules);

            if(findfromrules.isavailable){
                isruleupdating = {parentidx: findfromrules.ruleparentidx, ruleidx: findfromrules.ruleidx};
            }
        }
        //remove counter
        this.handleRemoveProductCounter(cmenu.citem,1);

        this.setState({ currentInternalDraggableProd:null, mapproductList: cMapProdList, isviewcmenu: false,  contxtmenu: {xpos:0, ypos: 0, xidx: 0, scatidx: 0} }, () => {

            if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd => prd.isDelete !== true)
                const combinedPrds = this.state.mapproductList.filter(prd => prd.isDelete !== true)
                this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
            }

            //update rule list if item sub cat is rule
            //check non sim render count and display mange
            this.nonSimProddropremoveCounterupdate("deleteProd")
            if(isruleupdating){
                let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, true, isruleupdating);
                // console.log(updaterulelist);

                this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
            }

            //reload imported product update
            this.compareImportedProds();
        });

        this.props.handlehaveChnagesinCat(true);
    }
    //delete all umoverlap products
    handleDeleteAllProds = () => {
        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),2);

        var cmenu = this.state.contxtmenu;
        // console.log(cmenu);
        let deletedItemscount = 0;
        var cMapProdList = JSON.parse(JSON.stringify(this.state.mapproductList));
        let isaddcattouch=false
        let isruleupdating = false;
        for (let i = 0; i < cMapProdList.length; i++) {
            const proditem = cMapProdList[i];
            if(!proditem.isDelete && proditem.shelfrank === cmenu.citem.shelfrank && proditem.barcode === cmenu.citem.barcode){
                if(!isaddcattouch){
                    //cat rect chenged track
                    this.TouchedCatListUpdate(proditem.categoryRectId)
                    isaddcattouch=true
                }
                proditem["isDelete"] = true;

                deletedItemscount = (deletedItemscount + 1);

                if(proditem.subcategory && proditem.subcategory.type === catRectEnums.rule){
                    isruleupdating = true;
                }
            }
        }

        this.handleRemoveProductCounter(cmenu.citem, deletedItemscount);
        this.setState({ currentInternalDraggableProd:null, mapproductList: cMapProdList, isviewcmenu: false,  contxtmenu: {xpos:0, ypos: 0, xidx: 0, scatidx: 0} }, () => {

            if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
            }

            //check non sim render count and display mange
             this.nonSimProddropremoveCounterupdate("deleteAllProds")
            //update rule list if item sub cat is rule
            if(isruleupdating){
                let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, false);
                // console.log(updaterulelist);

                this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
            }

            //reload imported product update
            this.compareImportedProds();
        });
        this.props.handlehaveChnagesinCat(true);

    }
    //counter of removed products
    handleRemoveProductCounter = (item, removecount) => {
        var toarraypush = true;
        var cremovedProductsCounter = this.state.removedProductsCounter;
        var caddedProductsCounter=this.state.addedProductsCounter
        for (let i = 0; i < cremovedProductsCounter.length; i++) {
            const rpord = cremovedProductsCounter[i];
            //is existing product in list
            if(rpord.barcode === item.barcode){
                toarraypush = false;
                rpord.qty = rpord.qty + (removecount?removecount:1)
                break
            }
        }
        //if empty or newe prosuct
        if(toarraypush){
            var sendobj={
                imageUrl:item.imageUrl,
                barcode: item.barcode,
                productName: item.productName,
                productId: item.productId,
                qty: (removecount?removecount:1)
            }
            cremovedProductsCounter.push(sendobj);
        }


        // adding
        if(caddedProductsCounter.length>0){
            for (let t = 0; t < caddedProductsCounter.length; t++) {
            const element = caddedProductsCounter[t];
            //is existing product in list
            if(element.productId === item.productId){

                toarraypush = false;
                element.qty = (((element.qty - (removecount?removecount:1))>-1)?(element.qty - (removecount?removecount:1)):0)
                break
            }
        }}
        this.setState({removedProductsCounter:cremovedProductsCounter,addedProductsCounter:caddedProductsCounter},()=>{
            this.props.handlehaveChnagesinCat(true);
        })

    }
    //counter of removed products
    handleAddProductCounter=(item, counts)=>{

        var toarraypush=true;
        var caddedProductsCounter=this.state.addedProductsCounter
        var cremovedProductsCounter = this.state.removedProductsCounter;
        for (let i = 0; i < caddedProductsCounter.length; i++) {
            const rpord = caddedProductsCounter[i];
            //is existing product in list
            if(rpord.barcode === item.barcode){
                toarraypush=false
                rpord.qty= (rpord.qty + counts);
                break
            }
        }
        //if empty or newe prosuct
        if(toarraypush){
            var sendobj={
                imageUrl:item.imageUrl,
                barcode: item.barcode,
                productName: item.productName,
                productId: item.productId,
                qty:1
            }
            caddedProductsCounter.push(sendobj);
        }

        //remove
        if(cremovedProductsCounter.length>0){
            for (let t = 0; t < cremovedProductsCounter.length; t++) {
                const rmprod = cremovedProductsCounter[t];
                rmprod.qty= ((rmprod.qty - counts)>-1)?rmprod.qty - counts:0;
            }
        }

        this.setState({addedProductsCounter:caddedProductsCounter,removedProductsCounter:cremovedProductsCounter});
    }
    //toggle zoom pan tool
    toggleZoompan = (evt,ismove,enablemove) => {
        if(ismove){
            this.setState({ isAllowPan: enablemove });
        } else{
            this.setState({ activeTool: (this.state.activeTool !== "pan"?"pan":"drawBlock") });
        }
    }
    //find real xy locations of clicking location according to svg viewbox
    xyChangeCoords = (evt) => {
        this.svgCreatePoint.x = evt.clientX;
        this.svgCreatePoint.y = evt.clientY;

        // The cursor point, translated into svg coordinates
        var cursorpt =  this.svgCreatePoint.matrixTransform(this.drawSVG.getScreenCTM().inverse());

        return {x: cursorpt.x, y: cursorpt.y};
    }
    //handle zoom feature
    handleZoomInOut = (iszoomin,isreset) => {

        // let editwrapper = document.getElementById(this.state.wrapperId);
        let svgdrawDiemention = this.state.svgdrawDiemention;

        // let fieldwidth = (this.state.zoomXRatio > 0 && (editwrapper.clientWidth > svgdrawDiemention.drawWidth)?editwrapper.clientWidth:svgdrawDiemention.drawWidth);
        // let fieldheight = this.state.catDivHeight;

        let svg = document.getElementById(this.state.svgViewId);
        // let viewBox = svg.viewBox.baseVal;
        let curInterDraggable = this.state.currentInternalDraggableProd;
        let curSelectedBlock = this.state.currentSelectedBlock;

        let zoomsizex = this.state.zoomXRatio;
        if(iszoomin){
            // viewBox.x = viewBox.x + viewBox.width / 4;
            // viewBox.y = viewBox.y + viewBox.height / 4;
            // viewBox.width = viewBox.width / 2;
            // viewBox.height = viewBox.height / 2;

            // if(zoomsizex === 0){
            //     viewBox.x = 0;
            //     viewBox.y = 0;
            // }

            // if(zoomsizex === 0 && (svgdrawDiemention.drawWidth ) < editwrapper.clientWidth){
            //     viewBox.width = (editwrapper.clientWidth / 2);
            // }

            zoomsizex = zoomsizex + 1;

            svg.style.width = (svgdrawDiemention.drawWidth * (zoomsizex + 1)) + 'px';

        } else if(isreset){
            // viewBox.x = 0;
            // viewBox.y = 0;
            // viewBox.width = svgdrawDiemention.drawWidth;
            // viewBox.height = fieldheight;

            zoomsizex = 0;

            svg.style.width = svgdrawDiemention.drawWidth + 'px';

            curInterDraggable = null;
            curSelectedBlock = null;

            this.setState({ activeTool: "drawBlock" });
        } else{
            if(zoomsizex > 0){
                // viewBox.x = 0;
                // viewBox.y = 0;
                // viewBox.width = viewBox.width * 2;
                // viewBox.height = viewBox.height * 2;

                zoomsizex = zoomsizex - 1;

                svg.style.width = (svgdrawDiemention.drawWidth + (zoomsizex > 0?(svgdrawDiemention.drawWidth * zoomsizex):0)) + 'px';

                //reset to default view
                if(zoomsizex === 0){
                    // viewBox.x = 0;
                    // viewBox.y = 0;
                    // viewBox.width = svgdrawDiemention.drawWidth;
                    // viewBox.height = fieldheight;

                    zoomsizex = 0;

                    svg.style.width = svgdrawDiemention.drawWidth + 'px';

                    curInterDraggable = null;
                    curSelectedBlock = null;

                    this.setState({ activeTool: "drawBlock" });
                }
            } else{
                // viewBox.x = 0;
                // viewBox.y = 0;
                // viewBox.width = svgdrawDiemention.drawWidth;
                // viewBox.height = fieldheight;

                svg.style.width = svgdrawDiemention.drawWidth + 'px';

                zoomsizex = 0;

                curInterDraggable = null;
                curSelectedBlock = null;

                this.setState({ activeTool: "drawBlock" });
            }
        }
        this.setState({ zoomXRatio: zoomsizex, isviewcmenu: false, currentInternalDraggableProd: curInterDraggable, currentSelectedBlock: curSelectedBlock, contxtmenu: {isexpand: false} });
    }
    //enables pan
    handlePanView = (event) => {
        if(this.state.isAllowPan && this.state.activeTool === "pan"){

            // let svg = document.getElementById(this.state.svgViewId);
            // let viewBox = svg.viewBox.baseVal;

            // //block more going more than layout size
            // //get current viewbox x,y location change
            // let newmovex = (viewBox.x - event.movementX);
            // let newmovey = (viewBox.y - event.movementY);

            // viewBox.x = newmovex;
            // viewBox.y = newmovey;

            let parent = document.getElementById(this.state.wrapperId);

            parent.scrollLeft= parent.scrollLeft-event.movementX
            parent.scrollTop= parent.scrollTop-event.movementY
        }
    }


    //back btn validate and redirect
    handlebackbtn=()=>{
        // handlehaveChnagesinCat

        if(this.state.historyData.past.length>0 ){
            if(this.state.isStackableEdited){
                this.sendmarkStackableCall()
            }
            confirmAlert({
                title: this.props.t('YOU_HAVE_UNSAVED_CHANGES'),
                message: this.props.t("YOU_HAVE_UNSAVED_CHANGES_SURE_TO_LEAVE"),
                overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
                buttons: [{
                    label: this.props.t('btnnames.yes'),
                    onClick: () => {
                        // this.reSetNewProdsRemoveProdstoPrevious()
                        this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, this.props.mapProducts)
                        this.props.setMpEditStackHistory(null)
                        this.props.handlehaveChnagesinCat(false)
                        this.props.toggleOneCategory()
                    }
                }, {
                    label: this.props.t('btnnames.no'),
                    onClick: () => {
                        return false;
                    }
                }]
            });
        }else{
            if(this.state.isStackableEdited&&this.props.mpstate.mpStackableProdList!==null?this.props.mpstate.mpStackableProdList.length>0:false){
                  //if markstackable have changes
                this.sendmarkStackableCall("back")
            }else{
                this.props.toggleOneCategory()
            }
        }

    }
    //new tools handle
    handleToolControls = (viewid,tooltype, event, startpan) => {
        let activezoompan = true;

        let svg = document.getElementById(viewid);
        let viewBox = svg.viewBox.baseVal;

        //view width/height
        let vwidth = this.state.viewWidth;
        let vheight = this.state.viewHeight;

        let iszpactive = this.state.zoompanactive;
        let actool = this.state.activeTool;
        let stpan = this.state.startpan;

        let zoomdrawx = this.state.zoomDrawX;
        let aczoomdrawx = this.state.aczoomDrawX;

        if(tooltype === "zoomin"){
            this.handleZoomInOut(viewid,true,false);

            zoomdrawx = zoomdrawx + 1;
            this.setState({ isShowProdView: false, isenablefieldedit: false, isviewvmenu: false });
        } else if(tooltype === "zoomout"){
            if(roundOffDecimal(vwidth,2) <= roundOffDecimal((viewBox.width * 2),2)){
                activezoompan = false;
                this.handleZoomInOut(viewid,false,true,vwidth,vheight);

                zoomdrawx = 0;
            } else{
                this.handleZoomInOut(viewid,false,false,vwidth);

                zoomdrawx = zoomdrawx - 1;
            }

        } else if(tooltype === "zoomreset"){
            activezoompan = false;
            this.handleZoomInOut(viewid,false,true,vwidth,vheight);

            this.setState({ activeTool: "drawBlock" });
            zoomdrawx = 0;

        }

        if(tooltype === "zoomin" || tooltype === "zoomout" || tooltype === "zoomreset"){
            //console.log(tooltype);
            this.setState({ zoomDrawX: zoomdrawx, aczoomDrawX: aczoomdrawx, isviewcmenu: false, contxtmenu:{isexpand: false} }, () => {
                if(zoomdrawx === 0){
                    this.checkEnableFieldEdit();
                }
            });
        }

        if(tooltype === "pan"){
            if(actool === "pantool" && stpan){
                let fielddetails = { drawWidth: this.state.viewWidth, drawHeight: this.state.viewHeight };
                this.handlePanView(viewid, event, iszpactive, this.state.zoomDrawX, fielddetails);
            }
        } else if(tooltype === "panstart"){
            this.setState({ startpan: startpan });
        } else if(tooltype === "pantool" || tooltype === "shelvemove"||tooltype==="drawBlock"){
            this.setState({ activeTool: (tooltype === actool?"drawBlock":tooltype) });
        } else{
            this.setState({ zoompanactive: activezoompan, allowovrflwprod: (activezoompan && this.state.allowovrflwprod?false:this.state.allowovrflwprod) });
        }
    }
    propComparator = (propName) =>(a, b) => a[propName] === b[propName] ? 0 : a[propName] < b[propName] ? -1 : 1

    updateSaveObjChild=(newfields,shelfIdx,BrandIdx)=>{
        this.setState({selectedlocobj:null, currentSelectedBlock: null, currentInternalDraggableProd: null, isblockmove: false});
    }

    nullselectedlocobjnull=()=>{
        this.setState({selectedlocobj:null})
    }

    //clickon svgMouseDown
    svgMouseDown=(e)=>{
        // console.log('this.state.isPegDrawing==========>', this.state.isPegDrawing);
        if(this.state.activeTool==="pan"){
            this.toggleZoompan(e,true,true)
        }else if(this.state.activeTool==="drawBlock"){
            if(!this.state.isPegDrawing){
                this.startNewRect(e)
            }else{
                this.startNewRectForPeg(e)
            }
        }

    }
    //clickon svgMouseMove
    svgMouseMove=(e)=>{
        if(this.state.activeTool==="pan"){
            this.handlePanView(e)
        }else if(this.state.activeTool==="drawBlock"){
            if(!this.state.isPegDrawing){
                this.changeDashRect(e)
            }else{
                this.changeDashRectForPeg(e)              
            }
        }

    }
    //clickon svgMouseUp
    svgMouseUp=(e)=>{
        if(this.state.activeTool==="pan"){
            this.toggleZoompan(e,true,false)
        }else if(this.state.activeTool==="drawBlock"){
            if(!this.state.isPegDrawing){
                this.drawNewRect(e)
            }else{
                this.drawNewRectForReg(e)
            }
        }
    }
    startNewRect=(e)=>{
        
        if( e.nativeEvent.which === 1&& !this.state.markablestackable&&(!this.state.isDisableEDitingwithfullscreen&&!this.state.isDisableEdits)){ //only left mouse click
            let normalize_pointer = this.getScreenPointer(e);

            let newoffx = normalize_pointer.x;
            let newoffy = normalize_pointer.y;

            var positionobj = elmAccordingtoXY(newoffx,newoffy, 0, 0,this.state.mapFields,this.state.mapCatRects);
            var drawingDetails = ((Object.keys(positionobj).length > 0)?positionobj:null);

            this.setState({
                newrectstart: {x: newoffx, y:newoffy},
                isshowdash: true,
                dashrect: { drawingDetails:drawingDetails, startx: newoffx, starty: newoffy, x: newoffx, y:newoffy, width: 0, height: 0, percentage: 0 }
            },()=>{
                //console.log('dashrect+++++++============>', this.state.dashrect);
            });
        }
    }
    // PEG CR - 2025 March - Start New Rect for Peg
    startNewRectForPeg=(e)=>{
        
        if(e.nativeEvent.which === 1 && !this.state.markablestackable&&(!this.state.isDisableEDitingwithfullscreen&&!this.state.isDisableEdits)){ //only left mouse click
            let normalize_pointer = this.getScreenPointer(e);

            let newoffx = normalize_pointer.x;
            let newoffy = normalize_pointer.y;

            var positionobj    = elmAccordingtoXYForPeg(newoffx,newoffy, 0, 0,this.state.mapFields,this.state.mapCatRects, this.state.actualFieldStructures);
            var drawingDetails = ((Object.keys(positionobj).length > 0)?positionobj:null);
            this.setState({
                newPegrectstart: {x: newoffx, y:newoffy},
                isPegDrawingShowdash: true,
                pegDashrect: { 
                    drawingDetails  : drawingDetails, 
                    startx          : newoffx, 
                    starty          : newoffy, 
                    x               : newoffx, 
                    y               : newoffy, 
                    width           : 0, 
                    height          : 0, 
                    percentage      : 0
                }
            },()=>{});
        }
    }
    //get new x point
    getScreenPointer = (e) => {
        let svg = document.getElementById(this.state.svgViewId);
        if (!svg) {
            return {x: 0, y: 0};
        }
        
        let point = svg.createSVGPoint();
        point.x = e.nativeEvent.clientX;
        point.y = e.nativeEvent.clientY;
        let target = e.target;
        let ctm = (target.getScreenCTM?target.getScreenCTM():null);

        if (ctm) {
            return point.matrixTransform(ctm.inverse());
        } else {
            // Fallback: Try to get CTM from the SVG element itself
            let svgCtm = svg.getScreenCTM();
            if (svgCtm) {
                return point.matrixTransform(svgCtm.inverse());
            } else {
                // Final fallback: Calculate relative to SVG bounds
                let svgRect = svg.getBoundingClientRect();
                return {
                    x: e.nativeEvent.clientX - svgRect.left,
                    y: e.nativeEvent.clientY - svgRect.top
                };
            }
        }
    }

    changeDashRect = (e) => {
        if (e && this.state.isshowdash) {
            var cobj = this.state.dashrect;

            if(cobj && cobj.drawingDetails && cobj.drawingDetails.catrect && cobj.drawingDetails.catrect.drawMarginstartY !== null){
                let normalize_pointer = this.getScreenPointer(e);

                let scrollobj = { x: normalize_pointer.x, y: normalize_pointer.y, drawWidth: 1, drawHeight: 1 };

                cobj["pointerX"] = normalize_pointer.x;
                cobj["pointerY"] = normalize_pointer.y;

                cobj["x"] = (cobj.startx < normalize_pointer.x?cobj.x:normalize_pointer.x);
                cobj["y"] = (cobj.starty < normalize_pointer.y?cobj.y:normalize_pointer.y);

                let boxwidth = (cobj.startx < normalize_pointer.x?Math.abs(normalize_pointer.x - cobj.startx):Math.abs(cobj.startx - normalize_pointer.x));
                cobj["width"] = boxwidth;

                let boxheight = (cobj.starty < normalize_pointer.y?Math.abs(normalize_pointer.y - cobj.starty):Math.abs(cobj.starty - normalize_pointer.y));
                cobj["height"] = boxheight;

                var dDetails = cobj.drawingDetails;
                if(dDetails.catrect){
                    /* if(dDetails.catrect.drawMarginstartY > cobj.y){
                        cobj["y"] = dDetails.catrect.drawMarginstartY;
                    } */

                    // (dDetails.catrect.drawMarginstartY + dDetails.catrect.drawHeightMargin)
                    let fieldy2 = (dDetails.field && dDetails.field.drawHeight?(dDetails.field.y + dDetails.field.drawHeight):0);
                    if(fieldy2 < (cobj.y + cobj.height)){
                        // cobj["height"] = ((dDetails.catrect.drawMarginstartY + dDetails.catrect.drawHeightMargin) - cobj.y);
                        cobj["height"] = dDetails.field.drawHeight;
                    }

                    // REMOVE CATEGORY SEPERATOR VALIDATION WHEN SELECTION AREA BY CURSOR WITH PRE PLAN CR - 2025 NOV

                    // if(dDetails.catrect.x > cobj.x){
                    //     cobj["x"] = dDetails.catrect.x;
                    // }
                    

                    // if((dDetails.catrect.x + dDetails.catrect.drawWidth) < (cobj.x + cobj.width)){
                    //     cobj["width"] = ((dDetails.catrect.x + dDetails.catrect.drawWidth) - cobj.x);
                    // }

                }

                //scroll parent with drag
                this.scrollParentWithDrag(scrollobj);

                this.setState({ dashrect: cobj });
            }
        }
    }
    // PEG CR - 2025 March  - Change Dash Rect for Peg
    changeDashRectForPeg = (e) => {
        if (e && this.state.isPegDrawingShowdash) {
            var cobj = this.state.pegDashrect;
            let fieldIDsList = [];
            let shelfIdList  = [];

            if(cobj && cobj.drawingDetails && cobj.drawingDetails.catrect && cobj.drawingDetails.catrect.drawMarginstartY !== null){
                let normalize_pointer = this.getScreenPointer(e);

                let scrollobj = { x: normalize_pointer.x, y: normalize_pointer.y, drawWidth: 1, drawHeight: 1 };

                cobj["pointerX"] = normalize_pointer.x;
                cobj["pointerY"] = normalize_pointer.y;

                cobj["x"] = (cobj.startx < normalize_pointer.x?cobj.x:normalize_pointer.x);
                cobj["y"] = (cobj.starty < normalize_pointer.y?cobj.y:normalize_pointer.y);

                let boxwidth = (cobj.startx < normalize_pointer.x?Math.abs(normalize_pointer.x - cobj.startx):Math.abs(cobj.startx - normalize_pointer.x));
                cobj["width"] = boxwidth;

                let boxheight  = (cobj.starty < normalize_pointer.y?Math.abs(normalize_pointer.y - cobj.starty):Math.abs(cobj.starty - normalize_pointer.y));
                cobj["height"] = boxheight;

                var dDetails = cobj.drawingDetails;
                if(!dDetails.catrect){
                    /* if(dDetails.catrect.drawMarginstartY > cobj.y){
                        cobj["y"] = dDetails.catrect.drawMarginstartY;
                    } */

                    // (dDetails.catrect.drawMarginstartY + dDetails.catrect.drawHeightMargin)
                    let fieldy2 = (dDetails.field && dDetails.field.drawHeight?(dDetails.field.y + dDetails.field.drawHeight):0);
                    if(fieldy2 < (cobj.y + cobj.height)){
                        // cobj["height"] = ((dDetails.catrect.drawMarginstartY + dDetails.catrect.drawHeightMargin) - cobj.y);
                        cobj["height"] = dDetails.field.drawHeight;
                    }

                    if(dDetails.catrect.x > cobj.x){
                        cobj["x"] = dDetails.catrect.x;
                    }

                    if((dDetails.catrect.x + dDetails.catrect.drawWidth) < (cobj.x + cobj.width)){
                        cobj["width"] = ((dDetails.catrect.x + dDetails.catrect.drawWidth) - cobj.x);
                    }

                }

                var findPegRectBoundariesval = findPegRectBoundaries(this.state.mapFields, cobj);
                let pegRectWidth             = (findPegRectBoundariesval?.endValue - findPegRectBoundariesval?.startValue);

                //rect start y selection from top to bottom or bottom to top
                let rectStartY = (cobj.starty < normalize_pointer.y ? cobj.starty : normalize_pointer.y);

                cobj['drawX']          = findPegRectBoundariesval?.startValue;
                cobj['drawY']          = rectStartY; 
                cobj['drawRectWidth']  = pegRectWidth;
                cobj['drawRectHeight'] = boxheight; 

               // var positionobj          = elmAccordingtoXYForPeg(normalize_pointer.x, normalize_pointer.y, 0, 0,this.state.mapFields,this.state.mapCatRects);
               // var recEndDrawingDetails = ((Object.keys(positionobj).length > 0)?positionobj:null);
                
                // x value -> drawX
                cobj['pegRectStartx'] = findPegRectBoundariesval?.startValue / this.state.displayRatio; //measureConverter(this.state.displayUOM, this.state.convertedUOM, findPegRectBoundariesval?.startValue) / this.state.displayRatio;
                // y value -> drawY
                cobj['pegRectEndx']   = rectStartY / this.state.displayRatio; //measureConverter(this.state.displayUOM, this.state.convertedUOM, cobj.starty) / this.state.displayRatio; 
                //rectWidth ->  drawRectWidth
                cobj['newWidth']      = measureConverter(this.state.displayUOM, this.state.convertedUOM, pegRectWidth) / this.state.displayRatio;
                //rectHeight -> drawRectHeight
                cobj["heightLabelVal"] = measureConverter(this.state.displayUOM, this.state.convertedUOM, boxheight) / this.state.displayRatio;

                cobj['pegRectStartxLabelVal'] = measureConverter(this.state.displayUOM, this.state.convertedUOM, findPegRectBoundariesval?.startValue) / this.state.displayRatio; 
                cobj['pegRectEndxLabelVal']   = measureConverter(this.state.displayUOM, this.state.convertedUOM, pegRectWidth) / this.state.displayRatio;

                var positionobj        = elmAccordingtoXYForPeg(cobj["x"],rectStartY, boxwidth, boxheight,this.state.mapFields,this.state.mapCatRects, this.state.actualFieldStructures);
                var rectdrawingDetails = ((Object.keys(positionobj).length > 0)?positionobj:null);

                cobj['drawingDetails']['field']['intersectedFields'] = rectdrawingDetails?.field?.intersectedFields; 
                cobj['drawingDetails']['field']['intersectedShelves'] = rectdrawingDetails?.field?.intersectedShelves;

                rectdrawingDetails?.field?.intersectedFields?.forEach((field, index) => {
                    let fieldID = field.actualFieldId;
                    fieldIDsList.push(fieldID);
                });

                rectdrawingDetails?.field?.intersectedShelves?.forEach((shelf, index) => {
                    let shelfID = shelf.rank;
                    if(!shelfIdList.includes(shelfID)){
                        shelfIdList.push(shelfID);
                    }
                });
                
                cobj['fieldIDs'] = fieldIDsList;
                cobj['shelfIDs'] = shelfIdList;
                //scroll parent with drag
                this.scrollParentWithDrag(scrollobj);
               
                this.setState({ pegDashrect: cobj });
            }
        }
    }

    drawNewRect=(e)=>{
        if ( this.state.isshowdash) {
            if( e.nativeEvent.which === 1){ //only left mouse click
                var drawedSelectionRect=JSON.parse(JSON.stringify(this.state.dashrect));
                this.setState({
                    selectedblockpos:drawedSelectionRect,
                    isshowdash: false,
                    dashrect: { startx:0, starty: 0, x: 0, y: 0, width: 0, height: 0, percentage: 0 },
                    ghostWrapperObj: null,
                },()=>{
                    this.setSelectedblock()
                })
            }
        }
    }

    // PEG CR - 2025 March  - Draw new rect for drawing peg board
    drawNewRectForReg=(e)=>{
        if (this.state.isPegDrawingShowdash) {

            if( e.nativeEvent.which === 1){ //only left mouse click
                let drawingDashRect = this.state.pegDashrect;
                drawingDashRect['x']     = drawingDashRect['drawX'];
                drawingDashRect['width'] = drawingDashRect['drawX'] + drawingDashRect['drawRectWidth'];
                
                var drawedSelectionRect = JSON.parse(JSON.stringify(drawingDashRect));

                //if(!drawedSelectionRect.fieldIDs && !drawedSelectionRect.shelfIDs) return false;

                //validate pegboards to be drawn overlapping with the stack layers.
                // remove all stack layer in peg board covering field & shelf
                const pegCoveringFields = drawedSelectionRect?.fieldIDs;
                const pegCoveringShelfs = drawedSelectionRect?.shelfIDs;
                const productList = this.state.mapproductList;

                //find similar products in field IDs & shelfIDs in covering peg boards & stack count updated products
                const stackableProduct = productList.filter(product => {

                    const { isStackable, actualFieldInfo, shelfrank, stackCount } = product;

                    const isInCoveringField = actualFieldInfo?.some(field => pegCoveringFields?.includes(field.actualFieldId));

                    const isInCoveringShelf = pegCoveringShelfs?.includes(shelfrank);

                    return stackCount > 0 && isStackable && isInCoveringField && isInCoveringShelf;

                });

                // reset stack count of filtered product list

                let newProductList = productList?.map((product) => {
                    const isStackableProduct = stackableProduct?.some(stackable => stackable.groupId === product.groupId);
                    
                    if(isStackableProduct){
                        return {
                            ...product,
                            stackCount: 0
                        };
                    }
                    return product;
                });

                // update map product list with reset stackCount in stackableProduct list
                this.setState({mapproductList : newProductList}, () => {
                    // console.log('stackableProduct_', stackableProduct);
                    if(stackableProduct && stackableProduct.length > 0){
                        alertService.warn(this.props.t("RESET_STACK_LAYER"));
                    }
                });
                
                const newRect = {
                    pegRectStartx : drawedSelectionRect.drawX,
                    pegRectEndx   : drawedSelectionRect.drawRectWidth,
                    startY        : drawedSelectionRect.drawY,
                    height        : drawedSelectionRect.drawRectHeight,
                }
               
                //check drawing rect is on the existing rect
                if(isPegsOverlapping(newRect, this.state.pegList)){
                    alertService.warn(this.props.t("CANNOT_OVERLAPPING_PEGBOARD"));
                    this.setState({
                        selectedblockpos:{},
                        isPegDrawingShowdash: false,
                        pegDashrect: { startx:0, starty: 0, x: 0, y: 0, width: 0, height: 0, percentage: 0 },
                        ghostWrapperObj: null,
                        isPegDrawing: true,
                        cursorChangeToPeg:true,
                        isRectDrawingCompleted:false,
                        currentSelectedBlock: null
                    },()=>{})
                }else if(this.isPegBoardDrawingOutSide(drawedSelectionRect, this.state.mapFields)){
                    alertService.warn(this.props.t("PEGBOARD_CANNOT_DRAW_OUTSIDE"));
                    this.setState({
                        selectedblockpos:{},
                        isPegDrawingShowdash: false,
                        pegDashrect: { startx:0, starty: 0, x: 0, y: 0, width: 0, height: 0, percentage: 0 },
                        ghostWrapperObj: null,
                        isPegDrawing: true,
                        cursorChangeToPeg:true,
                        isRectDrawingCompleted:false,
                        currentSelectedBlock: null
                    },()=>{})
                    // check drawing rect is on the different fields
                }else if(this.isPegBoardDrawingDifferentField(drawedSelectionRect, this.state.mapFields)){
                    alertService.warn(this.props.t("PEGBOARD_SHOULD_BE_IN_SAME_FIELD"));
                    this.setState({
                        selectedblockpos:{},
                        isPegDrawingShowdash: false,
                        pegDashrect: { startx:0, starty: 0, x: 0, y: 0, width: 0, height: 0, percentage: 0 },
                        ghostWrapperObj: null,
                        isPegDrawing: true,
                        cursorChangeToPeg:true,
                        isRectDrawingCompleted:false,
                        currentSelectedBlock: null
                    },()=>{})
                }else{

                    this.setState((prveState) => {

                        //clone the pegList array
                        let currentPegListArray = [...prveState.pegList];

                        //adding custom peroperty 
                        let updatedPeg = { 
                            ...currentPegListArray[prveState.pegList.length - 1], 
                            pegDrawingRect: drawedSelectionRect,
                            savePegBoard  : false,
                        };

                        currentPegListArray[prveState.pegList.length - 1] = updatedPeg;

                        return { 
                            pegList: currentPegListArray  
                        };
                        
                    }, () => {});

                    this.setState({
                        selectedblockpos:drawedSelectionRect,
                        isPegDrawingShowdash: false,
                        pegDashrect: { startx:0, starty: 0, x: 0, y: 0, width: 0, height: 0, percentage: 0 },
                        ghostWrapperObj: null,
                        isPegDrawing: false,
                        cursorChangeToPeg:false,
                        isRectDrawingCompleted:true,
                        tempCurrentSelectedBlock:null
                    },()=>{
                        this.setSelectedblock();
                    })
                }
            }
        }
    }

    // PEG CR - 2025
    //Calculate peg board drawing outside the field list
    isPegBoardDrawingOutSide = (drawingRect, mapFields) => {
        let isOutSide = false;
        if(Object.keys(mapFields).length > 0){
            for (let key of Object.keys(mapFields)) {
                const field = mapFields[key];
                // NEW UPDATE - 2025 Nov - Check peg board drawing outside the field from itersect field list
                if(drawingRect?.fieldIDs && drawingRect?.fieldIDs.includes(field.actualFieldId)){
                    const fieldY = field.y;
                    if(drawingRect.drawY < fieldY){
                        isOutSide = true;
                    }
                }
            }
        }
        return isOutSide;
    }

    //PEG CR - 2025
    //Calculate peg board creation in same fields
    isPegBoardDrawingDifferentField = (drawingRect, mpFields) => {
        let isDifferentField = false;

        /*if(drawingRect?.drawingDetails?.field?.intersectedShelves?.length > 1 ){
            drawingRect?.drawingDetails?.field?.intersectedShelves?.forEach((selectedShelf, index) => {
            
                const isSimilarShelfs = this.isFindSimilarLevelShelfInDifferentFields(selectedShelf, mpFields);
                
                if (isSimilarShelfs) {
                    isDifferentField = true;
                }

            });
        }*/

        return isDifferentField;
    }

    //PEG CR - 2025
    //Calculate similar level shelf in different fields
    isFindSimilarLevelShelfInDifferentFields = (currentMovingSelectedShelf, mapFields) => {

        const currentFieldCustomId = currentMovingSelectedShelf.field_custom_id;
        const currentY = currentMovingSelectedShelf.y;
        const currentHeight = currentMovingSelectedShelf.drawHeight;
        const currentX = currentMovingSelectedShelf.x;
        const currentDrawWidth = currentMovingSelectedShelf.drawWidth;
        let isDifferentShelf = false;

        const currentBottom = roundOffDecimal(currentY + currentHeight, 2);
    
        let shelvesAtSameLevel = [];

        // Collect shelves that are at the same Y level
        for (const fieldId in mapFields) {
            // if (fieldId === currentFieldCustomId) continue;
            // Skip the same field
           // console.log('fieldId--->', fieldId, 'currentFieldCustomId--->', currentFieldCustomId);
           // if (fieldId === currentFieldCustomId) continue;

           if(fieldId !== currentFieldCustomId) {
                isDifferentShelf = true;
           }

            //const field = mapFields[fieldId];
            //console.log('field-------->', field);
            //const shelves = field.shelf;

            //for (const shelf of shelves) {
                // const shelfY = shelf.y;
                // const shelfHeight = shelf.drawHeight;

                // // Check if the shelf is at the same level (y + height match)
                // console.log('field', roundOffDecimal(shelfY + shelfHeight, 2))
                // console.log('drawing',  roundOffDecimal(currentY + currentHeight, 2))
                // console.log('---------------');
                // if (roundOffDecimal(shelfY + shelfHeight, 2) !== roundOffDecimal(currentY + currentHeight, 2)) {
                //     //shelvesAtSameLevel.push(shelf);
                //     isDifferentShelf = true;
                // }

            //    const shelfBottom = roundOffDecimal(shelf.y + shelf.drawHeight, 2);



               // if (shelfBottom === currentBottom) {
                    // ✅ Found a shelf at the same level in a different field
                    //console.log('✔️ Match in field:', fieldId, '-> Shelf:', shelf);
                    //isDifferentShelf = true
                //}


            //}
        }
        // console.log('isDifferentShelf----->', isDifferentShelf);
        return isDifferentShelf;
    }
    
    //#MP-SML-E-BS1
    setSelectedblock=(iscontextnmenu, contextProd)=>{
        var pselectedBlock = this.state.selectedblockpos;
        let fieldobj = (pselectedBlock.drawingDetails && pselectedBlock.drawingDetails.field?pselectedBlock.drawingDetails.field:null)
        if(fieldobj){
            var minStartX = pselectedBlock.x;
            var minStartY = pselectedBlock.y;
            var minEndY = roundOffDecimal((pselectedBlock.y+pselectedBlock.height),2);
            var minEndX = roundOffDecimal((pselectedBlock.x+pselectedBlock.width),2);
            var retrurnObj=null
            let checkfieldobj = this.state.mapFields[fieldobj.key];
            //OLD Method - Single Product Seletct----
            /*if(iscontextnmenu){
                var contextstruc={
                   isNoproducts:false,
                   selectedProds:contextProd,
                   startProd:contextProd,
                }
                retrurnObj=contextstruc
            }else{
                retrurnObj = GetContainingProdsByBox(minStartX,minStartY,minEndX,minEndY,this.state.mapproductList, checkfieldobj);
            }*/
            //console.log('minStartX===========>', minStartX);
            // ************** Group wise product select here ****************
            retrurnObj = GetContainingProdGroupByBox(minStartX,minStartY,minEndX,minEndY,this.state.mapproductList, checkfieldobj, undefined, undefined, undefined, undefined, this.state.displayRatio);
            // var retrurnObj = GetContainingProdsByBox(minStartX,minStartY,minEndX,minEndY,this.state.mapproductList, checkfieldobj);
            // console.log("loc 3",minStartX,minStartY,minEndX,minEndY,this.state.mapproductList, checkfieldobj);
            var containElem = elmAccordingtoXY(minStartX,minStartY,pselectedBlock.width,pselectedBlock.height,this.state.mapFields,this.state.mapCatRects)
            var containElemend = elmAccordingtoXY(minStartX+pselectedBlock.width,minStartY+pselectedBlock.height,pselectedBlock.width,pselectedBlock.height,this.state.mapFields,this.state.mapCatRects)//box end point
            // console.log(containElem.field.uom);
            if(!retrurnObj.isNoproducts){
                //let notDeletedProds = retrurnObj.selectedProds.filter(x => !x.isDelete);
                let notDeletedProds = retrurnObj.selectedProds;
                // let cactivetool = JSON.parse(JSON.stringify(this.state.activeTool));
                if(notDeletedProds && notDeletedProds.length > 0){
                    this.setState({ activeTool: "default",
                     isviewcmenu: iscontextnmenu?this.state.isviewcmenu:false, contxtmenu: iscontextnmenu?this.state.contxtmenu:{isexpand: false}
                     }, () => { //

                        // var curselloc = notDeletedProds[0];
                        let newblockobj = {  drawingProducts: notDeletedProds,currfielduom:containElem.field?containElem.field.uom:containElemend.field };
                        if(notDeletedProds && notDeletedProds.length > 0){

                            //sorted grouping product list to small x to large x
                            notDeletedProds = notDeletedProds.sort((a,b) => a.x - b.x);

                            var internalProd={
                                prodidx: notDeletedProds[0].prodidx,
                                prod   : notDeletedProds[0]
                            }
                            
                            var isAuismallScreen = ((!this.props.isShowFromPreview && !this.props.isFullscreenEditModal)&&(this.props.simType==="AUI"))?true:false
                            var redY = 0
                            var contextX = this.props.isRTL === "rtl" ? (this.state.rightClickXPos - this.state.AUISideBarGap) - 200 : this.state.rightClickXPos;

                            if(isAuismallScreen){
                                var auiscroll = document.getElementById("aui-sim-scroll-main");
                                redY     = auiscroll.scrollTop;
                                contextX = this.props.isRTL === "rtl" ?(this.state.rightClickXPos - this.state.AUISideBarGap) - 600:contextX-this.state.AUISideBarGap;
                            }

                            let cobj = {
                                xpos: contextX,//e.clientX,
                                ypos: (this.state.rightClickYPos+redY)-110, //e.clientY
                            };

                            let prodlist = this.state.mapproductList.filter(x => !x.isDelete);
                            let index    = prodlist.findIndex(p=>p.id.toString() === notDeletedProds[notDeletedProds.length-1].id.toString());
                            cobj["prodidx"] = index;
                            cobj["citem"]   = notDeletedProds[notDeletedProds.length-1];

                            this.setState({
                                currentInternalDraggableProd: internalProd,
                                currentDraggableProd:notDeletedProds[0],
                                // activeTool: cactivetool,
                                isselectprodblock: true,
                                isblockmove: true,
                                currentSelectedBlock: newblockobj,
                                contxtmenu:iscontextnmenu?this.state.contxtmenu:{isexpand: false},
                                selectedlocobj: null,
                                isGroupContexMenu: true,
                                isGroupExpand: true,
                                groupExpandLeftSideProduct: notDeletedProds[0], 
                                groupExpandRightSideProduct: notDeletedProds[notDeletedProds.length-1],
                                contxtmenu: cobj,
                            },()=>{
                                this.handleToolControls(this.state.svgViewId,"drawBlock")
                                //temporary set peg board under selected product block
                                if(this.state.tempCurrentSelectedBlock === null){
                                    this.setState({tempCurrentSelectedBlock:this.state.currentSelectedBlock});
                                }
                            });
                        } else{
                            alertService.error(this.props.t("PRODUCT_BLOCK_NOT_FOUND"));
                        }
                    });
                }

            }
        }
    }

    handlePreviewModal = (obj, type) =>{
        this.setState({productId:(obj?(obj.productId?obj.productId:obj.id):0), showPreviewImageModal:type});
    }

    handleBlockContextMenu=(e,isshow,x,y,width,height,selectedprods)=>{
        // let editwrapper = document.getElementById(this.state.wrapperId);
        // let viewboxcoords = this.getScreenPointer(e);
        // let reducescrolledgap = (viewboxcoords.x - editwrapper.scrollLeft);

        var isAuismallScreen=((!this.props.isShowFromPreview && !this.props.isFullscreenEditModal)&&(this.props.simType==="AUI"))?true:false
        var redY=0
        var contextX = this.props.isRTL ==="rtl" ? (e.clientX - this.state.AUISideBarGap) - 200 :  e.clientX;
        if(isAuismallScreen){
            var auiscroll=document.getElementById("aui-sim-scroll-main")
            redY=auiscroll.scrollTop
            contextX=this.props.isRTL === "rtl" ?(e.clientX-this.state.AUISideBarGap)-600:e.clientX

        }

        let cobj = {
            xpos: contextX,//e.clientX,
            ypos: (e.clientY+redY)-110,//e.clientY
        };
        //if block item have selected only one produc
        if(selectedprods&&selectedprods.length===1){
            let prodlist=this.state.mapproductList

            let index=prodlist.findIndex(p=>p.id.toString()===selectedprods[0].id.toString())
            cobj["prodidx"]=index
            cobj["citem"]=selectedprods[0]
            this.setState({ isviewcmenu: isshow, contxtmenu: cobj });
        }else{
            const firstGroupId = selectedprods[0]?.groupId;
            const hasUniqueGroupIds = selectedprods.every(p=>p.groupId === firstGroupId);

            if(hasUniqueGroupIds){
                const sortedSelectedProduct = selectedprods.sort((a, b) => a.x - b.x);

                // As new CR need to show first context menu for all selected product
                // add last object as selected
                let prodlist=this.state.mapproductList
                let index=prodlist.findIndex(p=>p.id.toString()===selectedprods[selectedprods.length-1].id.toString())
                cobj["prodidx"]=index
                cobj["citem"]=selectedprods[selectedprods.length-1]
                this.setState({ 
                    isviewcmenu: isshow, 
                    isGroupContexMenu: true,
                    contxtmenu: cobj, 
                    isGroupExpand: true, 
                    groupExpandLeftSideProduct: sortedSelectedProduct[0], 
                    groupExpandRightSideProduct: sortedSelectedProduct[sortedSelectedProduct.length-1],
                });
            }else{
                //block context menu display
                this.setState({ isviewcmenu2: isshow, contxtmenu2: cobj }); // second context menu
            }
        }

    }
    confirmingDeleteSelecteBlock=()=>{
        this.handleSelectedBlockDelete();
    }
    //#MP-SML-E-BD1
    handleSelectedBlockDelete = () => {
        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),2);

        let cprodlist = this.state.mapproductList;
        let filteredCprodlist = cprodlist.filter(x => !x.isDelete);
        let selectedblock = JSON.parse(JSON.stringify(this.state.currentSelectedBlock));
        // let firstitem = selectedblock.newDrawingProducts[0];
        // let removecount = selectedblock.newDrawingProducts.length;
        //cat rect chenged track
        this.TouchedCatListUpdate(selectedblock.newDrawingProducts[0].categoryRectId)
        let isruleupdating = false;
        let deleteprodlist = [];
        for (let s = 0; s < selectedblock.newDrawingProducts.length; s++) {
            const selectedproditem = selectedblock.newDrawingProducts[s];
            filteredCprodlist[selectedproditem.prodidx]["isDelete"] = true;

            if(selectedproditem.subcategory && selectedproditem.subcategory.type === catRectEnums.rule){
                isruleupdating = true;
            }

            let isalreadyadded = deleteprodlist.findIndex(x => x.prodobj.productId === selectedproditem.productId);
            if(isalreadyadded === -1){
                let removecount = selectedblock.newDrawingProducts.filter(z => z.productId === selectedproditem.productId);
                deleteprodlist.push({prodobj: selectedproditem, removecount: removecount.length});
            }
        }
        // console.log(deleteprodlist);

        this.setState({ mapproductList: filteredCprodlist, currentSelectedBlock: null, isviewcmenu2: false, currentInternalDraggableProd: null }, () => {

            if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
            }

            if(deleteprodlist.length > 0){
                for (let i = 0; i < deleteprodlist.length; i++) {
                    const delteproditem = deleteprodlist[i];
                    this.handleRemoveProductCounter(delteproditem.prodobj, delteproditem.removecount);
                }
            }

            this.props.handlehaveChnagesinCat(true);
            //check non sim render count and display mange
            this.nonSimProddropremoveCounterupdate("blockDelete")
            //update rule list if item sub cat is rule
            if(isruleupdating){
                let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, false);
                // console.log(updaterulelist);

                this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
            }

            //reload imported product update
            this.compareImportedProds();
        });
    }

    hadnleremoveblockcounter=(shelfIdx,brnadidx)=>{
        var  prods=this.state.currentSelectedBlock.drawingProducts
        for (let i = 0; i < prods.length; i++) {
            const prod = prods[i];
            this.handleRemoveProductCounter(prod,shelfIdx,brnadidx,1);

        }
    }
    //#MP-SML-E-BCU1
    //cut block
    handleBlockCut = (iscopy,isFromDelete) => {
        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),2);
        // if(!iscopy){
        //     this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),2);
        // }
        
        // filter for getting non deleted products...
        // let cprodlist = this.state.mapproductList.filter(x => !x.isDelete);
        let cprodlist = this.state.mapproductList;

        let selectedblock = this.state.currentSelectedBlock;

        // check if selected block have mixing hanged products
        if(selectedblock?.drawingProducts.length > 0){
            // if mixing any, isHagged true & false products, return the error
            let isHangedTrue = selectedblock.drawingProducts.some(p => p.isHanged === true);
            let isHangedFalse = selectedblock.drawingProducts.some(p => p.isHanged === false || p.isHanged === undefined);

            if(isHangedTrue && isHangedFalse){
                alertService.error(this.props.t("CANNOT_CUT_MIXING_HANGED_PRODUCTS"));
                this.setState({currentSelectedBlock: null, isviewcmenu2: false, isviewcmenu: false, isGroupContexMenu: false, currentInternalDraggableProd: null})
                return;
            }
        }

        //cat rect chenged track
        this.TouchedCatListUpdate(selectedblock?.newDrawingProducts[0]?.categoryRectId)
        let selcutlist = null;
        let isruleupdating = false;
        var shelfs=[]
        //counter
        let deleteprodlist = [];
        let deletedPegProducts = [];
        //end
        for (let s = 0; s < selectedblock?.selectedshelves.length; s++) {
            const shlfitem = selectedblock.selectedshelves[s];
            let products=shlfitem.selectedProducts
            // set price tag Latest properties for clipboard
            products.forEach(prod => {
                if(prod.hasPriceTag || prod.product?.hasPriceTag){
                    prod["hasPriceTagLatest"] = prod.hasPriceTag;
                    prod["priceTagGapLatest"] = prod.priceTagGap;
                    prod["priceTagHeightLatest"] = prod.priceTagHeight;
                    if(prod.product){
                        prod.product["hasPriceTagLatest"] = prod.product.hasPriceTag;
                        prod.product["priceTagGapLatest"] = prod.product.priceTagGap;
                        prod.product["priceTagHeightLatest"] = prod.product.priceTagHeight;
                    }
                } else {
                    prod["hasPriceTagLatest"] = false;
                    prod["priceTagGapLatest"] = 0;
                    prod["priceTagHeightLatest"] = 0;
                    if(prod.product){
                        prod.product["hasPriceTagLatest"] = false;
                        prod.product["priceTagGapLatest"] = 0;
                        prod.product["priceTagHeightLatest"] = 0;
                    }
                }
            });
            // products.forEach(prod => {
            //     prod["startingPointDraw"]=prod.x
            //     prod["startingPoint"]=prod.x/this.state.displayRatio
            //     prod.isNew= true
            //     prod.isDelete= false
            // });
            // selcutlist.push({ rank: shlfitem.rank, iscopy: iscopy, prods: shlfitem.selectedProducts });

            if(!iscopy){
                for (let j = 0; j < shlfitem.selectedProducts.length; j++) {
                    const sproditem = shlfitem.selectedProducts[j];
                    cprodlist[sproditem.prodidx]["isDelete"] = true;
                    if(sproditem?.isHanged){
                        deletedPegProducts.push(sproditem);
                    }
                    if(cprodlist[sproditem.prodidx].subcategory && cprodlist[sproditem.prodidx].subcategory.type === catRectEnums.rule){
                        isruleupdating = true;
                    }

                    //counter
                    let isalreadyadded = deleteprodlist.findIndex(x => x.prodobj.productId === sproditem.productId);
                    if(isalreadyadded === -1){
                        let removecount = selectedblock.newDrawingProducts.filter(z => z.productId === sproditem.productId);
                        deleteprodlist.push({prodobj: sproditem, removecount: removecount.length});
                    }
                     //end
                }
            }
            shelfs.push({shelfRank:shlfitem.rank,products:products})
        }
        //making new clip board obj
        selcutlist={
            groupUUID: uuidv4(),isNew:true, isDelete: false, mode: isFromDelete?"delete":iscopy?"copy":"cut" ,uom:selectedblock?.currfielduom,shelf:shelfs
        }

        // PEG CR - 2025 March
        this.updatePegProductSetWhenDeleted(deletedPegProducts);

        this.updateCutList(selcutlist);
        this.setState({ mapproductList: cprodlist, currentSelectedBlock: null, isviewcmenu2: false, isviewcmenu: false, isGroupContexMenu: false, currentInternalDraggableProd: null }, () => {
            // update actual field list spacing after deleted products
            this.updateActualFieldListSpacing();
            
            if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
            }

            //counter
            if(deleteprodlist.length > 0){
                for (let i = 0; i < deleteprodlist.length; i++) {
                    const delteproditem = deleteprodlist[i];
                    this.handleRemoveProductCounter(delteproditem.prodobj, delteproditem.removecount);
                }
            }
            //end

            //check non sim render count and display mange
             this.nonSimProddropremoveCounterupdate("blockCut")
            //update rule list if item sub cat is rule
            if(isruleupdating){
                let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, false);
                // console.log(updaterulelist);

                this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
            }

            // this.cacheClipboardandOtherOnlyCutProdsReplace()

            //reload imported product update
            this.compareImportedProds();
        });
    }

    // Add deleted products to clipboard - following handleBlockCut methodology
    // Each shelf group is pushed to clipboard separately, one by one
    handleDeletedProductsToClipboard = (deletedProducts) => {
        if (!deletedProducts || deletedProducts.length === 0) {
            return;
        }

        console.log("CLIP-deletedProducts", deletedProducts);

        // Get UOM once
        const currfielduom = this.state.selectedCatRect?.fieldList?.[0]?.uom ||
                             (deletedProducts[0]?.products?.[0]?.uom) ||
                             (deletedProducts[0]?.uom) ||
                             'mm';

        // Process each shelf group separately
        deletedProducts.forEach(shelfGroup => {
            // Check if this is a grouped format (from DisplayUnitEdit)
            if (shelfGroup.products && shelfGroup.shelfRank !== undefined) {
                // Step 1: Create shelf array for this group
                const shelfs = [{
                    shelfRank: shelfGroup.shelfRank,
                    products: shelfGroup.products
                }];

                console.log(`CLIP-Shelf ${shelfGroup.shelfRank} products:`, shelfs);

                // Step 2: Create clipboard object for this shelf group
                const clipboardObj = {
                    groupUUID: uuidv4(), // Unique UUID for each shelf group
                    isNew: true,
                    isDelete: false,
                    mode: "cut",
                    uom: currfielduom,
                    shelf: shelfs
                };

                // Step 3: Push this shelf group to clipboard
                this.updateCutList(clipboardObj);
                console.log(`CLIP-Shelf ${shelfGroup.shelfRank} clipboardObj:`, clipboardObj);
            } else {
                // Fallback: Old format - single product or ungrouped products
                // Group by shelf rank if needed
                const shelfRank = shelfGroup.shelfrank || 0;
                const shelfs = [{
                    shelfRank: shelfRank,
                    products: [shelfGroup]
                }];

                const clipboardObj = {
                    groupUUID: uuidv4(),
                    isNew: true,
                    isDelete: false,
                    mode: "cut",
                    uom: currfielduom,
                    shelf: shelfs
                };

                this.updateCutList(clipboardObj);
                console.log(`CLIP-Single product clipboardObj:`, clipboardObj);
            }
        });
    }

     //cut block old
    //  handleBlockCutOld = (iscopy) => {
    //     // this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),2);
    //     if(!iscopy){
    //         this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),2);
    //     }

    //     let cprodlist = this.state.mapproductList;
    //     let selectedblock = this.state.currentSelectedBlock;
    //     //cat rect chenged track
    //     this.TouchedCatListUpdate(selectedblock.newDrawingProducts[0].categoryRectId)
    //     let selcutlist = [];
    //     let isruleupdating = false;
    //     for (let s = 0; s < selectedblock.selectedshelves.length; s++) {
    //         const shlfitem = selectedblock.selectedshelves[s];
    //         selcutlist.push({ rank: shlfitem.rank, iscopy: iscopy, prods: shlfitem.selectedProducts });

    //         if(!iscopy){
    //             for (let j = 0; j < shlfitem.selectedProducts.length; j++) {
    //                 const sproditem = shlfitem.selectedProducts[j];

    //                 cprodlist[sproditem.prodidx]["isDelete"] = true;

    //                 if(cprodlist[sproditem.prodidx].subcategory && cprodlist[sproditem.prodidx].subcategory.type === catRectEnums.rule){
    //                     isruleupdating = true;
    //                 }
    //             }
    //         }
    //     }


    //     this.updateCutList(selcutlist);
    //     this.setState({ mapproductList: cprodlist, currentSelectedBlock: null, isviewcmenu2: false, currentInternalDraggableProd: null }, () => {

    //         if(this.props.simType === "AUI" || this.props.simType === "Normal"){
    //             const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
    //             this.props.getProductAnomalies(this.props.mapFields,combinedPrds)
    //         }

    //         //check non sim render count and display mange
    //          this.nonSimProddropremoveCounterupdate("blockCut")
    //         //update rule list if item sub cat is rule
    //         if(isruleupdating){
    //             let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, false);
    //             // console.log(updaterulelist);

    //             this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
    //         }

    //         this.cacheClipboardandOtherOnlyCutProdsReplace()
    //     });
    // }

    handleclipbordopen=(seltab)=>{
        if(this.state.isStackableEdited){
            this.sendmarkStackableCall()
        }

        this.setState({productTab: seltab},()=>{
            if(this.state.productTab!== "saleCycle" && seltab !== "saleCycle"){
                 this.setState({selectedScProductId: -1})
            }

            //close excel info popover
            this.closeExcelUploadFile();
        })
    }
    //load ghost from parent
    ghostFromParent = (evt, viewobj, isignore) => {
        let ghostviewobj = this.state.ghostWrapperObj;
        // console.log(ghostviewobj);
        
        if(!isignore && ghostviewobj){
            viewobj.drawWidth = ghostviewobj.width;
            viewobj.drawHeight = ghostviewobj.height;
        }

        ghostOnDrag(evt, viewobj, this.oriPageXY);
    }
    handleXrayDepView=(type)=>{
        this.setState({xrayActive:type})
    }
    updateProductList=(mapprodList, isruleupdating, isExpand = false)=>{

        this.setState({mapproductList:mapprodList, currentSelectedBlock: null, currentInternalDraggableProd: null, isContentDragging: false}, () => {
            // update actual field list spacing after expand products
            this.updateActualFieldListSpacing();

            if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
            }

            this.nonSimProddropremoveCounterupdate("updateprodList")
            //update rule list if item sub cat is rule
            //update rule list if item sub cat is rule
            if(isruleupdating){
                let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, false);
                // console.log(updaterulelist);

                this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
            }

            // group id update
            this.groupByProduct();
        });
        this.props.handlehaveChnagesinCat(true);
    }

    
    // newClipBoardToched=(value)=>{
    //     this.setState({isNewClipBoardTouched:value})
    // }
    //
    updateSingleCutProduct = (dragprod, isremove, cidx, groupUUID, ismanualRemove) => {
        // let cutarray = this.state.newCutarray;
        let cutarray = this.state.cutNewArray;
        if(!isremove){
            let selectedgroupidx = cutarray?.findIndex(x=>x.groupUUID === dragprod.clipGroupid || x.groupUUID === dragprod.groupUUID);
            let selectedshelfidx = cutarray[selectedgroupidx]?.shelf?.findIndex(c => c.shelfrank === dragprod.clipShelfrank || c.shelfRank === dragprod.clipShelfrank)
            let changingitem     = cutarray[selectedgroupidx]?.shelf[selectedshelfidx];
            // let selectedprodidx=cutarray[selectedgroupidx].shelf[selectedshelfidx].products.findIndex(v=>v.id=dragprod.clipprodid)
            // let changingitem = cutarray[dragprod.cutidx].shelf[dragprod.cutshelfidx];
            // let changingitem =cutarray.find(x=>x.groupUUID===dragprod.clipGroupid).find(c=>c.shelfRank===dragprod.clipShelfrank).find(v=>v.clipprodid)
            let cutitems     = []; 
            let reduceamount = 0;
            let totalwidth   = 0;
            for (let i = 0; i < changingitem?.products.length; i++) {
                const cutprod = changingitem?.products[i];
                //new method for keeping remaning groups when remove group from clipboard
                if(dragprod.singleidx !== cutprod.groupId){
                    if(cutprod.isDelete !== true){
                        cutprod.x = (cutprod.x - reduceamount);
                        cutprod.startingPoint = cutprod.x/this.state.displayRatio
                        totalwidth = (cutprod.x + cutprod.drawWidth);
                    }
                    cutitems.push(cutprod);
                }else{
                    //cutprod.isDelete = true;
                    //cutitems.push(cutprod);
                    reduceamount += cutprod.drawWidth;
                }
                //old method for keeping remaning items when remove item from clipboard......
                // if(dragprod.singleidx !== i){
                //     if(cutprod.isDelete!==true){
                //         cutprod.x = (cutprod.x - reduceamount);
                //         cutprod.startingPoint= cutprod.x/this.state.displayRatio
                //         totalwidth = (cutprod.x + cutprod.drawWidth);
                //     }
                //     cutitems.push(cutprod);
                // } else {
                //     cutprod.isDelete=true
                //     cutitems.push(cutprod);
                //     reduceamount = cutprod.drawWidth;
                // }
            }
            var filteredcutitems = cutitems?.filter(x => x.isDelete !== true)
            if(filteredcutitems.length > 0){
                changingitem.products = cutitems;
                changingitem["width"] = totalwidth;
            } else{
                // if(cutarray.isNew){
                //     cutarray.splice(selectedgroupidx, 1);
                // }else{
                cutarray[selectedgroupidx].shelf[selectedshelfidx].isDelete = true
                var filtershelves = cutarray[selectedgroupidx]?.shelf.filter(f => f.isDelete !== true)
                if(filtershelves.length === 0){
                    cutarray[selectedgroupidx].isDelete = true
                }
                // }
            }
            var notdeletedshelves = cutarray[selectedgroupidx]?.shelf.filter(c => c.isDelete !== true)
            var notdeletedshelvesmaxwidthsort = notdeletedshelves.sort((a,b) =>  b.width - a.width);
            if(notdeletedshelvesmaxwidthsort.length > 0){
                cutarray[selectedgroupidx].width = notdeletedshelvesmaxwidthsort[0].width
                var cheight = 0
                notdeletedshelves.forEach(shlf => {
                    cheight = cheight + shlf.height
                });
                cutarray[selectedgroupidx].height = cheight
            }
        } else{
            var findixd = this.state.cutNewArray.findIndex(v => v.groupUUID === groupUUID)
            if(ismanualRemove)  {
                confirmAlert({
                    title: this.props.t('SURE_TO_REMOVE_THIS'),
                    message: this.props.t('THIS_WILL_REMOVE_FROM_CLIPBOARD_AFTER_SAVE_PLANOGRAM_SURETO_CONTINUE'),
                    overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
                    buttons: [{
                        label: this.props.t('btnnames.yes'),
                        onClick: () => {
                            this.setState({isClipboardreload:false},() => {
                                // this.newClipBoardToched(true)
                                this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),2);
                                if(cutarray[findixd].isNew){
                                    cutarray.splice(findixd, 1);
                                }else{
                                    cutarray[findixd].isDelete = true
                                }
                                this.setState({
                                    isClipboardreload:true
                                })
                            })

                        }
                    }, {
                        label: this.props.t('btnnames.no')
                    }]
                });

            }else{
                if(cutarray[findixd].isNew){
                    cutarray.splice(findixd, 1);
                }else{
                    cutarray[findixd].isDelete = true
                }
            }
        }
        // this.setState({ cutArray: cutarray },()=>{
        this.setState({ cutNewArray: cutarray },()=>{
            // this.cacheClipboardandOtherOnlyCutProdsReplace()
        });
        this.props.handlehaveChnagesinCat(true);

    }

    clearSelectedCutProducts = (selectedGroupUUIDs) => {
        confirmAlert({
            title: this.props.t('SURE_TO_REMOVE_THIS'),
            message: this.props.t('THIS_WILL_REMOVE_SELECTED_FROM_CLIPBOARD_AFTER_SAVE_PLANOGRAM_SURETO_CONTINUE'),
            overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
            buttons: [{
                label: this.props.t('btnnames.yes'),
                onClick: () => {
                    this.setState({ isClipboardreload: false }, () => {
                        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)), 2);
                        let cutarray = [...this.state.cutNewArray];
                        for (let i = cutarray.length - 1; i >= 0; i--) {
                            if (selectedGroupUUIDs.includes(cutarray[i].groupUUID)) {
                                this.updateSingleCutProduct(null, true, i, cutarray[i].groupUUID, false);
                            }
                        }
                        this.setState({ isClipboardreload: true });
                        if (this.props.handlehaveChnagesinCat) this.props.handlehaveChnagesinCat(true);
                    });
                }
            }, {
                label: this.props.t('btnnames.no')
            }]
        });
    }
    
    clearAllCutProducts = () => {
        confirmAlert({
            title: this.props.t('SURE_TO_REMOVE_THIS'),
            message: this.props.t('THIS_WILL_REMOVE_ALL_FROM_CLIPBOARD_AFTER_SAVE_PLANOGRAM_SURETO_CONTINUE'),
            overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
            buttons: [{
                label: this.props.t('btnnames.yes'),
                onClick: () => {
                    this.setState({ isClipboardreload: false }, () => {
                        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)), 2);
                        let cutarray = [...this.state.cutNewArray];
                        for (let i = cutarray.length - 1; i >= 0; i--) {
                            this.updateSingleCutProduct(null, true, i, cutarray[i].groupUUID, false);
                        }
                        this.setState({ isClipboardreload: true });
                        if (this.props.handlehaveChnagesinCat) this.props.handlehaveChnagesinCat(true);
                    });
                }
            }, {
                label: this.props.t('btnnames.no')
            }]
        });
    }

    //update cut list
    updateCutList = (cutlist) => {
        // if(cutlist && cutlist.length > 0){
        if(cutlist&&cutlist.shelf.length>0 ){
            let curcutlist = this.state.cutNewArray;

            // for (let i = 0; i < cutlist.length; i++) {
                // const cutshelfobj = JSON.parse(JSON.stringify(cutlist[i]));
                const cutshelfobj = cutlist
                var maxwdithoftile=0
                var maxheightoftile=0

                cutshelfobj.shelf.forEach(cutshelf => {
                    if(cutshelf.products.length === 0) return null; // if no products hanged on peg baord
                    // let sorttolowy = cutshelf.products.sort((a,b) => a.y - b.y);
                    //cutshelf.shelfRank=cutshelf.shelfrank **************** 
                    let toheighstsortarray= JSON.parse(JSON.stringify(cutshelf.products))
                    let sorttomaxheight = toheighstsortarray.sort((a,b) =>  b.height - a.height);
                    // let lowyprody = sorttolowy[0].y;

                    let sortprods = cutshelf.products.sort((a,b) => a.x - b.x);

                    let lowestxprod = JSON.parse(JSON.stringify(sortprods[0]));
                    let svgwidth = 0; let svgheight = 0;
                    let maxheightofprod=0
                    let hanggedProductsX = 0;
                    for (let j = 0; j < sortprods.length; j++) {
                        const sortitem = sortprods[j];

                        let gapbetweenlowest = (sortitem.x - lowestxprod.x);
                        // handle hangged products
                        // if prev product and current porudtc is hanged then we need to set the x position of prev product x + product width
                        if(j > 0 && sortprods[j-1]?.isHanged && sortprods[j-1].isHanged === true && sortitem?.isHanged && sortitem?.isHanged === true){
                            gapbetweenlowest = (sortprods[j-1].x + sortprods[j-1].drawWidth);
                        }
                        sortitem["x"] = gapbetweenlowest;
                        sortitem["startingPointDraw"]=sortitem.x
                        sortitem["startingPoint"]=sortitem.x/this.state.displayRatio
                        sortitem.isNew= true
                        sortitem.isDelete= false
                        sortitem["xCoppy"] = gapbetweenlowest;
                        sortitem["drawWidthCoppy"] = sortitem.drawWidth;
                        sortitem["drawHeightCoppy"] = sortitem.drawHeight;
                        let gapbetweenlowesty = sorttomaxheight[0].drawHeight-sortitem.drawHeight//(sortitem.y - lowyprody);
                        sortitem["gaptolowy"] = gapbetweenlowesty;
                        // Preserve price tag properties for clipboard - add Latest versions from existing properties
                        // if(sortitem.hasPriceTag || sortitem.product?.hasPriceTag){
                        //     sortitem["hasPriceTagLatest"] = sortitem.hasPriceTag || sortitem.product?.hasPriceTag;
                        //     sortitem["priceTagGapLatest"] = sortitem.priceTagGap || sortitem.product?.priceTagGap;
                        //     sortitem["priceTagHeightLatest"] = sortitem.priceTagHeight || sortitem.product?.priceTagHeight;
                        // }
                        
                        svgwidth = (gapbetweenlowest + sortitem.drawWidth);
                        svgheight = (svgheight < sortitem.drawHeight?sortitem.drawHeight:svgheight);
                        maxheightofprod=maxheightofprod<sortitem.drawHeight?sortitem.drawHeight:maxheightofprod
                    }
                    maxheightoftile=maxheightoftile+maxheightofprod
                    cutshelf["id"] = uuidv4();
                    cutshelf["width"] = svgwidth;
                    cutshelf["height"] = svgheight;
                    // cutshelf["widthCoppy"] = svgwidth;
                    // cutshelf["heightCoppy"] = svgheight;
                    // cutshelf["ratio"] = this.state.displayRatio;

                    // cutshelf["added_categoryRectId"] = sortprods[0].categoryRectId;
                    cutshelf.products = sortprods;
                    maxwdithoftile=maxwdithoftile<cutshelf.width?cutshelf.width:maxwdithoftile

                });
                cutshelfobj["width"]=maxwdithoftile
                cutshelfobj["height"]=maxheightoftile
                cutshelfobj["is_cutitem"] = true;
                curcutlist.push(cutshelfobj);
            // }
            this.setState({ cutNewArray: curcutlist },()=>{
                // this.cacheClipboardandOtherOnlyCutProdsReplace()
            });
            this.props.handlehaveChnagesinCat(true);
            // Mark changes for refresh indicator
            this.markChangesForRefresh();
        }
    }
     //update cut list
    //  updateCutListOld = (cutlist) => {
    //     // console.log(cutlist);

    //     if(cutlist && cutlist.length > 0){
    //         let curcutlist = this.state.cutArray;

    //         for (let i = 0; i < cutlist.length; i++) {
    //             const cutshelf = JSON.parse(JSON.stringify(cutlist[i]));

    //             let sorttolowy = cutshelf.prods.sort((a,b) => a.y - b.y);
    //             let lowyprody = sorttolowy[0].y;

    //             let sortprods = cutshelf.prods.sort((a,b) => a.x - b.x);

    //             let lowestxprod = JSON.parse(JSON.stringify(sortprods[0]));
    //             let svgwidth = 0; let svgheight = 0;
    //             for (let j = 0; j < sortprods.length; j++) {
    //                 const sortitem = sortprods[j];

    //                 let gapbetweenlowest = (sortitem.x - lowestxprod.x);
    //                 sortitem["x"] = gapbetweenlowest;
    //                 sortitem["xCoppy"] = gapbetweenlowest;
    //                 sortitem["drawWidthCoppy"] = sortitem.drawWidth;
    //                 sortitem["drawHeightCoppy"] = sortitem.drawHeight;
    //                 let gapbetweenlowesty = (sortitem.y - lowyprody);
    //                 sortitem["gaptolowy"] = gapbetweenlowesty;

    //                 svgwidth = (gapbetweenlowest + sortitem.drawWidth);
    //                 svgheight = (svgheight < sortitem.drawHeight?sortitem.drawHeight:svgheight);
    //             }

    //             cutshelf["id"] = uuidv4();
    //             cutshelf["width"] = svgwidth;
    //             cutshelf["height"] = svgheight;
    //             cutshelf["widthCoppy"] = svgwidth;
    //             cutshelf["heightCoppy"] = svgheight;
    //             cutshelf["ratio"] = this.state.displayRatio;
    //             cutshelf["is_cutitem"] = true;
    //             cutshelf["added_categoryRectId"] = sortprods[0].categoryRectId;
    //             cutshelf.prods = sortprods;

    //             curcutlist.push(cutshelf);
    //         }

    //         // console.log(curcutlist);
    //         this.setState({ cutArray: curcutlist },()=>{
    //             this.cacheClipboardandOtherOnlyCutProdsReplace()
    //         });
    //         this.props.handlehaveChnagesinCat(true);
    //     }
    // }
    //toggle clipboard drag type
    toggleClipDragType = (ctype) => {
        this.setState({ clipDragType: ctype });
    }

    setPreviewGuid = (isReset, previewShelves, field, isMoveClear, previewSendProdList) => {
        // console.log(structuredClone(previewShelves));

        let filedmapobj = this.state.mapFields;
        // let previewProdList = (previewSendProdList && previewSendProdList.length > 0?previewSendProdList:[]);
        let previewProdList = [];
        let ghostobj = { width: 0, height: 0 };

        let uniqueFieldCustomIds = [];
        if(this.state.ghostWrapperObj){
            if(this.state.ghostWrapperObj?.selectedShelfSet && this.state.ghostWrapperObj?.selectedShelfSet.length > 0){
                // Extract unique field_custom_id values
                uniqueFieldCustomIds = [...new Set(this.state.ghostWrapperObj?.selectedShelfSet.map(item => item.field_custom_id))];
            }
        }

        if(isReset || isMoveClear){
            for (let key of Object.keys(filedmapobj)) {
                let fieldobj = filedmapobj[key];

                for (let i = 0; i < fieldobj.shelf.length; i++) {
                    const fieldshelf = fieldobj.shelf[i];
                    fieldshelf["previewguid"] = {startX:-1,EndX:-1};
                }
            }

            for (let l = 0; l < document.getElementsByClassName("sftrect-notdis").length; l++) {
                const element = document.getElementsByClassName("sftrect-notdis")[l];
                element.style.fill = 'transparent';
            }

            if(isMoveClear){
                this.setState({ isFirstTimeDrawguid: false });
            } else{
                this.setState({ isContentDragging: false, ghostWrapperObj: null });
            }


        } else if(field){
            let selectedfield = filedmapobj[field.key];

            let availableDropShelfs = 0;

            for (let i = 0; i < selectedfield.shelf.length; i++) {
                let shelfitem = selectedfield.shelf[i];

                if(isReset){
                    shelfitem["previewguid"] = { startX: -1, EndX: -1 };
                } else{
                    let findshelffrompreview = previewShelves.findIndex(x => x.rank === shelfitem.rank);

                    if(findshelffrompreview > -1){
                        shelfitem = previewShelves[findshelffrompreview];

                        if(shelfitem.previewguid.startX > -1){
                            availableDropShelfs += 1;
                            let gapbetweenguidelines = (shelfitem.previewguid.endX - shelfitem.previewguid.startX);

                            ghostobj.width = (gapbetweenguidelines > ghostobj.width?gapbetweenguidelines:ghostobj.width);
                            ghostobj.height += (shelfitem.drawHeight + shelfitem.drawGap);
                        }
                        

                        //find shelf preview guide inside prods list

                        // old method
                        // if(previewProdList.length === 0){
                        //     let checkstartx = shelfitem.previewguid.startX;
                        //     let checkendx = shelfitem.previewguid.endX;

                        //     let selblock = this.state.currentSelectedBlock;
                        //     let selblockprods = (selblock && selblock.newDrawingProducts?selblock.newDrawingProducts:[]);

                        //     let filterprodlist = this.state.mapproductList.filter(proditem => {
                        //         let isnotignore = (proditem.shelfrank === shelfitem.rank?selblockprods.findIndex(bprod => bprod.id === proditem.id):0);

                        //         let checkprodx = (proditem.x + this.state.saftyMargin);
                        //         let checkprodx2 = ((proditem.x + proditem.drawWidth) - this.state.saftyMargin);

                        //         return (isnotignore === -1 &&
                        //             ((proditem.x >= checkstartx && checkprodx2 <= checkendx) ||
                        //             (checkprodx < checkstartx && checkstartx < checkprodx2) ||
                        //             (checkprodx < checkendx && checkendx < checkprodx2))
                        //         );
                        //     });

                        //     // console.log(filterprodlist);
                        //     previewProdList = previewProdList.concat((filterprodlist && filterprodlist.length > 0?filterprodlist:[]));
                        // }

                        // new method
                        if(previewProdList.length === 0){
                            let checkstartx = shelfitem.previewguid.startX;
                            let checkendx = shelfitem.previewguid.endX;

                            let selblock = this.state.currentSelectedBlock;
                            let selblockprods = (selblock && selblock.newDrawingProducts?selblock.newDrawingProducts:[]);

                            let filterprodlist = this.state.mapproductList.filter(proditem => {
                                let isnotignore = (proditem.shelfrank === shelfitem.rank?selblockprods.findIndex(bprod => bprod.id === proditem.id):0);
                               
                                // check product is in the selected shelf set only
                                if(uniqueFieldCustomIds.length > 0){
                                    if (!uniqueFieldCustomIds.includes(proditem.field_custom_id)) {
                                        return false;
                                    }
                                }
                                
                                let checkprodx = (proditem.x);
                                let checkprodx2 = ((proditem.x + proditem.drawWidth));

                                let overlapWidth = Math.min(checkendx, checkprodx2) - Math.max(checkstartx, checkprodx);
                                if (overlapWidth > 0) {
                                    return (isnotignore === -1 &&
                                        ((proditem.x >= checkstartx && checkprodx2 <= checkendx) ||
                                        (checkprodx < checkstartx && checkstartx < checkprodx2) ||
                                        (checkprodx < checkendx && checkendx < checkprodx2))
                                      );
                                } else {
                                return false;
                                }
                            });

                            // console.log(filterprodlist);
                            previewProdList = previewProdList.concat((filterprodlist && filterprodlist.length > 0?filterprodlist:[]));
                        }
                    } else{
                        shelfitem["previewguid"]={startX:-1,EndX:-1}
                    }
                }
            }
            // console.log(previewheight);

            let blockcutitem = (this.state.currentDraggableProd && this.state.currentDraggableProd.is_cutitem?true:false);
            let blockshelfcount = (blockcutitem?this.state.currentDraggableProd.shelf:[]);

            if(!blockcutitem || (blockcutitem && blockshelfcount.length === availableDropShelfs)){
                this.setState({ isFirstTimeDrawguid: true});

            } else{
                for (let key of Object.keys(filedmapobj)) {
                    let fieldobj = filedmapobj[key];
                    

                    for (let i = 0; i < fieldobj.shelf.length; i++) {
                        const fieldshelf = fieldobj.shelf[i];
                        fieldshelf["previewguid"] = {startX:-1,EndX:-1};
                    }
                }
                this.setState({ isFirstTimeDrawguid: false});
            }
        }

        this.setState({
            mapFields: filedmapobj,
            guideProdList: previewProdList,
            droppingShelfList: previewShelves,
            ghostWrapperObj: (ghostobj.height > 0?ghostobj:this.state.ghostWrapperObj),
        });
    }
    //handle export to vmp
    handleExportVMP = () => {
        var cobj = JSON.parse(JSON.stringify(this.state.selectedCatRect));
        // console.log(this.props.selectedCatRect);
        if(this.state.isStackableEdited){
            this.sendmarkStackableCall()
        }
        if(cobj && cobj.categoryList){
            confirmAlert({
                title: this.props.t('SIMULATE_CONVERT_VMP_CONFIRM'),
                message: this.props.t("SIMULATE_CONVERT_VMP_CONFIRM_MSG"),
                overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
                buttons: [{
                    label: this.props.t('btnnames.yes'),
                    onClick: () => {

                        // let svgdrawDimension = this.state.svgdrawDiemention;
                        // let editwrapper = document.getElementById("simulation-edit-wrapper");

                        // let totaldivwidth = (this.state.zoomXRatio > 0 && (editwrapper.clientWidth > svgdrawDimension.drawWidth)?editwrapper.clientWidth:svgdrawDimension.drawWidth);

                        // let exportobj = exportSimulationToVMP(cobj.categoryList, this.state.mapFields, this.state.mapproductList, totaldivwidth, this.state.checkSaftyMargin);

                        // console.log(exportobj);

                        // this.props.handlehaveChnagesinCat(false);
                    }
                }, {
                    label: this.props.t('btnnames.no')
                }]
            });
        }
    }


    disconnectDecider = (type) => {
        this.saveSimulateConfirm(type);
    }

    validateProductOverlapAndDelete() {
        let cprodlist = JSON.parse(JSON.stringify(this.state.mapproductList));

        // filter the hangged product set
        let hangedProductList =  this.state.mapproductList.filter((prod)=>prod?.isHanged === true);
        hangedProductList = hangedProductList.filter((prod)=>prod?.isProductDelete === true );
        let localDelHangbleProduct = hangedProductList.filter((prod)=>prod?.isDelete === true);

        if(hangedProductList.length> 0){
            if (localDelHangbleProduct.length !== hangedProductList.length) {
                alertService.error(this.props.t("DELETED_PRODUCT_AVAILABLE"));
                return false;
            }
        }

        let isProductDeleteAvailable = false;
        for (const prodt of Object.keys(cprodlist)) {
            const product = cprodlist[prodt];
            if (product.isProductDelete && product.isDelete === false) {
                isProductDeleteAvailable = true;
                break; 
            }
        }

        if (isProductDeleteAvailable) {
            alertService.error(this.props.t("DELETED_PRODUCT_AVAILABLE"));
            return false;
        }

        // OLD CODE FOR CHECK OVERLAP
        // let isAnyProductOverlap = false;
        // let iscount = 0;
        // Object.keys(this.state.mapproductList).map((Prod,prodt)=>{
        //     var product = this.state.mapproductList[Prod]; 
        //         if (product.isNewDiamsonChange && product.isDelete === false) {
        //             Object.keys(this.state.mapproductList).forEach((OtherProd, otherIndex) => {
        //                 if (otherIndex !== prodt) {
        //                     const otherProduct = this.state.mapproductList[OtherProd];
        //                     if (isOverlapping(product, otherProduct)) {
        //                         isAnyProductOverlap = true;
        //                         iscount++;
        //                     }
        //                 }
        //             });
        //         }
        // })
        let isNewDiamsonChangeProdList = cprodlist.filter((prod)=> prod?.isNewDiamsonChange === true && prod?.isDelete === false);
        let isOVerlapProdList = isNewDiamsonChangeProdList.filter((prod)=> prod?.isOverlap === true);

        let hangedProdList2 = this.state.mapproductList.filter((prod)=>prod?.isHanged === true)
        let hangedDimentionChangeProdList = hangedProdList2.filter((prod)=> prod?.isNewDiamsonChange === true && prod?.isDelete !== true);
        let hangableOverlapProdList = hangedDimentionChangeProdList.filter((prod)=> prod?.isOverlap === true);


        if (isOVerlapProdList.length > 0 || hangableOverlapProdList.length > 0) {
            alertService.error(this.props.t("RESLOVE_OVERLAP_PRODUCT"));
            return false;
        }
    
        return true;
    }

    //confirm save simulate changes
    saveSimulateConfirm = (type, selectedClusterId, selectFieldArrayId) => {
        if(this.state.isStackableEdited){
            this.sendmarkStackableCall()
        }

        const isValid = this.validateProductOverlapAndDelete();

        if (!isValid) return;
        
        if(type === "takeback"){
            this.checkAvailabilityTakeBack(type, selectedClusterId, selectFieldArrayId)
        }else{
            confirmAlert({
                title: this.props.t(type === "disconnected"?'DISCONNECT':'SIMULATE_SAVE_CONFIRM'),
                message: this.props.t(type === "disconnected"?'ARE_YOU_SURE_YOU_WANT_TO_DISCONNECT' : "SIMULATE_SAVE_CONFIRM_MSG"),
                overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
                buttons: [{
                    label: this.props.t('btnnames.yes'),
                    onClick: () => {
                            this.handleSaveMP(type);
                    }
                }, {
                    label: this.props.t('btnnames.no')
                }]
            });

        }

    }

    checkAvailabilityTakeBack = (type, selectedClusterId, selectFieldArrayId) => {
        confirmAlert({
            title: this.props.t('CONT_TAKE_BACK'),
            message: this.props.t("ARE_YOU_SURE_TO_CONTINUE_THIS_TASK"),
            overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
            buttons: [{
                label: this.props.t('btnnames.yes'),
                onClick: () => {

                    let sobj;
                    if(this.props.storeId > -1){
                        let fieldCount = (this.props.tagStoreGroup.length > 0?this.props.tagStoreGroup[0].fieldCount:0);

                        let tagStoreObj =this.props.tagStoreGroup.map((item)=>item.storesGroupByTags)

                        let flatObj = tagStoreObj.flatMap((subArray) => subArray)

                        let tags = flatObj.find((group) =>
                        group.connectedStores.some((store) => store.id === this.props.storeId) ||
                        group.disconnectedStores.some((store) => store.id === this.props.storeId)
                        ).tags;

                        let tagsWithName = tags.map(tg => {
                            return {
                                id: tg.id,
                                tagName: tg.name
                            };
                        });
                        if(this.props.simulationObj.simsimulationSnapshotId > -1){
                            sobj = { simulationSnapshotId: this.props.simulationObj.simulationSnapshotId };
                        }else{
                            sobj = {
                                clusterId: selectedClusterId,
                                editionId: this.props.editionId,
                                fieldArrayId: selectFieldArrayId,
                                storeId: this.props.storeId ? this.props.storeId : -1,
                                tags: tagsWithName,
                                // fieldCount: fieldCount ? fieldCount : this.props.tagStoreGroup[0].fieldCount
                            };
                        }
                    }else{

                        let tagList = this.props.selectedTagList;
                        let refinedArray = [];
                        for(let i=0; i<tagList.length; i++){
                            let obj = {
                                id:tagList[i].id,
                                tagName:tagList[i].name
                            }
                            refinedArray.push(obj);
                        }

                        // when taking back from tag level and authority level
                        if(this.props.simulationObj.simsimulationSnapshotId > -1){
                            sobj = { simulationSnapshotId: this.props.simulationObj.simulationSnapshotId };
                        }else{
                            sobj = {
                                clusterId: selectedClusterId,
                                editionId: this.props.editionId,
                                fieldArrayId: selectFieldArrayId,
                                storeId: this.props.storeId ? this.props.storeId : -1,
                                tags: refinedArray,
                                // fieldCount: fieldCount ? fieldCount : this.props.tagStoreGroup[0].fieldCount
                            };
                        }
                    }
                    this.props.toggleLoadingModal(true, () => {
                        submitSets(submitCollection.auiTakeBackAvailability, sobj, false, null, true).then(res => {
                            if(res && res.status && res.extra){
                                if(res.extra.isParentBlocked === false){
                                    this.handleSaveMP(type);
                                } else{
                                    this.setState({
                                        isShowTakeBackError: true,
                                        takeBackErrorObj: res.extra.blockedSimulationSearchDto
                                    });
                                    this.props.toggleLoadingModal(false);
                                }
                            } else if(res.status === false){
                                // alertService.error(res.extra);
                                this.props.toggleLoadingModal(false);
                            } else{
                                this.props.toggleLoadingModal(false);
                            }
                        });
                    });
                }
            }, {
                label: this.props.t('btnnames.no'),
                onClick: () => {
                    return false;
                }
            }]
        });
    }

     //toggle take back snapshot warning modal
     toggleTakebackWarnModal = (isshow, iscontinue) => {
        this.setState({ isShowTakeBackError: isshow }, () => {
            if(iscontinue){
                this.handleSaveMP("takeback");
            }
        });
    }

    //handle save simulation changes
    handleSaveMP = (type, isCloseModal) => {
     this.props.toggleLoadingModal(true, () => {    
        let cprodlist = JSON.parse(JSON.stringify(this.state.mapproductList));
        let currentNonSimulatedProducts = JSON.parse(JSON.stringify(this.state.nonfilteredNonEProducts));
        //set current prod list details on save
        let mapFields = this.state.mapFields;
        const mapFieldArray = this.state.isDisplayUnitEdited ? Object.values(this.state.mapFields).map(field => ({
        ...field
        })) : null;
        let searchDto = this.props.simulateSearchObj;

        // remove the hanged products from the mapproductList
        cprodlist = cprodlist.filter((prod)=>prod?.isHanged != true);

        // filter the hangged product set
        let hangedProductList =  this.state.mapproductList.filter((prod)=>prod?.isHanged === true);
        // remove isDelete true set from the hangedProductList - API does not need to delete the hanged products
        hangedProductList = hangedProductList.filter((prod)=>prod?.isDelete !== true);

        let exportprodlist = [];
        for (let i = 0; i < cprodlist.length; i++) {
            const proditem = cprodlist[i];
            let prodfield = mapFields[proditem.field_custom_id];
            let prodstartpoint = ((proditem.x - prodfield.x) / this.state.displayRatio);

            const match = prodstartpoint.toString().match(/^-?\d+\.\d{0,9}/);
            prodstartpoint = match ? match[0] : prodstartpoint.toString(); // 999.9999999999998 ----> 999.999999 // 6 decimal points (Not rounding)

            proditem["startingPoint"] = prodstartpoint;
            proditem["isDelete"] = (proditem.isDelete?proditem.isDelete:false);
            proditem["isNew"] = ((proditem.isNew || proditem.isDropNew)?proditem.isNew:false);

            if(!proditem.isNew || (proditem.isNew && !proditem.isDelete)){
                exportprodlist.push(proditem);
            }
        }
        let storeIds = [];

        let lastSimOption;

        if(type && type !== "none" && this.props.simType === "AUI" ){

            lastSimOption = this.props.selectedTagGroup.simOption;

            if(this.props.storeId > -1){
                // let tagStoreObj =this.props.tagStoreGroup.map((item)=>item.storesGroupByTags)

                // let flatObj = tagStoreObj.flatMap((subArray) => subArray)

                // let taggroup = flatObj.find((group) =>
                //     group.connectedStores.some((store) => store.id === this.props.storeId) ||
                //     group.disconnectedStores.some((store) => store.id === this.props.storeId)
                //     );

                let taggroup = this.props.selectedTagGroup;

                let allStores = taggroup.connectedStores.concat(taggroup.disconnectedStores);

                let allStoreIds = allStores.map(str => str.id);

                storeIds = allStoreIds.filter(itm => itm !== this.props.storeId);

                let storeObj = allStores.find((obj) => obj.id === this.props.storeId);

                lastSimOption = storeObj.simOption;

                if(!searchDto.storeId){
                    searchDto["storeId"] = storeObj.id;
                }

            }else{
                if(!searchDto.storeId){
                    searchDto["storeId"] = -1;
                }
            }

            let tagList = this.props.selectedTagList;

            let refinedArray = [];

            for(let i=0; i<tagList.length; i++){
                let obj = {
                    id:tagList[i].id,
                    tagName:tagList[i].name
                }

                refinedArray.push(obj);
            }

            if(!searchDto.fieldCount){
                searchDto["fieldCount"] = this.props.tagStoreGroup[0].fieldCount;
            }

            if(!searchDto.selectedTagsId){
                searchDto["selectedTagsId"] = refinedArray;
            }

        }

        searchDto['editionId'] = this.props.editionId;

        let notrelatedprods = JSON.parse(JSON.stringify(this.props.notReleatedProdList));

        let allSimulationObj = JSON.parse(JSON.stringify(this.props.simulationObj));

        let notrelatedrules = allSimulationObj.subCategoryRuleWrapperDtos.filter(ritem => (this.state.mapRulesList.length > 0?this.state.mapRulesList.some(mritem => mritem.categoryId !== ritem.categoryId):true));

        //preview apply prods
        let previewSelectedProds = [];
        if(this.props.isShowFromPreview){
            for (let i = 0; i < this.state.selectedSaveProds.length; i++) {
                const groupObj = this.state.selectedSaveProds[i];
                for (let j = 0; j < groupObj.products.length; j++) {
                    const prodObj = groupObj.products[j];

                    previewSelectedProds.push({ prodId: prodObj.productInfo.productId, chainOption: prodObj.chainOption });
                }
            }
        }

        //filter the peg board api properties
        this.state.pegList?.map(obj => {
            const newObj = { ...obj };  // Create a shallow copy of the object
            
            // Remove the "id" property
            delete newObj.drawGapH;
            delete newObj.drawGapW;
            
            // Check if pegDrawingRect exists and remove the specified properties
            if (newObj.pegDrawingRect) {
              delete newObj.pegDrawingRect.drawRectHeight;
              delete newObj.pegDrawingRect.drawRectWidth;
              delete newObj.pegDrawingRect.drawX;
              delete newObj.pegDrawingRect.drawY;
              delete newObj.pegDrawingRect.xPositions;
              delete newObj.pegDrawingRect.yPositions;
            }
            
            // Return the modified object
            return newObj;
        });

        let relogramPlanogramStatus = "relogram"
        let exportsaveobj = {
            simulationSnapshotId: (allSimulationObj.simulationSnapshotId?allSimulationObj.simulationSnapshotId:-1),
            simulationSnapshotStatus: (allSimulationObj.simulationSnapshotStatus?allSimulationObj.simulationSnapshotStatus:simulateSnapshotEnums.normal),
            virtualBoxList: allSimulationObj.virtualBoxList,
            fieldList: allSimulationObj.fieldList,
            editedFieldList: mapFieldArray,
            categoryList: allSimulationObj.categoryList,
            products: notrelatedprods.concat(exportprodlist),
            pegProductList: hangedProductList,
            nonSimulateProducts: currentNonSimulatedProducts || allSimulationObj.nonSimulateProducts,
            subCategoryRuleWrapperDtos: notrelatedrules.concat(this.state.mapRulesList),
            searchDto: searchDto,
            simOption: type,
            storeIds: storeIds,
            lastSimOption: lastSimOption,
            removedOldProductsDueToNewProducts: (allSimulationObj.removedOldProductsDueToNewProducts && allSimulationObj.removedOldProductsDueToNewProducts.length > 0?allSimulationObj.removedOldProductsDueToNewProducts:[]),
            previewSelectedProds: previewSelectedProds,
            // changedCategories:this.state.TouchedCatRcetList,
            clipboardData:this.state.cutNewArray,
            replaceProds: allSimulationObj.replaceProds,
            relogramPlanogramStatus: relogramPlanogramStatus,
            // changedCategories:this.state.TouchedCatRcetList
            pegBoards:this.state.pegList
        };

        if(exportsaveobj.simulationSnapshotId > 0 && exportsaveobj.simulationSnapshotStatus === simulateSnapshotEnums.normal){
            exportsaveobj = {
                simulationSnapshotId: (allSimulationObj.simulationSnapshotId?allSimulationObj.simulationSnapshotId:-1),
                simulationSnapshotStatus: (allSimulationObj.simulationSnapshotStatus?allSimulationObj.simulationSnapshotStatus:simulateSnapshotEnums.normal),
                virtualBoxList: allSimulationObj.virtualBoxList,
                fieldList: allSimulationObj.fieldList,
                editedFieldList: mapFieldArray,
                categoryList: allSimulationObj.categoryList,
                relogramPlanogramStatus: "relogram",
                products: exportprodlist,
                nonSimulateProducts: currentNonSimulatedProducts || allSimulationObj.nonSimulateProducts,
                subCategoryRuleWrapperDtos: notrelatedrules.concat(this.state.mapRulesList),
                pegProductList: hangedProductList,
                searchDto: searchDto,
                simOption: type,
                storeIds: storeIds,
                lastSimOption: lastSimOption,
                changedCategories:this.state.TouchedCatRcetList,
                removedOldProductsDueToNewProducts: (allSimulationObj.removedOldProductsDueToNewProducts && allSimulationObj.removedOldProductsDueToNewProducts.length > 0?allSimulationObj.removedOldProductsDueToNewProducts:[]),
                previewSelectedProds: previewSelectedProds,
                clipboardData:this.state.cutNewArray,
                replaceProds: allSimulationObj.replaceProds,
                pegBoards:this.state.pegList
            }
        }

        this.setState({ selectedViewTypeSimulation: "current",  }, () => {
            this.props.onViewTypeChange?.("current", true);
        });
        // added this attribute for identify copy arrangement save
        if (allSimulationObj.isCopyArrangement) {
            exportsaveobj.isCopyArrangement = allSimulationObj.isCopyArrangement;
            // exportsaveobj.simulationSnapshotId = -1;

            // Create mapping of old pegBoardIndex to new pegBoardIndex
            const pegBoardIndexMapping = {};
            exportsaveobj.pegBoards.forEach(pegObj => {
                const oldPegBoardIndex = pegObj.pegBoardIndex;
                const newPegBoardIndex = uuidv4();
                pegBoardIndexMapping[oldPegBoardIndex] = newPegBoardIndex;
            });
            // Transform pegBoards to match initial creation format
            exportsaveobj.pegBoards = exportsaveobj.pegBoards.map((pegObj, index) => {
                // Clean pegDrawingRect - remove backend-added fields
                const cleanedPegDrawingRect = { ...pegObj.pegDrawingRect };
                delete cleanedPegDrawingRect.id;
                delete cleanedPegDrawingRect.status;
                delete cleanedPegDrawingRect.createdDate;
                delete cleanedPegDrawingRect.editedDate;
                delete cleanedPegDrawingRect.pegBoardId;

                // Clean pegCoordinations - remove backend-added fields
                const cleanedPegCoordinations = pegObj.pegCoordinations?.map(coord => {
                    const { id, status, createdDate, editedDate, pegBoardId, ...cleanCoord } = coord;
                    return cleanCoord;
                }) || [];

                // Remove backend-specific fields from pegBoard object
                const { status, createdDate, editedDate, simulationSnapshotId, ...cleanPegObj } = pegObj;

                // Get new pegBoardIndex for this pegBoard
                const newPegBoardIndex = pegBoardIndexMapping[pegObj.pegBoardIndex];

                // Return cleaned pegBoard object matching initial creation format
                if(allSimulationObj.simulationSnapshotId > 0) {
                    return {
                        ...cleanPegObj,
                        //id: index + 1,
                        name: String(index + 1),
                        pegId: index + 1,
                        pegBoardIndex: newPegBoardIndex, // Assign new UUID
                        pegDrawingRect: cleanedPegDrawingRect,
                        pegCoordinations: cleanedPegCoordinations,
                        savePegBoard: true,
                        isPegBoardSaving: false
                    };
                }else{
                    // Remove id property from cleanPegObj before spreading
                    const { id, ...restCleanPegObj } = cleanPegObj;
                    return {
                        ...restCleanPegObj,
                        name: String(index + 1),
                        pegId: index + 1,
                        pegBoardIndex: newPegBoardIndex, // Assign new UUID
                        pegDrawingRect: cleanedPegDrawingRect,
                        pegCoordinations: cleanedPegCoordinations,
                        savePegBoard: true,
                        isPegBoardSaving: false
                    };
                }
            });

            // Clean pegProductList - transform to match initial creation format
            exportsaveobj.pegProductList = exportsaveobj.pegProductList.map(pegProd => {
                // Extract essential fields and remove backend-specific fields
                const {
                    // Remove these backend-specific fields
                    pegBoard,
                    // product,
                    uuid,
                    status,
                    created_date,
                    edited_date,
                    productSource,
                    pos_mapping_id,
                    productPadding,
                    orientation,
                    productType,
                    isNOOS,
                    isFavorite,
                    isMandatory,
                    isPremium,
                    minQty,
                    maxQty,
                    minRevenue,
                    maxRevenue,
                    shelveLife,
                    paceOfSalesInQty,
                    paceOfSalesInQtyUot,
                    shelveLifeUot,
                    revenueSource,
                    isPremiumBrand,
                    isTypeManualAdeded,
                    usageStatus,
                    completeStatus,
                    importRefCode,
                    importBarcode,
                    arigoName,
                    gs1Name,
                    importName,
                    subCategoryImportRefCode,
                    subCategoryOriginalImportRefCode,
                    categoryImportRefCode,
                    categoryOriginalImportRefCode,
                    departmentImportRefCode,
                    departmentOriginalImportRefCode,
                    brandImportRefCode,
                    supplierImportRefCode,
                    importStatus,
                    haveBrandChange,
                    haveSubCategoryChange,
                    imageSource,
                    import_created_date,
                    importCreatedDateType,
                    isUpdateSupplierWhileLookup,
                    hierarchyCompleteStatus,
                    productTestPeriod,
                    origin,
                    dimensionSource,
                    lookupJobStatus,
                    brandSource,
                    barcodeDuplicateStatus,
                    blockUntilDate,
                    isInOutProduct,
                    newProductStatus,
                    testStartDate,
                    testPeriodOverMethod,
                    isTestPeriodOver,
                    testEndDate,
                    isRemovedNewProduct,
                    testStartDateEnterType,
                    taskDoneDate,
                    chainOption,
                    cost_price,
                    sell_price,
                    sensitivity,
                    isUseProdMinRev,
                    // hasPriceTag,
                    // priceTagGap,
                    // priceTagHeight,
                    image,
                    label,
                    mpPreProcessData,
                    isProductDelete,
                    isNewDiamsonChange,
                    productLabel,
                    // hasPriceTagLatest,
                    // priceTagGapLatest,
                    // priceTagHeightLatest,
                    barcodeTwo,
                    gs1_no,
                    last_price,
                    productBrand,
                    qty,
                    subCategory,
                    subCategoryId,
                    subCategoryName,
                    // Keep the rest
                    ...cleanPegProd
                } = pegProd;

                // Simplify nested objects to match initial format
                if (cleanPegProd.brand && cleanPegProd.brand.brand) {
                    cleanPegProd.brand = {
                        brand: {
                            brandName: cleanPegProd.brand.brand.brandName,
                            brandId: cleanPegProd.brand.brand.brandId,
                            supplier: cleanPegProd.brand.brand.supplier ? {
                                supplierId: cleanPegProd.brand.brand.supplier.supplierId,
                                supplierName: cleanPegProd.brand.brand.supplier.supplierName
                            } : undefined
                        },
                        type: cleanPegProd.brand.type || "default",
                        rule: cleanPegProd.brand.rule || null,
                        posCode: cleanPegProd.brand.posCode
                    };
                }

                if (cleanPegProd.subcategory && cleanPegProd.subcategory.sub_category) {
                    cleanPegProd.subcategory = {
                        sub_category: {
                            subCategoryName: cleanPegProd.subcategory.sub_category.subCategoryName,
                            subCategoryId: cleanPegProd.subcategory.sub_category.subCategoryId,
                            color: cleanPegProd.subcategory.sub_category.color
                        },
                        type: cleanPegProd.subcategory.type || "default",
                        rule: cleanPegProd.subcategory.rule || null
                    };
                }

                if (cleanPegProd.category) {
                    cleanPegProd.category = {
                        id: cleanPegProd.category.id,
                        categoryName: cleanPegProd.category.categoryName,
                        isDelete: cleanPegProd.category.isDelete || false,
                        isDepartmentResolved: cleanPegProd.category.isDepartmentResolved || false,
                        isNew: cleanPegProd.category.isNew || false,
                        subCategory: cleanPegProd.category.subCategory || [],
                        posCode: cleanPegProd.category.posCode
                    };
                }

                if (cleanPegProd.department) {
                    cleanPegProd.department = {
                        id: cleanPegProd.department.id,
                        name: cleanPegProd.department.name,
                        posCode: cleanPegProd.department.posCode
                    };
                }

                if (cleanPegProd.supplier) {
                    cleanPegProd.supplier = {
                        supplierName: cleanPegProd.supplier.supplierName,
                        supplierId: cleanPegProd.supplier.supplierId,
                        supplierCode: cleanPegProd.supplier.supplierCode,
                        supplierRec: cleanPegProd.supplier.supplierRec || 0,
                        supplierNow: cleanPegProd.supplier.supplierNow || 0
                    };
                }

                // Ensure pegBoardId is removed (it's the backend DB ID, not the UUID)
                delete cleanPegProd.pegBoardId;

                // Update pegBoardIndex to new UUID using the mapping
                if (cleanPegProd.pegBoardIndex && pegBoardIndexMapping[cleanPegProd.pegBoardIndex]) {
                    cleanPegProd.pegBoardIndex = pegBoardIndexMapping[cleanPegProd.pegBoardIndex];
                }

                // Generate new UUIDs for product placement identifiers
                // These need to be unique for each copy of the arrangement
                cleanPegProd.id = uuidv4();              // Product placement ID (backend returns DB ID, need UUID)
                cleanPegProd.fuuid = uuidv4();           // Frontend UUID (not in backend response)
                cleanPegProd.pegProductId = uuidv4();    // Peg product ID (backend returns DB ID, need UUID)

                return cleanPegProd;
            });
        }
       
        // return;
            submitSets(submitCollection.saveSimulationSnapshot, exportsaveobj, false, null, true).then(res => {
                if(res && res.status){
                    this.props.getSimulatePlanogram(false);
                    // this.newClipBoardToched(false)
                    let taggroup;
                    let storeobj;
                    if(this.props.storeId >-1){
                        let tagStoreObj =this.props.tagStoreGroup.map((item)=>item.storesGroupByTags)

                        let flatObj = tagStoreObj.flatMap((subArray) => subArray)

                        taggroup = flatObj.find((group) =>
                            group.connectedStores.some((store) => store.id === this.props.storeId) ||
                            group.disconnectedStores.some((store) => store.id === this.props.storeId)
                            );

                        let allStores = taggroup.connectedStores.concat(taggroup.disconnectedStores);

                        storeobj = allStores.find((obj) => obj.id === this.props.storeId);
                    }

                    if(type === "takeback"){
                        alertService.success(this.props.t('TACKBACK_SUCCESS'));
                        if(this.props.storeId > -1){
                            this.props.reloadSimAndStore(storeobj, taggroup);
                        }else{
                            this.props.reloadSimAndTag(this.props.selectedTagGroup);
                        }
                    }else if(type === "disconnected"){
                        alertService.success(this.props.t('Successfully_disconnected'));
                        if(this.props.storeId > -1){
                            this.props.reloadSimAndStore(storeobj, taggroup);
                        }else{
                            this.props.reloadSimAndTag(this.props.selectedTagGroup);
                        }
                    }else{
                        alertService.success(this.props.t('SIMULATE_SAVE_SUCCESS'));
                    }

                    if(res.extra && Object.keys(res.extra).length > 0){

                        if(this.props.saveSimulationObjToSideBarComp){
                            this.props.saveSimulationObjToSideBarComp(res.extra)
                        }
                        if(this.props.checkToggleState) {
                            this.props.checkToggleState(true)
                        }

                        this.props.loadData?.()

                        //set to redux
                        var obj={
                            exportsaveobj:exportsaveobj,
                            extra:res.extra,
                        }
                        this.props.setMpFullscreenchngesobj(obj)
                        //end

                        this.checkAndReloadProds(exportsaveobj, res.extra);

                        this.props.toggleOneCategory(true);
                        // this.props.handlehaveChnagesinCat(false);
                    }

                    this.props.handlehaveChnagesinCat(false);
                      // Recall getSimulatePlanogram function

                    if(this.state.isPrintPending){
                            this.excelPrint();
                        
                    }
                    this.setState({ isPrintPending: false });

                    if(isCloseModal){
                        this.props.toggleSimulateAllModal(true);
                    }
                    // disable save btn  after copy arrangement enable
                    this.props.setCopyArrangementPrevAfter(false)
                
                } else{
                    this.props.toggleLoadingModal(false);
                    // alertService.error(res.extra && res.extra !== ""?res.extra:this.props.t('erroroccurred'));
                    this.props.togglePrintPending(null, false, true);
                    // Reset download flag if save fails
                    this.props.setShouldDownloadAfterRefresh(false);
                }
            }).catch(error => {
                this.props.setShouldDownloadAfterRefresh(false);
                this.props.toggleLoadingModal(false);
            });
        });
    }
    // checkAndReloadProdsbackup = (exportsaveobj, response,type) => {
    //     let crectobj = this.state.selectedCatRect;
    //     let newresponseobj = {};
    //     // this.TouchedCatListUpdate(null,true)
    //     //update snapshot available updates only category items
    //     if(exportsaveobj.simulationSnapshotId > 0 && exportsaveobj.simulationSnapshotStatus === simulateSnapshotEnums.normal){
    //         var non_sim_cat=response.nonSimulateProducts.find(g=>g.categoryId===crectobj.selectedCat.id);
    //         let notrelatedprods = JSON.parse(JSON.stringify(this.props.notReleatedProdList));

    //         //console.log(response.products)

    //         newresponseobj = JSON.parse(JSON.stringify(this.props.simulationObj));
    //         newresponseobj["products"] = notrelatedprods.concat(response.products);
    //         newresponseobj["nonSimulateProducts"] = response.nonSimulateProducts;


    //         //rules list update
    //         let notrelatedrules = newresponseobj.subCategoryRuleWrapperDtos.filter(ritem => (this.state.mapRulesList.length > 0?this.state.mapRulesList.some(mritem => mritem.categoryId !== ritem.categoryId):true));
    //         let responseRules = (response.subCategoryRuleWrapperDtos && response.subCategoryRuleWrapperDtos.length > 0?response.subCategoryRuleWrapperDtos:[]);
    //         newresponseobj["subCategoryRuleWrapperDtos"] = notrelatedrules.concat(responseRules);

    //         let selectedObj = this.state.selectedCatRect;
    //         selectedObj["products"] = response.products;
    //         selectedObj["rulesList"] = responseRules;
    //         selectedObj["non_sim_prodlist"] = non_sim_cat?non_sim_cat.nonSimulatedProducts:[];

    //         this.setState({ selectedCatRect: selectedObj }, () => {
    //             this.mapobjectsdraw();
    //             this.props.updateSaveReloadStatus(true, newresponseobj );
    //         });

    //     } else{

    //         newresponseobj = response;

    //         let selectedcat = (crectobj && crectobj.selectedCat?crectobj.selectedCat:null);

    //         if(selectedcat){
    //             let allSelectedCats = response.categoryList.filter(a =>
    //                 (selectedcat.type === catRectEnums.default && a.type === catRectEnums.default && getNameorIdorColorofBox(a,"num") === getNameorIdorColorofBox(selectedcat, "num")) ||
    //                 (selectedcat.type === catRectEnums.rule && a.type === catRectEnums.rule && a.rule && selectedcat.rule && a.rule.level === selectedcat.rule.level && getNameorIdorColorofBox(a,"num") === getNameorIdorColorofBox(selectedcat, "num"))
    //             );

    //             if(allSelectedCats && allSelectedCats.length > 0){
    //                 let firstcatitem = allSelectedCats[0];

    //                 let non_simu_cat_list = (response.nonSimulateProducts?response.nonSimulateProducts:[]);
    //                 let non_sim_cat = non_simu_cat_list.find(g => g.categoryId === firstcatitem.id);

    //                 let cfileds = response.fieldList.filter(x => x.virtualBoxId === firstcatitem.virtualBoxId)

    //                 let notrelatedprods = [];
    //                 let selectetProducts = [];

    //                 for (let i = 0; i < response.products.length; i++) {
    //                     const originprod = response.products[i];

    //                     if(allSelectedCats.length > 0 && allSelectedCats.some(a => originprod.categoryRectId === a.id)){
    //                         selectetProducts.push(originprod);
    //                     } else{
    //                         notrelatedprods.push(originprod);
    //                     }
    //                 }

    //                 //get rules list
    //                 let selectedCatRules = response.subCategoryRuleWrapperDtos.filter(z => (allSelectedCats.length > 0?allSelectedCats.some(b => z.categoryId === b.id):true));

    //                 let selectedObj = {
    //                     selectedCat: firstcatitem,
    //                     categoryList:allSelectedCats,
    //                     fieldList: cfileds,
    //                     non_sim_prodlist: non_sim_cat?non_sim_cat.nonSimulatedProducts:[],
    //                     products:selectetProducts,
    //                     rulesList: selectedCatRules,
    //                 }

    //                 this.setState({
    //                     selectedCatRect: selectedObj, nonfilteredNonEProducts: selectedObj.non_sim_prodlist,
    //                     //y
    //                     currentDraggableProd: null,
    //                     currentSelectedBlock:null,
    //                     currentInternalDraggableProd:null
    //                 }, () => {
    //                     this.mapobjectsdraw();
    //                     this.props.updateSaveReloadStatus(true, newresponseobj, notrelatedprods );
    //                 });
    //             }
    //         }
    //     }
    //     if(type==="fullscreenedit"){
    //         this.props.setMpFullscreenchngesobj(null)
    //     }
    // }
    //check save response and reload changes
    checkAndReloadProds = (exportsaveobj, response,type) => {
        // let crectobj = this.state.selectedCatRect;
        let newresponseobj = {};
        //update snapshot available updates only category items
        if(exportsaveobj.simulationSnapshotId > 0 && exportsaveobj.simulationSnapshotStatus === simulateSnapshotEnums.normal){
            var non_sim_cat=null//response.nonSimulateProducts.find(g=>g.categoryId===crectobj.selectedCat.id);
            // let notrelatedprods = JSON.parse(JSON.stringify(this.props.notReleatedProdList));

            //console.log(response.products)
            var remainProducts=this.findproductexcludeCatrects(this.state.TouchedCatRcetList,this.props.simulationObj.products)
            newresponseobj = JSON.parse(JSON.stringify(this.props.simulationObj));
            // newresponseobj["products"] = notrelatedprods.concat(response.products);
            newresponseobj["products"] = remainProducts.excludeproducts.concat(response.products);
            // newresponseobj["products"] = exportsaveobj.products; // NOTE: Assign already built object to this, Because API return product object data is wrong. Need to check API.
            newresponseobj["nonSimulateProducts"] = response.nonSimulateProducts;
            newresponseobj["clipboardData"] = response.clipboardData

            //rules list update
            let notrelatedrules = newresponseobj.subCategoryRuleWrapperDtos.filter(ritem => (this.state.mapRulesList.length > 0?this.state.mapRulesList.some(mritem => mritem.categoryId !== ritem.categoryId):true));
            let responseRules = (response.subCategoryRuleWrapperDtos && response.subCategoryRuleWrapperDtos.length > 0?response.subCategoryRuleWrapperDtos:[]);
            newresponseobj["subCategoryRuleWrapperDtos"] = notrelatedrules.concat(responseRules);

            let selectedObj = this.state.selectedCatRect;
            selectedObj["products"] = response.products;
            selectedObj["rulesList"] = responseRules;
            selectedObj["non_sim_prodlist"] = non_sim_cat?non_sim_cat.nonSimulatedProducts:[];
            selectedObj["clipboardData"] = response.clipboardData
            
            this.setState({ selectedCatRect: selectedObj }, () => {
                this.TouchedCatListUpdate(null,true)
                this.mapobjectsdraw();
                this.props.updateSaveReloadStatus(true, newresponseobj );

                //reload imported product update
                this.compareImportedProds();
            });

        } else{

            newresponseobj = response;

            // let selectedcat = (crectobj && crectobj.selectedCat?crectobj.selectedCat:null);

            // if(selectedcat){
                let allSelectedCats = response.categoryList
                // let allSelectedCats = response.categoryList.filter(a =>
                //     (selectedcat.type === catRectEnums.default && a.type === catRectEnums.default && getNameorIdorColorofBox(a,"num") === getNameorIdorColorofBox(selectedcat, "num")) ||
                //     (selectedcat.type === catRectEnums.rule && a.type === catRectEnums.rule && a.rule && selectedcat.rule && a.rule.level === selectedcat.rule.level && getNameorIdorColorofBox(a,"num") === getNameorIdorColorofBox(selectedcat, "num"))
                // );
                if(allSelectedCats && allSelectedCats.length > 0){
                    let firstcatitem = allSelectedCats[0];

                    let non_simu_cat_list = (response.nonSimulateProducts?response.nonSimulateProducts:[]);
                    let non_sim_cat = non_simu_cat_list.find(g => g.categoryId === firstcatitem.id);

                    let cfileds = response.fieldList.filter(x => x.virtualBoxId === firstcatitem.virtualBoxId)

                    let notrelatedprods = [];
                    let selectetProducts = [];

                    for (let i = 0; i < response.products.length; i++) {
                        const originprod = response.products[i];

                        if(allSelectedCats.length > 0 && allSelectedCats.some(a => originprod.categoryRectId === a.id)){
                            selectetProducts.push(originprod);
                        } else{
                            notrelatedprods.push(originprod);
                        }
                    }

                    //get rules list
                    let selectedCatRules = response.subCategoryRuleWrapperDtos.filter(z => (allSelectedCats.length > 0?allSelectedCats.some(b => z.categoryId === b.id):true));

                    let selectedObj = {
                        selectedCat: firstcatitem,
                        categoryList:allSelectedCats,
                        fieldList: cfileds,
                        non_sim_prodlist: non_sim_cat?non_sim_cat.nonSimulatedProducts:[],
                        products:selectetProducts,
                        rulesList: selectedCatRules,
                    }

                    this.setState({
                        selectedCatRect: selectedObj, nonfilteredNonEProducts: selectedObj.non_sim_prodlist,
                        //y
                        currentDraggableProd: null,
                        currentSelectedBlock:null,
                        currentInternalDraggableProd:null
                    }, () => {
                        this.mapobjectsdraw();
                        this.props.updateSaveReloadStatus(true, newresponseobj, notrelatedprods );

                        //reload imported product update
                        this.compareImportedProds();
                    });
                }
            // }
        }
        if(type==="fullscreenedit"){
            this.props.setMpFullscreenchngesobj(null)
        }

    }
    drawClipboardfromback=()=>{
        var  newresponseobj = JSON.parse(JSON.stringify(this.props.simulationObj));
        var clipboarddata=newresponseobj.clipboardData
        if(clipboarddata.length>0){
            let curcutlist = [];
            for (let i = 0; i < clipboarddata.length; i++) {
                const cdata = clipboarddata[i];
                let maxwdithoftile = 0;
                let maxheightoftile = 0;

                cdata.shelf.forEach(cutshelf => {
                    // Sort products by startingPoint to maintain order
                    let sortprods = cutshelf.products.sort((a,b) => a.startingPoint - b.startingPoint);

                    // Find max height among all products for vertical alignment
                    let maxheightofprod = 0;

                    // Calculate draw dimensions and reposition products without gaps
                    let currentXPosition = 0;

                    for (let j = 0; j < sortprods.length; j++) {
                        const sortitem = sortprods[j];

                        // Convert width and height to display units
                        sortitem.drawWidth = measureConverter(sortitem.uom, this.state.displayUOM, sortitem.width) * this.state.displayRatio;
                        sortitem.drawHeight = measureConverter(sortitem.uom, this.state.displayUOM, sortitem.height) * this.state.displayRatio;
                        sortitem.height = measureConverter(sortitem.uom, this.state.displayUOM, sortitem.height);
                        sortitem.width = measureConverter(sortitem.uom, this.state.displayUOM, sortitem.width);
                        sortitem.uom = this.state.displayUOM;

                        // Position product at current X position (no gaps)
                        sortitem["x"] = currentXPosition;

                        // Update current position for next product
                        // 2 - add some gap one product to another
                        currentXPosition += sortitem.drawWidth + 2;

                        // Track max height
                        maxheightofprod = Math.max(maxheightofprod, sortitem.drawHeight);
                    }

                    // Calculate vertical gap from bottom for each product
                    for (let j = 0; j < sortprods.length; j++) {
                        const sortitem = sortprods[j];
                        sortitem["gaptolowy"] = maxheightofprod - sortitem.drawHeight;
                    }

                    maxheightoftile += maxheightofprod;

                    cutshelf["id"] = uuidv4();
                    cutshelf["width"] = currentXPosition; // Total width is the accumulated width
                    cutshelf["height"] = maxheightofprod;
                    cutshelf.products = sortprods;

                    maxwdithoftile = Math.max(maxwdithoftile, cutshelf.width);
                });

                cdata["width"] = maxwdithoftile;
                cdata["height"] = maxheightoftile;
                cdata["is_cutitem"] = true;

                curcutlist.push(cdata);
            }

            // Return if display unit is in editing mode
            if(this.state.isDisplayUnitEdited) {
                return
            }
            this.setState({cutNewArray:curcutlist})
        }

    }
    findproductexcludeCatrects=(selectCatRects,products)=>{
        var filteredproducts = products.filter(x => !selectCatRects.includes( x.categoryRectId ));

        return {excludeproducts:filteredproducts}
    }
    //cut content item
    cutContextItem = (iscopy, citem,isFromDelete) => {
        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),2);
        // if(!iscopy){
        //     this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),2);
        // }
        var cmenu = this.state.contxtmenu;
        let prodlist = JSON.parse(JSON.stringify(this.state.mapproductList));

        let isruleupdating = false;
        if(!iscopy){
            if (!prodlist[citem.prodidx].hasOwnProperty('isDelete')) {
                prodlist[citem.prodidx]["isDelete"] = true;
            }

            prodlist[citem.prodidx]["isDelete"] = true;
            let changeprodobj = prodlist[citem.prodidx];
             //cat rect chenged track
            this.TouchedCatListUpdate(changeprodobj.categoryRectId)
            if(changeprodobj.subcategory && changeprodobj.subcategory.type === catRectEnums.rule){
                let scatruleid = getNameorIdorColorofBox(changeprodobj.subcategory, "num");
                let scatrulelevel = changeprodobj.subcategory.rule.level;
                let findfromrules = findRuleAvailableForBrand(scatruleid, true, scatrulelevel, this.state.mapRulesList);

                if(findfromrules.isavailable){
                    isruleupdating = {parentidx: findfromrules.ruleparentidx, ruleidx: findfromrules.ruleidx};
                }
            }
        }
        // let newcutarray = [{ rank: citem.prod.shelfrank, iscopy: iscopy, prods: [citem.prod] }];
        //making new clip board obj
        var cuttingProduct=citem.prod
        // cuttingProduct["startingPointDraw"]=cuttingProduct.x
        // cuttingProduct["startingPoint"]=cuttingProduct.x/this.props.displayratio
        var cshelfs=[{shelfrank:citem.prod.shelfrank,products:[cuttingProduct]}]
        var selfield=this.state.mapFields[citem.prod.field_custom_id]
        var objtopass={
            groupUUID: uuidv4(),isNew:true, isDelete: false, mode: isFromDelete?"delete":iscopy?"copy":"cut" ,uom:selfield.uom,shelf:cshelfs
        }
        this.updateCutList(objtopass);

        this.handleRemoveProductCounter(cmenu.citem,1);

        this.setState({ mapproductList: prodlist, currentInternalDraggableProd: null, currentSelectedBlock: null, isviewcmenu: false, contxtmenu: { isexpand: false } }, () => {

            if(this.props.simType === "AUI" || this.props.simType === "Normal"){
                // const combinedPrds = this.state.mapproductList.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
                const combinedPrds = this.state.mapproductList.filter(prd=>prd.isDelete !== true)
                this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
            }

            //check non sim render count and display mange
             this.nonSimProddropremoveCounterupdate("cutSingleItem")
            //update rule list if item sub cat is rule
            if(isruleupdating){
                let updaterulelist = getAllRuleWarnings(this.state.mapCatRects, this.state.mapRulesList, this.state.mapproductList, false, true, isruleupdating);

                this.setState({ mapRulesList: updaterulelist.rulelist, isRuleWarn: updaterulelist.iswarn });
            }

            // this.cacheClipboardandOtherOnlyCutProdsReplace()

            //reload imported product update
            this.compareImportedProds();
        });
    }
    //remove prod drag end
    prodDragEnd = () => {
        this.setState({ isContentDragging: false, currentInternalDraggableProd: null, currentSelectedBlock: null, contxtmenu: { isexpand: false } });
        setTimeout(() => {
            this.setPreviewGuid(true);
        }, 500);
        removeGhostImage();
    }
    setFullscreenShow=(value)=>{
        var cloadedprodcount=this.state.loadedprodcount
        if(value===false){
            cloadedprodcount=0
            this.setState({fullscreenObj:null, isPdfExporting:false})// after save print prod image switching images fix only this line
        }
        if(value===true){
            cloadedprodcount=0
            this._loadedProdCountRef = 0;
            if (this._loadedProdCountFlushTimeout) clearTimeout(this._loadedProdCountFlushTimeout);
        }
        this.setState({isShowFullscreen:value,loadedprodcount:cloadedprodcount},()=>{
            if(value===true){
                this.calculateDrawingobject()
                this.calculateDrawingobject2()
            }
        })
    }
    calculateDrawingobject=()=>{
        var cobj = JSON.parse(JSON.stringify(this.props.selectedCatRect));
        let simLoadedObj = JSON.parse(JSON.stringify(this.props.allCategoryData));

        var divheight=(this.fullscreendiv.current?(this.fullscreendiv.current.offsetHeight - 10) : 0)

        var cfieldList = cobj.fieldList;
        // var normalDimention = makeRatiofromhieghestField(cfieldList, this.state.displayUOM, this.state.catDivHeight);

        var dimentionforfullscreen = makeRatiofromhieghestField(cobj.fieldList, this.state.displayUOM, divheight)
        // var cmapFields = JSON.parse(JSON.stringify(this.state.mapFields))
        // var cmapproductList=JSON.parse(JSON.stringify(this.state.mapproductList));

        // let simLoadedObj = this.props.allCategoryData;
        // let actualFieldsCounts = (simLoadedObj?simLoadedObj.actualFieldStructures:[]);

        this.setState({
            fullScreenRatio: dimentionforfullscreen,
            fullscreenheight: divheight
        },()=>{
            // var convertedfield=convertfieldstoFullScreen(cmapFields, normalDimention, this.state.fullScreenRatio, this.state.displayUOM, actualFieldsCounts)
            // var convertedprods=convertProductstoFullScreen(cmapproductList, normalDimention, this.state.fullScreenRatio)

            //reconvert for full screen view
            var convertedfield = makemapFieldObj( cfieldList, this.state.displayUOM, dimentionforfullscreen, divheight, [] );
            // console.log(convertedfield);
            var cmapfieldObj= convertedfield.mapfieldObj;

            let previewobj = this.props.selectedSimPreviewObj;
            let previewProdList = (previewobj && previewobj.selectedProds && previewobj.selectedProds.length > 0?previewobj.selectedProds:[]);

            var convertedprods = makemaProductsObj(cobj.products, this.state.displayUOM, dimentionforfullscreen, cmapfieldObj, this.props.isShowFromPreview, previewProdList);
            var pegBoardConvert = makePegBoardObj(simLoadedObj.pegBoards , this.state.displayUOM , dimentionforfullscreen )
            let cpegProductList = makePegProductsObj(this.props.mapPegProducts, this.state.displayUOM, dimentionforfullscreen, pegBoardConvert,true,this.props.pegProductOriginalList)

            var fullscreenobj={
                fields: cmapfieldObj,
                products: convertedprods.concat(cpegProductList)
            }

            this.setState({
                fullscreensvgdrawDiemention:{ drawWidth: convertedfield.svgWidth, drawHeight: 0 },
                fullscreenObj:fullscreenobj,
                CategoryWisescalePegBoardObj:pegBoardConvert
            })
        })
    }

    calculateDrawingobject2=()=>{
        let simLoadedObj = JSON.parse(JSON.stringify(this.props.allCategoryData));
        var cobj = JSON.parse(JSON.stringify(this.props.selectedCatRect));
        
        const actualFieldStructures  = cobj?.actualFieldStructures || simLoadedObj?.actualFieldStructures;
        var divheight=1500

        var cfieldList = cobj.fieldList;
        // var normalDimention = makeRatiofromhieghestField(cfieldList, this.state.displayUOM, this.state.catDivHeight);

        var dimentionforfullscreen = makeRatiofromhieghestField(cobj.fieldList, this.state.displayUOM, divheight)
        var cactualFieldStructures2=makemapactualFieldObj(actualFieldStructures,this.state.displayUOM,dimentionforfullscreen,divheight, actualFieldStructures);
        // var cmapFields = JSON.parse(JSON.stringify(this.state.mapFields))
        // var cmapproductList=JSON.parse(JSON.stringify(this.state.mapproductList));

        // let simLoadedObj = this.props.allCategoryData;
        // let actualFieldsCounts = (simLoadedObj?simLoadedObj.actualFieldStructures:[]);

        this.setState({
            fullScreenRatio: dimentionforfullscreen,
            fullscreenheight: divheight
        },()=>{
            // var convertedfield=convertfieldstoFullScreen(cmapFields, normalDimention, this.state.fullScreenRatio, this.state.displayUOM, actualFieldsCounts)
            // var convertedprods=convertProductstoFullScreen(cmapproductList, normalDimention, this.state.fullScreenRatio)

            //reconvert for full screen view
            var convertedfield = makemapFieldObj( cfieldList, this.state.displayUOM, dimentionforfullscreen, divheight, [] );
            var cmapfieldObj= convertedfield.mapfieldObj;

            let previewobj = this.props.selectedSimPreviewObj;
            let previewProdList = (previewobj && previewobj.selectedProds && previewobj.selectedProds.length > 0?previewobj.selectedProds:[]);

            var convertedprods = makemaProductsObj(cobj.products, this.state.displayUOM, dimentionforfullscreen, cmapfieldObj, this.props.isShowFromPreview, previewProdList);
            var pegBoardConvert = makePegBoardObj(simLoadedObj.pegBoards , this.state.displayUOM , dimentionforfullscreen )
            let cpegProductList = makePegProductsObj(this.props.mapPegProducts, this.state.displayUOM, dimentionforfullscreen, pegBoardConvert,true,this.props.pegProductOriginalList)
            
            var fullscreenobj={
                fields: convertedfield.mapfieldObj,
                products: convertedprods.concat(cpegProductList)
            }

            this.setState({
                fullscreensvgdrawDiemention:{ drawWidth: convertedfield.svgWidth, drawHeight: 0 },
                fullscreenobjs:fullscreenobj,
                actualFieldStructuresNew: cactualFieldStructures2,
                mapFields2:convertedfield,
                mapproductList2:convertedprods.concat(cpegProductList),
                scalePegBoardObj:pegBoardConvert
            },()=>{
                this.groupByProduct2();
            })
        })
    }
    toggleProductEditModal = (type) => {
        //get product details after complete
        if(type === "update" && this.state.isShowPreviewModal&&this.state.selectedwarningdropprod){
            this.reloadProdWarnModalDetails();
        }

        this.setState({isShowPreviewModal:!this.state.isShowPreviewModal});
    }
     //get data for product preview modal
     getProductData = (citem ) => {
        if(citem){
            this.setState({loadinggif:true, selectedProduct:null,originalData:{}, isShowPreviewModal:false, snapId:(citem.snapId?citem.snapId:-1)},()=>{
                // let svobj = "?productId="+citem.id;

                let svobj = "";
                if (citem.category === "simulated") {
                    svobj = "?productId=" + citem.productId;
                } else {
                    svobj = "?productId=" + (citem.id || citem.productId);
                }
                submitSets(submitCollection.findProdByID, svobj).then(res => {
                    //console.log(res.extra);
                    this.setState({loadinggif:false});
                    if(res && res.status && res.extra){
                        this.setState({selectedProduct: (res.extra?res.extra:null) , originalData: (res.extra?res.extra:null)},()=>{
                            this.toggleProductEditModal();
                        });
                    } else{
                        this.setState({loadinggif:false})
                        alertService.error(this.props.t("PRODUCT_NOT_FOUND"));
                    }
                });
            });
            // if(!citem.isNew){
            // } else{
            //     this.setState({ isShowPreviewModal: false, selectedProduct: null });
            //     alertService.error(this.props.t("SAVE_PRODUCT_BEFORE_EDIT"));
            // }
        } else{
            this.setState({ isShowPreviewModal: false, selectedProduct: null });
        }
    }
    handleopenDetailmodal=(prod)=>{
        if(this.state.historyData.past.length > 0){
                confirmAlert({
                title: this.props.t('There_are_unsaved_changes'),
                message: this.props.t("You_have_unsaved_changes_please_save_before_continue"),
                overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
                buttons: [{
                    label: this.props.t('OKAY'),
                    onClick: () => {
                        return false;
                    }
                }]
            });
        }else{
            this.getProductData(prod)
        }
    }
    //save product details
    handleSaveProduct = (saveobj, updateSnapshot) => {
        this.setState({isdataloading:true});

        let defSaveObj = this.props.defSaveObj;

        saveobj.mpId = defSaveObj.mp_id;
        saveobj.snapId = this.state.snapId;
        saveobj.isApprovedSnapshot = updateSnapshot;
        saveobj.isUpdateOnlyFlags = false;

        submitSets(submitCollection.updateProds, saveobj, false, null, true).then(res => {
            this.setState({isdataloading:false});
            if(res && res.status){
                alertService.success(this.props.t("PRODUCT_DETAILS_SUCCESSFULLY_UPDATED"));
                // this.sendmarkStackableCall()
                // if(updateSnapshot===true){
                //     this.updateSnapshots(saveobj,true);
                // }
                // else{
                //     this.props.loadSidebarProductList();
                // }
                this.loadAGAINProds()
                //search if have this prod
                var haveidx=this.state.mapproductList.findIndex(x=>x.productId===saveobj.id)
                if(haveidx>-1){
                    this.markingtempStackableprods(null,null,haveidx)
                }

                this.setState({ isShowPreviewModal: false, selectedProduct: null });
            } else{
                // alertService.error(res && res.extra?res.extra:this.props.t("erroroccurred"));
            }
        });
    }

    printInit = (isexcelprint, isfullscreen, isfieldwiseprint) => {
        // update the field wise group ID
        this.updateFieldWIseGroupId(this.state.mapproductList);

        this.setState({ isFieldWisePDFPrint: isfieldwiseprint }, () => {
            if(isexcelprint){
                this.checkExcelPrint(isfullscreen, isfieldwiseprint);
            } else{
                /* if(isfullscreen){
                    this.handletoImage();
                } else{
                    this.print();
                } */

                this.print(isfullscreen);
            }
        });
    }

    checkExcelPrint = (isfullscreen, isfieldwiseprint) => {
        if(!isfullscreen && this.state.historyData.past.length > 0){
            // console.log("if trigred")
            const isValid = this.validateProductOverlapAndDelete();
            if (!isValid) return;
            //have unsaved
            confirmAlert({
                title: this.props.t('There_are_unsaved_changes'),
                message: this.props.t("DO_YOU_WANT_TO_SAVE_AND_PRINT"),
                overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
                buttons: [{
                    label: this.props.t('SavenPrint'),
                    onClick: async () => {
                        this.excelPrint();
                        this.props.togglePrintPending("excel", true, false, async () => {
                        this.setState({isExcelPrintClick: true})
                        this.handleSaveMP();
                        }, this.state.isFieldWisePDFPrint);
                    }
                }, {
                    label: this.props.t('btnnames.close'),
                    /* onClick: () => {
                        this.excelPrint(); 
                    } */
                }]
            })
        }else{
            //no unsaved
            this.excelPrint();
        }
    }

    excelPrint = () => {
        this.setState({ loadinggif: true }, () => {
            
            let isFieldWisePrint = this.state.isFieldWisePDFPrint; //is print is seperate by field
            // let parentobj = (this.props.simulationObj?JSON.parse(JSON.stringify(this.props.simulationObj.fieldList)):null);
            let allprodlist = JSON.parse(JSON.stringify(this.state.mapproductList));    
            let actualFieldsCounts = this.state.actualFieldsCounts;

            let selectedCatRect = this.props.selectedCatRect;
            let fullscreenFields = (this.state.fullscreenObj?this.state.fullscreenObj.fields:null);
            let fullscreenProds = (this.state.fullscreenObj?this.state.fullscreenObj.products:[])

            //****************************************************************************************************************************** */
            //location id new logic 
            let checkSafetyMargin = 3;
            // let exportDataWithoutMerge = compareAndGetFieldProdsWithoutMerge(this.state.mapFields, selectedCatRect, allprodlist, isFieldWisePrint, actualFieldsCounts,
            //     this.state.displayUOM,this.state.displayRatio, checkSaftyMargin);
            // Filter out deleted products
            let newMapProductList = allprodlist.filter(x => !x.isDelete);

            // Sort products by shelfrank and x position (same as groupByProduct2)
            const sortedProducts = [...newMapProductList].sort((a, b) => {
                if (a.shelfrank !== b.shelfrank) {
                    return a.shelfrank - b.shelfrank;
                }
                if (a.x !== b.x) {
                    return a.x - b.x;
                }
                return 0;
            });

            let currentGroupId = 1;
            let groupProducts = [];

            // Assign groupId values to sortedProducts (same logic as groupByProduct2)
            for (let i = 0; i < sortedProducts.length; i++) {
                const product = sortedProducts[i];
                if (i === 0) {
                    var containElem = elmAccordingtoXY(product.x, product.y, product.drawWidth, product.drawHeight, this.state.mapFields, this.state.mapCatRects);
                    let updatedCustomId = this.findCustomFieldIdByX(this.state.mapFields, product.x);
                    product.groupId = currentGroupId;
                    product.field_custom_id = updatedCustomId ? updatedCustomId : product.field_custom_id;
                    product.categoryRectId = containElem ? containElem?.catrect?.catrectId : product.categoryRectId;
                    groupProducts.push(product);
                    continue;
                }

                const previousProd = sortedProducts[i - 1];
                const currentProdStartX = roundOffDecimal(product.x, 2);
                const previousProdEndX = roundOffDecimal(previousProd.x + previousProd.drawWidth, 2);
// console.table( product.shelfrank , previousProd.shelfrank ,
//     product.barcode,  previousProd.barcode, "/",
//     product.masterFieldId , previousProd.masterFieldId, "/",
//     currentProdStartX - previousProdEndX , checkSafetyMargin)
                const isSameGroup =
                    product.shelfrank === previousProd.shelfrank &&
                    product.barcode === previousProd.barcode &&
                    product.masterFieldId === previousProd.masterFieldId &&
                    currentProdStartX - previousProdEndX <= checkSafetyMargin;

                if (!isSameGroup) {
                    // Do not apply applyCustomGroupLogic here (similar to mapproductList3forPdf)
                    currentGroupId++;
                    groupProducts = [];
                }

                let updatedCustomId = this.findCustomFieldIdByX(this.state.mapFields, product.x);
                var containElem = elmAccordingtoXY(product.x, product.y, product.drawWidth, product.drawHeight, this.state.mapFields, this.state.mapCatRects);

                product.groupId = currentGroupId;
                product.field_custom_id = updatedCustomId ? updatedCustomId : product.field_custom_id;
                product.categoryRectId = containElem ? containElem?.catrect?.catrectId : product.categoryRectId;
                groupProducts.push(product);
            }

            // Update allprodlist with the sorted and grouped products
            let updatedProductIds = sortedProducts.map(product => product.id);
            let restProducts = allprodlist.filter(product => !updatedProductIds.includes(product.id));
            allprodlist = [...sortedProducts, ...restProducts];

            // Step 2: Generate exportDataWithoutMerge with the updated allprodlist
            let checkSaftyMargin = roundOffDecimal(this.state.displayRatio, 2);
     
            let exportDataWithoutMerge = compareAndGetFieldProdsWithoutMerge(
                this.state.mapFields,
                selectedCatRect,
                allprodlist,
                isFieldWisePrint,
                actualFieldsCounts,
                this.state.displayUOM,
                this.state.displayRatio,
                checkSaftyMargin
            );
//****************************************************************************************************************************** */
            const fileExtension = '.xlsx';
            //export data
            
            let csvData = [];
            let isrtlview = (this.props.isRTL === "rtl");
            // let styles = { font: { bold: true }, fill: { fgColor: { rgb: "E9E9E9" } }, alignment: { wrapText: false } };
            let baseStyles = { 
                font: { bold: true }, 
                fill: { fgColor: { rgb: "E9E9E9" } }, 
                alignment: { wrapText: false } 
            };
            
            // Apply right alignment for RTL, keep base styles for LTR
            const styles = isrtlview 
                ? { ...baseStyles, alignment: { ...baseStyles.alignment, horizontal: "right" } } 
                : baseStyles; 

            let headerstyles = { font: { bold: true, sz: "16" }, alignment: { horizontal: "center" } };
            let smallheaderstyles = { font: { bold: true, sz: "14" }, alignment: {  horizontal: "center" } };

            const cluster = this.props.clusterData.find(
            (item) => item.id === this.props.selectedClusterId
            );

            let chaindetails = (this.props.signedobj && this.props.signedobj.signinDetails?this.props.signedobj.signinDetails.chain:null);
            let departmentname = (this.props.defSaveObj && this.props.defSaveObj.department?(((this.props.simType === "AUI")?cluster?.department?.importName ? cluster?.department?.importName : cluster?.department?.name:cluster?.department?.importName ? cluster?.department?.importName : cluster?.department?.name)+" "+this.props.t("department")):"-");
            let userdetails = (this.props.signedobj && this.props.signedobj.signinDetails?this.props.signedobj.signinDetails.userDto:null);
            let fieldCount = cluster?cluster?.clusterFieldArrays?.length:0;
            let mpDetails = ((this.props.defSaveObj && this.props.defSaveObj.masterPlanogram)?this.props.defSaveObj.masterPlanogram:undefined);

            let MPVersion = this.props?.EditionName;
            let MPVName = cluster?.name;
            let isOriginatedMPAvailable = (this.props.originatedMpId > 0);

            let totalsum = 0;

                this.props?.simulationObj?.fieldList?.forEach((field) => {
                let width = field?.width ?? field?.field?.width;
                let uom = (field?.uom ?? field?.field?.uom)?.toLowerCase(); // Normalize unit

                if (!isNaN(width)) {
                    switch (uom) {
                    case 'inches':
                    case 'inch':
                    case 'in':
                        width *= 2.54; // 1 inch = 2.54 cm
                        break;

                    case 'ft':
                    case 'feet':
                    case 'foot':
                        width *= 30.48; // 1 foot = 30.48 cm
                        break;

                    case 'mm':
                        width *= 0.1; // 1 mm = 0.1 cm
                        break;

                    case 'm':
                    case 'meter':
                    case 'metre':
                    case 'meters':
                    case 'metres':
                        width *= 100; // 1 m = 100 cm
                        break;

                    case 'cm':
                    default:
                        // Already in cm or unknown, assume cm
                        break;
                    }

                    totalsum += width;
                }
                });

                // const field_Count =
                //     cluster?.clusterFieldArrays?.length > 0
                //         ? cluster.clusterFieldArrays[0]?.fieldArray?.fieldsArrayHasFields?.length || 0
                //         : 0;
                const field_Count = this.props.simulationObj?.fieldList?.length

            if (this.state.isFieldWisePDFPrint) {
                // let headRow = [{v: "", s: headerstyles},{v: "", s: headerstyles},{v: "", s: headerstyles},{v: (chaindetails?chaindetails.chainName:"-"), s: headerstyles},{v: "", s: headerstyles},{v: "", s: headerstyles},{v: "", s: headerstyles}]
                // let headRow2 = [{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: (departmentname+" | "+(isOriginatedMPAvailable?MPVName:(MPVName+" | v"+MPVersion))), s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}]
                // let difference = this.props.fieldWiseExcelDataLabel.length - headRow.length;
                // if (difference >= 1) {
                //     Array(difference).fill(1).forEach((_,i) => headRow.push({v: "", s: headerstyles}));
                // }
                // csvData.push(headRow);
                // if (difference >= 1) {
                //     Array(difference).fill(1).forEach((_,i) => headRow2.push({v: "", s: smallheaderstyles}));
                // }
                // csvData.push(headRow2); 
                let headRow = [
                    { v: "", s: headerstyles },
                    { v: (chaindetails ? chaindetails.chainName : "-"), s: headerstyles },
                    { v: "", s: headerstyles },
                    { v: "", s: headerstyles },
                    { v: "", s: headerstyles },
                ];

                const cluster = this.props.clusterData.find(
                (item) => item.id === this.props.selectedClusterId
                );
                
                // Construct the title components for headRow2
                const departmentText = cluster?.department?.importName ? cluster?.department?.importName + " " + this.props.t("department") : cluster?.department?.name + " " + this.props.t("department"); // e.g., "Electronics Department"
                const mpvNameText = cluster?.name || ""; // e.g., "Spring Plan"
                const mpVersionText = (this.props.EditionName || ""); // e.g., "v1.2"

                
                
                // Build the title based on RTL or LTR
                const title1 = isrtlview
                    ? (isOriginatedMPAvailable
                        ? `${mpvNameText} | ${departmentText}` // RTL: MPVName | department
                        : `${mpVersionText} | ${mpvNameText} | ${departmentText}`)  // RTL: MPVersion | MPVName | department
                    : (isOriginatedMPAvailable
                        ? `${departmentText} | ${mpvNameText} | ${mpVersionText}` // LTR: department | MPVName
                        : `${departmentText} | ${mpvNameText} | ${mpVersionText}`); // LTR: department | MPVName | MPVersion
                    
                // headRow2 with the reformatted title
                
                let headRow2 = [
                    { v: "", s: smallheaderstyles },           
                    { v: title1, s: smallheaderstyles },
                    { v: "", s: smallheaderstyles },
                    { v: "", s: smallheaderstyles },
                    { v: "", s: smallheaderstyles },
                ];

                const title3 = isrtlview 
                ? (`${this.props.t("FIELD_COUNT")} : ${field_Count} | ${this.props.t("TOTAL_WIDTH")} : \u202A${roundOffDecimal(totalsum,2)} cm\u202C`)
                : (`${this.props.t("TOTAL_WIDTH")}:${roundOffDecimal(totalsum,2)} cm | ${this.props.t("FIELD_COUNT")}:${field_Count}`);

                let headRow3 = [
                    { v: "", s: smallheaderstyles },           
                    { v: title3, s: smallheaderstyles },
                    { v: "", s: smallheaderstyles },
                    { v: "", s: smallheaderstyles },
                    { v: "", s: smallheaderstyles },
                ]
            
                let difference = this.props.fieldWiseExcelDataLabel?.length - headRow.length;
                if (difference >= 1) {
                    Array(difference).fill(1).forEach((_, i) => headRow.push({ v: "", s: headerstyles }));
                }
                csvData.push(headRow);
            
                if (difference >= 1) {
                    Array(difference).fill(1).forEach((_, i) => headRow2.push({ v: "", s: smallheaderstyles }));
                }
                csvData.push(headRow2);
                if (difference >= 1) {
                    Array(difference).fill(1).forEach((_, i) => headRow3.push({ v: "", s: smallheaderstyles }));
                }
                csvData.push(headRow3);   
            } else {
                const mpVersionText = (this.props.EditionName || ""); 
                const cluster = this.props.clusterData.find(
                (item) => item.id === this.props.selectedClusterId
                );

                 const mpvNameText = cluster?.name || ""; 

                csvData.push([{v: "", s: headerstyles},{v: "", s: headerstyles},{v: (chaindetails?chaindetails.chainName:"-"), s: headerstyles},{v: "", s: headerstyles},{v: "", s: headerstyles},{v: "", s: headerstyles}]);
                const title2 = isrtlview
                    ? (isOriginatedMPAvailable
                        ? `${mpvNameText} | ${cluster?.department?.importName ? cluster?.department?.importName + " " + this.props.t("department") : cluster?.department?.name + " " + this.props.t("department")}` 
                        : `${mpVersionText} | ${mpvNameText} | ${cluster?.department?.importName ? cluster?.department?.importName + " " + this.props.t("department") : cluster?.department?.name + " " + this.props.t("department")}`)  
                    : (isOriginatedMPAvailable
                        ? `${cluster?.department?.importName ? cluster?.department?.importName + " "+this.props.t("department") : cluster?.department?.name + " " + this.props.t("department")} | ${mpvNameText}` 
                        : `${cluster?.department?.importName ? cluster?.department?.importName + " "+this.props.t("department") : cluster?.department?.name + " "+this.props.t("department")} | ${mpvNameText} | ${mpVersionText}`); 

              csvData.push([{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: title2, s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}]);
              if(isrtlview){
                    csvData.push([{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}, {v: (this.props.t("FIELD_COUNT")+" : "+field_Count+" | "+this.props.t("TOTAL_WIDTH")+" : "+"\u202A"+roundOffDecimal(totalsum,2)+" cm"+"\u202C"), s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}]);
                }else{
                    csvData.push([{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}, {v: (this.props.t("TOTAL_WIDTH")+":"+roundOffDecimal(totalsum,2)+" cm | "+this.props.t("FIELD_COUNT")+":"+field_Count), s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}]);
                } 
                
            }

            let subheaderstyles = { font: { bold: true }, alignment: { wrapText: false, horizontal: "center" } };
            let subheaderstyles2 = { font: { bold: true }, alignment: { wrapText: false, horizontal: "center" } };

            if (this.state.isFieldWisePDFPrint) {
            
                // Construct the title components
                const fieldCountText = isrtlview
                    ? `\u202D${fieldCount}: ${this.props.t("FIELD_ARRAYS")}\u202C` 
                    : `${this.props.t("FIELD_ARRAYS")}:${fieldCount}`;
                const dateText = moment().format("MMMM DD YYYY"); 
                const timeText = moment().format("hh:mm:ss"); 
                const userDetailsText = userdetails ? (userdetails.fName + " " + userdetails.lName) : "-"; 
                
                const excelType = (this.state.isFieldWisePDFPrint ? this.props.t("FIELD_WISE_PRINT") : this.props.t("CATEGORY_WISE_PRINT"))
                // Build the title based on RTL or LTR
                const title = isrtlview
                    ? `${userDetailsText} | ${timeText} | ${dateText} | ${excelType}` 
                    : `${excelType} | ${dateText} |${timeText} | ${userDetailsText}`; 
                
                // headRow1 with the reformatted title
                let headRow1 = [
                    { v: "", s: subheaderstyles },
                    { v: title, s: subheaderstyles },
                    { v: "", s: subheaderstyles },
                    { v: "", s: subheaderstyles },
                    { v: "", s: subheaderstyles }
                ];
                
                let difference = this.props.fieldWiseExcelDataLabel?.length - headRow1.length;
                if (difference >= 1) {
                    Array(difference).fill(1).forEach((_, i) => headRow1.push({ v: "", s: subheaderstyles }));
                }
                csvData.push(headRow1);
                
                // let headRow2 = [
                //     { v: "", s: subheaderstyles2 },
                //     { v: "", s: subheaderstyles2 },
                //     { v: (this.state.isFieldWisePDFPrint ? this.props.t("FIELD_WISE_PRINT") : this.props.t("CATEGORY_WISE_PRINT")), s: subheaderstyles2 },
                //     { v: "", s: subheaderstyles2 },
                //     { v: "", s: subheaderstyles2 },
                //     { v: "", s: subheaderstyles2 }
                // ];
                // if (difference >= 1) {
                //     Array(difference).fill(1).forEach((_, i) => headRow2.push({ v: "", s: subheaderstyles2 }));
                // }
                // csvData.push(headRow2);
            } else {
                if(isrtlview){
                    csvData.push([{v: "", s: subheaderstyles},{v: "", s: subheaderstyles},
                    {v: (((moment().format("MMMM DD YYYY")+" | "+moment().format("hh:mm:ss")+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")+"| " + (this.state.isFieldWisePDFPrint?this.props.t("FIELD_WISE_PRINT"):this.props.t("CATEGORY_WISE_PRINT"))))), s: subheaderstyles},
                    {v: "", s: subheaderstyles},{v: "", s: subheaderstyles},{v: "", s: subheaderstyles}]); 
                }else{
                    csvData.push([{v: "", s: subheaderstyles},{v: "", s: subheaderstyles},
                    {v: ((moment().format("MMMM DD YYYY")+" | "+moment().format("hh:mm:ss")+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")+"| " + (this.state.isFieldWisePDFPrint?this.props.t("FIELD_WISE_PRINT"):this.props.t("CATEGORY_WISE_PRINT")))), s: subheaderstyles},
                {v: "", s: subheaderstyles},{v: "", s: subheaderstyles},{v: "", s: subheaderstyles}]);
                }
                
                // csvData.push([{v: "", s: subheaderstyles2},{v: "", s: subheaderstyles2},
                //     {v: (this.state.isFieldWisePDFPrint?this.props.t("FIELD_WISE_PRINT"):this.props.t("CATEGORY_WISE_PRINT")), s: subheaderstyles2},
                //     {v: "", s: subheaderstyles2},{v: "", s: subheaderstyles2},{v: "", s: subheaderstyles2}]);
            }

            let columnwidths = { barcode: 10, name: departmentname.length, supplier: 10, facing: 10, barcodeTwo:10 };

             // Sort the field data by the 'order' field in ascending order
            const sortedData = [...(this.state.fieldWiseExcelDataLabel || [])].sort((a, b) => a.order - b.order);

            const hasShelfProducts = exportDataWithoutMerge && exportDataWithoutMerge.some(exproditem => {
                if (!exproditem.shelfprods) return false;
                return Object.values(exproditem.shelfprods).some(shelfProducts =>
                    shelfProducts && shelfProducts.some(prod => !prod.isHanged)
                );
            });
            
            if (exportDataWithoutMerge && exportDataWithoutMerge.length > 0 && hasShelfProducts) {
            //=================================non-isHanged products========================================
                // Filter out isHanged products from exportDataWithoutMerge
                const filteredExportData = exportDataWithoutMerge
                .map(exproditem => {
                    // Create a new shelfprods object with hangable products filtered out
                    const filteredShelfprods = {};
                    for (const shelfkey in exproditem.shelfprods) {
                        const shelfProducts = exproditem.shelfprods[shelfkey];
                        // Filter out products where isHangable === true
                        const nonHangableProducts = shelfProducts.filter(shelfprod => !shelfprod.isHanged);
                        // Only include the shelf if it has non-isHanged products
                        if (nonHangableProducts.length > 0) {
                            filteredShelfprods[shelfkey] = nonHangableProducts;
                        }
                    }
                    // Return the updated exproditem only if it has non-empty shelves
                    return Object.keys(filteredShelfprods).length > 0
                        ? { ...exproditem, shelfprods: filteredShelfprods }
                        : null;
                })
                .filter(item => item !== null); // Remove any exproditem with no shelves

                if (filteredExportData.length === 0) {
                    return; // Exit early if there's no data left after filtering
                }

            //=========================================================================
            filteredExportData.forEach((exproditem, index) => {
                    let isrtlview = (this.props.isRTL === "rtl");
                    let fieldstyles = { font: { bold: true, sz: "13" }, fill: { fgColor: { rgb: "DA9694" } }, alignment: { wrapText: false,horizontal: isrtlview ? "right" : "left" } };
                    let fieldstylealign = { font: { bold: true, sz: "13" }, fill: { fgColor: { rgb: "DA9694" } }, alignment: { horizontal: isrtlview ? "right" : "left" } };

                    if (this.state.isFieldWisePDFPrint) {
                        let headRow = [];
                        if (isrtlview) {
                            // RTL: Field_unit_no in the first column, fieldName at the end (right side)
                            headRow = [
                                { v: (exproditem.fieldName ? exproditem.fieldName : "-"), s: fieldstylealign }, 
                                { v: "", s: fieldstyles },
                                { v: "", s: fieldstyles },
                                { v: (this.props.t("Field_unit_no") + " " + (index + 1)), s: fieldstyles }, 
                            ];
                        } else {
                            // LTR: Field_unit_no at the start, fieldName towards the end
                            headRow = [
                                { v: (this.props.t("Field_unit_no") + " " + (index + 1)), s: fieldstyles },
                                { v: "", s: fieldstyles },
                                { v: "", s: fieldstyles },
                                { v: "", s: fieldstyles }
                            ];
                        }
                        
                        let minusVal = sortedData.length >= 7 ? 4 : sortedData.length;
                        let difference = sortedData.length - minusVal;

                        if (difference >= 1) {
                            Array(difference).fill(1).forEach((_, i) => {
                                if (isrtlview) {
                                    // Insert empty cells before Field_unit_no (last element)
                                    headRow.splice(headRow.length - 1, 0, { v: "", s: fieldstyles });
                                } else {
                                    // Append empty cells, then fieldName at the end
                                    if (i === difference - 1) {
                                        headRow.push({ v: (exproditem.fieldName ? exproditem.fieldName : "-"), s: fieldstylealign });
                                    } else {
                                        headRow.push({ v: "", s: fieldstyles });
                                    }
                                }
                            });
                        } else {
                            if (isrtlview) {
                                // Add two empty cells before Field_unit_no
                                headRow.splice(headRow.length - 1, 0, { v: "", s: fieldstyles }, { v: "", s: fieldstyles });
                            } else {
                                // Append fieldName and two empty cells
                                headRow.push(
                                    { v: (exproditem.fieldName ? exproditem.fieldName : "-"), s: fieldstylealign },
                                    { v: "", s: fieldstyles },
                                    { v: "", s: fieldstyles }
                                );
                            }
                        }
                        csvData.push(headRow);
                    } else {
                        if (isrtlview) {
                            // RTL: Category/field unit info at the end, fieldName at the start
                            csvData.push([
                                { v: (exproditem.fieldName ? exproditem.fieldName : "-"), s: fieldstylealign },
                                { v: "", s: fieldstyles },
                                { v: "", s: fieldstyles },
                                { v: "", s: fieldstyles },
                                { v: "", s: fieldstyles },
                                { v: (!this.state.isFieldWisePDFPrint ? (exproditem.category ? (exproditem.category + ": " + exproditem.categoryNo) : "-") : (this.props.t("Field_unit_no") + ": " + (index + 1))), s: fieldstyles }
                            ]);
                        } else {
                            // LTR: Original order (category/field unit info at the start)
                            csvData.push([
                                { v: (!this.state.isFieldWisePDFPrint ? (exproditem.category ? (exproditem.category + ": " + exproditem.categoryNo) : "-") : (this.props.t("Field_unit_no") + ": " + (index + 1))), s: fieldstyles },
                                { v: "", s: fieldstyles },
                                { v: "", s: fieldstyles },
                                { v: "", s: fieldstyles },
                                { v: "", s: fieldstyles },
                                { v: (exproditem.fieldName ? exproditem.fieldName : "-"), s: fieldstylealign }
                            ]);
                        }
                    }

                    if(columnwidths.facing < exproditem.fieldName?.length){
                        columnwidths.facing = (exproditem.fieldName?.length + 5);
                    }
                    for (const shelfkey in exproditem.shelfprods) {
                       // 1. Get the products for this specific key
                        const fieldshelf = exproditem.shelfprods[shelfkey];
                        
                        // 2. Try to find the shelf object. 
                        // If (shelfkey - 1) fails, we search the array for a matching ID or index.
                        let shelfobj = exproditem.shelf[parseInt(shelfkey) - 1];
                        
                        // Fallback: If shelfobj is undefined because the index is out of range
                        if (!shelfobj) {
                            // Option A: Try to find by a property (e.g., if shelf has a 'rank' or 'id')
                            shelfobj = exproditem.shelf.find(s => s.shelfrank == shelfkey) || 
                                    { shelfName: `Shelf ${shelfkey}`, height: 0 }; // Option B: Default object
                        }
                        if(shelfobj){
                            //! HIII
                            let shelfstyles = { font: { bold: true, sz: "13" }, fill: { fgColor: { rgb: "f2ebff" } }, alignment: { wrapText: false } };
                            let shelfstylealign = { font: { bold: true, sz: "13" }, fill: { fgColor: { rgb: "f2ebff" } }, alignment: { horizontal: "right" } };

                            if (this.state.isFieldWisePDFPrint) {                                
                                let headRow = [];
                                if (isrtlview) {
                                    // RTL: Shelf_unit_no at the end, right-aligned
                                    headRow = [
                                        { v: "", s: shelfstyles }, 
                                        { v: "", s: shelfstyles },
                                        { v: "", s: shelfstyles }, 
                                        { v: "", s: shelfstyles },
                                      
                                        { v: (this.props.t("Shelf_unit_no") + " " + shelfkey), s: { ...shelfstyles, alignment: { ...shelfstyles.alignment, horizontal: "right" } } } // Right-align Shelf_unit_no
                                    ];
                                } else {
                                    // LTR: Shelf_unit_no at the start, default alignment
                                    headRow = [
                                        { v: (this.props.t("Shelf_unit_no") + " " + shelfkey), s: shelfstyles }, // Default alignment (left or center)
                                        { v: "", s: shelfstyles }, 
                                        { v: "", s: shelfstyles },
                                        { v: "", s: shelfstyles }, 
                                        { v: "", s: shelfstyles },
                                        { v: "", s: shelfstylealign }, 
                                        { v: "", s: shelfstylealign }
                                    ];
                                }
                                let difference = sortedData.length - headRow.length;
                                if (difference >= 1) {
                                    Array(difference).fill(1).forEach((_, i) => {
                                        if (isrtlview) {
                                            // Insert empty cells before the last element (Shelf_unit_no)
                                            headRow.splice(headRow.length - 1, 0, { v: "", s: shelfstyles });
                                        } else {
                                            // Append empty cells for LTR
                                            headRow.push({ v: "", s: shelfstyles });
                                        }
                                    });
                                }
                                csvData.push(headRow); 

                                const dataToIterate = isrtlview ? [...sortedData].reverse() : sortedData;
                                // const labelData = dataToIterate.map((item) => {
                                //     let labelValue = item.label;
                                //     if (isrtlview) {
                                //         const translationEntry = Object.values(LabelTranslations).find(
                                //             trans => trans.en === item.label
                                //         );
                                //         labelValue = translationEntry ? translationEntry.he : item.label;
                                //     }
                                //     return { v: labelValue, s: styles };
                                // });
                                //field wise print excel column data set
                                let labelData = [];
                                
                                dataToIterate.forEach((label) => {
                                   const translatedLabel = label.label; //isrtlview ? this.props.t(label.fieldsList) : label.label;
                                   return labelData.push({v: translatedLabel, s: styles})
                                })
                                csvData.push(labelData);
                            } else {
                            //    csvData.push([{v: (this.props.t("Shelf_unit_no")+" "+shelfobj.rank), s: shelfstyles}, {v: "", s: shelfstyles}, {v: "", s: shelfstyles},{v: "", s: shelfstyles},{v: "", s: shelfstyles},{v: "", s: shelfstyles},]); //exproditem.fieldName
                            if (isrtlview) {
                                csvData.push([
                                    { v: "", s: shelfstyles }, { v: "", s: shelfstyles }, { v: "", s: shelfstyles },
                                    { v: "", s: shelfstyles }, { v: "", s: shelfstyles },
                                    { v: (this.props.t("Shelf_unit_no") + " " + shelfkey), s: shelfstyles }
                                ]);
                            } else {
                                csvData.push([
                                    { v: (this.props.t("Shelf_unit_no") + " " + shelfkey), s: shelfstyles },
                                    { v: "", s: shelfstyles }, { v: "", s: shelfstyles }, { v: "", s: shelfstyles },
                                    { v: "", s: shelfstyles }, { v: "", s: shelfstyles }
                                ]);
                            }
                                // //category wise print excel column data set
                                // csvData.push([{v: this.props.t("barcode"), s: styles}, {v: this.props.t("PRODUCT_NAME"), s: styles}, {v: this.props.t("supname"),s:styles},{v: this.props.t("brand"),s:styles}, {v: this.props.t("FACING"), s: styles},{v: this.props.t("STACK_COUNT"), s: styles}]);   
                                if (isrtlview) {
                                    csvData.push([
                                        { v: this.props.t("STACK_COUNT"), s: styles },
                                        { v: this.props.t("FACING"), s: styles },
                                        { v: this.props.t("brand"), s: styles },
                                        { v: this.props.t("supname"), s: styles },
                                        { v: this.props.t("PRODUCT_NAME"), s: styles },
                                        { v: this.props.t("barcode"), s: styles }
                                    ]);
                                } else {
                                    csvData.push([
                                        { v: this.props.t("barcode"), s: styles },
                                        { v: this.props.t("PRODUCT_NAME"), s: styles },
                                        { v: this.props.t("supname"), s: styles },
                                        { v: this.props.t("brand"), s: styles },
                                        { v: this.props.t("FACING"), s: styles },
                                        { v: this.props.t("STACK_COUNT"), s: styles }
                                    ]);
                                }
                            }
                           
                            fieldshelf.forEach(shelfprod => {
                                
                                let shelfprodsup = (shelfprod.productBrand && shelfprod.productBrand.supplier?shelfprod.productBrand.supplier.supplierName:"-");
                                let brandname =(shelfprod.productBrand && shelfprod.productBrand.brandName?shelfprod.productBrand.brandName:"-");
                                let count = Number(this.validateProductHeight(shelfprod));
                                let stackcount = shelfprod.isStackable ? count ? count === 0 ? 1 : (count > 0 ? count + 1 : count): 1: 1;
                                let barcodeTwo = shelfprod.barcodeTwo ? shelfprod.barcodeTwo : ' ';
                                const columnsToIterate = isrtlview ? [...sortedData].reverse() : sortedData;

                                if (this.state.isFieldWisePDFPrint) {
                                    //field wise print excel column data set
                                    let fieldData = [];
                                    // Prefer field-specific lookup for field-wise group id (handles same product on multiple shelves)
                                    const fieldIdForShelfProd = (shelfprod?.actualFieldInfo && shelfprod.actualFieldInfo.length > 0) ? shelfprod.actualFieldInfo[0].actualFieldId : null;
                                    let filedWiseGroupIdText = this.getFieldWiseGroupId(shelfprod?.id, false, fieldIdForShelfProd) || this.getFieldWiseGroupId(shelfprod?.id);

                                    columnsToIterate.forEach((label) => {
                                        if (label.fieldsList === 'barcode') return fieldData.push(shelfprod?.barcode)
                                        if (label.fieldsList === 'productName') return fieldData.push(shelfprod?.name)
                                        if (label.fieldsList === 'supplierName') return fieldData.push(shelfprodsup)
                                        if (label.fieldsList === 'face') return fieldData.push(shelfprod?.qty)
                                        if (label.fieldsList === 'layers') return fieldData.push(stackcount)
                                        if (label.fieldsList === 'barcodeTwo') return fieldData.push(barcodeTwo)
                                        // if (label.fieldsList === 'locationId') return fieldData.push(shelfprod.groupId)
                                        if (label.fieldsList === 'locationId') return fieldData.push(filedWiseGroupIdText)
                                        if (label.fieldsList === 'sale') return fieldData.push(shelfprod?.normalizedData?.salesCurrency)
                                        if (label.fieldsList === 'label') return fieldData.push(shelfprod?.productLabel?.name)
                                        if (label.fieldsList === 'width') return fieldData.push(`${shelfprod.width}  ${shelfprod?.uom}`)
                                        if (label.fieldsList === 'brand') return fieldData.push(brandname)
                                    })
                                    const baseRowStyle = shelfprod?.isNew ? { fill: { fgColor: { rgb: "75E81E" } } } : {};

                                    // Apply right alignment for RTL, keep base style for LTR
                                    const rowStyle = isrtlview 
                                        ? { ...baseRowStyle, alignment: { horizontal: "right" } } // Right-align for RTL
                                        : baseRowStyle; // Default alignment for LTR
                                
                                    // Prepare the row with styles
                                    const rowWithStyle = fieldData.map((value, index) => {
                                        return { v: value, s: rowStyle }; // Apply the style to each cell
                                    });
                                    csvData.push(rowWithStyle);
                                } else {
                                    // //category wise print excel column data set
                                    // csvData.push([shelfprod.barcode, shelfprod.name, shelfprodsup, brandname,shelfprod.qty,stackcount]);
                                  const baseRowStyle = shelfprod?.isNew ? { fill: { fgColor: { rgb: "75E81E" } } } : {};
    
                                const rowStyle = isrtlview 
                                    ? { ...baseRowStyle, alignment: { horizontal: "right" } } 
                                    : { ...baseRowStyle, alignment: { horizontal: "left" } }; 
                                
                                let rowData;
                                if (isrtlview) {
                                    rowData = [stackcount, shelfprod.qty, brandname, shelfprodsup, shelfprod.name, shelfprod.barcode];
                                } else {
                                    rowData = [shelfprod.barcode, shelfprod.name, shelfprodsup, brandname, shelfprod.qty, stackcount];
                                }
                                
                                const rowWithStyle = rowData.map((value) => {
                                    return { v: value, s: rowStyle };
                                });
                                
                                csvData.push(rowWithStyle);
                                }
                            });
                        }
                    }
                });
            }

              //=============================PEGBOARD EXCEL=============================


            // csvData.push([{ v: "" }]); 

              //get pegboard data
            let pegBoards = this.state.pegList;
  
            let pegLocationId = 1; // Start sequence from 1 across all pegboards
             
              pegBoards.forEach((pegBoard, index) => {
              
                  //Filtered pegProducts for pegBoard
                  const pegProducts = allprodlist.filter(product => 
                    
                    product.pegBoard && product.pegBoard.id === pegBoard.id && product.pegBoard.pegLength > 0
                );
            

                const pegBoardDetailsStyles = {
                    ...styles, 
                    font: { bold: true, sz: "13" },
                    fill: { fgColor: { rgb: "DA9694" } } 
                };

                if (this.state.isFieldWisePDFPrint) {
                    const dynamicHeaders = sortedData.map(item => item.label);
                    let pegBoardDetailsRow;
                    if (isrtlview) {
                        pegBoardDetailsRow = [
                            ...Array(dynamicHeaders.length - 4).fill({ v: "", s: pegBoardDetailsStyles }),
                            { v: `d: ${pegBoard.pegLength ? pegBoard.pegLength.toFixed(2) : ""} cm`, s: pegBoardDetailsStyles },
                            { v: `w: ${pegBoard.gapW ? pegBoard.gapW.toFixed(2) : ""} cm`, s: pegBoardDetailsStyles },
                            { v: `h: ${pegBoard.gapH ? pegBoard.gapH.toFixed(2) : ""} cm`, s: pegBoardDetailsStyles },
                            { v: `${this.props.t("PEG_BOARD")} ${index + 1}`, s: pegBoardDetailsStyles }  
                        ];
                    } else {
                        pegBoardDetailsRow = [
                            { v: `${this.props.t("PEG_BOARD")} ${index + 1}`, s: pegBoardDetailsStyles },  
                            { v: `h: ${pegBoard.gapH ? pegBoard.gapH.toFixed(2) : ""} cm`, s: pegBoardDetailsStyles },
                            { v: `w: ${pegBoard.gapW ? pegBoard.gapW.toFixed(2) : ""} cm`, s: pegBoardDetailsStyles },
                            { v: `d: ${pegBoard.pegLength ? pegBoard.pegLength.toFixed(2) : ""} cm`, s: pegBoardDetailsStyles },
                            ...Array(dynamicHeaders.length - 4).fill({ v: "", s: pegBoardDetailsStyles })
                        ];
                    }
                    csvData.push(pegBoardDetailsRow);

                    const headerRow = (isrtlview ? [...dynamicHeaders].reverse() : dynamicHeaders).map(header => ({
                        v: header, s: styles
                    }));
                    csvData.push(headerRow);
                    const fieldMapping = {
                        barcode: (pegProduct) => pegProduct.barcode || "", 
                        barcodeTwo: (pegProduct) => pegProduct.barcodeTwo || "", 
                        productName: (pegProduct) => pegProduct.name || "", 
                        supplierName: (pegProduct) => 
                            pegProduct.productBrand && pegProduct.productBrand.supplier 
                            ? pegProduct.productBrand.supplier.supplierName || "" 
                            : "", // Nested field
                        face: (pegProduct) => Number(pegProduct.qty) || 1, 
                        layers: (pegProduct) =>  pegProduct.stackCount ? (Number(this.validateProductHeight(pegProduct)) === 0 ? 1 : (Number(this.validateProductHeight(pegProduct)) > 0 ? Number(this.validateProductHeight(pegProduct)) + 1 : Number(this.validateProductHeight(pegProduct)))) : 1, 
                        // Use field-specific lookup (fall back to generic lookup if needed)
                        locationId: (pegProduct) => this.getFieldWiseGroupId(pegProduct.id, false, pegProduct?.actualFieldInfo?.[0]?.actualFieldId) || this.getFieldWiseGroupId(pegProduct.id) || "", 
                        width: (pegProduct) => pegProduct.width ? `${pegProduct.width} cm` : "", 
                        sale: (pegProduct) => pegProduct?.normalizedData?.salesCurrency, 
                        label:(pegProduct) => pegProduct.productLabel && pegProduct.productLabel.name || "" ,
                        brand:(pegProduct) => pegProduct?.brand?.brand?.brandName && pegProduct?.brand?.brand?.brandName || "" ,
                    };
                     
                     if (pegProducts && pegProducts.length > 0) {
                        const sortedPegProducts = pegProducts.sort((a, b) => {
                        const locationA = this.getFieldWiseGroupId(a.id, false, a?.actualFieldInfo?.[0]?.actualFieldId) || this.getFieldWiseGroupId(a.id) || "";
                        const locationB = this.getFieldWiseGroupId(b.id, false, b?.actualFieldInfo?.[0]?.actualFieldId) || this.getFieldWiseGroupId(b.id) || "";
                        
                        const getFirstNumber = (loc) => {
                            if (!loc) return 999; 
                            const firstNum = loc.toString().split(',')[0].trim();
                            const parsed = parseInt(firstNum, 10);
                            return isNaN(parsed) ? 999 : parsed;
                        };
                
                            return getFirstNumber(locationA) - getFirstNumber(locationB);
                        });

                        sortedPegProducts.forEach((pegProduct) => {
                            // Map the data using the fieldMapping object
                            let rowData = sortedData.map(item => {
                                const mappingFunction = fieldMapping[item.fieldsList] || (() => ""); 
                                return mappingFunction(pegProduct);
                            });

                            if (isrtlview) {
                             rowData = [...rowData].reverse();
                            }
                
                            const rowWithStyle = rowData.map((value) => {
                                const alignmentStyle = isrtlview ? { alignment: { horizontal: "right" } } : {};
                                return { v: value, s: { ...alignmentStyle } }; 
                            });
                            csvData.push(rowWithStyle);
                
                            // Update column widths based on the second table data
                            sortedData.forEach((item, idx) => {
                                const value = rowData[idx];
                                const valueLength = typeof value === "string" ? value.length : String(value).length;
                                if (columnwidths[item.fieldsList] < valueLength) {
                                    columnwidths[item.fieldsList] = valueLength + 5;
                                }
                            });
                    });

                    }
                    else {
                        
                        const noDataRow = [
                            { v: "No Data", s: { alignment: { horizontal: "center" } } },
                            { v: "" }, { v: "" }, { v: "" }, { v: "" }, { v: "" },
                            { v: "" }, { v: "" }, { v: "" }, { v: "" }, { v: "" }, { v: "" }
                        ];

                        if (isrtlview) {
                            noDataRow.reverse();
                        }
                        csvData.push(noDataRow);
                    }
            }
            else {
                const emptyCell = { v: "", s: pegBoardDetailsStyles };
                const pegboardText = `${this.props.t("PEG_BOARD")} ${index + 1}`;

                let pegBoardDetailsRow;

                if (isrtlview) {
                    pegBoardDetailsRow = [
                        emptyCell, emptyCell, emptyCell, emptyCell, emptyCell,
                        { v: pegboardText, s: pegBoardDetailsStyles }
                    ];
                } else {
                    pegBoardDetailsRow = [
                        { v: pegboardText, s: pegBoardDetailsStyles },
                        emptyCell, emptyCell, emptyCell, emptyCell, emptyCell 
                    ];
                }

                csvData.push(pegBoardDetailsRow);
                
                const headers = [
                    this.props.t("barcode"), 
                    this.props.t("PRODUCT_NAME"), 
                    this.props.t("supname"), 
                    this.props.t("brand"), 
                    this.props.t("FACING"),
                    this.props.t("STACK_COUNT")
                ];
                
                const headerRow = (isrtlview ? [...headers].reverse() : headers).map(header => ({
                    v: header,
                    s: styles
                }));
                csvData.push(headerRow);

                // Sort pegProducts by fieldWiseGroupId (locationId)
                if (pegProducts && pegProducts.length > 0) {
                    const sortedPegProducts = [...pegProducts].sort((a, b) => {
                        const groupIdA = this.getFieldWiseGroupId(a?.id) || '';
                        const groupIdB = this.getFieldWiseGroupId(b?.id) || '';

                        const idsA = groupIdA.split(',').map(id => id.trim());
                        const idsB = groupIdB.split(',').map(id => id.trim());

                        const firstIdA = idsA[0];
                        const firstIdB = idsB[0];
                        const numA = parseInt(firstIdA);
                        const numB = parseInt(firstIdB);

                        if (!isNaN(numA) && !isNaN(numB)) {
                            return numA - numB;
                        }
                        return groupIdA.localeCompare(groupIdB, undefined, { numeric: true, sensitivity: 'base' });
                    });

                    sortedPegProducts.forEach((pegProduct) => {
                        const brandName = pegProduct.productBrand?.brandName || "-";
                        const supplierName = pegProduct.productBrand?.supplier?.supplierName || "-";

                        const rowData = [
                            pegProduct.barcode || "-",     // UPC
                            pegProduct.name || "-",        // Product Name
                            supplierName,                  // Supplier
                            brandName,                     // Brand
                            pegProduct.qty || 1,           // Facing
                            pegProduct.stackCount
                                ? (Number(pegProduct.stackCount) === 0
                                    ? 1
                                    : Number(pegProduct.stackCount) > 0
                                        ? Number(pegProduct.stackCount) + 1
                                        : Number(pegProduct.stackCount))
                                : 1,                      // Stack Count
                        ];

                        const baseRowStyle = pegProduct?.isNew
                            ? { fill: { fgColor: { rgb: "75E81E" } } }
                            : {};

                        const rowStyle = isrtlview
                            ? { ...baseRowStyle, alignment: { horizontal: "right" } } 
                            : { ...baseRowStyle, alignment: { horizontal: "left" } };   

                        const rowWithStyle = (isrtlview ? [...rowData].reverse() : rowData).map((value) => {
                            return { v: value, s: rowStyle };
                        });

                        csvData.push(rowWithStyle);
                    });
                } else {                     
                    const noDataRow = [
                        { v: "No Data", s: { alignment: { horizontal: "center" } } },
                        { v: "" }, { v: "" }, { v: "" }, { v: "" }, { v: "" },
                        { v: "" }, { v: "" }, { v: "" }, { v: "" }, { v: "" }, { v: "" }
                    ];
                    csvData.push(noDataRow);
                }
            }         
              });
              //===============================

            const wb = XLSX.utils.book_new();
            // const wb = { Workbook: { Views: [{ RTL: (this.props.isRTL === "rtl"?true:false) }] }, Sheets: {}, SheetNames: [] };

            let ws = XLSX.utils.aoa_to_sheet(csvData);//set column widths
            const shelfUnitText = this.props.t("Shelf_unit_no");

            if (this.state.isFieldWisePDFPrint) {
            ws['!merges'] = [
                { s: { r: 0, c: 1 }, e: { r: 0, c: 7 } }, 
                { s: { r: 1, c: 1 }, e: { r: 1, c: 7 } },
                { s: { r: 2, c: 1 }, e: { r: 2, c: 7 } },
                { s: { r: 3, c: 1 }, e: { r: 3, c: 7 } }  
            ];
        } else {
            ws['!merges'] = [
                { s: { r: 0, c: 2 }, e: { r: 0, c: 5 } }, 
                { s: { r: 1, c: 2 }, e: { r: 1, c: 5 } },
                { s: { r: 2, c: 2 }, e: { r: 2, c: 5 } },
                { s: { r: 3, c: 2 }, e: { r: 3, c: 5 } }  
            ];
        }

            let fieldWidth = [];
            const columnsToIterate = this.props.isRTL === "rtl" ? [...sortedData].reverse() : sortedData;
            columnsToIterate.forEach((label) => {
                if (label.fieldsList === 'barcode') return fieldWidth.push({wch: parseInt(label.width)})
                if (label.fieldsList === 'productName') return fieldWidth.push({wch: parseInt(label.width)})
                if (label.fieldsList === 'supplierName') return fieldWidth.push({wch: parseInt(label.width)})
                if (label.fieldsList === 'face') return fieldWidth.push({wch: parseInt(label.width)})
                if (label.fieldsList === 'layers') return fieldWidth.push({wch: parseInt(label.width)})
                if (label.fieldsList === 'barcodeTwo') return fieldWidth.push({wch: parseInt(label.width)})
                if (label.fieldsList === 'locationId') return fieldWidth.push({wch: parseInt(label.width)})
                if (label.fieldsList === 'sale') return fieldWidth.push({wch:  parseInt(label.width)})
                if (label.fieldsList === 'label') return fieldWidth.push({wch:  parseInt(label.width)})
                if (label.fieldsList === 'width') return fieldWidth.push({wch:  parseInt(label.width)})
                if (label.fieldsList === 'brand') return fieldWidth.push({wch:  parseInt(label.width)})
            })

            let wscols = [ {wch: columnwidths.barcode}, {wch: columnwidths.name}, {wch: columnwidths.supplier}, {wch: columnwidths.facing}];

            if (this.state.isFieldWisePDFPrint) {
                ws['!cols'] = fieldWidth; 
            } else {
                ws['!cols'] = wscols;
            }
            
            XLSX.utils.book_append_sheet(wb, ws, "readme");

            var depname=cluster?.department?.importName ? cluster?.department?.importName : cluster?.department?.name;
            let userlogged = (this.props.signedobj && this.props.signedobj.signinDetails&&this.props.signedobj.signinDetails.userDto?(this.props.signedobj.signinDetails.userDto.fName+"-"+this.props.signedobj.signinDetails.userDto.lName):"");
            let filename=(depname+"_"+userlogged+"_"+fieldCount+"Fields");

            // STEP 4: Write Excel file to browser
            XLSX.writeFile(wb, replaceSpecialChars(replaceSpecialChars(String(filename)))+fileExtension);
            this.setState({isExcelPrintClick:false,loadinggif2:false, loadinggif:false},()=>{
                //close fullscreen
                this.props.togglePrintPending("done", false, true);
            })
        });
    }

    print = (isfullscreen) => {
        if(this.state.historyData.past.length > 0){ //!isfullscreen &&
            const isValid = this.validateProductOverlapAndDelete();
            if (!isValid) return;
            //have unsaved
            confirmAlert({
                title: this.props.t('There_are_unsaved_changes'),
                message: this.props.t("DO_YOU_WANT_TO_SAVE_AND_PRINT"),
                overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
                buttons: [{
                    label: this.props.t('SavenPrint'),
                    onClick: async () => {
                    
                        this.props.togglePrintPending("pdf", true, false, async () => {
                            // // Start the print process
                           
    
                            // //  Wait until the PDF download completes
                            // const waitForPDFDownload = async () => {
                            //     return new Promise(resolve => {
                            //         const interval = setInterval(() => {
                            //             let filteredmapproductList = this.state.mapproductList.filter(x => x.isDelete !== true);
                                        
                            //             if (filteredmapproductList.length === this.state.loadedprodcount && !this.state.loadinggif2) {
                                            
                            //                 clearInterval(interval);
                            //                 resolve();
                            //             }
                            //         }, 500); // Check every 500ms
                            //     });
                            // };
    
                            //await waitForPDFDownload(); // Ensure the PDF is downloaded
    
                            //  Now, trigger handleSaveMP()
                            this.setState({isPdfPrintClick:true});
                            this.handleSaveMP();
                        }, this.state.isFieldWisePDFPrint);
                    }
                }, {
                    label: this.props.t('btnnames.close'),
                    // /* onClick: () => {
                    //     this.gotprintStart()
                    // } */
                }]
            })
        } else{
            //no unsaved
            this.gotprintStart();
        }
    }

    gotPrintExcel = () => {
        this.setState({ printloading: true, loadinggif: true }, () => {
            this.handleloadedprodcount()
            // update the field wise group ID
            this.updateFieldWIseGroupId(this.state.mapproductList);

            let filterdmapproductList = this.state.mapproductList.filter(x => x.isDelete !== true);

            // Check if all objects have masterFieldId defined
            const allMasterFieldIdDefined = filterdmapproductList.every(x => x.masterFieldId !== undefined);
          
            // If not all objects have masterFieldId defined, wait for a while and try again
            if (!allMasterFieldIdDefined) {
                setTimeout(this.gotPrintExcel, 1000); // Try again after 1 second
            } else {
                if (filterdmapproductList.length !== this.state.loadedprodcount){
                    setTimeout(this.gotPrintExcel, 1000); // Try again after 1 second
                } 
                else {
                    setTimeout(this.excelPrint, 1000);
                }
            }
        })
    }


    gotprintStart = () => {
        if (this.state.isPrintingInProgress) {
            return;
        }
        this.setState({ printloading: true }, () => {
            this.setFullscreenShow(true);
            setTimeout(() => {
                this.setState({ loadinggif2: true });
            }, 50);

            this.updateFieldWIseGroupId(this.state.mapproductList);

            const targetCount = this.state.mapproductList.filter(x => x.isDelete !== true).length;
            this._waitForProdsLoaded(targetCount);
        });
    }

    _waitForProdsLoaded = (targetCount) => {
        const current = this.state.loadedprodcount;
        const fullscreenReady = this.state.fullscreenobjs &&
            this.state.fullscreenobjs.fields &&
            Object.keys(this.state.fullscreenobjs.fields).length > 0;

        if (current >= targetCount && fullscreenReady) {
            this.handletoImage();
        } else {
            window.setTimeout(() => this._waitForProdsLoaded(targetCount), 500);
        }
    }
    handletoImage = () => {
        this.setState({
            loadinggif2: true
        }, () => {
            setTimeout(() => {
                this.StartPrint();
            }, 1000);

        });
    }

    // StartPrint = () => {
    //     let chaindetails = (this.props.signedobj && this.props.signedobj.signinDetails?this.props.signedobj.signinDetails.chain:null);
    //     let userdetails = (this.props.signedobj && this.props.signedobj.signinDetails?this.props.signedobj.signinDetails.userDto:null);

    //     toImg('.sim-catpreview-all-full', 'name', {
    //         quality: 0.01,
    //         download: false,
    //       }).then(fileData => {
    //         //do something with the data
    //         var calratio = CalculateRatio(this.state.fullscreenheight,this.state.printHeight)

    //         this.setState({
    //             PrintFullImg: fileData,
    //             printRatio: calratio,
    //             printWidth: (this.state.fullscreensvgdrawDiemention.drawWidth * calratio),
    //         },()=>{
    //             let isFieldWisePrint = this.state.isFieldWisePDFPrint; //is print is seperate by field

    //             // var imagearray = [];
    //             //create canvas to crop all simulation fields
    //             var canvas = document.getElementById("simcatfull-canvas");
    //             var ctx = canvas.getContext("2d");
    //             var image = new Image();
    //             //   console.log(this.state.fullscreenObj,JSON.parse(JSON.stringify(this.state.fullscreenObj)));
    //             let fullscreenFields = (this.state.fullscreenObj?this.state.fullscreenObj.fields:null);
    //             let fullscreenProds = (this.state.fullscreenObj?this.state.fullscreenObj.products:[]);

    //             let selectedCatRect = this.props.selectedCatRect;
    //             let actualFieldsCounts = this.state.actualFieldsCounts;

    //             let checkSaftyMargin = roundOffDecimal((this.state.isShowFullscreen?this.state.fullScreenRatio:this.state.displayRatio),2);
    //             let printallprods = compareAndGetFieldProds(fullscreenFields, selectedCatRect, fullscreenProds, isFieldWisePrint, actualFieldsCounts,
    //                 this.state.displayUOM, (this.state.isShowFullscreen?this.state.fullScreenRatio:this.state.displayRatio), checkSaftyMargin);

    //             let printallprodsWithoutMerge = compareAndGetFieldProdsWithoutMerge(fullscreenFields, selectedCatRect, fullscreenProds, isFieldWisePrint, actualFieldsCounts,
    //                 this.state.displayUOM, (this.state.isShowFullscreen?this.state.fullScreenRatio:this.state.displayRatio), checkSaftyMargin);
    //             // console.log(printallprods);

    //             //set canvas width/height
    //             canvas.width=this.state.printWidth;
    //             canvas.height=this.state.printHeight;

    //             //crop image
    //             image.src = this.state.PrintFullImg;
    //             image.onload = () =>{
    //                 //after image loaded set image to canvas
    //                 ctx.drawImage(image, 0, 0, this.state.printWidth, this.state.printHeight);

    //                 //loop available fields
    //                 let fieldcropx = 0; //last crop x
    //                 let newprintfields = []; //new fields list after image cropping
    //                 for (let k = 0; k < printallprods.length; k++) {
    //                     const printfieldobj = printallprods[k];
    //                     //empty image array
    //                     printfieldobj["imagearray"] = [];

    //                     let fieldtotalwidth = (printfieldobj.totalDrawWidth * calratio);
    //                     // let fieldendx = (fieldtotalwidth * (k > 0?(k + 1):1));
    //                     let fieldendx = (fieldcropx + fieldtotalwidth);

    //                     let printpagecount = Math.ceil(fieldtotalwidth / this.state.printonepagewidthinPX);
    //                     // console.log(printpagecount, this.state.printWidth, fieldtotalwidth);
    //                     for (let z = 0; z < printpagecount; z++) {
    //                         let nextFieldWidth = (printallprods[k + 1] ? printallprods[k + 1].totalDrawWidth * calratio : 0); // Field 2's width
    //                         let combinedFieldEndX = fieldendx + nextFieldWidth; // Combined end for two fields

    //                         let cropwidth = (
    //                             (((fieldcropx + this.state.printonepagewidthinPX) > fieldendx) || ((z + 1) === printpagecount && (fieldcropx + this.state.printonepagewidthinPX) < fieldendx))?(fieldendx - fieldcropx)
    //                             :this.state.printonepagewidthinPX);
    //                         let cropwidthper = convertWidthPercent(cropwidth, this.state.printonepagewidthinPX);

    //                         //check last one is less than 50% of print page size
    //                         let islastpageadded = false;
    //                         if((z + 2) === printpagecount){
    //                             let lastpagecropx = (fieldcropx + cropwidth);
    //                             let lastcropwidth = ((((lastpagecropx + this.state.printonepagewidthinPX) > fieldendx) || ((z + 1) === printpagecount && (lastpagecropx + this.state.printonepagewidthinPX) < fieldendx))?(fieldendx - lastpagecropx):this.state.printonepagewidthinPX);
    //                             let lastpageper = convertWidthPercent(lastcropwidth, this.state.printonepagewidthinPX);

    //                             if(lastpageper < 50){
    //                                 cropwidth = (cropwidth + lastcropwidth);
    //                                 islastpageadded = true;
    //                             }
    //                         }

    //                         if(cropwidthper > 1){
    //                             let outbase64 = this.createcanvasiandexportbase64(ctx, fieldcropx, cropwidth);
    //                             printfieldobj.imagearray.push({
    //                                 width: convertWidthPercent(cropwidth, this.state.printonepagewidthinPX),
    //                                 imgsrc: outbase64,
    //                                 fieldName:printfieldobj.fieldName
    //                             });
    //                         }

    //                         fieldcropx = (fieldcropx + cropwidth);



    //                         if(islastpageadded){
    //                             break;
    //                         }
    //                     }

    //                     if(printfieldobj.imagearray.length > 0){
    //                         newprintfields.push(printfieldobj);
    //                     }
    //                 }

    //                 printallprods = newprintfields;

    //                 // console.log(printallprods);

    //                 let generatedDate = moment().format("MMMM DD YYYY");
    //                 let generatedTime = moment().format("hh:mm:ss");

    //                 let callAddFont = function () {
    //                     this.addFileToVFS('Assistant-Medium-normal.ttf', assistant_medium);
    //                     this.addFont('Assistant-Medium-normal.ttf', 'Assistant-Medium', 'normal');
    //                 };
    //                 jsPDF.API.events.push(['addFonts', callAddFont])
    //                 // this.setState({loadinggif:false})

    //                 const pdf = new jsPDF({
    //                     orientation: "landscape",
    //                     unit: "px",
    //                     format:'a4',
    //                     // compress: true
    //                 });

    //                 let width = pdf.internal.pageSize.getWidth();
    //                 let height = pdf.internal.pageSize.getHeight();

    //                 let isrtlview = (this.props.isRTL === "rtl");

    //                 pdf.setFont("Assistant-Medium", "normal");
    //                 document.getElementById("simcatprint-wrapper").style.display = "block";
    //                 htmlToImage.toPng(document.getElementById("simcatprint-wrapper"), {
    //                     width: 1191,
    //                     height: 842,
    //                     quality: 1,
    //                     cacheBust: true,
    //                 })
    //                 .then((coverimage) => {
    //                     if(document.getElementById("simcatprint-wrapper")){
    //                         document.getElementById("simcatprint-wrapper").style.display = "none";
    //                     }

    //                     pdf.addImage(coverimage, 'PNG', 0, 0,width, height, "alias1", "FAST");
    //                     pdf.addPage();

    //                     //if rtl then set rtl
    //                     const optionsL = {
    //                         isInputVisual: false,
    //                         isOutputVisual: true,
    //                         isInputRtl: false,
    //                         isOutputRtl: false,
    //                         align: (isrtlview?"left":"right")
    //                       };
    //                       const optionsR = {
    //                         isInputVisual: false,
    //                         isOutputVisual: true,
    //                         isInputRtl: false,
    //                         isOutputRtl: false,
    //                         align: (isrtlview?"right":"left")
    //                       };


    //                     // Set some general padding to the document
    //                     const pageMargin = 45;
    //                     // Reduce width to get total table width
    //                     const reducetablewidth = (width - 90);

    //                     let pageno = 1;
    //                     let tabledrawy = pageMargin;

    //                     let lastaddedpage = null;
    //                     // let ischecklast = false;

    //                     if(this.state.isFieldWisePDFPrint){
    //                         for (let index = 0; index < printallprods.length; index++) {
    //                             let printOneField = printallprods[index];
    //                             let fieldCount = (this.props.simulateCount > 0?this.props.simulateCount:0);

    //                             for (let l = 0; l < printOneField.imagearray.length; l++) {
    //                                 const imgData = printOneField.imagearray[l];
    //                                 let fieldCountStr = "";
    //                                 if (fieldCount % 2 === 0) {
    //                                     for(let i = 1; i <= printOneField.order; i+=2){
    //                                         let firstField = i; // First field in the pair
    //                                         let secondField = i + 1; // Second field in the pair
    //                                         fieldCountStr = `${firstField} ${this.props.t('AND')} ${secondField}`;
    //                                     }
    //                                 }else{
    //                                     for(let i =1 ; i <= printOneField.order; i += 2){
    //                                         let firstField = i; // First field in the pair
    //                                         let secondField = i + 1 <= fieldCount ? i + 1 : null; // Handle the case where there is no pair
    //                                         fieldCountStr = secondField
    //                                             ? `${firstField} ${this.props.t('AND')} ${secondField}`
    //                                             : `${firstField}`;
    //                                                         }
    //                                 }
    //                                 pageno = (pageno + 1);
    //                                 pdf.setTextColor(0, 0, 0);
    //                                 //page no
    //                                 pdf.setFontSize(11);
    //                                 pdf.text((this.props.t("PAGE")+" "+pageno), (isrtlview?(width - 40):40), 30, optionsR);
    //                                 //shelf and field details
    //                                 pdf.setFontSize(12);
    //                                 pdf.text(
    //                                     (!this.state.isFieldWisePDFPrint?(printOneField.category?(printOneField.category+": "+printOneField.categoryNo):"-"):(this.props.t("Field_unit_no")+" "+fieldCountStr)),
    //                                     (isrtlview?(width - 40):40), 55, optionsR
    //                                 ); //
    //                                 pdf.text(imgData.fieldName?imgData.fieldName:"-", (isrtlview?40:(width - 40)), 55, optionsL);
    //                                 //line
    //                                 pdf.setLineHeightFactor(5);
    //                                 pdf.line(40, 60, (width - 40), 60,);
    //                                 //field border and image
    //                                 pdf.setDrawColor(0, 0, 0);
    //                                 pdf.setFillColor(255, 255, 255);
    //                                 pdf.rect(40, 70,(width - 80), (height - 110), 'FD');

    //                                 let imageviewwidth = ((imgData.width <= 100)?(convertWidthPercent(imgData.width, width, true) - (imgData.width >= 80?80:0)):(width - 80));
    //                                 pdf.addImage(imgData.imgsrc, 'PNG', 40, 70,imageviewwidth, (height - 110), ("alias"+(index+""+l)),"FAST");
    //                                 //page footer details
    //                                 let bottombranchtxt = (isrtlview?((this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?(this.props.simulateSearchObj.storeName+" <"):"")+" "+(chaindetails?chaindetails.chainName:"-"))
    //                                     :((chaindetails?chaindetails.chainName:"-")+" "+(this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?("> "+this.props.simulateSearchObj.storeName):"")));
    //                                 pdf.text(bottombranchtxt, (isrtlview?(width - 40):40), (height - 20), optionsR);

    //                                 let bottomusertxt = (isrtlview?((userdetails?(userdetails.lName+" "+userdetails.fName):"-")+" | "+generatedTime+" | "+generatedDate)
    //                                     :(generatedDate+" | "+generatedTime+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")))
    //                                 pdf.text(bottomusertxt, (isrtlview?40:(width - 40)), (height - 20), optionsL);


    //                                 if((l + 1) < printOneField.imagearray.length){
    //                                     pdf.addPage();
    //                                     pageno = (pageno + 1);
    //                                 }
    //                             }


    //                             if((index + 1) < printallprods.length){
    //                                 pdf.addPage();
    //                                 tabledrawy = pageMargin;
    //                             }
    //                         }

    //                         for(let index = 0; index < printallprodsWithoutMerge.length; index++){
    //                             let printOneField = printallprodsWithoutMerge[index];
    //                             let fieldCount = (this.props.simulateCount > 0?this.props.simulateCount:0);

    //                             //auto table
    //                             if(printOneField && printOneField.shelfprods && Object.keys(printOneField.shelfprods).length > 0){
    //                                 pdf.addPage();
    //                                 pageno = (pageno + 1);
    //                                 tabledrawy = pageMargin;

    //                                 pdf.setTextColor("#000000");
    //                                 pdf.setFontSize(14);

    //                                 pdf.text((this.props.t("Field_unit_no")+": "+(index+1)), (isrtlview?(width - pageMargin):pageMargin), tabledrawy,optionsR);
    //                                 pdf.setLineHeightFactor(5);
    //                                 pdf.line(pageMargin, (tabledrawy + 5), (width - pageMargin), (tabledrawy + 5));

    //                             tabledrawy = (tabledrawy + 30);

    //                                 // let shelfidx = 0;
    //                                 for (const shelfkey in printOneField.shelfprods) {
    //                                     const fieldshelf = printOneField.shelfprods[shelfkey];

    //                                     let prodarrobj = [];
    //                                     for (let j = 0; j < fieldshelf.length; j++) {
    //                                         const shelfsingleobj = fieldshelf[j];

    //                                         let prodsupname = (shelfsingleobj.productBrand && shelfsingleobj.productBrand.supplier?shelfsingleobj.productBrand.supplier.supplierName:"-");
    //                                         let newprodobj = [shelfsingleobj.barcode, shelfsingleobj.name, prodsupname, shelfsingleobj.qty];
    //                                         prodarrobj.push(newprodobj);
    //                                     }
    //                                     // Let's set up a standard padding that we can add to known coordinates
    //                                     const padding = 15;
    //                                     const xPositions = [];

    //                                     tabledrawy = (tabledrawy === 45 ?(tabledrawy + padding) : tabledrawy);

    //                                     let bottompagemargin = pageMargin * 2;
    //                                     if ((tabledrawy + bottompagemargin) > height) {
    //                                         pdf.addPage();
    //                                         tabledrawy = (pageMargin + padding);

    //                                         let newpageno = (pageno + 1);
    //                                         pageno = newpageno;
    //                                     }

    //                                     //headers
    //                                     pdf.setTextColor("#000000");
    //                                     pdf.setFontSize(12);

    //                                     pdf.text((this.props.t("Shelf_unit_no")+": "+shelfkey), (isrtlview?(width - pageMargin):pageMargin), tabledrawy,optionsR);
    //                                     pdf.text(((printOneField && printOneField.fieldName)?printOneField.fieldName:"-"), (isrtlview?pageMargin:(width - pageMargin)), tabledrawy, optionsL);

    //                                     //line
    //                                     pdf.setLineHeightFactor(5);
    //                                     pdf.line(pageMargin, (tabledrawy + 5), (width - pageMargin), (tabledrawy + 5));

    //                                     tabledrawy = (tabledrawy + 30);

    //                                     if (!lastaddedpage || lastaddedpage !== pageno) {
    //                                         lastaddedpage = pageno;
    //                                         // //page no
    //                                         pdf.setFontSize(11);
    //                                         pdf.text(((this.props.t("PAGE")+" "+pageno)), (isrtlview?(width - pageMargin):pageMargin), 30, optionsR);

    //                                         // //shelf and field details
    //                                         pdf.setFontSize(12);
    //                                         //page footer details
    //                                         let bottombranchtxt = (isrtlview?((this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?(this.props.simulateSearchObj.storeName+" <"):"")+" "+(chaindetails?chaindetails.chainName:"-"))
    //                                             :((chaindetails?chaindetails.chainName:"-")+" "+(this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?("> "+this.props.simulateSearchObj.storeName):"")));
    //                                         pdf.text(bottombranchtxt, (isrtlview?(width - pageMargin):pageMargin), (height - 20), optionsR);

    //                                         let bottomusertxt = (isrtlview?((userdetails?(userdetails.lName+" "+userdetails.fName):"-")+" | "+generatedTime+" | "+generatedDate)
    //                                             :(generatedDate+" | "+generatedTime+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")))
    //                                         pdf.text(bottomusertxt, (isrtlview?pageMargin:(width - pageMargin)), (height - 20), optionsL);
    //                                     }

    //                                     //table
    //                                     let headers = [
    //                                         {key: "barcode", label: this.props.t("barcode"), width: 15},
    //                                         {key: "name", label: this.props.t("PRODUCT_NAME"), width: 45},
    //                                         {key: "distributor", label: this.props.t("supname"), width: 30},
    //                                         {key: "qty", label: this.props.t("FACING"), width: 10}
    //                                     ];

    //                                     let headerxpos = (isrtlview?(reducetablewidth + pageMargin):pageMargin); //default start
    //                                     let headernewy = tabledrawy;

    //                                     headers.forEach((heading, index) => {

    //                                         pdf.setTextColor("#000000");
    //                                         pdf.setFontSize(10);
    //                                         pdf.text(heading.label, (index === 0 ?headerxpos:(isrtlview?(headerxpos - padding):(headerxpos + padding))), headernewy, optionsR);

    //                                         xPositions.push(index === 0?(isrtlview?(headerxpos - 3):(headerxpos + 3)):(isrtlview?(headerxpos - padding):(headerxpos + padding)));

    //                                         //if last one reset to 45
    //                                         const xPositionForCurrentHeader = (isrtlview?(headerxpos - ((reducetablewidth / 100) * heading.width)):(headerxpos + ((reducetablewidth / 100) * heading.width)));
    //                                         let defxpos = (isrtlview?reducetablewidth:pageMargin);
    //                                         headerxpos = ((index + 1) === headers.length?defxpos:xPositionForCurrentHeader);
    //                                     });

    //                                     tabledrawy = (tabledrawy + 20);

    //                                     // ROWS
    //                                     let tablerowheight = 20;
    //                                     let tablecellpadding = 15;

    //                                     let newheadery = tabledrawy;
    //                                     let newpageno = pageno;
    //                                     let curlastaddedpage = lastaddedpage;

    //                                     fieldshelf.forEach((row, rIndex) => {
    //                                         const rowHeights = [];
    //                                         const rowRectHeights = [];

    //                                         newheadery = (newheadery === 45 ? (newheadery + padding) : newheadery);

    //                                         // COLUMNS
    //                                         let newrowcells = [];
    //                                         headers.forEach((column, cIndex) => {
    //                                             const xPositionForCurrentHeader = (((reducetablewidth / 100) * column.width) - tablecellpadding);

    //                                             const longText = ((column.key !== "barcode" && column.key !== "qty")?pdf.splitTextToSize(String(row[column.key]), xPositionForCurrentHeader):[String(row[column.key])]);
    //                                             const rowHeight = longText.length * tablerowheight;
    //                                             rowHeights.push(rowHeight);

    //                                             const rowRectHeight = (longText.length > 1 ? (longText.length * 16) : tablerowheight);
    //                                             rowRectHeights.push(rowRectHeight);

    //                                             let cellobj = { text: longText, xpos: xPositions[cIndex], ypos: newheadery};
    //                                             newrowcells.push(cellobj);
    //                                         });

    //                                         let nextrectrowheight = (Math.max(...rowRectHeights) > tablerowheight ? Math.max(...rowRectHeights) : tablerowheight);

    //                                         pdf.setFillColor(0, 0, 0, 0.05);
    //                                         pdf.rect(pageMargin, newheadery - 11, reducetablewidth, nextrectrowheight - 3, "F");

    //                                         let nextaddy = (Math.max(...rowHeights) > tablerowheight? Math.max(...rowHeights): tablerowheight);

    //                                         newrowcells.forEach((rowcell, rIndex) => {
    //                                             pdf.setTextColor("#555555");
    //                                             pdf.setFontSize(10);

    //                                             pdf.setLineHeightFactor(1.5);
    //                                             pdf.text(rowcell.text, rowcell.xpos, rowcell.ypos, optionsR);
    //                                         });

    //                                         let newcelly = (newheadery + nextaddy);
    //                                         newheadery = newcelly;

    //                                         let bottompagemargin = pageMargin * 2;
    //                                         if ((newcelly + bottompagemargin) > height && (rIndex + 1) < fieldshelf.length) {
    //                                             pdf.addPage();

    //                                             newheadery = (pageMargin + padding);
    //                                             newpageno = (newpageno + 1);

    //                                             //if last page add headers
    //                                                 if (!curlastaddedpage || curlastaddedpage !== newpageno) {
    //                                                     curlastaddedpage = newpageno;
    //                                                     // //page no
    //                                                     pdf.setFontSize(11);
    //                                                     pdf.setTextColor("#000000");
    //                                                     pdf.text(((this.props.t("PAGE")+" "+curlastaddedpage)), (isrtlview?(width - pageMargin):pageMargin), 30, optionsR);

    //                                                     // //shelf and field details
    //                                                     pdf.setFontSize(12);
    //                                                     //page footer details
    //                                                     let bottombranchtxt = (isrtlview?((this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?(this.props.simulateSearchObj.storeName+" <"):"")+" "+(chaindetails?chaindetails.chainName:"-"))
    //                                                         :((chaindetails?chaindetails.chainName:"-")+" "+(this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?("> "+this.props.simulateSearchObj.storeName):"")));
    //                                                     pdf.text(bottombranchtxt, (isrtlview?(width - pageMargin):pageMargin), (height - 20), optionsR);

    //                                                     let bottomusertxt = (isrtlview?((userdetails?(userdetails.lName+" "+userdetails.fName):"-")+" | "+generatedTime+" | "+generatedDate)
    //                                                         :(generatedDate+" | "+generatedTime+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")))
    //                                                     pdf.text(bottomusertxt, (isrtlview?pageMargin:(width - pageMargin)), (height - 20), optionsL);
    //                                                 }
    //                                             // }
    //                                         }
    //                                     });
    //                                     lastaddedpage = curlastaddedpage;

    //                                     pageno = newpageno;
    //                                     tabledrawy = (newheadery + 20);
    //                                 }
    //                             }

    //                             // if((index + 1) < printallprods.length){
    //                             //     pdf.addPage();
    //                             //     tabledrawy = pageMargin;
    //                             // }
    //                         }

    //                     }else{
    //                         for (let index = 0; index < printallprods.length; index++) {
    //                             let printOneField = printallprods[index];

    //                             pageno = (pageno + 1);

    //                             for (let l = 0; l < printOneField.imagearray.length; l++) {
    //                                 const imgData = printOneField.imagearray[l];

    //                                 pdf.setTextColor(0, 0, 0);
    //                                 //page no
    //                                 pdf.setFontSize(11);
    //                                 pdf.text((this.props.t("PAGE")+" "+pageno), (isrtlview?(width - 40):40), 30, optionsR);
    //                                 //shelf and field details
    //                                 pdf.setFontSize(12);
    //                                 pdf.text(
    //                                     (!this.state.isFieldWisePDFPrint?(printOneField.category?(printOneField.category+": "+printOneField.categoryNo):"-"):(this.props.t("Field_unit_no")+" "+(index + 1))),
    //                                     (isrtlview?(width - 40):40), 55, optionsR
    //                                 ); //
    //                                 pdf.text(imgData.fieldName?imgData.fieldName:"-", (isrtlview?40:(width - 40)), 55, optionsL);
    //                                 //line
    //                                 pdf.setLineHeightFactor(5);
    //                                 pdf.line(40, 60, (width - 40), 60,);
    //                                 //field border and image
    //                                 pdf.setDrawColor(0, 0, 0);
    //                                 pdf.setFillColor(255, 255, 255);
    //                                 pdf.rect(40, 70,(width - 80), (height - 110), 'FD');

    //                                 let imageviewwidth = ((imgData.width <= 100)?(convertWidthPercent(imgData.width, width, true) - (imgData.width >= 80?80:0)):(width - 80));
    //                                 pdf.addImage(imgData.imgsrc, 'PNG', 40, 70,imageviewwidth, (height - 110), ("alias"+(index+""+l)),"FAST");
    //                                 //page footer details
    //                                 let bottombranchtxt = (isrtlview?((this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?(this.props.simulateSearchObj.storeName+" <"):"")+" "+(chaindetails?chaindetails.chainName:"-"))
    //                                     :((chaindetails?chaindetails.chainName:"-")+" "+(this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?("> "+this.props.simulateSearchObj.storeName):"")));
    //                                 pdf.text(bottombranchtxt, (isrtlview?(width - 40):40), (height - 20), optionsR);

    //                                 let bottomusertxt = (isrtlview?((userdetails?(userdetails.lName+" "+userdetails.fName):"-")+" | "+generatedTime+" | "+generatedDate)
    //                                     :(generatedDate+" | "+generatedTime+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")))
    //                                 pdf.text(bottomusertxt, (isrtlview?40:(width - 40)), (height - 20), optionsL);

    //                                 if((l + 1) < printOneField.imagearray.length){
    //                                     pdf.addPage();
    //                                     pageno = (pageno + 1);
    //                                 }
    //                             }

    //                             //auto table
    //                             if(printOneField && printOneField.shelfprods && Object.keys(printOneField.shelfprods).length > 0){
    //                                 pdf.addPage();
    //                                 pageno = (pageno + 1);

    //                                 // let shelfidx = 0;
    //                                 for (const shelfkey in printOneField.shelfprods) {
    //                                     const fieldshelf = printOneField.shelfprods[shelfkey];

    //                                     let prodarrobj = [];
    //                                     for (let j = 0; j < fieldshelf.length; j++) {
    //                                         const shelfsingleobj = fieldshelf[j];

    //                                         let prodsupname = (shelfsingleobj.productBrand && shelfsingleobj.productBrand.supplier?shelfsingleobj.productBrand.supplier.supplierName:"-");
    //                                         let newprodobj = [shelfsingleobj.barcode, shelfsingleobj.name, prodsupname, shelfsingleobj.qty];
    //                                         prodarrobj.push(newprodobj);
    //                                     }
    //                                     // Let's set up a standard padding that we can add to known coordinates
    //                                     const padding = 15;
    //                                     const xPositions = [];

    //                                     tabledrawy = (tabledrawy === 45 ?(tabledrawy + padding) : tabledrawy);

    //                                     let bottompagemargin = pageMargin * 2;
    //                                     if ((tabledrawy + bottompagemargin) > height) {
    //                                         pdf.addPage();
    //                                         tabledrawy = (pageMargin + padding);

    //                                         let newpageno = (pageno + 1);
    //                                         pageno = newpageno;
    //                                     }

    //                                     //headers
    //                                     pdf.setTextColor("#000000");
    //                                     pdf.setFontSize(12);

    //                                     pdf.text((this.props.t("Shelf_unit_no")+": "+shelfkey), (isrtlview?(width - pageMargin):pageMargin), tabledrawy,optionsR);
    //                                     pdf.text(((printOneField && printOneField.fieldName)?printOneField.fieldName:"-"), (isrtlview?pageMargin:(width - pageMargin)), tabledrawy, optionsL);

    //                                     //line
    //                                     pdf.setLineHeightFactor(5);
    //                                     pdf.line(pageMargin, (tabledrawy + 5), (width - pageMargin), (tabledrawy + 5));

    //                                     tabledrawy = (tabledrawy + 30);

    //                                     if (!lastaddedpage || lastaddedpage !== pageno) {
    //                                         lastaddedpage = pageno;
    //                                         // //page no
    //                                         pdf.setFontSize(11);
    //                                         pdf.text(((this.props.t("PAGE")+" "+pageno)), (isrtlview?(width - pageMargin):pageMargin), 30, optionsR);

    //                                         // //shelf and field details
    //                                         pdf.setFontSize(12);
    //                                         //page footer details
    //                                         let bottombranchtxt = (isrtlview?((this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?(this.props.simulateSearchObj.storeName+" <"):"")+" "+(chaindetails?chaindetails.chainName:"-"))
    //                                             :((chaindetails?chaindetails.chainName:"-")+" "+(this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?("> "+this.props.simulateSearchObj.storeName):"")));
    //                                         pdf.text(bottombranchtxt, (isrtlview?(width - pageMargin):pageMargin), (height - 20), optionsR);

    //                                         let bottomusertxt = (isrtlview?((userdetails?(userdetails.lName+" "+userdetails.fName):"-")+" | "+generatedTime+" | "+generatedDate)
    //                                             :(generatedDate+" | "+generatedTime+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")))
    //                                         pdf.text(bottomusertxt, (isrtlview?pageMargin:(width - pageMargin)), (height - 20), optionsL);
    //                                     }

    //                                     //table
    //                                     let headers = [
    //                                         {key: "barcode", label: this.props.t("barcode"), width: 15},
    //                                         {key: "name", label: this.props.t("PRODUCT_NAME"), width: 45},
    //                                         {key: "distributor", label: this.props.t("supname"), width: 30},
    //                                         {key: "qty", label: this.props.t("FACING"), width: 10}
    //                                     ];

    //                                     let headerxpos = (isrtlview?(reducetablewidth + pageMargin):pageMargin); //default start
    //                                     let headernewy = tabledrawy;

    //                                     headers.forEach((heading, index) => {

    //                                         pdf.setTextColor("#000000");
    //                                         pdf.setFontSize(10);
    //                                         pdf.text(heading.label, (index === 0 ?headerxpos:(isrtlview?(headerxpos - padding):(headerxpos + padding))), headernewy, optionsR);

    //                                         xPositions.push(index === 0?(isrtlview?(headerxpos - 3):(headerxpos + 3)):(isrtlview?(headerxpos - padding):(headerxpos + padding)));

    //                                         //if last one reset to 45
    //                                         const xPositionForCurrentHeader = (isrtlview?(headerxpos - ((reducetablewidth / 100) * heading.width)):(headerxpos + ((reducetablewidth / 100) * heading.width)));
    //                                         let defxpos = (isrtlview?reducetablewidth:pageMargin);
    //                                         headerxpos = ((index + 1) === headers.length?defxpos:xPositionForCurrentHeader);
    //                                     });

    //                                     tabledrawy = (tabledrawy + 20);

    //                                     // ROWS
    //                                     let tablerowheight = 20;
    //                                     let tablecellpadding = 15;

    //                                     let newheadery = tabledrawy;
    //                                     let newpageno = pageno;
    //                                     let curlastaddedpage = lastaddedpage;

    //                                     fieldshelf.forEach((row, rIndex) => {
    //                                         const rowHeights = [];
    //                                         const rowRectHeights = [];

    //                                         newheadery = (newheadery === 45 ? (newheadery + padding) : newheadery);

    //                                         // COLUMNS
    //                                         let newrowcells = [];
    //                                         headers.forEach((column, cIndex) => {
    //                                             const xPositionForCurrentHeader = (((reducetablewidth / 100) * column.width) - tablecellpadding);

    //                                             const longText = ((column.key !== "barcode" && column.key !== "qty")?pdf.splitTextToSize(String(row[column.key]), xPositionForCurrentHeader):[String(row[column.key])]);
    //                                             const rowHeight = longText.length * tablerowheight;
    //                                             rowHeights.push(rowHeight);

    //                                             const rowRectHeight = (longText.length > 1 ? (longText.length * 16) : tablerowheight);
    //                                             rowRectHeights.push(rowRectHeight);

    //                                             let cellobj = { text: longText, xpos: xPositions[cIndex], ypos: newheadery};
    //                                             newrowcells.push(cellobj);
    //                                         });

    //                                         let nextrectrowheight = (Math.max(...rowRectHeights) > tablerowheight ? Math.max(...rowRectHeights) : tablerowheight);

    //                                         pdf.setFillColor(0, 0, 0, 0.05);
    //                                         pdf.rect(pageMargin, newheadery - 11, reducetablewidth, nextrectrowheight - 3, "F");

    //                                         let nextaddy = (Math.max(...rowHeights) > tablerowheight? Math.max(...rowHeights): tablerowheight);

    //                                         newrowcells.forEach((rowcell, rIndex) => {
    //                                             pdf.setTextColor("#555555");
    //                                             pdf.setFontSize(10);

    //                                             pdf.setLineHeightFactor(1.5);
    //                                             pdf.text(rowcell.text, rowcell.xpos, rowcell.ypos, optionsR);
    //                                         });

    //                                         let newcelly = (newheadery + nextaddy);
    //                                         newheadery = newcelly;

    //                                         let bottompagemargin = pageMargin * 2;
    //                                         if ((newcelly + bottompagemargin) > height && (rIndex + 1) < fieldshelf.length) {
    //                                             pdf.addPage();

    //                                             newheadery = (pageMargin + padding);
    //                                             newpageno = (newpageno + 1);

    //                                             //if last page add headers
    //                                                 if (!curlastaddedpage || curlastaddedpage !== newpageno) {
    //                                                     curlastaddedpage = newpageno;
    //                                                     // //page no
    //                                                     pdf.setFontSize(11);
    //                                                     pdf.setTextColor("#000000");
    //                                                     pdf.text(((this.props.t("PAGE")+" "+curlastaddedpage)), (isrtlview?(width - pageMargin):pageMargin), 30, optionsR);

    //                                                     // //shelf and field details
    //                                                     pdf.setFontSize(12);
    //                                                     //page footer details
    //                                                     let bottombranchtxt = (isrtlview?((this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?(this.props.simulateSearchObj.storeName+" <"):"")+" "+(chaindetails?chaindetails.chainName:"-"))
    //                                                         :((chaindetails?chaindetails.chainName:"-")+" "+(this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?("> "+this.props.simulateSearchObj.storeName):"")));
    //                                                     pdf.text(bottombranchtxt, (isrtlview?(width - pageMargin):pageMargin), (height - 20), optionsR);

    //                                                     let bottomusertxt = (isrtlview?((userdetails?(userdetails.lName+" "+userdetails.fName):"-")+" | "+generatedTime+" | "+generatedDate)
    //                                                         :(generatedDate+" | "+generatedTime+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")))
    //                                                     pdf.text(bottomusertxt, (isrtlview?pageMargin:(width - pageMargin)), (height - 20), optionsL);
    //                                                 }
    //                                             // }
    //                                         }
    //                                     });
    //                                     lastaddedpage = curlastaddedpage;

    //                                     pageno = newpageno;
    //                                     tabledrawy = (newheadery + 20);
    //                                 }
    //                             }

    //                             if((index + 1) < printallprods.length){
    //                                 pdf.addPage();
    //                                 tabledrawy = pageMargin;
    //                             }
    //                         }
    //                     }


    //                     //file name
    //                     var catname=(this.state.selectedCatRect && this.state.selectedCatRect.selectedCat && this.state.selectedCatRect.selectedCat)?getNameorIdorColorofBox(this.state.selectedCatRect.selectedCat,"name"):"";
    //                     var depname=this.props.defSaveObj && this.props.defSaveObj.department?((this.props.simType === "AUI")?this.props.defSaveObj.department.name:this.props.defSaveObj.department.department_name):""
    //                     var userlogged = (this.props.signedobj && this.props.signedobj.signinDetails&&this.props.signedobj.signinDetails.userDto?(this.props.signedobj.signinDetails.userDto.fName+"-"+this.props.signedobj.signinDetails.userDto.lName):"");
    //                     var fieldcountz=(this.props.simulateCount > 0?this.props.simulateCount:0);
    //                     var filename=(catname+"_"+depname+"_"+userlogged+"_"+fieldcountz+"Fields")

    //                     // window.open(pdf.output('bloburl', { filename: 'new-file.pdf' }), '_blank');
    //                     pdf.save(replaceSpecialChars(String(filename)))
    //                     this.setState({loadinggif2:false,loadedprodcount:0,printloading:false},()=>{
    //                         //close fullscreen
    //                         this.setFullscreenShow(false)
    //                     })
    //                 });
    //             };
    //         })

    //       });
    // }

     groupColors(products) {
        const uniqueColors = new Map();
    
        // Loop through products and store unique colors with their first label
        Object.values(products).forEach(product => {
            const color = product?.productLabel?.color;  // Access color from productLabel
            const label = product?.productLabel?.name;   // Access name from productLabel
    
            // Ensure that the color is valid and not already in the map
            if (color && !uniqueColors.has(color)) {
                uniqueColors.set(color, label); // Store unique color with its label
            }
        });
    
        // Convert map to an array of objects
        return Array.from(uniqueColors, ([color, label]) => ({ color, label }));
    }

    // Group colors by field wise
    groupColorsByField(products) {
        const fieldLabelMap = {};
    
        products.forEach(product => {
            const productLabel = product?.productLabel?.name;
            const labelColor = product?.productLabel?.color;
            const labelText = product?.productLabel?.name;
    
            if (!labelColor || !labelText) return;
    
            product.actualFieldInfo?.forEach(({ actualFieldId }) => {
                if (!actualFieldId) return;
    
                if (!fieldLabelMap[actualFieldId]) {
                    fieldLabelMap[actualFieldId] = new Map();
                }
    
                const labelKey = `${labelColor}_${labelText}`;
                if (!fieldLabelMap[actualFieldId].has(labelKey)) {
                    fieldLabelMap[actualFieldId].set(labelKey, {
                        color: labelColor,
                        label: labelText,
                    });
                }
            });
        });

        return Object.entries(fieldLabelMap).map(([actualFieldId, labelsMap]) => ({
            actualFieldId: Number(actualFieldId),
            labelList: Array.from(labelsMap.values())
        }));
    }


    StartPrint = async () => {
         const cluster = this.props.clusterData.find(
            (item) => item.id === this.props.selectedClusterId
            );
        let chaindetails = (this.props.signedobj && this.props.signedobj.signinDetails?this.props.signedobj.signinDetails.chain:null);
        let userdetails = (this.props.signedobj && this.props.signedobj.signinDetails?this.props.signedobj.signinDetails.userDto:null);
        const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));


        const BLANK_PNG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==';

        // DOM-safe SVG → PNG capture.
        // react-svg-to-image was replaced because it:
        //   1. Writes all 300+ computed CSS properties inline onto every live DOM node (inlineStyles)
        //   2. Then calls elt.innerHTML = rememberHTML to restore — this replaces the DOM nodes
        //      React is managing, leaving React's fiber tree with references to the OLD detached
        //      nodes (each carrying 300+ style strings). Those nodes can never be GC'd.
        //      Result: ~370 MB of heap permanently retained after every export.
        // This implementation clones the SVG element and never touches the live React DOM.

        // Fetch an external URL and return a base64 data URI; returns null on failure.
        const toDataURI = async (url) => {
            try {
                const res = await fetch(url, { mode: 'cors', cache: 'force-cache' });
                if (!res.ok) return null;
                const blob = await res.blob();
                return await new Promise((res2) => {
                    const reader = new FileReader();
                    reader.onloadend = () => res2(reader.result);
                    reader.onerror  = () => res2(null);
                    reader.readAsDataURL(blob);
                });
            } catch {
                return null;
            }
        };

        // Replace all cross-origin references in a cloned SVG with inline base64
        // data URIs. If a fetch fails the element is removed entirely — leaving a
        // cross-origin URL would still taint the canvas.
        const XLINK = 'http://www.w3.org/1999/xlink';
        const getHref = (el) =>
            el.getAttribute('href') || el.getAttributeNS(XLINK, 'href') || '';
        const setHref = (el, val) => {
            el.setAttribute('href', val);
            el.setAttributeNS(XLINK, 'href', val);
        };

        const inlineSvgImages = async (clone) => {
            // <image> — product photos
            const imageEls = Array.from(clone.querySelectorAll('image'));
            // <feImage> — filter images (also taint-capable)
            const feImageEls = Array.from(clone.querySelectorAll('feImage'));

            await Promise.all([...imageEls, ...feImageEls].map(async (el) => {
                const href = getHref(el);
                if (!href || href.startsWith('data:')) return;
                const dataUri = await toDataURI(href);
                if (dataUri) {
                    setHref(el, dataUri);
                } else {
                    // CORS failed — remove the element so canvas stays clean
                    el.remove();
                }
            }));

            // <foreignObject> ALWAYS taints the canvas (browser security rule),
            // even when the HTML content is same-origin. Remove them entirely.
            Array.from(clone.querySelectorAll('foreignObject')).forEach((el) => el.remove());

            // <use> with external document reference (e.g. "external.svg#id")
            Array.from(clone.querySelectorAll('use')).forEach((el) => {
                const href = getHref(el);
                if (href && href.includes('.svg#')) el.remove();
            });

            // Strip any <style>/<defs> url() references pointing to external origins
            Array.from(clone.querySelectorAll('style')).forEach((el) => {
                el.textContent = el.textContent.replace(/url\((?!["']?data:)[^)]+\)/g, 'none');
            });
        };

        const safeToImg = (selector) => {
            return new Promise((resolve) => {
                try {
                    const el = document.querySelector(selector);
                    if (!el) {
                        console.warn('[PDF-DEBUG] safeToImg: not found:', selector);
                        return resolve(BLANK_PNG);
                    }
                    // Deep clone — never touch the live React DOM
                    const clone = el.cloneNode(true);

                    // Inline all cross-origin images to prevent canvas tainting
                    inlineSvgImages(clone).then(() => {
                    const svgData = new XMLSerializer().serializeToString(clone);
                    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
                    const blobUrl = URL.createObjectURL(svgBlob);

                    const vb = (el.getAttribute('viewBox') || '').split(' ');
                    const w = parseFloat(el.getAttribute('width'))  || parseFloat(vb[2]) || el.getBoundingClientRect().width  || 1000;
                    const h = parseFloat(el.getAttribute('height')) || parseFloat(vb[3]) || el.getBoundingClientRect().height || 800;

                    const canvas = document.createElement('canvas');
                    canvas.width  = w;
                    canvas.height = h;
                    const img = new Image();

                    img.onload = () => {
                        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
                        const dataUrl = canvas.toDataURL('image/png', 1.0);
                        // Deterministic cleanup — free Blob, decoded bitmap, and pixel buffer
                        URL.revokeObjectURL(blobUrl);
                        img.src = '';
                        canvas.width = 0; canvas.height = 0;
                        resolve(dataUrl);
                    };
                    img.onerror = () => {
                        URL.revokeObjectURL(blobUrl);
                        console.warn('[PDF-DEBUG] safeToImg img failed:', selector);
                        resolve(BLANK_PNG);
                    };
                    img.src = blobUrl;
                    }).catch((e) => {
                        console.warn('[PDF-DEBUG] safeToImg inlineSvgImages failed:', selector, e);
                        resolve(BLANK_PNG);
                    });
                } catch(e) {
                    console.warn('[PDF-DEBUG] safeToImg threw:', selector, e);
                    resolve(BLANK_PNG);
                }
            });
        };

        const svgPromises = [
            delay(1000).then(() => { console.log('[PDF-DEBUG] safeToImg .sim-catpreview-all-full start'); return safeToImg('.sim-catpreview-all-full'); }),
            delay(1000).then(() => { console.log('[PDF-DEBUG] safeToImg .wide start');       return safeToImg('.wide'); }),
            delay(1000).then(() => { console.log('[PDF-DEBUG] safeToImg .left start');       return safeToImg('.left'); }),
            delay(1000).then(() => { console.log('[PDF-DEBUG] safeToImg .rigthside start');  return safeToImg('.rigthside'); }),
        ];

        Promise.all(svgPromises)
        .then(([fileData , wide, left , right]) => {
            //do something with the data
            var calratio = CalculateRatio(this.state.fullscreenheight,this.state.printHeight)

            this.setState({
                printRatio: calratio,
                printWidth: (this.state.fullscreensvgdrawDiemention.drawWidth * calratio),
                isPdfExporting: true, // hide SVGs so Chrome can evict their GPU image textures
            },()=>{
                let isFieldWisePrint = this.state.isFieldWisePDFPrint; //is print is seperate by field

                // var imagearray = [];
                //create canvas to crop all simulation fields
                var canvas = document.getElementById("simcatfull-canvas");
                // new canvases
                var canvasWide = document.getElementById("simcatfull-canvas-wide");
                var canvasLeft = document.getElementById("simcatfull-canvas-left");
                var canvasRight = document.getElementById("simcatfull-canvas-right");
                if (!canvas || !canvasWide || !canvasLeft || !canvasRight) {
                    console.error('[PDF-DEBUG] CRASH RISK: One or more canvas elements are NULL/missing from DOM!');
                }

                var ctx = canvas.getContext("2d");
                var ctxWide = canvasWide.getContext("2d");
                var ctxLeft = canvasLeft.getContext("2d");
                var ctxRight = canvasRight.getContext("2d");

                var image = new Image();
                var imageWide = new Image();
                var imageLeft = new Image();
                var imageRight = new Image();
                //   console.log(this.state.fullscreenObj,JSON.parse(JSON.stringify(this.state.fullscreenObj)));
                let fullscreenFields = (this.state.fullscreenObj?this.state.fullscreenObj.fields:null);
                let fullscreenProds = (this.state.fullscreenObj?this.state.fullscreenObj.products:[]);

                let selectedCatRect = this.props.selectedCatRect;
                let actualFieldsCounts = this.state.actualFieldsCounts;

                let checkSaftyMargin = roundOffDecimal((this.state.isShowFullscreen?this.state.fullScreenRatio:this.state.displayRatio),2);
                let printallprods = compareAndGetFieldProds(fullscreenFields, selectedCatRect, fullscreenProds, isFieldWisePrint, actualFieldsCounts,
                    this.state.displayUOM, (this.state.isShowFullscreen?this.state.fullScreenRatio:this.state.displayRatio), checkSaftyMargin);

                let printallprodsWide = compareAndGetFieldProds(fullscreenFields, selectedCatRect, fullscreenProds, isFieldWisePrint, actualFieldsCounts,
                    this.state.displayUOM, (this.state.isShowFullscreen?this.state.fullScreenRatio:this.state.displayRatio), checkSaftyMargin);
                
                let printallprodsLeft = compareAndGetFieldProds(fullscreenFields, selectedCatRect, fullscreenProds, isFieldWisePrint, actualFieldsCounts,
                    this.state.displayUOM, (this.state.isShowFullscreen?this.state.fullScreenRatio:this.state.displayRatio), checkSaftyMargin);

                let printallprodsRight = compareAndGetFieldProds(fullscreenFields, selectedCatRect, fullscreenProds, isFieldWisePrint, actualFieldsCounts,
                    this.state.displayUOM, (this.state.isShowFullscreen?this.state.fullScreenRatio:this.state.displayRatio), checkSaftyMargin);
               
                let printallprodsWithoutMerge = compareAndGetFieldProdsWithoutMerge(fullscreenFields, selectedCatRect, this.state.mapproductList3forPdf, isFieldWisePrint, actualFieldsCounts,
                    this.state.displayUOM, (this.state.isShowFullscreen?this.state.fullScreenRatio:this.state.displayRatio), checkSaftyMargin);
                
                const nonHangingProds = this.state.mapproductList3forPdf.filter(
                        product =>  product.isHanged !== true
                );

                let printallprodsWithoutMergeNonHanging = compareAndGetFieldProdsWithoutMerge(fullscreenFields, selectedCatRect, nonHangingProds, isFieldWisePrint, actualFieldsCounts,
                    this.state.displayUOM, (this.state.isShowFullscreen?this.state.fullScreenRatio:this.state.displayRatio), checkSaftyMargin);
                
                const nonHangingProdsFieldProd = fullscreenProds.filter(
                        product =>  product.isHanged !== true
                );


                let printallprodsWithoutHanging = compareAndGetFieldProds(fullscreenFields, selectedCatRect, nonHangingProdsFieldProd, isFieldWisePrint, actualFieldsCounts,
                    this.state.displayUOM, (this.state.isShowFullscreen?this.state.fullScreenRatio:this.state.displayRatio), checkSaftyMargin);
                

                //set canvas width/height
                canvas.width=this.state.printWidth;
                canvas.height=this.state.printHeight;

                canvasWide.width=this.state.printWidth;
                canvasWide.height=this.state.printHeight;

                canvasLeft.width=this.state.printWidth;
                canvasLeft.height=this.state.printHeight;

                canvasRight.width=this.state.printWidth;
                canvasRight.height=this.state.printHeight;

                //crop image
                image.src = fileData;
                imageWide.src = wide;
                imageLeft.src = left;
                imageRight.src = right;
                // Free SVG base64 strings — they're now held by the Image elements only;
                // nulling here lets V8 GC the strings while the rest of the chain runs
                fileData = null; wide = null; left = null; right = null;

                return Promise.all([
                    new Promise((resolve, reject) => { image.onload = resolve; image.onerror = reject; }),
                    new Promise((resolve, reject) => { imageWide.onload = resolve; imageWide.onerror = reject; }),
                    new Promise((resolve, reject) => { imageLeft.onload = resolve; imageLeft.onerror = reject; }),
                    new Promise((resolve, reject) => { imageRight.onload = resolve; imageRight.onerror = reject; }),

                ]).then(()=>{
                    //after image loaded set image to canvas
                    ctx.drawImage(image, 0, 0, this.state.printWidth, this.state.printHeight);
                    ctxWide.drawImage(imageWide, 0, 0, this.state.printWidth, this.state.printHeight);
                    ctxLeft.drawImage(imageLeft, 0, 0, this.state.printWidth, this.state.printHeight);
                    ctxRight.drawImage(imageRight, 0, 0, this.state.printWidth, this.state.printHeight);

                    // Free decoded bitmap memory — browser holds the decoded pixel data until src is cleared
                    image.src = ''; imageWide.src = ''; imageLeft.src = ''; imageRight.src = '';

                    //loop available fields
                    let fieldcropx = 0; //last crop x
                    let newprintfields = []; //new fields list after image cropping

                    let fieldcropxwide = 0; //last crop x
                    let newprintfieldswide = [];

                    let fieldcropxleft = 0; //last crop x
                    let newprintfieldsleft = [];

                    let fieldcropxright = 0; //last crop x
                    let newprintfieldsright = [];

                    for (let k = 0; k < printallprods.length; k++) {
                        const printfieldobj = printallprods[k];
                        //empty image array
                        printfieldobj["imagearray"] = [];

                        let fieldtotalwidth = (printfieldobj.totalDrawWidth * calratio);
                        // let fieldendx = (fieldtotalwidth * (k > 0?(k + 1):1));
                        let fieldendx = (fieldcropx + fieldtotalwidth);

                        let printpagecount = Math.ceil(fieldtotalwidth / this.state.printonepagewidthinPX);
                        // console.log(printpagecount, this.state.printWidth, fieldtotalwidth);
                        for (let z = 0; z < printpagecount; z++) {
                            let nextFieldWidth = (printallprods[k + 1] ? printallprods[k + 1].totalDrawWidth * calratio : 0); // Field 2's width
                            let combinedFieldEndX = fieldendx + nextFieldWidth; // Combined end for two fields

                            let cropwidth = (
                                (((fieldcropx + this.state.printonepagewidthinPX) > fieldendx) || ((z + 1) === printpagecount && (fieldcropx + this.state.printonepagewidthinPX) < fieldendx))?(fieldendx - fieldcropx)
                                :this.state.printonepagewidthinPX);
                            let cropwidthper = convertWidthPercent(cropwidth, this.state.printonepagewidthinPX);

                            //check last one is less than 50% of print page size
                            let islastpageadded = false;
                            if((z + 2) === printpagecount){
                                let lastpagecropx = (fieldcropx + cropwidth);
                                let lastcropwidth = ((((lastpagecropx + this.state.printonepagewidthinPX) > fieldendx) || ((z + 1) === printpagecount && (lastpagecropx + this.state.printonepagewidthinPX) < fieldendx))?(fieldendx - lastpagecropx):this.state.printonepagewidthinPX);
                                let lastpageper = convertWidthPercent(lastcropwidth, this.state.printonepagewidthinPX);

                                if(lastpageper < 50){
                                    cropwidth = (cropwidth + lastcropwidth);
                                    islastpageadded = true;
                                }
                            }

                            if(cropwidthper > 1){
                                let outbase64 = this.createcanvasiandexportbase64(ctx, fieldcropx, cropwidth);
                                printfieldobj.imagearray.push({
                                    width: convertWidthPercent(cropwidth, this.state.printonepagewidthinPX),
                                    imgsrc: outbase64,
                                    fieldName:printfieldobj.fieldName
                                });
                            }

                            fieldcropx = (fieldcropx + cropwidth);



                            if(islastpageadded){
                                break;
                            }
                        }

                        if(printfieldobj.imagearray.length > 0){
                            newprintfields.push(printfieldobj);
                        }
                    }

                    // Wide
                    for (let k = 0; k < printallprodsWide.length; k++) {
                        const printfieldobj = printallprodsWide[k];
                        //empty image array
                        printfieldobj["imagearray"] = [];

                        let fieldtotalwidth = (printfieldobj.totalDrawWidth * calratio);
                        // let fieldendx = (fieldtotalwidth * (k > 0?(k + 1):1));
                        let fieldendx = (fieldcropxwide + fieldtotalwidth);

                        let printpagecount = Math.ceil(fieldtotalwidth / this.state.printonepagewidthinPX);
                        // console.log(printpagecount, this.state.printWidth, fieldtotalwidth);
                        for (let z = 0; z < printpagecount; z++) {
                            let nextFieldWidth = (printallprodsWide[k + 1] ? printallprodsWide[k + 1].totalDrawWidth * calratio : 0); // Field 2's width
                            let combinedFieldEndX = fieldendx + nextFieldWidth; // Combined end for two fields

                            let cropwidth = (
                                (((fieldcropxwide + this.state.printonepagewidthinPX) > fieldendx) || ((z + 1) === printpagecount && (fieldcropxwide + this.state.printonepagewidthinPX) < fieldendx))?(fieldendx - fieldcropxwide)
                                :this.state.printonepagewidthinPX);
                            let cropwidthper = convertWidthPercent(cropwidth, this.state.printonepagewidthinPX);

                            //check last one is less than 50% of print page size
                            let islastpageadded = false;
                            if((z + 2) === printpagecount){
                                let lastpagecropx = (fieldcropxwide + cropwidth);
                                let lastcropwidth = ((((lastpagecropx + this.state.printonepagewidthinPX) > fieldendx) || ((z + 1) === printpagecount && (lastpagecropx + this.state.printonepagewidthinPX) < fieldendx))?(fieldendx - lastpagecropx):this.state.printonepagewidthinPX);
                                let lastpageper = convertWidthPercent(lastcropwidth, this.state.printonepagewidthinPX);

                                if(lastpageper < 50){
                                    cropwidth = (cropwidth + lastcropwidth);
                                    islastpageadded = true;
                                }
                            }

                            if(cropwidthper > 1){
                                let outbase64 = this.createcanvasiandexportbase64(ctxWide, fieldcropxwide, cropwidth);
                                let imgAspectRatio = ctxWide.canvas.height / ctxWide.canvas.width;
                                let imgHeight = cropwidth * imgAspectRatio;
                                printfieldobj.imagearray.push({
                                    width: convertWidthPercent(cropwidth, this.state.printonepagewidthinPX),
                                    height: convertWidthPercent(imgHeight, 2480),
                                    imgsrc: outbase64,
                                    fieldName:printfieldobj.fieldName
                                });
                            }

                            fieldcropxwide = (fieldcropxwide + cropwidth);



                            if(islastpageadded){
                                break;
                            }
                        }

                        if(printfieldobj.imagearray.length > 0){
                            newprintfieldswide.push(printfieldobj);
                        }
                    }

                    // left
                    for (let k = 0; k < printallprodsLeft.length; k++) {
                        const printfieldobj = printallprodsLeft[k];
                        //empty image array
                        printfieldobj["imagearray"] = [];

                        let fieldtotalwidth = (printfieldobj.totalDrawWidth * calratio);
                        // let fieldendx = (fieldtotalwidth * (k > 0?(k + 1):1));
                        let fieldendx = (fieldcropxleft + fieldtotalwidth);

                        let printpagecount = Math.ceil(fieldtotalwidth / this.state.printonepagewidthinPX);
                        // console.log(printpagecount, this.state.printWidth, fieldtotalwidth);
                        for (let z = 0; z < printpagecount; z++) {
                            let nextFieldWidth = (printallprodsLeft[k + 1] ? printallprodsLeft[k + 1].totalDrawWidth * calratio : 0); // Field 2's width
                            let combinedFieldEndX = fieldendx + nextFieldWidth; // Combined end for two fields

                            let cropwidth = (
                                (((fieldcropxleft + this.state.printonepagewidthinPX) > fieldendx) || ((z + 1) === printpagecount && (fieldcropxleft + this.state.printonepagewidthinPX) < fieldendx))?(fieldendx - fieldcropxleft)
                                :this.state.printonepagewidthinPX);
                            let cropwidthper = convertWidthPercent(cropwidth, this.state.printonepagewidthinPX);

                            //check last one is less than 50% of print page size
                            let islastpageadded = false;
                            if((z + 2) === printpagecount){
                                let lastpagecropx = (fieldcropxleft + cropwidth);
                                let lastcropwidth = ((((lastpagecropx + this.state.printonepagewidthinPX) > fieldendx) || ((z + 1) === printpagecount && (lastpagecropx + this.state.printonepagewidthinPX) < fieldendx))?(fieldendx - lastpagecropx):this.state.printonepagewidthinPX);
                                let lastpageper = convertWidthPercent(lastcropwidth, this.state.printonepagewidthinPX);

                                if(lastpageper < 50){
                                    cropwidth = (cropwidth + lastcropwidth);
                                    islastpageadded = true;
                                }
                            }

                            if(cropwidthper > 1){
                                let outbase64 = this.createcanvasiandexportbase64(ctxLeft, fieldcropxleft, cropwidth);
                                let imgAspectRatio = ctxLeft.canvas.height / ctxLeft.canvas.width;
                                let imgHeight = cropwidth * imgAspectRatio;
                                printfieldobj.imagearray.push({
                                    width: convertWidthPercent(cropwidth, this.state.printonepagewidthinPX),
                                    height: convertWidthPercent(imgHeight, 2480),
                                    imgsrc: outbase64,
                                    fieldName:printfieldobj.fieldName
                                });
                            }

                            fieldcropxleft = (fieldcropxleft + cropwidth);



                            if(islastpageadded){
                                break;
                            }
                        }

                        if(printfieldobj.imagearray.length > 0){
                            newprintfieldsleft.push(printfieldobj);
                        }
                    }

                    // right
                    for (let k = 0; k < printallprodsRight.length; k++) {
                        const printfieldobj = printallprodsRight[k];
                        //empty image array
                        printfieldobj["imagearray"] = [];

                        let fieldtotalwidth = (printfieldobj.totalDrawWidth * calratio);
                        // let fieldendx = (fieldtotalwidth * (k > 0?(k + 1):1));
                        let fieldendx = (fieldcropxright + fieldtotalwidth);

                        let printpagecount = Math.ceil(fieldtotalwidth / this.state.printonepagewidthinPX);
                        // console.log(printpagecount, this.state.printWidth, fieldtotalwidth);
                        for (let z = 0; z < printpagecount; z++) {
                            let nextFieldWidth = (printallprodsRight[k + 1] ? printallprodsRight[k + 1].totalDrawWidth * calratio : 0); // Field 2's width
                            let combinedFieldEndX = fieldendx + nextFieldWidth; // Combined end for two fields

                            let cropwidth = (
                                (((fieldcropxright + this.state.printonepagewidthinPX) > fieldendx) || ((z + 1) === printpagecount && (fieldcropxright + this.state.printonepagewidthinPX) < fieldendx))?(fieldendx - fieldcropxright)
                                :this.state.printonepagewidthinPX);
                            let cropwidthper = convertWidthPercent(cropwidth, this.state.printonepagewidthinPX);

                            //check last one is less than 50% of print page size
                            let islastpageadded = false;
                            if((z + 2) === printpagecount){
                                let lastpagecropx = (fieldcropxright + cropwidth);
                                let lastcropwidth = ((((lastpagecropx + this.state.printonepagewidthinPX) > fieldendx) || ((z + 1) === printpagecount && (lastpagecropx + this.state.printonepagewidthinPX) < fieldendx))?(fieldendx - lastpagecropx):this.state.printonepagewidthinPX);
                                let lastpageper = convertWidthPercent(lastcropwidth, this.state.printonepagewidthinPX);

                                if(lastpageper < 50){
                                    cropwidth = (cropwidth + lastcropwidth);
                                    islastpageadded = true;
                                }
                            }

                            if(cropwidthper > 1){
                                let outbase64 = this.createcanvasiandexportbase64(ctxRight, fieldcropxright, cropwidth);
                                let imgAspectRatio = ctxRight.canvas.height / ctxRight.canvas.width;
                                let imgHeight = cropwidth * imgAspectRatio;
                                printfieldobj.imagearray.push({
                                    width: convertWidthPercent(cropwidth, this.state.printonepagewidthinPX),
                                    height: convertWidthPercent(imgHeight, 2480),
                                    imgsrc: outbase64,
                                    fieldName:printfieldobj.fieldName
                                });
                            }

                            fieldcropxright = (fieldcropxright + cropwidth);



                            if(islastpageadded){
                                break;
                            }
                        }

                        if(printfieldobj.imagearray.length > 0){
                            newprintfieldsright.push(printfieldobj);
                        }
                    }


                    printallprods = newprintfields;
                    printallprodsWide = newprintfieldswide;
                    printallprodsLeft = newprintfieldsleft;
                    printallprodsRight = newprintfieldsright;

                    // Free canvas pixel buffers — all crops are done, 4 × ~34 MB released
                    canvas.width = 0; canvas.height = 0;
                    canvasWide.width = 0; canvasWide.height = 0;
                    canvasLeft.width = 0; canvasLeft.height = 0;
                    canvasRight.width = 0; canvasRight.height = 0;

                    // console.log(printallprods);

                    let generatedDate = moment().format("MMMM DD YYYY");
                    let generatedTime = moment().format("hh:mm:ss");

                    const pdf = new jsPDF({
                        orientation: "landscape",
                        unit: "px",
                        format:'a4',
                        // compress: true
                    });

                    // Register font directly on this instance — jsPDF.API.events.push() accumulates
                    // on every export (never cleaned up) and is not needed for single-instance use
                    pdf.addFileToVFS('Assistant-Medium-normal.ttf', assistant_medium);
                    pdf.addFont('Assistant-Medium-normal.ttf', 'Assistant-Medium', 'normal');

                    let width = pdf.internal.pageSize.getWidth();
                    let height = pdf.internal.pageSize.getHeight();

                    let isrtlview = (this.props.isRTL === "rtl");

                    pdf.setFont("Assistant-Medium", "normal");
                    const _simcatwrapper = document.getElementById("simcatprint-wrapper");
                    
                    if (!_simcatwrapper) {
                        console.error('[PDF-DEBUG] CRASH RISK: simcatprint-wrapper element NOT found in DOM!');
                    }
                    _simcatwrapper.style.display = "block";
                   
                    return htmlToImage.toPng(_simcatwrapper, {
                        width: 1191,
                        height: 842,
                        quality: 1,
                        cacheBust: true,
                    })
                    .then((coverimage) => {
                        if(document.getElementById("simcatprint-wrapper")){
                            document.getElementById("simcatprint-wrapper").style.display = "none";
                        }

                        pdf.addImage(coverimage, 'PNG', 0, 0,width, height, "alias1", "FAST");
                        coverimage = null; // free cover page base64 after PDF has consumed it

                        // if(this.state.getWideViewSettings?.isVisible){
                        //     pdf.addPage();
                        // }
                        pdf.addPage();

                        //if rtl then set rtl
                        const optionsL = {
                            isInputVisual: false,
                            isOutputVisual: true,
                            isInputRtl: false,
                            isOutputRtl: false,
                            align: (isrtlview?"left":"right")
                          };
                          const optionsR = {
                            isInputVisual: false,
                            isOutputVisual: true,
                            isInputRtl: false,
                            isOutputRtl: false,
                            align: (isrtlview?"right":"left")
                          };

                          const optionsC = {
                            isInputVisual: false,
                            isOutputVisual: true,
                            isInputRtl: false,
                            isOutputRtl: false,
                            align: (isrtlview?"center":"center")
                          };


                        // Set some general padding to the document
                        const pageMargin = 45;
                        // Reduce width to get total table width
                        const reducetablewidth = (width - 90);

                        let pageno = this.state.getWideViewSettings?.isVisible?1:0;
                        let tabledrawy = pageMargin;

                        let lastaddedpage = null;
                        // let ischecklast = false;

                        if(this.state.isFieldWisePDFPrint){
                            let margin = 45;  // Hardcoded margin 
                            let pageWidth = pdf.internal.pageSize.getWidth(); 
                            let pageHeight = pdf.internal.pageSize.getHeight(); 
                            let contentWidth = pageWidth - 2 * margin; // Adjusted for margins 
                            let contentHeight = pageHeight - 2 * margin; // Adjusted for margins 

                            let sideWidth = (contentWidth / 2) - 10; // Half width minus gap between views
                            // const fieldCount =
                            //     cluster?.clusterFieldArrays?.length > 0
                            //         ? cluster.clusterFieldArrays[0]?.fieldArray?.fieldsArrayHasFields?.length || 0
                            //         : 0;

                            let fieldCount = this.props.simulationObj?.fieldList?.length
                            
                            let fieldsPerRow = Math.floor(contentWidth / 100); 
                            let fieldWidth = contentWidth / fieldsPerRow; 
                            let fieldHeight = contentHeight;
                            const svgPadding = 5 

                            let currentX = margin+svgPadding; // Start at margin 
                            let currentY = margin; // Start at margin 
                            let fieldCount1 = 0; 

                            // Define heights for top and bottom sections
                            let topHeight = 30;  // Height for the top text fields
                            let bottomHeight = 30;  // Height for the bottom fields

                            const currentDate = new Date();
                            const formattedDate = `${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`;
                            let hours = currentDate.getHours();
                            const minutes = String(currentDate.getMinutes()).padStart(2, '0');
                            const ampm = hours >= 12 ? 'PM' : 'AM';

                            hours = hours % 12 || 12; // Convert 24-hour format to 12-hour format, ensuring 12 instead of 0

                            const formattedTime = `${String(hours).padStart(2, '0')}.${minutes} ${ampm}`;
                            var depname=cluster?.department?.importName ? cluster?.department?.importName : cluster?.department?.name;

                            if(this.state.getWideViewSettings?.isVisible){
                                // Draw main border 
                                pdf.setDrawColor(0); // Black color 
                                pdf.setLineWidth(0.5); // Border thickness 
                                pdf.rect(margin, margin, contentWidth, contentHeight); // Draw the border 

                                // Draw internal lines for top section
                                pdf.line(margin, margin + topHeight, margin + contentWidth, margin + topHeight);
                                pdf.line(margin + (contentWidth/2), margin, margin + (contentWidth/2), margin + topHeight);

                                // Draw internal lines for bottom section
                                pdf.line(margin, margin + contentHeight - bottomHeight, margin + contentWidth, margin + contentHeight - bottomHeight);
                                pdf.line(margin + (contentWidth/2), margin + contentHeight - bottomHeight, margin + (contentWidth/2), margin + contentHeight);

                                // Add text labels
                                pdf.setFontSize(12);
                                const projectNameLine = isrtlview ? `${depname} : ${this.props.t("departmentname")}` : `${this.props.t("departmentname")} : ${depname}`;
                                const planogramNameLine = isrtlview ? `${this.props.t("FIELD_PLANPGRAM")}-${fieldCount}  : ${this.props.t("PLANOGRAM_NAME")}` : `${this.props.t("PLANOGRAM_NAME")} : ${fieldCount}-${this.props.t("FIELD_PLANPGRAM")}`;
                                const pageLine = isrtlview ? `${pageno} : ${this.props.t("PAGE")}` : `${this.props.t("PAGE")}: ${pageno}`

                                pdf.text(projectNameLine, margin + (contentWidth/4), margin + 15, optionsC);
                                pdf.text(planogramNameLine, margin + (contentWidth * 3/4), margin + 15, optionsC);
                                pdf.text(`${formattedDate}`, margin + (contentWidth/4), margin + contentHeight - 15, optionsC);
                                pdf.text(pageLine, margin + (contentWidth * 3/4), margin + contentHeight - 15, optionsC);
                            }

                            

                            const generateRange = (start, end) => {
                                return Array.from({ length: end - start + 1 }, (_, i) => start + i);
                            };
                            
                            const specificNumbers = generateRange(10, 100)
                            if(printallprods.length > 8){
                                pageno = (pageno + 1);
                            }
                            if (specificNumbers.includes(printallprods.length)) {
                                pageno = (pageno - 1);
                            }
                            
                            let currentXTemp = margin+svgPadding;

                            if(this.state.getWideViewSettings?.isVisible){
                                let isWidthOverlfow = false
                                for (let index = 0; index < printallprodsWide.length; index++) {
                                    let printOneField = printallprodsWide[index];
                                    let fieldCount = (this.props.simulateCount > 0?this.props.simulateCount:0);
                                    
                                    let imgWidth
                                    let imgHeight
                                    
                                    
                                    for (let l = 0; l < printOneField.imagearray.length; l++) {
                                        const imgData = printOneField.imagearray[l];
                                        const imgProps = pdf.getImageProperties(imgData.imgsrc);
                                       
                                        imgHeight = (fieldHeight - topHeight - bottomHeight)-svgPadding; // Height for the image
                                        imgWidth = ((imgProps.width * imgHeight) / imgProps.height)- svgPadding;

                                        //check current x overflow page content width
                                        if(currentXTemp + imgWidth > margin + contentWidth) {
                                            isWidthOverlfow = true
                                            break
                                        }
                                    }
    
                                    // Move to the next column 
                                    currentXTemp += imgWidth 

                                }
                                for (let index = 0; index < printallprodsWide.length; index++) {
                                    let printOneField = printallprodsWide[index];
                                    let fieldCount = (this.props.simulateCount > 0?this.props.simulateCount:0);
    
                                    if (fieldCount1 > 0 && fieldCount1 % fieldsPerRow === 0) { 
                                    
                                        pdf.setDrawColor(0); 
                                        pdf.setLineWidth(0.5); 
                                        pdf.rect(margin, margin, contentWidth, contentHeight); 
        
                                        // Redraw internal lines and text for new page
                                        pdf.line(margin, margin + topHeight, margin + contentWidth, margin + topHeight);
                                        pdf.line(margin + (contentWidth/2), margin, margin + (contentWidth/2), margin + topHeight);
                                        pdf.line(margin, margin + contentHeight - bottomHeight, margin + contentWidth, margin + contentHeight - bottomHeight);
                                        pdf.line(margin + (contentWidth/2), margin + contentHeight - bottomHeight, margin + (contentWidth/2), margin + contentHeight);
        
                                        // Add text labels on new page
                                        pdf.setFontSize(12);
                                        //pdf.text(`${this.props.t("departmentname")}: ${depname}`, margin + (contentWidth/4), margin + 15, { align: "center" });
                                        //pdf.text(`${this.props.t("PLANOGRAM_NAME")}: ${fieldCount}-${this.props.t("FIELD_PLANPGRAM")}`, margin + (contentWidth * 3/4), margin + 15, { align: "center" });
                                        //pdf.text(`${formattedDate}`, margin + (contentWidth/4), margin + contentHeight - 15, { align: "center" });
                                        // pdf.text(`page: ${pageno}`, margin + (contentWidth * 3/4), margin + contentHeight - 15, { align: "center" });
        
                                        currentX = margin + svgPadding; // Reset X position for new page
                                        currentY = margin + topHeight; // Start below top section
                                        // pageno = (pageno + 1); 
                                    }
                                    
                                    let imgWidth
                                    let imgHeight
                                    
                                        for (let l = 0; l < printOneField.imagearray.length; l++) {
                                            const imgData = printOneField.imagearray[l];
                                            const imgProps = pdf.getImageProperties(imgData.imgsrc);

                                            if(isWidthOverlfow){
                                                imgWidth = fieldWidth - svgPadding;
                                                imgHeight = ((imgProps.height * imgWidth) / imgProps.width)-svgPadding;
                                            }else{
                                                imgHeight = (fieldHeight - topHeight - bottomHeight)-svgPadding; // Height for the image
                                                imgWidth = ((imgProps.width * imgHeight) / imgProps.height)- svgPadding;
                                            }
                                            
                                            
                                            let imageY = margin + topHeight + (fieldHeight - topHeight - bottomHeight - imgHeight)
                                            pdf.addImage(imgData.imgsrc, 'PNG', currentX, imageY, imgWidth, imgHeight, "img" + index + "-" + l, "FAST");
                                            imgData.imgsrc = null; // free base64 after PDF has consumed it
                                        }



                                    // Move to the next column
                                    currentX += imgWidth 
                                    fieldCount1++; 
    
                                    
    
                                    // Ensure last field doesn't print incorrectly on the first page 
                                    if (fieldCount1 % fieldsPerRow === 0 && index < printallprods.length - 1) { 
                                        pageno = (pageno + 1); 
                                        pdf.addPage(); 
                                        pdf.setDrawColor(0); 
                                        pdf.setLineWidth(0.5); 
                                        pdf.rect(margin, margin, contentWidth, contentHeight); 
    
                                        // Redraw internal lines and text for new page
                                        pdf.line(margin, margin + topHeight, margin + contentWidth, margin + topHeight);
                                        pdf.line(margin + (contentWidth/2), margin, margin + (contentWidth/2), margin + topHeight);
                                        pdf.line(margin, margin + contentHeight - bottomHeight, margin + contentWidth, margin + contentHeight - bottomHeight);
                                        pdf.line(margin + (contentWidth/2), margin + contentHeight - bottomHeight, margin + (contentWidth/2), margin + contentHeight);
    
                                        // Add text labels on new page
                                        pdf.setFontSize(12);
                                        const projectNameLine = isrtlview ? `${depname} : ${this.props.t("departmentname")}` : `${this.props.t("departmentname")} : ${depname}`;
                                        const planogramNameLine = isrtlview ? `${this.props.t("FIELD_PLANPGRAM")}-${fieldCount}  : ${this.props.t("PLANOGRAM_NAME")}` : `${this.props.t("PLANOGRAM_NAME")} : ${fieldCount}-${this.props.t("FIELD_PLANPGRAM")}`;
                                        const pageLine = isrtlview ? `${pageno} : ${this.props.t("PAGE")}` : `${this.props.t("PAGE")}: ${pageno}`

                                        pdf.text(projectNameLine, margin + (contentWidth/4), margin + 15, optionsC);
                                        pdf.text(planogramNameLine, margin + (contentWidth * 3/4), margin + 15, optionsC);
                                        pdf.text(`${formattedDate}`, margin + (contentWidth/4), margin + contentHeight - 15, optionsC);
                                        pdf.text(pageLine, margin + (contentWidth * 3/4), margin + contentHeight - 15, optionsC);
    
                                        currentX = margin + svgPadding; // Reset X position for new page
                                        currentY = margin + topHeight; 
                                        // pageno = (pageno + 1); 
                                    } 
                                }
                            }
                            
                            if(this.state.getModuleViewSettings?.isVisible){
                                pdf.addPage("a4", "portrait");
                                let margin2 = 25;  // Hardcoded margin 
                                let pageWidth2 = pdf.internal.pageSize.getWidth(); 
                                let pageHeight2 = pdf.internal.pageSize.getHeight(); 
                                let contentWidth2 = pageWidth2 - 2 * margin2; // Adjusted for margins 
                                let contentHeight2 = pageHeight2 - 2 * margin2; 

                                for (let index = 0; index < printallprodsLeft.length; index++) {
                                    let printOneField = printallprodsLeft[index];
                                    let printOneFieldRight = printallprodsRight[index];
                                    pageno = (pageno + 1); 
        
                                    for (let l = 0; l < printOneField.imagearray.length; l++) {
                                        const imgData = printOneField.imagearray[l];
                                        const imgDataRight = printOneFieldRight.imagearray[l];
                                        let fieldWidth = (contentWidth2 - 20) / 2;
                                        let fieldHeight = contentHeight2 - 100;// Added extra space between images
        
                                        let spaceBetween = 20;
                                        let leftX = margin2 + svgPadding 
                                        let rightX = margin2 + fieldWidth + spaceBetween
        
                                        pdf.setDrawColor(0); 
                                        pdf.setLineWidth(0.5); 
                                        pdf.rect(margin2, margin2, contentWidth2, contentHeight2); 
                                        // Draw top and bottom horizontal lines
                                        pdf.line(margin2, margin2 + topHeight, margin2 + contentWidth2, margin2 + topHeight); 
                                        pdf.line(margin2, margin2 + contentHeight2 - bottomHeight, margin2 + contentWidth2, margin2 + contentHeight2 - bottomHeight);
        
                                        // Draw vertical lines for four boxes
                                        
                                        pdf.line(margin2 + (contentWidth2 / 4), margin2 + contentHeight2 - bottomHeight, margin2 + (contentWidth2 / 4), margin2 + contentHeight2);
                                        pdf.line(margin2 + (contentWidth2 / 2), margin2 + contentHeight2 - bottomHeight, margin2 + (contentWidth2 / 2), margin2 + contentHeight2);
                                        pdf.line(margin2 + (3 * contentWidth2 / 4), margin2 + contentHeight2 - bottomHeight, margin2 + (3 * contentWidth2 / 4), margin2 + contentHeight2);
        
                                        // 🟡 **Draw the additional horizontal line on top of the footer**
                                        pdf.line(margin2, margin2 + contentHeight2 - bottomHeight - 40, margin2 + contentWidth2, margin2 + contentHeight2 - bottomHeight-40); 
        
                                        let rectSize = 6; // Size of small rectangles
                                        let startXLeft = margin2 + 10; // Starting X position for left section
                                        let startXRight = margin2 + (contentWidth2 / 2) + 10; // Start X for right section
                                        let startY = margin2 + contentHeight2 - bottomHeight - 25; // Start position above the new line
                                        let gapX = 50; // Horizontal spacing between rectangles
                                        let gapY = 15; // Vertical spacing between rectangles
                                        let maxHeight = margin2 + contentHeight2 - bottomHeight - 10; // Bottom boundary for placement

                                        let leftSectionFull = false; // Flag to switch to the right section
                                        let rowIndexLeft = 0, rowIndexRight = 0; // Track row indices separately for each section
                                        
                                    // Get unique colors and labels
                                    // const uniqueColorsWithLabels = this.groupColors(this.state.fullscreenobjs.products);
                                    const uniqueColorsWithLabelsFildWise = this.groupColorsByField(this.state.mapproductList);
                                    // get labelList by field id uniqueColorsWithLabelsFildWise
                                    const uniqueColorsWithLabels = uniqueColorsWithLabelsFildWise.find(d => d.actualFieldId === index+1)?.labelList || [];
                                    // Dynamically create labels array from grouped colors
                                    let labels = uniqueColorsWithLabels.map(({ color,label }) => [color, label]);
                
        
                                    labels.forEach((row, index) => {
                                        let isLeftSection = !leftSectionFull;
                                        let rowNum = isLeftSection ? Math.floor(rowIndexLeft / 3) : Math.floor(rowIndexRight / 3);
                                        let col = index % 3; // 3 columns per section
                                    
                                        let x = isLeftSection ? startXLeft + (col * gapX) : startXRight + (col * gapX);
                                        let y = startY + (rowNum * gapY);
                                    
                                        // Switch to right section if left side is full
                                        if (isLeftSection && y > maxHeight) {
                                            leftSectionFull = true;
                                            rowNum = Math.floor(rowIndexRight / 3);
                                            col = rowIndexRight % 3;
                                            x = startXRight + (col * gapX);
                                            y = startY + (rowNum * gapY);
                                        }
                                    
                                        // Update row index counters
                                        if (isLeftSection) {
                                            rowIndexLeft++;
                                        } else {
                                            rowIndexRight++;
                                        }
                                    
                                        function hexToRgb(hex) {
                                            let r = parseInt(hex.slice(1, 3), 16);
                                            let g = parseInt(hex.slice(3, 5), 16);
                                            let b = parseInt(hex.slice(5, 7), 16);
                                            return { r, g, b };
                                        }
                                    
                                        let { r, g, b } = hexToRgb(row[0]);
                                        // Only draw rectangles and labels if fieldLeftByLabel is true
                                        if (this.state.getModuleViewSettings.fieldLeftByLabel) {
                                        // 🟥 Draw Rectangle
                                        pdf.setFillColor(r, g, b);
                                        pdf.rect(x, y - 5, rectSize, rectSize, "F");
                                    
                                        // 📝 Add Text next to the rectangle
                                            pdf.setFontSize(8);

                                            const isHebrew = /[\u0590-\u05FF]/.test(row[1]);

                                            if (isHebrew) {
                                                const rtlText = row[1].substring(0, 13).split('').reverse().join(''); 
                                                pdf.text(rtlText, x + rectSize + 5, (y - 3) + rectSize / 2, { maxWidth: 36 });
                                            } else {
                                                // pdf.text(row[1]?.substring(0, 13), x + rectSize + 5, (y - 3) + rectSize / 2);
                                                const text = row[1]?.substring(0, 13); 
                                                pdf.text(text, x + rectSize + 5, (y - 3) + rectSize / 2, { maxWidth: 36 }); 
                                            }
                                        }
                                    });

                                        // Set text inside right two boxes
                                        pdf.setFontSize(12);
                                        const segmentLine = isrtlview ? `${this.props.t("FIELD")}: ${index+1} ${this.props.t("OF")} ${printallprodsLeft.length}` : `${this.props.t("FIELD")}: ${index+1} ${this.props.t("OF")} ${printallprodsLeft.length}`;
                                        const pageLine = isrtlview ? `${pageno} : ${this.props.t("PAGE")}` : `${this.props.t("PAGE")}: ${pageno}`

                                        pdf.text(segmentLine, margin2 + (5 * contentWidth2 / 8), margin2 + contentHeight2 - 15, optionsC);
                                        pdf.text(pageLine, margin2 + (7 * contentWidth2 / 8), margin2 + contentHeight2 - 15, optionsC);
                                        pdf.text(`${formattedDate}`, margin2 + (contentWidth2 / 8), margin2 + contentHeight2 - (bottomHeight / 2), optionsC);
                                        pdf.text(`${formattedTime}`, margin2 + (contentWidth2 / 4) + (contentWidth2 / 8), margin2 + contentHeight2 - (bottomHeight / 2), optionsC);
                                        
                                        
                                        // Title
                                        pdf.setFontSize(30);
                                        pdf.text(`${this.props.t("FRONT_VIEW")}`, margin2 + (contentWidth2 / 2), margin2 + 20, optionsC);

                                        // Draw middle vertical line
                                        pdf.setDrawColor(0); // Black color
                                        pdf.setLineWidth(0.5); // Set line width
                                        let middleX = margin2 + (contentWidth2 / 2);
                                        pdf.line(middleX, margin2 + topHeight, middleX, margin2 + contentHeight2 - bottomHeight);
        
        
                                        pdf.setDrawColor(0, 0, 0);
                                        pdf.setFillColor(255, 255, 255); 

                                        // Calculate aspect ratio
                                        let aspectRatio = imgData.width / imgData.height;

                                        // Calculate width based on aspect ratio
                                        let imageviewwidth = fieldHeight * aspectRatio;
                                        let imageviewheight = imageviewwidth / aspectRatio;

                                        // Correct imageviewwidth if only 1 image
                                        if (printOneField.imagearray.length <= 1) {
                                            imageviewwidth = fieldWidth;  // Force full width
                                        } else {
                                            // Normal case - Ensure width does not exceed fieldWidth
                                            if (imageviewwidth > fieldWidth) {
                                                imageviewwidth = fieldWidth;
                                            }
                                        }
                                        
                                        const imgProps = pdf.getImageProperties(imgData.imgsrc);
                                       
                                        let imgHeight = fieldHeight - svgPadding
                                        let imgWidth = ((imgProps.width * imgHeight) / imgProps.height)- svgPadding;
                                        
                                        if( imgWidth > fieldWidth) {
                                            imgWidth = fieldWidth - svgPadding;
                                            imgHeight = ((imgProps.height * imgWidth) / imgProps.width)- svgPadding;
                                        }
                                        // if (imgAspectRatio > fieldAspectRatio) {
                                        //     // Image is wider than container, fit by width
                                        //     imgWidth = fieldWidth;
                                        //     imgHeight = fieldWidth / imgAspectRatio;
                                        // } else {
                                        //     // Image is taller than container, fit by height
                                        //     imgHeight = fieldHeight;
                                        //     imgWidth = fieldHeight * imgAspectRatio;
                                        // }


                                        let imageY = margin2 + topHeight + (fieldHeight - imgHeight);

                                        // Step 4: Draw gray line left of the image
                                        pdf.setDrawColor(157, 160, 157); // Set color to #9da09d
                                        pdf.setLineWidth(0.5); // optional: set line thickness
                                        // centered iamge 
                                        const imgLeftx = (leftX + (fieldWidth - imgWidth) / 2);
                                        pdf.line(imgLeftx + imgWidth, imageY, imgLeftx + imgWidth, imageY + imgHeight);
                                        
                                        pdf.addImage(imgData.imgsrc, 'PNG', imgLeftx,  imageY , imgWidth, imgHeight, "alias" + (index + "_left" + l), "FAST");
                                        imgData.imgsrc = null; // free base64 after PDF has consumed it

                                        pdf.setDrawColor(0, 0, 0);
                                        pdf.setFillColor(255, 255, 255);
                                        // centered iamge
                                        const imgRightx = (rightX + (fieldWidth - imgWidth) / 2);
                                        pdf.addImage(imgDataRight.imgsrc, 'PNG', imgRightx, imageY, imgWidth, imgHeight, "alias" + (index + "_right" + l), "FAST");
                                        imgDataRight.imgsrc = null; // free base64 after PDF has consumed it
                                        pdf.setDrawColor(157, 160, 157); // Set color to #9da09d
                                        pdf.setLineWidth(0.5); // optional: set line thickness
                                        //draw line left using imgHeight
                                        pdf.line(imgRightx + imgWidth , imageY, imgRightx+ imgWidth, imageY + imgHeight);

                                        // footer
        
                                        if ((l + 1) < printOneField.imagearray.length) {
                                            pdf.addPage();
                                            pageno = (pageno + 1);
                                        }
                                    }
                                    
                                    if((index + 1) < printallprodsLeft.length){
                                        pdf.addPage();
                                        tabledrawy = pageMargin;
                                    }
                                }
                            }
                            
                            

                            for (let index = 0; index < printallprodsWithoutMergeNonHanging.length; index++) {
                                if (index === 0 ) {
                                    
                                    pdf.addPage("a4", "portrait");
                                    pageno = pageno + 1;
                                   
                                }
                                 
                                let printOneField = printallprodsWithoutMergeNonHanging[index];
                                let fieldCount = (this.props.simulateCount > 0 ? this.props.simulateCount : 0);
                                let pageMarginNew = 25;
                            
                                // Auto table
                                if (printOneField && printOneField.shelfprods && Object.keys(printOneField.shelfprods).length > 0) {
                                    let tableWidth = pdf.internal.pageSize.getWidth();
                                    let tableHeight = pdf.internal.pageSize.getHeight();
                            
                                    // Define padding, RTL text offsets, and other constants
                                    const padding = 15;
                                    const rtlTextOffset = -5;
                                    const rtlFirstColumnOffset = 0;
                                    const xPositions = [];
                                    const boundaryThreshold = 10;
                                    const fieldUnitRowHeight = 10;
                                    const shelfUnitRowHeight = 10;
                                    let headerHeight = 10; // Will adjust dynamically based on wrapped text
                                    const tablerowheight = 10;
                                    const tablecellpadding = 15;
                                    const footerHeight = 5;
                                    const bottompagemargin = pageMarginNew * 2 + footerHeight;
                                    const minimalGap = 0; // Keep as 0 to maintain connected appearance
                                    const dataTextOffset = 2;
                                    const bottomPadding = 2;
                            
                                    // Calculate the minimum height required for "Field Unit No", headers, and at least one Shelf Unit
                                    let firstShelfKey = Object.keys(printOneField.shelfprods)[0];
                                    let firstShelf = printOneField.shelfprods[firstShelfKey] || [];
                                    let minRows = firstShelf.length > 0 ? 1 : 0; // At least one row, if available
                                    let minShelfHeight = shelfUnitRowHeight + (minRows * (tablerowheight + bottomPadding));
                                    let maxHeaderLines = 1;
                                    const fieldMapping = {
                                        barcode: "barcode",
                                        productName: "name",
                                        supplierName: "distributor",
                                        face: "qty",
                                        layers: "stackCount",
                                        barcodeTwo: "barcodeTwo",
                                        locationId: "groupId",
                                        width: "width",
                                        sale: "totalSale",
                                        label: "productLabel",
                                        brand: 'brand'
                                    };
                                    let headers = this?.state?.moduleDetailedData
                                        ?.filter((item) => item.status === "online")
                                        .map((item) => ({
                                            key: fieldMapping[item.fieldsList] || item.fieldsList,
                                            label: item.label,
                                            width: parseInt(item.width, 10),
                                        }));
                                    const newReducableWidth = tableWidth - 60;
                                    headers.forEach((heading) => {
                                        let availableWidth = (newReducableWidth / 100) * heading.width - 5;
                                        let splitHeader = pdf.splitTextToSize(heading.label, availableWidth);
                                        maxHeaderLines = Math.max(maxHeaderLines, splitHeader.length);
                                    });
                                    headerHeight = 9 + (maxHeaderLines - 1) * 6;
                                    let minRequiredHeight = fieldUnitRowHeight + headerHeight + minShelfHeight;
                            
                                    if (tabledrawy + minRequiredHeight + bottompagemargin > tableHeight) {
                                        pdf.addPage("a4", "portrait");
                                        pageno = pageno + 1;
                                        tabledrawy = pageMarginNew;
                                    } else {
                                        tabledrawy += minimalGap; // minimalGap is 0, so Field Units remain connected
                                    }
                            
                                    if (!lastaddedpage || lastaddedpage !== pageno) {
                                        lastaddedpage = pageno;
                                        pdf.setFontSize(10);
                                        pdf.text(
                                            this.props.t("PAGE") + " " + pageno,
                                            isrtlview ? tableWidth - pageMarginNew : pageMarginNew,
                                            10,
                                            optionsR
                                        );
                            
                                        let bottombranchtxt = isrtlview
                                            ? (this.props.simulateSearchObj && this.props.simulateSearchObj.storeName
                                                ? this.props.simulateSearchObj.storeName + " <"
                                                : "") +
                                            " " +
                                            (chaindetails ? chaindetails.chainName : "-")
                                            : (chaindetails ? chaindetails.chainName : "-") +
                                            " " +
                                            (this.props.simulateSearchObj && this.props.simulateSearchObj.storeName
                                                ? "> " + this.props.simulateSearchObj.storeName
                                                : "");
                                        pdf.text(
                                            bottombranchtxt,
                                            isrtlview ? tableWidth - pageMarginNew : pageMarginNew,
                                            tableHeight - 20,
                                            optionsR
                                        );
                            
                                        let bottomusertxt = isrtlview
                                            ? (userdetails ? userdetails.fName + " " + userdetails.lName : "-") +
                                            " | " +
                                            generatedTime +
                                            " | " +
                                            generatedDate
                                            : generatedDate +
                                            " | " +
                                            generatedTime +
                                            " | " +
                                            (userdetails ? userdetails.fName + " " + userdetails.lName : "-");
                                        pdf.text(
                                            bottomusertxt,
                                            isrtlview ? pageMarginNew : tableWidth - pageMarginNew,
                                            tableHeight - 20,
                                            optionsL
                                        );
                                    }
                            
                                    let headerxpos = isrtlview ? tableWidth - pageMarginNew : pageMarginNew;
                                    let fieldHeaderY = tabledrawy - 5;
                                    let headerStartY;
                            
                                    // Draw "Field Unit No" as the first row
                                    const textOffset = 2;
                            
                                    pdf.setFillColor(141, 162, 216);
                                    pdf.rect(pageMarginNew - 3, tabledrawy - 5, tableWidth - pageMarginNew + 3 - (pageMarginNew - 3), fieldUnitRowHeight, "F");
                            
                                    pdf.setDrawColor(0);
                                    pdf.setLineWidth(0.5);
                                    pdf.line(pageMarginNew - 3, tabledrawy - 5, tableWidth - pageMarginNew + 3, tabledrawy - 5);
                            
                                    pdf.setTextColor("#000000");
                                    pdf.setFontSize(9);
                                    pdf.text(
                                        this.props.t("Field_unit_no") + ": " + (index + 1),
                                        isrtlview ? tableWidth - pageMarginNew : pageMarginNew + 3,
                                        tabledrawy + textOffset,
                                        optionsR
                                    );
                            
                                    pdf.setDrawColor(0);
                                    pdf.setLineWidth(0.5);
                                    pdf.line(pageMarginNew - 3, tabledrawy - 5 + fieldUnitRowHeight, tableWidth - pageMarginNew + 3, tabledrawy - 5 + fieldUnitRowHeight);
                            
                                    tabledrawy += fieldUnitRowHeight;
                            
                                    // Draw headers
                                    headerStartY = tabledrawy;
                                    maxHeaderLines = 1;
                                    headers.forEach((heading, index) => {
                                        pdf.setTextColor("#000000");
                                        pdf.setFontSize(8);
                                        let availableWidth = (newReducableWidth / 100) * heading.width - 5;
                                        let splitHeader = pdf.splitTextToSize(heading.label, availableWidth);
                                        maxHeaderLines = Math.max(maxHeaderLines, splitHeader.length);
                                        let currentXPosition = index === 0 ? headerxpos : (isrtlview ? headerxpos - padding : headerxpos + padding);
                                        let adjustedXPosition = isrtlview
                                            ? (index === 0 ? currentXPosition + rtlFirstColumnOffset : currentXPosition + rtlTextOffset)
                                            : currentXPosition;
                                        let currentYPosition = tabledrawy + 2;
                                        splitHeader.forEach((line, lineIndex) => {
                                            pdf.text(line, adjustedXPosition, currentYPosition, optionsR);
                                            currentYPosition += 6;
                                        });
                                        xPositions.push(currentXPosition);
                                        const xPositionForCurrentHeader = isrtlview
                                            ? headerxpos - (newReducableWidth / 100) * heading.width
                                            : headerxpos + (newReducableWidth / 100) * heading.width;
                                        headerxpos = xPositionForCurrentHeader;
                                    });
                            
                                    xPositions.sort((a, b) => (isrtlview ? b - a : a - b));
                            
                                    // Calculate the Y-position of the last line of header text
                                    let lastHeaderTextLineY = tabledrawy + 2 + (maxHeaderLines - 1) * 6;
                            
                                    // Redefine headerHeight to be the height from tabledrawy to the bottom line plus a small gap
                                    headerHeight = 9 + (maxHeaderLines - 1) * 6;
                            
                                    // Draw the bottom line just below the last header text line
                                    pdf.setDrawColor(0);
                                    pdf.setLineWidth(0.5);
                                    pdf.line(pageMarginNew - 3, lastHeaderTextLineY + 2, tableWidth - pageMarginNew + 3, lastHeaderTextLineY + 2);
                            
                                    tabledrawy += headerHeight;
                            
                                    // ROWS for all shelves in the Field Unit
                                    let newheadery = tabledrawy;
                                    let newpageno = pageno;
                                    let curlastaddedpage = lastaddedpage;
                                    let tableBodyStartY = newheadery - 5;
                                    let lastRowY = newheadery;
                            
                                    for (const shelfkey in printOneField.shelfprods) {
                                        const fieldshelf = printOneField.shelfprods[shelfkey];
                            
                                        if (!Array.isArray(fieldshelf) || fieldshelf.length === 0) {
                                            continue;
                                        }
                            
                                        let estimatedShelfHeight = shelfUnitRowHeight;
                                        fieldshelf.forEach(() => {
                                            estimatedShelfHeight += tablerowheight + bottomPadding;
                                        });
                            
                                        if (newheadery + estimatedShelfHeight + bottompagemargin > tableHeight) {
                                            // Draw vertical lines for the current page before the page break
                                            pdf.setDrawColor(0);
                                            pdf.setLineWidth(0.5);
                                            xPositions.forEach((xPos, idx) => {
                                                if (idx < xPositions.length) {
                                                    let startY = fieldHeaderY;
                                                    let endY = newheadery - 5;
                                                    let rightBoundary = isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3;
                                                    let leftBoundary = isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3;
                                                    let adjustedXPos = xPos - 3;
                                                    if (
                                                        Math.abs(adjustedXPos - rightBoundary) > boundaryThreshold &&
                                                        Math.abs(adjustedXPos - leftBoundary) > boundaryThreshold
                                                    ) {
                                                        pdf.line(adjustedXPos, startY, adjustedXPos, endY);
                                                    }
                                                }
                                            });
                                            pdf.line(
                                                isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3,
                                                fieldHeaderY,
                                                isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3,
                                                newheadery - 5
                                            );
                                            pdf.line(
                                                isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3,
                                                fieldHeaderY,
                                                isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3,
                                                newheadery - 5
                                            );
                            
                                            pdf.addPage();
                                            newheadery = pageMarginNew;
                                            newpageno = newpageno + 1;
                                            tableBodyStartY = newheadery - 5;
                                            lastRowY = newheadery;
                            
                                            if (!curlastaddedpage || curlastaddedpage !== newpageno) {
                                                curlastaddedpage = newpageno;
                                                pdf.setFontSize(10);
                                                pdf.setTextColor("#000000");
                                                pdf.text(
                                                    this.props.t("PAGE") + " " + curlastaddedpage,
                                                    isrtlview ? tableWidth - pageMarginNew : pageMarginNew,
                                                    10,
                                                    optionsR
                                                );
                            
                                                let bottombranchtxt = isrtlview
                                                    ? (this.props.simulateSearchObj && this.props.simulateSearchObj.storeName
                                                        ? this.props.simulateSearchObj.storeName + " <"
                                                        : "") +
                                                    " " +
                                                    (chaindetails ? chaindetails.chainName : "-")
                                                    : (chaindetails ? chaindetails.chainName : "-") +
                                                    " " +
                                                    (this.props.simulateSearchObj && this.props.simulateSearchObj.storeName
                                                        ? "> " + this.props.simulateSearchObj.storeName
                                                        : "");
                                                pdf.text(
                                                    bottombranchtxt,
                                                    isrtlview ? tableWidth - pageMarginNew : pageMarginNew,
                                                    tableHeight - 20,
                                                    optionsR
                                                );
                            
                                                let bottomusertxt = isrtlview
                                                    ? (userdetails ? userdetails.fName + " " + userdetails.lName : "-") +
                                                    " | " +
                                                    generatedTime +
                                                    " | " +
                                                    generatedDate
                                                    : generatedDate +
                                                    " | " +
                                                    generatedTime +
                                                    " | " +
                                                    (userdetails ? userdetails.fName + " " + userdetails.lName : "-");
                                                pdf.text(
                                                    bottomusertxt,
                                                    isrtlview ? pageMarginNew : tableWidth - pageMarginNew,
                                                    tableHeight - 20,
                                                    optionsL
                                                );
                            
                                                pdf.setDrawColor(0);
                                                pdf.setLineWidth(0.5);
                                                pdf.setFillColor(141, 162, 216);
                                                pdf.rect(pageMarginNew - 3, newheadery - 5, tableWidth - pageMarginNew + 3 - (pageMarginNew - 3), fieldUnitRowHeight, "F");
                            
                                                pdf.line(pageMarginNew - 3, newheadery - 5, tableWidth - pageMarginNew + 3, newheadery - 5);
                            
                                                pdf.setTextColor("#000000");
                                                pdf.setFontSize(9);
                                                pdf.text(
                                                    this.props.t("Field_unit_no") + ": " + (index + 1),
                                                    isrtlview ? tableWidth - pageMarginNew : pageMarginNew + 3,
                                                    newheadery + textOffset,
                                                    optionsR
                                                );
                            
                                                pdf.setDrawColor(0);
                                                pdf.setLineWidth(0.5);
                                                pdf.line(pageMarginNew - 3, newheadery - 5 + fieldUnitRowHeight, tableWidth - pageMarginNew + 3, newheadery - 5 + fieldUnitRowHeight);
                            
                                                fieldHeaderY = newheadery - 5;
                                                newheadery += fieldUnitRowHeight;
                            
                                                headerxpos = isrtlview ? tableWidth - pageMarginNew : pageMarginNew;
                                                headerStartY = newheadery;
                                                xPositions.length = 0;
                                                maxHeaderLines = 1;
                                                headers.forEach((heading, index) => {
                                                    pdf.setTextColor("#000000");
                                                    pdf.setFontSize(8);
                                                    let availableWidth = (newReducableWidth / 100) * heading.width - 5;
                                                    let splitHeader = pdf.splitTextToSize(heading.label, availableWidth);
                                                    maxHeaderLines = Math.max(maxHeaderLines, splitHeader.length);
                                                    let currentXPosition = index === 0 ? headerxpos : (isrtlview ? headerxpos - padding : headerxpos + padding);
                                                    let adjustedXPosition = isrtlview
                                                        ? (index === 0 ? currentXPosition + rtlFirstColumnOffset : currentXPosition + rtlTextOffset)
                                                        : currentXPosition;
                                                    let currentYPosition = newheadery + 2;
                                                    splitHeader.forEach((line, lineIndex) => {
                                                        pdf.text(line, adjustedXPosition, currentYPosition, optionsR);
                                                        currentYPosition += 6;
                                                    });
                                                    xPositions.push(currentXPosition);
                                                    const xPositionForCurrentHeader = isrtlview
                                                        ? headerxpos - (newReducableWidth / 100) * heading.width
                                                        : headerxpos + (newReducableWidth / 100) * heading.width;
                                                    headerxpos = xPositionForCurrentHeader;
                                                });
                            
                                                xPositions.sort((a, b) => (isrtlview ? b - a : a - b));
                            
                                                lastHeaderTextLineY = newheadery + 2 + (maxHeaderLines - 1) * 6;
                                                headerHeight = 9 + (maxHeaderLines - 1) * 6;
                            
                                                pdf.setDrawColor(0);
                                                pdf.setLineWidth(0.5);
                                                pdf.line(pageMarginNew - 3, lastHeaderTextLineY + 2, tableWidth - pageMarginNew + 3, lastHeaderTextLineY + 2);
                            
                                                newheadery = newheadery + headerHeight;
                                                tableBodyStartY = newheadery - 5;
                                            }
                                        }
                            
                                        // Draw "Shelf Unit No" row
                                        pdf.setFillColor(220, 220, 220);
                                        pdf.rect(pageMarginNew - 3, newheadery - 5, tableWidth - pageMarginNew + 3 - (pageMarginNew - 3), shelfUnitRowHeight, "F");
                            
                                        pdf.setDrawColor(0);
                                        pdf.setLineWidth(0.5);
                                        pdf.line(pageMarginNew - 3, newheadery - 5, tableWidth - pageMarginNew + 3, newheadery - 5);
                            
                                        pdf.setTextColor("#000000");
                                        pdf.setFontSize(9);
                                        pdf.text(
                                            this.props.t("Shelf_unit_no") + ": " + shelfkey,
                                            isrtlview ? tableWidth - pageMarginNew : pageMarginNew + 3,
                                            newheadery + textOffset,
                                            optionsR
                                        );
                            
                                        pdf.setDrawColor(0);
                                        pdf.setLineWidth(0.5);
                                        pdf.line(pageMarginNew - 3, newheadery - 5 + shelfUnitRowHeight, tableWidth - pageMarginNew + 3, newheadery - 5 + shelfUnitRowHeight);
                            
                                        newheadery += shelfUnitRowHeight;
                            
                                        fieldshelf.forEach((row, rIndex) => {
                                            if (!row) {
                                                return;
                                            }
                            
                                            const rowHeights = [];
                                            const rowRectHeights = [];
                            
                                            let newrowcells = [];
                                            headers.forEach((column, cIndex) => {
                                                const xPositionForCurrentHeader = (((newReducableWidth / 100) * column.width) - tablecellpadding);
                                                // const longText = ((column.key !== "barcode" && column.key !== "qty")?pdf.splitTextToSize(String(row[column.key]), xPositionForCurrentHeader):[String(row[column.key])]);
                                                let cellValue = row[column.key] !== null && row[column.key] !== undefined ? String(row[column.key]) : '';
                                                if (column?.key === 'stackCount') {
                                                    const numericValue = Number(this.validateProductHeight(row));
                                                    if (row.stackCount) {
                                                        if(!row.isStackable){
                                                            cellValue = '1';
                                                        }else{
                                                            if (numericValue === 0) {
                                                                cellValue = '1';
                                                            } else if (numericValue > 0) {
                                                                cellValue = String(numericValue + 1);
                                                            }
                                                        }
                                                    } else {
                                                        cellValue = '1';
                                                    }
                                                   
                                                }
                                                if (column?.key === "productLabel" && row[column.key] && typeof row[column.key] === "object") {
                                                    cellValue = row[column.key].name || "";
                                                }

                                                // group id replace by new field wise group id
                                                // if(column?.key === 'groupId'){
                                                //     let filedWiseGroupIdText = this.getFieldWiseGroupId(row?.productId, true);
                                                //     if(filedWiseGroupIdText){
                                                //         cellValue = filedWiseGroupIdText
                                                //     }else{
                                                //         cellValue = '';
                                                //     }
                                                // }
                                                if(column?.key === 'groupId'){
                                                    let fieldId = row?.actualFieldId || row?.fieldId; // Use the appropriate field identifier from your row
                                                    console.log('row', row);
                                                    
                                                    let filedWiseGroupIdText = this.getFieldWiseGroupId(row?.id);
                                                    if(filedWiseGroupIdText){
                                                        cellValue = filedWiseGroupIdText
                                                    }else{
                                                        cellValue = '';
                                                    }
                                                }
                                                
                                                if (column?.key === 'brand' && row[column.key] && typeof row[column.key] === 'object') {
                                                    cellValue = row?.productBrand.brandName || ''; 
                                                }
                                                

                                                if (column?.key === 'totalSale'){
                                                    cellValue = row?.normalizedData?.salesCurrency || ''; 
                                                }

                                                const longText = pdf.splitTextToSize(cellValue, xPositionForCurrentHeader);
                                                const rowHeight = longText.length * tablerowheight;
                                                rowHeights.push(rowHeight);
                                                const rowRectHeight = (longText.length > 1 ? longText.length * 8 : tablerowheight) + bottomPadding;
                                                rowRectHeights.push(rowRectHeight);
                                                let adjustedXPosition = isrtlview
                                                    ? (cIndex === 0 ? xPositions[cIndex] + rtlFirstColumnOffset : xPositions[cIndex] + rtlTextOffset)
                                                    : xPositions[cIndex];
                                                let cellobj = { text: longText, xpos: adjustedXPosition, ypos: newheadery + dataTextOffset };
                                                newrowcells.push(cellobj);
                                            });
                            
                                            let nextrectrowheight = Math.max(...rowRectHeights) > tablerowheight ? Math.max(...rowRectHeights) : tablerowheight + bottomPadding;
                            
                                            pdf.setDrawColor(0);
                                            pdf.setLineWidth(0.5);
                                            pdf.line(pageMarginNew - 3, newheadery - 5 + nextrectrowheight, tableWidth - pageMarginNew + 3, newheadery - 5 + nextrectrowheight);
                            
                                            let nextaddy = Math.max(...rowHeights) > tablerowheight ? Math.max(...rowHeights) + bottomPadding : tablerowheight + bottomPadding;
                                            newrowcells.forEach((rowcell) => {
                                                pdf.setTextColor("#555555");
                                                pdf.setFontSize(8);
                                                pdf.setLineHeightFactor(1.2);
                                                pdf.text(rowcell.text, rowcell.xpos, rowcell.ypos, optionsR);
                                            });
                            
                                            let newcelly = newheadery + nextrectrowheight;
                                            newheadery = newcelly;
                                            lastRowY = newheadery;
                            
                                            let estimatedRowHeight = Math.max(...rowHeights) > tablerowheight ? Math.max(...rowHeights) + bottomPadding : tablerowheight + bottomPadding;
                            
                                            if (newheadery + estimatedRowHeight + bottompagemargin > tableHeight) {
                                                // Draw vertical lines for the current page before the page break
                                                pdf.setDrawColor(0);
                                                pdf.setLineWidth(0.5);
                                                xPositions.forEach((xPos, idx) => {
                                                    if (idx < xPositions.length) {
                                                        let startY = fieldHeaderY;
                                                        let endY = newheadery - 5;
                                                        let rightBoundary = isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3;
                                                        let leftBoundary = isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3;
                                                        let adjustedXPos = xPos - 3;
                                                        if (
                                                            Math.abs(adjustedXPos - rightBoundary) > boundaryThreshold &&
                                                            Math.abs(adjustedXPos - leftBoundary) > boundaryThreshold
                                                        ) {
                                                            pdf.line(adjustedXPos, startY, adjustedXPos, endY);
                                                        }
                                                    }
                                                });
                                                pdf.line(
                                                    isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3,
                                                    fieldHeaderY,
                                                    isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3,
                                                    newheadery - 5
                                                );
                                                pdf.line(
                                                    isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3,
                                                    fieldHeaderY,
                                                    isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3,
                                                    newheadery - 5
                                                );
                            
                                                pdf.addPage();
                                                newheadery = pageMarginNew + padding;
                                                newpageno = newpageno + 1;
                                                tableBodyStartY = newheadery - 5;
                                                lastRowY = newheadery;
                            
                                                if (!curlastaddedpage || curlastaddedpage !== newpageno) {
                                                    curlastaddedpage = newpageno;
                                                    pdf.setFontSize(10);
                                                    pdf.setTextColor("#000000");
                                                    pdf.text(
                                                        this.props.t("PAGE") + " " + curlastaddedpage,
                                                        isrtlview ? tableWidth - pageMarginNew : pageMarginNew,
                                                        10,
                                                        optionsR
                                                    );
                            
                                                    let bottombranchtxt = isrtlview
                                                        ? (this.props.simulateSearchObj && this.props.simulateSearchObj.storeName
                                                            ? this.props.simulateSearchObj.storeName + " <"
                                                            : "") +
                                                        " " +
                                                        (chaindetails ? chaindetails.chainName : "-")
                                                        : (chaindetails ? chaindetails.chainName : "-") +
                                                        " " +
                                                        (this.props.simulateSearchObj && this.props.simulateSearchObj.storeName
                                                            ? "> " + this.props.simulateSearchObj.storeName
                                                            : "");
                                                    pdf.text(
                                                        bottombranchtxt,
                                                        isrtlview ? tableWidth - pageMarginNew : pageMarginNew,
                                                        tableHeight - 20,
                                                        optionsR
                                                    );
                            
                                                    let bottomusertxt = isrtlview
                                                        ? (userdetails ? userdetails.fName + " " + userdetails.lName : "-") +
                                                        " | " +
                                                        generatedTime +
                                                        " | " +
                                                        generatedDate
                                                        : generatedDate +
                                                        " | " +
                                                        generatedTime +
                                                        " | " +
                                                        (userdetails ? userdetails.fName + " " + userdetails.lName : "-");
                                                    pdf.text(
                                                        bottomusertxt,
                                                        isrtlview ? pageMarginNew : tableWidth - pageMarginNew,
                                                        tableHeight - 20,
                                                        optionsL
                                                    );
                            
                                                    pdf.setDrawColor(0);
                                                    pdf.setLineWidth(0.5);
                                                    pdf.setFillColor(141, 162, 216);
                                                    pdf.rect(pageMarginNew - 3, newheadery - 5, tableWidth - pageMarginNew + 3 - (pageMarginNew - 3), fieldUnitRowHeight, "F");
                            
                                                    pdf.line(pageMarginNew - 3, newheadery - 5, tableWidth - pageMarginNew + 3, newheadery - 5);
                            
                                                    pdf.setTextColor("#000000");
                                                    pdf.setFontSize(9);
                                                    pdf.text(
                                                        this.props.t("Field_unit_no") + ": " + (index + 1),
                                                        isrtlview ? tableWidth - pageMarginNew : pageMarginNew + 3,
                                                        newheadery + textOffset,
                                                        optionsR
                                                    );
                            
                                                    pdf.setDrawColor(0);
                                                    pdf.setLineWidth(0.5);
                                                    pdf.line(pageMarginNew - 3, newheadery - 5 + fieldUnitRowHeight, tableWidth - pageMarginNew + 3, newheadery - 5 + fieldUnitRowHeight);
                            
                                                    fieldHeaderY = newheadery - 5;
                                                    newheadery += fieldUnitRowHeight;
                            
                                                    headerxpos = isrtlview ? tableWidth - pageMarginNew : pageMarginNew;
                                                    headerStartY = newheadery;
                                                    xPositions.length = 0;
                                                    maxHeaderLines = 1;
                                                    headers.forEach((heading, index) => {
                                                        pdf.setTextColor("#000000");
                                                        pdf.setFontSize(8);
                                                        let availableWidth = (newReducableWidth / 100) * heading.width - 5;
                                                        let splitHeader = pdf.splitTextToSize(heading.label, availableWidth);
                                                        maxHeaderLines = Math.max(maxHeaderLines, splitHeader.length);
                                                        let currentXPosition = index === 0 ? headerxpos : (isrtlview ? headerxpos - padding : headerxpos + padding);
                                                        let adjustedXPosition = isrtlview
                                                            ? (index === 0 ? currentXPosition + rtlFirstColumnOffset : currentXPosition + rtlTextOffset)
                                                            : currentXPosition;
                                                        let currentYPosition = newheadery + 2;
                                                        splitHeader.forEach((line, lineIndex) => {
                                                            pdf.text(line, adjustedXPosition, currentYPosition, optionsR);
                                                            currentYPosition += 6;
                                                        });
                                                        xPositions.push(currentXPosition);
                                                        const xPositionForCurrentHeader = isrtlview
                                                            ? headerxpos - (newReducableWidth / 100) * heading.width
                                                            : headerxpos + (newReducableWidth / 100) * heading.width;
                                                        headerxpos = xPositionForCurrentHeader;
                                                    });
                            
                                                    xPositions.sort((a, b) => (isrtlview ? b - a : a - b));
                            
                                                    lastHeaderTextLineY = newheadery + 2 + (maxHeaderLines - 1) * 6;
                                                    headerHeight = 9 + (maxHeaderLines - 1) * 6;
                            
                                                    pdf.setDrawColor(0);
                                                    pdf.setLineWidth(0.5);
                                                    pdf.line(pageMarginNew - 3, lastHeaderTextLineY + 2, tableWidth - pageMarginNew + 3, lastHeaderTextLineY + 2);
                            
                                                    newheadery = newheadery + headerHeight;
                                                    tableBodyStartY = newheadery - 5;
                                                }
                                            }
                                        });
                                    }
                            
                                    // Draw vertical lines for the entire field unit
                                    pdf.setDrawColor(0);
                                    pdf.setLineWidth(0.5);
                                    xPositions.forEach((xPos, idx) => {
                                        if (idx < xPositions.length) {
                                            let startY = fieldHeaderY;
                                            let endY = lastRowY - 5;
                                            let rightBoundary = isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3;
                                            let leftBoundary = isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3;
                                            let adjustedXPos = xPos - 3;
                                            if (
                                                Math.abs(adjustedXPos - rightBoundary) > boundaryThreshold &&
                                                Math.abs(adjustedXPos - leftBoundary) > boundaryThreshold
                                            ) {
                                                pdf.line(adjustedXPos, startY, adjustedXPos, endY);
                                            }
                                        }
                                    });
                                    pdf.line(
                                        isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3,
                                        fieldHeaderY,
                                        isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3,
                                        lastRowY - 5
                                    );
                                    pdf.line(
                                        isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3,
                                        fieldHeaderY,
                                        isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3,
                                        lastRowY - 5
                                    );
                            
                                    lastaddedpage = curlastaddedpage;
                                    pageno = newpageno;
                                    tabledrawy = lastRowY;
                                }
                            }
                            
                            // pegboard table data
                            for (let index = 0; index < this.state.CategoryWisescalePegBoardObj?.length; index++) {
                                let pegBoard = this.state.CategoryWisescalePegBoardObj[index];
                                let pegBoardProducts = this.state.pegProductList.filter(product => product?.pegBoard?.id === pegBoard.id);

                                // Sort pegBoardProducts by filedWiseGroupIdText
                                pegBoardProducts = pegBoardProducts.sort((a, b) => {
                                    const groupIdA = this.getFieldWiseGroupId(a?.id) || '';
                                    const groupIdB = this.getFieldWiseGroupId(b?.id) || '';

                                    // Split by comma and get array of IDs
                                    const idsA = groupIdA.split(',').map(id => id.trim());
                                    const idsB = groupIdB.split(',').map(id => id.trim());

                                    // Compare first ID numerically, then alphabetically if not numeric
                                    const firstIdA = idsA[0];
                                    const firstIdB = idsB[0];
                                    const numA = parseInt(firstIdA);
                                    const numB = parseInt(firstIdB);

                                    if (!isNaN(numA) && !isNaN(numB)) {
                                        return numA - numB;
                                    }
                                    return groupIdA.localeCompare(groupIdB, undefined, { numeric: true, sensitivity: 'base' });
                                });

                                let pageMarginNew = 25;

                            
                                // Auto table
                                if (pegBoard) {
                                    let tableWidth = pdf.internal.pageSize.getWidth();
                                    let tableHeight = pdf.internal.pageSize.getHeight();
                            
                                    // Define padding, RTL text offsets, and other constants
                                    const padding = 15;
                                    const rtlTextOffset = -5;
                                    const rtlFirstColumnOffset = 0;
                                    const xPositions = [];
                                    const boundaryThreshold = 10;
                                    const pegBoardRowHeight = 10; // Similar to fieldUnitRowHeight
                                    let headerHeight = 10; // Will adjust dynamically based on wrapped text
                                    const tablerowheight = 10;
                                    const tablecellpadding = 15;
                                    const footerHeight = 5;
                                    const bottompagemargin = pageMarginNew * 2 + footerHeight;
                                    const minimalGap = 0;
                                    const dataTextOffset = 2;
                                    const bottomPadding = 2;
                            
                                    // Estimate the height of the table to determine if it fits on the current page
                                    let estimatedTableHeight = pegBoardRowHeight + headerHeight;
                                    pegBoardProducts.forEach(() => {
                                        estimatedTableHeight += tablerowheight + bottomPadding;
                                    });
                                    estimatedTableHeight += minimalGap;
                            
                                    if (index === 0 || tabledrawy + estimatedTableHeight + bottompagemargin > tableHeight) {
                                        pdf.addPage("a4", "portrait");
                                        pageno = pageno + 1;
                                        tabledrawy = pageMarginNew;
                                    } else {
                                        tabledrawy += minimalGap;
                                    }
                            
                                    if (!lastaddedpage || lastaddedpage !== pageno) {
                                        lastaddedpage = pageno;
                                        pdf.setFontSize(10);
                                        const pageLine = isrtlview ? `${pageno} ${" "} ${this.props.t("PAGE")}` : `${this.props.t("PAGE")}  ${" "} ${pageno}`;
                                        pdf.text(pageLine, isrtlview ? tableWidth - pageMarginNew : pageMarginNew, 10, optionsR);
                            
                                        let bottombranchtxt = isrtlview
                                            ? (this.props.simulateSearchObj && this.props.simulateSearchObj.storeName
                                                ? this.props.simulateSearchObj.storeName + " <"
                                                : "") + " " + (chaindetails ? chaindetails.chainName : "-")
                                            : (chaindetails ? chaindetails.chainName : "-") + " " +
                                              (this.props.simulateSearchObj && this.props.simulateSearchObj.storeName
                                                ? "> " + this.props.simulateSearchObj.storeName
                                                : "");
                                        pdf.text(bottombranchtxt, isrtlview ? tableWidth - pageMarginNew : pageMarginNew, tableHeight - 20, optionsR);
                            
                                        let bottomusertxt = isrtlview
                                            ? (userdetails ? userdetails.fName + " " + userdetails.lName : "-") + " | " + generatedTime + " | " + generatedDate
                                            : generatedDate + " | " + generatedTime + " | " + (userdetails ? userdetails.fName + " " + userdetails.lName : "-");
                                        pdf.text(bottomusertxt, isrtlview ? pageMarginNew : tableWidth - pageMarginNew, tableHeight - 20, optionsL);
                                    }
                            
                                    const fieldMapping = {
                                        barcode: 'barcode',
                                        productName: 'name',
                                        supplierName: 'productBrand',
                                        face: 'qty',
                                        layers: 'stackCount',
                                        barcodeTwo: 'barcodeTwo',
                                        locationId: 'groupId',
                                        width: 'width',
                                        sale: 'totalSale',
                                        label: 'productLabel',
                                        brand: 'brand'
                                    };
                            
                                    let headers = this?.state?.moduleDetailedData
                                        ?.filter(item => item.status === "online")
                                        .map(item => ({
                                            key: fieldMapping[item.fieldsList] || item.fieldsList,
                                            label: item.label,
                                            width: parseInt(item.width, 10)
                                        }));
                            
                                    const newReducableWidth = tableWidth - 60;
                                    let headerxpos = isrtlview ? tableWidth - pageMarginNew : pageMarginNew;
                                    let pegBoardHeaderY = tabledrawy - 5;
                                    let headerStartY;
                            
                                    // Draw "PEG BOARD" as the first row
                                    const textOffset = 2;
                            
                                    pdf.setFillColor(141, 162, 216);
                                    pdf.rect(pageMarginNew - 3, tabledrawy - 5, tableWidth - pageMarginNew + 3 - (pageMarginNew - 3), pegBoardRowHeight, "F");
                            
                                    pdf.setDrawColor(0);
                                    pdf.setLineWidth(0.5);
                                    pdf.line(pageMarginNew - 3, tabledrawy - 5, tableWidth - pageMarginNew + 3, tabledrawy - 5);
                            
                                    pdf.setTextColor("#000000");
                                    pdf.setFontSize(9);
                                    pdf.text(
                                        this.props.t("PEG_BOARD") + ": " + (index + 1),
                                        isrtlview ? tableWidth - pageMarginNew : pageMarginNew + 3,
                                        tabledrawy + textOffset,
                                        optionsR
                                    );
                            
                                    pdf.setDrawColor(0);
                                    pdf.setLineWidth(0.5);
                                    pdf.line(pageMarginNew - 3, tabledrawy - 5 + pegBoardRowHeight, tableWidth - pageMarginNew + 3, tabledrawy - 5 + pegBoardRowHeight);
                            
                                    tabledrawy += pegBoardRowHeight;
                            
                                    // Draw headers
                                    headerStartY = tabledrawy;
                                    let maxHeaderLines = 1;
                                    headers.forEach((heading, index) => {
                                        pdf.setTextColor("#000000");
                                        pdf.setFontSize(8);
                                        let availableWidth = (newReducableWidth / 100) * heading.width - 5;
                                        let splitHeader = pdf.splitTextToSize(heading.label, availableWidth);
                                        maxHeaderLines = Math.max(maxHeaderLines, splitHeader.length);
                                        let currentXPosition = index === 0 ? headerxpos : (isrtlview ? headerxpos - padding : headerxpos + padding);
                                        let adjustedXPosition = isrtlview
                                            ? (index === 0 ? currentXPosition + rtlFirstColumnOffset : currentXPosition + rtlTextOffset)
                                            : currentXPosition;
                                        let currentYPosition = tabledrawy + 2;
                                        splitHeader.forEach((line, lineIndex) => {
                                            pdf.text(line, adjustedXPosition, currentYPosition, optionsR);
                                            currentYPosition += 6;
                                        });
                                        xPositions.push(currentXPosition);
                                        const xPositionForCurrentHeader = isrtlview
                                            ? headerxpos - (newReducableWidth / 100) * heading.width
                                            : headerxpos + (newReducableWidth / 100) * heading.width;
                                        headerxpos = xPositionForCurrentHeader;
                                    });
                            
                                    xPositions.sort((a, b) => (isrtlview ? b - a : a - b));
                            
                                    // Calculate the Y-position of the last line of header text
                                    let lastHeaderTextLineY = tabledrawy + 2 + (maxHeaderLines - 1) * 6;
                            
                                    // Redefine headerHeight to be the height from tabledrawy to the bottom line plus a small gap
                                    headerHeight = 8 + (maxHeaderLines - 1) * 6; // Same gap as previous components
                            
                                    // Draw the bottom line just below the last header text line
                                    pdf.setDrawColor(0);
                                    pdf.setLineWidth(0.5);
                                    pdf.line(pageMarginNew - 3, lastHeaderTextLineY + 2, tableWidth - pageMarginNew + 3, lastHeaderTextLineY + 2);
                            
                                    tabledrawy += headerHeight;
                            
                                    // ROWS for all products in the PegBoard
                                    let newheadery = tabledrawy;
                                    let newpageno = pageno;
                                    let curlastaddedpage = lastaddedpage;
                                    let tableBodyStartY = newheadery - 5;
                                    let lastRowY = newheadery;
                            
                                    pegBoardProducts.forEach((row, rIndex) => {
                                        const rowHeights = [];
                                        const rowRectHeights = [];
                            
                                        let newrowcells = [];
                                        headers.forEach((column, cIndex) => {
                                            const xPositionForCurrentHeader = (newReducableWidth / 100) * column.width - tablecellpadding;
                                            let cellValue = row[column.key] !== null && row[column.key] !== undefined ? String(row[column.key]) : '';
                                            if (column?.key === 'stackCount') {
                                                    const numericValue = Number(this.validateProductHeight(row));
                                                    if (row.stackCount) {
                                                        if(!row.isStackable){
                                                            cellValue = '1';
                                                        }else{
                                                            if (numericValue === 0) {
                                                                cellValue = '1';
                                                            } else if (numericValue > 0) {
                                                                cellValue = String(numericValue + 1);
                                                            }
                                                        }
                                                    } else {
                                                        cellValue = '1';
                                                    }
                                                }
                                            if (column?.key === 'qty' && cellValue === '0') {
                                                cellValue = '1';
                                            }
                                            if (column?.key === 'productLabel' && row[column.key] && typeof row[column.key] === 'object') {
                                                cellValue = row[column.key].name || '';
                                            }
                                            if (column?.key === 'productBrand' && row[column.key] && typeof row[column.key] === 'object') {
                                                cellValue = row[column.key]?.supplier?.supplierName || '';
                                            }

                                            if (column?.key === 'brand' && row[column.key] && typeof row[column.key] === 'object') {
                                                cellValue = row[column.key]?.brand?.brandName || ''; 
                                            }

                                            if (column?.key === 'totalSale'){
                                                cellValue = row?.normalizedData?.salesCurrency || '';
                                            }

                                            // group id replace by new field wise group id
                                            if(column?.key === 'groupId'){
                                                let filedWiseGroupIdText = this.getFieldWiseGroupId(row?.id);
                                                if(filedWiseGroupIdText){
                                                    cellValue = filedWiseGroupIdText
                                                }else{
                                                    cellValue = '';
                                                }
                                            }

                                            const longText = pdf.splitTextToSize(cellValue, xPositionForCurrentHeader);
                                            const rowHeight = longText.length * tablerowheight;
                                            rowHeights.push(rowHeight);
                                            const rowRectHeight = (longText.length > 1 ? longText.length * 8 : tablerowheight) + bottomPadding;
                                            rowRectHeights.push(rowRectHeight);
                                            let adjustedXPosition = isrtlview
                                                ? (cIndex === 0 ? xPositions[cIndex] + rtlFirstColumnOffset : xPositions[cIndex] + rtlTextOffset)
                                                : xPositions[cIndex];
                                            let cellobj = { text: longText, xpos: adjustedXPosition, ypos: newheadery + dataTextOffset };
                                            newrowcells.push(cellobj);
                                        });
                            
                                        let nextrectrowheight = Math.max(...rowRectHeights) > tablerowheight ? Math.max(...rowRectHeights) : tablerowheight + bottomPadding;
                        
                            
                                        pdf.setDrawColor(0);
                                        pdf.setLineWidth(0.5);
                                        pdf.line(pageMarginNew - 3, newheadery - 5 + nextrectrowheight, tableWidth - pageMarginNew + 3, newheadery - 5 + nextrectrowheight);
                            
                                        let nextaddy = Math.max(...rowHeights) > tablerowheight ? Math.max(...rowHeights) + bottomPadding : tablerowheight + bottomPadding;
                                        newrowcells.forEach((rowcell) => {
                                            pdf.setTextColor("#555555");
                                            pdf.setFontSize(8);
                                            pdf.setLineHeightFactor(1.2);
                                            pdf.text(rowcell.text, rowcell.xpos, rowcell.ypos, optionsR);
                                        });
                            
                                        let newcelly = newheadery + nextrectrowheight;
                                        newheadery = newcelly;
                                        lastRowY = newheadery;
                            
                                        let estimatedRowHeight = Math.max(...rowHeights) > tablerowheight ? Math.max(...rowHeights) + bottomPadding : tablerowheight + bottomPadding;
                                        let isLastRow = (rIndex === pegBoardProducts.length - 1);
                            
                                        if (!isLastRow && (newheadery + estimatedRowHeight + bottompagemargin > tableHeight)) {
                                            // Draw vertical lines for the current page before the page break
                                            pdf.setDrawColor(0);
                                            pdf.setLineWidth(0.5);
                                            xPositions.forEach((xPos, idx) => {
                                                if (idx < xPositions.length) {
                                                    let startY = pegBoardHeaderY;
                                                    let endY = newheadery - 5;
                                                    let rightBoundary = isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3;
                                                    let leftBoundary = isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3;
                                                    let adjustedXPos = xPos - 3;
                                                    if (
                                                        Math.abs(adjustedXPos - rightBoundary) > boundaryThreshold &&
                                                        Math.abs(adjustedXPos - leftBoundary) > boundaryThreshold
                                                    ) {
                                                        pdf.line(adjustedXPos, startY, adjustedXPos, endY);
                                                    }
                                                }
                                            });
                                            pdf.line(
                                                isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3,
                                                pegBoardHeaderY,
                                                isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3,
                                                newheadery - 5
                                            );
                                            pdf.line(
                                                isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3,
                                                pegBoardHeaderY,
                                                isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3,
                                                newheadery - 5
                                            );
                            
                                            pdf.addPage();
                                            newheadery = pageMarginNew + padding;
                                            newpageno = newpageno + 1;
                                            tableBodyStartY = newheadery - 5;
                                            lastRowY = newheadery;
                            
                                            if (!curlastaddedpage || curlastaddedpage !== newpageno) {
                                                curlastaddedpage = newpageno;
                                                pdf.setFontSize(10);
                                                pdf.setTextColor("#000000");
                                                const pageLine = isrtlview ? `${curlastaddedpage} ${" "} ${this.props.t("PAGE")}` : `${this.props.t("PAGE")}  ${" "} ${curlastaddedpage}`;
                                                pdf.text(pageLine, isrtlview ? tableWidth - pageMarginNew : pageMarginNew, 10, optionsR);
                            
                                                let bottombranchtxt = isrtlview
                                                    ? (this.props.simulateSearchObj && this.props.simulateSearchObj.storeName
                                                        ? this.props.simulateSearchObj.storeName + " <"
                                                        : "") + " " + (chaindetails ? chaindetails.chainName : "-")
                                                    : (chaindetails ? chaindetails.chainName : "-") + " " +
                                                      (this.props.simulateSearchObj && this.props.simulateSearchObj.storeName
                                                        ? "> " + this.props.simulateSearchObj.storeName
                                                        : "");
                                                pdf.text(bottombranchtxt, isrtlview ? tableWidth - pageMarginNew : pageMarginNew, tableHeight - 20, optionsR);
                            
                                                let bottomusertxt = isrtlview
                                                    ? (userdetails ? userdetails.fName + " " + userdetails.lName : "-") + " | " + generatedTime + " | " + generatedDate
                                                    : generatedDate + " | " + generatedTime + " | " + (userdetails ? userdetails.fName + " " + userdetails.lName : "-");
                                                pdf.text(bottomusertxt, isrtlview ? pageMarginNew : tableWidth - pageMarginNew, tableHeight - 20, optionsL);
                            
                                                pdf.setDrawColor(0);
                                                pdf.setLineWidth(0.5);
                                                pdf.setFillColor(141, 162, 216);
                                                pdf.rect(pageMarginNew - 3, newheadery - 5, tableWidth - pageMarginNew + 3 - (pageMarginNew - 3), pegBoardRowHeight, "F");
                            
                                                pdf.line(pageMarginNew - 3, newheadery - 5, tableWidth - pageMarginNew + 3, newheadery - 5);
                            
                                                pdf.setTextColor("#000000");
                                                pdf.setFontSize(9);
                                                pdf.text(
                                                    this.props.t("PEG_BOARD") + ": " + (index + 1),
                                                    isrtlview ? tableWidth - pageMarginNew : pageMarginNew + 3,
                                                    newheadery + textOffset,
                                                    optionsR
                                                );
                            
                                                pdf.setDrawColor(0);
                                                pdf.setLineWidth(0.5);
                                                pdf.line(pageMarginNew - 3, newheadery - 5 + pegBoardRowHeight, tableWidth - pageMarginNew + 3, newheadery - 5 + pegBoardRowHeight);
                            
                                                pegBoardHeaderY = newheadery - 5;
                                                newheadery += pegBoardRowHeight;
                            
                                                headerxpos = isrtlview ? tableWidth - pageMarginNew : pageMarginNew;
                                                headerStartY = newheadery;
                                                xPositions.length = 0;
                                                maxHeaderLines = 1;
                                                headers.forEach((heading, index) => {
                                                    pdf.setTextColor("#000000");
                                                    pdf.setFontSize(8);
                                                    let availableWidth = (newReducableWidth / 100) * heading.width - 5;
                                                    let splitHeader = pdf.splitTextToSize(heading.label, availableWidth);
                                                    maxHeaderLines = Math.max(maxHeaderLines, splitHeader.length);
                                                    let currentXPosition = index === 0 ? headerxpos : (isrtlview ? headerxpos - padding : headerxpos + padding);
                                                    let adjustedXPosition = isrtlview
                                                        ? (index === 0 ? currentXPosition + rtlFirstColumnOffset : currentXPosition + rtlTextOffset)
                                                        : currentXPosition;
                                                    let currentYPosition = newheadery + 2;
                                                    splitHeader.forEach((line, lineIndex) => {
                                                        pdf.text(line, adjustedXPosition, currentYPosition, optionsR);
                                                        currentYPosition += 6;
                                                    });
                                                    xPositions.push(currentXPosition);
                                                    const xPositionForCurrentHeader = isrtlview
                                                        ? headerxpos - (newReducableWidth / 100) * heading.width
                                                        : headerxpos + (newReducableWidth / 100) * heading.width;
                                                    headerxpos = xPositionForCurrentHeader;
                                                });
                            
                                                xPositions.sort((a, b) => (isrtlview ? b - a : a - b));
                            
                                                lastHeaderTextLineY = newheadery + 2 + (maxHeaderLines - 1) * 6;
                                                headerHeight = 8 + (maxHeaderLines - 1) * 6;
                            
                                                pdf.setDrawColor(0);
                                                pdf.setLineWidth(0.5);
                                                pdf.line(pageMarginNew - 3, lastHeaderTextLineY + 2, tableWidth - pageMarginNew + 3, lastHeaderTextLineY + 2);
                            
                                                newheadery = newheadery + headerHeight;
                                                tableBodyStartY = newheadery - 5;
                                            }
                                        }
                                    });
                            
                                    // Draw vertical lines for the entire PegBoard
                                    pdf.setDrawColor(0);
                                    pdf.setLineWidth(0.5);
                                    xPositions.forEach((xPos, idx) => {
                                        if (idx < xPositions.length) {
                                            let startY = pegBoardHeaderY;
                                            let endY = lastRowY - 5;
                                            let rightBoundary = isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3;
                                            let leftBoundary = isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3;
                                            let adjustedXPos = xPos - 3;
                                            if (
                                                Math.abs(adjustedXPos - rightBoundary) > boundaryThreshold &&
                                                Math.abs(adjustedXPos - leftBoundary) > boundaryThreshold
                                            ) {
                                                pdf.line(adjustedXPos, startY, adjustedXPos, endY);
                                            }
                                        }
                                    });
                                    pdf.line(
                                        isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3,
                                        pegBoardHeaderY,
                                        isrtlview ? pageMarginNew - 3 : tableWidth - pageMarginNew + 3,
                                        lastRowY - 5
                                    );
                                    pdf.line(
                                        isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3,
                                        pegBoardHeaderY,
                                        isrtlview ? tableWidth - pageMarginNew + 3 : pageMarginNew - 3,
                                        lastRowY - 5
                                    );
                            
                                    lastaddedpage = curlastaddedpage;
                                    pageno = newpageno;
                                    tabledrawy = lastRowY;
                                }
                            }


                        } else{
                            for (let index = 0; index < printallprods.length; index++) {
                                let printOneField = printallprods[index];
                                let printOneFieldWithoutHangable = printallprodsWithoutHanging[index]

                                pageno = (pageno + 1);

                                for (let l = 0; l < printOneField.imagearray.length; l++) {
                                    const imgData = printOneField.imagearray[l];

                                    pdf.setTextColor(0, 0, 0);
                                    //page no
                                    pdf.setFontSize(11);
                                    const pageLine = isrtlview ? `${pageno} ${" "} ${this.props.t("PAGE")}` : `${this.props.t("PAGE")}  ${" "} ${pageno}`
                                    pdf.text((pageLine), (isrtlview?(width - 40):40), 30, optionsR);
                                    //shelf and field details
                                    pdf.setFontSize(12);
                                    pdf.text(
                                        (!this.state.isFieldWisePDFPrint?(printOneField.category?(printOneField.category+": "+printOneField.categoryNo):"-"):(this.props.t("Field_unit_no")+" "+(index + 1))),
                                        (isrtlview?(width - 40):40), 55, optionsR
                                    ); //
                                    pdf.text(imgData.fieldName?imgData.fieldName:"-", (isrtlview?40:(width - 40)), 55, optionsL);
                                    //line
                                    pdf.setLineHeightFactor(5);
                                    pdf.line(40, 60, (width - 40), 60,);
                                    //field border and image
                                    pdf.setDrawColor(0, 0, 0);
                                    pdf.setFillColor(255, 255, 255);
                                    pdf.rect(40, 70,(width - 80), (height - 110), 'FD');
                                    
                                    
                                    let imageviewwidth = ((imgData.width <= 100)?(convertWidthPercent(imgData.width, width, true) - (imgData.width >= 80?80:0)):(width - 80));
                                    let ImageY = 200
                                    pdf.addImage(imgData.imgsrc, 'PNG', 40, ImageY,imageviewwidth, (height - 110), ("alias"+(index+""+l)),"FAST");
                                    imgData.imgsrc = null; // free base64 after PDF has consumed it
                                    //page footer details
                                    let bottombranchtxt = (isrtlview?((this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?(this.props.simulateSearchObj.storeName+" <"):"")+" "+(chaindetails?chaindetails.chainName:"-"))
                                        :((chaindetails?chaindetails.chainName:"-")+" "+(this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?("> "+this.props.simulateSearchObj.storeName):"")));
                                    pdf.text(bottombranchtxt, (isrtlview?(width - 40):40), (height - 20), optionsR);

                                    let bottomusertxt = (isrtlview?((userdetails?(userdetails.fName+" "+userdetails.lName):"-")+" | "+generatedTime+" | "+generatedDate)
                                        :(generatedDate+" | "+generatedTime+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")))
                                    pdf.text(bottomusertxt, (isrtlview?40:(width - 40)), (height - 20), optionsL);

                                    if((l + 1) < printOneField.imagearray.length){
                                        pdf.addPage();
                                        pageno = (pageno + 1);
                                    }
                                }

                                //auto table
                                if(printOneFieldWithoutHangable && printOneFieldWithoutHangable.shelfprods && Object.keys(printOneField.shelfprods).length > 0){
                                    pdf.addPage();
                                    pageno = (pageno + 1);

                                    // let shelfidx = 0;
                                    for (const shelfkey in printOneFieldWithoutHangable.shelfprods) {
                                        const fieldshelf = printOneFieldWithoutHangable.shelfprods[shelfkey];

                                        let prodarrobj = [];
                                        for (let j = 0; j < fieldshelf.length; j++) {
                                            const shelfsingleobj = fieldshelf[j];

                                            let prodsupname = (shelfsingleobj.productBrand && shelfsingleobj.productBrand.supplier?shelfsingleobj.productBrand.supplier.supplierName:"-");
                                            let newprodobj = [shelfsingleobj.barcode, shelfsingleobj.name, prodsupname, shelfsingleobj.qty];
                                            prodarrobj.push(newprodobj);
                                        }
                                        // Let's set up a standard padding that we can add to known coordinates
                                        const padding = 15;
                                        const xPositions = [];

                                        tabledrawy = (tabledrawy === 45 ?(tabledrawy + padding) : tabledrawy);

                                        let bottompagemargin = pageMargin * 2;
                                        if ((tabledrawy + bottompagemargin) > height) {
                                            pdf.addPage();
                                            tabledrawy = (pageMargin + padding);

                                            let newpageno = (pageno + 1);
                                            pageno = newpageno;
                                        }

                                        //headers
                                        pdf.setTextColor("#000000");
                                        pdf.setFontSize(12);

                                        pdf.text((this.props.t("Shelf_unit_no")+": "+shelfkey), (isrtlview?(width - pageMargin):pageMargin), tabledrawy,optionsR);
                                        pdf.text(((printOneFieldWithoutHangable && printOneFieldWithoutHangable.fieldName)?printOneFieldWithoutHangable.fieldName:"-"), (isrtlview?pageMargin:(width - pageMargin)), tabledrawy, optionsL);

                                        //line
                                        pdf.setLineHeightFactor(5);
                                        pdf.line(pageMargin, (tabledrawy + 5), (width - pageMargin), (tabledrawy + 5));

                                        tabledrawy = (tabledrawy + 30);

                                        if (!lastaddedpage || lastaddedpage !== pageno) {
                                            lastaddedpage = pageno;
                                            // //page no
                                            pdf.setFontSize(11);
                                             const pageLine = isrtlview ? `${pageno} ${" "} ${this.props.t("PAGE")}` : `${this.props.t("PAGE")}  ${" "} ${pageno}`
                                            pdf.text(((pageLine)), (isrtlview?(width - pageMargin):pageMargin), 30, optionsR);

                                            // //shelf and field details
                                            pdf.setFontSize(12);
                                            //page footer details
                                            let bottombranchtxt = (isrtlview?((this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?(this.props.simulateSearchObj.storeName+" <"):"")+" "+(chaindetails?chaindetails.chainName:"-"))
                                                :((chaindetails?chaindetails.chainName:"-")+" "+(this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?("> "+this.props.simulateSearchObj.storeName):"")));
                                            pdf.text(bottombranchtxt, (isrtlview?(width - pageMargin):pageMargin), (height - 20), optionsR);

                                            let bottomusertxt = (isrtlview?((userdetails?(userdetails.fName+" "+userdetails.lName):"-")+" | "+generatedTime+" | "+generatedDate)
                                                :(generatedDate+" | "+generatedTime+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")))
                                            pdf.text(bottomusertxt, (isrtlview?pageMargin:(width - pageMargin)), (height - 20), optionsL);
                                        }

                                        //table
                                        let headers = [
                                            {key: "barcode", label: this.props.t("barcode"), width: 15},
                                            {key: "name", label: this.props.t("PRODUCT_NAME"), width: 45},
                                            {key: "distributor", label: this.props.t("supname"), width: 30},
                                            {key: "qty", label: this.props.t("FACING"), width: 10}
                                        ];

                                        let headerxpos = (isrtlview?(reducetablewidth + pageMargin):pageMargin); //default start
                                        let headernewy = tabledrawy;

                                        headers.forEach((heading, index) => {

                                            pdf.setTextColor("#000000");
                                            pdf.setFontSize(10);
                                            pdf.text(heading.label, (index === 0 ?headerxpos:(isrtlview?(headerxpos - padding):(headerxpos + padding))), headernewy, optionsR);

                                            xPositions.push(index === 0?(isrtlview?(headerxpos - 3):(headerxpos + 3)):(isrtlview?(headerxpos - padding):(headerxpos + padding)));

                                            //if last one reset to 45
                                            const xPositionForCurrentHeader = (isrtlview?(headerxpos - ((reducetablewidth / 100) * heading.width)):(headerxpos + ((reducetablewidth / 100) * heading.width)));
                                            let defxpos = (isrtlview?reducetablewidth:pageMargin);
                                            headerxpos = ((index + 1) === headers.length?defxpos:xPositionForCurrentHeader);
                                        });

                                        tabledrawy = (tabledrawy + 20);

                                        // ROWS
                                        let tablerowheight = 20;
                                        let tablecellpadding = 15;

                                        let newheadery = tabledrawy;
                                        let newpageno = pageno;
                                        let curlastaddedpage = lastaddedpage;

                                        fieldshelf.forEach((row, rIndex) => {
                                            const rowHeights = [];
                                            const rowRectHeights = [];

                                            newheadery = (newheadery === 45 ? (newheadery + padding) : newheadery);

                                            // COLUMNS
                                            let newrowcells = [];
                                            headers.forEach((column, cIndex) => {
                                                const xPositionForCurrentHeader = (((reducetablewidth / 100) * column.width) - tablecellpadding);

                                                const longText = ((column.key !== "barcode" && column.key !== "qty")?pdf.splitTextToSize(String(row[column.key]), xPositionForCurrentHeader):[String(row[column.key])]);
                                                const rowHeight = longText.length * tablerowheight;
                                                rowHeights.push(rowHeight);

                                                const rowRectHeight = (longText.length > 1 ? (longText.length * 16) : tablerowheight);
                                                rowRectHeights.push(rowRectHeight);

                                                let cellobj = { text: longText, xpos: xPositions[cIndex], ypos: newheadery};
                                                newrowcells.push(cellobj);
                                            });

                                            let nextrectrowheight = (Math.max(...rowRectHeights) > tablerowheight ? Math.max(...rowRectHeights) : tablerowheight);

                                            pdf.setFillColor(0, 0, 0, 0.05);
                                            pdf.rect(pageMargin, newheadery - 11, reducetablewidth, nextrectrowheight - 3, "F");

                                            let nextaddy = (Math.max(...rowHeights) > tablerowheight? Math.max(...rowHeights): tablerowheight);

                                            newrowcells.forEach((rowcell, rIndex) => {
                                                pdf.setTextColor("#555555");
                                                pdf.setFontSize(10);

                                                pdf.setLineHeightFactor(1.5);
                                                pdf.text(rowcell.text, rowcell.xpos, rowcell.ypos, optionsR);
                                            });

                                            let newcelly = (newheadery + nextaddy);
                                            newheadery = newcelly;

                                            let bottompagemargin = pageMargin * 2;
                                            if ((newcelly + bottompagemargin) > height && (rIndex + 1) < fieldshelf.length) {
                                                pdf.addPage();

                                                newheadery = (pageMargin + padding);
                                                newpageno = (newpageno + 1);

                                                //if last page add headers
                                                    if (!curlastaddedpage || curlastaddedpage !== newpageno) {
                                                        curlastaddedpage = newpageno;
                                                        // //page no
                                                        pdf.setFontSize(11);
                                                        pdf.setTextColor("#000000");
                                                        const pageLine = isrtlview ? `${curlastaddedpage} ${" "} ${this.props.t("PAGE")}` : `${this.props.t("PAGE")}  ${" "} ${curlastaddedpage}`
                                                        pdf.text(((pageLine)), (isrtlview?(width - pageMargin):pageMargin), 30, optionsR);

                                                        // //shelf and field details
                                                        pdf.setFontSize(12);
                                                        //page footer details
                                                        let bottombranchtxt = (isrtlview?((this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?(this.props.simulateSearchObj.storeName+" <"):"")+" "+(chaindetails?chaindetails.chainName:"-"))
                                                            :((chaindetails?chaindetails.chainName:"-")+" "+(this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?("> "+this.props.simulateSearchObj.storeName):"")));
                                                        pdf.text(bottombranchtxt, (isrtlview?(width - pageMargin):pageMargin), (height - 20), optionsR);

                                                        let bottomusertxt = (isrtlview?((userdetails?(userdetails.fName+" "+userdetails.lName):"-")+" | "+generatedTime+" | "+generatedDate)
                                                            :(generatedDate+" | "+generatedTime+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")))
                                                        pdf.text(bottomusertxt, (isrtlview?pageMargin:(width - pageMargin)), (height - 20), optionsL);
                                                    }
                                                // }
                                            }
                                        });
                                        lastaddedpage = curlastaddedpage;

                                        pageno = newpageno;
                                        tabledrawy = (newheadery + 20);
                                    }
                                }

                                

                                if((index + 1) < printallprods.length){
                                    pdf.addPage();
                                    tabledrawy = pageMargin;
                                }
                            }


                            // pegboard table data
                            for(let index = 0; index < this.state.CategoryWisescalePegBoardObj?.length; index++){

                                let pegBoard = this.state.CategoryWisescalePegBoardObj[index];
                                let pegBoardProducts = this.state.pegProductList.filter(product => product?.pegBoard?.id === pegBoard.id);

                                // Sort pegBoardProducts by filedWiseGroupIdText
                                pegBoardProducts = pegBoardProducts.sort((a, b) => {
                                    const groupIdA = this.getFieldWiseGroupId(a?.id) || '';
                                    const groupIdB = this.getFieldWiseGroupId(b?.id) || '';

                                    // Split by comma and get array of IDs
                                    const idsA = groupIdA.split(',').map(id => id.trim());
                                    const idsB = groupIdB.split(',').map(id => id.trim());

                                    // Compare first ID numerically, then alphabetically if not numeric
                                    const firstIdA = idsA[0];
                                    const firstIdB = idsB[0];
                                    const numA = parseInt(firstIdA);
                                    const numB = parseInt(firstIdB);

                                    if (!isNaN(numA) && !isNaN(numB)) {
                                        return numA - numB;
                                    }
                                    return groupIdA.localeCompare(groupIdB, undefined, { numeric: true, sensitivity: 'base' });
                                });

                                //auto table
                                if(pegBoard){
                                    pdf.addPage("a4", "landscape");
                                    pageno = (pageno + 1);
                                    tabledrawy = pageMargin;

                                        let prodarrobj = [];
                                        for (let j = 0; j < pegBoardProducts.length; j++) {
                                            const shelfsingleobj = pegBoardProducts[j];

                                            let prodsupname = (shelfsingleobj.productBrand && shelfsingleobj.productBrand.supplier?shelfsingleobj.productBrand.supplier.supplierName:"-");
                                            let newprodobj = [shelfsingleobj.barcode, shelfsingleobj.name, prodsupname, shelfsingleobj.qty];
                                            prodarrobj.push(newprodobj);
                                        }
                                        // Let's set up a standard padding that we can add to known coordinates
                                        const padding = 15;
                                        const xPositions = [];

                                        tabledrawy = (tabledrawy === 45 ?(tabledrawy + padding) : tabledrawy);

                                        let bottompagemargin = pageMargin * 2;
                                        if ((tabledrawy + bottompagemargin) > height) {
                                            pdf.addPage();
                                            tabledrawy = (pageMargin + padding);

                                            let newpageno = (pageno + 1);
                                            pageno = newpageno;
                                        }

                                        //headers
                                        pdf.setTextColor("#000000");
                                        pdf.setFontSize(12);

                                        pdf.text((this.props.t("PEG_BOARD")+": "+(index+1)), (isrtlview?(width - pageMargin):pageMargin), tabledrawy,optionsR);
                                        //pdf.text(((printOneField && printOneField.fieldName)?printOneField.fieldName:"-"), (isrtlview?pageMargin:(width - pageMargin)), tabledrawy, optionsL);

                                        //line
                                        pdf.setLineHeightFactor(5);
                                        pdf.line(pageMargin, (tabledrawy + 5), (width - pageMargin), (tabledrawy + 5));

                                        tabledrawy = (tabledrawy + 30);

                                        if (!lastaddedpage || lastaddedpage !== pageno) {
                                            lastaddedpage = pageno;
                                            // //page no
                                            pdf.setFontSize(11);
                                            const pageLine = isrtlview ? `${pageno} ${" "} ${this.props.t("PAGE")}` : `${this.props.t("PAGE")}  ${" "} ${pageno}`
                                            pdf.text(((pageLine)), (isrtlview?(width - pageMargin):pageMargin), 30, optionsR);

                                            // //shelf and field details
                                            pdf.setFontSize(12);
                                            //page footer details
                                            let bottombranchtxt = (isrtlview?((this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?(this.props.simulateSearchObj.storeName+" <"):"")+" "+(chaindetails?chaindetails.chainName:"-"))
                                                :((chaindetails?chaindetails.chainName:"-")+" "+(this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?("> "+this.props.simulateSearchObj.storeName):"")));
                                            pdf.text(bottombranchtxt, (isrtlview?(width - pageMargin):pageMargin), (height - 20), optionsR);

                                            let bottomusertxt = (isrtlview?((userdetails?(userdetails.fName+" "+userdetails.lName):"-")+" | "+generatedTime+" | "+generatedDate)
                                                :(generatedDate+" | "+generatedTime+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")))
                                            pdf.text(bottomusertxt, (isrtlview?pageMargin:(width - pageMargin)), (height - 20), optionsL);
                                        }

                                        //table
                                        // let headers = [
                                        //     {key: "barcode", label: this.props.t("barcode"), width: 15},
                                        //     {key: "name", label: this.props.t("PRODUCT_NAME"), width: 45},
                                        //     {key: "distributor", label: this.props.t("supname"), width: 30},
                                        //     {key: "qty", label: this.props.t("FACING"), width: 10}
                                        // ];
                                        
                                        // Filter out only fields where status is "online"
                                        let headers = [
                                            {key: "barcode", label: this.props.t("barcode"), width: 15},
                                            {key: "name", label: this.props.t("PRODUCT_NAME"), width: 45},
                                            {key: "productBrand", label: this.props.t("supname"), width: 30},
                                            {key: "qty", label: this.props.t("FACING"), width: 10}
                                        ];
                                        

                                        // Change the order of the labels
                                        // headers = headers.sort((a, b) => {
                                        //     const order = ['barcode', 'name', 'distributor', 'qty', 'maxStackableCount', 'barcodeTwo'];
                                        //     return order.indexOf(a.key) - order.indexOf(b.key);
                                        // });

                                        let headerxpos = (isrtlview?(reducetablewidth + pageMargin):pageMargin); //default start
                                        let headernewy = tabledrawy;

                                        headers.forEach((heading, index) => {

                                            pdf.setTextColor("#000000");
                                            pdf.setFontSize(10);
                                            pdf.text(heading.label, (index === 0 ?headerxpos:(isrtlview?(headerxpos - padding):(headerxpos + padding))), headernewy, optionsR);

                                            xPositions.push(index === 0?(isrtlview?(headerxpos - 3):(headerxpos + 3)):(isrtlview?(headerxpos - padding):(headerxpos + padding)));

                                            //if last one reset to 45
                                            const xPositionForCurrentHeader = (isrtlview?(headerxpos - ((reducetablewidth / 100) * heading.width)):(headerxpos + ((reducetablewidth / 100) * heading.width)));
                                            let defxpos = (isrtlview?reducetablewidth:pageMargin);
                                            headerxpos = ((index + 1) === headers.length?defxpos:xPositionForCurrentHeader);
                                        });

                                        tabledrawy = (tabledrawy + 20);

                                        // ROWS
                                        let tablerowheight = 20;
                                        let tablecellpadding = 15;

                                        let newheadery = tabledrawy;
                                        let newpageno = pageno;
                                        let curlastaddedpage = lastaddedpage;
                                        // console.log(fieldshelf,"________PDF Shelf")
                                        // console.log(this.state.mapproductList2New,"________PDF mapproductList2New")
                                        pegBoardProducts.forEach((row, rIndex) => {
                                            const rowHeights = [];
                                            const rowRectHeights = [];

                                            newheadery = (newheadery === 45 ? (newheadery + padding) : newheadery);

                                            // COLUMNS
                                            let newrowcells = [];
                                            headers.forEach((column, cIndex) => {
                                                const xPositionForCurrentHeader = (((reducetablewidth / 100) * column.width) - tablecellpadding);

                                                // const longText = ((column.key !== "barcode" && column.key !== "qty")?pdf.splitTextToSize(String(row[column.key]), xPositionForCurrentHeader):[String(row[column.key])]);
                                                let cellValue = row[column.key] !== null && row[column.key] !== undefined ? String(row[column.key]) : '';
                                                // console.log({cellValue})
                                                if (column?.key === 'maxStackableCount' && cellValue === '0') {
                                                    cellValue = '1';
                                                }
                                                if (column?.key === 'qty' && cellValue === '0') {
                                                    cellValue = '1';
                                                }

                                                if (column?.key === 'productLabel' && row[column.key] && typeof row[column.key] === 'object') {
                                                    cellValue = row[column.key].name || ''; 
                                                }

                                                if (column?.key === 'productBrand' && row[column.key] && typeof row[column.key] === 'object') {
                                                    cellValue = row[column.key]?.supplier?.supplierName || ''; 
                                                }
                                                
                                                const longText = (column.key !== "barcode" && column.key !== "qty") ? pdf.splitTextToSize(cellValue, xPositionForCurrentHeader) : [cellValue];
                                                const rowHeight = longText.length * tablerowheight;
                                                rowHeights.push(rowHeight);

                                                const rowRectHeight = (longText.length > 1 ? (longText.length * 16) : tablerowheight);
                                                rowRectHeights.push(rowRectHeight);

                                                let cellobj = { text: longText, xpos: xPositions[cIndex], ypos: newheadery};
                                                newrowcells.push(cellobj);
                                            });

                                            let nextrectrowheight = (Math.max(...rowRectHeights) > tablerowheight ? Math.max(...rowRectHeights) : tablerowheight);

                                            pdf.setFillColor(0, 0, 0, 0.05);
                                            pdf.rect(pageMargin, newheadery - 11, reducetablewidth, nextrectrowheight - 3, "F");

                                            let nextaddy = (Math.max(...rowHeights) > tablerowheight? Math.max(...rowHeights): tablerowheight);

                                            newrowcells.forEach((rowcell, rIndex) => {
                                                pdf.setTextColor("#555555");
                                                pdf.setFontSize(10);

                                                pdf.setLineHeightFactor(1.5);
                                                pdf.text(rowcell.text, rowcell.xpos, rowcell.ypos, optionsR);
                                            });

                                            let newcelly = (newheadery + nextaddy);
                                            newheadery = newcelly;

                                            let bottompagemargin = pageMargin * 2;
                                            if ((newcelly + bottompagemargin) > height && (rIndex + 1) < pegBoardProducts.length) {
                                                pdf.addPage();

                                                newheadery = (pageMargin + padding);
                                                newpageno = (newpageno + 1);

                                                //if last page add headers
                                                    if (!curlastaddedpage || curlastaddedpage !== newpageno) {
                                                        curlastaddedpage = newpageno;
                                                        // //page no
                                                        pdf.setFontSize(11);
                                                        pdf.setTextColor("#000000");
                                                        const pageLine = isrtlview ? `${curlastaddedpage} ${" "} ${this.props.t("PAGE")}` : `${this.props.t("PAGE")}  ${" "} ${curlastaddedpage}`
                                                        
                                                        pdf.text(((pageLine)), (isrtlview?(width - pageMargin):pageMargin), 30, optionsR);

                                                        // //shelf and field details
                                                        pdf.setFontSize(12);
                                                        //page footer details
                                                        let bottombranchtxt = (isrtlview?((this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?(this.props.simulateSearchObj.storeName+" <"):"")+" "+(chaindetails?chaindetails.chainName:"-"))
                                                            :((chaindetails?chaindetails.chainName:"-")+" "+(this.props.simulateSearchObj && this.props.simulateSearchObj.storeName?("> "+this.props.simulateSearchObj.storeName):"")));
                                                        pdf.text(bottombranchtxt, (isrtlview?(width - pageMargin):pageMargin), (height - 20), optionsR);

                                                        let bottomusertxt = (isrtlview?((userdetails?(userdetails.fName+" "+userdetails.lName):"-")+" | "+generatedTime+" | "+generatedDate)
                                                            :(generatedDate+" | "+generatedTime+" | "+(userdetails?(userdetails.fName+" "+userdetails.lName):"-")))
                                                        pdf.text(bottomusertxt, (isrtlview?pageMargin:(width - pageMargin)), (height - 20), optionsL);
                                                    }
                                                // }
                                            }
                                        });
                                        lastaddedpage = curlastaddedpage;

                                        pageno = newpageno;
                                        tabledrawy = (newheadery + 20);
                                    
                                }
                            }
                        }


                        //file name
                        var catname=(this.state.selectedCatRect && this.state.selectedCatRect.selectedCat && this.state.selectedCatRect.selectedCat)?getNameorIdorColorofBox(this.state.selectedCatRect.selectedCat,"name"):"";
                        var depname=cluster?.department?.importName ? cluster?.department?.importName : cluster?.department?.name;
                        var userlogged = (this.props.signedobj && this.props.signedobj.signinDetails&&this.props.signedobj.signinDetails.userDto?(this.props.signedobj.signinDetails.userDto.fName+"-"+this.props.signedobj.signinDetails.userDto.lName):"");
                        var fieldcountz=(this.props.simulateCount > 0?this.props.simulateCount:0);
                        var filename=(depname+"_"+userlogged+"_"+fieldcountz+"Fields")

                        // window.open(pdf.output('bloburl', { filename: 'new-file.pdf' }), '_blank');
                        pdf.save(replaceSpecialChars(String(filename)))
                        // Free all large data structures now that PDF is saved
                        printallprods = null; printallprodsWide = null; printallprodsLeft = null; printallprodsRight = null;
                        printallprodsWithoutMerge = null; printallprodsWithoutMergeNonHanging = null; printallprodsWithoutHanging = null;
                        // Clear jsPDF's internal image dictionary — releases compressed image buffers before GC
                        try { if (pdf.internal && pdf.internal.collections) pdf.internal.collections = {}; } catch(e) {}
                        this.setState({isPdfPrintClick:false,loadinggif2:false,loadedprodcount:0,printloading:false,PrintFullImg:null},()=>{
                            //close fullscreen
                            this.setFullscreenShow(false)
                            this.props.togglePrintPending("done", false, true);
                        })
                    }).catch((err) => {
                        console.error('[PDF-DEBUG] ERROR in htmlToImage.toPng() chain:', err);
                    });
                }).catch((err) => {
                    console.error('[PDF-DEBUG] ERROR in image onload Promise.all:', err);
                });
            })

          }).catch((err) => {
              console.error('[PDF-DEBUG] ERROR in safeToImg() Promise.all:', err);
          });
    }

    createcanvasiandexportbase64=(ctx, x, desiredWidth)=>{
        var y = 0;
        var desiredHeight = this.state.printHeight;
        var imageContentRaw = ctx.getImageData(x,y,desiredWidth,desiredHeight);
        // create new canvas
        var canvas2 = document.createElement('canvas');
        // with the correct size
        canvas2.width = desiredWidth;
        canvas2.height = desiredHeight;
        // put there raw image data
        // expected to be faster as tere are no scaling, etc
        canvas2.getContext('2d').putImageData(imageContentRaw, 0, 0);
        // get image data (encoded as bas64)
        var result = canvas2.toDataURL("image/png", 1.0)//type,size

        // Free pixel buffers before returning — canvas2 is a detached element, Chrome won't GC it promptly otherwise
        canvas2.width = 0; canvas2.height = 0;
        canvas2 = null;
        imageContentRaw = null;

        return result
    }
    handleloadedprodcount=()=>{
        this._loadedProdCountRef = (this._loadedProdCountRef || 0) + 1;
        if (this._loadedProdCountFlushTimeout) clearTimeout(this._loadedProdCountFlushTimeout);
        this._loadedProdCountFlushTimeout = setTimeout(() => {
            this.setState({ loadedprodcount: this._loadedProdCountRef });
        }, 100);
    }
    StackablemarkableToggle=(isclose)=>{
        this.setState({currentSelectedBlock:null})//unselect block if stackable turning on
        if(isclose){
            this.setState({markablestackable:false},)
        }else{
            if(this.state.markablestackable&&this.state.isStackableEdited){
                this.sendmarkStackableCall()
            }
            this.setState({markablestackable:!this.state.markablestackable,IsShowStackables:true})
        }

    }
    StackablemarkableAllToggle=()=>{
        var prodlist=this.state.mapproductList
        var stackablemarkArray=this.state.stackablemarkArray
        const toggleState = !this.state.toggleAllStackable; // Flip toggle state

        var isHaveatleastOneunstackable=prodlist.find(pr=>pr.isStackable!==true)
        //mark show products stack boolean
        for (let i = 0; i < prodlist.length; i++) {
            const prod = prodlist[i];
           if(isHaveatleastOneunstackable){
                if(!prod.isStackable){
                    prod.isStackable=true
                    let obj={
                        IsFromFE:true,
                        productId : prod.productId,
                        isStackable : prod.isStackable,
                        maxStackableCount : this.state.stackableCountofmark===""?0:parseInt(this.state.stackableCountofmark)
                    }


                    //check selected product is in stack array
                    let haveselectedproductinarrayidx=stackablemarkArray.findIndex(x=>x.productId===prod.productId)
                    // console.log(haveselectedproductinarrayidx);
                    if(haveselectedproductinarrayidx===-1){
                        stackablemarkArray.push(obj)
                    }
                }
           }else{
            if(prod.isStackable){
                prod.isStackable=false
                let obj={
                    IsFromFE:true,
                    productId : prod.productId,
                    isStackable : prod.isStackable,
                    maxStackableCount : this.state.stackableCountofmark===""?0:parseInt(this.state.stackableCountofmark)
                }


                //check selected product is in stack array
                let haveselectedproductinarrayidx=stackablemarkArray.findIndex(x=>x.productId===prod.productId)
                // console.log(haveselectedproductinarrayidx);
                if(haveselectedproductinarrayidx===-1){
                    stackablemarkArray.push(obj)
                }
            }
           }

        }

        if(this.props.simType === "AUI" || this.props.simType === "Normal"){
            // const combinedPrds = prodlist.concat(this.state.filteredOtherPrds).filter(prd=>prd.isDelete !== true)
            const combinedPrds = prodlist.filter(prd=>prd.isDelete !== true)
            this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds)
        }

        this.setState({stackablemarkArray:stackablemarkArray, /*allmarkablestackable:!this.state.allmarkablestackable*/},()=>{
            this.sendmarkStackableArray()
        })
    }
    handletypemarkStackCout=(evt)=>{
        this.setState({stackableCountofmark:evt.target.value})
    }
    arraycombinestack=(newarray)=>{
        // console.log("this.props.mpstate.mpStackableProdList---->",this.props.mpstate.mpStackableProdList)
        // var oriarray=this.props?.mpstate?.mpStackableProdList!==null?this.props.mpstate.mpStackableProdList:[]
        // var addeditems = [];
        // for (var i = 0; i < oriarray.length; i++) {
        //     for (var k = 0; k < newarray.length; k++) {
        //       if (newarray[k].productId === oriarray[i].productId) {
        //         oriarray[i].isStackable = newarray[k].isStackable;
        //         addeditems.push(oriarray[i]);
        //       }
        //     }
        // }

        // let newitems = [];
        // for (let j = 0; j < newarray.length; j++) {
        //     let findinadded = addeditems.findIndex(x => x.productId === newarray[j].productId);

        //     if(findinadded === -1){
        //         newitems.push(newarray[j]);
        //     }
        // }
        // oriarray = oriarray.concat(newitems);

        // return oriarray;
    }
    sendmarkStackableArray=()=>{
        var sobj =this.state.stackablemarkArray
        var newproduts=this.arraycombinestack(sobj)
        this.props.setMPStackableProdListArray(newproduts)

        this.setState({stackablemarkArray:[], stackableCountofmark:"",isStackableEdited:true});
    }
    sendmarkStackableCall=(type)=>{
        // if(this.props.mpstate.mpStackableProdList!==null&&this.props.mpstate.mpStackableProdList.length>0){
        //     this.setState({
        //         // loadinggif:true,loadingstackablecall:true,
        //         isStackableEdited:this.props.isFullScreenEdit?this.state.isStackableEdited:false},()=>{

        //         var prodlist=JSON.parse(JSON.stringify(this.state.mapproductList))
        //         //mark show products stack boolean
        //         for (let i = 0; i < prodlist.length; i++) {
        //             const prod = prodlist[i];
        //             var have=this.props.mpstate.mpStackableProdList.find(x=>x.productId===prod.productId)
        //             if(have){
        //                 prod.isStackable=have.isStackable
        //             }
        //         }
        //         this.setState({mapproductList:prodlist},()=>{
        //         })


        //         var sobj =this.props.mpstate.mpStackableProdList!==null?this.props.mpstate.mpStackableProdList:[]
        //         submitSets(submitCollection.bulkUpdateByProductClick, sobj, false, null, true).then(res => {
        //             if(res && res.status){
        //                 // alertService.success(res.extra===""?this.props.t("SUCCESSFULLY_UPDATED"):res.extra)
        //                 this.setState({
        //                     // loadinggif: false,loadingstackablecall:false,
        //                     markablestackable:false, stackableCountofmark:"", /*allmarkablestackable:false*/},()=>{
        //                         //put drawing here if not work

        //                 });
        //             }else{
        //                 // alertService.error(res.extra===""?this.props.t("erroroccurred"):res.extra)
        //                 // this.setState({loadinggif: false,loadingstackablecall:false})
        //             }
        //         });
        //         if(type==="back"){
        //             this.props.toggleOneCategory()
        //         }
        //     })
        // }

    }

    ToggleshowhideStack=()=>{
        this.setState({IsShowStackables:!this.state.IsShowStackables})
    }

    //edit screen in fullscreen mode
    handleFullscreenEdit=(val)=>{
        if(!val) {
            this.props.loadData(true,() => {
            this.props.getSimulatePlanogram();
         },false)
        } 
       
        if(this.state.isStackableEdited){

            if(this.props.isFullScreenEdit){
                this.props.sendmarkStackableCallParent()
            }else{
                this.sendmarkStackableCall()
            }

        }
        // if(this.props.mpstate.mpstackHistory!==null&&this.props.mpstate.mpstackHistory.past.length>0){
        //     confirmAlert({
        //         title: this.props.t('There_are_unsaved_changes'),
        //         message: (this.props.t('YOU_HAVE_UNSAVED_CHANGES_SURE_TO_LEAVE')),
        //         overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
        //         buttons: [
        //             {
        //                 label: this.props.t('btnnames.yes'),
        //                 onClick: () => {
        //                     if(val){
        //                         // this.reSetNewProdsRemoveProdstoPrevious()
        //                         this.fieldHistoryReset("switchfullSCEdit",val)
        //                     }else{

        //                         this.handleFullscreenEditMethodcall(val)
        //                         // this.props.mapobjectsdraw("firsttime");
        //                     }

        //                 }
        //             },
        //             {
        //                 label: this.props.t('btnnames.no'),
        //                 onClick: () => {
        //                     return false
        //                 }
        //             }]
        //         });
        // }else{

           this.handleFullscreenEditMethodcall(val);
        //    if(!val){
        //     this.props.mapobjectsdraw("firsttime");
        //    }
        // }

    }
    handleFullscreenEditMethodcall=(val) => {
        if(this.props.isFullScreenEdit){
            this.props.handleFullscreenEditMethodcall()
        }else{
            if(val && this.state.selectedCatRect) {
                const updatedSelectedCatRect = {
                    ...this.state.selectedCatRect,
                    non_sim_prodlist: this.state.nonfilteredNonEProducts
                };
                this.setState({
                    selectedCatRect: updatedSelectedCatRect,
                    isSetFullScreenEditModal: val
                }, () => {
                    this.props.setMpEditStackHistory(null);
                });
            } else {
                this.setState({isSetFullScreenEditModal:val},()=>{
                    this.props.setMpEditStackHistory(null);
                    // if(this.props.mpstate.mpFullscreenEditObj!==null){
                    //     var Fobj=this.props.mpstate.mpFullscreenEditObj
                    //     if(Fobj&&!val){//!val only added
                    //         this.checkAndReloadProds(Fobj.exportsaveobj, Fobj.extra,"fullscreenedit");
                    //     }
                    // }
                    this.checkAndReloadProds(this.props.simulationObj, this.props.simulationObj,"fullscreenedit");
                    //reload imported product update
                    this.compareImportedProds();
                });
            }
        }
    }

    handleSalesCycleAct = () =>{
        if(this.props.simType==="AUI" && !this.props.isNewProdSim){
            this.setState({isSalesCycle : !this.state.isSalesCycle},()=>{
                if(this.state.isSalesCycle === false && this.state.productTab === 'saleCycle'){
                    this.setState({productTab:'products', selectedScProductId: -1});
                }
                this.props.changeSaleCycleActive(this.state.isSalesCycle)
            })
        }

        if(this.props.simType==="AUI" && this.props.isNewProdSim){
            this.setState({isSCycle : !this.state.isSCycle},()=>{
                if(this.state.isSCycle === false && this.state.productTab === 'saleCycle'){
                    this.setState({productTab:'products', selectedScProductId: -1});
                }
                this.props.handleSCycle(this.state.isSCycle)
            })
        }

        if(this.props.simType==="Normal"){
            this.setState({isSCycle : !this.state.isSCycle},()=>{
                if(this.state.isSCycle === false && this.state.productTab === 'saleCycle'){
                    this.setState({productTab:'products', selectedScProductId: -1});
                }
                this.props.handleSCycle(this.state.isSCycle)
            })
        }
    }


    // haveplanoversionCreateNewAUI=()=>{
    //     this.openHaveVerAlertBox(true)
    // }
    // openHaveVerAlertBox=(val)=>{
    //     this.setState({APverAlert:val})
    // }
    // closeCNAUIclose=()=>{
    //     this.setState({APverAlert:false})
    // }

    handleResetEdit=()=>{
        confirmAlert({
            title: this.props.t('Reset_Changes'),
            message: this.props.t("this_will_reset_your_unsaved_actions_are_you_sure_to_continue"),
            overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
            buttons: [{
                label: this.props.t('btnnames.yes'),
                onClick: () => {
                    this.fieldHistoryReset()
                }
            }, {
                label: this.props.t('btnnames.no')
            }]
        });
    }
    // reSetNewProdsRemoveProdstoPrevious=()=>{
    //     if(this.props.mpstate.mpstackHistory!==null&&this.props.mpstate.mpstackHistory.past.length>0){
    //       let mpstackHistory = JSON.parse(JSON.stringify(this.props.mpstate.mpstackHistory));
    //       var clipboardArray=JSON.parse(JSON.stringify(this.props.mpstate.mpClipoardnOther))

    //       for (let i = 0; i < clipboardArray.length; i++) {
    //         const clip = clipboardArray[i];
    //         // if(clip.catId===mpstackHistory.CatId){
    //         if(clip.mp_id===mpstackHistory.mp_id){
    //           clip.removeprodlist=mpstackHistory.past[0].removeprodlist
    //           clip.addprodlist=mpstackHistory.past[0].addprodlist
    //         }
    //       }

    //       this.props.setMpClipBoardsforCats(clipboardArray)
    //     }
    //   }
    handleShowNewProducts=(val)=>{
        this.setState({isShowNewProds:val})
    }

    handleSnapshotClick = () => {
        const snapshotId = this.props.simulationObj?.simulationSnapshotId;
        if (snapshotId && snapshotId > 0) {
            confirmAlert({
                title: this.props.t('CONFIRM_DELETE'),
                overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
                message: (
                    <div>
                        <div>{this.props.t('CONFIRM_SNAPSHOT_DELETE_MESSAGE')}</div>
                        <div>{this.props.t('SnapShot')} ID: {snapshotId}</div>
                    </div>
                ),
                buttons: [
                    {
                        label: this.props.t('btnnames.yes'),
                        onClick: () => this.confirmDeleteSnapshot(snapshotId)
                    },
                    {
                        label: this.props.t('btnnames.no'),
                        onClick: () => {}
                    }
                ]
            });
        }
    }

    // confirmDeleteSnapshot = async (snapshotId) => {
    //     try {
    //         const result = await submitSets(
    //             submitCollection.deleteSnapshot,
    //             { snapshotId: snapshotId },
    //             false
    //         );

    //         if (result && result.status === true) {
    //             // Show success message
    //             alertService.success(this.props.t('SNAPSHOT_DELETED_SUCCESS_MESSAGE'));

    //             // Reload the page or navigate back to refresh the data properly
    //             // This avoids the null reference errors
    //             setTimeout(() => {
    //                 if (this.props.getSimulationcall) {
    //                     this.props.getSimulationcall();
    //                 }
    //             }, 500);
    //         }else{
    //             alertService.error(this.props.t('SNAPSHOT_DELETED_ERROR_MESSAGE'));
    //         }
    //     } catch (error) {
    //         console.error('Error deleting snapshot:', error);
    //         alertService.error(this.props.t('SNAPSHOT_DELETED_ERROR_MESSAGE'));
    //     }
    // }
    confirmDeleteSnapshot = async (snapshotId) => {
        try {
            const result = await submitSets(
                submitCollection.deleteSnapshot,
                { snapshotId: snapshotId },
                false
            );

            if (result && result.status === true) {
                // Show success message
                alertService.success(this.props.t('SNAPSHOT_DELETED_SUCCESS_MESSAGE'));

                if (this.props.loadData) {
                    await this.props.loadData();
                    
                    if (this.props.getSimulationcall) {
                        this.props.getSimulationcall(false, true);
                    }
                } else if (this.props.getSimulationcall) {
                    this.props.getSimulationcall(false, true);
                }
            } else {
                alertService.error(this.props.t('SNAPSHOT_DELETED_ERROR_MESSAGE'));
            }
        } catch (error) {
            console.error('Error deleting snapshot:', error);
            alertService.error(this.props.t('SNAPSHOT_DELETED_ERROR_MESSAGE'));
        }
    }

    //handle click aui preview apply
    auiPreviewApply = () => {
        let previewobj = this.props.selectedSimPreviewObj;

        this.setState({
            isShowStrategyModal: true,
            selectedSaveProds: (previewobj && previewobj.selectedProds && previewobj.selectedProds.length > 0?previewobj.selectedProds:[])
         }, () => {
            this.compareStrategyItems();
         });
        //this.handleSaveMP("none", true);
    }

    //compare strategy items
    compareStrategyItems = () => {
        let selecteditems = this.state.selectedSaveProds;

        let notSelectedCount = 0;
        for (let i = 0; i < selecteditems.length; i++) {
            const groupitem = selecteditems[i];

            if(!groupitem.isDelete){
                if(groupitem.type === "group"){
                    if(groupitem.isChecked && !groupitem.chainOption){
                        notSelectedCount = (notSelectedCount + 1);

                        groupitem.chainOption = "A";
                    }
                } else{
                    for (let j = 0; j < groupitem.products.length; j++) {
                        const prodobj = groupitem.products[j];

                        if(!prodobj.isDelete && prodobj.isChecked && !groupitem.chainOption){
                            notSelectedCount = (notSelectedCount + 1);

                            groupitem.chainOption = "A";
                        }
                    }
                }
            }
        }
    }

    getFieldsWithAnomaly = (products, productsWithAnomaly) => {

        // Get productIds where anomaly is high or low
        const filteredProductIds = productsWithAnomaly.filter(data => data.anomaly === 'high' || data.anomaly === 'low').map(data => data.productId);

        // Get field_custom_id values for filtered productIds
        const fieldCustomIds = [];

        products.forEach(obj => {
            if (filteredProductIds.includes(obj.productId) &&  !fieldCustomIds.includes(obj.field_custom_id)){
                fieldCustomIds.push(obj.field_custom_id);
            }
        });

        this.setState({fieldsWithAnomaly:fieldCustomIds},()=>{
            // console.log(this.state.fieldsWithAnomaly)
        })
    }

    //toggle preview new prod list
    toggleNewProdPreview = () => {
        this.setState({ isShowPreviewNewProds: !this.state.isShowPreviewNewProds });
    }

    //toggle strategy apply modal
    toggleStrategyApplyModal = () => {
        this.setState({ isShowStrategyModal: !this.state.isShowStrategyModal });
    }

    //apply strategy for all items
    chainOptionToAll = (type) => {
        //console.log(type);

        if(type !== "NONE"){
            let selecteditems = this.state.selectedSaveProds;

            for (let i = 0; i < selecteditems.length; i++) {
                const groupitem = selecteditems[i];

                if(!groupitem.isDelete && groupitem.isChecked){
                    if(groupitem.type === "group"){
                        groupitem.chainOption = type;
                    } else{
                        for (let j = 0; j < groupitem.products.length; j++) {
                            const prodobj = groupitem.products[j];

                            if(!prodobj.isDelete){
                                prodobj.chainOption = type;
                            }
                        }
                    }
                }
            }

            //console.log(selecteditems);
            this.setState({ selectedSaveProds: selecteditems });
        }
    }

    //update single item strategy
    handleChangeStrategy = (isparent, groupidx, prodidx, type) => {
        //console.log(isparent, groupidx, prodidx, type);

        let selecteditems = this.state.selectedSaveProds;

        if(isparent){
            selecteditems[groupidx].chainOption = type;
        } else{
            selecteditems[groupidx].products[prodidx].chainOption = type;
        }

        this.setState({ selectedSaveProds: selecteditems });
    }

    //continue save new prod strategy
    continueNewProdApply = () => {
        //console.log(this.state.selectedSaveProds);
        this.setState({ isShowStrategyModal: false }, () => {
            this.handleSaveMP("none", true);
        });
    }

    handleApplyModel = ()=>{
        this.setState({
            isApplyModel:false,
            responseObj:[]
        })
    }

    //toggle strategy help modal
    toggleStrategyHelpDrop = (isshow) => {
        this.setState({ isShowStrategyHelp: isshow });
    }
    //filters for non simulated products
    //get categories call
    getAllCategoriesFromDepartment=()=>{
        let defSaveObj = this.props.defSaveObj;
        var csobj={
            isReqPagination:false,
            departmentId:(defSaveObj && defSaveObj.department?(defSaveObj.department.department_id?defSaveObj.department.department_id:defSaveObj.department.id):-1),
        }
        submitSets(submitCollection.getAllCategoriesFromDepartment, csobj, true).then(res => {
            var cdata = [{value:0, label:""}];
            if(res && res.status){
                for (let i = 0; i < res.extra.length; i++) {
                    cdata.push({value:res.extra[i].id, label:res.extra[i].categoryName});
                }
                this.setState({nonsimFilter_categoryList:cdata, scFilter_categoryList:cdata})
            }else{
                alertService.error(this.props.t("ERROR_OCCURED"));
            }
        })
    }
    getbrandsforFilter=()=>{
        var csobj={
            isReqPagination:false
        }
        submitSets(submitCollection.findAllBrands, csobj, true).then(res => {
            var cdata = [{value:0, label:""}];
            if(res && res.status){
                for (let i = 0; i < res.extra.length; i++) {
                    cdata.push({value:res.extra[i].brandId, label:res.extra[i].brandName});
                }
                this.setState({nonsimFilter_brandsList:cdata, scFilter_brandsList:cdata})
            }else{
                alertService.error(this.props.t("ERROR_OCCURED"));
            }
        })
    }
    getSupplierList=()=>{
        var csobj={
            isReqPagination:false
        }
        submitSets(submitCollection.searchSuppliers, csobj, true).then(res => {
            var cdata = [{value:0, label:""}];
            if(res && res.status){
                for (let i = 0; i < res.extra.length; i++) {
                    cdata.push({value:res.extra[i].supplierId, label:res.extra[i].supplierName});
                }
                this.setState({nonsimFilter_supplierList:cdata, scFilter_supplierList:cdata})
            }else{
                alertService.error(this.props.t("ERROR_OCCURED"));
            }
        })
    }
    getSubCategoriesnonSimFilter=()=>{
        let defSaveObj = this.props.defSaveObj;
        var csobj={
            isReqPagination:false,
            depCategoryId:this.state.selectedNonSimFilterCat.value,
            departmentId:(defSaveObj && defSaveObj.department?(defSaveObj.department.department_id?defSaveObj.department.department_id:defSaveObj.department.id):-1),
        }
        submitSets(submitCollection.getSubCategories, csobj, true).then(res => {
            var cdata = [{value:0, label:""}];
            if(res && res.status){
                for (let i = 0; i < res.extra.length; i++) {
                    cdata.push({value:res.extra[i].subCategoryId, label:res.extra[i].subCategoryName});
                }
                this.setState({nonsimFilter_subcategoryList:cdata, scFilter_subcategoryList:cdata})
            }else{
                alertService.error(this.props.t("ERROR_OCCURED"));
            }
        })
    }

    toggleSCFilter=(evt,type)=>{
        if(type==="cat"){
            this.setState({selectedScFilterCat:evt,selectedScFiltersubcat:{value:"-1", label:this.props.t("NONE")}}, () => {
                this.getSubCategoriesnonSimFilter();
            });
        }
        if(type==="brand"){
            this.setState({selectedScFilterBrand:evt})
        }
        if(type==="supllier"){
            this.setState({selectedScFilterSupp:evt})
        }
        if(type==="subcat"){
            this.setState({selectedScFiltersubcat:evt})
        }

        if(type==="status"){
            this.setState({selectedScFilterStat:evt})
        }

        this.handleFilterSCProducts("",true)

    }

    togglenonSimFilter=(evt,type)=>{
        if(type==="cat"){
            this.setState({selectedNonSimFilterCat:evt,selectedNonSimFiltersubCat:{value:"-1", label:this.props.t("NONE")}}, () => {
                this.getSubCategoriesnonSimFilter();
            });
        }
        if(type==="brand"){
            this.setState({selectedNonSimFilterBrand:evt})
        }
        if(type==="supllier"){
            this.setState({selectedNonSimFilterSupp:evt})
        }
        if(type==="subcat"){
            this.setState({selectedNonSimFiltersubCat:evt})
        }

        this.handleFilterNoEProducts("",true)

    }

    cannotDropWarningHandle=()=>{
        this.setState({isProductDropwarn:!this.state.isProductDropwarn})
    }
    // handleacknowledgeSimulationWarning=(obj)=>{
    //     if(obj){
    //         confirmAlert({
    //             title: this.props.t('Sure_to_aknowladge_warnining'),
    //             message: this.props.t("this_action__will_remove_this_warning_only_for_this_snapshot"),
    //             overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
    //             buttons: [{
    //                 label: this.props.t('btnnames.yes'),
    //                 onClick: () => {
    //                     this.acknowledgeSimulationWarning(obj)
    //                 }
    //             }, {
    //                 label: this.props.t('btnnames.no'),
    //                 onClick: () => {
    //                     return false;
    //                 }}]
    //             });
    //     }else{
    //         confirmAlert({
    //             title: this.props.t('Sure_to_aknowladge_warnining'),
    //             message: this.props.t("this_action__will_remove_this_all_warning_only_for_this_snapshot"),
    //             overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
    //             buttons: [{
    //                 label: this.props.t('btnnames.yes'),
    //                 onClick: () => {
    //                     this.acknowledgeSimulationWarning(obj)
    //                 }
    //             }, {
    //                 label: this.props.t('btnnames.no'),
    //                 onClick: () => {
    //                     return false;
    //                 }}]
    //             });
    //     }


    //update ghost object
    updateGhostObjDetails = (ghostobj) => {
        let checkghostobj = (ghostobj.width > 0 && ghostobj.height > 0?ghostobj:null);
        this.setState({ ghostWrapperObj: checkghostobj });
    }

    // }
    // acknowledgeSimulationWarning=(obj)=>{
    //     let sobj = {type : obj?"PRODUCT":"ALL",
    //     productId :  obj?obj.id:-1,
    //     simulationSnapshotId: this.props.simulationObj?this.props.simulationObj.simulationSnapshotId:-1}
    //     this.setState({loadinggif:true})
    //     submitSets(submitCollection.acknowledgeSimulationWarning, sobj, false).then(res => {
    //         if(res.status){
    //             var list=obj?this.state.productEditWarningsList.filter(x=>x.id!==obj.id):[]
    //             this.setState({productEditWarningsList:list,loadinggif:false})
    //         }else{
    //             alertService.error(res.extra);
    //         }
    //         this.setState({loadinggif:false})

    //     });
    // }

    //update
    reloadProdWarnModalDetails = (isshowmodal) => {
        let citem = this.state.selectedwarningdropprod;

        this.props.toggleLoadingModal(true, () => {
            let svobj = "?productId="+citem.id;
            submitSets(submitCollection.findProdByID, svobj).then(res => {
                // console.log(res.extra);

                if(res && res.status && res.extra){
                    let prodobj = res.extra;

                    let departmentId = (this.props.defSaveObj && this.props.defSaveObj.department?((this.props.simType === "AUI")?this.props.defSaveObj.department.id:this.props.defSaveObj.department.department_id):null);
                    let departmentname = (this.props.defSaveObj && this.props.defSaveObj.department?(((this.props.simType === "AUI")?this.props.defSaveObj.department.name:this.props.defSaveObj.department.department_name)+" "+this.props.t("department")):"-");
                    // console.log(deptObj);
                    let prodwarnlist = validateHeirarchyMissings(prodobj, departmentId, departmentname);

                    let searchProdList = this.state.filteredProdList;
                    let selProdIdx = searchProdList.findIndex(x => x.id === prodobj.id);
                    // console.log(prodobj);
                    searchProdList[selProdIdx] = prodobj;

                    let importedDataObj = this.props.importedDataObj;

                    // Safety check: ensure importedDataObj exists
                    if (!importedDataObj) {
                        return;
                    }

                    let excelUploadList = importedDataObj.excelUploadList;
                    let importedProdIdx = excelUploadList.findIndex(x => x.id === prodobj.id);

                    if(importedProdIdx > -1){
                        let oldobj = structuredClone(excelUploadList[importedProdIdx]);
                        // console.log(oldobj);

                        excelUploadList[importedProdIdx] = prodobj;
                        excelUploadList[importedProdIdx].availabilityType = oldobj.availabilityType;
                    }

                    //update warning list, imported prod list and product details states
                    this.setState({
                        dropWarningList: prodwarnlist,
                        selectedwarningdropprod: prodobj,
                        filteredProdList: searchProdList,
                    }, () => {
                        this.props.updateImportedDataObj(importedDataObj);
                    });

                    //if no warnings available
                    if(prodwarnlist.length === 0){
                        this.setState({
                            dropWarningList: [], selectedwarningdropprod: null, isProductDropwarn: false,
                        });
                    } else{
                        if(isshowmodal){
                            this.setState({ isProductDropwarn: true });
                        }
                    }
                }

                this.props.toggleLoadingModal(false);
            });
        });
    }

    //
    toggleNewProdTab = (viewtab) => {
        this.setState({ newProdTab: viewtab });
    }
    //
    sendExcelData = (prodlist, totalcount, additionalIDs) => {

        if(totalcount > 0){
            let importedDataObj = this.props.importedDataObj;

            // Safety check: ensure importedDataObj exists
            if (!importedDataObj) {
                return;
            }

            importedDataObj.excelUploadList = prodlist || [];
            importedDataObj.totalExcelProdCount = totalcount || 0;
            importedDataObj.excelStartIndex = 0;
            importedDataObj.excelSearchText = "";

            let additionalIDs = (this.props.isSetFullScreenEditModal || this.props.isShowFromPreview?"-fullview":"");
            this.setState({
                productTab: "products",
                newProdTab: ("imported"+additionalIDs),
            }, () => {
                // Don't call loadImportProdList here - already have the data from the Excel upload
                // this.loadImportProdList();
                this.props.updateImportedDataObj(importedDataObj, () => {
                    this.compareImportedProds();
                });
            });
        }
    }
    //update imported scroll list
    updateImportScrollList = (scrollTop) => {
        this._importedScrollHeight = scrollTop;
    }
    //update prod list
    updateExcelSearchText = (evt, isreset, value) => {
        let importedDataObj = this.props.importedDataObj;

        // Safety check: ensure importedDataObj exists
        if (!importedDataObj) {
            return;
        }

        //if enter
        if(isreset || evt.which === 13){
            importedDataObj.excelSearchText = (isreset?"":value);
            importedDataObj.excelStartIndex = 0;

            this.props.updateImportedDataObj(importedDataObj, () => {
                this.loadImportProdList();
            });
        }
    }
    //load imported prod list
    loadImportProdList = (initail = false) => {
        this.updateImportScrollList(0);

        let importedDataObj = this.props.importedDataObj;

        // Safety check: ensure importedDataObj exists
        if (!importedDataObj) {
            return;
        }

        // Clear search text on initial load/reload
        if (initail) {
            importedDataObj.excelSearchText = "";
        }

        let mpId = (this.props.originatedMpId && this.props.originatedMpId > -1?this.props.originatedMpId:this.props.defSaveObj?this.props.defSaveObj.mp_id:-1);
        if(this.props.isShowFromPreview && this.props.selectedSimPreviewObj){
            mpId = this.props.selectedSimPreviewObj.mpId;
        }

        let sendobj = {
            searchValue: importedDataObj.excelSearchText,
            mpId: mpId,
            isReqPagination: true,
            isReqCount: false,
            maxResult: importedDataObj.paginationMaxCount,
            startIndex: initail ? 0 : importedDataObj.excelStartIndex,
            editionId: this.props.editionId,
            clusterId: this.props.selectedClusterId,
            fieldArrayId: this.props.selectFieldArrayId,
            currentBaseStatus: this.props.selectedViewTypeSimulation,
        }

        importedDataObj.isImportDataLoading = true;

        this.props.updateImportedDataObj(importedDataObj, () => {
            submitSets(submitCollection.getSimImportedProdBarcodes, sendobj, false).then(res => {
                // console.log(res);
                let mergedProds = [];
                if(res && res.status){
                    let datalist = (res.extra && res.extra.importedBarcodes && res.extra.importedBarcodes.length > 0?res.extra.importedBarcodes:[]);

                    for (let i = 0; i < datalist.length; i++) {
                        const importedProd = datalist[i];
                        importedProd.subCategoryName = importedProd.subcategoryName;
                        importedProd.subCategoryColor = importedProd.subcategoryColor;
                        importedProd.subCategoryId = importedProd.subcategoryId;
                    }
                    // console.log(datalist);
                    mergedProds = (sendobj.startIndex === 0?datalist:importedDataObj.excelUploadList.concat(datalist));

                    importedDataObj.totalExcelProdCount = (res.extra && res.extra.avaibleImportedBarcodeCount > 0 ? res.extra.avaibleImportedBarcodeCount : 0);

                    importedDataObj.excelStartIndex = datalist.length > 0
                        ? ((sendobj.startIndex === 0 ? 0 : importedDataObj.excelStartIndex) + datalist.length)
                        : importedDataObj.totalExcelProdCount;
                } else {
                    // Stop further loading on API failure
                    importedDataObj.excelStartIndex = importedDataObj.totalExcelProdCount;
                }

                importedDataObj.isImportDataLoading = false;
                this.props.updateImportedDataObj(importedDataObj, () => {
                    this.setImportedProds(mergedProds);
                });
            });
        });
    }
    //set imported prods
    setImportedProds = (datalist, isReloadProds, isFEDelete, removelist) => {
        let importedDataObj = this.props.importedDataObj;

        if(isFEDelete){
            // console.log(removeItem);
            let filteredUploadList = importedDataObj.excelUploadList;

            for (let i = 0; i < removelist.length; i++) {
                filteredUploadList = filteredUploadList.filter(x => x.barcode !== removelist[i]);
            }

            importedDataObj.excelUploadList = filteredUploadList;
            importedDataObj.excelStartIndex = ((importedDataObj.excelStartIndex - removelist.length) > -1?(importedDataObj.excelStartIndex - removelist.length):0);
            importedDataObj.totalExcelProdCount = ((importedDataObj.totalExcelProdCount - removelist.length) > -1?(importedDataObj.totalExcelProdCount - removelist.length):0);

            this.props.updateImportedDataObj(importedDataObj);
        } else{
            importedDataObj.excelUploadList = datalist;
            this.props.updateImportedDataObj(importedDataObj, () => {
                //reload imported product update
                this.compareImportedProds();
            });
        }
    }
    //compare imported prod list
    compareImportedProds = () => {
        let importedDataObj = this.props.importedDataObj;
        if(importedDataObj){
            let importedProds = importedDataObj.excelUploadList;

            for (let i = 0; i < importedProds.length; i++) {
                const importprod = importedProds[i];
                let isAdded = this.state.mapproductList.find(x => x.barcode === importprod.barcode && !x.isDelete);

                importprod.isAdded = (isAdded?true:false);
            }

            this.props.updateImportedDataObj(importedDataObj);
        }
    }
    //manage excel upload pagination details
    setExcelUploadPagination = (updateobj, _callback) => {
        this.setState({ excelUploadPagination: updateobj }, () => {
            if(_callback){
                _callback();
            }
        });
    }
    //update imported prod list
    updateImportedList = (updatedlist) => {
        let importedDataObj = this.props.importedDataObj;
        importedDataObj.excelUploadList = updatedlist;

        this.props.updateImportedDataObj(importedDataObj);
    }
    //close excel upload info
    closeExcelUploadFile = () => {
        let popoverelem = document.getElementById("productexport-examples");
        if(popoverelem && popoverelem.classList.contains("show")){
            document.getElementById("upload-info-link").click();
        }
    }

    setLableWidth=(drawwidthfield)=>{
        let retunval=0
        let maxWidth=250
        let lowWidth=25
        var percentageWidth=drawwidthfield*0.30
        if(lowWidth>percentageWidth){
            retunval=lowWidth
        }else if(maxWidth<percentageWidth){
            retunval=maxWidth
        }else{
            retunval=percentageWidth
        }
        return retunval
    }
    checkoverlapingprod=()=>{
        //console.log(this.state.mapproductList);
        var filtedlist=this.state.mapproductList.filter(x=>x.isDelete!==true)
       // Find overlapping pairs of boxes
        const overlappingPairs = this.findOverlappingPairs(filtedlist);
        // Print the overlapping pairs
        if (overlappingPairs.length > 0) {
            // console.log("Overlapping pairs:");
            overlappingPairs.forEach(pair => {
                //console.log(`Box ${pair.box1.id} x:${pair.box1.x} xend:${pair.box1.x+pair.box1.drawWidth} overlaps with Box ${pair.box2.id} x:${pair.box2.x} xend:${pair.box2.x+pair.box2.drawWidth}`);
            });
        } else {
            // console.log("No boxes overlap.");
        }
    }
    // Define a function to check if two boxes overlap
    boxesOverlap=(box1, box2)=> {
        return this.overlapOnXAxis(box1, box2) && this.overlapOnYAxis(box1, box2);
    }
    // Define a function to check if two boxes overlap along the X-axis
    overlapOnXAxis=(box1, box2) =>{
        const box1RightX = box1.x + box1.width;
        const box2RightX = box2.x + box2.width;
        return box1.x < box2RightX && box1RightX > box2.x;
    }
    // Define a function to check if two boxes overlap along the Y-axis
    overlapOnYAxis=(box1, box2)=> {
        const box1BottomY = box1.y + box1.height;
        const box2BottomY = box2.y + box2.height;
        return box1.y < box2BottomY && box1BottomY > box2.y;
    }
    // Function to check if any two boxes overlap in the array
    findOverlappingPairs=(boxes)=> {
        const overlappingPairs = [];
        for (let i = 0; i < boxes.length; i++) {
            for (let j = i + 1; j < boxes.length; j++) {
                if (this.boxesOverlap(boxes[i], boxes[j])) {
                    overlappingPairs.push({ box1: boxes[i], box2: boxes[j] });
                }
            }
        }
        return overlappingPairs;
    }

    // This function return object with validation,
    // product list width compare with perticuar shelf width
    validateShelfWidth = (mapproductList, mapFields) => {
        const shelfrankSums = {};

        mapproductList && mapproductList.length > 0 && mapproductList.forEach((product) => {
            const { shelfrank, width, field_custom_id, startingPoint, productId } = product;

            if (!mapFields[field_custom_id]) {
                //Field custom ID not found in mapFields
                return;
            }
            const sum = width;

            if (!shelfrankSums[field_custom_id]) {
                shelfrankSums[field_custom_id] = {};
            }

            if (!shelfrankSums[field_custom_id][shelfrank]) {
                shelfrankSums[field_custom_id][shelfrank] = sum;
            } else {
                shelfrankSums[field_custom_id][shelfrank] += sum;
            }
        });

        const validationResults = {};
        for (const field_custom_id in mapFields) {
            const field = mapFields[field_custom_id];
            validationResults[field_custom_id] = {};

            field.shelf.forEach((shelf) => {
                const { rank, width: shelfWidth } = shelf;
                const productWidthSum = shelfrankSums[field_custom_id]?.[rank] || 0;

                validationResults[field_custom_id][rank] = {
                    shelfWidth,
                    productWidthSum,
                    isValid: productWidthSum <= shelfWidth,
                };
            });
        }

        return validationResults;
    };
    // Validate Product with shelf width
    validateProductWidth = (mapproductList, mapFields) => {
        const invalidProducts = {};
        mapproductList && mapproductList.length > 0 && mapproductList.forEach((product) => {
            const { shelfrank, width, field_custom_id, startingPoint, id } = product;

            if (!mapFields[field_custom_id]) {
                // Field custom ID not found in mapFields
                return;
            }

            const field = mapFields[field_custom_id];
            const shelf = field.shelf.find(shelf => shelf.rank === shelfrank);

            if (shelf) {
                const shelfWidth = shelf.width;
                if (startingPoint + width > shelfWidth || startingPoint < 0) {
                    // Product does not fit within the shelf
                    invalidProducts[id] = product;
                }
            }
        });

        return invalidProducts;
    };

    //DataPanelTab handeler
    handleDataPanelTab = (setTab) =>{
        this.setState({dataPanelTab: setTab}, () => {
            // Re-evaluate if filters are active after tab change
            const { selectedBrand, selectedSubCategory, selectedCategory, is_hangable } = this.state;

            const isFilterActive = (
                (selectedBrand && selectedBrand !== 'ALL') ||
                (selectedSubCategory && selectedSubCategory !== 'ALL') ||
                (is_hangable && is_hangable !== 'all')
            );

            // Notify DataPanelTab about current filter state
            if (this.dataPanelTabFilterModeChangeRef) {
                this.dataPanelTabFilterModeChangeRef(isFilterActive);
            }
        });
    }


    loadSimSummaryData = () => {
        // console.log("defSaveObj.department.id",this.props.defSaveObj.department.id)
        let sobj = {
            // chainHasDepartmentId: (this.props.defSaveObj.department?(this.props.simType === "AUI" && this.props.defSaveObj.department?this.props.defSaveObj.department.id:this.props.defSaveObj.department.department_id):-1),
            chainHasDepartmentId: -1,
            mp_id : -1
            // mp_id : (this.props.originatedMpId ? this.props.originatedMpId > -1 ? this.props.originatedMpId : this.props.defSaveObj ? this.props.defSaveObj.mp_id : -1 : this.props.defSaveObj ? this.props.defSaveObj.mp_id : -1)
        }

        this.setState({ loadinggif: true }, () => {
            submitSets(submitCollection.loadMp, sobj, false).then(res => {
                //console.log(res);
                if(res && res.status){
                    let newsaveobj = ((res.extra && Object.keys(res.extra).length > 0)?res.extra:null);
                    this.setState({ summaryLoadObj: newsaveobj }, () => {
                        this.createSummaryObj(newsaveobj);
                    });
                } else{
                    alertService.error(this.props.t("ERROR_OCCURRED"));
                    this.setState({ loadinggif: false });
                }
            });
        });
    }
    
    createSummaryObj = (loaddata) => {
        let newSumCats = [];
        let catruleids = [];

        if (loaddata && loaddata.categories && loaddata.categories.length > 0) {
            for (let i = 0; i < loaddata.categories.length; i++) {
                const parentrect = loaddata.categories[i];
                for (let j = 0; j < parentrect.rects.length; j++) {
                    const catitem = parentrect.rects[j];
                    catitem["percentage"] = catitem.width;

                    if (catitem.type === catRectEnums.rule) {
                        catruleids.push({ level: catitem.rule.level, id: getNameorIdorColorofBox(catitem, "num") });
                    }

                    for (let k = 0; k < catitem.sub_categories.length; k++) {
                        const subcatitem = catitem.sub_categories[k];

                        let subcatper = 0;
                        let scatbrands = [];
                        for (let l = 0; l < subcatitem.rects.length; l++) {
                            const scatrect = subcatitem.rects[l];
                            subcatper += scatrect.width;

                            for (let z = 0; z < scatrect.brands.length; z++) {
                                const scrbrand = scatrect.brands[z];

                                let scrbrandper = scrbrand.rects.map(brect => brect.width).reduce((breprev, brenext) => breprev + brenext);
                                scrbrand["percentage"] = scrbrandper;

                                let isbrandadded = scatbrands.findIndex(bnditem => getNameorIdorColorofBox(bnditem, "num") === getNameorIdorColorofBox(scrbrand, "num"));
                                if (isbrandadded > -1) {
                                    scatbrands[isbrandadded].percentage += scrbrand.percentage;
                                } else {
                                    scatbrands.push(scrbrand);
                                }
                            }
                        }
                        subcatitem["brands"] = scatbrands;
                        subcatitem["percentage"] = subcatper;
                    }

                    newSumCats.push(catitem);
                }
            }
            this.setState({ summaryViewObj: newSumCats }, async() => {
                // this.getCategoryAndBrandRecPercentages(newSumCats, catruleids);
                let pegProductsToUpdate = this.state.mapproductList.filter(prod => prod?.isHanged === true);
                let pegBoardsToUpdate = this.state.pegList;
                // console.log(this.state.mapproductList,"_____PROD____")
                // console.log( this.props.actualFieldStructures,"_____PROD____1")
                // let updatedData = await this.fetchUpdatedCategoryData(this.state.mapproductList, this.props.actualFieldStructures, pegProductsToUpdate, pegBoardsToUpdate);
        
                // subcat and barnd now value fetch from fetchUpdatedCategoryData
                // console.log(updatedData,"_____PROD____22")
                
               
                // let nowPrecentageBranddata = updatedData?.brands?.map(brand => ({
                //     brand: brand?.brandName,
                //     brandId: brand?.brandId,
                //     brandNowPercentage: brand?.brandNow,
                //     brandRecPercentage: brand?.recValue,
                //     subCategoryId: brand?.subCategoryId
                // }));

                // let percentagesubCatdata = updatedData?.subCategories?.map(subCat => ({
                //     categoryId:subCat.categoryId,
                //     subCategoryWidth:subCat.subCategoryWidth,
                //     subCatRecPercentage: subCat.recValue,
                //     percentage: subCat?.subCategoryNow,
                //     subCategoryId: subCat?.subCategoryId
                // }));

                // let percentagesCatdata = updatedData?.categories?.map(cat => ({
                //     categoryId: cat.categoryId,
                //     category: cat.categoryName,
                //     categoryWidth: cat.categoryWidth,
                //     categoryNowPercentage: cat.categoryNow,
                //     categoryRecPercentage: cat.recValue
                // }))

                // let percentagesSupdata = updatedData?.suppliers?.map(sup => ({
                //     supplierId: sup.supplierId,
                //     supplierName: sup.supplierName,
                //     supplierNowPercentage: sup.supplierNow,
                //     supplierRecPercentage: sup.recValue,
                //     supplierWidth: sup.supplierWidth
                // }))
               

                this.setState({ 
                    // nowPrecentageBranddata,percentagesubCatdata, percentagesCatdata,percentagesSupdata
                 }, () => {
                            // console.log("nowPrecentageBranddata", this.state.nowPrecentageBranddata);
                            this.setInitialFilteredList();
                        });
                
            });


        } else {
            this.setState({ loadinggif: false });
        }
    }


     getCategoryAndBrandRecPercentages = async (fixdata, ruleids) => {
        let mpid = (this.props.originatedMpId ? this.props.originatedMpId > -1 ? this.props.originatedMpId : this.props.defSaveObj ? this.props.defSaveObj.mp_id : -1 : this.props.defSaveObj ? this.props.defSaveObj.mp_id : -1);

        const categoryIds = fixdata.map(item => item.category ? item.category.category_id : -1).filter(id => id !== -1);

        let svobj = {
            mpId: mpid,
            departmentId: (this.props.defSaveObj.department ? this.props.defSaveObj.department.department_id : -1),
            categoryIds: categoryIds,
        };

        this.setState({ loadinggif: true }, () => {
            submitSets(submitCollection.mpBrandSubCategoryPercentage, svobj).then(res => {
                if (res && res.status && res.extra) {
                    const categories = res.extra.categories || [];
                    const suppliers = res.extra.suppliers || [];

                    const subCatPercentages = categories.flatMap(category =>
                        (category.subCategory || []).map(subCat => ({
                            subategoryId: subCat?.subategoryId,
                            subCategoryName: subCat?.subCategoryName,
                            suggestedPercentage: subCat?.suggestedPercentage,
                            recValue: subCat?.recValue
                        }))
                    );

                    const brand = categories.flatMap(category =>
                        (category.subCategory || []).flatMap(subCat =>
                            (subCat.brand || []).map(brand => ({
                                subategoryId: subCat?.subategoryId,
                                brandId: brand?.brandId,
                                brandName: brand?.brandName,
                                suggestedPercentage: brand?.suggestedPercentage,
                                recValue: brand?.recValue
                            }))
                        )
                    );

                    const categoryPercentages = categories.map(category => ({
                        categoryId: category?.categoryId,
                        recValue: category?.recValue
                    }));

                    const supplierPercentages = suppliers.map(supplier => ({
                        supplierId: supplier?.supplierId,
                        supplierName: supplier?.supplierName,
                        recValue: supplier?.recValue
                    }));  

                    this.setState({
                        subCatRecPercentages: subCatPercentages,
                        brandPercentages: brand,
                        categoryPercentages: categoryPercentages,
                        supplierPercentages: supplierPercentages,
                        loadinggif: false
                    }, () => {
                        this.setInitialFilteredList();
                    });
                } else {
                    this.setState({ loadinggif: false });
                }
            });
        });
    }

    allDataPanelData = () => {

        // console.log("allDataPanelData1");
        setTimeout(() => {
            const mapproductList = this.state.mapproductList;
            const nonfilteredNonEProducts = this.state.nonfilteredNonEProducts;
            this.setState({ mapproductList, nonfilteredNonEProducts }, () => {
            this.setInitialFilteredList();
            this.updateNonSimProductsCount();
            //this.loadSimSummaryData();  2025 oct
        });
            // console.log("allDataPanelData", mapproductList);
            // console.log('filter_data', this.state.filteredList);
        }, 1000);

    };

    setInitialFilteredList = () => {
        const { mapproductList, nonfilteredNonEProducts, pegProductList
            // percentagesubCatdata,subCatRecPercentages,brandPercentages,nowPrecentageBranddata, percentagesCatdata, percentagesSupdata, categoryPercentages, supplierPercentages,
         } = this.state;

        // get isHangged product ids from mapproductList
        const isHangedProductBarcode = mapproductList
            .filter(product => product?.isHanged)
            .map(product => product?.barcode);

            

        // Filter out products that are not in the isHangedProductBarcode array
        const filteredNonEProducts = nonfilteredNonEProducts.filter(product => !isHangedProductBarcode.includes(product?.barcode));

        const combinedProducts = [...filteredNonEProducts, ...mapproductList , ...pegProductList];

        const normalizedDataPanelData = combinedProducts.map(this.normalizeDataPaneltData);

        // Create normalized data for only simulated products (mapproductList) for now value calculations
        const simulatedProductsNormalized = mapproductList.map(this.normalizeDataPaneltData);

        // console.log("normalizedDataPanelData", combinedProducts);
        // Count occurrences of each barcode in simulated products only
        const nameCounts = simulatedProductsNormalized
            .filter(product => !product?.isDelete)
            .reduce((acc, product) => {
                const barcode = product?.barcode || 'Unknown';
                acc[barcode] = (acc[barcode] || 0) + 1;
                return acc;
            }, {}
            );

        // Calculate total shelf width from actualFieldStructures prop
        const totalShelfWidth = this.props.actualFieldStructures ? 
            this.props.actualFieldStructures.reduce((sum, field) => {
                const fieldShelfWidth = field.mpField?.field_shelves?.reduce((shelfSum, shelf) => 
                    shelfSum + (shelf.width || 0), 0) || 0;
                return sum + fieldShelfWidth;
            }, 0) : 0;

        // Calculate total width of all simulated products (sum of all product widths * their face counts)
        const totalSimulatedProductsWidth = mapproductList.reduce((sum, product) => {
            const width = product?.width || 0;
            const faceCount = nameCounts[product?.barcode] || 1;
            const contribution = width * faceCount;
            return sum + contribution;
        }, 0);

        // Calculate category width sums - with face counts for correct category NOW calculation
        const categoryWidthSums = simulatedProductsNormalized.reduce((acc, product) => {
            const categoryId = product?.categoryId;
            if (categoryId) {
                const faceCount = nameCounts[product?.barcode] || 1;
                const contribution = (product?.width || 0) * faceCount;
                acc[categoryId] = (acc[categoryId] || 0) + contribution;
            }
            return acc;
        }, {});

        // Calculate total product width across all categories
        const subCategoryWidthSums = simulatedProductsNormalized.reduce((acc, product) => {
            const subCategoryId = product?.subCat?.subCategoryid;
            if (subCategoryId) {
                acc[subCategoryId] = (acc[subCategoryId] || 0) + (product?.width || 0);
            }
            return acc;
        }, {});

        const supplierWidthSums = simulatedProductsNormalized.reduce((acc, product) => {
            const supplierId = product?.supplier?.supplierId;
            const subCategoryId = product?.subCat?.subCategoryid;
            if (supplierId && subCategoryId) {
                const supplierKey = `${supplierId}-${subCategoryId}`;
                acc[supplierKey] = (acc[supplierKey] || 0) + (product?.width || 0);
            }
            return acc;
        }, {});

        const brandWidthSums = simulatedProductsNormalized.reduce((acc, product) => {
            const brandId = product?.brand?.brandid;
            const subCategoryId = product?.subCat?.subCategoryid;
            if (brandId && subCategoryId) {
                const brandKey = `${brandId}-${subCategoryId}`;
                acc[brandKey] = (acc[brandKey] || 0) + (product?.width || 0);
            }
            return acc;
        }, {});

        // Calculate category width sums by category for subcategory percentage calculations
        const categoryTotalWidths = simulatedProductsNormalized.reduce((acc, product) => {
            const categoryId = product?.categoryId;
            if (categoryId) {
                acc[categoryId] = (acc[categoryId] || 0) + (product?.width || 0);
            }
            return acc;
        }, {});

        // Calculate subcategory width sums by subcategory for brand percentage calculations  
        const subCategoryTotalWidths = simulatedProductsNormalized.reduce((acc, product) => {
            const subCategoryId = product?.subCat?.subCategoryid;
            if (subCategoryId) {
                acc[subCategoryId] = (acc[subCategoryId] || 0) + (product?.width || 0);
            }
            return acc;
        }, {});


        // Remove duplicates based on the barcode
        const uniqueDataPanelData = Array.from(new Map(normalizedDataPanelData.map(item => [item.barcode, item])).values());


        // Flatten the subCatRecPercentages array
        // const flattenedSubCatPercentages = subCatRecPercentages.flat();

        const updatedDataPanelData = uniqueDataPanelData.map(product => {

            //get Now value in subcat
            // const matchingSubCatNow = percentagesubCatdata?.find(subCat => subCat?.subCategoryId === product?.subCat?.subCategoryid);

            // //get Rec value in subcat
            // const matchingSubCatRec = flattenedSubCatPercentages?.find(subCat => subCat.subategoryId === product?.subCat?.subCategoryid);

            // //get Now value in brand
            // const matchingBrandNow = nowPrecentageBranddata?.find(brand => brand?.brandId === product?.brand?.brandid && brand?.subCategoryId === product?.subCat?.subCategoryid);

            // //get Rec value in brand
            // const matchingBrandCatRec = brandPercentages?.find(brand => brand.brandId === product?.brand?.brandid && brand.subategoryId === product?.subCat?.subCategoryid);

            // const matchingSupplierNow = percentagesSupdata?.find(sup => sup.supplierId === product?.supplier?.supplierId);

            // const matchingCatNow = percentagesCatdata?.find(cat => cat.categoryId === product?.categoryId);

            // //no products scenarios
            // //get Rec value in supplier
            // const matchingSupplierRec = supplierPercentages?.find(sup => sup.supplierId === product?.supplier?.supplierId);

            // //get Rec value in category
            // const matchingCatRec = categoryPercentages?.find(cat => cat.categoryId === product?.categoryId);

            // //get Rec value in brand
            // const matchingBrandRec = brandPercentages?.find(brand => brand.brandId === product?.brand?.brandid && brand.subategoryId === product?.subCat?.subCategoryid);
            
            // //get Rec value in subCategory
            // const matchingSubCategoryRec = flattenedSubCatPercentages?.find(subCat => subCat.subategoryId === product?.subCat?.subCategoryid);

            // console.log("matchingSubCat",percentagesubCatdata)
            // console.log("matchingSubCatRec",matchingSubCatRec)
            // console.log("matchingBrandCatRec",matchingBrandCatRec)
            // console.log("matchingBrandNow",matchingBrandNow)

            // Get hierarchy data for this product
            const hierarchyData = this.enrichWithAggregatedLambdaData(product);
            
            const brandKey = product?.brand?.brandid && product?.subCat?.subCategoryid ? 
                `${product?.brand?.brandid}-${product?.subCat?.subCategoryid}` : null;
            const supplierKey = product?.supplier?.supplierId && product?.subCat?.subCategoryid ? 
                `${product?.supplier?.supplierId}-${product?.subCat?.subCategoryid}` : null;

            // Check if this product is in the simulation (has a face count > 0)
            const isSimulated = nameCounts[product?.barcode] > 0;

            // Calculate percentage-based now values only for simulated products
            // Category uses face counts, others use old logic without face counts
            const categoryNowValue = isSimulated && totalSimulatedProductsWidth > 0 ?
                parseFloat(((categoryWidthSums[product?.categoryId] || 0) / totalSimulatedProductsWidth * 100).toFixed(2)) : 0;
            const subCategoryNowValue = categoryTotalWidths[product?.categoryId] > 0 ?
                parseFloat(((subCategoryWidthSums[product?.subCat?.subCategoryid] || 0) / categoryTotalWidths[product?.categoryId] * 100).toFixed(2)) : 0;
            
            const brandNowValue = brandKey && subCategoryTotalWidths[product?.subCat?.subCategoryid] > 0 ?
                parseFloat(((brandWidthSums[brandKey] || 0) / subCategoryTotalWidths[product?.subCat?.subCategoryid] * 100).toFixed(2)) : 0;

            const supplierNowValue = supplierKey && subCategoryTotalWidths[product?.subCat?.subCategoryid] > 0 ?
                parseFloat(((supplierWidthSums[supplierKey] || 0) / subCategoryTotalWidths[product?.subCat?.subCategoryid] * 100).toFixed(2)) : 0;

            // Get enriched Lambda data
            const enrichedLambdaData = this.enrichWithLambdaData(product);

            // Extract recValue from Lambda data
            const enrichedRecValue = enrichedLambdaData?.lambdaData?.recValue;
            const dataPanelRecValue = enrichedLambdaData?.dataPanelData?.recValue ?? product?.dataPanelData?.recValue;
            const rootRecValue = product?.recValue;
            const extractedRecValue = enrichedRecValue ?? dataPanelRecValue ??
                ((rootRecValue === 0 || rootRecValue === null || rootRecValue === undefined)
                    ? (product?.prePlanData?.recValue ?? product?.preplanData?.recValue ?? 0)
                    : (rootRecValue ?? product?.prePlanData?.recValue ?? product?.preplanData?.recValue ?? 0));
            const codeFallbacks = {
                departmentCode: product?.departmentCode || product?.department?.posCode || product?.department?.code || product?.departmentData?.posCode || product?.departmentData?.code || product?.prePlanData?.departmentCode || product?.preplanData?.departmentCode,
                categoryCode: product?.categoryCode || product?.category?.posCode || product?.category?.importRefCode || product?.prePlanData?.categoryCode || product?.preplanData?.categoryCode,
                subcategoryCode: product?.subcategoryCode || product?.subcategory?.posCode || product?.subcategory?.sub_category?.posCode || product?.prePlanData?.subCategoryCode || product?.preplanData?.subCategoryCode,
                brandCode: product?.brandCode || product?.brand?.brand?.posCode || product?.brand?.posCode || product?.productBrand?.posCode || product?.prePlanData?.brandCode || product?.preplanData?.brandCode,
                supplierCode: product?.supplierCode || product?.supplier?.posCode || product?.supplier?.supplierCode || product?.productBrand?.supplier?.posCode || product?.prePlanData?.supplierCode || product?.preplanData?.supplierCode
            };
            const enrichedLambdaDataWithRec = {
                ...enrichedLambdaData,
                lambdaData: {
                    ...(enrichedLambdaData?.lambdaData || {}),
                    recValue: extractedRecValue,
                    departmentCode: enrichedLambdaData?.lambdaData?.departmentCode ?? codeFallbacks.departmentCode,
                    categoryCode: enrichedLambdaData?.lambdaData?.categoryCode ?? codeFallbacks.categoryCode,
                    subcategoryCode: enrichedLambdaData?.lambdaData?.subcategoryCode ?? codeFallbacks.subcategoryCode,
                    brandCode: enrichedLambdaData?.lambdaData?.brandCode ?? codeFallbacks.brandCode,
                    supplierCode: enrichedLambdaData?.lambdaData?.supplierCode ?? codeFallbacks.supplierCode
                }
            };

            // Products with 0 facing count that were classified as 'simulated' by dedup are considered deleted
            // therefore override to 'non-simulated' so dataPanelItemCard renders the border bottom and notSimulatedReason icon
            const isDeletedSimProduct = !isSimulated && product.category === 'simulated';

            return {
                ...product,
                now: nameCounts[product?.barcode] || 0,
                ...(isDeletedSimProduct ? { category: 'non-simulated', notSimulatedReason: product.notSimulatedReason || 'none' } : {}),
                subCatNow: parseFloat((parseFloat(hierarchyData?.subCategoryDataPanelData?.actualShareCategory) || 0).toFixed(2)),
                subCatRec: parseFloat((parseFloat(hierarchyData?.subCategoryLambdaData?.allocatedShareSubcategory) || 0).toFixed(2)),
                brandNow: parseFloat((parseFloat(hierarchyData?.brandDataPanelData?.actualShareSubcategory) || 0).toFixed(2)),
                brandRec: (() => {
                    const supplierAllocatedShare = parseFloat(hierarchyData?.supplierLambdaData?.allocatedShareSupplier) || 0;
                    const brandAllocatedShare = parseFloat(hierarchyData?.brandLambdaData?.allocatedShareBrand) || 0;
                    const recValue = parseFloat(((supplierAllocatedShare / 100) * (brandAllocatedShare / 100) * 100).toFixed(2));
                    return recValue;
                })(),
                categoryNow: parseFloat((parseFloat(hierarchyData?.categoryDataPanelData?.actualSharePlanogram) || 0).toFixed(2)),
                categoryRec: parseFloat((parseFloat(hierarchyData?.categoryLambdaData?.allocatedShareCategory) || 0).toFixed(2)),
                supplierNow: parseFloat((parseFloat(hierarchyData?.supplierDataPanelData?.actualShareSubcategory) || 0).toFixed(2)),
                supplierRec: parseFloat((parseFloat(hierarchyData?.supplierLambdaData?.allocatedShareSupplier) || 0).toFixed(2)),

                // Add Lambda data matching
                ...enrichedLambdaDataWithRec,
                // Extract recValue and rec to top level from Lambda data
                recValue: extractedRecValue,
                rec: extractedRecValue, // Update rec field for UI
                // Add aggregated hierarchy data matching (selective to avoid conflicts)
                brandLambdaData: hierarchyData?.brandLambdaData || {},
                brandNormalizedLambdaData: hierarchyData?.brandNormalizedLambdaData || {},
                supplierLambdaData: hierarchyData?.supplierLambdaData || {},
                supplierNormalizedLambdaData: hierarchyData?.supplierNormalizedLambdaData || {},
                categoryLambdaData: hierarchyData?.categoryLambdaData || {},
                categoryNormalizedLambdaData: hierarchyData?.categoryNormalizedLambdaData || {},
                subCategoryLambdaData: hierarchyData?.subCategoryLambdaData || {},
                subCategoryNormalizedLambdaData: hierarchyData?.subCategoryNormalizedLambdaData || {},
            };
        });

        // update data panel with inital filtered list
        this.nonSimProddropremoveCounterupdate();
        
        // Enrich hierachy data with aggregated Lambda data
        const finalUpdatedDataPanelData = updatedDataPanelData.map(product => {
            return {
                ...product,
                // Add aggregated Lambda data for grouping
                ...this.enrichWithAggregatedLambdaData(product, updatedDataPanelData)
            };
        });

        if (!this.props.isReSimulateAfterCopyArrangement) {
            this.props.updateProdArrayBeforeCopyArrangement?.(finalUpdatedDataPanelData)
        }

        // Re-apply currently active filters so refresh preserves the user's filter selections
        const { selectedBrand, selectedSubCategory, selectedCategory, is_hangable } = this.state;
        const effectiveBrand = selectedBrand || 'ALL';
        const effectiveSubCategory = selectedSubCategory || 'ALL';

        const applyActiveFilters = (list) => {
            const hasActiveFilter = is_hangable !== 'all' || effectiveBrand !== 'ALL' || effectiveSubCategory !== 'ALL' || selectedCategory;
            if (!hasActiveFilter) return list;
            return list.filter(product => {
                if (selectedCategory === 'simulated_only' && product?.category !== 'simulated') return false;
                if (selectedCategory === 'not_simulated_only' && product?.category !== 'non-simulated') return false;
                if (effectiveBrand !== 'ALL' && product?.brand?.brandName !== effectiveBrand) return false;
                if (effectiveSubCategory !== 'ALL' && product?.subCat?.subCategoryName !== effectiveSubCategory) return false;
                if (is_hangable !== 'all' && product?.isHangable !== is_hangable) return false;
                return true;
            });
        };

        if (this.props.isReSimulateAfterCopyArrangement) {
            const update = [...finalUpdatedDataPanelData, ...this.props.prevProdDataBeforeCopyArrangement];
            const uniqueDataPanelData = Array.from(new Map(update.map(item => [item.barcode, item])).values());
            this.setState({ filteredList: applyActiveFilters(uniqueDataPanelData), originalDataPanelList: uniqueDataPanelData });
        } else {
            this.setState({ filteredList: applyActiveFilters(finalUpdatedDataPanelData), originalDataPanelList: finalUpdatedDataPanelData });
        }
    };
 


    normalizeDataPaneltData(product) {
        const isNonSimulated = product.hasOwnProperty('productName') && !product.hasOwnProperty('isSimulatedProd');
        return {
            ...product,
            brand: {
                brandName: product?.brand?.brand?.brandName || product.brandName || product.productBrand?.brandName || '',
                brandid: product?.brand?.brand?.brandId || product.brandId || product.productBrand?.brandId || '',
                brandRec:0,
                brandNow:0,
            },
            subCat:{
                subCategoryName: product?.subcategory?.sub_category?.subCategoryName || product.subCategoryName || product.subcategory?.name ||'',
                subCategoryid: product?.subcategory?.sub_category?.subCategoryId || product?.subCategoryId || product.subcategory?.id ||'',
                subCatRec:0,
                subCatNow:0,
            },
            category: {
                categoryName: product?.category?.categoryName || product?.category?.name || product.categoryName || product?.prePlanData?.categoryName || product?.preplanData?.categoryName || product?.lambdaData?.categoryName || '',
                categoryId: product?.category?.id || product.categoryId || '',
                categoryRec: 0,
                categoryNow: 0,  
            },
            supplier:{
                supplierName: product?.productBrand?.supplier?.supplierName || product?.brand?.brand?.supplier?.supplierName || product.supplierName || product?.supplier?.name || '',
                supplierId: product?.productBrand?.supplier?.supplierId || product?.brand?.brand?.supplier?.supplierId || product.supplierId || product?.supplier?.id || '',
                supplierCode: product?.productBrand?.supplier?.supplierCode || product?.brand?.brand?.supplier?.supplierCode || product.supplierCode || product?.supplier?.code || '',
                supplierRec: 0, 
                supplierNow: 0,
            },
            brandName: product?.brand?.brand?.brandName || product.brandName || product.productBrand?.brandName || '',
            brandId: product?.brand?.brand?.brandId || product.brandId || product.productBrand?.brandId || '',
            brandCode: product?.brandCode || product?.brand?.brand?.posCode || product?.brand?.posCode || product?.productBrand?.posCode || product?.prePlanData?.brandCode || product?.preplanData?.brandCode || product?.lambdaData?.brandCode || '',
            categoryId: product?.category?.id || product.categoryId || '',
            categoryName: product?.category?.categoryName || product?.category?.name || product.categoryName || product?.prePlanData?.categoryName || product?.preplanData?.categoryName || product?.lambdaData?.categoryName || '',
            categoryCode: product?.category?.posCode || product?.category?.importRefCode || product?.prePlanData?.categoryCode || product?.preplanData?.categoryCode || product?.lambdaData?.categoryCode || product?.categoryCode,
            name: product.name || product.productName || '',
            barcode: product.barcode || '',
            imageUrl: product.imageUrl || '',
            rec: product?.recValue || product?.lambdaData?.recValue || product?.prePlanData?.recValue || product?.preplanData?.recValue || 0,
            now: 0,
            uom: product?.uom || '',
            width:product?.width || '',
            height:product?.height || '',
            supplierName: product?.productBrand?.supplier?.supplierName || product?.brand?.brand?.supplier?.supplierName || product.supplierName || product?.supplier?.name || '',
            supplierId:product?.productBrand?.supplier?.supplierId || product?.brand?.brand?.supplier?.supplierId || product.supplierId || product?.supplier?.id || '',
            supplierCode: product?.productBrand?.supplier?.supplierCode || product?.brand?.brand?.supplier?.supplierCode || product.supplierCode || product?.supplier?.code || '',
            subCategoryName: product?.subcategory?.sub_category?.subCategoryName || product.subCategoryName || product.subcategory?.name ||'',
            subCategoryId: product?.subcategory?.sub_category?.subCategoryId || product?.subCategoryId || product.subcategory?.id || '',
            notSimulatedReason:product?.notSimulatedReason || '',
            isMandatoryProduct: product?.isMandatoryProduct || product?.prePlanData?.isMandatoryProduct || product?.preplanData?.isMandatoryProduct || product?.prePlanData?.mandatory || product?.preplanData?.mandatory || false,
            isNewProduct: product?.isNewProduct || product?.prePlanData?.isNewProduct || product?.preplanData?.isNewProduct || false,
            category: isNonSimulated ? 'non-simulated' : 'simulated',
            // hasPriceTagLatest: product?.product?.hasPriceTagLatest || product?.hasPriceTagLatest || product?.product?.hasPriceTag || product?.hasPriceTag,
            // priceTagGapLatest: product?.product?.priceTagGapLatest || product?.priceTagGapLatest || product?.product?.priceTagGap || product?.priceTagGap,
            // priceTagHeightLatest: product?.product?.priceTagHeightLatest || product?.priceTagHeightLatest || product?.product?.priceTagHeight || product?.priceTagHeight,
        };
    }




    // Reference to store DataPanelTab's handleFilterModeChange
    dataPanelTabFilterModeChangeRef = null;

    setDataPanelTabFilterModeChangeRef = (callback) => {
        this.dataPanelTabFilterModeChangeRef = callback;
    }

    handleBrandFilterChange = (selectedValue, type) => {

        this.setState({
            currentBrandFilter: selectedValue,
            currentFilterType: type
        });
        const newState = {};
        if (type === 'brand') {
            newState.selectedBrand = selectedValue;
        } else if (type === 'subCategory') {
            newState.selectedSubCategory = selectedValue;
        } else if (type === 'category') {
            newState.selectedCategory = selectedValue;
        }

        // Check if hierarchy filters are active (brand, subcategory, hangable)
        const isFilterActive = (
            (type === 'brand' && selectedValue && selectedValue !== 'ALL') ||
            (type === 'subCategory' && selectedValue && selectedValue !== 'ALL') ||
            (type === 'hangable' && selectedValue && selectedValue !== 'all')
        );

        // Notify DataPanelTab about filter mode change
        if (this.dataPanelTabFilterModeChangeRef) {
            this.dataPanelTabFilterModeChangeRef(isFilterActive);
        }

        this.setState(newState, () => {
            const { selectedBrand, selectedSubCategory, selectedCategory, originalDataPanelList } = this.state;

            // Treat empty string as 'ALL'
            const effectiveBrand = selectedBrand || 'ALL';
            const effectiveSubCategory = selectedSubCategory || 'ALL';

            // Check if selectedValue is "not_simulated_only" with type "category"
            if (selectedCategory === 'not_simulated_only') {
                const filteredList = originalDataPanelList.filter(product => {
                    if (effectiveBrand === 'ALL' && effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'non-simulated' && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'non-simulated';
                    } else if (effectiveBrand === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'non-simulated' && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'non-simulated' && product?.subCat?.subCategoryName === effectiveSubCategory;
                    } else if (effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'non-simulated' && product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'non-simulated' && product?.brand?.brandName === effectiveBrand;
                    } else if (effectiveBrand && effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'non-simulated' && product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'non-simulated' && product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory;
                    } else if (effectiveBrand) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'non-simulated' && product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'non-simulated' && product?.brand?.brandName === effectiveBrand;
                    } else if (effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'non-simulated' && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'non-simulated' && product?.subCat?.subCategoryName === effectiveSubCategory;
                    }
                    if(this.state.is_hangable !== 'all'){
                        return product?.category === 'non-simulated' && product?.isHangable === this.state.is_hangable;
                    }
                    return product?.category === 'non-simulated';
                });
                this.setState({ filteredList });
                return;
            }

            // Check if selectedValue is "simulated_only" with type "category"
            if (selectedCategory === 'simulated_only') {
                const filteredList = originalDataPanelList.filter(product => {
                    if (effectiveBrand === 'ALL' && effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'simulated' && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'simulated';
                    } else if (effectiveBrand === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'simulated' && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'simulated' && product?.subCat?.subCategoryName === effectiveSubCategory;
                    } else if (effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'simulated' && product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'simulated' && product?.brand?.brandName === effectiveBrand;
                    } else if (effectiveBrand && effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'simulated' && product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'simulated' && product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory;
                    } else if (effectiveBrand) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'simulated' && product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'simulated' && product?.brand?.brandName === effectiveBrand;
                    } else if (effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.category === 'simulated' && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.category === 'simulated' && product?.subCat?.subCategoryName === effectiveSubCategory;
                    }  
                    if(this.state.is_hangable !== 'all'){
                        return product?.category === 'simulated' && product?.isHangable === this.state.is_hangable;
                    }
                    return product?.category === 'simulated';
                })
                this.setState({ filteredList });
                return;
            }

            // Check if selectedCategory is "all_product"
            if (selectedCategory === 'all_product') {
                const filteredList = originalDataPanelList.filter(product => {
                    if (effectiveBrand === 'ALL' && effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return true && product?.isHangable === this.state.is_hangable; // Show all products with hangble option
                        }
                        return true;
                    } else if (effectiveBrand === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.subCat?.subCategoryName === effectiveSubCategory;
                    } else if (effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand; 
                    } else if (effectiveBrand && effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory;
                    } else if (effectiveBrand) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand;
                    } else if (effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.subCat?.subCategoryName === effectiveSubCategory;
                    }
                    if(this.state.is_hangable !== 'all'){
                        return true && product?.isHangable === this.state.is_hangable // Show all products
                    }
                    return true;
                });

                this.setState({ filteredList });
                return;
            }

            // Filter the list based on the selected value and type
            const filteredList = originalDataPanelList.filter(product => {
                if (effectiveBrand === 'ALL' && effectiveSubCategory === 'ALL') {
                    if(this.state.is_hangable !== 'all'){
                        return product?.isHangable === this.state.is_hangable; // Show all products
                    }
                    return true;
                } else if (effectiveBrand === 'ALL') {
                    if(this.state.is_hangable !== 'all'){
                        return product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                    }
                    return product?.subCat?.subCategoryName === effectiveSubCategory;
                } else if (effectiveSubCategory === 'ALL') {
                    if(this.state.is_hangable !== 'all'){
                        return product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                    }
                    return product?.brand?.brandName === effectiveBrand;
                } else if (effectiveBrand && effectiveSubCategory) {
                    if(this.state.is_hangable !== 'all'){
                        return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                    }
                    return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory;
                } else if (type === 'brand') {
                    if(this.state.is_hangable !== 'all'){
                        return effectiveBrand === 'ALL' || product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                    }
                    return effectiveBrand === 'ALL' || product?.brand?.brandName === effectiveBrand;
                } else if (type === 'subCategory') {
                    if(this.state.is_hangable !== 'all'){
                        return effectiveSubCategory === 'ALL' || product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                    }
                    return effectiveSubCategory === 'ALL' || product?.subCat?.subCategoryName === effectiveSubCategory;
                }
                return false;
            });
            // Update the state with the filtered list
            this.setState({ filteredList });
        });
    };

    /** filter hangable product & non hangable products */
    handleHangableProductChange = (value) => {

        const { originalDataPanelList, selectedBrand, selectedSubCategory, selectedCategory } = this.state;

        // Treat empty string as 'ALL'
        const effectiveBrand = selectedBrand || 'ALL';
        const effectiveSubCategory = selectedSubCategory || 'ALL';

        this.setState({
            is_hangable : value === 'all' ? 'all' : value === 'true'? true : false
        }, () => {
            // Check if selectedCategory is "all_product"
            if (selectedCategory === 'all_product') {
                const filteredList = originalDataPanelList.filter(product => {
                    if (effectiveBrand === 'ALL' && effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return product?.isHangable === this.state.is_hangable;
                        }
                        return;
                    }else if(effectiveBrand === 'ALL'){
                        if(this.state.is_hangable !== 'all'){
                            return product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.subCat?.subCategoryName === effectiveSubCategory;
                    }else if(effectiveSubCategory === 'ALL'){
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand;
                    }else if (effectiveBrand && effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory;
                    } else if (effectiveBrand) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand;
                    } else if (effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.subCat?.subCategoryName === effectiveSubCategory;
                    }

                    if(this.state.is_hangable !== 'all'){
                        return true && product?.isHangable === this.state.is_hangable // Show all products
                    }
                    return true;
                });
                this.setState({ filteredList });
            }

            // Check if selectedCategory is "simulated_only" with type "category"
            if (selectedCategory === 'simulated_only') {
                const filteredList = originalDataPanelList.filter(product => {
                    if (effectiveBrand === 'ALL' && effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return product?.isHangable === this.state.is_hangable;
                        }
                        return;
                    }else if(effectiveBrand === 'ALL'){
                        if(this.state.is_hangable !== 'all'){
                            return product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.subCat?.subCategoryName === effectiveSubCategory;
                    }else if(effectiveSubCategory === 'ALL'){
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand;
                    }else if (effectiveBrand && effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory;
                    } else if (effectiveBrand) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand;
                    } else if (effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.subCat?.subCategoryName === effectiveSubCategory;
                    }

                    if(this.state.is_hangable !== 'all'){
                        return true && product?.isHangable === this.state.is_hangable // Show all products
                    }
                    return true;
                });
                this.setState({ filteredList });
            }

            // Check if selectedCategory is "not_simulated_only" with type "category"
            if (selectedCategory === 'not_simulated_only') {
                const filteredList = originalDataPanelList.filter(product => {
                    if (effectiveBrand === 'ALL' && effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return product?.isHangable === this.state.is_hangable;
                        }
                        return;
                    }else if(effectiveBrand === 'ALL'){
                        if(this.state.is_hangable !== 'all'){
                            return product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.subCat?.subCategoryName === effectiveSubCategory;
                    }else if(effectiveSubCategory === 'ALL'){
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand;
                    }else if (effectiveBrand && effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory;
                    } else if (effectiveBrand) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand;
                    } else if (effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.subCat?.subCategoryName === effectiveSubCategory;
                    }

                    if(this.state.is_hangable !== 'all'){
                        return true && product?.isHangable === this.state.is_hangable // Show all products
                    }
                    return true;
                });
                this.setState({ filteredList });
            }

            // Check if effectiveBrand is "" with type "category"
            if(effectiveBrand !== ''){
                const filteredList = originalDataPanelList.filter(product => {
                    if (effectiveBrand === 'ALL' && effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return true && product?.isHangable === this.state.is_hangable; // Show all products
                        }
                        return true;
                    } else if (effectiveBrand === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return true && product?.isHangable === this.state.is_hangable;
                        }
                        return true
                    } else if (effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return true && product?.isHangable === this.state.is_hangable;
                        }
                        return true;
                    } else if (effectiveBrand && effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory;
                    }
                    // } else if (type === 'brand') {
                    //     console.log('effectiveBrand_', effectiveBrand);
                    //     if(this.state.is_hangable !== 'all'){
                    //         return effectiveBrand === 'ALL' || product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                    //     }
                    //     return effectiveBrand === 'ALL' || product?.brand?.brandName === effectiveBrand;
                    // } else if (type === 'subCategory') {
                    //     if(this.state.is_hangable !== 'all'){
                    //         return effectiveSubCategory === 'ALL' || product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                    //     }
                    //     return effectiveSubCategory === 'ALL' || product?.subCat?.subCategoryName === effectiveSubCategory;
                    // }
                    return false;
                });
                // Update the state with the filtered list
                this.setState({ filteredList });
            }

            // Check if effectiveBrand is "" with type "category"
            if(effectiveSubCategory !== ''){
                const filteredList = originalDataPanelList.filter(product => {
                    if (effectiveBrand === 'ALL' && effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return true && product?.isHangable === this.state.is_hangable; // Show all products
                        }
                        return true;
                    } else if (effectiveBrand === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return true && product?.isHangable === this.state.is_hangable;
                        }
                        return true
                    } else if (effectiveSubCategory === 'ALL') {
                        if(this.state.is_hangable !== 'all'){
                            return true && product?.isHangable === this.state.is_hangable;
                        }
                        return true;
                    } else if (effectiveBrand && effectiveSubCategory) {
                        if(this.state.is_hangable !== 'all'){
                            return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                        }
                        return product?.brand?.brandName === effectiveBrand && product?.subCat?.subCategoryName === effectiveSubCategory;
                    }
                    // } else if (type === 'brand') {
                    //     console.log('effectiveBrand_', effectiveBrand);
                    //     if(this.state.is_hangable !== 'all'){
                    //         return effectiveBrand === 'ALL' || product?.brand?.brandName === effectiveBrand && product?.isHangable === this.state.is_hangable;
                    //     }
                    //     return effectiveBrand === 'ALL' || product?.brand?.brandName === effectiveBrand;
                    // } else if (type === 'subCategory') {
                    //     if(this.state.is_hangable !== 'all'){
                    //         return effectiveSubCategory === 'ALL' || product?.subCat?.subCategoryName === effectiveSubCategory && product?.isHangable === this.state.is_hangable;
                    //     }
                    //     return effectiveSubCategory === 'ALL' || product?.subCat?.subCategoryName === effectiveSubCategory;
                    // }
                    return false;
                });
                // Update the state with the filtered list
                this.setState({ filteredList });
            }

            //Check if all other filter is empty
            if(selectedCategory === ''){

                const filteredList = originalDataPanelList.filter(product => {

                    if(value === 'true'){
                        return product?.isHangable === true;
                    }
                    if(value === 'false'){
                        return product?.isHangable === false;
                    }
                    if(value === 'all'){
                        return product;
                    }

                });

                this.setState({ filteredList });
            }

        })

    }

    /*--- set initial level of grouping ---
      field wise
      shelfrank wise
      barcode wise
      nearst product wise */

    groupByProduct = () => {

        const { mapproductList, mapFields, actualFieldStructures, actualFieldsCounts } = this.state;

        // filter for getting non deleted products...
        let newMapProductList = mapproductList.filter(x => !x.isDelete);

        let checkSafetyMargin = 3;
        
        // Sort products by `shelfrank`, `barcode`, and `x` position
        const sortedProducts = [...newMapProductList].sort((a, b) => {
            if (a.shelfrank !== b.shelfrank) {
                return a.shelfrank - b.shelfrank;
            }
            // temporary leaving this commented out due to prod grouping breaking on first load after arrange
            // NOTE: need to check shelf height and draw height to this sorting
            // if (a.masterFieldId !== b.masterFieldId) {
            //     return a.masterFieldId - b.masterFieldId;
            // }
            if (a.barcode !== b.barcode) {
                return a.barcode.localeCompare(b.barcode);
            }
            return a.x - b.x;
        });
    
        let currentGroupId = 1;
    
        // Iterate through sorted products and assign group IDs
        for (let i = 0; i < sortedProducts.length; i++) {
            const product = sortedProducts[i];
            const otherProductList = sortedProducts.filter(x => x.id !== product.id);


            if (i === 0) {
                var containElem = elmAccordingtoXY(product.x,product.y,product.drawWidth,product.drawHeight,this.state.mapFields,this.state.mapCatRects);
                let updatedCustomId = this.findCustomFieldIdByX(this.state.mapFields, product.x);
                // Assign the first product to the initial group
                product.groupId = currentGroupId;
                product.field_custom_id = updatedCustomId ? updatedCustomId : product.field_custom_id;
                product.categoryRectId = containElem ? containElem?.catrect?.catrectId : product.categoryRectId;
                // Actual Field Data
                let fieldInfo = this.getProductFieldInfo(actualFieldStructures, product);
                product.actualFieldInfo = fieldInfo;
                // product overlap check
                let isOverlap = multipleProductOverlapChecking(product, otherProductList, this.state.saftyMargin);
                if (isOverlap) {
                    product.isOverlap = true;
                }else{
                    product.isOverlap = false;
                }
                continue;
            }
    
            const previousProd = sortedProducts[i - 1];
            const currentProdStartX = roundOffDecimal(product.x, 2);
            const previousProdEndX = roundOffDecimal(previousProd.x + previousProd.drawWidth, 2);
    
            // Check if the current product matches the previous product's group conditions
            // Allow cross-field grouping if products are adjacent (distance <= 1)
            const fieldMatch = product.masterFieldId === previousProd.masterFieldId;
            const trulyAdjacent = (currentProdStartX - previousProdEndX) <= 1;

            const isSameGroup =
                product.shelfrank === previousProd.shelfrank &&
                product.barcode === previousProd.barcode &&
                (fieldMatch || trulyAdjacent) &&
                currentProdStartX - previousProdEndX <= checkSafetyMargin;
    
            // if product is hanged add new group id
            if (!isSameGroup || product?.isHanged) {
                currentGroupId++; // Start a new group if the conditions are not met
            }
    
            let updatedCustomId = this.findCustomFieldIdByX(this.state.mapFields, product.x);
            var containElem = elmAccordingtoXY(product.x,product.y,product.drawWidth,product.drawHeight,this.state.mapFields,this.state.mapCatRects)

            product.groupId = currentGroupId; // Assign groupId to the current product
            product.field_custom_id = updatedCustomId ? updatedCustomId : product.field_custom_id;
            product.categoryRectId = containElem ? containElem?.catrect?.catrectId : product.categoryRectId;
            // Actual Field Data
            let fieldInfo = this.getProductFieldInfo(actualFieldStructures, product);
            product.actualFieldInfo = fieldInfo;
            // product overlap check
            let isOverlap = multipleProductOverlapChecking(product, otherProductList, this.state.saftyMargin);
            if (isOverlap) {
                product.isOverlap = true;
            }else{
                product.isOverlap = false;
            }
        }
        // find the updated product id list
        let updatedProductIds = sortedProducts.map(product => product.id);

        // filter the rest of the products from mapproductList
        let restProducts = mapproductList.filter(product => !updatedProductIds.includes(product.id));

        // merge the rest of the products with the updated products
        let mergedProducts = [...sortedProducts, ...restProducts];
        
        this.setState({
            mapproductList: mergedProducts,
        },()=>{
            // Issue happend when call this function each time
            // add this call function before the priting
            // this.updateFieldWIseGroupId(mergedProducts);

            // update the actural field sturacture free spacing
            this.updateActualFieldListSpacing();

            // call groupByProduct2 if it was requested to be called after groupByProduct completes
            if (this._callGroupByProduct2After) {
                this._callGroupByProduct2After = false;
                this.groupByProduct2();
            }
        });
    };

    // field locator finding function
    getProductFieldInfo = (actualFieldStructures, product) => {
        const { x, y, drawWidth, drawHeight } = product;
        // console.log("product",product)
        let productX = x;
        let productY = y;
        let productWidth = drawWidth;
        let productHeight = drawHeight;

        const results = [];
    
        for (const field of actualFieldStructures) {
          const fieldLeft = field.x;
          const fieldRight = field.x + field.drawWidth;
          const fieldTop = field.y;
          const fieldBottom = field.y + field.drawHeight;
    
          const productRight = productX + productWidth;
          const productBottom = productY + productHeight;
    
          const isInsideX = productX >= fieldLeft && productRight <= fieldRight;
          const isInsideY = productY >= fieldTop && productBottom <= fieldBottom;
    
          // Fully inside the field
          if (isInsideX && isInsideY) {
            return [{ actualFieldId: field?.actualFieldId }];
          }
    
          // Partially intersecting horizontally
          const intersectLeft = Math.max(productX, fieldLeft);
          const intersectRight = Math.min(productRight, fieldRight);
          const intersectWidth = intersectRight - intersectLeft;
    
          const isOverlappingY =
            productY < fieldBottom && productBottom > fieldTop;
    
          if (intersectWidth > 0 && isOverlappingY) {
            results.push({
              actualFieldId: field.actualFieldId,
              availableWidth: roundOffDecimal(intersectWidth,2),
            });
          }
        }
    
        if (results.length > 0) {
          return results;
        }
    
        // Not inside or overlapping any field
        return null;
    };


    // Field wise grouping id instet
    updateFieldWIseGroupId = (prods, isPrintingArray=false) => {
        // Deep clone to avoid mutating original
        let productList = structuredClone(prods);
        let updatedList = productList;

        // Sort by shelf rank and x coordinate
        updatedList = updatedList.sort((a, b) => {
            if (a.shelfrank !== b.shelfrank) {
                return a.shelfrank - b.shelfrank;
            }
                return a.x - b.x;
        });
    
        // Clear existing fieldWiseGroupInfo
        for (const product of updatedList) {
            product.fieldWiseGroupInfo = [];
        }
    
        // Collect all unique actualFieldIds
        const allFieldIds = new Set();
        for (const product of updatedList) {
            for (const info of product.actualFieldInfo || []) {
                allFieldIds.add(info.actualFieldId);
            }
        }
    
        let currentGroupId = 1;
        let currentPegGroupId = 1;
    
        for (const fieldId of [...allFieldIds]) {
            // Filter and sort
            const filtered = updatedList
                .filter(product =>
                    (product.actualFieldInfo || []).some(info => info.actualFieldId === fieldId)
                );

            const pegProducts = filtered.filter(p => p.pegBoardIndex != null);
            const regularProducts = filtered.filter(p => p.pegBoardIndex == null);

            const sortedPeg = pegProducts.sort((a, b) => {
                const aY = a.y;
                const bY = b.y;
                if (aY !== bY) return aY - bY;
                const aX = a.x;
                const bX = b.x;
                return aX - bX;
            });

            const sortedRegular = regularProducts.sort((a, b) => {
                if (a.shelfrank !== b.shelfrank) return a.shelfrank - b.shelfrank;
                return a.x - b.x;
            });

            const sortedFiltered = [...sortedPeg, ...sortedRegular];
    
            let groupIdMap = new Map(); // to track already assigned groupIds for regular products
    
            for (const product of sortedFiltered) {
                const productGroupId = product.groupId;
    
                if (product.pegBoardIndex != null) {
                    // For peg products, assign sequential IDs based on sorted order
                product.fieldWiseGroupInfo.push({
                    actualFieldId: fieldId,
                        fieldWiseGroupId: currentPegGroupId
                    });
                    currentPegGroupId++;
                } else {
                    // For regular products
                    if (groupIdMap.has(productGroupId)) {
                        product.fieldWiseGroupInfo.push({
                            actualFieldId: fieldId,
                            fieldWiseGroupId: groupIdMap.get(productGroupId)
                        });
                    } else {
                        groupIdMap.set(productGroupId, currentGroupId);
                        product.fieldWiseGroupInfo.push({
                            actualFieldId: fieldId,
                            fieldWiseGroupId: currentGroupId
                });
                        currentGroupId++;
                    }
                }
            }
        }
    
        if(isPrintingArray){
            this.setState({
                mapproductList2New: updatedList,
            });
        }else{
            this.setState({
                mapproductList: updatedList,
            });
        }
    };

    // Return the fieldWiseGroupInfo when pass the product id
//     getFieldWiseGroupId = (productId, useProductId = false) => {
//         const { mapproductList, mapproductList2New } = this.state;

//         // First try to find in mapproductList
//         let product = mapproductList.find(item =>
//             useProductId ? item.productId === productId : item.id === productId
//         );

//         // If not found and useProductId is true, try mapproductList2New
//         if (!product && useProductId && mapproductList2New) {
//             const productList2Array = Object.values(mapproductList2New);
//             product = productList2Array.find(item => item.productId === productId);
//         }
// console.log("getFieldWiseGroupId_product",product)
//         if (product && product.fieldWiseGroupInfo) {
//             // Check if it's the same product or product set using productId
//             // Extract unique fieldWiseGroupIds, sort them, and join as string to ensure uniqueness
//             const uniqueIds = [...new Set(product.fieldWiseGroupInfo.map(info => info.fieldWiseGroupId))].sort((a, b) => a - b);
//             const fieldWiseGroupText = uniqueIds.join(' , ');
//             return fieldWiseGroupText;
//         }
//         return null;
//     };

    getFieldWiseGroupId = (productId, useProductId = false, fieldId = null) => {
        const { mapproductList, mapproductList2New } = this.state;

        // First try to find in mapproductList
        let product = mapproductList.find(item =>
            useProductId ? item.productId === productId : item.id === productId
        );

        // If not found and useProductId is true, try mapproductList2New
        if (!product && useProductId && mapproductList2New) {
            const productList2Array = Object.values(mapproductList2New);
            product = productList2Array.find(item => item.productId === productId);
        }
        
        if (product && product.fieldWiseGroupInfo) {
            // If fieldId is provided, filter by that specific field
            let relevantGroupInfo = product.fieldWiseGroupInfo;
            
            // if (fieldId !== null && fieldId !== undefined) {
            //     console.log('Working on this');
                
            //     // Filter to only get the fieldWiseGroupId for the specific field
            //     relevantGroupInfo = product.fieldWiseGroupInfo.filter(
            //         info => info.actualFieldId === fieldId
            //     );                
            // }
            
            // If no matching field found, return null
            if (relevantGroupInfo.length === 0) {
                return null;
            }
            
            // Extract unique fieldWiseGroupIds, sort them, and join as string
            const uniqueIds = [...new Set(relevantGroupInfo.map(info => info.fieldWiseGroupId))]
                .sort((a, b) => a - b);
            const fieldWiseGroupText = uniqueIds.join(' , ');
            // console.log('fieldWiseGroupText1', fieldWiseGroupText    );
            
            
            return fieldWiseGroupText;
        }
        
        return null;
    };

    // Update actual field list spacing vale
    // each product has actural field info
    // i need to calculate the shelft width - all product width of that shelf rank
    updateActualFieldListSpacing = () => {
        const { mapproductList, mapFields } = this.state;
        
        let productList = structuredClone(mapproductList);
        // filter for getting non deleted products...
        productList = productList.filter(x => !x.isDelete);
         // Create a map to hold total used width per shelf rank in each actualField
        const spacingMap = {};

        productList.length > 0 && productList.forEach(product => {
            const { drawWidth, shelfrank, actualFieldInfo } = product;
            // if products is hannged true, don't consider it
            if (product?.isHanged) return;

            if (!Array.isArray(actualFieldInfo) || shelfrank == null) return;

            // If only one field — allocate all drawWidth to that field
            if (actualFieldInfo.length === 1) {
                const fieldId = actualFieldInfo[0].actualFieldId;
                const key = `${fieldId}-${shelfrank}`;
                if (!spacingMap[key]) spacingMap[key] = 0;
                spacingMap[key] += drawWidth;
            } else {
                // Distribute drawWidth based on availableWidth ratio
                const totalAvailable = actualFieldInfo.reduce((sum, obj) => sum + (obj.availableWidth || 0), 0);
                actualFieldInfo.forEach(({ actualFieldId, availableWidth }) => {
                    const key = `${actualFieldId}-${shelfrank}`;
                    if (!spacingMap[key]) spacingMap[key] = 0;
                    const weight = totalAvailable > 0 ? availableWidth / totalAvailable : 0;
                    spacingMap[key] += drawWidth * weight;
                });
            }
        });
        
        // NEW CODE - 2025 NOV
        for (const key in mapFields) {
            const field = mapFields[key];

            field.shelf = field.shelf.map((shelf) => {
                const spacingKey = `${field.actualFieldId}-${shelf.rank}`;
                const usedWidth = spacingMap[spacingKey] || 0;

                const availableFreeSpacing = Math.max(
                0,
                field.drawWidth / this.state.displayRatio -
                    usedWidth / this.state.displayRatio
                );

                return {
                ...shelf,
                availableFreeSpacing: parseFloat(availableFreeSpacing.toFixed(2)),
                };
            });
        }

        // OLD CODE - 2025 NOV
        // Clone actualFieldStructures with updated spacing
        // const updatedFieldList = Object.keys(mapFields).map((key) => {
        //     const field = mapFields[key];
        //     const updatedShelves = field.shelf.map(shelf => {
        //         const key = `${field.actualFieldId}-${shelf.rank}`;
        //         const usedWidth = spacingMap[key] || 0;
        //         const availableFreeSpacing = Math.max(0, field.drawWidth  / this.state.displayRatio - usedWidth  / this.state.displayRatio);

        //         return {
        //             ...shelf,
        //             availableFreeSpacing: parseFloat(availableFreeSpacing.toFixed(2))
        //         };
        //     });

        //     return {
        //         ...key,
        //         shelf: updatedShelves,
        //     };
        // });
        
        //this.setState({ mapFields : updatedFieldList});

        // OLD CODE
        
        // Clone actualFieldStructures with updated spacing
        // const updatedActualFeidlStucature = actualFieldStructures.map(field => {
        //     const updatedShelves = field.field_shelves.map(shelf => {
        //         const key = `${field.actualFieldId}-${shelf.rank}`;
        //         const usedWidth = spacingMap[key] || 0;
        //         const availableFreeSpacing = Math.max(0, field.drawWidth  / this.state.displayRatio - usedWidth  / this.state.displayRatio);
        //         return {
        //             ...shelf,
        //             availableFreeSpacing: parseFloat(availableFreeSpacing.toFixed(2))
        //         };
        //     });

        //     return {
        //         ...field,
        //         field_shelves: updatedShelves
        //     };
        // });

        // this.setState({ actualFieldStructures : updatedActualFeidlStucature});
    };

    // Get the free space by actualFieldId and shelf rank
    getFreeSpaceByFieldIdAndRank = (fieldId, rank) => {

        //NEW CODE - 2025 NOV

        const { mapFields } = this.state;

        const actualField = Object.values(mapFields).find(
            (item) => item?.actualFieldId === fieldId
        );
                    
        if (actualField) {
            const shelf = actualField.shelf.find(shelf => shelf.rank === rank);
            let editedValue = shelf?.availableFreeSpacing;
            if (editedValue) {
                // devide by ration
                editedValue = roundOffDecimal(editedValue,2);
            }
            if (shelf) {
                // Simulating asynchronous behavior
                return `${editedValue} ${shelf.uom}`;
               //return `${editedValue} ${actualField.uom}`;
            }
        }

        return '0'; // Default value if not found

        // OLD CODE

        //const { actualFieldStructures } = this.state;
        
        //const field = actualFieldStructures.find(field => field.actualFieldId === fieldId);
    
        // if (field) {
        //     const shelf = field.field_shelves.find(shelf => shelf.rank === rank);
        //     let editedValue = shelf.availableFreeSpacing;
        //     if (editedValue) {
        //         // devide by ration
        //         editedValue = roundOffDecimal(editedValue,2);
        //     }
        //     if (shelf) {
        //         // Simulating asynchronous behavior
        //         // return `${editedValue} ${shelf.uom}`;
        //         return `${editedValue} cm`;
        //     }
        // }
    
        //return '0'; // Default value if not found
    };


    groupByProduct2 = async () => {

        const { mapproductList2New, mapproductList2, mapFields,mapproductList3forPdf } = this.state;

        // filter for getting non deleted products...
        let newMapProductList = mapproductList2.filter(x => !x.isDelete);

        let checkSafetyMargin = 3;
    
        // Sort products by `shelfrank`, `barcode`, and `x` position
        const sortedProducts = [...newMapProductList].sort((a, b) => {
            if (a.shelfrank !== b.shelfrank) { 
                return a.shelfrank - b.shelfrank;
            }
            if (a.x !== b.x) {
                return a.x - b.x;
            }
            // if (a.masterFieldId !== b.masterFieldId) {
            //     console.log("SORT 3 - Master Field ID");
            //     return a.masterFieldId - b.masterFieldId;
            // }
            // if (a.barcode !== b.barcode) {
            //     console.log("SORT 4 - Barcode");
            //     return a.barcode.localeCompare(b.barcode);
            // }
            return 0;
        });

        // Create a copy for mapproductList3forPdf without group separation
        const pdfProducts = sortedProducts.map(product => ({ ...product }));
    
        
        let currentGroupId = 1;
        let groupProducts = [];

    
        // Iterate through sorted products and assign group IDs
        for (let i = 0; i < sortedProducts.length; i++) {
            const product = sortedProducts[i];
            const pdfProduct = pdfProducts[i];

            if (i === 0) {
                var containElem = elmAccordingtoXY(product.x,product.y,product.drawWidth,product.drawHeight,this.state.mapFields,this.state.mapCatRects);
                let updatedCustomId = this.findCustomFieldIdByX(this.state.mapFields, product.x);
                // Assign the first product to the initial group
                product.groupId = currentGroupId;
                pdfProduct.groupId = currentGroupId;
                product.field_custom_id = updatedCustomId ? updatedCustomId : product.field_custom_id;
                product.categoryRectId = containElem ? containElem?.catrect?.catrectId : product.categoryRectId;

                pdfProduct.field_custom_id = updatedCustomId ? updatedCustomId : pdfProduct.field_custom_id;
                pdfProduct.categoryRectId = containElem ? containElem?.catrect?.catrectId : pdfProduct.categoryRectId;

                groupProducts.push(product);
                continue;
            }
    
            const previousProd = sortedProducts[i - 1];
            const currentProdStartX = roundOffDecimal(product.x, 2);
            const previousProdEndX = roundOffDecimal(previousProd.x + previousProd.drawWidth, 2);
            
            
            // Check if the current product matches the previous product's group conditions
            // Allow cross-field grouping if products are adjacent (distance <= 1)
            const fieldMatch = product.masterFieldId === previousProd.masterFieldId;
            const trulyAdjacent = (currentProdStartX - previousProdEndX) <= 1;

            const isSameGroup =
                product.shelfrank === previousProd.shelfrank &&
                product.barcode === previousProd.barcode &&
                (fieldMatch || trulyAdjacent) &&
                currentProdStartX - previousProdEndX <= checkSafetyMargin;
    
                if (!isSameGroup) {
                    await this.applyCustomGroupLogic(groupProducts, currentGroupId);
                    currentGroupId++; // Start a new group if the conditions are not met
                    groupProducts = [];
                }
            
            // if product is hanged add new group id
            // if (!isSameGroup || product?.isHanged) {
            //     currentGroupId++; // Start a new group if the conditions are not met
            // }    

            let updatedCustomId = this.findCustomFieldIdByX(this.state.mapFields, product.x);
            var containElem = elmAccordingtoXY(product.x,product.y,product.drawWidth,product.drawHeight,this.state.mapFields,this.state.mapCatRects)

            product.groupId = currentGroupId; // Assign groupId to the current product
            pdfProduct.groupId = currentGroupId;
            product.field_custom_id = updatedCustomId ? updatedCustomId : product.field_custom_id;
            product.categoryRectId = containElem ? containElem?.catrect?.catrectId : product.categoryRectId;

            pdfProduct.field_custom_id = updatedCustomId ? updatedCustomId : pdfProduct.field_custom_id;
            pdfProduct.categoryRectId = containElem ? containElem?.catrect?.catrectId : pdfProduct.categoryRectId;
        
            groupProducts.push(product);
            
        }

        this.applyCustomGroupLogic(groupProducts, currentGroupId);
        // find the updated product id list
        let updatedProductIds = sortedProducts.map(product => product.id);
        let pdfProductIds = pdfProducts.map(product => product.id);

        // filter the rest of the products from mapproductList
        let restProducts = mapproductList2.filter(product => !updatedProductIds.includes(product.id));
        let restProductsForPdf = mapproductList2.filter(product => !pdfProductIds.includes(product.id));
        // merge the rest of the products with the updated products
        let mergedProducts = [...sortedProducts, ...restProducts];
        let mergedProductsForPdf = [...pdfProducts, ...restProductsForPdf];

        const updatedFullscreenObjs = this.state.fullscreenobjs ? {
            ...this.state.fullscreenobjs,
            products: mergedProducts
        } : null;

        this.setState({
            mapproductList2New: mergedProducts,
            mapproductList3forPdf: mergedProductsForPdf,
            fullscreenobjs: updatedFullscreenObjs
        });
        return mergedProductsForPdf;
    };


    applyCustomGroupLogic = async (groupProducts, groupId) => {
        // console.log("groupId",groupId)
        // console.log("groupProducts",groupProducts)
        if (groupProducts.length > 1) {
            let middleIndex = Math.floor(groupProducts.length / 2);
            groupProducts.forEach((product, index) => {
                // product.groupId =groupId;
                product.groupId = index === middleIndex ? groupId : product?.isHanged ? groupId : null;
                //product.isEvenGroup = groupProducts.length % 2 === 0;
                // Manage productLabel show it only on the middle product
                if (product.productLabel && product.productLabel.shortText) {
                    if (index !== middleIndex) {
                        // Clear shortText for non-middle products
                        product.productLabel.shortText = '';
                    }
                    
                }
            });
        }
    };

    // This function will return specific product in which filed, 
    findCustomFieldIdByX = (mapFields, xValue) => {
        // Convert mapFields object to an array and sort by x coordinate
        const sortedFields = Object.values(mapFields).sort((a, b) => a.x - b.x);
        
        // Iterate through the sorted fields and check if xValue falls within any field's range
        for (const field of sortedFields) {
            const fieldEndX = field.x + field.drawWidth;
            
            if (xValue >= field.x && xValue < fieldEndX) {
                return field.field_custom_id; // Return the field_custom_id of the matched field
            }
        }
        
        return null;
    }

    validateProductHeight = (product) => {
        const { mapFields, displayUOM } = this.state;

        if (!mapFields) return false;
        // PLAN-783 - Fixed this bug
        const field = mapFields[product.field_custom_id];
        if (!field) return false;

        for (let shelf of field.shelf) {
            if (shelf.rank === product.shelfrank) {
                const maxProductCount = Math.floor(measureConverter(shelf.uom, displayUOM, shelf.height) / measureConverter(product.uom, displayUOM, product.height));
                if (product.stackCount >= maxProductCount) {
                    return maxProductCount - 1;
                } else {
                    return product.stackCount;
                }
            }
        }
        return false;
    };


    validateProductFieldHeight = (product) => {
        const { mapFields, displayUOM } = this.state;

        if (!mapFields) return false;
        // PLAN-783 - Fixed this bug
        const field = mapFields[product.field_custom_id];
        if (!field) return false;

        for (let shelf of field.shelf) {
            if (shelf.rank === product.shelfrank) {
                const maxProductCount = Math.floor(measureConverter(shelf.uom, displayUOM, shelf.height) / measureConverter(product.uom, displayUOM, product.height));
                return maxProductCount;
            }
        }
        return false;
    };

    handleExpandNumberInput = (expandNumber) => {
        const { contxtmenu, mapproductList, currentInternalDraggableProd, currentSelectedBlock, mapFields } = this.state;

        this.setState({isviewcmenu:false})

        if (!contxtmenu || !currentInternalDraggableProd) return;

        let currentlySelectedProd = mapproductList[currentInternalDraggableProd.prodidx];
        if (!currentlySelectedProd) return;

        let selectedField = mapFields[currentlySelectedProd?.field_custom_id];
        if(!selectedField) return;

        let cshelf = selectedField.shelf.find(x => x.rank === currentlySelectedProd.shelfrank);
        if(!cshelf) return;

        // Determine similar level shelves excluding `cshelf`
        let leftSideShelves  = null;
        let rightSideShelves = null;
        let selectedShelf    = cshelf;
        //const targetY = roundOffDecimal(cshelf.y + cshelf.height, 2); // Reference y position of the current shelf
        /*Object.keys(mapFields).forEach((fieldId) => {
            const field = mapFields[fieldId];
            field.shelf.forEach((shelf) => {
                if (roundOffDecimal((shelf.y + shelf.height),2)  === targetY && shelf.field_custom_id === cshelf.field_custom_id) {
                    if (shelf.x < cshelf.x) {
                        // Shelf on the left side
                        leftSideShelves = shelf;
                    } else if (shelf.x > cshelf.x) {
                        // Shelf on the right side
                        rightSideShelves = shelf;
                    }
                    selectedShelf = shelf;
                }
            });
        });*/

        let newProd = {
            ...currentlySelectedProd,
            id: uuidv4(),
            isNew: true,
            x: currentlySelectedProd.x,
            y: currentlySelectedProd.y
        };

        this.multiplyProductToDropZoneNewDirection(cshelf, newProd, currentlySelectedProd, expandNumber, leftSideShelves, rightSideShelves, selectedShelf);

    }


    handleExpandStackInput = (expandNumber) => {
        const { contxtmenu, mapproductList, currentInternalDraggableProd, currentSelectedBlock, mapFields, pegList } = this.state;

        this.setState({isviewcmenu:false})

        if (!contxtmenu || !currentInternalDraggableProd) return;

        let currentlySelectedProd = mapproductList[currentInternalDraggableProd.prodidx];
        if (!currentlySelectedProd) return;

        let selectedField = mapFields[currentlySelectedProd?.field_custom_id];
        if(!selectedField) return;

        let cshelf = selectedField.shelf.find(x => x.rank === currentlySelectedProd.shelfrank);
        if(!cshelf) return;
        
        let leftSideShelves  = null;
        let rightSideShelves = null;
        let selectedShelf    = cshelf;

        const maxHeigth = this.validateProductFieldHeight(currentlySelectedProd);

        const stackOverlapPegboards = this.stackProductOverlapCheckWithPegBoard(pegList, currentSelectedBlock, expandNumber);

        if(stackOverlapPegboards){
            alertService.error(this?.props?.t('PRODUCT_STACK_OVERLAP_PEGBOARD'), 4000);
            return
        }

        //when stack layer updating 

        if(expandNumber < maxHeigth){
            let newProductList = mapproductList.map((product) => {
                if (product.groupId === currentlySelectedProd.groupId ) {
                    return {
                        ...product,
                        stackCount: expandNumber
                    };
    
                }
                return product;
            });

            let newProd = {
                ...currentlySelectedProd,
                id: uuidv4(),
                isNew: true,
                x: currentlySelectedProd.x,
                y: currentlySelectedProd.y
            }
            this.multiplyProductToDropZoneStacking(cshelf, newProd, currentlySelectedProd , true);
            this.setState({ mapproductList: newProductList});
            this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)),1);
        }else{
            alertService.error(this?.props?.t('NO_SPACE_AVALIBLE'),4000);
            return
            
        }

        
    }


    multiplyProductToDropZoneNewDirection = (shelf, addingProduct, changeProduct, count = 1, leftSideShelves, rightSideShelves, selectedShelf, direction = "right") => {

        const { currentSelectedBlock, mapFields } = this.state;

        let selectedLeftSideProduct = addingProduct;
        let selectedRightSideProduct = addingProduct;
        let selectedProduct = addingProduct;
        let cProdList = structuredClone(this.state.mapproductList);
        let isruleupdating = false;
        
        // Calculate the count of selected products belonging to the specified group
        const selectedProductsCount = currentSelectedBlock?.drawingProducts?.filter(
            (prod) => prod?.groupId === addingProduct?.groupId
        )?.length || 0;

        //var  filterddraggingProductshelfs = currentSelectedBlock?.selectedshelves?.filter(q=>q.isDelete!==true)

        if(count > selectedProductsCount){
            count = count - selectedProductsCount;

            // get similer shelf from selected shelf y+drawheight
            let similarLevelShelves = this.getSimilarLevelShelves(selectedShelf, mapFields);

            let productList = JSON.parse(JSON.stringify(this.state.mapproductList));

            // assume only 1 shelf product dragged
            let draggingProductSet = currentSelectedBlock; //draggingProductSet?.shelf[0]?.products;

            let exisitingProductList = this.getSelectedProducts(productList, similarLevelShelves, draggingProductSet?.drawingProducts, true);
            // get exiting product total width
            let totalProductWidth = 0;
            exisitingProductList.forEach(product => {
                totalProductWidth += product?.drawWidth;
            });
                    
            // get total width of selected shelf
            let totalShelfWidth = 0;
            similarLevelShelves.forEach(shelf => {
                totalShelfWidth += shelf?.drawWidth;
            });
            
            let currentRestSpace = (totalShelfWidth - totalProductWidth);

            //let movingProductBlockWidth = draggingProductSet?.drawWidth;
            // for (let i = 0; i < draggingProductSet?.drawingProducts.length; i++) {
            //     movingProductBlockWidth += draggingProductSet?.drawingProducts[i].drawWidth;
            // }

            let toBeExapndTotalProductWidth = 0;
            for (let i = 0; i < count; i++) {
                toBeExapndTotalProductWidth += selectedProduct?.drawWidth;
            }

            let droppedFiledCustomId      = selectedShelf?.field_custom_id;
            let droppedFieldMasterFieldId = mapFields[droppedFiledCustomId]?.masterFieldId;

            const roundedRestSpace = Number(currentRestSpace.toFixed(2));
            const roundedMovingProductBlockWidth = Number(toBeExapndTotalProductWidth.toFixed(2));
            
            const isAllowToDrop = (roundedRestSpace >= roundedMovingProductBlockWidth);
            if(!isAllowToDrop){
                alertService.error(this?.props?.t('NO_SPACE_AVALIBLE_FOR_DROPPED_PRODUCT_SET'),4000);
                this.setPreviewGuid(true, null, null, true, []);
                clearTimeout(this._guideTimeout); 
                return
            }

            let canExpandproductList = [];

            let existingGroupLastProduct = draggingProductSet?.drawingProducts[draggingProductSet?.drawingProducts.length - 1];
            
            for(let i = 0; i < count; i++){

                let newX = roundOffDecimal(existingGroupLastProduct?.x + (i + 1) * existingGroupLastProduct?.drawWidth, 2);
                let newY = roundOffDecimal(existingGroupLastProduct?.y, 2);

                let newProd = {
                    ...addingProduct,
                    id: uuidv4(),
                    isNew: true,
                    x: newX,
                    y: newY
                };

                canExpandproductList.push(newProd);
            }

            let notDeletedProds = [...currentSelectedBlock?.drawingProducts, ...canExpandproductList];

            let isOutSideOfShelf = this.checkProductOverlapWithShelf(similarLevelShelves, notDeletedProds);

            if(isOutSideOfShelf){
                alertService.error(this.props.t('OUTSIDE_OF_THE_FIELD'),4000);
                this.setPreviewGuid(true, null, null, true, []);
                clearTimeout(this._guideTimeout); 
                //this.setState({ currentSelectedBlock: null}); // 2025 - 07 - 31 New Update 
                return;
            }

            // 2025-07-31 - EXPAND PRODUCTION BUG - START
            // PEG CR - 2025 March
            // check if any product cross the peg board
            
            const {isPegBoardOverlap} = this.productOverlapCheckerWithPegBoard(this.state.pegList, notDeletedProds); 

            if(isPegBoardOverlap){ 
                alertService.error(this.props.t('PEG_BOARD_OVERLAP'),4000);
                this.setPreviewGuid(false, null, null, true);
                this.setState({selectBlockObj:null, isPegBoardOverlapping:true});
                return;
            }

            // 2025-07-31 - EXPAND PRODUCTION BUG - END

            //calculate total width 
            let totalGroupWidth = 0;
            notDeletedProds.forEach(product => {
               totalGroupWidth += product?.drawWidth;
            });

            currentSelectedBlock.drawingProducts = notDeletedProds;

            currentSelectedBlock.newDrawingProducts = notDeletedProds;

            currentSelectedBlock.selectedshelves[0].selectedProducts = notDeletedProds;

            currentSelectedBlock.drawWidth = totalGroupWidth;

            // check if neadding products is inside of the shelf
            // let isOutSideOfShelf = this.checkProductOverlapWithShelf(similarLevelShelves, notDeletedProds); // OLD CODE BEFORE 2025-07-31

            // if(isOutSideOfShelf){
            //     alertService.error(this.props.t('OUTSIDE_OF_THE_FIELD'),4000);
            //     this.setState({ currentSelectedBlock: null}); // 2025 - 07 - 31
            //     return;
            // }
           
            //Rearrange existing groups
            this.fieldHistoryAdd(structuredClone(this.state.mapproductList),1);

            let reArrangeProducts = JSON.parse(JSON.stringify(this.state.mapproductList));

            const {needToReArrange, updatedProducts} = this.filterInlineShelfProductSet(selectedProduct?.x, selectedProduct?.y, similarLevelShelves, reArrangeProducts, currentSelectedBlock.drawingProducts, currentSelectedBlock, this.state.checkSaftyMargin, droppedFiledCustomId, droppedFieldMasterFieldId, true, true);
            if(needToReArrange){
                const updatingProductIds = new Set(updatedProducts.map(product => product.id));

                const filteredUpdatedProducts = reArrangeProducts.filter(
                    product => !updatingProductIds.has(product.id)
                ); 
                
                reArrangeProducts = [...filteredUpdatedProducts, ...updatedProducts];
            }else{
                // console.log("reArrangeProducts",reArrangeProducts)
                // console.log("reArrangeProducts",currentSelectedBlock.drawingProducts)
                // remove the currentSelectedBlock.drawingProducts ids from reArrangeProducts
                const updatingProductIds = new Set(currentSelectedBlock.drawingProducts.map(product => product.id));
                const filteredUpdatedProducts = reArrangeProducts.filter(
                    product => !updatingProductIds.has(product.id)
                );
                // add the currentSelectedBlock.drawingProducts ids to reArrangeProducts
                reArrangeProducts = [...filteredUpdatedProducts, ...currentSelectedBlock.drawingProducts];
            }

            // 2025-07-31 - EXPAND PRODUCTION BUG START
            // PEG CR - 2025 March -  
            // check if any product cross the peg board
            // const {isPegBoardOverlap} = this.productOverlapCheckerWithPegBoard(this.state.pegList, reArrangeProducts)
            // if(isPegBoardOverlap){
            //     console.log('isPegBoardOverlap___>', isPegBoardOverlap);
            //     alertService.error(this.props.t('PEG_BOARD_OVERLAP'),4000);
            //     this.setPreviewGuid(false, null, null, true);
            //     this.setState({selectBlockObj:null, isPegBoardOverlapping:true, currentSelectedBlock: null});
            //     this.setState({currentSelectedBlock: null}, () => {
            //         console.log('currentSelectedBlock-->', this.state.currentSelectedBlock);
            //     })
            //     return;
            // }
             // 2025-07-31 - EXPAND PRODUCTION BUG - END
            
            this.updateProductList(reArrangeProducts, isruleupdating);

            this.updateActualFieldListSpacing();

            this.setState({selectBlockObj:null})

            //OLD EXPAND CODE
            // if(this.state.isGroupExpand){
            //     if(this.state.groupExpandLeftSideProduct){
            //         selectedLeftSideProduct = this.state.groupExpandLeftSideProduct;
            //     }
            //     if(this.state.groupExpandRightSideProduct){
            //         selectedRightSideProduct = this.state.groupExpandRightSideProduct;
            //     }
            // }

            // if (shelf && addingProduct) {
            //     // var cprodlist = JSON.parse(JSON.stringify(this.state.mapproductList));
            //     var cprodlist = this.state.mapproductList;
        
            //     let allAllowToAdd = true;
            //     let placementDirection = direction;
            //     let failedIndex = -1;
        
            //     // Try placing all products on the right first using `shelf`
            //     for (let i = 0; i < count; i++) {
            //         let xa1 = roundOffDecimal(selectedRightSideProduct.x + (i + 1) * selectedRightSideProduct.drawWidth, 2);
            //         let ya1 = roundOffDecimal(selectedRightSideProduct.y, 2);

            //         // last product x position add with draw width
            //         if(i === count - 1 && xa1 + selectedRightSideProduct.drawWidth >= shelf.x + shelf.drawWidth){
            //             xa1 = xa1 + selectedRightSideProduct.drawWidth;
            //         }

            //         const allowToAdd = checkAllowToAddForExpandNumber(null, shelf, selectedRightSideProduct, xa1, ya1, this.state.checkSaftyMargin);

            //         if (allowToAdd.allowToAdd) {
            //             const checkx1 = roundOffDecimal((xa1 + this.state.checkSaftyMargin), 2);
            //             const boxx2 = roundOffDecimal((xa1 + selectedRightSideProduct.drawWidth - this.state.checkSaftyMargin), 2);
            //             const boxy2 = roundOffDecimal((ya1 + selectedRightSideProduct.drawHeight), 2);

            //             const findsameShelfItems = cprodlist.filter(z => !z.isDelete && z.shelfrank === shelf.rank);
            //             const fieldobj = this.state.mapFields[selectedRightSideProduct.field_custom_id];
            //             const containProds = GetContainingProdsByBox(checkx1, ya1, boxx2, boxy2, findsameShelfItems, fieldobj);

            //             if (containProds.selectedProds && containProds.selectedProds.length > 0) {
            //                 allAllowToAdd = false;
            //                 failedIndex = i;
            //                 break;
            //             }
            //         } else {
            //             allAllowToAdd = false;
            //             failedIndex = i;
            //             break;
            //         }
            //     }
            //     // Retry using `rightSideShelves` if right side fails partially
            //     if (!allAllowToAdd && placementDirection === "right" && failedIndex !== -1 && rightSideShelves) {
                    
            //         for (let i = failedIndex; i <= count; i++) {
            //             let xa1 = roundOffDecimal(selectedRightSideProduct.x + ((i + 1) * selectedRightSideProduct.drawWidth), 2);
            //             let ya1 = roundOffDecimal(selectedRightSideProduct.y, 2);

            //             const allowToAdd = checkAllowToAddForExpandNumber(null, rightSideShelves, selectedRightSideProduct, xa1, ya1, this.state.checkSaftyMargin);
            //             if (allowToAdd.allowToAdd) {
            //                 const checkx1 = roundOffDecimal((xa1 + this.state.checkSaftyMargin), 2);
            //                 const boxx2 = roundOffDecimal((xa1 + selectedRightSideProduct.drawWidth - this.state.checkSaftyMargin), 2);
            //                 const boxy2 = roundOffDecimal((ya1 + selectedRightSideProduct.drawHeight), 2);
            
            //                 const findsameShelfItems = cprodlist.filter(z => !z.isDelete && z.shelfrank === shelf.rank);
            //                 const fieldobj = this.state.mapFields[selectedRightSideProduct.field_custom_id];
            //                 const containProds = GetContainingProdsByBox(checkx1, ya1, boxx2, boxy2, findsameShelfItems, fieldobj);
            
            //                 if (containProds.selectedProds && containProds.selectedProds.length > 0) {
            //                     allAllowToAdd = false;
            //                     break;
            //                 }

            //                 allAllowToAdd = true;
            //             } else {
            //                 allAllowToAdd = false;
            //                 break;
            //             }
            //         }
            //     }
            //     // If right side fails completely, try placing all products on the left using `shelf`
            //     if (!allAllowToAdd) {
            //         allAllowToAdd = true;
            //         placementDirection = "left";
            //         failedIndex = -1;

            //         for (let i = 0; i < count; i++) {
            //             let xa1 = roundOffDecimal(selectedLeftSideProduct.x - (i + 1) * selectedLeftSideProduct.drawWidth, 2);
            //             let ya1 = roundOffDecimal(selectedLeftSideProduct.y, 2);

            //             if (xa1 <= 0) {
            //                 allAllowToAdd = false;
            //                 failedIndex = i;
            //                 break;
            //             }

            //             const allowToAdd = checkAllowToAddForExpandNumber(null, shelf, selectedLeftSideProduct, xa1, ya1, this.state.checkSaftyMargin);
            //             // console.log("LEFT--------> allowToAdd", allowToAdd);

            //             if (allowToAdd.allowToAdd) {
            //                 const checkx1 = roundOffDecimal((xa1 + this.state.checkSaftyMargin), 2);
            //                 const boxx2 = roundOffDecimal((xa1 + selectedLeftSideProduct.drawWidth - this.state.checkSaftyMargin), 2);
            //                 const boxy2 = roundOffDecimal((ya1 + selectedLeftSideProduct.drawHeight), 2);

            //                 const findsameShelfItems = cprodlist.filter(z => !z.isDelete && z.shelfrank === shelf.rank);
            //                 const fieldobj = this.state.mapFields[selectedLeftSideProduct.field_custom_id];
            //                 const containProds = GetContainingProdsByBox(checkx1, ya1, boxx2, boxy2, findsameShelfItems, fieldobj);
            //                 // console.log("LEFT--------> containProds", containProds);

            //                 if (containProds.selectedProds && containProds.selectedProds.length > 0) {
            //                     allAllowToAdd = false;
            //                     failedIndex = i;
            //                     break;
            //                 }
            //             } else {
            //                 allAllowToAdd = false;
            //                 failedIndex = i;
            //                 break;
            //             }
            //         }

            //         // Retry using `leftSideShelves` if left side fails partially
            //         if (!allAllowToAdd && failedIndex !== -1 && leftSideShelves) {
            //             for (let i = failedIndex; i < count; i++) {
            //                 let xa1 = roundOffDecimal(selectedLeftSideProduct.x - (i + 1) * selectedLeftSideProduct.drawWidth, 2);
            //                 let ya1 = roundOffDecimal(selectedLeftSideProduct.y, 2);

            //                 if (xa1 <= 0) {
            //                     allAllowToAdd = false;
            //                     break;
            //                 }

            //                 const allowToAdd = checkAllowToAddForExpandNumber(null, leftSideShelves, selectedLeftSideProduct, xa1, ya1, this.state.checkSaftyMargin);
            //                 // console.log(" LEFT RETRY --------> allowToAdd", allowToAdd);

            //                 if (allowToAdd.allowToAdd) {
            //                     const checkx1 = roundOffDecimal((xa1 + this.state.checkSaftyMargin), 2);
            //                     const boxx2 = roundOffDecimal((xa1 + selectedLeftSideProduct.drawWidth - this.state.checkSaftyMargin), 2);
            //                     const boxy2 = roundOffDecimal((ya1 + selectedLeftSideProduct.drawHeight), 2);
        
            //                     const findsameShelfItems = cprodlist.filter(z => !z.isDelete && z.shelfrank === leftSideShelves.rank);
            //                     const fieldobj = this.state.mapFields[selectedLeftSideProduct.field_custom_id];
            //                     const containProds = GetContainingProdsByBox(checkx1, ya1, boxx2, boxy2, findsameShelfItems, fieldobj);
            //                     // console.log("LEFT RETRY --------> containProds", containProds);
        
            //                     if (containProds.selectedProds && containProds.selectedProds.length > 0) {
            //                         allAllowToAdd = false;
            //                         break;
            //                     }
        
            //                     allAllowToAdd = true;
            //                 } else {
            //                     allAllowToAdd = false;
            //                     break;
            //                 }
            //             }
            //         }
            //     }
                
            //     // If both directions fail, return error
            //     if (!allAllowToAdd) {
            //         alertService.error(this.props.t("CANNOT_EXPAND_PROD_ANOTHER_EXIST"));
            //         this.setState({
            //             isGroupExpand: false,
            //             groupExpandLeftSideProduct: null,
            //             groupExpandRightSideProduct: null,
            //         });
            //         return;
            //     }
        
            //     // Add history for the new state
            //     this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)), 1);
        
            //     // Add products in the determined direction
            //     for (let i = 0; i < count; i++) {
            //         let xa1 = placementDirection === "left"
            //             ? roundOffDecimal(selectedLeftSideProduct.x - (i + 1) * selectedLeftSideProduct.drawWidth, 2)
            //             : roundOffDecimal(selectedRightSideProduct.x + (i + 1) * selectedRightSideProduct.drawWidth, 2);
            //         let ya1 = roundOffDecimal(selectedProduct.y, 2);
        
            //         // Clone and update product properties
            //         const newProduct = {
            //             ...selectedProduct,
            //             id: uuidv4(),
            //             x: xa1,
            //             y: ya1,
            //             isNew: true
            //         };
        
            //         cprodlist.push(newProduct);
            //     }

            //     this.setState({ 
            //         mapproductList: cprodlist,
            //         currentSelectedBlock: null,
            //         currentInternalDraggableProd: null,
            //         currentSelectedBlock: null,
            //     }, () => {
            //         // Update UI elements and counters
            //         this.nonSimProddropremoveCounterupdate("DropfromClipboard");
            //         this.TouchedCatListUpdate(selectedProduct.categoryRectId);
        
            //         if (this.props.simType === "AUI" || this.props.simType === "Normal") {
            //             const combinedPrds = this.state.mapproductList.filter(prd => !prd.isDelete !== true);
            //             this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds);
            //         }
        
            //         // Rule handling
            //         if (selectedProduct.subcategory && selectedProduct.type === catRectEnums.rule) {
            //             const updaterulelist = getAllRuleWarnings(
            //                 this.state.mapCatRects,
            //                 this.state.mapRulesList,
            //                 this.state.mapproductList,
            //                 false,
            //                 true
            //             );
        
            //             this.setState({
            //                 mapRulesList: updaterulelist.rulelist,
            //                 isRuleWarn: updaterulelist.iswarn,
            //                 isGroupExpand: false,
            //                 groupExpandLeftSideProduct: null,
            //                 groupExpandRightSideProduct: null,
            //             });
            //         }
            //         // update group id
            //         this.groupByProduct();
        
            //         // Reload imported product update
            //         this.compareImportedProds();
            //         this.props.handlehaveChnagesinCat(true);
                    
            //     });
            // }
        }else if(count < selectedProductsCount){
            this.handleExpandNegativeNumberInput(count);
            return;
        }else{
            alertService.error(this.props.t("EXISTING_COUNT_IS_SAME_WITH_ENTERED_VALUE"));
            return;
        }
    }
    
    handleExpandNegativeNumberInput = (expandNumber) => {
        const { contxtmenu, currentInternalDraggableProd, currentSelectedBlock } = this.state;
        this.setState({ isviewcmenu: false });
        var cprodlist = this.state.mapproductList;
    
        if (!contxtmenu || !currentInternalDraggableProd) return;
    
        let selectedProducts = currentSelectedBlock?.drawingProducts;
        if (!selectedProducts || selectedProducts.length === 0) return;
    
        // Ensure expandNumber is positive for calculation
        let removeCount = Math.abs(expandNumber);
        
        // Validation: If removeCount exceeds the selected products length, return
        if (removeCount > selectedProducts.length) {
            alertService.error(this.props.t("CANNOT_REMOVE_MORE_PRODUCTS_THAN_AVALIABLE"));
            return;
        }

        //update removeCount
        removeCount = selectedProducts.length - removeCount;

        // Add history for the new state
        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)), 1);
        // Get the last `removeCount` products from selectedProducts
        const productsToRemove = selectedProducts.slice(-removeCount);
    
        // Extract the IDs of products to remove
        const productIdsToRemove = productsToRemove.map(product => product.id);

        // Update mapproductList: Set `isDelete` to true for matching product IDs
        cprodlist = cprodlist.map(product => {
            if (productIdsToRemove.includes(product.id)) {
                return { ...product, isDelete: true };
            }
            return product;
        });

        // Update the state with the new product list
        this.setState({ 
            mapproductList: cprodlist,
            currentSelectedBlock: null,
            currentInternalDraggableProd: null,
            currentSelectedBlock: null,
        }, () => {

            // Update UI elements and counters
            this.nonSimProddropremoveCounterupdate("DropfromClipboard");
            var cmenu = this.state.contxtmenu;
            var cMapProdList = JSON.parse(JSON.stringify(this.state.mapproductList))
    
            let plocobj = cMapProdList[cmenu.prodidx];
            //toched cat list added
            this.TouchedCatListUpdate(plocobj.categoryRectId)

            if (this.props.simType === "AUI" || this.props.simType === "Normal") {
                const combinedPrds = this.state.mapproductList.filter(prd => !prd.isDelete !== true);
                this.props.getProductAnomalies(this.props.mapFields, this.props.mapCategories, combinedPrds);
            }

            // Rule handling
            // const updaterulelist = getAllRuleWarnings(
            //     this.state.mapCatRects,
            //     this.state.mapRulesList,
            //     this.state.mapproductList,
            //     false,
            //     true
            // );

            this.setState({
                // mapRulesList: updaterulelist.rulelist,
                // isRuleWarn: updaterulelist.iswarn,
                isGroupExpand: false,
                groupExpandLeftSideProduct: null,
                groupExpandRightSideProduct: null,
            });

            // update group id
            this.groupByProduct();

            // Reload imported product update
            this.compareImportedProds();
            this.props.handlehaveChnagesinCat(true);
        });
    };

    resetSelectBlockObj = () => {
        this.setState({
            removeGhost:false,
        })
    }

    resetSelectBlockObjData = () => {
        this.setState({
            removeGhost:false,
            currentSelectedRecBlock:{},
            currentSelectedBlock:null,
            currentInternalDraggableProd: null,
            currentDraggableProd:null,
            ghostWrapperObj: null,
        })
    }

    // PEG CR - 2025 March
    //add new peg board settings
    handleAddPeg = () => {

        const {pegList} = this.state;
        this.setState((prevState) => ({
            pegList: [...prevState.pegList, {
                pegId:pegList.length + 1, // temporary added
                pegBoardIndex:uuidv4(),
                name : pegList.length + 1,
                //width: 0,
                //height: 0,
                gapW: 20,
                gapH: 20,
                pegLength: 20,
                isPegDrawing:true,
                holeUOM:'cm',
                savePegBoard:false,
                pegCoordinations:[],
                isPegBoardSaving:true,
                pegBoardStatus:PEG_BOARD_ADD
            }]
        }), () => {
            this.setState({
                isPegDrawing: true,
                isshowdash:false,
                isPegDrawingShowdash:true,
                enableNextPegBoardSetting:false,
                cursorChangeToPeg:true,
                currentSelectedRecBlock:{},
                currentSelectedBlock:null,
            });
        });
    }

    // PEG CR - 2025 March
    //add new peg holes
    handleAddPegHoles = (pegID, inputStates) => {

        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)), 2);

        const {pegList, displayUOM, displayRatio} = this.state;

        let pegBoardDetails = pegList.find(x => x.pegBoardIndex === pegID);

        let editIndex       = pegList.findIndex(x => x.pegBoardIndex === pegID);

        pegBoardDetails['gapH']      = inputStates?.gapH;
        pegBoardDetails['gapW']      = inputStates?.gapW; 
        pegBoardDetails['pegLength'] = inputStates?.pegLength;       

        const gapH = measureConverter(pegBoardDetails.holeUOM,displayUOM,pegBoardDetails.gapH) * displayRatio;
        const gapW = measureConverter(pegBoardDetails.holeUOM,displayUOM,pegBoardDetails.gapW) * displayRatio; 

        // Generate arrays for x and y positions
        const startX     = pegBoardDetails.pegDrawingRect?.drawX  || 0;
        const startY     = pegBoardDetails.pegDrawingRect?.drawY  || 0;
        const rectWidth  = pegBoardDetails.pegDrawingRect?.drawRectWidth  || 0;
        const rectHeight = pegBoardDetails.pegDrawingRect?.drawRectHeight  || 0;
        const gapX       = gapW;
        const gapY       = gapH;
        const radius     = 2;

        const xPositionsNew = [];
        const yPositionsNew = [];

        for (let i = 0; i < Math.floor(rectWidth / gapX); i++) {
            //check rect x border over hole position
            if((startX + rectWidth) > (startX + gapX + i * gapX + radius)){
                xPositionsNew.push(startX + gapX + i * gapX + radius);
            }
        }

        for (let j = 0; j < Math.floor(rectHeight / gapY); j++) {
            //check rect start y border over hole position
            if((startY + rectHeight) > (startY + gapY + j * gapY + radius)){
                yPositionsNew.push(startY + gapY + j * gapY + radius);
            }
        }

        pegBoardDetails['xPositions'] = xPositionsNew;
        pegBoardDetails['yPositions'] = yPositionsNew;

        this.setState({currentSelectedBlock:null}, () => {
            this.setState({currentSelectedRecBlock:pegBoardDetails, currentSelectedBlock : this.state.tempCurrentSelectedBlock},()=>{
                this.handleUpdateGroup();
            });
        });

        let pegCoordination = [];

        xPositionsNew?.forEach((x, indexX) => {
            yPositionsNew?.forEach((y, indexY) => {
                // Create coordinate object
                const xyCoordinates = {
                    refCode: "x-"+indexX+"y-"+indexY,
                    pegX: "x"+indexX,
                    pegY: "y"+indexY,
                    x: measureConverter(pegBoardDetails.holeUOM,displayUOM,x) / displayRatio,  
                    y: measureConverter(pegBoardDetails.holeUOM,displayUOM,y) / displayRatio, 
                    drawX:x,
                    drawY:y
                };
                // Push to array
                pegCoordination.push(xyCoordinates);
            });
        });

        this.setState((prveState) => {
            //clone the pegList array
            let currentPegListArray = [...prveState.pegList];

            //adding custom peroperty 
            let updatedPeg = { 
                ...currentPegListArray[editIndex], 
                pegCoordinations: pegCoordination,
                savePegBoard:true,
                gapH:inputStates?.gapH,
                gapW:inputStates?.gapW,
                pegLength:inputStates?.pegLength,
                isPegBoardSaving:false,
                pegBoardStatus:PEG_BOARD_EDIT,
                drawGapH:gapH,
                drawGapW:gapW
            };

            currentPegListArray[editIndex] = updatedPeg;

            return { pegList: currentPegListArray };
            
        }, () => {

           
            
            this.setState({
                enableNextPegBoardSetting:true,
                cursorChangeToPeg:false,
                isRectDrawingCompleted:false,
                isPegDrawing:false,
                currentSelectedBlock:this.state.tempCurrentSelectedBlock
            }, () => {
                //remove current shelf products of simulation when peg board is added 

                if(this.state.enableNextPegBoardSetting && this.state.currentSelectedBlock !== null){
                    //console.log('chobj.past---before', this.state.historyData)
                    
                    //console.log('chobj.past---after', JSON.parse(JSON.stringify(chobj.past)));
                    this.handleBlockCut(false,true);
                    var chobj  = this.state.historyData;
                    chobj.past.splice(-1,1);
                }
            });
            
        });

    }

    // PEG CR - 2025 March
    //delete peg board
    handleDeletePeg = (pegID) => {

        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)), 2);

        const {pegList} = this.state;
        
        let removePegIndex = pegList?.findIndex(x => x.pegBoardIndex === pegID);
        // // If found, remove it from the array
        if (removePegIndex !== -1) {
            pegList.splice(removePegIndex, 1);
        }

        // remove the peg products if any in the deleted peg board
        let updatedPegProducts = this.state.pegProductList.filter(peg => !(peg.pegBoardIndex === pegID && peg.isHanged === true));
        let updatedMapProducts = this.state.mapproductList.filter(peg => !(peg.pegBoardIndex === pegID && peg.isHanged === true));

        // Push deleted product set to clipboard
        var shelfs=[]
        let deltedProductSet = this.state.mapproductList.filter(peg => peg.pegBoardIndex == pegID && (peg?.isDelete == false || peg?.isDelete == undefined) && peg.isHanged === true);
        let needToPushClipboard = deltedProductSet;

        for (let i = 0; i < needToPushClipboard.length; i++) {
            const product = needToPushClipboard[i];
            product.isDelete = true;
        }
        shelfs.push({shelfRank:1,products:needToPushClipboard})

        let selcutlist={
            groupUUID: uuidv4(),isNew: true, isDelete: false, mode: "delete", uom: "cm", shelf: shelfs
        }
        // Update the clipboard state
        this.updateCutList(selcutlist);

        this.setState({
            pegProductList: updatedPegProducts,
            mapproductList: updatedMapProducts,
            currentSelectedRecBlock:{},
            currentSelectedBlock:null,
            currentInternalDraggableProd: null,
            currentDraggableProd:null,
            isPegDrawing:false,
            isRectDrawingCompleted:false
        }, () => {
            // clear highlighted imported products
            this.compareImportedProds();
            this.nonSimProddropremoveCounterupdate();
        });

        this.setState((prevState) => {
            const updatedPegList = prevState.pegList.filter(peg => peg.pegBoardIndex !== pegID);
            return { pegList: updatedPegList, cursorChangeToPeg:false, enableNextPegBoardSetting:true};
        });
        
        // Mark changes for refresh indicator
        this.markChangesForRefresh();
    }

    // PEG CR - 2025 March
    // handle peg product add
    handlePegProductAdd = (productList, callback) => {
        this.setState({pegProductList: productList}, () => {
            if(callback){
                callback();
            }
        });
        // console.log("PEG PRPDUCT- ", this.state.pegProductList)
        // console.log("All PRPDUCT- ", this.state.mapproductList)
    }

    // PEG CR - 2025 March
    // handle peg board edit
    handleEditPegHoles = (pegID) => {
        const {pegList} = this.state;

        let editIndex = pegList.findIndex(x => x.pegBoardIndex === pegID);

        this.setState((prveState) => {
            //clone the pegList array
            let currentPegListArray = [...prveState.pegList];

            //update peg board status 
            let updatedPeg = { 
                ...currentPegListArray[editIndex], 
                pegBoardStatus:PEG_BOARD_UPDATE
            };

            currentPegListArray[editIndex] = updatedPeg;

            return { pegList: currentPegListArray };
            
        }, () => {});

    }

    // PEG CR - 2025 March
    // handle peg board update
    handleUpdatePegHoles = (pegId, inputStates) => {

        this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)), 2);

        const {pegList, displayUOM, displayRatio} = this.state;

        let pegBoardDetails = pegList.find(x => x.pegBoardIndex === pegId);

        pegBoardDetails['gapH']      = inputStates?.gapH;
        pegBoardDetails['gapW']      = inputStates?.gapW; 
        pegBoardDetails['pegLength'] = inputStates?.pegLength;       
    
        const gapH = measureConverter(pegBoardDetails.holeUOM,displayUOM,pegBoardDetails.gapH) * displayRatio;
        const gapW = measureConverter(pegBoardDetails.holeUOM,displayUOM,pegBoardDetails.gapW) * displayRatio;
        
        // Generate arrays for x and y positions
        const startX     = pegBoardDetails.pegDrawingRect?.drawX || 0;
        const startY     = pegBoardDetails.pegDrawingRect?.drawY || 0;
        const rectWidth  = pegBoardDetails.pegDrawingRect?.drawRectWidth || 0;
        const rectHeight = pegBoardDetails.pegDrawingRect?.drawRectHeight || 0;
        const gapX       = gapW;
        const gapY       = gapH;
        const radius     = 2;

        const xPositionsNew = [];
        const yPositionsNew = [];

        for (let i = 0; i < Math.floor(rectWidth / gapX); i++) {
            //check rect x border over hole position
            if((startX + rectWidth) > (startX + gapX + i * gapX + radius)){
                xPositionsNew.push(startX + gapX + i * gapX + radius);
            }
        }

        for (let j = 0; j < Math.floor(rectHeight / gapY); j++) {
            //check rect start y border over hole position
            if((startY + rectHeight) > (startY + gapY + j * gapY + radius)){
                yPositionsNew.push(startY + gapY + j * gapY + radius);
            }
        }

        pegBoardDetails['xPositions'] = xPositionsNew;
        pegBoardDetails['yPositions'] = yPositionsNew

        this.setState({currentSelectedRecBlock:pegBoardDetails},()=>{});

        let pegCoordination = [];

        xPositionsNew?.forEach((x, indexX) => {
            yPositionsNew?.forEach((y, indexY) => {
                // Create coordinate object
                const xyCoordinates = {
                    refCode: "x-"+indexX+"y-"+indexY,
                    pegX: "x"+indexX,
                    pegY: "y"+indexY,
                    x: measureConverter(pegBoardDetails.holeUOM,displayUOM,x) / displayRatio,  
                    y: measureConverter(pegBoardDetails.holeUOM,displayUOM,y) / displayRatio, 
                    drawX : x,
                    drawY : y
                };
                // Push to array
                pegCoordination.push(xyCoordinates);
            });
        });

        let editIndex = pegList.findIndex(x => x.pegBoardIndex === pegId);

        // remove the peg products if any in the deleted peg board
        let updatedPegProducts = this.state.pegProductList.filter(peg => peg.pegBoardIndex !== pegId);
        let updatedMapProducts = this.state.mapproductList.filter(peg => peg.pegBoardIndex !== pegId);
        
        // Push deleted product set to clipboard
        var shelfs=[]
        let deltedProductSet = this.state.mapproductList.filter(peg => peg.pegBoardIndex == pegId && (peg?.isDelete == false || peg?.isDelete == undefined));
        let needToPushClipboard = deltedProductSet;

        for (let i = 0; i < needToPushClipboard.length; i++) {
            const product = needToPushClipboard[i];
            product.isDelete = true;
        }
        shelfs.push({shelfRank:1,products:needToPushClipboard})

        let selcutlist={
            groupUUID: uuidv4(),isNew: true, isDelete: false, mode: "delete", uom: "cm", shelf: shelfs
        }
        // Update the clipboard state
        this.updateCutList(selcutlist);

        this.setState({
            pegProductList: updatedPegProducts,
            mapproductList: updatedMapProducts,
            currentSelectedRecBlock:{},
            currentSelectedBlock:null,
            currentInternalDraggableProd: null,
            currentDraggableProd:null,
        });

        this.setState((prveState) => {
            //clone the pegList array
            let currentPegListArray = [...prveState.pegList];

            //adding custom peroperty 
            let updatedPeg = { 
                ...currentPegListArray[editIndex], 
                pegCoordinations: pegCoordination,
                savePegBoard:true,
                gapH:inputStates?.gapH,
                gapW:inputStates?.gapW,
                pegLength:inputStates?.pegLength,
                isPegBoardSaving:false,
                pegBoardStatus:PEG_BOARD_EDIT,
                drawGapH:gapH,
                drawGapW:gapW
            };

            currentPegListArray[editIndex] = updatedPeg;

            return { pegList: currentPegListArray };
            
        }, () => {
            this.fieldHistoryAdd(JSON.parse(JSON.stringify(this.state.mapproductList)), 2);
            // Mark changes for refresh indicator
            this.markChangesForRefresh();
        });

    }

    

    // PEG CR - 2025 March
    // This function will return if any product overlap the peg board
    // @pegboard - all peg board data array
    // @productList - all product list
    productOverlapCheckerWithPegBoard = (pegBoard, productList) => {
        for (let i = 0; i < pegBoard.length; i++) {
          const {pegDrawingRect} = pegBoard[i];
  
          let pegBoardStartX = pegDrawingRect.drawX;
          let pegBoardStartY = pegDrawingRect.drawY;
  
          let pegBoardEndX = pegDrawingRect.drawX + pegDrawingRect.drawRectWidth;
          let pegBoardEndY = pegDrawingRect.drawY + pegDrawingRect.drawRectHeight;
          
          for (let j = 0; j < productList.length; j++) {
            let product = productList[j];
            let productStartX = product.x;
            let productStartY = product.y;
            let productEndX = product.x + product.drawWidth;
            let productEndY = product.y + product.drawHeight;
  
            if(product.isDelete || product.isHanged){
                continue;
            }

            if (productEndX > pegBoardStartX && productStartX < pegBoardEndX && productEndY > pegBoardStartY && productStartY < pegBoardEndY) {
                return {isPegBoardOverlap:true, product:product};
            }
          }
        }
        return {isPegBoardOverlap:false};
    }

    // PEG CR - 2025 March
    // isDelete update for peg products
    updatePegProductSetWhenDeleted = (deletedProdList) => {
        let deletedProdListIds = deletedProdList.map(product => product.id);

        let updatedPegProducts = this.state.pegProductList.map(peg => {
            if (deletedProdListIds.includes(peg.id)) {
                return { ...peg, isDelete: true };
            }
            return peg;
        });

        this.setState({ pegProductList: updatedPegProducts });
        this.nonSimProddropremoveCounterupdate("deleteProd")
    }

    // PEG CR - 2025 March
    // handle when peg board drawing, brake the product groups
    handleUpdateGroup(){
        const {currentSelectedRecBlock, currentSelectedBlock} = this.state; 
        if(currentSelectedRecBlock && currentSelectedBlock && currentSelectedBlock?.selectedshelves?.length > 0){
            //read the selected shelf wise selected product groups
            let allGroupProducts = [];

            for(let i=0; i < currentSelectedBlock?.selectedshelves?.length; i++){
                let selectedShelf = currentSelectedBlock?.selectedshelves[i];
               
                // Filter the selected products that fall within the defined rectangular scope
                let filteredProducts = selectedShelf?.selectedProducts?.filter((product) => {
                    // Check if the product's x-coordinate and width are within the rectangle's x-coordinate and width
                    return currentSelectedRecBlock?.pegDrawingRect?.drawX < (product.x + product.drawWidth) && 
                    product.x < currentSelectedRecBlock?.pegDrawingRect?.drawX + currentSelectedRecBlock?.pegDrawingRect?.drawRectWidth;
                });

                if (filteredProducts.length > 0) {
                    selectedShelf.selectedProducts = filteredProducts;
                    allGroupProducts.push(...filteredProducts);
                }
            }
            currentSelectedBlock.drawingProducts    = allGroupProducts;
            currentSelectedBlock.newDrawingProducts = allGroupProducts;
            this.groupByProduct();
        }
    }

    // PEG CR & STACK CR - 2025 - March - April
    // This function will return if any stack product overlap the peg board
    // @pegboard - all peg board data array
    // @stackProduct - stack product
    stackProductOverlapCheckWithPegBoard = (pegBoard, stackProductList, stackCount) => {

        const stackProduct = stackProductList?.drawingProducts;
        if (!stackProduct || stackProduct.length === 0) {
            // console.log('No stack products to validate.');
            return false;
        }

        // Sort by x-axis
        const sortedStack = [...stackProduct].sort((a, b) => a.x - b.x);

        // Calculate stack boundary
        const stackProductStartX = sortedStack[0].x;
        const stackProductEndX   = sortedStack[sortedStack.length - 1].x + sortedStack[sortedStack.length - 1].drawWidth;

        const stackProductStartY = stackProduct?.[0]?.y - stackProduct?.[0]?.drawHeight;
        const stackProductEndY   = stackProduct?.[0]?.y

        const newStackProductStartY = stackProductStartY - (stackProduct?.[0]?.drawHeight * stackCount)

        for (let i = 0; i < pegBoard.length; i++) {
            const {pegDrawingRect} = pegBoard[i];

            let pegBoardStartX = pegDrawingRect.drawX;
            let pegBoardStartY = pegDrawingRect.drawY;
            let pegBoardEndX   = pegDrawingRect.drawX + pegDrawingRect.drawRectWidth;
            let pegBoardEndY   = pegDrawingRect.drawY + pegDrawingRect.drawRectHeight;
            // Check if the stack product overlaps with the peg board
            if (stackProductEndX > pegBoardStartX && stackProductStartX < pegBoardEndX && stackProductEndY > pegBoardStartY && newStackProductStartY < pegBoardEndY) { 
                return true;
            }
        }
        return false;
    }


    // PEG CR - 2025 March
    resetPegBoardOverlap = () => {
        this.setState({isPegBoardOverlapping: false})
    }

    // PEG CR - 2025 May
    checkSelectedMovingProductBlockHaveHanggedProducts = (selectedProducts) => {
        let selectedProductsList = selectedProducts?.drawingProducts;
        // check if all products have hanged products or if not return alert mixing 
        let isHanggedChekStatus = '';
        if(selectedProductsList?.length === 0 || selectedProductsList === undefined){
            return isHanggedChekStatus;
        }
        let hangedProducts = selectedProductsList.filter(product => product.isHanged === true);

        // check selectedProducts length and hanged products length
        if(selectedProductsList?.length > 0 && hangedProducts?.length > 0){
            if(selectedProductsList.length === hangedProducts.length){
                isHanggedChekStatus = 'HANGED_PRDUCTS_ONLY';
            }else{
                isHanggedChekStatus = 'MIXING_PRODUCTS';
            }
        }

        return isHanggedChekStatus;
    }

    // PEG CR - 2025 May
    handlePegProductMovement = (movingSide) => {
        const { contxtmenu, mapproductList, pegList, currentInternalDraggableProd, currentSelectedBlock, mapFields, isPegBoardOverlapping } = this.state;

        if (!contxtmenu || !currentInternalDraggableProd || isPegBoardOverlapping) return;

        let currentlySelectedProd = currentSelectedBlock?.drawingProducts;

        if (!currentlySelectedProd || currentlySelectedProd.length === 0) return;
        let originalProductList = structuredClone(mapproductList); 
        let originalProductList2 = structuredClone(originalProductList); 
        // filter the peg products list
        let pegProductList = mapproductList.filter(prod => prod.isHanged === true && prod.pegBoardIndex !== undefined);
        // filter the product pegProductList from is delete true
        pegProductList = pegProductList.filter(prod => prod.isDelete !== true);

        let updatedProductList = [];

        if(movingSide === 'up'){
            currentlySelectedProd.forEach((prod)=>{
                let pegProduct = structuredClone(prod);
                let product = structuredClone(pegProduct);

                let pegBoard = pegList.find(x => x.pegBoardIndex === product.pegBoardIndex);
                // get peg pegCoordinations
                let pegCoordinations = pegBoard?.pegCoordinations;
                // get selected product pegRefCode
                let selectedProductPegRefCode = product.pegRefCode;
                // get the pegCoordination object
                let pegCoordination = pegCoordinations?.find(x => x.refCode === selectedProductPegRefCode);
     
                if(pegCoordination){
                    // try to get the up pegCoordination
                    let upPegCoordination = pegCoordinations?.find(x => x.pegX === pegCoordination.pegX && x.pegY === 'y'+(parseInt(pegCoordination.pegY.replace('y',''))-1));
                   
                    if(upPegCoordination){
                        // check if the pegCoordination is already occupied by other product
                        let isPegCoordinationOccupied = pegProductList?.find(x => x.pegRefCode === upPegCoordination.refCode && (x?.pegBoardIndex == pegBoard?.pegBoardIndex));
                        if(isPegCoordinationOccupied){
                            return;
                        }else{
                            // update the pegCoordination of the product
                            const productHoleXPos = (measureConverter(product?.uom ,"cm",product?.haggingHorizontal)*this.state.displayRatio);
                            const productHoleYPos = (measureConverter(product?.uom ,"cm",product?.haggingVertical)*this.state.displayRatio);
                            
                            const updatedProductX = upPegCoordination.drawX - productHoleXPos;
                            const updatedProductY = upPegCoordination.drawY - productHoleYPos;

                            product.pegRefCode = upPegCoordination.refCode;
                            product.x = updatedProductX;
                            product.y = updatedProductY;
                            product.pegX = upPegCoordination.x;
                            product.pegDrawX = upPegCoordination.drawX;
                            product.pegY = upPegCoordination.y;
                            product.pegDrawY = upPegCoordination.drawY;
                            product.isHanged = true;

                            // check product overlap with existing peg products
                            const {isOverlap} =  this.productOverlapCheckerForMove(pegBoard, pegProductList, product);
       
                            if(isOverlap){
                                return;
                            } else{
                                updatedProductList.push(product);
                            }
                        }
                    }else{
                        return; 
                    }
                }

            })
        }else if(movingSide === 'down'){
            currentlySelectedProd.forEach((prod)=>{
                let pegProduct = structuredClone(prod);
                let product = structuredClone(pegProduct);
                let pegBoard = pegList.find(x => x.pegBoardIndex === product.pegBoardIndex);
                // get peg pegCoordinations
                let pegCoordinations = pegBoard?.pegCoordinations;
                // get selected product pegRefCode
                let selectedProductPegRefCode = product.pegRefCode;
                // get the pegCoordination object
                let pegCoordination = pegCoordinations?.find(x => x.refCode === selectedProductPegRefCode);

                if(pegCoordination){
                    // try to get the down pegCoordination
                    let downPegCoordination = pegCoordinations?.find(x => x.pegX === pegCoordination.pegX && x.pegY === 'y'+(parseInt(pegCoordination.pegY.replace('y',''))+1));

                    if(downPegCoordination){
                        // check if the pegCoordination is already occupied by other product
                        let isPegCoordinationOccupied = pegProductList?.find(x => x.pegRefCode === downPegCoordination.refCode && (x?.pegBoardIndex == pegBoard?.pegBoardIndex));
                        if(isPegCoordinationOccupied){
                            return;
                        }else{
                            // update the pegCoordination of the product
                            const productHoleXPos = (measureConverter(product?.uom ,"cm",product?.haggingHorizontal)*this.state.displayRatio);
                            const productHoleYPos = (measureConverter(product?.uom ,"cm",product?.haggingVertical)*this.state.displayRatio);
                            const updatedProductX = downPegCoordination.drawX - productHoleXPos;
                            const updatedProductY = downPegCoordination.drawY - productHoleYPos;
                            product.pegRefCode = downPegCoordination.refCode;
                            product.x = updatedProductX;
                            product.y = updatedProductY;
                            product.pegX = downPegCoordination.x;
                            product.pegDrawX = downPegCoordination.drawX;
                            product.pegY = downPegCoordination.y;
                            product.pegDrawY = downPegCoordination.drawY;
                            product.isHanged = true;
                            // check product overlap with existing peg products
                            // check if some product overlap
                            const {isOverlap} =  this.productOverlapCheckerForMove(pegBoard, pegProductList, product);

                            if(isOverlap){
                                return;
                            } else{
                                updatedProductList.push(product);
                            }
                        }
                    }else{
                        return;
                    }
                }
            })
        }else if(movingSide === 'left'){
            currentlySelectedProd.forEach((prod)=>{
                let pegProduct = structuredClone(prod);
                let product = structuredClone(pegProduct);
                let pegBoard = pegList.find(x => x.pegBoardIndex === product.pegBoardIndex);
                // get peg pegCoordinations
                let pegCoordinations = pegBoard?.pegCoordinations;  
                // get selected product pegRefCode
                let selectedProductPegRefCode = product.pegRefCode;
                // get the pegCoordination object
                let pegCoordination = pegCoordinations?.find(x => x.refCode === selectedProductPegRefCode);

                if(pegCoordination){
                    // try to get the left pegCoordination
                    let leftPegCoordination = pegCoordinations?.find(x => x.pegX === 'x'+(parseInt(pegCoordination.pegX.replace('x',''))-1) && x.pegY === pegCoordination.pegY);
 
                    if(leftPegCoordination){
                        // check if the pegCoordination is already occupied by other product
                        let isPegCoordinationOccupied = pegProductList?.find(x => x.pegRefCode === leftPegCoordination.refCode && (x?.pegBoardIndex == pegBoard?.pegBoardIndex));
                        if(isPegCoordinationOccupied){
                            return;
                        }else{
                            // update the pegCoordination of the product
                            const productHoleXPos = (measureConverter(product?.uom ,"cm",product?.haggingHorizontal)*this.state.displayRatio);
                            const productHoleYPos = (measureConverter(product?.uom ,"cm",product?.haggingVertical)*this.state.displayRatio);
                            const updatedProductX = leftPegCoordination.drawX - productHoleXPos;
                            const updatedProductY = leftPegCoordination.drawY - productHoleYPos;
                            product.pegRefCode = leftPegCoordination.refCode;
                            product.x = updatedProductX;
                            product.y = updatedProductY;
                            product.pegX = leftPegCoordination.x;
                            product.pegDrawX = leftPegCoordination.drawX;
                            product.pegY = leftPegCoordination.y;
                            product.pegDrawY = leftPegCoordination.drawY;
                            product.isHanged = true;
                            // check product overlap with existing peg products
                            const {isOverlap} =  this.productOverlapCheckerForMove(pegBoard, pegProductList, product);

                            if(isOverlap){
                                return;
                            } else{
                                updatedProductList.push(product);
                            }
                        }
                    }else{
                        return;
                    }
                }
            })
        }else if(movingSide === 'right'){
            currentlySelectedProd.forEach((prod)=>{
                let pegProduct = structuredClone(prod);
                let product = structuredClone(pegProduct);
                let pegBoard = pegList.find(x => x.pegBoardIndex === product.pegBoardIndex);
                // get peg pegCoordinations
                let pegCoordinations = pegBoard?.pegCoordinations;
                // get selected product pegRefCode
                let selectedProductPegRefCode = product.pegRefCode;
                // get the pegCoordination object
                let pegCoordination = pegCoordinations?.find(x => x.refCode === selectedProductPegRefCode);

                if(pegCoordination){
                    // try to get the right pegCoordination
                    let rightPegCoordination = pegCoordinations?.find(x => x.pegX === 'x'+(parseInt(pegCoordination.pegX.replace('x',''))+1) && x.pegY === pegCoordination.pegY);

                    if(rightPegCoordination){
                        // check if the pegCoordination is already occupied by other product
                        let isPegCoordinationOccupied = pegProductList?.find(x => x.pegRefCode === rightPegCoordination.refCode && (x?.pegBoardIndex == pegBoard?.pegBoardIndex));
                        if(isPegCoordinationOccupied){
                            return;
                        }else{
                            // update the pegCoordination of the product
                            const productHoleXPos = (measureConverter(product?.uom ,"cm",product?.haggingHorizontal)*this.state.displayRatio);
                            const productHoleYPos = (measureConverter(product?.uom ,"cm",product?.haggingVertical)*this.state.displayRatio);
                            const updatedProductX = rightPegCoordination.drawX - productHoleXPos;
                            const updatedProductY = rightPegCoordination.drawY - productHoleYPos;
                            product.pegRefCode = rightPegCoordination.refCode;
                            product.x = updatedProductX;
                            product.y = updatedProductY;
                            product.pegX = rightPegCoordination.x;
                            product.pegDrawX = rightPegCoordination.drawX;
                            product.pegY = rightPegCoordination.y;
                            product.pegDrawY = rightPegCoordination.drawY;
                            product.isHanged = true;
                            // check product overlap with existing peg products
                            const {isOverlap} =  this.productOverlapCheckerForMove(pegBoard, pegProductList, product);

                            if(isOverlap){
                                return;
                            } else{
                                updatedProductList.push(product);
                            }
                        }
                    }else{
                        return;
                    }
                }
            })
        }

        if(updatedProductList.length === 0){
            alertService.error(this.props.t("NO_PRODUCT_TO_MOVE"));
            return;
        }

        // update the pegProductList with the updated product list
        let updatedPegProductList = pegProductList.map((pegProd) => {
            let updatedProduct = updatedProductList.find((prod) => prod.id === pegProd.id);
            if (updatedProduct) {
                return { ...pegProd, ...updatedProduct };
            }
            return pegProd;
        });
        // update the mapproductList with the updated product list
        let updatedMainProductList = mapproductList.map((mapProd) => {
            let updatedProduct = updatedProductList.find((prod) => prod.id === mapProd.id);
            if (updatedProduct) {
                return { ...mapProd, ...updatedProduct };
            }
            return mapProd;
        });
        // update currentSelectedBlock x and y
        let currentSelectedBlockObj = structuredClone(currentSelectedBlock);

        currentSelectedBlockObj.drawingProducts = updatedProductList;
        currentSelectedBlockObj.newDrawingProducts = updatedProductList;

        // get the low and hight x & y
        const { minX, minY, maxX, maxY } = updatedProductList.reduce(
            (acc, prod) => {
              const x1 = prod.x;
              const y1 = prod.y;
              const x2 = prod.x + prod.drawWidth;
              const y2 = prod.y + prod.drawHeight;

              return {
                minX: Math.min(acc.minX, x1),
                minY: Math.min(acc.minY, y1),
                maxX: Math.max(acc.maxX, x2),
                maxY: Math.max(acc.maxY, y2),
              };
            },
            {
              minX: Infinity,
              minY: Infinity,
              maxX: -Infinity,
              maxY: -Infinity,
            }
          );

        currentSelectedBlockObj.x = minX;
        currentSelectedBlockObj.y = minY;
        currentSelectedBlockObj.drawWidth = maxX - minX;
        currentSelectedBlockObj.drawHeight = maxY - minY;

        // save history data
        this.fieldHistoryAdd(JSON.parse(JSON.stringify(originalProductList2)), 3);

        // update the state with the updated product list
        this.setState({
            pegProductList: updatedPegProductList,
            mapproductList: updatedMainProductList,
            currentSelectedBlock: currentSelectedBlockObj,
        }, () => {
            updatedProductList = [];
            // groupByProduct
            this.groupByProduct();
        });
    }

    // PEG CR - 2025 May
    // This function will check product movement other product will overlap
    productOverlapCheckerForMove = (pegBoard, existingProductList, newProduct) => {
        // remove the dropping product if avaliable the
        let existingPegProducts = existingProductList.filter((prod)=>prod.id != newProduct.id);
        // remove the other peg boards products
        existingPegProducts = existingPegProducts.filter((prod)=>prod?.pegBoardIndex == pegBoard?.pegBoardIndex || prod?.pegBoardId == pegBoard?.id);

        // check newProduct x and y position overlap with other peg products
        const productWidth = newProduct?.drawWidth;
        // Calculate total height including price tag if hasPriceTag is true for new product
        const newPriceTagHeightPx = newProduct?.hasPriceTag ? (newProduct?.priceTagHeight * this.state.displayRatio) : 0;
        const newGapPx = newProduct?.hasPriceTag ? (newProduct?.priceTagGap * this.state.displayRatio) : 0;
        const productHeight = (newProduct?.isHanged && newProduct?.hasPriceTag)
            ? newPriceTagHeightPx + newGapPx + newProduct?.drawHeight
            : newProduct?.drawHeight;
        // For new product with price tag, Y starts at top of price tag (pegDrawY - priceTagHeight/2)
        const newProductY = (newProduct?.isHanged && newProduct?.hasPriceTag && newProduct?.pegDrawY !== undefined)
            ? newProduct.pegDrawY - (newPriceTagHeightPx / 2)
            : newProduct?.y;
        // For new product with price tag, X is centered on peg hole: pegDrawX - (drawWidth/2)
        const newProductX = (newProduct?.isHanged && newProduct?.hasPriceTag && newProduct?.pegDrawX !== undefined)
            ? newProduct.pegDrawX - (productWidth / 2)
            : newProduct?.x;

        // Check for overlap with any existing products on the peg board
        for (let existingProduct of existingPegProducts) {
            // console.log("existingProduct --- ",existingProduct)
            // For existing products with price tag, X is centered on peg hole: pegDrawX - (drawWidth/2)
            const existingWidth = existingProduct?.drawWidth;
            const existingX = (existingProduct?.isHanged && existingProduct?.hasPriceTag && existingProduct?.pegDrawX !== undefined)
                ? existingProduct.pegDrawX - (existingWidth / 2)
                : existingProduct?.x;
            // Calculate total height including price tag if hasPriceTag is true for existing product
            const existingPriceTagHeightPx = existingProduct?.hasPriceTag ? (existingProduct?.priceTagHeight * this.state.displayRatio) : 0;
            const existingGapPx = existingProduct?.hasPriceTag ? (existingProduct?.priceTagGap * this.state.displayRatio) : 0;
            const existingHeight = (existingProduct?.isHanged && existingProduct?.hasPriceTag)
                ? existingPriceTagHeightPx + existingGapPx + existingProduct?.drawHeight
                : existingProduct?.drawHeight;
            // For products with price tag, Y starts at top of price tag (pegDrawY - priceTagHeight/2), otherwise use product.y
            const existingY = (existingProduct?.isHanged && existingProduct?.hasPriceTag && existingProduct?.pegDrawY !== undefined)
                ? existingProduct.pegDrawY - (existingPriceTagHeightPx / 2)
                : existingProduct?.y;

            // check if the products is delete ture then skip the products
            if(existingProduct?.isDelete){
                continue;
            }
            const isOverlap = !(
                newProductX + productWidth <= existingX || // New product is entirely left of the existing product
                newProductX >= existingX + existingWidth || // New product is entirely right of the existing product
                newProductY + productHeight <= existingY || // New product is entirely above the existing product
                newProductY >= existingY + existingHeight // New product is entirely below the existing product
            );

            if (isOverlap) {
                return {isOverlap:true};
            }
        }
        // check if the product pegboard is outside the peg board
        const pegBoardX = pegBoard?.pegDrawingRect?.drawX;
        const pegBoardY = pegBoard?.pegDrawingRect?.drawY;
        const pegBoardWidth = pegBoard?.pegDrawingRect?.drawRectWidth;
        const pegBoardHeight = pegBoard?.pegDrawingRect?.drawRectHeight;

        if(newProductX < pegBoardX || newProductX + productWidth > pegBoardX + pegBoardWidth || newProductY < pegBoardY || newProductY + productHeight > pegBoardY + pegBoardHeight){
            // console.log("Product is outside the peg board");
            return {isOverlap:true};
        }
        // No overlap, product can be dropped at the original position
        return {isOverlap:false};  // No overlap, return null or appropriate result
    };


    // check if all products withing the shelf 
    checkProductOverlapWithShelf = (simmilerShelfList, productList) => {
        // Sort shelves by x
        const sortedShelves = [...simmilerShelfList].sort((a, b) => a.x - b.x);

        // Calculate the total horizontal range (start to end)
        const totalStartX = sortedShelves[0].x;
        const totalEndX = sortedShelves.reduce((acc, shelf) => acc + shelf.drawWidth, totalStartX);

        // Check if any product is outside the full shelf span
        return productList.some(product => {
            const productStartX = product.x;
            const productEndX = product.x + product.drawWidth;

            return productStartX < totalStartX || productEndX > totalEndX;
        });
    }

    // PEG CR - 2025 May
    // This function will check new x & y corss any peagboard
    checkPegboardWithNewXYCoordinations = (x, endX, y, endY, pegBoardList, threshold) => {
        for (let i = 0; i < pegBoardList.length; i++) {
            const {pegDrawingRect} = pegBoardList[i];
            let pegBoardStartX = pegDrawingRect.drawX - threshold;
            let pegBoardStartY = pegDrawingRect.drawY - threshold;
    
            let pegBoardEndX = pegDrawingRect.drawX + pegDrawingRect.drawRectWidth + threshold;
            let pegBoardEndY = pegDrawingRect.drawY + pegDrawingRect.drawRectHeight + threshold;

            if (endX > pegBoardStartX && x < pegBoardEndX && endY > pegBoardStartY && y < pegBoardEndY) {
                return true;
            }  
        }
        return false;
    }

    // DU EDIT CR - 2025 November
    // Handle display unit edit panel open
    handleDisplayUnitEditPanel =  () => {
        // reset zoom level to default when DU edit panel open
        this.handleZoomInOut(false,true);
        // open the DU edit panel
        this.setState({showDUEditComponent: true}, () => {
            // Calculate top height for each shelf in each field
            this.getTopHeightForDUEditPanel();
        });
    }


    // Handle save from Display Unit Edit
    handleDUEditSave = (data) => {
        const { mapFields, mapProducts, deletedProducts } = data;

        // Get the IDs of deleted products
        const deletedProductIds = deletedProducts
            ? deletedProducts.flatMap(item => item.products.map(p => p.id))
            : [];

        const initalProducts = structuredClone(this.state.mapproductList);
        // Update mapproductList: mark deleted products with isDelete: true and sync shelf ranks
        let updatedMapProductList = [...initalProducts];

        // Update products: mark deleted and sync shelf ranks from child component
        updatedMapProductList = updatedMapProductList.map(product => {
            let updatedProduct = { ...product };

            // Mark deleted products
            if (deletedProductIds.includes(product.id)) {
                updatedProduct.isDelete = true;
            }

            // Sync shelf rank from mapProducts (child component) if it has changed
            const childProduct = mapProducts.find(p => p.id === product.id);
            if(product.isHanged){
                return product;
            }
            if (childProduct) {
                updatedProduct.shelfrank = childProduct.shelfrank;
                updatedProduct.field_custom_id = childProduct.field_custom_id;
                // Calculate the starting point
                let prodfield = mapFields[childProduct?.field_custom_id];
                let prodstartpoint = ((childProduct?.x - prodfield?.x) / this.state.displayRatio);
                const match = prodstartpoint.toString().match(/^-?\d+\.\d{0,9}/);
                prodstartpoint = match ? match[0] : prodstartpoint.toString();
                updatedProduct.startingPoint = prodstartpoint;
            }

            return updatedProduct;
        });

        // Update selectedCatRect to ensure mapobjectsdraw uses the latest data
        let updatedSelectedCatRect = JSON.parse(JSON.stringify(this.state.selectedCatRect));

        // Sync non_sim_prodlist with the current nonfilteredNonEProducts state
        // so that products deleted earlier in the session are not lost when
        // mapobjectsdraw resets nonfilteredNonEProducts from selectedCatRect.non_sim_prodlist
        if (updatedSelectedCatRect) {
            updatedSelectedCatRect.non_sim_prodlist = JSON.parse(JSON.stringify(this.state.nonfilteredNonEProducts));
        }

        // Convert mapFields (display ratio applied) back to original field format for selectedCatRect
        // selectedCatRect.fieldList needs original field data, not the display ratio applied data
        // So we need to extract the original field structure from mapFields
        if (updatedSelectedCatRect && mapFields) {
            // Update fieldList - convert display unit data back to original format
            const updatedFieldList = Object.keys(mapFields).map(fieldKey => {
                const field = mapFields[fieldKey];
                // Extract original field data structure
                return {
                    ...field,
                    // Preserve original properties that might be needed
                };
            });

            // Update selectedCatRect with new data
            updatedSelectedCatRect.fieldList = updatedFieldList;

            // Update products with the deleted products marked and sync shelf ranks
            if (updatedSelectedCatRect.products) {
                updatedSelectedCatRect.products = initalProducts.map(product => {
                    // DUE TO BUG PLAN-819
                    // if the products is hanged, skip the products
                    if(product.isHanged){
                        return product;
                    }
                    let updatedProduct = { ...product };

                    // Mark deleted products
                    if (deletedProductIds.includes(product.id)) {
                        updatedProduct.isDelete = true;
                    }

                    // Sync shelf rank from mapProducts (child component) if it has changed
                    const childProduct = mapProducts.find(p => p.id === product.id && !p.isDelete);
                    if (childProduct) {
                        updatedProduct.shelfrank = childProduct.shelfrank;
                        updatedProduct.field_custom_id = childProduct.field_custom_id;
                        // Calculate the starting point
                        let prodfield = mapFields[childProduct?.field_custom_id];
                        let prodstartpoint = ((childProduct?.x - prodfield?.x) / this.state.displayRatio);
                        const match = prodstartpoint.toString().match(/^-?\d+\.\d{0,9}/);
                        prodstartpoint = match ? match[0] : prodstartpoint.toString();
                        updatedProduct.startingPoint = prodstartpoint; 
                    }

                    return updatedProduct;
                });
            }
        }
        // Add deleted products to clipboard using the proper format
        if (deletedProducts && deletedProducts.length > 0) {
            this.handleDeletedProductsToClipboard(deletedProducts);
        }

        // remove isHanged products from updatedSelectedCatRect.products
        if (updatedSelectedCatRect && updatedSelectedCatRect.products) {
            updatedSelectedCatRect.products = updatedSelectedCatRect.products.filter(product => !product.isHanged);
        }

        // Add deleted shelf products to non_sim_prodlist so mapobjectsdraw
        // preserves them in nonfilteredNonEProducts when it rebuilds state.
        if (deletedProducts && deletedProducts.length > 0 && updatedSelectedCatRect) {
            if (!updatedSelectedCatRect.non_sim_prodlist) {
                updatedSelectedCatRect.non_sim_prodlist = [];
            }
            const existingBarcodes = new Set(
                updatedSelectedCatRect.non_sim_prodlist.map(p => String(p?.barcode || ''))
            );
            deletedProducts.forEach(shelfGroup => {
                if (shelfGroup.products) {
                    shelfGroup.products.forEach(product => {
                        const barcode = String(product?.barcode || '');
                        if (barcode && !existingBarcodes.has(barcode)) {
                            // Remove isSimulatedProd and add productName so
                            // normalizeDataPaneltData classifies as 'non-simulated'
                            // when called later in setInitialFilteredList.
                            // Set category to 'non-simulated' string so dataPanelItemCard
                            // renders the border bottom and notSimulatedReason icon.
                            // also extract category info to top-level fields so processLambdaDataPanelResult
                            // can reconstruct the category object for the calculate payload.
                            const { isSimulatedProd, ...productBase } = product;
                            updatedSelectedCatRect.non_sim_prodlist.push({
                                ...productBase,
                                productName: product.name || product.productName || '',
                                categoryId: product.categoryId || product.category?.id || product.category?.categoryId || '',
                                categoryName: product.categoryName || product.category?.categoryName || product.category?.name || '',
                                categoryCode: product.categoryCode || product.category?.posCode || product.category?.importRefCode || '',
                                category: 'non-simulated',
                                isDelete: false,
                                isNew: false,
                                isFilterd: false,
                                isAdded: false,
                                notSimulatedReason: 'none',
                            });
                            existingBarcodes.add(barcode);
                        }
                    });
                }
            });
        }

        const preservedPegList = JSON.parse(JSON.stringify(this.state.pegList));

        // Update the state with all changes
        this.setState({
            mapFields: mapFields,
            mapproductList: updatedMapProductList,
            selectedCatRect: updatedSelectedCatRect,
            isDisplayUnitEdited: true,
            pegList: this.state.pegList,
            deepClonePegList: preservedPegList,
        }, () => {
            // After updating the fields and products, recalculate grouping
            this.mapobjectsdraw(null, true);
            this.groupByProduct();
            this.nonSimProddropremoveCounterupdate();
            this.markChangesForRefresh();
            this.updatePegBoardShelfIDs(this.state.pegList, this.state.mapFields);
        });
    }

    // ARI-84 - Fix
    onHideCheck = () => {
      // Check if there are unsaved changes in the history
      const hasUnsavedChanges =
        this.state.historyData &&
        this.state.historyData.past &&
        Array.isArray(this.state.historyData.past) &&
        this.state.historyData.past.length > 0

      if (hasUnsavedChanges) {
        //have unsavedchnages
        confirmAlert({
          title: this.props.t('UNSAVE_CHANGES'),
          message: this.props.t('YOU_HAVE_UNSAVED_CHANGES_SURE_TO_LEAVE'),
          overlayClassName:
            this.props.isRTL === 'rtl' ? 'alertrtl-content' : '',
          buttons: [
            {
              label: this.props.t('btnnames.yes'),
              onClick: () => {
                this.handleFullscreenEdit(false)
              },
            },
            {
              label: this.props.t('btnnames.no'),
              onClick: () => {
                return false
              },
            },
          ],
        })
      } else {
        //no unsaved changes
        confirmAlert({
          title: this.props.t('CLOSE_SIMULATION'),
          message: '',
          overlayClassName:
            this.props.isRTL === 'rtl' ? 'alertrtl-content' : '',
          buttons: [
            {
              label: this.props.t('btnnames.yes'),
              onClick: () => {
                this.handleFullscreenEdit(false)
              },
            },
            {
              label: this.props.t('btnnames.no'),
              onClick: () => {
                return false
              },
            },
          ],
        })
      }
    }

    // DU EDIT CR - 2026 January
    // Calculate each field wise shelf placed products top height for DU edit panel
    // If product has stack then calculate the top height with stack count
    // If product has no stack then calculate the top height with single product height
    // return top height object with fieldId & shelfRank
    //[{fieldId: 'field1', shelfRank: 1, topHeight: 150}, ...]

    getTopHeightForDUEditPanel = () => {

        const { mapFields, mapproductList, markablestackable } = this.state;
        let topHeightArray = [];
        mapFields && Object.keys(mapFields).length > 0 && Object.keys(mapFields).map((fieldKey, f) => {
            const field = mapFields[fieldKey];

            if (field.shelf && field.shelf.length > 0) {
                field.shelf.forEach((shelf) => {  

                    // Filter products placed on the current shelf
                    const productsOnShelf = mapproductList.filter(product =>
                        // product.field_custom_id === field.fieldId &&
                        product?.actualFieldInfo && product.actualFieldInfo.some(info => info.actualFieldId === field.actualFieldId) &&
                        product.shelfrank === shelf.rank &&
                        !product.isDelete
                    );

                    if (productsOnShelf.length > 0) {
                        // Calculate the top height considering stack count
                        let maxTopHeight = 0;
                        productsOnShelf.forEach((product) => {
                            const productTopHeight = product.y;
                            const productHeight = product.drawHeight;
                            let totalHeight;
                            // Calculate the top position based on stack count
                            if (!product.stackCount || product.stackCount === 0) {
                                // No stack - use product's current position
                                totalHeight = productHeight;
                            } else if (!markablestackable && product.stackCount === 0) {
                                // Stackable not allowed - treat as no stack
                                totalHeight = productHeight;
                            } else if (markablestackable && product.stackCount > 0) {
                                // Stackable allowed - calculate with stack count
                                totalHeight = productHeight * product.stackCount;
                            }else {
                                // Has stacks - calculate the top position of all stacked products
                                // stackCount represents number of products stacked on top of the base product
                                totalHeight = productHeight * product.stackCount;
                            }

                            // Find the MAXIMUM height (tallest product) on this shelf
                            if (totalHeight > maxTopHeight || maxTopHeight === 0) {
                                maxTopHeight = totalHeight;
                            }
                        });
                        topHeightArray.push({
                            fieldId: field.actualFieldId,
                            shelfRank: shelf.rank,
                            topHeight: maxTopHeight
                        });
                    }   
                }); 
            }
        });

        this.setState({ topProductHeights : topHeightArray });

    }

    // 2026 FEB - DU Edit CR
    // Check if shelf aligns with shelf hole positions
    isShelfAlignedWithShelfHoles = (field, shelf) => {
        if (!field.simulationDefaultGap) return true; 

        const gapInDrawUnits = field.simulationDefaultGap * this.state.displayRatio;
        const tolerance = 2;

        // Calculate the bottom of the shelf (y + drawHeight)
        const shelfBottom = shelf.y + shelf.drawHeight;

        // Use simulationShelfStartPoint from the bottom upward, or default to field bottom
        const fieldBottom = field.y + field.drawHeight;

        const startPoint = field.simulationShelfStartPoint
            ? (fieldBottom - (field.simulationShelfStartPoint * this.state.displayRatio))
            : fieldBottom;

        // Calculate available height from start point to top of field
        const availableHeight = startPoint - field.y;
        const dotCount = Math.floor(availableHeight / gapInDrawUnits);

        for (let i = 0; i <= dotCount; i++) {
            const dotY = startPoint - (i * gapInDrawUnits);
            const difference = Math.abs(shelfBottom - dotY);
            const isMatch = difference <= tolerance;

            if (isMatch) {
                return true;
            }
        }

        return false;
    };

    // 2026 FEB - DU Edit CR
    // Full screen hole positions match the shelf holes
    isShelfAlignedWithShelfHolesFullscreen = (field, shelf) => {
        if (!field.simulationDefaultGap) return true;

        const normalField = this.state.mapFields && this.state.mapFields[field.field_custom_id];
        if (!normalField) return true;

        const normalShelf = normalField.shelf && normalField.shelf.find(s => s.rank === shelf.rank);
        if (!normalShelf) return true;

        return this.isShelfAlignedWithShelfHoles(normalField, normalShelf);
    };

    // 2026 FEB - Update shelfIDs for existing pegboards that intersect with shelves
    updatePegBoardShelfIDs = (pegBoards, mapFields) => {
        if (!pegBoards || !Array.isArray(pegBoards) || pegBoards.length === 0) {
            return pegBoards;
        }

        if (!mapFields || Object.keys(mapFields).length === 0) {
            return pegBoards;
        }
        
        const updatedPegBoards = pegBoards.map(pegBoard => {

            // Only update if pegDrawingRect exists and shelfIDs is empty or missing
            // if (!pegBoard.pegDrawingRect || (pegBoard.pegDrawingRect.shelfIDs && pegBoard.pegDrawingRect.shelfIDs.length > 0)) {
            //     return pegBoard;
            // }

            const pegRect = pegBoard.pegDrawingRect;
            const pegY1 = pegRect.drawY || 0;
            const pegY2 = (pegRect.drawY || 0) + (pegRect.drawRectHeight || 0);
            const pegX1 = pegRect.drawX || 0;
            const pegX2 = (pegRect.drawX || 0) + (pegRect.drawRectWidth || 0);

            const intersectedShelfRanks = [];

            // Check intersection with all fields
            Object.values(mapFields).forEach(field => {
                // Check if pegboard intersects with this field horizontally
                const fieldX1 = field.x;
                const fieldX2 = field.x + field.drawWidth;
                const isXOverlap = (pegX1 < fieldX2) && (pegX2 > fieldX1);

                if (!isXOverlap || !field.shelf || field.shelf.length === 0) {
                    return;
                }

                // Check which shelves in this field intersect with pegboard
                field.shelf.forEach(shelf => {
                    const shelfY1 = shelf.y;
                    const shelfY2 = shelf.y + shelf.drawHeight + (shelf.drawGap || 0);

                    // Check vertical overlap
                    const isYOverlap = (pegY1 < shelfY2) && (pegY2 > shelfY1);

                    if (isYOverlap && !intersectedShelfRanks.includes(shelf.rank)) {
                        intersectedShelfRanks.push(shelf.rank);
                    }
                });
            });

            // Return updated pegboard with shelfIDs inside pegDrawingRect
            return {
                ...pegBoard,
                pegDrawingRect: {
                    ...pegBoard.pegDrawingRect,
                    shelfIDs: intersectedShelfRanks
                }
            };
        });

        return updatedPegBoards;
    };

    // 2026 FEB - DU Edit CR
    // Check if all shelves in fields with simulationDefaultGap are aligned
    areAllShelvesAligned = () => {
        const { mapFields, pegList } = this.state;

        if (!mapFields || Object.keys(mapFields).length === 0) {
            return true;
        }

        for (const fieldKey in mapFields) {
            const field = mapFields[fieldKey];

            if (field.simulationDefaultGap && field.shelf && field.shelf.length > 0) {

                const lastShelfRank = field.shelf[field.shelf.length - 1].rank;

                for (const shelf of field.shelf) {
                    // Skip the bottom/last shelf - it doesn't need to align with holes
                    if (shelf.rank === lastShelfRank) {
                        continue;
                    }

                    // Skip shelves that are behind pegboards
                    const isBehindPegboard = pegList && pegList.some(peg =>
                        peg.pegDrawingRect && peg.pegDrawingRect.fieldIDs && peg.pegDrawingRect.fieldIDs.includes(field.actualFieldId) &&
                        peg.pegDrawingRect && peg.pegDrawingRect.shelfIDs && peg.pegDrawingRect.shelfIDs.includes(shelf.rank)
                    );

                    if (isBehindPegboard) {
                        continue; // Skip alignment check for shelves behind pegboards
                    }

                    const isAligned = this.isShelfAlignedWithShelfHoles(field, shelf);
                    if (!isAligned) {
                        return false; // At least one shelf is not aligned
                    }
                }
            }
        }

        return true; // All shelves are aligned
    };

    // 2026 FEB - DU Edit CR
    // Show shelf mismatch warning once after copy arrangement is applied
    checkAndShowCopyArrangementShelfMismatch = () => {

        if (!this.props.isReSimulateAfterCopyArrangement) return;

        if (this.state.isShelfMismatchWarningShown) return;

        // Check if any shelf is misaligned
        if (!this.areAllShelvesAligned()) {
            this.setState({
                isShelfMismatchWarningShown: true,
                isShowShelfDifferentCopyArrangementModal: true,
                setUnsavedChangesModalData: {
                    title: 'SHELF_HOLE_MISMATCH_TITLE',
                    desc: 'SHELF_HOLE_MISMATCH_DESC',
                    callBack: () => this.clearInitialShelfMismtachWarning()
                }
            });
        }
    };

    // 2026 FEB - DU Edit CR
    // close the shelf mismatch warning
    clearInitialShelfMismtachWarning = () => {
        this.setState({isShowShelfDifferentCopyArrangementModal : false});
    }

    render() {
        var {fullscreenObj,mapFields,mapproductList, pegProductList, isAddProucts,addedProductsCounter,
            svgdrawDiemention,fieldsWithAnomaly, isShowPreviewNewProds, isShowNewProds,
            cutNewArray, actualFieldStructures, isDisableEDitingwithfullscreen, nonfilteredNonEProducts,originalDataPanelList,summaryViewObj,summarySubCategory,extractSubcat,categoryPercentages,filteredList, currentSelectedRecBlock, historyData, showDUEditComponent} = this.state;
            // let { isAuiViewsAllow, simulationObj, isSCycle, isSalesCycle, isShowFromPreview, ConversionAvailabilityDetails, isCustomPushEnabled,productEditWarningsList } = this.props;
        let { isAuiViewsAllow, simulationObj, isSCycle, isSalesCycle, isShowFromPreview, ConversionAvailabilityDetails, isCustomPushEnabled, productEditWarningsList } = this.props;
        let editwrapper = document.getElementById(this.state.wrapperId);
        var mapCategories = this.state.mapCatRects;
        let filteredcutNewArray = cutNewArray.filter(x=>x.isDelete!==true);
        //mapCatRects,mapSubCatRects,mapBrandrects, console.log((editwrapper?editwrapper.clientWidth:0));
        let reduceViewHeight = (this.props.simType !== "AUI" && this.props.isShowCleanSnapshotWarn?true:false);
        //imported prod list
        let importedDataObj = this.props.importedDataObj;
        // console.log(importedDataObj);
        let isFullscreenIdShow = (this.props.isIsleSimulation || this.props.isSetFullScreenEditModal);
        // Get all brands from hierarchy data (includes brands without products)
        const allHierarchyBrands = this.state.hierarchyData?.brands
            ? Array.from(this.state.hierarchyData.brands.values()).map(brand => brand.brandName)
            : [];
        // Combine brands from products and hierarchy, remove duplicates
        const productBrands = originalDataPanelList.map(product => product?.brand?.brandName);
        const barndList = [...new Set([...productBrands, ...allHierarchyBrands])].filter(Boolean);
        // Get all subcategories from hierarchy data (includes subcategories without products)
        // Note: hierarchy uses 'subcategoryName' but we need to match product field 'subCategoryName'
        const allHierarchySubCats = this.state.hierarchyData?.subcategories
            ? Array.from(this.state.hierarchyData.subcategories.values()).map(subcat => subcat.lambdaData?.subcategoryName || subcat.subcategoryName)
            : [];
        // Combine subcategories from products and hierarchy, remove duplicates
        const productSubCats = originalDataPanelList.map(product => product?.subCat?.subCategoryName);
        const subCatList = [...new Set([...productSubCats, ...allHierarchySubCats])].filter(Boolean);

        const textContent = `65 cm`;
        const textWidth = textContent.length * 7;

        const duSettingButtonAlign = this.props.isRTL === 'rtl' ? { marginRight: "auto" } : { marginLeft: "auto" };

        const zoomLevel = Math.round(window.devicePixelRatio * 100);
        const customSvgW = (zoomLevel === 125) ? (360 + 80) : (360 + 300);

        const simOptionsView = (<Col
        {...(this.props.simType === "AUI" ? { md: 4 } : {})}
        >
            <Col xs={12} style={{ padding: "10px" }} className={"middle-section-cat" + (isShowFromPreview ? " sim-previewview" : "") + (reduceViewHeight ? " reduce-viewheight" : "")}> {/* ,height:this.state.catDivHeight+(this.props.simType !== "AUI"?130: (this.props.isSetFullScreenEditModal?130:70)) */}
                <Tab.Container activeKey={this.state.productTab} onSelect={this.handleclipbordopen}>
                    <Row>
                        <Col className='editprod-view'>
                            <Nav variant="pills" className="flex-row">

                                <Nav.Item>
                                    <Nav.Link eventKey="products">{this.props.t("products")}</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="clipboard">
                                        <span>{this.props.t("CLIPBOARD")}</span>
                                        {/* {this.state.cutArray.length>0?<span className='prevwCount'>{this.state.cutArray.length}</span>:<></>} */}
                                        {filteredcutNewArray.length > 0 ? <span className='prevwCount'>{filteredcutNewArray.length}</span> : <></>}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="notsimprods">
                                        <span>{this.props.t("NOT_SIM_PRODUCTS")}</span>
                                        {(this.state.isNonSimulatedDataReady && !this.state.isLoadingDataPanelLambda && this.state.nonSimProductsCount > 0) ? <span className='prevwCount'
                                        // style={{left: "98px"}}
                                        >{this.state.nonSimProductsCount}</span> : <></>}
                                    </Nav.Link>
                                </Nav.Item>
                                {/* <Nav.Item>
                                    <Nav.Link eventKey="rulewarnings">
                                        <span>{this.props.t("rules")}</span>
                                        {this.state.isRuleWarn.isshow ? <span className='warn-icon'><FeatherIcon icon="alert-triangle"
                                            color={(this.state.isRuleWarn.mainWarnStatus === "danger") ? "red" : (this.state.isRuleWarn.mainWarnStatus === "warning") ? "orange" : "green"}
                                            size={20} /></span> : <></>}
                                        
                                    </Nav.Link>
                                </Nav.Item> */}
                                {isAuiViewsAllow || isShowFromPreview ? <Nav.Item>
                                    <Nav.Link eventKey="replaceProds">
                                        <span>{this.props.t("replaced")}</span>
                                        {this.state.replaceProds && this.state.replaceProds.length > 0 ? <span className='prevwCount'>{this.state.replaceProds.length}</span> : <></>}
                                    </Nav.Link>
                                </Nav.Item> : <></>}
                                <Nav.Item>
                                    <Nav.Link eventKey="changedProducts">
                                    <span>{this.props.t("Data_updated")}</span>
                                        {(productEditWarningsList.filter(p => p.isDelete !== true).length > 0) ? <span className='prevwCount'
                                        // style={{left: "98px"}}
                                        >{productEditWarningsList.filter(p => p.isDelete !== true).length}</span> : <></>}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="dataPanel">{this.props.t("dataPanel")}</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="pegBoard">
                                        <span>{this.props.t("PEG_BOARD")}</span>
                                        {this.state.pegList && this.state.pegList.length > 0 ? <span className='prevwCount'> {this.state.pegList.length} </span> : <></>}
                                    </Nav.Link>
                                </Nav.Item>
                                {/* {(this.state.isSCycle || this.props.isSalesCycle) ? <Nav.Item>
                                    <Nav.Link eventKey="saleCycle">
                                        {this.props.t('SALE_CYCLE')}
                                    </Nav.Link>
                                </Nav.Item> : <></>} */}

                            </Nav>
                        </Col>
                        <Col xs={12} className="Hproductsdiv" style={{ height: "auto" }}>
                            <Tab.Content>
                                <Tab.Pane eventKey="pegBoard">
                                    {/* Peg board creation content here */}
                                    <PegBoardTab
                                        isRTL={this.props.isRTL}
                                        pegList={this.state.pegList}
                                        handleAddPeg={this.handleAddPeg}
                                        handleAddPegHoles={this.handleAddPegHoles}
                                        enableNextPegBoardSetting={this.state.enableNextPegBoardSetting}
                                        handleDeletePeg={this.handleDeletePeg}
                                        handleEditPegHoles={this.handleEditPegHoles}
                                        handleUpdatePegHoles={this.handleUpdatePegHoles}
                                        isRectDrawingCompleted={this.state.isRectDrawingCompleted}
                                        catDivHeight={this.state.catDivHeight}
                                        simType={this.props.simType}
                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey="dataPanel">
                               
                                    {/* Filter Component */}
                                    <DataPanelFilter
                                        // departmentSubCategory={scFilter_subcategoryList}
                                        allBrands={barndList}
                                        allSubCat={subCatList}
                                        isRTL={this.props.isRTL}
                                        // combinedProducts={combinedProducts}
                                        onFilterChange={this.handleBrandFilterChange}
                                        onHangableFilterChange={this.handleHangableProductChange}
                                        isHangable={this.state.is_hangable}
                                        formValue={this.state.formValue}
                                        onFormValueChange={val => this.setState({ formValue: val })}
                                    // onCategoryFilterChange={this.handleCategoryFilterChange}
                                    />
                                    {/* Data Panel Tab */}
                                    <DataPanelTab
                                        dataPanelTab={this.state.dataPanelTab}
                                        handleDataPanelTab={this.handleDataPanelTab}
                                        toSimulateProduct={this.state.filteredList}
                                        hierarchyData={this.state.hierarchyData}
                                        copyArrangementProduct={[...this.props.simulationObj.products]}
                                        isCopyArrangement={this.props.isReSimulateAfterCopyArrangement}
                                        // brandList={mapproductList}
                                        // subCategoryList={mapproductList}
                                        catDivHeight={this.state.catDivHeight}
                                        simType={this.props.simType}
                                        // setSearchQuery={this.setSearchQuery}
                                        // nonfilteredNonEProducts={this.state.nonfilteredNonEProducts}
                                        isRTL={this.props.isRTL}
                                        drawRectCanvas={this.drawRectCanvas}
                                        dragStart={this.dragStart}
                                        dragProdView={this.dragProdView}
                                        prodDragEnd={this.prodDragEnd}
                                        handleopenDetailmodal={this.handleopenDetailmodal}
                                        handlePreviewModal={this.handlePreviewModal}
                                        copyToClipboard={this.copyToClipboard}
                                        loadingNow={this.state.loadingNow}
                                        onHangableFilterChange={this.handleHangableProductChange}
                                        setFilterModeChangeRef={this.setDataPanelTabFilterModeChangeRef}
                                        dmode={this.props.dmode}
                                        formValue={this.state.formValue}
                                        // generateDataPanelExcelExport={this.generateDataPanelExcelExport}
                                        isLoadingLambdaDataPanel={this.state.isLoadingDataPanelLambda}
                                        clusterData = {this.props.clusterData}
                                        EditionName={this.props?.EditionName}
                                        saleStartDate={this.props?.saleStartDate}
                                        saleEndDate={this.props?.saleEndDate}
                                        createdDate={this.props?.createdDate}
                                        selectedClusterId={this.props.selectedClusterId}
                                        actualFieldStructures={this.props.actualFieldStructures}
                                        processLambdaDataPanelResult={this.processLambdaDataPanelResult}
                                        isNewClipBoardTouched={this.state.isNewClipBoardTouched}
                                        historyData={this.state.historyData}
                                        hasChangesSinceLastRefresh={this.state.hasChangesSinceLastRefresh}
                                        handleSaveMP={this.handleSaveMP}
                                    />


                                </Tab.Pane>
                                <Tab.Pane eventKey="products">
                                    {isAddProucts ?
                                        <Col className='searchprodBox'>
                                            <span
                                                className="custom-btn"
                                                onClick={() => this.toggleprodAddNProdpanel()}
                                                style={{
                                                    ...(this.props.isRTL === "rtl" ? { float: "left" } : { float: "right" }),
                                                    ...(this.props.dmode ? { color: "#fff" } : {})
                                                }}
                                            >
                                                <XCircleFillIcon />
                                            </span>
                                            <h4>{this.props.t('productslist')}</h4>
                                            <InputGroup size="sm" className="mb-3 input-search">
                                                <Form.Control id="filterprodtxt" aria-label="Small" placeholder={this.props.t('srchproduct')} aria-describedby="inputGroup-sizing-sm" value={this.state.productSearchText} onChange={e => this.handleFilterProducts(e)} onKeyUp={e => this.handleFilterProducts(e)} />
                                                <InputGroup.Text id="inputGroup-sizing-sm"><SearchIcon size={18} /></InputGroup.Text>
                                            </InputGroup>

                                            <ButtonGroup style={{direction: "ltr"}} className={"pviewchange-list " + (this.props.isRTL === "rtl" ? "float-left" : "float-right")}>
                                                {this.props.isRTL === "rtl" ? (
                                                    <>
                                                        <Button variant="secondary" onClick={() => this.toggleProdListView("GRID")} className={(this.state.isListViewActive === "GRID" ? "active" : "")}><DiffAddedIcon size={14} /></Button>
                                                        <Button variant="secondary" onClick={() => this.toggleProdListView("LIST")} className={(this.state.isListViewActive === "LIST" ? "active" : "")}><ListUnorderedIcon size={14} /></Button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Button variant="secondary" onClick={() => this.toggleProdListView("LIST")} className={(this.state.isListViewActive === "LIST" ? "active" : "")}><ListUnorderedIcon size={14} /></Button>
                                                        <Button variant="secondary" onClick={() => this.toggleProdListView("GRID")} className={(this.state.isListViewActive === "GRID" ? "active" : "")}><DiffAddedIcon size={14} /></Button>
                                                    </>
                                                )}
                                            </ButtonGroup>

                                            {(this.state.isListViewActive !== null && this.state.recentProdList && this.state.filteredProdList.length === 0 ?
                                                <Col className="col-xs-12 div-con">
                                                    <h5> {this.props.t('recentlist')}</h5>
                                                    <Col xs={12} className="div-con subprod-list" style={{ height: this.props.simType === 'AUI' ? this.state.catDivHeight - 100 : this.state.catDivHeight + 150, overflow: 'auto' }}>
                                                        <Row style={this.props.isRTL === "rtl" ? { marginRight: "0px", width: "100%" } : { marginLeft: "0px", width: "100%" }}>
                                                            {(this.state.recentProdList ? this.state.recentProdList.map((prod, i) =>
                                                                <Col key={i} className={"sub-item" + (this.state.isListViewActive === "LIST" ? "" : " rectview")} xs={this.state.isListViewActive === "LIST" ? 12 : 4}><Col style={{ margin: 5 }}>

                                                                    <div onClick={() => this.handlePreviewModal(prod, true)}>
                                                                        <ProdRectView t={this.props.t} isRTL={this.props.isRTL} viewtype={this.state.isListViewActive} prod={prod}>
                                                                            <div className="thumb-div" draggable id={prod.id} ref={(r) => this[prod.id] = r} onMouseDown={(e) => { this.drawRectCanvas(prod) }} onDragStart={(e) => this.dragStart(e, prod)} onDrag={e => this.dragProdView(e, prod)} onDragEnd={() => this.prodDragEnd()}>
                                                                                {prod.imageUrl ? <img key={i} src={prod.imageUrl} className={prod.width >= prod.height ? "img-resize-ver" : "img-resize-hor"} alt="" /> :
                                                                                    <img key={i} src={NoIMage} className={prod.width >= prod.height ? "img-resize-ver" : "img-resize-hor"} alt="" />}
                                                                            </div>
                                                                        </ProdRectView>
                                                                    </div>
                                                                    {(this.state.isListViewActive === "LIST" ?
                                                                        <><CopyToClipboard text={prod.barcode} onCopy={() => this.copyToClipboard()}><small style={{ fontSize: "0.75rem" }}>{prod.barcode}</small></CopyToClipboard><br />{prod.productName}<br />
                                                                            <small>{this.props.t("brand") + ": "}{prod.brandName && prod.brandName !== "" && prod.brandName !== "-" ? (prod.brandName + " ") : (this.props.t("notavailable") + " ")}</small><br />
                                                                            <small style={{ fontSize: "0.75rem" }}><i>
                                                                                {this.props.t('WIDTH')}{(prod.width > 0 ? roundOffDecimal(prod.width, numOfDecimalsLimit) : prod.width) + "" + convertUomtoSym(prod.uom)},
                                                                                {this.props.t('HEIGHT')} {(prod.height > 0 ? roundOffDecimal(prod.height, numOfDecimalsLimit) : prod.height) + "" + convertUomtoSym(prod.uom)}</i></small></> : "")}
                                                                </Col></Col>) : (<></>))}

                                                        </Row>
                                                    </Col>
                                                </Col> : <></>)}

                                            {(this.state.isListViewActive !== null && this.state.filteredProdList && this.state.filteredProdList.length > 0 ?
                                                <Col className="col-xs-12 div-con">
                                                    <h5>{this.props.t('productslist')}</h5>
                                                    <Col xs={12} className="div-con subprod-list" style={{ height: this.props.simType === 'AUI' ? this.state.catDivHeight - 100 : this.state.catDivHeight + 150, overflow: 'auto' }}>
                                                        <Row style={this.props.isRTL === "rtl" ? { marginRight: "0px", width: "100%" } : { marginLeft: "0px", width: "100%" }}>
                                                            {(this.state.filteredProdList ? this.state.filteredProdList.map((prod, i) =>
                                                                <Col key={i} className={"sub-item" + (this.state.isListViewActive === "LIST" ? "" : " rectview")} xs={this.state.isListViewActive === "LIST" ? 12 : 4}><Col style={{ margin: 5 }}>

                                                                    <div onClick={() => this.handlePreviewModal(prod, true)}>
                                                                        <ProdRectView t={this.props.t} isRTL={this.props.isRTL} viewtype={this.state.isListViewActive} prod={prod}>
                                                                            <div className="thumb-div" draggable id={prod.id} ref={(r) => this[prod.id] = r} onMouseDown={(e) => { this.drawRectCanvas(prod) }} onDragStart={(e) => this.dragStart(e, prod)} onDrag={e => this.dragProdView(e, prod)} onDragEnd={() => this.prodDragEnd()}>
                                                                                {prod.imageUrl ? <img key={i} src={prod.imageUrl} className={prod.width >= prod.height ? "img-resize-ver" : "img-resize-hor"} alt="" /> :
                                                                                    <img key={i} src={NoIMage} className={prod.width >= prod.height ? "img-resize-ver" : "img-resize-hor"} alt="" />}
                                                                            </div>
                                                                        </ProdRectView>
                                                                    </div>
                                                                    {(this.state.isListViewActive === "LIST" ?
                                                                        <><CopyToClipboard text={prod.barcode} onCopy={() => this.copyToClipboard()}><small style={{ fontSize: "0.75rem" }}>{prod.barcode}</small></CopyToClipboard><br />
                                                                            <div style={{ cursor: "pointer" }} onClick={() => this.handleopenDetailmodal(prod)}>{prod.productName}<br />
                                                                                <small >{this.props.t("brand") + ": "}{prod.brandName && prod.brandName !== "" && prod.brandName !== "-" ? (prod.brandName + " ") : (this.props.t("notavailable") + " ")}</small><br />
                                                                                <small style={{ fontSize: "0.75rem" }}><i>{this.props.t('width')}: {(prod.width ? prod.width : " - ") + "" + convertUomtoSym(prod.uom)}, {this.props.t('height')}: {(prod.height ? prod.height : " - ") + "" + convertUomtoSym(prod.uom)}</i></small>

                                                                            </div>

                                                                        </> :
                                                                        <></>)}
                                                                </Col></Col>) : (<></>))}
                                                            {this.state.srchprodsloading ? <Col xs={12} className="text-center" style={{ marginBottom: "5px" }}><img src={loadinggif} className="img-fluid" style={{ height: "20px" }} alt="" /></Col> : <></>}
                                                        </Row>
                                                        {this.state.filteredProdList.length < this.state.ptotalresults ?
                                                            <Col xs={12} className="ploadmore-link text-center" onClick={() => { this.loadMoreProds() }}>{this.props.t('btnnames.loadmore')}</Col> : <></>}
                                                    </Col>
                                                </Col> : <></>)}
                                            {this.state.srchprodsloading && this.state.filteredProdList.length === 0 ?
                                                <div className='loadingprod-wrapper' style={{position: "absolute", top: "60%", margin: this.props.simType === 'AUI' ? window.devicePixelRatio > 1.01 ? "0 0px" : "0 10px": window.devicePixelRatio > 1.01 ? "0 160px" : "0 180px"}}><img src={loadinggif} className="img-fluid loadingProdPlanel" style={{ height: "30px" }} alt="" /></div>
                                                : <></>}
                                        </Col>
                                        :
                                        <Col className="prod_bar">
                                            {this.props.simType !== SimulationTypesFE.IsleAllocation ? 
                                                <ExportCSV 
                                                    t={this.props.t} 
                                                    isRTL={this.props.isRTL}
                                                    isSimView={true}
                                                    additionalIDs={(this.props.isSetFullScreenEditModal || this.props.isShowFromPreview ? "-fullview" : "")}
                                                    isShowFromPreview={this.props.isShowFromPreview}
                                                    selectedSimPreviewObj={this.props.selectedSimPreviewObj}
                                                    excelUploadPagination={this.state.excelUploadPagination}
                                                    paginationMaxCount={this.state.paginationMaxCount}
                                                    saveObj={this.props.defSaveObj}
                                                    bkpSaveObj={this.props.defSaveObj}
                                                    originatedMpId={this.props.originatedMpId}
                                                    handleAddProduct={this.handleAddProduct}
                                                    sendExcelData={this.sendExcelData}
                                                    setExcelUploadPagination={this.setExcelUploadPagination}
                                                    toggleLoadingModal={this.props.toggleLoadingModal}
                                                    selectedEditionId={this.props.editionId}
                                                    selectedClusterId={this.props.selectedClusterId}
                                                    selectedFieldArrayId={this.props.selectFieldArrayId}
                                                    selectedViewTypeSimulation={this.props.selectedViewTypeSimulation}
                                            /> : <></>}

                                            <Col className='newprods'>
                                                <NewProductsTab t={this.props.t} isRTL={this.props.isRTL}
                                                    addedProductsCounter={addedProductsCounter}
                                                    additionalIDs={(this.props.isSetFullScreenEditModal || this.props.isShowFromPreview ? "-fullview" : "")}
                                                    isShowFromPreview={this.props.isShowFromPreview}
                                                    selectedSimPreviewObj={this.props.selectedSimPreviewObj}
                                                    importedScrollHeight={this._importedScrollHeight}
                                                    importedDataObj={importedDataObj}
                                                    excelStartIndex={importedDataObj ? importedDataObj.excelStartIndex : -1}
                                                    totalExcelProdCount={importedDataObj ? importedDataObj.totalExcelProdCount : 0}
                                                    excelUploadList={importedDataObj ? importedDataObj.excelUploadList : null}
                                                    excelSearchText={importedDataObj ? importedDataObj.excelSearchText : ""}
                                                    displayUOM={this.state.displayUOM}
                                                    displayRatio={this.state.displayRatio}
                                                    isImportDataLoading={importedDataObj ? importedDataObj.isImportDataLoading : false}
                                                    newProdTab={this.state.newProdTab}
                                                    simType={this.props.simType}
                                                    originatedMpId={this.props.originatedMpId}
                                                    saveObj={this.props.defSaveObj}
                                                    zoomDrawX={this.state.zoomDrawX}
                                                    drawRectCanvas={this.drawRectCanvas}
                                                    dragStart={this.dragStart}
                                                    ghostFromParent={this.ghostFromParent}
                                                    handlePreviewModal={this.handlePreviewModal}
                                                    loadImportProdList={this.loadImportProdList}
                                                    prodDragEnd={this.prodDragEnd}
                                                    setImportedProds={this.setImportedProds}
                                                    sendExcelData={this.sendExcelData}
                                                    toggleNewProdTab={this.toggleNewProdTab}
                                                    toggleLoadingModal={this.props.toggleLoadingModal}
                                                    updateImportedList={this.updateImportedList}
                                                    updateImportScrollList={this.updateImportScrollList}
                                                    updateExcelSearchText={this.updateExcelSearchText}
                                                    catDivHeight={this.state.catDivHeight}
                                                />
                                            </Col>
                                            {/* <Col className='removed_prods'>
                                                            <h6>{this.props.t("removeproducts")}</h6>
                                                            <Col md={12} className="prods">
                                                                <Row>
                                                                    {removedProductsCounter.length>0?removedProductsCounter.map((prod,i)=>
                                                                            <Col  className='prodbox' key={i} onClick={()=>this.handlePreviewModal(prod,true)}>
                                                                                <img draggable={false} src={prod.imageUrl } alt=""/>
                                                                                <span>{prod.qty}</span>
                                                                            </Col>
                                                                    ):<></>}

                                                                </Row>
                                                            </Col>
                                                        </Col> */}
                                        </Col>}
                                </Tab.Pane>
                                <Tab.Pane eventKey="clipboard">
                                    {this.state.isClipboardreload ? <EditSimulateClipBoard
                                        catDivHeight={this.state.catDivHeight}
                                        simType={this.props.simType}
                                        cutNewArray={filteredcutNewArray}
                                        cutArray={this.state.cutArray}
                                        clipDragType={this.state.clipDragType}
                                        cutDragObj={this._cutDragObj}
                                        displayRatio={this.state.displayRatio}
                                        zoomXRatio={this.state.zoomXRatio}
                                        dragStart={this.dragStart}
                                        dropCutblock={this.dropCutblock}
                                        drawRectCanvas={this.drawRectCanvas}
                                        ghostFromParent={this.ghostFromParent}
                                        setPreviewGuid={this.setPreviewGuid}
                                        toggleClipDragType={this.toggleClipDragType}
                                        updateSingleCutProduct={this.updateSingleCutProduct}
                                        xyChangeCoords={this.xyChangeCoords}
                                        clearAllCutProducts={this.clearAllCutProducts}
                                        clearSelectedCutProducts={this.clearSelectedCutProducts}
                                        dmode={this.props.dmode}
                                        isRTL={this.props.isRTL} 
                                        t={this.props.t}
                                    /> : <></>}
                                </Tab.Pane>
                                <Tab.Pane eventKey="notsimprods">
                                    <NoSimProductsComp
                                        handleopenDetailmodal={this.handleopenDetailmodal}
                                        selectedNonSimFilterCat={this.state.selectedNonSimFilterCat}
                                        selectedNonSimFiltersubCat={this.state.selectedNonSimFiltersubCat}
                                        selectedNonSimFilterBrand={this.state.selectedNonSimFilterBrand}
                                        selectedNonSimFilterSupp={this.state.selectedNonSimFilterSupp}
                                        nonsimFilter_brandsList={this.state.nonsimFilter_brandsList}
                                        nonsimFilter_categoryList={this.state.nonsimFilter_categoryList}
                                        nonsimFilter_subcategoryList={this.state.nonsimFilter_subcategoryList}
                                        nonsimFilter_supplierList={this.state.nonsimFilter_supplierList}
                                        catDivHeight={this.state.catDivHeight}
                                        simType={this.props.simType}
                                        noSim_filter={this.state.noSim_filter}
                                        togglenonSimFilter={this.togglenonSimFilter}
                                        drawRectCanvas={this.drawRectCanvas}
                                        dragStart={this.dragStart}
                                        dragProdView={this.dragProdView}
                                        prodDragEnd={this.prodDragEnd}
                                        handlePreviewModal={this.handlePreviewModal}
                                        handleFilterNoEProducts={this.handleFilterNoEProducts}
                                        copyToClipboard={this.copyToClipboard}
                                        isRTL={this.props.isRTL} t={this.props.t}
                                        nonfilteredNonEProducts={this.state.nonfilteredNonEProducts}
                                    />
                                </Tab.Pane>
                                {/* <Tab.Pane eventKey="rulewarnings">
                                    <RuleWarningsComp
                                        isRuleWarn={this.state.isRuleWarn}
                                        mapRulesList={this.state.mapRulesList}
                                        catDivHeight={this.state.catDivHeight}
                                        simType={this.props.simType}
                                        isRTL={this.props.isRTL} trans={this.props.t} />
                                </Tab.Pane> */}
                                <Tab.Pane eventKey="changedProducts">
                                    <DimensionChangedProdComp
                                        handlePreviewModal={this.handlePreviewModal}
                                        copyToClipboard={this.copyToClipboard}
                                        handleopenDetailmodal={this.handleopenDetailmodal}
                                        productEditWarningsList={productEditWarningsList}
                                        isRuleWarn={this.state.isRuleWarn}
                                        mapRulesList={this.state.mapRulesList}
                                        isRTL={this.props.isRTL} t={this.props.t}
                                        catDivHeight={this.state.catDivHeight}
                                        simType={this.props.simType}
                                        handleacknowledgeSimulationWarning={this.props.handleacknowledgeSimulationWarning} />
                                </Tab.Pane>
                                {isAuiViewsAllow || isShowFromPreview ? <Tab.Pane eventKey="replaceProds">
                                    <ReplaceProductsTab
                                        catDivHeight={this.state.catDivHeight}
                                        isRuleWarn={this.state.isRuleWarn}
                                        mapRulesList={this.state.mapRulesList}
                                        isRTL={this.props.isRTL} trans={this.props.t}
                                        replaceProds={this.state.replaceProds}
                                        viewSimID={this.state.viewSimID}
                                        copyToClipboard={this.copyToClipboard}
                                        getPageXYCords={this.getPageXYCords}
                                    />
                                </Tab.Pane> : <></>}
                                {/* <Tab.Pane eventKey="saleCycle">
                                    <SaleCycleComp
                                        isChainSaleCycle={this.props.isChainSaleCycle}
                                        scFilter_brandsList={this.state.scFilter_brandsList}
                                        scFilter_categoryList={this.state.scFilter_categoryList}
                                        scFilter_subcategoryList={this.state.scFilter_subcategoryList}
                                        scFilter_supplierList={this.state.scFilter_supplierList}
                                        scFilter_statusList={this.state.scFilter_statusList}
                                        selectedScFilterCat={this.state.selectedScFilterCat}
                                        selectedScFiltersubcat={this.state.selectedScFiltersubcat}
                                        selectedScFilterBrand={this.state.selectedScFilterBrand}
                                        selectedScFilterSupp={this.state.selectedScFilterSupp}
                                        selectedScFilterStat={this.state.selectedScFilterStat}
                                        toggleSCFilter={this.toggleSCFilter}
                                        sc_filter={this.state.sc_filter}
                                        handleFilterSCProducts={this.handleFilterSCProducts}
                                        nonfilteredSCProducts={this.state.nonfilteredSCProducts}
                                        copyToClipboard={this.copyToClipboard}
                                        handlePreviewModal={this.handlePreviewModal}
                                        showSelectedSCProduct={this.showSelectedSCProduct}
                                        selectedScProductId={this.state.selectedScProductId}
                                        isRTL={this.props.isRTL}
                                        t={this.props.t}
                                        dmode={this.props.dmode}
                                        catDivHeight={this.state.catDivHeight}
                                        simType={this.props.simType}
                                    />
                                </Tab.Pane> */}
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </Col>

        </Col>)


        return (
            <Col className={"MPSimulateOneModal "+(isShowFromPreview?" previewShow ":"")+(this.props.simType==="AUI"?this.props.isSetFullScreenEditModal || this.props.isShowFromPreview?"preview-SimulateOneModal":"aiuMPSimulateOneModal-Aui":this.props.simType!==SimulationTypesFE.AUI?"normal-SimulateOneModal":"")}  >
                 {this.props.isFullScreenEdit?<Button className='CloseModal-FE-Internalbtn' onClick={() => this.onHideCheck()}><XIcon size={21} /></Button>:<></>}
                <Col className="simulate-edit-wrapper">
                {/* <Button onClick={()=>this.checkoverlapingprod()}>check</Button> */}
                    <Row>
                        <Col 
                        {...(this.props.simType === "AUI" ? { md: isDisableEDitingwithfullscreen?12:this.props.isSetFullScreenEditModal?8:12 } : {})}
                        // style={{width: "75vw"}}
                        >

                            <Col ref={this.displaydivNew} xs={12} className={"middle-section "+(isShowFromPreview?" sim-previewview ":"")+(reduceViewHeight?" reduce-viewheight ":"")+(this.props.simType==="AUI"?"middle-section-Aui":"")}
                            // ref={this.displaydiv}
                            >
                            {!showDUEditComponent &&
                            <div className='sim-header-wrapper'>
                            <div className={"lables-sim "+(this.props.simType === "AUI"?this.props.isFullScreenEdit?"auiFSedit":"auiedit":"normaledit")}>
                                {
                                    this.props.isRelogram ? <div className='relogram-info'>{this.props.t("RELOGRAM")} : {this.props.originatedMpName}</div> : <></>
                                }
                                {simulationObj&&simulationObj.simulationSnapshotId>0? <TooltipWrapper placement="bottom" text= {this.props.t("SnapShot") + " - " + this.props.t("CLICK_TO_DELETE")}><span className={
                                                'snapshot-icon-sim clickable ' +
                                                (this.props.simType !== "AUI" ? "dep" : "editcat")
                                            }
                                            style={{
                                                color: "rgb(255, 115, 0)",
                                                border: "2px solid rgb(255, 115, 0)",
                                                borderRadius: "5px",
                                                display: "inline-block",
                                                padding: "1px 6px",
                                                margin: '-8px 2px 0 2px',
                                                cursor: "pointer"
                                            }}
                                            onClick={() => this.handleSnapshotClick()}
                                            ><FeatherIcon icon="bookmark"  size={14} />
                                </span></TooltipWrapper>:<></>}
                            </div>
                                {(this.props.isSalesCycle === false && this.props.isSCycle === false) ?<div className='xray xray-dep'>
                                    <ButtonGroup style={{marginTop:isDisableEDitingwithfullscreen?"20px":"0px"}}>
                                        <Button size="sm" className={this.state.xrayActive===4?"active":""}  onClick={()=>this.handleXrayDepView(4)}>{this.props.t("category")}</Button>
                                        <Button size="sm" className={this.state.xrayActive===2?"active":""}  onClick={()=>this.handleXrayDepView(2)}>{this.props.t("subcategory")}</Button>
                                        <Button size="sm" className={this.state.xrayActive===3?"active":""}  onClick={()=>this.handleXrayDepView(3)}>{this.props.t("brand")}</Button>
                                        <Button size="sm" className={this.state.xrayActive===1?"active":""}  onClick={()=>this.handleXrayDepView(1)}>{this.props.t("products")}</Button>
                                    </ButtonGroup>
                                </div>:<></>}
                            </div>
                            }

                                {!isDisableEDitingwithfullscreen && !showDUEditComponent ?<Col xs={12} className="svg-controllers controllerbox">
                                    <div style={{display:"flex", alignItems:"center", width:"100%"}}  >
                                        <SimEditToolBox
                                            t={this.props.t} isRTL={this.props.isRTL}
                                            isDisableEDitingwithfullscreen={this.state.isDisableEDitingwithfullscreen}
                                            isDisableEdits={this.state.isDisableEdits}
                                            mapproductList={mapproductList}
                                            contxtmenu={this.state.contxtmenu}
                                            zoomXRatio={this.state.zoomXRatio}
                                            activeTool={this.state.activeTool}
                                            markablestackable={this.state.markablestackable}
                                            loadingstackablecall={this.state.loadingstackablecall}
                                            IsShowStackables={this.state.IsShowStackables}
                                            isshowedit={this.state.isshowedit}
                                            historyData={this.state.historyData}
                                            isAddProucts={isAddProucts}
                                            print={this.print}
                                            printInit={this.printInit}
                                            areAllShelvesAligned={this.areAllShelvesAligned()}
                                            handleZoomInOut={this.handleZoomInOut}
                                            toggleZoompan={this.toggleZoompan}
                                            StackablemarkableToggle={this.StackablemarkableToggle}
                                            StackablemarkableAllToggle={this.StackablemarkableAllToggle}
                                            ToggleshowhideStack={this.ToggleshowhideStack}
                                            handleToolControls={this.handleToolControls}
                                            fieldHistoryRedo={this.fieldHistoryRedo}
                                            fieldHistoryUndo={this.fieldHistoryUndo}
                                            removeExpandOpts={this.removeExpandOpts}
                                            //allmarkablestackable={this.state.allmarkablestackable}
                                            />
                                        <div className={"toolbox showingbox"+(this.state.contxtmenu&&this.state.contxtmenu.isexpand?" expand":"")}>
                                            <ul className={"svg-toolkit newpgtop-btnlist list-inline"} style={{marginTop:"-2px", paddingRight:"0px"}}>
                                                <li className={"list-inline-item tool-controls-list"} style={{marginRight:"1px"}}>
                                                    {this.state.IsShowStackables?<Button variant="outline-dark"   className={"btn-with-icon "} size="sm" onClick={()=>this.ToggleshowhideStack()} title={this.props.t("HideStackable")}><FeatherIcon icon="eye-off"   size={16} /></Button>:
                                                    <Button variant="outline-dark"   className={"btn-with-icon "} size="sm" onClick={()=>this.ToggleshowhideStack()} title={this.props.t("ShowStackable")}><FeatherIcon icon="eye"   size={16} /></Button>}
                                                </li>
                                               {isAuiViewsAllow? <li className={"list-inline-item tool-controls-list hver"} style={{marginRight:"0px"}}><Button active={this.state.isShowNewProds} title={this.props.t("showhidenewproducts")} variant="outline-dark" onClick={() => this.handleShowNewProducts(!this.state.isShowNewProds)} className={"btn-with-icon "} size="sm"><NewReplaceProductIcon   /></Button></li>:<></>}
                                            </ul>
                                        </div>

                                        <div className='othertools'>
                                            {this.props.isShowFromPreview?
                                                <Button style={{marginRight:"5px"}} onClick={() => this.toggleNewProdPreview()} variant='outline-dark' className={"btn-with-icon newprod-link"} active={isShowPreviewNewProds} size="sm" title={this.props.t("showhidenewproducts")}><NewReplaceProductIcon /></Button>
                                            :<></>}

                                            <Button onClick={() => this.handleZoomInOut(true)} className={"btn-with-icon zoombtn"} size="sm" title={this.props.t("ZOOM_IN")}><PlusIcon size={16}  /></Button>
                                            <Button style={{marginLeft:"5px"}} onClick={() => this.handleZoomInOut(false)} className={"btn-with-icon zoombtn"} size="sm" title={this.props.t("ZOOM_OUT")}><DashIcon  size={16} /></Button>
                                            {/* {this.props.simType === "Normal" && this.props.selectedBrch !== null && <label className={"pure-material-switch plg-check-edit"} >
                                                <input type="checkbox" checked={this.state.isSCycle} onChange={this.handleSalesCycleAct} />
                                                <span style={{color:(this.props.dmode?'#2CC990':'#5128a0')}}>{this.props.t('SALE_CYCLE')}</span>
                                            </label>} */}


                                            {(((this.props.simType === "AUI" && this.props.isFullscreenEditModal)||this.props.simType !== "AUI"))?<Button style={{marginLeft:"5px"}} onClick={() => this.setFullscreenShow(true)} className={"btn-with-icon zoombtn"} size="sm" title={this.props.t("Full_Screen")}><FeatherIcon icon="maximize"  size={16} /></Button>:<></>}
                                            {((!isShowFromPreview && !this.props.isFullscreenEditModal)&&(this.props.simType==="AUI"))?<Button style={{marginLeft:"5px"}} onClick={() => this.handleFullscreenEdit(true)} className={"btn-with-icon zoombtn"} size="sm" title={this.props.t("Full_Screen")}><FeatherIcon icon="maximize-2"  size={16} /></Button>:<></>}
                                            {((this.props.isFullscreenEditModal)&&(this.props.simType==="AUI"))?<Button style={{marginLeft:"2px"}} onClick={() => this.onHideCheck()} className={"btn-with-icon zoombtn"} size="sm" title={this.props.t("MINIMIZE_Screen")}><FeatherIcon icon="minimize-2"  size={16} /></Button>:<></>}
                                            {/* {((this.props.isFullscreenEditModal)&&(this.props.simType==="AUI"))?<label className={this.props.isFullscreenEditModal?"pure-material-switch plg-check-fullscreen":"pure-material-switch plg-check"} >
                                                <input type="checkbox" checked={this.state.isSalesCycle} onChange={this.handleSalesCycleAct} />
                                                <span style={{color:(this.props.dmode?'#2CC990':'#5128a0')}}>{this.props.t('SALE_CYCLE')}</span>
                                            </label>:<></>} */}
                                            <Button style={{marginLeft:"5px"}} onClick={() => this.setState({showWarningModal : true})} className={"btn-with-icon zoombtn"} size="sm" title={this.props.t("ICON_KEY")}>
                                                <FeatherIcon icon="alert-triangle" size={18}/>
                                            </Button>
                                            
                                            {/* {(this.props.simType === "Normal" && !isCustomPushEnabled) && this.props.selectedBrch !== null && <label className={"pure-material-switch plg-check-edit"} > */}
                                            {/* { ( this.props.simType!=="AUI" || (this.props.simType==="AUI" && this.props.isNewProdSim) ) && <label className={"pure-material-switch plg-check-edit"}>
                                                <div className='Scycle'>
                                                {
                                                this.props.disableSCycle ?
                                                <TooltipWrapper placement="bottom" text={this.props.t('LESS_PRD')}>
                                                <div>
                                                    <span style={{color:(this.props.dmode?'#2CC990':'#4F4F4F')}}>{this.props.t('SALE_CYCLE')}</span>
                                                    <Switch disabled={this.props.disableSCycle} onChange={this.handleSalesCycleAct} checked={this.state.isSCycle} height={17} width={30} uncheckedIcon={true} checkedIcon={true}
                                                    handleDiameter={12} activeBoxShadow={"none"} className={"Scycleswitch"+(this.state.isSCycle?" checked":"")} onColor={"#f2f1ff"} offColor={"#f2f1ff"} offHandleColor={"#C2BFBF"} onHandleColor={this.props.dmode?"#2CC990":"#5128A0"} />
                                                    <InfoIcon size={16} color={"red"} />
                                                </div>
                                                </TooltipWrapper> :
                                                <>
                                                    <span style={{color:(this.props.dmode?'#2CC990':'#4F4F4F')}}>{this.props.t('SALE_CYCLE')}</span>
                                                    <Switch onChange={this.handleSalesCycleAct} checked={this.state.isSCycle} height={17} width={30} uncheckedIcon={true} checkedIcon={true}
                                                    handleDiameter={12} activeBoxShadow={"none"} className={"Scycleswitch"+(this.state.isSCycle?" checked":"")} onColor={"#f2f1ff"} offColor={"#f2f1ff"} offHandleColor={"#C2BFBF"} onHandleColor={this.props.dmode?"#2CC990":"#5128A0"} />
                                                    {   this.state.isSCycle && this.props.isChainSaleCycle &&
                                                            <PopoverWrapper cusid="salecycle-pop" trigger={["hover","focus"]}
                                                                text={
                                                                    <div>
                                                                          <h6>{this.props.t("SALECYCLE_MESSAGE")}</h6>
                                                                    </div>
                                                                } placement="top">
                                                                <FeatherIcon className="alrt" icon="alert-triangle" size={20}/>
                                                            </PopoverWrapper>
                                                    }
                                                </>

                                                }
                                                </div>
                                            </label>} */}

                                            {/* {((this.props.isFullscreenEditModal)&&(this.props.simType==="AUI"))?<label className={"pure-material-switch plg-check-fullscreen"} >
                                                <div className='Scycle'>
                                                        {this.props.disableSalesCycleState ?
                                                        <TooltipWrapper placement="bottom" text={this.props.t('LESS_PRD')}>
                                                            <div>
                                                                <span style={{color:(this.props.dmode?'#2CC990':'#4F4F4F')}}>{this.props.t('SALE_CYCLE')}</span>
                                                                <Switch disabled={this.props.disableSalesCycleState } onChange={this.handleSalesCycleAct} checked={this.state.isSalesCycle} height={17} width={30} uncheckedIcon={true} checkedIcon={true}
                                                                handleDiameter={12} activeBoxShadow={"none"} className={"Scycleswitch"+(this.state.isSalesCycle?" checked":"")} onColor={"#f2f1ff"} offColor={"#f2f1ff"} offHandleColor={"#C2BFBF"} onHandleColor={this.props.dmode?"#2CC990":"#5128A0"} />
                                                                <InfoIcon size={16} color={"red"} />
                                                            </div>
                                                        </TooltipWrapper>
                                                        :
                                                        <>
                                                            <span style={{color:(this.props.dmode?'#2CC990':'#4F4F4F')}}>{this.props.t('SALE_CYCLE')}</span>
                                                            <Switch onChange={this.handleSalesCycleAct} checked={this.state.isSalesCycle} height={17} width={30} uncheckedIcon={true} checkedIcon={true}
                                                            handleDiameter={12} activeBoxShadow={"none"} className={"Scycleswitch"+(this.state.isSalesCycle?" checked":"")} onColor={"#f2f1ff"} offColor={"#f2f1ff"} offHandleColor={"#C2BFBF"} onHandleColor={this.props.dmode?"#2CC990":"#5128A0"} />
                                                            {   this.state.isSalesCycle && this.props.isChainSaleCycle &&
                                                                <PopoverWrapper cusid="salecycle-pop" trigger={["hover","focus"]}
                                                                    text={
                                                                        <div>
                                                                            <h6>{this.props.t("SALECYCLE_MESSAGE")}</h6>
                                                                        </div>
                                                                    } placement="top">
                                                                    <FeatherIcon className="alrt" icon="alert-triangle" size={20}/>
                                                               </PopoverWrapper>
                                                            }
                                                        </>
                                                        }

                                                </div>
                                            </label>:<></>}
                                            {/* <Button style={{marginLeft:"5px"}} onClick={() => this.print()} className={"btn-with-icon zoombtn"} size="sm" title={this.props.t("print")}><FeatherIcon icon="print"  size={16} /></Button> */}
                                            {/* {!markablestackable?
                                                <Button  style={{marginLeft:"5px"}}  className={"btn-with-icon opendstackdivbt"} size="sm" >
                                                    <span onClick={()=>this.StackablemarkableToggle()} title={this.props.t("STACKABLE")}><FeatherIcon icon="layers"  size={16} /></span>
                                                {this.state.IsShowStackables?<span onClick={()=>this.ToggleshowhideStack()} title={this.props.t("HideStackable")}><FeatherIcon icon="eye-off"   size={16} /></span>:
                                                <span onClick={()=>this.ToggleshowhideStack()} title={this.props.t("ShowStackable")}><FeatherIcon icon="eye"   size={16} /></span>}

                                                    </Button>
                                                    :<></>}
                                            {markablestackable?
                                                <Button  style={{marginLeft:"5px"}}  className={"btn-with-icon opendstackdivbt"} size="sm">
                                                <FeatherIcon icon="layers"  size={16} />
                                                    <input className='maxstackcount' type="number" value={this.state.stackableCountofmark} onChange={(e)=>this.handletypemarkStackCout(e)} onKeyDown={ (evt) => (evt.key === 'e'||evt.key === '-'||evt.key === '.') && evt.preventDefault() } />
                                                    <span className='actionbtn-ok' onClick={()=>this.sendmarkStackableCall()}> <FeatherIcon icon="check"  size={14} /></span>
                                                    <span className='actionbtn-x'> <FeatherIcon icon="x"  size={14} onClick={()=>this.StackablemarkableToggle(true)} /></span>
                                                    {this.state.stackablemarkArray.length>0&&<span className='unsaved'>{this.state.stackablemarkArray.length}</span>}
                                                </Button>
                                            :<></>} */}
                                        </div>
                                        {this.props.simType !== "AUI" ?
                                            <div className='othertools' style={duSettingButtonAlign}>
                                                {/* 2025 SEP - DU EDIT CR */}
                                                <Button className="btn-with-icon" size="sm" onClick = {() => this.handleDisplayUnitEditPanel()}>
                                                    <FeatherIcon icon="tool" size={18} />
                                                </Button>
                                            </div>
                                        :<></>}
                                    </div>
                                </Col>:<></>}

                                {this.state.isviewcmenu2?<BlockContextMenu isRTL={this.props.isRTL}
                                    handlclose={() => this.setState({isviewcmenu2:false})}
                                    // handleBlockDelete={this.confirmingDeleteSelecteBlock}
                                    handleBlockDelete={this.handleBlockCut}
                                    handleBlockCut={this.handleBlockCut}
                                    xpos={this.state.isviewcmenu2?this.state.contxtmenu2.xpos:0} ypos={this.state.isviewcmenu2?this.state.contxtmenu2.ypos:0}/>
                                :<></>}

                                {this.state.isviewcmenu?<ContextMenu
                                    simType={this.props.simType} 
                                    isRTL={this.props.isRTL} 
                                    placeHolderText={this.props.t("EXPAND_NUMBER")}
                                    StackplaceHolderText={this.props.t("Stackable_Count")}
                                    integerErrorMessage={this.props.t("PLEASE_ENTER_INTEGER_VALUE")}
                                    validNumberErrorMessage={this.props.t("PLEASE_ENTER_VALID_NUMBER")}
                                    validPositiveNumberErrorMessage={this.props.t("PLEASE_ENTER_VALID_POSITIVE_NUMBER")}
                                    stackvalidNumberErrorMessage={this.props.t("Stackable_valid_error")}
                                    citem={this.state.contxtmenu.citem} 
                                    currentprod={this.state.currentInternalDraggableProd} 
                                    handlechangeobj={this.handleChangeObj}
                                    handledelete={this.handleDeleteProd} handleopenDetailmodal={this.handleopenDetailmodal}
                                    handledeleteall={this.handleDeleteAllProds} handlexpand={this.handleExpandProd} handlclose={() => this.setState({isviewcmenu:false, isGroupContexMenu: false})}
                                    cutContextItem={this.cutContextItem} 
                                    xpos={this.state.isviewcmenu?this.state.contxtmenu.xpos:0} 
                                    ypos={this.state.isviewcmenu?this.state.contxtmenu.ypos:0} 
                                    handlePreviewModal={this.handlePreviewModal} 
                                    copyToClipboard={this.copyToClipboard} 
                                    handleExpandNumberInput={this.handleExpandNumberInput}
                                    handleExpandStackInput={this.handleExpandStackInput}
                                    handleExpandNegativeNumberInput={this.handleExpandNegativeNumberInput}
                                    handleBlockCut={this.handleBlockCut}
                                    handleBlockDelete={this.handleBlockCut}
                                    isGroupContexMenu={this.state.isGroupContexMenu}
                                    parentRef = {this.displaydivNew}
                                    userData={this.props.signedobj && this.props.signedobj.signinDetails ? this.props.signedobj.signinDetails : null}
                                    isFullScreenAUI={this.props.isSetFullScreenEditModal || this.props.isShowFromPreview}
                                    />
                                :<></>}
                                {/* {simulationObj&&simulationObj.simulationSnapshotId>0? <TooltipWrapper placement="bottom" text= {this.props.t("SnapShot")}><span className={'snapshot_span '+(this.props.simType === "AUI"?"onecataui":'onecat')}><FeatherIcon icon="bookmark"  size={16} />
                                </span></TooltipWrapper>:<></>} */}
                                <Col id={this.state.wrapperId} className={"sim-wrapper"+(isShowFromPreview?" sim-previewview":"")+(reduceViewHeight?" reduce-viewheight":"")+(this.state.showDUEditComponent?" du-edited":"")} onScroll={this.removeExpandOpts}  ref={this.displaydiv}>  {/* style={{height:(this.state.catDivHeight+10)}} */}
                                    <Col className="drawing-div" style={this.props.simType !== "AUI" ? {maxWidth: "66vw"} : {}}>
                                        <React.Fragment>
                                            {(!this.state.showDUEditComponent && mapFields && !this.state.isPdfExporting && Object.keys(mapFields).length>0)&&<Col  className="single-simitem" onContextMenu={e => e.preventDefault()} style={{width: "100%"}}> {/* ,height:this.state.catDivHeight */}
                                                <svg id={this.state.svgViewId} viewBox={"0 0 "+svgdrawDiemention.drawWidth+" "+this.state.catDivHeight} width={(this.state.zoomXRatio > 0 && (editwrapper.clientWidth > svgdrawDiemention.drawWidth)?editwrapper.clientWidth:svgdrawDiemention.drawWidth)} style={{border: '0px solid rgb(81, 40, 160)'}}
                                                onMouseDown={(e) => this.svgMouseDown(e)} onMouseMove={(e)=>this.svgMouseMove(e)} onMouseUp={(e) => this.svgMouseUp(e)}
                                                ref={(ref) => this.drawSVG = ref} version="1.1" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" className={this.state.cursorChangeToPeg === true ? 'peg-enable':'peg-disable'}>  {/* height={this.state.catDivHeight} */}
                                                    
                                                    {(!this.state.showDUEditComponent && mapproductList && Object.keys(mapproductList).length > 0)? Object.keys(mapproductList).map((ProdS, prodtS) => {
                                                        var Sproduct = mapproductList[ProdS];
                                                        const maxProductCount = this.validateProductHeight(Sproduct);
                                                        const hanggedProduct = Sproduct?.isHanged ? true : false;

                                                        return <React.Fragment key={prodtS} >
                                                                { !Sproduct.isDelete&&<>
                                                                    {(Sproduct.isStackable&&this.state.IsShowStackables && !hanggedProduct)?(
                                                                        maxProductCount == 1 ? (<foreignObject   x={Sproduct.x} y={Sproduct.y-18} width={Sproduct.drawWidth} height={20}>
                                                                            <div
                                                                            // className='centered'
                                                                            style={{textAlign: "center"}}>
                                                                                <FeatherIcon icon="chevrons-up"  color={"#ED327A"} size={14} />
                                                                            </div>

                                                                        </foreignObject>):(
                                                                            [Array.from({length:maxProductCount}).map((_,index)=>{
                                                                                return(
                                                                                    <image
                                                                                id={Sproduct?.id}
                                                                                preserveAspectRatio="none"
                                                                                x={Sproduct.x}
                                                                                y={Sproduct.y - Sproduct.drawHeight * index}
                                                                                width={Sproduct.drawWidth}
                                                                                height={Sproduct.drawHeight}
                                                                                href={Sproduct.imageUrl}
                                                                                style={{
                                                                                    outline: "solid 1px #ED327A",
                                                                                }}
                                                                                />
                                                                                )
                                                                            })]
                                                                        )
                                                                    ):<></>}
                                                                </>}
                                                            </React.Fragment>
                                                        }):<></>
                                                    }
                                                    
                                                    {/* NEW WAY OF SHOWING FIELD DIMENSION - 2025 OCT*/}
                                                    {(!this.state.showDUEditComponent && mapFields && Object.keys(mapFields).length > 0) && Object.keys(mapFields).map((fld, f) => {
                                                        var Afld = mapFields[fld];
                                                        return<React.Fragment key={f}>
                                                            <rect 
                                                                width = {this.setLableWidth(Afld.drawWidth)} 
                                                                height = {this.state.spacefromtopsvgdraw} 
                                                                x = {Afld.x} 
                                                                y = {(Afld.y-this.state.spacefromtopsvgdraw) } 
                                                                fill = "#5128A0" 
                                                            />
                                                            <clipPath id={("simfieldN"+(this.props.isFullScreenEdit?"FC":"")+f)}>
                                                                <rect 
                                                                    width = {this.setLableWidth(Afld.drawWidth)} 
                                                                    height = {this.state.spacefromtopsvgdraw} 
                                                                    x = {Afld.x} 
                                                                    y = {(Afld.y-this.state.spacefromtopsvgdraw) } 
                                                                    fill = "#5128A0" />
                                                            </clipPath>

                                                            <g clipPath={"url(#simfieldN"+(this.props.isFullScreenEdit?"FC":"")+((this.props.simType)===SimulationTypesFE.IsleAllocation?"AilseAllo":"")+f+")"}>
                                                            <PopoverWrapper text={<div className='simdunit-name' >
                                                                    <div className='dname'>{Afld.fieldName}</div>
                                                                    {this.props.isRTL=== "rtl"?<div>{Afld.actualFieldWidth+" "+Afld.actualFieldUOM} :{this.props.t("width")} </div>:
                                                                        <div>{this.props.t("width")}: {Afld.actualFieldWidth+" "+Afld.actualFieldUOM}</div>
                                                                    }
                                                                    {this.props.isRTL=== "rtl"?<div>{Afld.actualFieldHeight+" "+Afld.actualFieldUOM} :{this.props.t("height")}</div>
                                                                    :<div>{this.props.t("height")}: {Afld.actualFieldHeight+" "+Afld.actualFieldUOM}</div>}

                                                                    {this.props.isRTL=== "rtl"?<div>{Afld.actualFieldDepth+" "+Afld.actualFieldUOM} :{this.props.t("depth")}</div>
                                                                    :<div>{this.props.t("depth")}: {Afld.actualFieldDepth+" "+Afld.actualFieldUOM}</div>}
                                                                </div>
                                                                } trigger={["hover","focus"]}>
                                                                    <text fill={"white"} x={(Afld.x+3) } y={(Afld.y-6)} className="small catnametag">{Afld.fieldName}</text>
                                                                </PopoverWrapper>
                                                            </g>
                                                        </React.Fragment>
                                                    })}

                                                    {(!this.state.showDUEditComponent && mapFields && Object.keys(mapFields).length > 0) && Object.keys(mapFields).map((Fld, f) => {
                                                        var fld = mapFields[Fld];
                                                        return<React.Fragment key={f}>
                                                            {/* PRE PLAN CR WITH FIELD DRAWING - 2025 NOV */}
                                                            {/* field left border */}
                                                            <line
                                                                x1={fld.x}
                                                                y1={fld.y}
                                                                x2={fld.x}
                                                                y2={fld.y + fld.drawHeight}
                                                                stroke={this.props.dmode?'#2CC990':'#5128a0'}
                                                                strokeWidth={4}
                                                                pointerEvents="none"
                                                            />
                                                            
                                                            {/* field right border */}
                                                            <line
                                                                x1={fld.x + fld.drawWidth}
                                                                y1={fld.y}
                                                                x2={fld.x + fld.drawWidth}
                                                                y2={fld.y + fld.drawHeight}
                                                                stroke={this.props.dmode?'#2CC990':'#5128a0'}
                                                                strokeWidth={4}
                                                                pointerEvents="none"
                                                            />

                                                            {/* field top border  */}
                                                            <line
                                                                x1={fld.x}
                                                                y1={fld.y}
                                                                x2={fld.x + fld.drawWidth}
                                                                y2={fld.y}
                                                                stroke={this.props.dmode?'#2CC990':'#5128a0'}
                                                                strokeWidth={1}
                                                                pointerEvents="none"
                                                            />

                                                            {/* field shelf */}
                                                            {!this.state.showDUEditComponent && fld.shelf.length > 0 ? fld.shelf.map((shlf, g) => {
                                                                // Check if this is the last shelf (bottom shelf)
                                                                const isLastShelf = shlf.rank === fld.shelf[fld.shelf.length - 1].rank;

                                                                // Check if shelf is aligned with dot positions
                                                                const isAligned = this.isShelfAlignedWithShelfHoles(fld, {
                                                                    ...shlf,
                                                                    y: shlf.y
                                                                });

                                                                // Check if shelf is behind a pegboard
                                                                const isBehindPegboard = this.state.pegList && this.state.pegList.some(peg =>
                                                                    peg.fieldIDs && peg.fieldIDs.includes(fld.actualFieldId) &&
                                                                    peg.pegDrawingRect && peg.pegDrawingRect.shelfIDs && peg.pegDrawingRect.shelfIDs.includes(shlf.rank)
                                                                );

                                                                // Determine shelf color based on alignment
                                                                const shelfColor = this.props.dmode ? '#2CC990' : '#5128a0';
                                                                const shelfMisalignedColor = '#ff0000'; // Red for misaligned shelves

                                                                // Use red color if misaligned and field has simulationDefaultGap
                                                                // But ignore the last shelf (bottom shelf) and shelves behind pegboards
                                                                const appliedColor = (!isAligned && fld.simulationDefaultGap && !isLastShelf && !isBehindPegboard) ? shelfMisalignedColor : shelfColor;

                                                                return (
                                                                    <React.Fragment key={g}>
                                                                        <line x1={shlf.previewguid.startX} y1={shlf.y} x2={shlf.previewguid.startX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />
                                                                        <line x1={shlf.previewguid.endX} y1={shlf.y} x2={shlf.previewguid.endX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />

                                                                        {/* <rect className={"sftrect"} width={shlf.drawWidth} height={shlf.drawHeight} x={shlf.x } y={shlf.y +0} style={{ strokeWidth: 1, stroke: (this.props.dmode?'#2CC990':'#5128a0'), fill: shlf.isDisable?'#897CA3':'transparent' }}
                                                                            /> */}
                                                                        <rect
                                                                            width={shlf.drawWidth}
                                                                            height={shlf.drawGap}
                                                                            x={shlf.x}
                                                                            y={(shlf.y + 0) + (shlf.drawHeight ? shlf.drawHeight : 0)}
                                                                            style={{ strokeWidth: 1, stroke: appliedColor, fill: appliedColor }} />

                                                                    </React.Fragment>
                                                                );
                                                            }):<></>}
                                                        </React.Fragment>
                                                    })}
                                                    
                                                    {/* SHOWING SHELF PLACING HOLES - 2025 FEB - DU EDIT CR */}
                                                    {/*  THIS PHASE WE ARE NOT GOING IMPLEMENT THIS FEATURE*/}
                                                    {(!mapFields && Object.keys(mapFields).length > 0) && Object.keys(mapFields).map((fld, f) => {
                                                        var fld = mapFields[fld];
                                                        return fld.simulationDefaultGap && (() => {
                                                            const gapInDrawUnits = fld.simulationDefaultGap * this.state.displayRatio;

                                                            // Use simulationShelfStartPoint from the bottom upward, or default to field bottom
                                                            const fieldBottom = fld.y + fld.drawHeight;
                                                            const startPoint = fld.simulationShelfStartPoint
                                                                ? (fieldBottom - (fld.simulationShelfStartPoint * this.state.displayRatio))
                                                                : fieldBottom;

                                                            // Calculate available height from start point to top of field
                                                            const availableHeight = startPoint - fld.y;
                                                            const dotCount = Math.floor(availableHeight / gapInDrawUnits);
                                                            const dots = [];

                                                            for (let i = 0; i <= dotCount; i++) {
                                                                const dotY = startPoint - (i * gapInDrawUnits);
                                                                if (dotY >= fld.y) {
                                                                    dots.push(
                                                                        <rect
                                                                            key={`dot-${i}`}
                                                                            x={fld.x - 2}
                                                                            y={dotY - 1}
                                                                            width={4}
                                                                            height={2}
                                                                            fill={this.state.dmode ? '#2CC990' : '#f9f8fb'}
                                                                            opacity={1}
                                                                        />
                                                                    );
                                                                }
                                                            }
                                                            return dots;
                                                        })()
                                                    })}

                                                    {(!this.state.showDUEditComponent && mapproductList && Object.keys(mapproductList).length > 0)? Object.keys(mapproductList).map((ProdS,prodtS) => {
                                                        var Sproduct = mapproductList[ProdS];
                                                        const maxProductCount = this.validateProductHeight(Sproduct);
                                                        const maxHeigth = this.validateProductFieldHeight(Sproduct);
                                                        const hanggedProduct = Sproduct?.isHanged ? true : false;

                                                        return <React.Fragment key={prodtS} >
                                                                { !Sproduct.isDelete&&<>
                                                                    {(Sproduct.isStackable&&this.state.IsShowStackables && !hanggedProduct)?(
                                                                        maxHeigth===1 ? (<foreignObject   x={Sproduct.x} y={Sproduct.y-18} width={Sproduct.drawWidth} height={20}>
                                                                            <div
                                                                            // className='centered'
                                                                            style={{textAlign: "center"}}>
                                                                                <FeatherIcon icon="chevrons-up"  color={"#ED327A"} size={14} />
                                                                            </div>

                                                                        </foreignObject>):(
                                                                            [Array.from({length:maxProductCount}).map((_,i)=>{
                                                                                const index = i + 1
                                                                                return(
                                                                                    <image
                                                                                id={Sproduct?.id}
                                                                                preserveAspectRatio="none"
                                                                                x={Sproduct.x}
                                                                                y={Sproduct.y - Sproduct.drawHeight * index}
                                                                                width={Sproduct.drawWidth}
                                                                                height={Sproduct.drawHeight}
                                                                                href={Sproduct.imageUrl}
                                                                                style={{
                                                                                    outline: "solid 1px #ED327A",
                                                                                }}
                                                                                />
                                                                                )
                                                    })]
                                                                        )
                                                                    ):<></>}
                                                                </>}
                                                            </React.Fragment>
                                                    }):<></>
                                                    }

                                                    {(!isSalesCycle && !isSCycle) && (mapCategories && Object.keys(mapCategories).length > 0)? Object.keys(mapCategories).map((cat, c) => {
                                                            var catrect = mapCategories[cat];
                                                            let catrectcolor = (getNameorIdorColorofBox(catrect, "color")?getNameorIdorColorofBox(catrect, "color"):"#F39C12");
                                                            let cattxtcolor = (checkColorIsLight(catrectcolor)?"#5128a0":"white");

                                                            return <React.Fragment key={c}>
                                                            {this.state.xrayActive===1 || this.state.xrayActive===4?
                                                            <React.Fragment>
                                                                {catrect.drawfromConShelf?<>
                                                                    {catrect.contain_shelves.map((crect,cr)=>{
                                                                        return <React.Fragment key={cr}>
                                                                        {crect.y > -1 && crect.height?<>
                                                                        <rect id={catrect.field_custom_id+"_"+catrect.id} className="category-box"   width={crect.drawWidth} height={crect.drawHeight} x={crect.x } y={crect.y +0} fill= {getNameorIdorColorofBox(catrect,"color")}  ref={(r) => this[cr] = r} />

                                                                        <clipPath id={("clip-"+(isFullscreenIdShow?"full-":"")+c+""+cr)}>
                                                                            <rect x={crect.x} y={crect.y} width={crect.drawWidth} height={20} />
                                                                        </clipPath>

                                                                        <g clipPath={"url(#clip-"+(isFullscreenIdShow?"full-":"")+(c+""+cr)+")"}>
                                                                            {/* <rect width={isSalesCycle && fieldsWithAnomaly.includes(catrect.field_custom_id)?68:54} height={20} x={crect.x+1 } y={crect.y +0} fill= {catrectcolor} id={c} ref={(r) => this[c] = r} />
                                                                            <text  fill={cattxtcolor} x={crect.x+5 } y={crect.y +13} className="small catnametag">{stringtrim(getNameorIdorColorofBox(catrect,"name"),10)} </text>
                                                                            {isSalesCycle && fieldsWithAnomaly.includes(catrect.field_custom_id) && Icons.Hazard(13,catrect.x+50,catrect.y +4)} */}
                                                                            { this.state.xrayActive===4 && catrect.type===MPBoxType.rule?
                                                                                <g>
                                                                                    <rect x={(crect.x +crect.drawWidth)- 17 } y={crect.y +0} fill={catrectcolor} height="15" width="15"></rect>
                                                                                    <text fill={cattxtcolor} x={(crect.x +crect.drawWidth)-13 } y={crect.y +12} className="small rule-label">R</text>
                                                                                </g>
                                                                            :<></> }
                                                                        </g></>:<></>}
                                                                        </React.Fragment>
                                                                    })}
                                                                </>:<>
                                                                    {/* {!isSalesCycle?<rect id={catrect.field_custom_id+"_"+catrect.id} className="category-box" onClick={()=>this.props.clickCategory(catrect,cat)}  width={catrect.drawWidth} height={catrect.drawHeight} x={catrect.x } y={catrect.y +0} fill= {getNameorIdorColorofBox(catrect,"color")}  ref={(r) => this[c] = r} />
                                                                    :<></>} */}
                                                                    <rect id={catrect.field_custom_id+"_"+catrect.id} className="category-box"   width={catrect.drawWidth} height={catrect.drawHeight} x={catrect.x } y={catrect.y +0} fill= {!isSalesCycle && !isSCycle?getNameorIdorColorofBox(catrect,"color"):"transparent"}  ref={(r) => this[c] = r} />
                                                                    <clipPath id={("clip-"+(isFullscreenIdShow?"full-":"")+c+"-nshelf")}>
                                                                        <rect width={catrect.drawWidth} x={catrect.x} y={catrect.y} height={20} />
                                                                    </clipPath>

                                                                    <g clipPath={"url(#clip-"+(isFullscreenIdShow?"full-":"")+c+"-nshelf)"}>
                                                                        {/* <rect  width={isSalesCycle && fieldsWithAnomaly.includes(catrect.field_custom_id)?68:54} height={20} x={catrect.x } y={catrect.y +0} fill= {catrectcolor} id={c} ref={(r) => this[c] = r} />
                                                                        <text  fill={cattxtcolor} x={catrect.x+5 } y={catrect.y +13} className="small catnametag">{stringtrim(getNameorIdorColorofBox(catrect,"name"),10)} </text>
                                                                        {isSalesCycle && fieldsWithAnomaly.includes(catrect.field_custom_id) && Icons.Hazard(13,catrect.x+50,catrect.y +4)} */}
                                                                        { this.state.xrayActive===4 && catrect.type===MPBoxType.rule?
                                                                        <g>
                                                                        <rect x={(catrect.x +catrect.drawWidth)-17 } y={catrect.y +0} fill={catrectcolor} height="15" width="15"></rect>
                                                                        <text  fill={cattxtcolor} x={(catrect.x +catrect.drawWidth)-13 } y={catrect.y +12} className="small rule-label">R</text>
                                                                        </g>
                                                                        :<></> }
                                                                    </g>
                                                                </>}

                                                            </React.Fragment>
                                                         :<></>}
                                                    </React.Fragment>
                                                    }) : <></>}

                                                    {/* Show available spaces in tag - NEW CODE FOR SHOWING SPACE TAG */}
                                                    {(!this.state.showDUEditComponent && mapFields && Object.keys(mapFields).length > 0) && Object.keys(mapFields).map((Fld, f) => {
                                                        var fld = mapFields[Fld];
                                                        return <React.Fragment key={f}>
                                                            {fld.shelf.length > 0 ? fld.shelf.map((shlf,g) => {
                                                                const freeSpacing = this.getFreeSpaceByFieldIdAndRank(fld?.actualFieldId, shlf?.rank);
                                                                let textWidth     = freeSpacing.length * 6;
                                                                if(shlf.rank !== fld.shelf[fld.shelf.length - 1].rank){
                                                                    return(
                                                                        <g direction={"ltr"} key={g}>
                                                                        {/* Shelf Rectangle */}
                                                                            <rect 
                                                                                width={textWidth} // Add padding around text
                                                                                height={10}   
                                                                                x={fld.x + (fld.drawWidth / 2) - (textWidth)/2} // Centering
                                                                                y={shlf.y + shlf.drawHeight} 
                                                                                fill="black"
                                                                                stroke="black" 
                                                                                strokeWidth="1"
                                                                            />
                                                                            <text 
                                                                                x={fld.x + (fld.drawWidth/2)} 
                                                                                y={(shlf.y + shlf.drawHeight + 8)} 
                                                                                fontSize="10" 
                                                                                fontWeight="normal" 
                                                                                fill="white" 
                                                                                textAnchor="middle"
                                                                            >
                                                                            {freeSpacing}
                                                                            </text>
                                                                        </g>
                                                                    )
                                                                }else{
                                                                    return(
                                                                        <g direction={"ltr"} key={g}>
                                                                            {/* Shelf Rectangle */}
                                                                            <rect 
                                                                                width={textWidth} // Add padding around text
                                                                                height={10}   
                                                                                x={fld.x + (fld.drawWidth / 2) - (textWidth)/2} // Centering
                                                                                y={shlf.y + shlf.drawHeight} 
                                                                                fill="black"
                                                                                stroke="black" 
                                                                                strokeWidth="1"
                                                                            />
                                                                            <PopoverWrapper text={<div className='simdunit-name'><div className='dname' style={{color:(this.props.dmode?'#2CC990':'#4F4F4F')}}>{freeSpacing}</div></div>} trigger={["hover","focus"]}>
                                                                                <text 
                                                                                    fontSize="10" 
                                                                                    fontWeight="normal" 
                                                                                    fill={"white"} 
                                                                                    textAnchor="middle"
                                                                                    x={fld.x + (fld.drawWidth/2)}
                                                                                    y={(shlf.y + shlf.drawHeight + 8)}
                                                                                >
                                                                                {freeSpacing}
                                                                                </text>
                                                                            </PopoverWrapper>
                                                                        </g>
                                                                    )
                                                                }
                                                            }):<></>}
                                                        </React.Fragment>
                                                    })}

                                                    {/* Render all drawing rects */}
                                                    {!this.state.showDUEditComponent && this.state.pegList && this.state.pegList.length > 0 && 
                                                        this.state.pegList.map((peg, index) => (
                                                            <rect 
                                                                key={peg?.id}
                                                                x={peg?.pegDrawingRect?.drawX} 
                                                                y={peg?.pegDrawingRect?.drawY} 
                                                                width={peg?.pegDrawingRect?.drawRectWidth} 
                                                                height={peg?.pegDrawingRect?.drawRectHeight} 
                                                                fill="#FFF" 
                                                                stroke="#000" 
                                                                strokeDasharray={[2,2]} 
                                                                strokeWidth={2}>
                                                            </rect>
                                                        ))
                                                    }

                                                    {/* Display peg board indexing label */}
                                                    {!this.state.showDUEditComponent && this.state.pegList && this.state.pegList.length > 0 && this.state.pegList.map((peg, index) => (
                                                        <text 
                                                            x={this.props.isRTL === 'ltr' ? peg?.pegDrawingRect?.drawX + 25 : peg?.pegDrawingRect?.drawX + peg?.pegDrawingRect?.drawRectWidth - 25} 
                                                            y={peg?.pegDrawingRect?.drawY + 10} 
                                                            fontSize="10" 
                                                            fontWeight="bold" 
                                                            fill="#a1a1a1ff" 
                                                            textAnchor="middle"
                                                        >{this.props.isRTL === 'ltr' ? this.props.t('PEG_BOARD')+' '+peg.name : peg.name+' '+this.props.t('PEG_BOARD')}</text> 
                                                    ))}

                                                    {/* drawing holes in created rect */}
                                                    {!this.state.showDUEditComponent && this.state.pegList && this.state.pegList.length > 0 && <> 
                                                         {/* Circles Grid using .map() */}
                                                            {currentSelectedRecBlock && currentSelectedRecBlock?.xPositions?.map((x) =>
                                                                currentSelectedRecBlock?.yPositions?.map((y) => (
                                                                    <circle key={`${x}-${y}`} cx={x} cy={y} r={2} fill="black" stroke="white" />
                                                                ))
                                                            )}
                                                        </>
                                                    }

                                                    {!this.state.showDUEditComponent && this.state.pegList && this.state.pegList.length > 0 &&
                                                        this.state.pegList.map((peg, index) => (    
                                                            peg?.pegCoordinations && peg?.pegCoordinations.length > 0 && peg?.pegCoordinations?.map((hole, index) => (
                                                                <circle key={hole?.refCode} cx={hole?.drawX} cy={hole?.drawY} r={2} fill="white" stroke="black" />
                                                            ))
                                                        ))
                                                    }

                                                    {(!this.state.showDUEditComponent && mapproductList && Object.keys(mapproductList).length > 0)? Object.keys(mapproductList).map((Prod, prodt) => {
                                                        var product = mapproductList[Prod];
                                                        var cintrlprodloc = this.state.currentInternalDraggableProd;
                                                        var cimgcolor = (cintrlprodloc && cintrlprodloc.prod.id===product.id?true:false);
                                                        var productSheflItem = (product.field_custom_id ?mapFields[product.field_custom_id]?.shelf.find(x => x.rank === product.shelfrank):null)

                                                        let isInGuideProds = (this.state.isFirstTimeDrawguid && this.state.guideProdList?this.state.guideProdList.findIndex(g => g.id === product.id):-1);
                                                        // Check for overlapping if isNewDiamsonChange is true
                                                        // let isOverlap = false;
                                                        // OLD CODE
                                                        // if (product.isNewDiamsonChange) {
                                                        //     Object.keys(mapproductList).forEach((OtherProd, otherIndex) => {
                                                        //         if (otherIndex !== prodt) {
                                                        //             const otherProduct = mapproductList[OtherProd];
                                                        //             if (isOverlapping(product, otherProduct)) {
                                                        //                 isOverlap = true;
                                                        //             }
                                                        //         }
                                                        //     });
                                                        // }

                                                        let isHightlightNewProd = (isShowPreviewNewProds?product.isPreviewNewProd:false);

                                                        var productValidateObject = this.validateProductWidth(mapproductList, mapFields);

                                                        return <React.Fragment key={prodt} >
                                                                { !product.isDelete && <>
                                                                    {/* {(product.isStackable&&this.state.IsShowStackables)?<foreignObject   x={product.x} y={product.y-18} width={product.drawWidth} height={product.drawHeight}>
                                                                        <div
                                                                        // className='centered'
                                                                        style={{textAlign: "center"}}>
                                                                            <FeatherIcon icon="chevrons-up"  color={"#ED327A"} size={14} />
                                                                        </div>

                                                                    </foreignObject>:<></>} */}

                                                                    {/* <image onMouseDown={(e)=>this.handleMouseClick(e,product,prodt)} pointerEvents="all" preserveAspectRatio="none" x={product.x+((product.drawWidth/2)-0)} y={(product.y-6)} width={15} height={20} href={simStackable}  style={{outline: "solid 1px rgb(204, 204, 204)"}} /> */}
                                                                    {(this.props.isSalesCycle || this.props.isSCycle) &&
                                                                        this.props.productsWithAnomaly.map(data => data.productId).includes(product.productId)? 
                                                                            <g>
                                                                                <TooltipWrapper placement="bottom" text={this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable)? isFinite(this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).salesCycle) ? this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).salesCycle.toFixed(2).replace(/\.?0+$/, '') : this.props.t("NO_SALES_DATA") : this.props.t("NO_SALES_DATA")} bcolor={this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable) ? isFinite(this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).salesCycle) ? this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "high" ? "red" : this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "low" ? "blue" : "white" : undefined : undefined}>
                                                                                    <g>
                                                                                        <rect 
                                                                                            className="other-box" 
                                                                                            width={product.drawWidth} 
                                                                                            height={this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable) ?  this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "high" || this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "low" ? productSheflItem?(productSheflItem.drawHeight+productSheflItem.drawGap):0 : product.drawHeight  : product.drawHeight} 
                                                                                            x={product.x}
                                                                                            y={(this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable) ? this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "high" || this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "low" ? (productSheflItem?productSheflItem.y:0) : product.y   : product.y )}
                                                                                            fill= "transparent"
                                                                                        />
                                                                                        <image 
                                                                                            id={product?.id} 
                                                                                            onMouseDown={(e) => this.handleMouseClick(e, product, prodt)} 
                                                                                            pointerEvents="all" 
                                                                                            preserveAspectRatio="none" 
                                                                                            x={product.x} 
                                                                                            y={product.y} 
                                                                                            width={product.drawWidth} 
                                                                                            height={product.drawHeight} 
                                                                                            href={product.imageUrl} 
                                                                                            style={{ outline: product?.mark_height_issue === true ? "solid 4px red" : (product.isStackable && this.state.IsShowStackables) ? this.state.selectedScProductId === product.productId ? this.props.dmode ? "solid 2px #2CC990" : "solid 2px #5128a0" : "solid 1px #ED327A" : this.state.selectedScProductId === product.productId ? this.props.dmode ? "solid 2px #2CC990" : "solid 2px #5128a0" : "solid 1px rgb(204, 204, 204)", opacity: (isShowNewProds || isShowPreviewNewProds ? ((product.isNewReplaced || isHightlightNewProd) ? 1 : 0.2) : 1) }} />
                                                                                    </g>
                                                                                </TooltipWrapper>
                                                                                    <rect 
                                                                                        className="other-box" 
                                                                                        width={product.drawWidth} 
                                                                                        height={this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable) ?  this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "high" || this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "low" ? productSheflItem?(productSheflItem.drawHeight+productSheflItem.drawGap):0 : product.drawHeight  : product.drawHeight} 
                                                                                        x={product.x}
                                                                                        y={(this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable) ? this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "high" || this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "low" ? (productSheflItem?productSheflItem.y:0) : product.y   : product.y )}
                                                                                        fill= {this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable) ?  this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "high" ? "#E90041" : this.props.productsWithAnomaly.find(prd => prd.productId === product.productId && prd.salesAvailable).anomaly === "low" ? "#2F80ED" : "transparent" : "transparent"}
                                                                                        fillOpacity="0.3" 
                                                                                        opacity="0.7" 
                                                                                        pointerEvents="none"
                                                                                        // onClick={()=>this.props.clickCategory(catrect,mapCategories)}
                                                                                    />
                                                                            </g>
                                                                        :
                                                                        <>
                                                                            {/* productValidateObject[product?.id] ? "solid 2px red" : */}
                                                                            {(() => {
                                                                                // For hanged products with price tag, position product below price tag
                                                                                const HasPriceTag = product?.hasPriceTag
                                                                                // priceTagHeight and priceTagGap are always in cm, multiply by displayRatio
                                                                                const priceTagHeightPx = (product?.priceTagHeight || 0) * this.state.displayRatio;
                                                                                const gapPx = (product?.priceTagGap || 0) * this.state.displayRatio;
                                                                                // For hanged products with price tag, X is centered on peg hole
                                                                                const productDisplayX = (product?.isHanged && HasPriceTag) ? product?.pegDrawX - (product.drawWidth / 2) : product.x;
                                                                                // When hasPriceTag, product starts below price tag (pegDrawY + priceTagHeight/2 + gap)
                                                                                const productDisplayY = (product?.isHanged && HasPriceTag) ? product?.pegDrawY + (priceTagHeightPx / 2) + gapPx : product.y;

                                                                                return (
                                                                                    <>
                                                                                        <image id={product?.id} onMouseDown={(e) => this.handleMouseClick(e, product, prodt)} pointerEvents="all" preserveAspectRatio="none" x={productDisplayX} y={productDisplayY} width={product.drawWidth} height={product.drawHeight} href={product.imageUrl}
                                                                                        style={{ outline: /*product?.mark_height_issue === true && product?.height > product?.previousShelfHeight*/ product?.height > product?.productPlaceShelfHeight ? "solid 4px red" : (product.isStackable && this.state.IsShowStackables) ? this.state.selectedScProductId === product.productId ? this.props.dmode ? "solid 2px #2CC990" : "solid 2px #5128a0" : "solid 1px #ED327A" : this.state.selectedScProductId === product.productId ? this.props.dmode ? "solid 2px #2CC990" : "solid 2px #5128a0" : "solid 1px rgb(204, 204, 204)", opacity: (isShowNewProds || isShowPreviewNewProds ? ((product.isNewReplaced || isHightlightNewProd) ? 1 : 0.2) : 1) }} />
                                                                                        {product?.isProductDelete === true && (
                                                                                            <rect
                                                                                                x={productDisplayX}
                                                                                                y={productDisplayY}
                                                                                                width={product.drawWidth}
                                                                                                height={product.drawHeight}
                                                                                                pointerEvents="none"
                                                                                                fill="red"
                                                                                                opacity="0.3" // semi-transparent red background
                                                                                            />
                                                                                        )}
                                                                                    </>
                                                                                );
                                                                            })()}

                                                                                {(product?.isNewDiamsonChange && product?.isOverlap) &&
                                                                                    <image
                                                                                        id={`${product?.id}-warning`}
                                                                                        href={warningImage}
                                                                                        title={this.props.t("RECTPER_WARN_PRODUCT")}
                                                                                        pointerEvents="none"
                                                                                        preserveAspectRatio="none"
                                                                                        x={product.x}
                                                                                        y={product.y}
                                                                                        width={12}
                                                                                        height={12}
                                                                                    />
                                                                                }
                                                                                {
                                                                                    product?.isProductDelete === true ? 
                                                                                        <image
                                                                                            id={product?.id}
                                                                                            href={warningImageRed}
                                                                                            title={this.props.t("RECTPER_WARN_PRODUCT")}
                                                                                            pointerEvents="none"
                                                                                            preserveAspectRatio="none"
                                                                                            x={product.x + 4} 
                                                                                            y={product.y}
                                                                                            width={12}
                                                                                            height={12}
                                                                                        /> : <></>
                                                                                } 
                                                                        </>
                                                                    }

                                                                    {/* Show hangged peg hole in red color - hide when product has price tag */}
                                                                    {(product?.isHanged && !product?.hasPriceTag) &&
                                                                        <circle key={product?.pegRefCode} cx={product?.pegDrawX} cy={product?.pegDrawY} r={2} fill="red" stroke="red" />
                                                                    }

                                                                    {/* Preview Price Tag for hanged products - centered on peg hole */}
                                                                    {(product?.isHanged && product?.hasPriceTag) &&  (() => {
                                                                        // priceTagHeight and priceTagGap are always in cm, multiply by displayRatio
                                                                        const priceTagHeightPx = (product?.priceTagHeight || 0) * this.state.displayRatio;
                                                                        const gapPx = (product?.priceTagGap || 0) * this.state.displayRatio;
                                                                        // Price tag X centered on peg hole (same as green box)
                                                                        const priceTagX = product?.pegDrawX - (product.drawWidth / 2);
                                                                        // Price tag Y centered on peg hole
                                                                        const priceTagY = product?.pegDrawY - (priceTagHeightPx/2);
                                                                        const totalHeight = priceTagHeightPx + gapPx + product.drawHeight;

                                                                        // Create modified product with adjusted coordinates for selection
                                                                        const productWithPriceTag = {
                                                                            ...product,
                                                                            x: priceTagX,
                                                                            y: priceTagY,
                                                                            drawHeight: totalHeight
                                                                        };

                                                                        return (
                                                                            <g key={`price-tag-${product?.pegRefCode || product?.id}`}>
                                                                                {/* Clickable area covering full height (price tag + gap + product) */}
                                                                                <rect
                                                                                    x={priceTagX}
                                                                                    y={priceTagY}
                                                                                    width={product.drawWidth}
                                                                                    height={totalHeight}
                                                                                    fill="transparent"
                                                                                    pointerEvents="all"
                                                                                    onMouseDown={(e) => this.handleMouseClick(e, productWithPriceTag, prodt)}
                                                                                />
                                                                                {/* Price Tag rectangle - centered on peg hole */}
                                                                                <rect
                                                                                    x={priceTagX}
                                                                                    y={priceTagY}
                                                                                    width={product.drawWidth}
                                                                                    height={priceTagHeightPx}
                                                                                    fill="white"
                                                                                    stroke="#000000"
                                                                                    strokeWidth={1}
                                                                                    pointerEvents="none"
                                                                                />
                                                                                {/* Price text */}
                                                                                <text
                                                                                    x={product?.pegDrawX}
                                                                                    y={priceTagY + (priceTagHeightPx / 2) + 3}
                                                                                    fill="#000000"
                                                                                    fontSize={8}
                                                                                    fontWeight="bold"
                                                                                    textAnchor="middle"
                                                                                    pointerEvents="none"
                                                                                >
                                                                                    {/* {product?.sell_price} */}
                                                                                </text>
                                                                                {/* Red dot centered on price tag to show hang point */}
                                                                                <circle
                                                                                    cx={product?.pegDrawX}
                                                                                    cy={product?.pegDrawY}
                                                                                    r={2}
                                                                                    fill="red"
                                                                                    stroke="red"
                                                                                    pointerEvents="none"
                                                                                />
                                                                            </g>
                                                                        );
                                                                    })()}

                                                                    {(cimgcolor && !this.state.markablestackable) && (() => {
                                                                        // Calculate total height including price tag if hasPriceTag is true
                                                                        const priceTagHeightPx = product?.hasPriceTag ? (product?.priceTagHeight * this.state.displayRatio) : 0;
                                                                        const gapPx = product?.hasPriceTag ? (product?.priceTagGap * this.state.displayRatio) : 0;
                                                                        const totalHeight = product?.isHanged && product?.hasPriceTag
                                                                            ? priceTagHeightPx + gapPx + product?.drawHeight
                                                                            : product?.drawHeight;
                                                                        // For hanged products with price tag, align selection rect with price tag (centered on peg hole)
                                                                        const selectionX = (product?.isHanged && product?.hasPriceTag)
                                                                            ? product?.pegDrawX - (product.drawWidth / 2)
                                                                            : product.x;
                                                                        const selectionY = (product?.isHanged && product?.hasPriceTag)
                                                                            ? product?.pegDrawY - (priceTagHeightPx / 2)
                                                                            : product.y;

                                                                        // Create modified product with adjusted coordinates for selection
                                                                        const productForSelection = (product?.isHanged && product?.hasPriceTag)
                                                                            ? { ...product, x: selectionX, y: selectionY, drawHeight: totalHeight }
                                                                            : product;

                                                                        return (
                                                                            <rect
                                                                                onMouseDown={(e)=>this.handleMouseClick(e, productForSelection, prodt)}
                                                                                x={selectionX}
                                                                                y={selectionY}
                                                                                width={product.drawWidth}
                                                                                height={totalHeight}
                                                                                style={{ fill: "#dc3545", fillOpacity:"0.4" }}
                                                                            />
                                                                        );
                                                                    })()}
                                                                    {/* {product.isStackable&& <rect onMouseDown={(e)=>this.handleMouseClick(e,product,prodt)} x={product.x} y={product.y} width={product.drawWidth} height={product.drawHeight} style={{ fill: "#dc3545", fillOpacity:"0.6" }}  />} */}
                                                                    {!this.props.isSalesCycle && !this.props.isSCycle && this.state.xrayActive === 3? (() => {
                                                                        // Calculate highlight position based on product type:
                                                                        // 1. Peg products WITH price tag: centered on peg hole, includes price tag
                                                                        // 2. Peg products WITHOUT price tag: use product.x/y directly
                                                                        // 3. Shelf products: use shelf position and height
                                                                        const brandPriceTagHeightPx = product?.hasPriceTag ? (product?.priceTagHeight * this.state.displayRatio) : 0;
                                                                        const brandGapPx = product?.hasPriceTag ? (product?.priceTagGap * this.state.displayRatio) : 0;

                                                                        let brandHighlightX, brandHighlightY, brandTotalHeight;
                                                                        if (product?.isHanged && product?.hasPriceTag && product?.pegDrawX !== undefined) {
                                                                            // Peg product WITH price tag - centered on peg hole
                                                                            brandHighlightX = product.pegDrawX - (product.drawWidth / 2);
                                                                            brandHighlightY = product.pegDrawY - (brandPriceTagHeightPx / 2);
                                                                            brandTotalHeight = brandPriceTagHeightPx + brandGapPx + product.drawHeight;
                                                                        } else if (product?.isHanged) {
                                                                            // Peg product WITHOUT price tag - use product position directly
                                                                            brandHighlightX = product.x;
                                                                            brandHighlightY = product.y;
                                                                            brandTotalHeight = product.drawHeight;
                                                                        } else {
                                                                            // Shelf product - use shelf position
                                                                            brandHighlightX = product.x;
                                                                            brandHighlightY = productSheflItem ? productSheflItem.y : product.y;
                                                                            brandTotalHeight = productSheflItem ? (productSheflItem.drawHeight + productSheflItem.drawGap) : product.drawHeight;
                                                                        }

                                                                        return <>
                                                                            <TooltipWrapperBrandnsubcat showdash={this.state.isshowdash} text={getNameorIdorColorofBox(product.brand,"name")}>
                                                                                <rect
                                                                                    className="other-box"
                                                                                    width={product.drawWidth}
                                                                                    height={brandTotalHeight}
                                                                                    x={brandHighlightX}
                                                                                    y={brandHighlightY}
                                                                                    fill= {(product.brand?getNameorIdorColorofBox(product.brand,"color"):"red")}
                                                                                />
                                                                            </TooltipWrapperBrandnsubcat>
                                                                        </>;
                                                                    })():<></>}

                                                                    {!this.props.isSalesCycle && !this.props.isSCycle && this.state.xrayActive === 2? (() => {
                                                                        // Calculate highlight position based on product type:
                                                                        // 1. Peg products WITH price tag: centered on peg hole, includes price tag
                                                                        // 2. Peg products WITHOUT price tag: use product.x/y directly
                                                                        // 3. Shelf products: use shelf position and height
                                                                        const subcatPriceTagHeightPx = product?.hasPriceTag ? (product?.priceTagHeight * this.state.displayRatio) : 0;
                                                                        const subcatGapPx = product?.hasPriceTag ? (product?.priceTagGap * this.state.displayRatio) : 0;

                                                                        let subcatHighlightX, subcatHighlightY, subcatTotalHeight;
                                                                        if (product?.isHanged && product?.hasPriceTag && product?.pegDrawX !== undefined) {
                                                                            // Peg product WITH price tag - centered on peg hole
                                                                            subcatHighlightX = product.pegDrawX - (product.drawWidth / 2);
                                                                            subcatHighlightY = product.pegDrawY - (subcatPriceTagHeightPx / 2);
                                                                            subcatTotalHeight = subcatPriceTagHeightPx + subcatGapPx + product.drawHeight;
                                                                        } else if (product?.isHanged) {
                                                                            // Peg product WITHOUT price tag - use product position directly
                                                                            subcatHighlightX = product.x;
                                                                            subcatHighlightY = product.y;
                                                                            subcatTotalHeight = product.drawHeight;
                                                                        } else {
                                                                            // Shelf product - use shelf position
                                                                            subcatHighlightX = product.x;
                                                                            subcatHighlightY = productSheflItem ? productSheflItem.y : product.y;
                                                                            subcatTotalHeight = productSheflItem ? (productSheflItem.drawHeight + productSheflItem.drawGap) : product.drawHeight;
                                                                        }

                                                                        return <>
                                                                            <TooltipWrapperBrandnsubcat showdash={this.state.isshowdash} text={product?.subcategory?.sub_category? getNameorIdorColorofBox(product.subcategory, "name") : getNameorIdorColorofBox(product, "name")}>
                                                                                <rect
                                                                                    className="other-box"
                                                                                    width={product.drawWidth}
                                                                                    height={subcatTotalHeight}
                                                                                    x={subcatHighlightX}
                                                                                    y={subcatHighlightY}
                                                                                    fill={(product?.subcategory?.sub_category? getNameorIdorColorofBox(product.subcategory, "color") : getNameorIdorColorofBox(product, "color"))}
                                                                                />
                                                                            </TooltipWrapperBrandnsubcat>
                                                                        </>;
                                                                    })():<></>}

                                                                    {(isInGuideProds > -1 && !product?.isHanged)? (() => {
                                                                        // For products with price tag, use pegDrawX/pegDrawY and total height
                                                                        const overlapPriceTagHeightPx = product?.hasPriceTag ? (product?.priceTagHeight * this.state.displayRatio) : 0;
                                                                        const overlapGapPx = product?.hasPriceTag ? (product?.priceTagGap * this.state.displayRatio) : 0;
                                                                        const overlapTotalHeight = (product?.isHanged && product?.hasPriceTag)
                                                                            ? overlapPriceTagHeightPx + overlapGapPx + product.drawHeight
                                                                            : product.drawHeight;
                                                                        const overlapX = (product?.isHanged && product?.hasPriceTag && product?.pegDrawX !== undefined)
                                                                            ? product.pegDrawX - (product.drawWidth / 2)
                                                                            : product.x;
                                                                        const overlapY = (product?.isHanged && product?.hasPriceTag && product?.pegDrawY)
                                                                            ? product.pegDrawY - (overlapPriceTagHeightPx/2)
                                                                            : product.y;

                                                                        return <rect className='redoverlap-box' width={product.drawWidth} height={overlapTotalHeight} x={overlapX} y={overlapY} fill="red" fillOpacity={0.8}></rect>;
                                                                    })():<></>}
                                                                </>}
                                                            </React.Fragment>
                                                        }):<></>
                                                    }

                                                    {(mapFields&&Object.keys(mapFields).length>0)&&Object.keys(mapFields).map((Fld,f)=>{
                                                        var fld = mapFields[Fld]
                                                        return<React.Fragment key={f}><g className={this.state.isContentDragging?'':'d-none'}>
                                                            {fld.shelf.length>0?fld.shelf.map((shlf,g)=><React.Fragment key={g}>
                                                                    <line x1={shlf.previewguid.startX} y1={shlf.y} x2={shlf.previewguid.startX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />
                                                                    <line x1={shlf.previewguid.endX} y1={shlf.y} x2={shlf.previewguid.endX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />

                                                                    <rect className={"sftrect "+(!shlf.isDisable?"sftrect-notdis":"")} ref={(r) => this[(f+""+g)] = r}
                                                                        onDragOver={(e) => this.dragEnd(e, shlf, this[(f+""+g)],false,null,true, g, fld)}
                                                                        // onMouseOut={(e) => this.dragClear(e, shlf, this[(f+""+g)])}
                                                                        onDragLeave={(e)=>this.dragClear(e, shlf, this[(f+""+g)])}
                                                                        onDrop={(e) => this.droppedNew(e, shlf, this[(f+""+g)], g, false, fld)} width={shlf.drawWidth} height={shlf.drawHeight} x={shlf.x } y={shlf.y +0} style={{ strokeWidth: 1, stroke: 'transparent', fill: 'transparent' }}
                                                                    />
                                                                    <rect width={shlf.drawWidth} height={shlf.drawGap} x={shlf.x} y={(shlf.y + 0)+(shlf.drawHeight?shlf.drawHeight:0)} style={{ strokeWidth: 1, stroke: 'transparent', fill: 'transparent' }} />
                                                                </React.Fragment>
                                                            ):<></>}
                                                        </g></React.Fragment>
                                                    })}

                                                    {(mapCategories && Object.keys(mapCategories).length > 0)? Object.keys(mapCategories).map((cat, c) => {
                                                        var catrect = mapCategories[cat];
                                                        let catrectcolor = (getNameorIdorColorofBox(catrect, "color")?getNameorIdorColorofBox(catrect, "color"):"#F39C12");
                                                        let cattxtcolor = (checkColorIsLight(catrectcolor)?"#5128a0":"white");

                                                        return <React.Fragment key={c}>
                                                            {this.state.xrayActive === 4?
                                                                <React.Fragment>
                                                                    {catrect.drawfromConShelf?<>
                                                                        {catrect.contain_shelves.map((crect,cr) => {
                                                                            return <React.Fragment key={cr}>
                                                                            {crect.y > -1 && crect.height?<>

                                                                            <g clipPath={"url(#clip-"+(isFullscreenIdShow?"full-":"")+(c+""+cr)+")"} >
                                                                                <rect width={(isSalesCycle || isSCycle) && fieldsWithAnomaly.includes(catrect.field_custom_id)?68:54} height={20} x={crect.x+1 } y={crect.y +0} fill= {catrectcolor} id={c} ref={(r) => this[c] = r} />
                                                                                <g>
                                                                                    <TooltipWrapper placement="bottom" text={getNameorIdorColorofBox(catrect,"name")}>
                                                                                        <text  fill={cattxtcolor} x={crect.x+5 } y={crect.y +13} className="small catnametag">{stringtrim(getNameorIdorColorofBox(catrect,"name"),10)}</text>
                                                                                    </TooltipWrapper>
                                                                                </g>
                                                                                {(isSalesCycle || isSCycle) && fieldsWithAnomaly.includes(catrect.field_custom_id) && Icons.Hazard(13,catrect.x+50,catrect.y +4)}
                                                                            </g></>:<></>}
                                                                            </React.Fragment>
                                                                        })}
                                                                    </>:<>
                                                                        <g clipPath={"url(#clip-"+(isFullscreenIdShow?"full-":"")+c+"-nshelf)"} >
                                                                            <rect  width={(isSalesCycle || isSCycle) && fieldsWithAnomaly.includes(catrect.field_custom_id)?68:54} height={20} x={catrect.x } y={catrect.y +0} fill= {catrectcolor} id={c} ref={(r) => this[c] = r} />
                                                                            <g>
                                                                                <TooltipWrapper placement="bottom" text={getNameorIdorColorofBox(catrect,"name")}>
                                                                                    <text  fill={cattxtcolor} x={catrect.x+5 } y={catrect.y +13} className="small catnametag">{stringtrim(getNameorIdorColorofBox(catrect,"name"),10)}</text>
                                                                                </TooltipWrapper>
                                                                            </g>
                                                                            {(isSalesCycle || isSCycle) && fieldsWithAnomaly.includes(catrect.field_custom_id) && Icons.Hazard(13,catrect.x+50,catrect.y +4)}
                                                                        </g>
                                                                    </>}
                                                                </React.Fragment>
                                                            :<></>}
                                                        </React.Fragment>
                                                    }):<></>}


                                                    {!this.state.showDUEditComponent && this.state.isshowdash && !this.state.isPegDrawing && !this.state.isPegDrawingShowdash?<>
                                                        <rect x={this.state.dashrect.x} y={this.state.dashrect.y} width={this.state.dashrect.width} height={this.state.dashrect.height} fill="none" stroke="green" strokeDasharray={[2,2]} strokeWidth={2}></rect>
                                                        {/* {this.state.dashrect.percentage > 1?<><rect fill="red" x={(this.state.dashrect.x+this.state.dashrect.width) - 50} y={this.state.dashrect.y} width={50} height={20}></rect>
                                                            <text fill="white" x={(this.state.dashrect.x+this.state.dashrect.width) - 40} y={(this.state.dashrect.y + 13)} fontSize="12" fontWeight={"700"}>{this.state.dashrect.percentage}%</text></>:<></>} */}
                                                        </>:<></>
                                                    }

                                                    {/* peg board drawing rect */}
                                                    {!this.state.showDUEditComponent && this.state.isPegDrawing && !this.state.isshowdash && this.state.isPegDrawingShowdash && <>
                                                        <rect 
                                                            x={this.state.pegDashrect.x} 
                                                            y={this.state.pegDashrect.y} 
                                                            width={this.state.pegDashrect.width} 
                                                            height={this.state.pegDashrect.height} 
                                                            fill="#FFF" 
                                                            stroke="#000" 
                                                            strokeDasharray={[2,2]} 
                                                            strokeWidth={2}>
                                                        </rect>
                                                    </>}

                                                    {/* NOTE - this rect only showing before the save the peg board*/}
                                                    {this.state.pegList && this.state.pegList.length > 0 && 
                                                        this.state.pegList.map((peg, index) => (
                                                            peg?.isPegBoardSaving && (
                                                                <rect 
                                                                    key={peg?.id}
                                                                    x={peg?.pegDrawingRect?.drawX} 
                                                                    y={peg?.pegDrawingRect?.drawY}
                                                                    width={peg?.pegDrawingRect?.drawRectWidth} 
                                                                    height={peg?.pegDrawingRect?.drawRectHeight} 
                                                                    fill="#FFF" 
                                                                    stroke="#000" 
                                                                    strokeDasharray={[2,2]} 
                                                                    strokeWidth={2}>
                                                                </rect>
                                                            )
                                                        ))
                                                    }

                                                    {(this.state.activeTool === "drawBlock" && this.state.currentInternalDraggableProd&&!this.state.markablestackable)?<>
                                                        <BlockRectangle checkSaftyMargin={this.state.checkSaftyMargin}
                                                        wrapperId={this.state.wrapperId}
                                                        zoomXRatio={this.state.zoomXRatio}
                                                        mapFields={this.state.mapFields} mapCatRects={this.state.mapCatRects} mapproductList={this.state.mapproductList}
                                                        curitem={this.state.currentInternalDraggableProd} saleSaftyMargin={this.state.saleSaftyMargin} locobj={this.state.selectedlocobj}
                                                        isblockmove={this.state.isblockmove} displayratio={this.state.displayRatio} displayuom={this.state.displayUOM}
                                                        isFirstTimeDrawguid={this.state.isFirstTimeDrawguid}
                                                        currentSelectedBlock={this.state.currentSelectedBlock}
                                                        ghostWrapperObj={this.state.ghostWrapperObj}
                                                        dragStart={this.dragStart} updateSaveObjChild={this.updateSaveObjChild}
                                                        updateProductList={this.updateProductList} updateCutList={this.updateCutList}
                                                        setPreviewGuid={this.setPreviewGuid}
                                                        handleBlockContextMenu={this.handleBlockContextMenu}
                                                        fieldHistoryAdd={this.fieldHistoryAdd}
                                                        TouchedCatListUpdate={this.TouchedCatListUpdate}
                                                        updateGhostObjDetails={this.updateGhostObjDetails}
                                                        actualFieldStructures={this.props.actualFieldStructures}
                                                        actualFieldStructuresNew={this.state.actualFieldStructures}
                                                        groupByProduct={this.groupByProduct}
                                                        removeGhost={this.state.removeGhost}
                                                        resetSelectBlockObj={this.resetSelectBlockObj}
                                                        resetSelectBlockObjData={this.resetSelectBlockObjData}
                                                        isPegDrawing={this.state.isRectDrawingCompleted}
                                                        pegList={this.state.pegList}
                                                        pegProductList={this.state.pegProductList}
                                                        handlePegProductAdd={this.handlePegProductAdd}
                                                        isRectDrawing={this.state.isPegDrawing}
                                                        />
                                                    </>:<></>}

                                                    {this.state.isAllowPan && this.state.activeTool === "pan"?
                                                        <rect x={0} y={0} width={(this.state.zoomXRatio > 0 && (editwrapper.clientWidth > svgdrawDiemention.drawWidth)?editwrapper.clientWidth:svgdrawDiemention.drawWidth)} height={this.state.catDivHeight} fill="rgba(255, 255, 255, 0.2)" stroke="none"></rect>
                                                    :<></>}
                                                </svg>
                                            </Col>
                                            }

                                        </React.Fragment>
                                    </Col>
                                </Col>
                    
                   {!this.props.isShowFromPreview && !this.props.isSetFullScreenEditModal?<div className="editsimulate-buttonsset" style={{paddingTop:(this.props.simType === "AUI" && !this.props.isShowFromPreview?this.props.isSetFullScreenEditModal?"0px":"0px":"0px")}}>
                        {/* <Button variant="secondary" className={"btn-save-cat back-link"} onClick={()=>this.handlebackbtn()}>{this.props.t("btnnames.back")}</Button> */}

                        {/* {this.props.simType!=="AUI"&& isAuiViewsAllow?
                        <Button
                            style={{visibility:(mapFields?"visible":"hidden"),
                            display:((this.props.simType)===SimulationTypesFE.IsleAllocation?"none":(this.props.isopenfromAffectedSimList?"none":"block"))}}
                            variant='success' className={"btn-save-cat "+(this.props.isRTL === "rtl"?"float-left":"float-right")}
                            disabled={ConversionAvailabilityDetails===undefined || (ConversionAvailabilityDetails && ConversionAvailabilityDetails.convertableFullCount===undefined) || (ConversionAvailabilityDetails && ConversionAvailabilityDetails.currentConvertedCount===undefined) || (ConversionAvailabilityDetails && ConversionAvailabilityDetails.currentConvertedCount > ConversionAvailabilityDetails.convertableFullCount) || (ConversionAvailabilityDetails !== null && (ConversionAvailabilityDetails.isAlreadyConverted || (ConversionAvailabilityDetails && ConversionAvailabilityDetails.currentConvertedCount === ConversionAvailabilityDetails.convertableFullCount)))}
                            onClick={()=>this.props.handleCreateNewAUI()}
                            >
                                {this.props.t("Create_new_AUI_version")+" "+(ConversionAvailabilityDetails!==null?(ConversionAvailabilityDetails.currentConvertedCount+"/"+ConversionAvailabilityDetails.convertableFullCount):"")}
                        </Button>:<></>} */}
                                            {/* <Button variant='success' className={"btn-save-cat "+(this.props.isRTL === "rtl"?"float-left":"float-right")}>{this.props.t("btnnames.export")}</Button> */}

                        {/* {this.props.simType === "AUI" ?
                        (this.props.originatedMpId || (this.props.originatedMpId === this.props.defSaveObj.mp_id)) ?
                        <>
                        { this.props.isRelogram !== true && (this.props.storeId > -1) || (this.props.storeId === -1 && this.props.selectedTagList.length > 0 && this.props.isNoTagAvailable) ?
                            <>
                                <Button variant='success' className={(this.props.simOption === "disconnected" ? this.props.newSnapshotId === -1 ?"disconnect-button-aui-edit" : "disconnect-button-aui-edit-enabled" : "disconnect-button-aui-edit") + " back-link "+ (this.props.isRTL === "rtl"?"float-left":"float-right")} disabled={!this.state.historyData.past.length>0} onClick={()=>this.disconnectDecider("disconnected")}>{this.props.t("Disconnect")}</Button>
                                {this.props.storeId > -1 || (this.props.storeId === -1 && this.props.isNoTagAvailable)?<Button variant='success' className={(this.props.simOption === "takeback" ? this.props.newSnapshotId === -1 ? "takeback-button-aui-edit" : "takeback-button-aui-edit-enabled" : "takeback-button-aui-edit") + " back-link "+ (this.props.isRTL === "rtl"?"float-left":"float-right")} disabled={!this.state.historyData.past.length>0} onClick={()=>this.saveSimulateConfirm("takeback")}>{this.props.t("TAKE_BACK")}</Button>:<></>}
                            </>
                            : this.props.isRelogram === true ? <></> :
                            <Button variant='success' className={"btn-save-cat back-link "+(this.props.isRTL === "rtl"?"float-left":"float-right")} disabled={(!this.state.isNewClipBoardTouched&& this.state.historyData.past.length===0)} onClick={()=>this.saveSimulateConfirm("none")}>{this.props.t("btnnames.save")}</Button>
                        }
                        </>
                        :
                        <></>
                        :  this.props.isReSimulateAfterCopyArrangement ? 
                                <Button variant='success' className={"btn-save-cat back-link "+(this.props.isRTL === "rtl"?"float-left":"float-right")} disabled={false} onClick={()=>this.saveSimulateConfirm("none")}>{this.props.t("btnnames.save")}</Button>
                            :
                        <Button variant='success' className={"btn-save-cat back-link "+(this.props.isRTL === "rtl"?"float-left":"float-right")} disabled={(!this.state.isNewClipBoardTouched&& this.state.historyData.past.length===0)} onClick={()=>this.saveSimulateConfirm("none")}>{this.props.t("btnnames.save")}</Button>
                        } */}
                        {!showDUEditComponent && (this.props.simType === "AUI" ? (
                              (this.props.originatedMpId || (this.props.originatedMpId === this.props.defSaveObj.mp_id)) ? (
                                <>
                                  {
                                    this.props.isRelogram !== true &&
                                    (
                                      (this.props.storeId > -1) ||
                                      (this.props.storeId === -1 &&
                                        this.props.selectedTagList.length > 0 &&
                                        this.props.isNoTagAvailable)
                                    ) ? (
                                      <>
                                        <Button
                                          variant='success'
                                          className={
                                            (this.props.simOption === "disconnected"
                                              ? (this.props.newSnapshotId === -1
                                                ? "disconnect-button-aui-edit"
                                                : "disconnect-button-aui-edit-enabled")
                                              : "disconnect-button-aui-edit"
                                            ) +
                                            " back-link " +
                                            (this.props.isRTL === "rtl" ? "float-left" : "float-right")
                                          }
                                          disabled={!this.state.historyData.past.length > 0}
                                          onClick={() => this.disconnectDecider("disconnected")}
                                        >
                                          {this.props.t("Disconnect")}
                                        </Button>
                                      
                                        {
                                          (this.props.storeId > -1 ||
                                            (this.props.storeId === -1 && this.props.isNoTagAvailable)) ? (
                                            <Button
                                              variant='success'
                                              className={
                                                (this.props.simOption === "takeback"
                                                  ? (this.props.newSnapshotId === -1
                                                    ? "takeback-button-aui-edit"
                                                    : "takeback-button-aui-edit-enabled")
                                                  : "takeback-button-aui-edit"
                                                ) +
                                                " back-link " +
                                                (this.props.isRTL === "rtl" ? "float-left" : "float-right")
                                              }
                                              disabled={!this.state.historyData.past.length > 0}
                                              onClick={() =>{
                                                this.saveSimulateConfirm("takeback", this.props.selectedClusterId, this.props.selectFieldArrayId)
                                                this.props.handleToggleForTakeBack(this.props.openIndexesForSideBar)
                                            }}
                                            >
                                              {this.props.t("TAKE_BACK")}
                                            </Button>
                                          ) : <></>
                                        }
                                      </>
                                    ) : (
                                      this.props.isRelogram === true ? <></> : (
                                        <Button
                                          variant='success'
                                          className={
                                            "btn-save-cat back-link " +
                                            (this.props.isRTL === "rtl" ? "float-left" : "float-right")
                                          }
                                          disabled={
                                            (!this.state.isNewClipBoardTouched &&
                                              this.state.historyData.past.length === 0)
                                          }
                                          onClick={() => this.saveSimulateConfirm("none")}
                                        >
                                          {this.props.t("btnnames.save")}
                                        </Button>
                                      )
                                    )
                                  }
                                </>
                              ) : <></>
                            ) : (
                              this.props.isReSimulateAfterCopyArrangement ? (
                                <Button
                                  variant='success'
                                  className={
                                    "btn-save-cat back-link " +
                                    (this.props.isRTL === "rtl" ? "float-left" : "float-right")
                                  }
                                  disabled={!this.areAllShelvesAligned()}
                                  onClick={() => this.saveSimulateConfirm("none")}
                                >
                                  {this.props.t("btnnames.save")}
                                </Button>
                              ) : (
                                // for AI simulate save button always enabled
                                this.props.isAIsimulate ? (
                                <Button
                                    variant='success'
                                    className={
                                        "btn-save-cat back-link " +
                                        (this.props.isRTL === "rtl" ? "float-left" : "float-right")
                                    }
                                    //disabled={!this.areAllShelvesAligned()}
                                    onClick={() => this.saveSimulateConfirm("none")}
                                    >
                                    {this.props.t("btnnames.save")}
                                    </Button>
                                ) : (
                                    <Button
                                    variant='success'
                                    className={
                                        "btn-save-cat back-link " +
                                        (this.props.isRTL === "rtl" ? "float-left" : "float-right")
                                    }
                                    disabled={
                                        (!this.state.isNewClipBoardTouched &&
                                        this.state.historyData.past.length === 0 &&
                                        !this.state.isDisplayUnitEdited) //|| !this.areAllShelvesAligned()
                                    }
                                    onClick={() => this.saveSimulateConfirm("none")}
                                    >
                                    {this.props.t("btnnames.save")}
                                    </Button>
                                )
                            )
                    ))}
                        
                    {/* <Button variant='primary' className={"btn-save-cat "+(this.props.isRTL === "rtl"?"float-left":"float-right")} disabled={!this.state.isFieldsMatching} onClick={()=>this.handleExportVMP()}>{this.props.t("export_to_vmp")}</Button> */}
                    </div>:<></>}
                            </Col>
                        </Col>
                        {!isDisableEDitingwithfullscreen && (
                            this.props.simType !== "AUI"
                                ? <PortalWrapper>{simOptionsView}</PortalWrapper>
                                : this.props.isSetFullScreenEditModal ? 
                                simOptionsView : <div style={{display: "none"}}>{simOptionsView}</div>
                        )}
                    </Row>

                    <div style={{display:"none"}}>
                        <canvas ref={this.dragPreviewCanvas}></canvas>
                    </div>

                        {!this.props.isShowFromPreview && this.props.isSetFullScreenEditModal?<div className="editsimulate-buttonsset-AUIFullScreen" style={{paddingTop:(this.props.simType === "AUI"?this.props.isSetFullScreenEditModal?"0px":"20px":"0px")}}>
                        <Button 
                            variant='secondary' 
                            className={"btn-save-cat"} 
                            disabled={!this.state.historyData.past.length>0} 
                            onClick={()=>this.handleResetEdit()}
                        >{this.props.t("btnnames.reset")}</Button>

                        {this.props.simType === "AUI"?

                        ((this.props.originatedMpId && this.props.originatedMpId === -1) || (this.props.originatedMpId === this.props.defSaveObj.mp_id)) ?
                        <>
                        { (this.props.storeId > -1) || (this.props.storeId === -1 && this.props.selectedTagList.length > 0 && this.props.isNoTagAvailable) ?
                            <>
                                <Button variant='success' className={(this.props.simOption === "disconnected" ? this.props.newSnapshotId === -1 ?"disconnect-button-aui-edit-fs" : "disconnect-button-aui-edit-fs-enabled" : "disconnect-button-aui-edit-fs")} disabled={!this.state.historyData.past.length>0} onClick={()=>this.disconnectDecider("disconnected")}>{this.props.t("Disconnect")}</Button>
                                {this.props.storeId > -1 || (this.props.storeId === -1 && this.props.isNoTagAvailable)?<Button variant='success' className={(this.props.simOption === "takeback" ? this.props.newSnapshotId === -1 ? "takeback-button-aui-edit-fs" : "takeback-button-aui-edit-fs-enabled" : "takeback-button-aui-edit-fs")} disabled={!this.state.historyData.past.length>0} onClick={()=>{

                                    this.props.handleToggleForTakeBack(this.props.openIndexesForSideBar); this.saveSimulateConfirm("takeback", this.props.selectedClusterId, this.props.selectFieldArrayId);}}>{this.props.t("TAKE_BACK")}</Button>:<></>}
                            </>
                            :
                            <Button
                                variant='success'
                                className={"btn-save-cat"}
                                disabled={(!this.state.historyData.past.length>0 && !this.state.isDisplayUnitEdited) || !this.areAllShelvesAligned()}
                                onClick={()=>this.saveSimulateConfirm("none")}
                            >{this.props.t("btnnames.save")}</Button>
                        }
                        </>
                        :
                        <></>
                        :
                        <Button
                            variant='success'
                            className={"btn-save-cat"}
                            disabled={(!this.state.historyData.past.length>0 && !this.state.isDisplayUnitEdited) || !this.areAllShelvesAligned()}
                            onClick={()=>this.saveSimulateConfirm("none")}>{this.props.t("btnnames.save")}</Button>
                        }
                    </div>:<></>}
                    {/* {
                        // console.log(this.props.isShowFromPreview,"____this.props.isShowFromPreview", this.props.isSetFullScreenEditModal,"___this.props.isSetFullScreenEditModal");
                    } */}
                    
                                        {/* {
                                            !this.props.isShowFromPreview && this.props.isSetFullScreenEditModal ? (
                                                <div
                                                className="editsimulate-buttonsset-AUIFullScreen"
                                                style={{  
                                                    paddingTop:
                                                    this.props.simType === "AUI"
                                                    ? this.props.isSetFullScreenEditModal
                                                        ? "0px"
                                                        : "20px"
                                                    : "0px",
                                                }}
                                                >
                                                <Button
                                                    variant="secondary"
                                                    className={"btn-save-cat"}
                                                    disabled={!this.state.historyData.past.length > 0}
                                                    onClick={() => this.handleResetEdit()}
                                                >
                                                {this.props.t("btnnames.reset")}
                                                </Button>
                                            
                                                {this.props.simType === "AUI" ? (
                                                    (this.props.originatedMpId && this.props.originatedMpId === -1) ||
                                                    this.props.originatedMpId === this.props.defSaveObj.mp_id ? (
                                                    <>
                                                        {(this.props.storeId > -1 ||
                                                        (this.props.storeId === -1 &&
                                                            this.props.selectedTagList.length > 0 &&
                                                            this.props.isNoTagAvailable)) ? (
                                                        <>
                                                            <Button
                                                            variant="success"
                                                            className={
                                                                this.props.simOption === "disconnected"
                                                                ? this.props.newSnapshotId === -1
                                                                    ? "disconnect-button-aui-edit-fs"
                                                                    : "disconnect-button-aui-edit-fs-enabled"
                                                                : "disconnect-button-aui-edit-fs"
                                                            }
                                                            disabled={!this.state.historyData.past.length > 0}
                                                            onClick={() => this.disconnectDecider("disconnected")}
                                                            >
                                                                {this.props.t("Disconnect")}
                                                            </Button>
                                                        
                                                        {this.props.storeId > -1 ||
                                                        (this.props.storeId === -1 && this.props.isNoTagAvailable) ? (
                                                            <Button
                                                                variant="success"
                                                                className={
                                                                this.props.simOption === "takeback"
                                                                    ? this.props.newSnapshotId === -1
                                                                    ? "takeback-button-aui-edit-fs"
                                                                    : "takeback-button-aui-edit-fs-enabled"
                                                                    : "takeback-button-aui-edit-fs"
                                                                }
                                                                disabled={!this.state.historyData.past.length > 0}
                                                                onClick={() => this.saveSimulateConfirm("takeback")}
                                                            >
                                                                {this.props.t("TAKE_BACK")}
                                                            </Button>
                                                            ) : (
                                                            <></>
                                                            )}
                                                        </>
                                                        ) : (
                                                            <Button
                                                                variant="success"
                                                                className={"btn-save-cat"}
                                                                disabled={!this.state.historyData.past.length > 0}
                                                                onClick={() => this.saveSimulateConfirm("none")}
                                                        >
                                                            {this.props.t("btnnames.save")}
                                                        </Button>
                                                    )}
                                                    </>
                                                ) : (
                                                    <>AAAAA</>
                                                )
                                                ) : (
                                                <Button
                                                    variant="success"
                                                    className={"btn-save-cat"}
                                                    disabled={!this.state.historyData.past.length > 0}
                                                    onClick={() => this.saveSimulateConfirm("none")}
                                                >
                                                    {this.props.t("btnnames.save")}
                                                </Button>
                                                )}
                                            </div>
                                            ) : (
                                                <>BBB</>
                                            )
                                        } */}
                    

                    {this.props.isShowFromPreview?<div className="editsimulate-buttonsset auipreview">
                        <Button variant='success' className={"btn-save-cat"} onClick={() => this.auiPreviewApply()}>{this.props.t("SAVE_AND_APPLY")}</Button>
                    </div>:<></>}

                    {this.state.showPreviewImageModal===true ?
                        <PreviewImage
                            productid={this.state.productId ? this.state.productId : null}
                            loadfromback={true}
                            imgurl={""}
                            isshow={this.state.showPreviewImageModal}
                            isRTL={this.props.isRTL}
                            handlePreviewModal={this.handlePreviewModal}
                            hideheaderlables={false}
                            />
                        :<></>
                    }

                    <div className='draggable-ghost-wrapper' style={{width: 300, height: 100}}></div>

                    <Modal dialogClassName="modal-fullscreen sim-fullscreen" fullscreen show={this.state.isShowFullscreen} onHide={() => this.setFullscreenShow(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title><span className="f-screenTitle">{this.props.t("Full_Screen")}</span>
                                {/* {(this.props.selectedCatRect&&this.props.selectedCatRect.categoryList.length>0)?<span className="catname">{getNameorIdorColorofBox(this.props.selectedCatRect.categoryList[0],"name")}</span>:<></>} */}
                            </Modal.Title>
                            {/* <Button size="sm" className="print-btn" title={this.props.t("print")} onClick={()=>this.handletoImage()}><FeatherIcon icon="printer" size={12} /> {this.props.t("PRINT_SIMULATION")}</Button> */}
                            <Dropdown drop='down' title={this.props.t("PRINT_SIMULATION")} className='printdrop-down down'>
                                <Dropdown.Toggle variant="success">
                                    <FeatherIcon icon="printer"  size={12} /> {this.props.t("PRINT_SIMULATION")}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <ul className='list-inline'>
                                        <li className='list-inline-item' style={!this.areAllShelvesAligned() ? { opacity: 0.4, pointerEvents: 'none' } : {}} onClick={() => this.areAllShelvesAligned() && this.printInit(false, true, false)}><TooltipWrapper text={this.props.t("SIM_PRINT_PDF")}><span><PDFPrintIcon size={26} /></span></TooltipWrapper></li>
                                        <li className='list-inline-item simfield-print' style={!this.areAllShelvesAligned() ? { opacity: 0.4, pointerEvents: 'none' } : {}} onClick={() => this.areAllShelvesAligned() && this.printInit(false, true, true)}><TooltipWrapper text={this.props.t("SIM_PRINT_PDF_FIELDWISE")}><span><PDFFieldPrintIcon size={26} /></span></TooltipWrapper></li>
                                        <li className='list-inline-item' style={!this.areAllShelvesAligned() ? { opacity: 0.4, pointerEvents: 'none' } : {}} onClick={() => this.areAllShelvesAligned() && this.printInit(true, false, false)}><TooltipWrapper text={this.props.t("SIM_PRINT_EXCEL")}><span><ExcelPrintIcon size={26} /></span></TooltipWrapper></li>
                                        <li className='list-inline-item simfield-print' style={!this.areAllShelvesAligned() ? { opacity: 0.4, pointerEvents: 'none' } : {}} onClick={() => this.areAllShelvesAligned() && this.printInit(true, false, true)}><TooltipWrapper text={this.props.t("SIM_PRINT_EXCEL_FIELDWISE")}><span><ExcelPrintFieldWiseIcon size={26} /></span></TooltipWrapper></li>
                                    </ul>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Modal.Header>
                        <Modal.Body ref={this.fullscreendiv}>
                            <Col className='fullscreenview-wrapper'>
                                <React.Fragment>
                                {(fullscreenObj!==null&&fullscreenObj.fields&&Object.keys(fullscreenObj.fields).length>0)&&<Col  className="single-simitem" onContextMenu={e => e.preventDefault()} style={{width: "100%", display: this.state.isPdfExporting ? 'none' : undefined}}> {/* ,height: (this.state.fullscreenheight-40) */}

                                    <svg id={this.state.svgViewId} className="sim-catpreview-all-full" viewBox={"0 0 "+this.state.fullscreensvgdrawDiemention.drawWidth+" "+this.state.fullscreenheight} width={this.state.fullscreensvgdrawDiemention.drawWidth} style={{  border: '0px solid rgb(81, 40, 160)'}}
                                    version="1.1" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">  {/* height={this.state.fullscreenheight-40} */}

                                        {(fullscreenObj.fields && Object.keys(fullscreenObj.fields).length > 0)&&Object.keys(fullscreenObj.fields).map((Fld, f) => {
                                            var fld = fullscreenObj.fields[Fld];
                                            return<React.Fragment key={f}>
                                                    {/* PRE PLAN CR WITH FIELD DRAWING - 2025 NOV */}
                                                        {/* field left border */}
                                                        <line
                                                            x1={fld.x}
                                                            y1={fld.y}
                                                            x2={fld.x}
                                                            y2={fld.y + fld.drawHeight}
                                                            stroke={this.props.dmode?'#2CC990':'#5128a0'}
                                                            strokeWidth={4}
                                                            pointerEvents="none"
                                                        />
                                                        
                                                        {/* field right border */}
                                                        <line
                                                            x1={fld.x + fld.drawWidth}
                                                            y1={fld.y}
                                                            x2={fld.x + fld.drawWidth}
                                                            y2={fld.y + fld.drawHeight}
                                                            stroke={this.props.dmode?'#2CC990':'#5128a0'}
                                                            strokeWidth={4}
                                                            pointerEvents="none"
                                                        />

                                                        {/* field top border  */}
                                                        <line
                                                            x1={fld.x}
                                                            y1={fld.y}
                                                            x2={fld.x + fld.drawWidth}
                                                            y2={fld.y}
                                                            stroke={this.props.dmode?'#2CC990':'#5128a0'}
                                                            strokeWidth={1}
                                                            pointerEvents="none"
                                                        />
                                                {/* OLD WAY OF FIELD LIST DRAWING */}
                                                {/* <rect className=""  width={fld.drawWidth} height={fld.drawHeight} x={fld.x } y={fld.y } style={{ strokeWidth: 0, stroke: (this.props.dmode?'#2CC990':'#5128a0'), fill: 'transparent' }}
                                                />
                                                    {fld.separators&&fld.separators.length>0?fld.separators.map((sprtr,sp)=> <React.Fragment key={sp}> {sprtr.isCategoryEnd?<line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight} strokeWidth={4} stroke="red" strokeDasharray="6"  />:<line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight} strokeWidth={4} stroke={(this.props.dmode?'#2CC990':'#5128a0')} />} </React.Fragment>)
                                                // {fld.separators&&fld.separators.length>0?fld.separators.map((sprtr,sp)=> <React.Fragment key={sp}>  <line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight} strokeWidth={4} stroke={(this.props.dmode?'#2CC990':'#5128a0')} /></React.Fragment>)
                                                :<></>} */}
                                                {!this.state.showDUEditComponent && fld.shelf.length > 0 ? fld.shelf.map((shlf,g) => {

                                                    // Check if this is the last shelf (bottom shelf)
                                                    const isLastShelf = shlf.rank === fld.shelf[fld.shelf.length - 1].rank;

                                                    // Check if shelf is aligned with dot positions (fullscreen ratio)
                                                    const isAligned = this.isShelfAlignedWithShelfHolesFullscreen(fld, {
                                                        ...shlf,
                                                        y: shlf.y
                                                    });

                                                    // Check if shelf is behind a pegboard
                                                    const isBehindPegboard = this.state.CategoryWisescalePegBoardObj && this.state.CategoryWisescalePegBoardObj.some(peg =>
                                                        peg.fieldIDs && peg.fieldIDs.includes(fld.actualFieldId) &&
                                                        peg.pegDrawingRect && peg.pegDrawingRect.shelfIDs && peg.pegDrawingRect.shelfIDs.includes(shlf.rank)
                                                    );

                                                    // Determine shelf color based on alignment
                                                    const shelfColor = this.props.dmode ? '#2CC990' : '#5128a0';
                                                    const shelfMisalignedColor = '#ff0000'; // Red for misaligned shelves

                                                    // Use red color if misaligned and field has simulationDefaultGap
                                                    // But ignore the last shelf (bottom shelf) and shelves behind pegboards
                                                    const appliedColor = (!isAligned && fld.simulationDefaultGap && !isLastShelf && !isBehindPegboard) ? shelfMisalignedColor : shelfColor;

                                                
                                                    return (<React.Fragment key={g}>
                                                        <line x1={shlf.previewguid.startX} y1={shlf.y} x2={shlf.previewguid.startX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />
                                                        <line x1={shlf.previewguid.endX} y1={shlf.y} x2={shlf.previewguid.endX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />

                                                        <rect className={"sftrect"} width={shlf.drawWidth} height={shlf.drawHeight} x={shlf.x } y={shlf.y +0} style={{ strokeWidth: 1, stroke: (this.props.dmode?'#2CC990':'#5128a0'), fill: shlf.isDisable?'#897CA3':'transparent' }}
                                                        />
                                                        <rect
                                                            width={shlf.drawWidth}
                                                            height={shlf.drawGap}
                                                            x={shlf.x}
                                                            y={(shlf.y + 0)+(shlf.drawHeight?shlf.drawHeight:0)}
                                                            style={{ strokeWidth: 1, stroke: appliedColor, fill: appliedColor }}
                                                        />
                                                        
                                                    </React.Fragment>);
                                                }) : <></>}
                                                    
                                                {/* {(fullscreenObj.fields && Object.keys(fullscreenObj.fields).length > 0) && Object.keys(fullscreenObj.fields).map((Fld, f) => {
                                                    var fld = fullscreenObj.fields[Fld]; */}

                                                {fld.shelf.length > 0 ? fld.shelf.map((shlf) => {
                                                    const freeSpacing = this.getFreeSpaceByFieldIdAndRank(fld?.actualFieldId, shlf?.rank);
                                                    let textWidth     = freeSpacing.length * 6;
                                                    
                                                    return(
                                                        <g direction={"ltr"} key={shlf.shelf_id}>
                                                            <rect 
                                                                width={textWidth} // Add padding around text
                                                                height={10}   
                                                                x={fld.x + (fld.drawWidth / 2) - (textWidth)/2} // Centering
                                                                y={shlf.y + shlf.drawHeight} 
                                                                fill="black"
                                                                stroke="black" 
                                                                strokeWidth="1"
                                                            />
                                                            <text 
                                                                x={fld.x + (fld.drawWidth/2)} 
                                                                y={(shlf.y + shlf.drawHeight + 8)} 
                                                                fontSize="10" 
                                                                fontWeight="normal" 
                                                                fill="white" 
                                                                textAnchor="middle"
                                                            >
                                                                {freeSpacing}
                                                            </text>
                                                        </g>
                                                    )
                                                }):<></>}
                                                {/* })} */}

                                                {/* OLD CODE */}
                                                {/* Show available space label */}
                                                {/* {actualFieldStructures && actualFieldStructures.length > 0 && actualFieldStructures?.map((fieldObj, index) => {

                                                    if(fieldObj.field_id !== fld.masterFieldId) return null;

                                                    return(
                                                        <g key={index}>
                                                            {fld.shelf.map((shelf) => {

                                                                const freeSpacing = this.getFreeSpaceByFieldIdAndRank(fieldObj?.actualFieldId, shelf?.rank);
                                                                var textWidth   = freeSpacing.length * 6;

                                                                if(shelf.rank !== shlf.rank) return null 
                                                                    
                                                                /*return(
                                                                    <g direction={"ltr"} key={shelf.shelf_id}>
                                                                        // space label rect
                                                                        <rect 
                                                                            width={textWidth} // Add padding around text
                                                                            height={10}   
                                                                            x={fieldObj.x + (fieldObj.drawWidth / 2) - (textWidth)/2} // Centering
                                                                            y={shlf.y + shlf.drawHeight} 
                                                                            fill="black"
                                                                            stroke="black" 
                                                                            strokeWidth="1"
                                                                        />
                                                                        <text 
                                                                                x={fieldObj.x + (fieldObj.drawWidth/2)} 
                                                                                y={(shlf.y + shlf.drawHeight + 8)} 
                                                                                fontSize="10" 
                                                                                fontWeight="normal" 
                                                                                fill="white" 
                                                                                textAnchor="middle"
                                                                        >
                                                                            {freeSpacing}
                                                                        </text>
                                                                    </g>
                                                                )
                                                            })}
                                                        </g>
                                                    )               
                                                })} */}
                                            </React.Fragment>
                                        })}

                                        
                                        {/* Peg Board */}
                                            {/* Render all drawing rects */}
                                            {this.state?.CategoryWisescalePegBoardObj && this.state.scalePegBoardObj.length > 0 && 
                                                    this.state.CategoryWisescalePegBoardObj.map((peg, index) => {
                                                        return(
                                                        <rect 
                                                            key={peg?.id}
                                                            x={peg?.pegDrawingRect?.drawX} 
                                                            y={peg?.pegDrawingRect?.drawY-40} 
                                                            width={peg?.pegDrawingRect?.drawRectWidth} 
                                                            height={peg?.pegDrawingRect?.drawRectHeight} 
                                                            fill="#FFF" 
                                                            stroke="#000" 
                                                            strokeDasharray={[2,2]} 
                                                            strokeWidth={2}>
                                                        </rect>
                                                    )})
                                                }
                                            {/* render all added peg holes in rect*/}
                                            {this.state.CategoryWisescalePegBoardObj && this.state.CategoryWisescalePegBoardObj?.length > 0 &&
                                                    this.state.CategoryWisescalePegBoardObj.map((peg, index) => (    
                                                        peg?.pegCoordinations && peg?.pegCoordinations.length > 0 && peg?.pegCoordinations?.map((hole, index) => (
                                                            <circle key={hole?.refCode} cx={hole?.drawX} cy={hole?.drawY-40} r={2} fill="white" stroke="black" />
                                                        ))
                                                    ))
                                        }


                                        {(fullscreenObj&&Object.keys(fullscreenObj.products).length>0)?Object.keys(fullscreenObj.products).map((Prod,prodt)=>{
                                            var product=fullscreenObj.products[Prod]
                                            
                                            const maxProductCount = this.validateProductHeight(product);
                                            const maxHeigth = this.validateProductFieldHeight(product);
                                            const hanggedProduct = product?.isHanged ? true : false;
                                            // var cintrlprodloc = this.state.currentInternalDraggableProd;
                                            // var cimgcolor = (cintrlprodloc && cintrlprodloc.prod.id===product.id?true:false);
                                            // var productSheflItem = (product.field_custom_id ?mapFields[product.field_custom_id].shelf.find(x => x.rank === product.shelfrank):null)
                                            // Price tag calculations for fullscreen - use displayRatio and -40 offset (fullscreen peg holes use -40)
                                            const HasPriceTag = product?.hasPriceTag
                                            // priceTagHeight and priceTagGap are always in cm, multiply by displayRatio (same as pegDrawY uses)
                                            const priceTagHeightPx = (product?.priceTagHeight || 0) * this.state.displayRatio;
                                            const gapPx = (product?.priceTagGap || 0) * this.state.displayRatio;
                                            // For hanged products with price tag, X is centered on peg hole
                                            const productDisplayX = (product?.isHanged && HasPriceTag) ? product?.pegDrawX - (product.drawWidth / 2) : product.x;
                                            // Product positioned below price tag - pegDrawY uses -40 offset in fullscreen
                                            const productDisplayY = (product?.isHanged && HasPriceTag) ? (product?.pegDrawY - 40) + (priceTagHeightPx / 2) + gapPx : product.y;

                                            // Create modified product object with adjusted X and Y for rendering
                                            const displayProduct = (product?.isHanged && HasPriceTag) ? { ...product, x: productDisplayX, y: productDisplayY } : product;

                                            return <React.Fragment key={prodt}>
                                                    { !product.isDelete&&<>
                                                        {/* Price Tag for hanged products - centered on peg hole */}
                                                        {(product?.isHanged && product?.hasPriceTag) && (() => {
                                                            // priceTagHeight and priceTagGap are always in cm, multiply by displayRatio (same as pegDrawY)
                                                            const priceTagHeightPxFS = (product?.priceTagHeight || 0) * this.state.displayRatio;
                                                            const gapPxFS = (product?.priceTagGap || 0) * this.state.displayRatio;
                                                            // Price tag X centered on peg hole
                                                            const priceTagX = product?.pegDrawX - (product.drawWidth / 2);
                                                            // Price tag Y centered on peg hole - fullscreen uses -40 offset for peg holes
                                                            const priceTagY = (product?.pegDrawY - 40) - (priceTagHeightPxFS / 2);

                                                            return (
                                                                <g key={`price-tag-${product?.pegRefCode || product?.id}`}>
                                                                    {/* Price Tag rectangle - centered on peg hole */}
                                                                    <rect
                                                                        x={priceTagX}
                                                                        y={priceTagY}
                                                                        width={product.drawWidth}
                                                                        height={priceTagHeightPxFS}
                                                                        fill="white"
                                                                        stroke="#000000"
                                                                        strokeWidth={1}
                                                                    />
                                                                    {/* Price text */}
                                                                    <text
                                                                        x={product?.pegDrawX}
                                                                        y={priceTagY + (priceTagHeightPxFS / 2) + 3}
                                                                        fill="#000000"
                                                                        fontSize={8}
                                                                        fontWeight="bold"
                                                                        textAnchor="middle"
                                                                    >
                                                                        {/* {product?.sell_price} */}

                                                                    </text>
                                                                    {/* Red dot centered on price tag to show hang point */}
                                                                    <circle
                                                                        cx={product?.pegDrawX}
                                                                        cy={product?.pegDrawY - 40}
                                                                        r={2}
                                                                        fill="red"
                                                                        stroke="red"
                                                                    />
                                                                </g>
                                                            );
                                                        })()}
                                                        <FullRenderProdImage prodObj={displayProduct} handleloadedprodcount={this.handleloadedprodcount} />
                                                        {product.isStackable ? (
                                                            maxHeigth===1 ? (<foreignObject   x={product.x} y={product.y-18} width={product.drawWidth} height={20}>
                                                            <div
                                                            // className='centered'
                                                            style={{textAlign: "center"}}>
                                                                <FeatherIcon icon="chevrons-up"  color={"#ED327A"} size={14} />
                                                            </div>

                                                        </foreignObject>):(
                                                            [Array.from({length:maxProductCount}).map((_,i)=>{
                                                                const index = i + 1
                                                                return(
                                                                    <StackRenderProdImage prodObj={product} index={index} handleloadedprodcount={this.handleloadedprodcount}/>
                                                                )

                                                            })]

                                                            )
                                                        ):<></>}

                                                    </>}
                                            </React.Fragment>
                                        }):<></>
                                        }
                                    </svg>
                            </Col>
                                }
                                </React.Fragment>
                                <div style={{position:'absolute' , left:this.props.isRTL==="rtl"?'99999px':'-99999px', display: this.state.isPdfExporting ? 'none' : undefined}}>
                                    {(fullscreenObj!==null&&this.state.mapproductList2New.length > 0 &&this.state.fullscreenobjs.fields&&Object.keys(this.state.fullscreenobjs.fields).length>0)&&<Col  className="single-simitem" onContextMenu={e => e.preventDefault()} style={{width: "100%"}}> {/* ,height: (this.state.fullscreenheight-40) */}
                                        {/* new svg's */}
                                        <svg id="wide" className="wide" viewBox={"0 0 "+this.state.fullscreensvgdrawDiemention.drawWidth+" "+(this.state.fullscreenheight+100)} width={this.state.fullscreensvgdrawDiemention.drawWidth} style={{  borderRight: '0px solid rgb(81, 40, 160)' , borderLeft:'0px solid rgb(81, 40, 160)' , borderBottom:'0px solid rgb(81, 40, 160)'}}
                                        version="1.1" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">  {/* height={this.state.fullscreenheight-40} */}

                                                    <rect 
                                                        x="0" 
                                                        y="0" 
                                                        width={this.state.fullscreensvgdrawDiemention.drawWidth} 
                                                        height={this.state.fullscreenheight} 
                                                        style={{ fill: 'white' }} 
                                                    />
                                            
                                            {(this.state.fullscreenobjs.fields&&Object.keys(this.state.fullscreenobjs.fields).length>0)&&Object.keys(this.state.fullscreenobjs.fields).map((Fld,f)=>{
                                                    var fld=this.state.fullscreenobjs.fields[Fld]
                                                    return<React.Fragment key={f}>
                                                        <rect className=""  width={fld.drawWidth} height={fld.drawHeight} x={fld.x } y={fld.y } style={{ strokeWidth: 0, stroke: (this.props.dmode?'#2CC990':'#5128a0'), fill: 'transparent' }} 
                                                        />
                                                         {fld.separators&&fld.separators.length>0?fld.separators.map((sprtr,sp)=> <React.Fragment key={sp}> {sprtr.isCategoryEnd?<line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight}  />:<line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight} strokeWidth={4} stroke={(this.props.dmode?'#2CC990':'#000000')} strokeDasharray={4} />} </React.Fragment>)
                                                        // {fld.separators&&fld.separators.length>0?fld.separators.map((sprtr,sp)=> <React.Fragment key={sp}>  <line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight} strokeWidth={4} stroke={(props.dmode?'#2CC990':'#5128a0')} /></React.Fragment>)
                                                        :<></>}

                                                        {fld.separators && fld.separators.length > 0 && fld.separators.map((sprtr, sp) => (
                                                            <React.Fragment key={sp}>
                                                                <line 
                                                                x1={sprtr.drawX} 
                                                                y1={fld.y} 
                                                                x2={sprtr.drawX} 
                                                                y2={fld.y + fld.drawHeight} 
                                                                strokeWidth={4} 
                                                                stroke={(this.props.dmode ? '#2CC990' : '#000000')} 
                                                                strokeDasharray={4} 
                                                                />
                                                            </React.Fragment>
                                                            ))}
                                                        {fld.shelf.length>0?fld.shelf.map((shlf,g)=><React.Fragment key={g}>
                                                                <line x1={shlf.previewguid.startX} y1={shlf.y} x2={shlf.previewguid.startX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />
                                                                <line x1={shlf.previewguid.endX} y1={shlf.y} x2={shlf.previewguid.endX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />
    
                                                                <rect className={"sftrect"} width={shlf.drawWidth} height={shlf.drawHeight} x={shlf.x } y={shlf.y +0} style={{ strokeWidth: 1, stroke: (this.props.dmode?'#2CC990':'#9da09d'), fill: shlf.isDisable?'#897CA3':'transparent' }} 
                                                                />
                                                                <rect width={shlf.drawWidth} height={shlf.drawGap} x={shlf.x} y={(shlf.y + 0)+(shlf.drawHeight?shlf.drawHeight:0)} style={{ strokeWidth: 1, stroke: (this.props.dmode?'#2CC990':'#9da09d'), fill: (this.props.dmode?'#2CC990':'#9da09d') }} />
                                                            </React.Fragment>
                                                        ):<></>}
                                                    </React.Fragment>
                                                })}
                                            
                                            {/* Peg Board */}
                                                {/* Render all drawing rects */}
                                                {this.state.scalePegBoardObj && this.state.scalePegBoardObj.length > 0 && 
                                                        this.state.scalePegBoardObj.map((peg, index) => {
                                                            return(
                                                            <rect 
                                                                key={peg?.id}
                                                                x={peg?.pegDrawingRect?.drawX} 
                                                                y={peg?.pegDrawingRect?.drawY-40} 
                                                                width={peg?.pegDrawingRect?.drawRectWidth} 
                                                                height={peg?.pegDrawingRect?.drawRectHeight} 
                                                                fill="#808040" 
                                                                stroke="#000" 
                                                                strokeDasharray={[2,2]} 
                                                                strokeWidth={2}>
                                                            </rect>
                                                        )})
                                                    }
                                                {/* render all added peg holes in rect*/}
                                                {this.state.scalePegBoardObj && this.state.scalePegBoardObj.length > 0 &&
                                                        this.state.scalePegBoardObj.map((peg, index) => (    
                                                            peg?.pegCoordinations && peg?.pegCoordinations.length > 0 && peg?.pegCoordinations?.map((hole, index) => (
                                                                <circle key={hole?.refCode} cx={hole?.drawX} cy={hole?.drawY-40} r={2} fill="white" stroke="black" />
                                                            ))
                                                        ))
                                                }

                                            {(this.state.fullscreenobjs&&Object.keys(this.state.fullscreenobjs.products).length>0)?Object.keys(this.state.fullscreenobjs.products).map((Prod,prodt)=>{
                                                var product=this.state.mapproductList2New[Prod]

                                                const maxProductCount = this.validateProductHeight(product);
                                                const maxHeigth = this.validateProductFieldHeight(product);
                                                const hanggedProduct = product?.isHanged ? true : false;
                                                // var cintrlprodloc = this.state.currentInternalDraggableProd;
                                                // var cimgcolor = (cintrlprodloc && cintrlprodloc.prod.id===product.id?true:false);
                                                // var productSheflItem = (product.field_custom_id ?mapFields[product.field_custom_id].shelf.find(x => x.rank === product.shelfrank):null)

                                                // Price tag calculations for wide view - use pegDrawX/pegDrawY for positioning
                                                const hasPriceTagWide = product?.hasPriceTag;
                                                // priceTagHeight and priceTagGap are always in cm, multiply by fullScreenRatio for wide view
                                                const priceTagHeightPxWide = hasPriceTagWide ? ((product?.priceTagHeight || 0) * this.state.fullScreenRatio) : 0;
                                                const gapPxWide = hasPriceTagWide ? ((product?.priceTagGap || 0) * this.state.fullScreenRatio) : 0;
                                                // Price tag X centered on peg hole
                                                const priceTagXWide = product?.pegDrawX - (product.drawWidth / 2);
                                                // Price tag Y position (with -40 offset to match peg hole drawing, centered on peg hole)
                                                const priceTagYWide = (product?.pegDrawY - 40) - (priceTagHeightPxWide/2);
                                                // Product positioned below price tag (priceTagY + priceTagHeight + gap)
                                                const productDisplayXWide = (product?.isHanged && hasPriceTagWide) ? product?.pegDrawX - (product.drawWidth / 2) : product.x;
                                                const productDisplayYWide = (product?.isHanged && hasPriceTagWide) ? priceTagYWide + priceTagHeightPxWide + gapPxWide : product.y;

                                                // Create modified product object with adjusted X and Y for rendering
                                                const displayProductWide = (product?.isHanged && hasPriceTagWide) ? { ...product, x: productDisplayXWide, y: productDisplayYWide } : product;

                                                return <React.Fragment key={prodt}>
                                                        { !product.isDelete&&<>
                                                            {/* Price Tag for hanged products - wide view - centered on peg hole */}
                                                            {(product?.isHanged && product?.hasPriceTag) && (() => {
                                                                // priceTagHeight and priceTagGap are always in cm, multiply by fullScreenRatio
                                                                const priceTagHeightPxWideFS = (product?.priceTagHeight || 0) * this.state.fullScreenRatio;
                                                                const gapPxWideFS = (product?.priceTagGap || 0) * this.state.fullScreenRatio;
                                                                // Price tag X centered on peg hole
                                                                const priceTagX = product?.pegDrawX - (product.drawWidth / 2);
                                                                // Price tag Y centered on peg hole (with -40 offset to match peg hole drawing)
                                                                const priceTagY = (product?.pegDrawY - 40) - (priceTagHeightPxWideFS/2);

                                                                return (
                                                                    <g key={`price-tag-wide-${product?.pegRefCode || product?.id}`}>
                                                                        {/* Price Tag rectangle - centered on peg hole */}
                                                                        <rect
                                                                            x={priceTagX}
                                                                            y={priceTagY}
                                                                            width={product.drawWidth}
                                                                            height={priceTagHeightPxWideFS}
                                                                            fill="white"
                                                                            stroke="#000000"
                                                                            strokeWidth={1}
                                                                        />
                                                                        {/* Price text */}
                                                                        <text
                                                                            x={product?.pegDrawX}
                                                                            y={priceTagY + (priceTagHeightPxWideFS / 2) + 3}
                                                                            fill="#000000"
                                                                            fontSize={8}
                                                                            fontWeight="bold"
                                                                            textAnchor="middle"
                                                                        >
                                                                            {/* {product?.sell_price} */}
                                                                            
                                                                        </text>
                                                                    </g>
                                                                );
                                                            })()}
                                                            <RenderProdImage prodObj={displayProductWide}
                                                                 topLabel={this.state.getWideViewSettings?.isAboveProduct === false ? null : product?.groupId}
                                                                 middleLabel={this.state.getWideViewSettings?.isProductFace === false ? null : product?.productLabel?.showText ? `${product?.productLabel?.shortText}`: ''}
                                                                 bottomLabel={this.state.getWideViewSettings?.isBelowProduct === false ? null : product?.groupId }
                                                                 />
                                                            {product.isStackable &&this.state.IsShowStackables && !hanggedProduct ? (
                                                               maxHeigth===1 ? (<foreignObject   x={product.x} y={product.y-18} width={product.drawWidth} height={20}>
                                                                <div
                                                                // className='centered'
                                                                style={{textAlign: "center"}}>
                                                                    <FeatherIcon icon="chevrons-up"  color={"#ED327A"} size={14} />
                                                                </div>

                                                            </foreignObject>):(
                                                                [Array.from({length:maxProductCount}).map((_,i)=>{
                                                                    const index = i + 1
                                                                    return(
                                                                        <StackRenderProdImage prodObj={product} index={index} />
                                                                    )

                                                                })]

                                                                )
                                                            ):<></>}

                                                        </>}
                                                </React.Fragment>
                                            }):<></>
                                            }

                                            {/* showing shelf space details */}
                                            {(this.state.getWideViewSettings?.shelfHeight && this.state.fullscreenobjs.fields && Object.keys(this.state.fullscreenobjs.fields).length > 0) && Object.keys(this.state.fullscreenobjs.fields).map((Fld,f) => {
                                                var fld = this.state.fullscreenobjs.fields[Fld];
                                                return <React.Fragment key={f}>
                                                    {fld.shelf.length > 0 ? fld.shelf.map((shlf, g) => {

                                                        // get the free spacing 
                                                        const freeSpacing = this.getFreeSpaceByFieldIdAndRank(fld?.actualFieldId, shlf?.rank);
                                                        var textWidth     = freeSpacing.length * 10;

                                                        return (
                                                            <g key={g}>
                                                                {/* Shelf Rectangle */}
                                                                <rect 
                                                                    width={textWidth + 10}
                                                                    height={15}   
                                                                    x={fld.x + (fld.drawWidth / 2) - (textWidth + 7)/2} // Centering
                                                                    y={shlf.y + shlf.drawHeight + 4} 
                                                                    fill="white" 
                                                                    stroke="blue" 
                                                                    strokeWidth="1"
                                                                />
                                                                <text 
                                                                    x={fld.x + (fld.drawWidth/2)} 
                                                                    y={(shlf.y + shlf.drawHeight + 17)} 
                                                                    fontSize="16" 
                                                                    fontWeight="normal" 
                                                                    fill="black" 
                                                                    textAnchor="middle"
                                                                >
                                                                {freeSpacing}
                                                                </text>
                                                            </g>
                                                        )
                                                    }):<></>}
                                                </React.Fragment>
                                                // OLD CODE
                                                // return <React.Fragment key={f}>
                                                //     {fld.shelf.length > 0 ? fld.shelf.map((shlf, g) => <React.Fragment key={g}>
                                                //     {this.state.actualFieldStructuresNew.mapfieldObj?.map((fieldObj, index) => {
                                                //         var textContent = `${shlf?.gap} ${shlf?.uom}`;
                                                //         var textWidth = textContent.length * 7;
                                                        
                                                //         return(
                                                //             <g key={index}>
                                                //                 {fieldObj.field_shelves.map((shelf) => {
                                                //                     // var textContent = `${shelf?.gap} ${shelf?.uom === "meters" ? "m" : shelf?.uom}`;

                                                //                     // get the free spacing 
                                                //                     const freeSpacing = this.getFreeSpaceByFieldIdAndRank(fieldObj?.actualFieldId, shelf?.rank);
                                                //                     var textWidth = freeSpacing.length * 10;
                                                //                     if(shlf?.rank != shelf?.rank) return null;

                                                //                     return (
                                                //                         <g key={shelf.shelf_id}>
                                                //                             {/* Shelf Rectangle */}
                                                //                             <rect 
                                                //                                 width={textWidth + 10}
                                                //                                 height={15}   
                                                //                                 x={fieldObj.x + (fieldObj.drawWidth / 2) - (textWidth + 7)/2} // Centering
                                                //                                 y={shlf.y + shlf.drawHeight + 4} 
                                                //                                 fill="white" 
                                                //                                 stroke="blue" 
                                                //                                 strokeWidth="1"
                                                //                             />
                                                //                             <text 
                                                //                                 x={fieldObj.x + (fieldObj.drawWidth/2)} 
                                                //                                 y={(shlf.y + shlf.drawHeight + 17)} 
                                                //                                 fontSize="16" 
                                                //                                 fontWeight="normal" 
                                                //                                 fill="black" 
                                                //                                 textAnchor="middle"
                                                //                             >
                                                //                             {freeSpacing}
                                                //                             </text>
                                                //                         </g>
                                                //                     )
                                                //                 })}
                                                //             </g>
                                                //         )
                                                //     })}
                                                //     </React.Fragment>
                                                //     ):<></>}
                                                // </React.Fragment>
                                            })}

                                                
                                                {this.state.getWideViewSettings?.addFieldsNumber && (
                                                    <>
                                                {this.state.getWideViewSettings?.addFieldsNumber && this.state.actualFieldStructuresNew.mapfieldObj?.map((field, index) => {
                                                    const centerX = field.x + (field.drawWidth / 2);

                                                    return (
                                                        <React.Fragment key={`wide-number-${index}`}>
                                                             <rect 
                                                                x={field.x} 
                                                                y={this.state.fullscreenheight+10}
                                                                width={this.state.mapFields2?.svgWidth}
                                                                height="40"
                                                                fill="#808040" 
                                                            />
                                                            {/* Left stroke */}
                                                            <line 
                                                                x1={field.x} 
                                                                y1={this.state.fullscreenheight + 10} 
                                                                x2={field.x} 
                                                                y2={this.state.fullscreenheight + 10 + 40} 
                                                                stroke="#000000"
                                                                strokeDasharray={4} 
                                                                strokeWidth="2"
                                                            />

                                                            {/* Right stroke */}
                                                            <line 
                                                                x1={field.x + field?.drawWidth} 
                                                                y1={this.state.fullscreenheight + 10} 
                                                                x2={field.x + field?.drawWidth} 
                                                                y2={this.state.fullscreenheight + 10 + 40} 
                                                                stroke="#000000"
                                                                strokeDasharray={4}  
                                                                strokeWidth="2"
                                                            />
                                                            <rect 
                                                                x={centerX - 15}
                                                                y={this.state.fullscreenheight+15}
                                                                width="50" 
                                                                height="30" 
                                                                fill="white" 
                                                                stroke="#000000" 
                                                                strokeWidth="1"
                                                            />
                                                            <text 
                                                                x={centerX+10}
                                                                y={this.state.fullscreenheight+30}
                                                                fontSize="18" 
                                                                fontWeight="normal" 
                                                                fill="black" 
                                                                textAnchor="middle" 
                                                                dominantBaseline="middle"
                                                            >
                                                                {index + 1}
                                                            </text>
                                                        </React.Fragment>
                                                    );
                                                })}
                                                    </>
                                                )}

                                                
                                                {this.state.getWideViewSettings?.fieldWidth && this.state.actualFieldStructuresNew.mapfieldObj?.map((field, index) => {
                                                    const fieldBottom = this.state.fullscreenheight + 50;
                                                    return (
                                                        <React.Fragment key={`wide-dimension-${index}`}>
                                                            {/* Dimension lines */}
                                                            {true === true && (
                                                                <>
                                                                <line
                                                                x1={field.x} 
                                                                y1={fieldBottom + 10} 
                                                                x2={field.x + field.drawWidth} 
                                                                y2={fieldBottom + 10} 
                                                                stroke="black" 
                                                                strokeWidth="1"
                                                            />
                                                            
                                                            {/* Left arrow */}
                                                            <path 
                                                                d={`M${field.x},${fieldBottom + 10} l5,-5 l0,10 l-5,-5`} 
                                                                fill="black"
                                                            />
                                                            
                                                            {/* Right arrow */}
                                                            <path 
                                                                d={`M${field.x + field.drawWidth},${fieldBottom + 10} l-5,-5 l0,10 l5,-5`} 
                                                                fill="black"
                                                            />
                                                        
                                                            
                                                            {/* Dimension text */}
                                                            <text 
                                                                x={field.x + (field.drawWidth / 2)} 
                                                                y={fieldBottom + 25} 
                                                                fontSize="12" 
                                                                textAnchor="middle"
                                                            >
                                                               {`${parseFloat(field.width).toFixed(2)} ${field?.field_uom === "meters" ? "m" : field?.field_uom}`}     
                                                            </text>
                                                            
                                                            {/* Zero marker for first field */}
                                                            {index === 0 && (
                                                                <text 
                                                                    x={field.x - 5} 
                                                                    y={fieldBottom + 25} 
                                                                    fontSize="12" 
                                                                    textAnchor="end"
                                                                >
                                                                    0
                                                                </text>
                                                            )}
                                                                </>
                                                            )}
                                                            
                                                        </React.Fragment>
                                                    );
                                                })}

                                                {/* shelf number */}
                                                {(this.state.getWideViewSettings?.shelf && this.state.fullscreenobjs.fields&&Object.keys(this.state.fullscreenobjs.fields).length>0)&&Object.keys(this.state.fullscreenobjs.fields).map((Fld,f)=>{
                                                    var fld = this.state.fullscreenobjs.fields[Fld];
                                                    // NEW CODE - 2025 NOV
                                                    return <React.Fragment key={f}>
                                                    {fld.shelf.length > 0 ? fld.shelf.map((shlf, g) => {
                                                        return (
                                                            <g key={g}>
                                                                {/* Shelf Rectangle */}
                                                                <rect
                                                                    x={fld.x + shlf.x}
                                                                    y={shlf.y + shlf.drawHeight }
                                                                    width={20}
                                                                    height={10}
                                                                    fill={"white"} // Highlight eye-level shelves
                                                                    stroke="black"
                                                                    strokeWidth="1"
                                                                />
                                                                {/* Text inside the rectangle */}
                                                                <text 
                                                                    x={fld.x+10} 
                                                                    y={(shlf.y + shlf.drawHeight + 8)} 
                                                                    fontSize="10" 
                                                                    fontWeight="normal" 
                                                                    fill="blue" 
                                                                    textAnchor="middle"
                                                                >
                                                                {shlf.rank}
                                                                </text>
                                                            </g>
                                                        )
                                                    }):<></>}
                                                    </React.Fragment>
                                                    //OLD CODE
                                                    //return<React.Fragment key={f}>
                                                    //             {fld.shelf.length>0?fld.shelf.map((shlf,g)=><React.Fragment key={g}>
                                                    //             {this.state.actualFieldStructuresNew.mapfieldObj?.map((fieldObj, index) => {
                                                                    
                                                    //                 return (
                                                    //                 <g key={index}>
                                                    //                     {fieldObj.field_shelves.map((shelf) => (
                                                    //                     <g key={shelf.shelf_id}>
                                                    //                         {/* Shelf Rectangle */}
                                                    //                         <rect
                                                    //                         x={fieldObj.x + shelf.x}
                                                    //                         y={shlf.y + shlf.drawHeight }
                                                    //                         width={20}
                                                    //                         height={10}
                                                    //                         fill={"white"} // Highlight eye-level shelves
                                                    //                         stroke="black"
                                                    //                         strokeWidth="1"
                                                    //                         />
                                                    //                         {/* Text inside the rectangle */}
                                                    //                         <text 
                                                    //                             x={fieldObj.x+10} 
                                                    //                             y={(shlf.y + shlf.drawHeight + 8)} 
                                                    //                             fontSize="10" 
                                                    //                             fontWeight="normal" 
                                                    //                             fill="blue" 
                                                    //                             textAnchor="middle"
                                                    //                         >
                                                    //                         {shlf.rank}
                                                    //                         </text>
                                                    //                     </g>
                                                    //                     ))}
                                                    //                 </g>
                                                    // )})}
                                                    //             </React.Fragment>
                                                    //             ):<></>}
                                                    //</React.Fragment>
                                                })}
                                                

                                        </svg>
                                        <svg id="left" className="left" viewBox={"0 0 "+this.state.fullscreensvgdrawDiemention.drawWidth+" "+(this.state.fullscreenheight+100)} width={this.state.fullscreensvgdrawDiemention.drawWidth} style={{  borderRight: '0px solid rgb(81, 40, 160)' , borderLeft:'0px solid rgb(81, 40, 160)' , borderBottom:'0px solid rgb(81, 40, 160)'}}
                                        version="1.1" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">  {/* height={this.state.fullscreenheight-40} */}

                                                    <rect 
                                                        x="0" 
                                                        y="0" 
                                                        width={this.state.fullscreensvgdrawDiemention.drawWidth} 
                                                        height={this.state.fullscreenheight} 
                                                        style={{ fill: 'white'  }} 
                                                    />
                                                
                                                {(this.state.fullscreenobjs.fields&&Object.keys(this.state.fullscreenobjs.fields).length>0)&&Object.keys(this.state.fullscreenobjs.fields).map((Fld,f)=>{
                                                    var fld=this.state.fullscreenobjs.fields[Fld]
                                                    return<React.Fragment key={f}>
                                                        <rect className=""  width={fld.drawWidth} height={fld.drawHeight} x={fld.x } y={fld.y } style={{ strokeWidth: 0, stroke: (this.props.dmode?'#2CC990':'#5128a0'), fill: 'transparent' }} 
                                                        />
                                                         {fld.separators&&fld.separators.length>0?fld.separators.map((sprtr,sp)=> <React.Fragment key={sp}> {sprtr.isCategoryEnd?<line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight}  />:<line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight} strokeWidth={4} stroke={(this.props.dmode?'#2CC990':'#9da09d')} />} </React.Fragment>)
                                                        // {fld.separators&&fld.separators.length>0?fld.separators.map((sprtr,sp)=> <React.Fragment key={sp}>  <line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight} strokeWidth={4} stroke={(props.dmode?'#2CC990':'#5128a0')} /></React.Fragment>)
                                                        :<></>}
                                                        {fld.shelf.length>0?fld.shelf.map((shlf,g)=><React.Fragment key={g}>
                                                                <line x1={shlf.previewguid.startX} y1={shlf.y} x2={shlf.previewguid.startX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />
                                                                <line x1={shlf.previewguid.endX} y1={shlf.y} x2={shlf.previewguid.endX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />
    
                                                                <rect className={"sftrect"} width={shlf.drawWidth} height={shlf.drawHeight} x={shlf.x } y={shlf.y +0} style={{ strokeWidth: 1, stroke: (this.props.dmode?'#2CC990':'#9da09d'), fill: shlf.isDisable?'#897CA3':'transparent' }} 
                                                                />
                                                                <rect width={shlf.drawWidth} height={shlf.drawGap} x={shlf.x} y={(shlf.y + 0)+(shlf.drawHeight?shlf.drawHeight:0)} style={{ strokeWidth: 1, stroke: (this.props.dmode?'#2CC990':'#9da09d'), fill: (this.props.dmode?'#2CC990':'#9da09d') }} />
                                                            </React.Fragment>
                                                        ):<></>}
                                                    </React.Fragment>
                                                })}

                                                {/* Peg Board */}
                                                {/* Render all drawing rects */}
                                                {this.state.scalePegBoardObj && this.state.scalePegBoardObj.length > 0 && 
                                                        this.state.scalePegBoardObj.map((peg, index) => {
                                                            return(
                                                            <rect 
                                                                key={peg?.id}
                                                                x={peg?.pegDrawingRect?.drawX} 
                                                                y={peg?.pegDrawingRect?.drawY-40} 
                                                                width={peg?.pegDrawingRect?.drawRectWidth} 
                                                                height={peg?.pegDrawingRect?.drawRectHeight} 
                                                                fill="#fff" 
                                                                stroke="#000" 
                                                                strokeDasharray={[2,2]} 
                                                                strokeWidth={2}>
                                                            </rect>
                                                        )})
                                                    }
                                                {/* render all added peg holes in rect*/}
                                                {this.state.scalePegBoardObj && this.state.scalePegBoardObj.length > 0 &&
                                                        this.state.scalePegBoardObj.map((peg, index) => (    
                                                            peg?.pegCoordinations && peg?.pegCoordinations.length > 0 && peg?.pegCoordinations?.map((hole, index) => (
                                                                <circle key={hole?.refCode} cx={hole?.drawX} cy={hole?.drawY-40} r={2} fill="white" stroke="black" />
                                                            ))
                                                        ))
                                                }    
                                            
                                            {(this.state.fullscreenobjs&&Object.keys(this.state.fullscreenobjs.products).length>0)?Object.keys(this.state.fullscreenobjs.products).map((Prod,prodt)=>{
                                                var product=this.state.mapproductList2New[Prod];
                                    
                                                let filedWiseGroupIdText = this.getFieldWiseGroupId(product?.id);
                                                
                                                const maxProductCount = this.validateProductHeight(product);
                                                const maxHeigth = this.validateProductFieldHeight(product);
                                                const hanggedProduct = product?.isHanged ? true : false;
                                                const isStack = maxProductCount > 0 ? false : true;
                                                const lastIndex = maxProductCount 
                                                // var cintrlprodloc = this.state.currentInternalDraggableProd;
                                                // var cimgcolor = (cintrlprodloc && cintrlprodloc.prod.id===product.id?true:false);
                                                // var productSheflItem = (product.field_custom_id ?mapFields[product.field_custom_id].shelf.find(x => x.rank === product.shelfrank):null)

                                                // Price tag calculations for wide view - use pegDrawX/pegDrawY for positioning
                                                const hasPriceTagWide = product?.hasPriceTag;
                                                // priceTagHeight and priceTagGap are always in cm, multiply by fullScreenRatio for wide view
                                                const priceTagHeightPxWide = hasPriceTagWide ? ((product?.priceTagHeight || 0) * this.state.fullScreenRatio) : 0;
                                                const gapPxWide = hasPriceTagWide ? ((product?.priceTagGap || 0) * this.state.fullScreenRatio) : 0;
                                                // Price tag X centered on peg hole
                                                const priceTagXWide = product?.pegDrawX - (product.drawWidth / 2);
                                                // Price tag Y position (with -40 offset to match peg hole drawing, centered on peg hole)
                                                const priceTagYWide = (product?.pegDrawY - 40) - (priceTagHeightPxWide/2);
                                                // Product positioned below price tag (priceTagY + priceTagHeight + gap)
                                                const productDisplayXWide = (product?.isHanged && hasPriceTagWide) ? product?.pegDrawX - (product.drawWidth / 2) : product.x;
                                                const productDisplayYWide = (product?.isHanged && hasPriceTagWide) ? priceTagYWide + priceTagHeightPxWide + gapPxWide : product.y;

                                                // Create modified product object with adjusted X and Y for rendering
                                                const displayProductWide = (product?.isHanged && hasPriceTagWide) ? { ...product, x: productDisplayXWide, y: productDisplayYWide } : product;

                                                                                                return <React.Fragment key={prodt}>
                                                        { !product.isDelete&&<>
                                                            {/* Price Tag for hanged products - wide view - centered on peg hole */}
                                                            {(product?.isHanged && product?.hasPriceTag) && (() => {
                                                                // priceTagHeight and priceTagGap are always in cm, multiply by fullScreenRatio
                                                                const priceTagHeightPxWideFS = (product?.priceTagHeight || 0) * this.state.fullScreenRatio;
                                                                const gapPxWideFS = (product?.priceTagGap || 0) * this.state.fullScreenRatio;
                                                                // Price tag X centered on peg hole
                                                                const priceTagX = product?.pegDrawX - (product.drawWidth / 2);
                                                                // Price tag Y centered on peg hole (with -40 offset to match peg hole drawing)
                                                                const priceTagY = (product?.pegDrawY - 40) - (priceTagHeightPxWideFS/2);

                                                                return (
                                                                    <g key={`price-tag-wide-${product?.pegRefCode || product?.id}`}>
                                                                        {/* Price Tag rectangle - centered on peg hole */}
                                                                        <rect
                                                                            x={priceTagX}
                                                                            y={priceTagY}
                                                                            width={product.drawWidth}
                                                                            height={priceTagHeightPxWideFS}
                                                                            fill="white"
                                                                            stroke="#000000"
                                                                            strokeWidth={1}
                                                                        />
                                                                        {/* Price text */}
                                                                        <text
                                                                            x={product?.pegDrawX}
                                                                            y={priceTagY + (priceTagHeightPxWideFS / 2) + 3}
                                                                            fill="#000000"
                                                                            fontSize={8}
                                                                            fontWeight="bold"
                                                                            textAnchor="middle"
                                                                        >
                                                                            {/* {product?.sell_price} */}
                                                                            
                                                                        </text>
                                                                    </g>
                                                                );
                                                            })()}
                                                            <RenderProdRectangle prodObj={displayProductWide} rectangleColor={`${product?.productLabel?.color || 'white'}`} 
                                                            isStack={isStack}
                                                            lastIndex={lastIndex}
                                                            topLabel={this.state.getModuleViewSettings?.fieldLeftAboveProduct === null ? null : filedWiseGroupIdText ? filedWiseGroupIdText : null }
                                                            // middleLabel={this.state.getModuleViewSettings?.fieldLeftProductFace === null ? null : product?.productLabel?.showText ? `${product?.productLabel?.shortText}`: ''} 
                                                            middleLabel={product?.productLabel?.showText ? `${product?.productLabel?.shortText}`: ''} 
                                                            productFace={this.state.getModuleViewSettings?.fieldLeftProductFace === null ? null : filedWiseGroupIdText ? filedWiseGroupIdText : null }
                                                            bottomLabel={this.state.getModuleViewSettings?.fieldLeftBelowProduct === null ? null : filedWiseGroupIdText ? filedWiseGroupIdText : null }
                                                            fullScreenRatio={this.state.fullScreenRatio}
                                                            isPriceTag={true}
                                                            />
                                                            {product.isStackable &&this.state.IsShowStackables && !hanggedProduct ? (
                                                               maxHeigth===1 ? (<foreignObject   x={product.x} y={product.y-8} width={product.drawWidth} height={20}>
                                                               {!(product?.groupId && (this.state.getModuleViewSettings?.fieldLeftAboveProduct === null ? null : product?.groupId)) && (
                                                                <div style={{textAlign: "center"}}>
                                                                    <FeatherIcon icon="chevrons-up" color={"#ED327A"} size={14} />
                                                                </div>
                                                                )}
                                                            </foreignObject>):(
                                                                [Array.from({length:maxProductCount}).map((_,i)=>{
                                                                    const index = i + 1
                                                                    return(
                                                                        <React.Fragment>
                                                                            <RenderStackProdRectangle 
                                                                            stackCount = {maxProductCount}
                                                                            lastIndex = {lastIndex}
                                                                            index={index} prodObj={product} rectangleColor={`${product?.productLabel?.color || 'white'}`} 
                                                                            topLabel={this.state.getModuleViewSettings?.fieldLeftAboveProduct === null ? null : filedWiseGroupIdText ? filedWiseGroupIdText : null}
                                                                            // middleLabel={this.state.getModuleViewSettings?.fieldLeftProductFace === null ? null : product?.productLabel?.showText ? `${product?.productLabel?.shortText}`: ''} 
                                                                            middleLabel={ product?.productLabel?.showText ? `${product?.productLabel?.shortText}`: ''}
                                                                            productFace={this.state.getModuleViewSettings?.fieldLeftProductFace === null ? null :  filedWiseGroupIdText ? filedWiseGroupIdText : null}
                                                                            bottomLabel={this.state.getModuleViewSettings?.fieldLeftBelowProduct === null ? null : filedWiseGroupIdText ? filedWiseGroupIdText : null} />
                                                                        </React.Fragment>
                                                                    )

                                                                })]

                                                                )
                                                            ):<></>}

                                                        </>}
                                                </React.Fragment>
                                            }):<></>
                                            }

                                            

                                            {/* shelf details */}
                                            {(this.state.getModuleViewSettings?.fieldLeftShelf&&this.state.fullscreenobjs.fields&&Object.keys(this.state.fullscreenobjs.fields).length>0)&&Object.keys(this.state.fullscreenobjs.fields).map((Fld,f)=>{
                                                    var fld=this.state.fullscreenobjs.fields[Fld]
                                                    return <React.Fragment key={f}>
                                                    {fld.shelf.length > 0 ? fld.shelf.map((shlf, g) => {

                                                        // get the free spacing 
                                                        const freeSpacing = this.getFreeSpaceByFieldIdAndRank(fld?.actualFieldId, shlf?.rank);
                                                        var textWidth     = freeSpacing.length * 10;

                                                        return (
                                                            <g key={g} direction={"ltr"}>
                                                                {/* Shelf Rectangle */}
                                                                <rect 
                                                                    width={textWidth + 10}
                                                                    height={15}   
                                                                    x={fld.x + (fld.drawWidth / 2) - (textWidth + 7)/2} // Centering
                                                                    y={shlf.y + shlf.drawHeight + 4} 
                                                                    fill="white" 
                                                                    stroke="blue" 
                                                                    strokeWidth="1"
                                                                />
                                                                <text 
                                                                    x={fld.x + (fld.drawWidth/2)} 
                                                                    y={(shlf.y + shlf.drawHeight + 17)} 
                                                                    fontSize="16" 
                                                                    fontWeight="normal" 
                                                                    fill="black" 
                                                                    textAnchor="middle"
                                                                >
                                                                {freeSpacing}
                                                                </text>
                                                            </g>
                                                        )
                                                    }):<></>}
                                                </React.Fragment>

                                                //     return<React.Fragment key={f}>
                                                //             {fld.shelf.length>0?fld.shelf.map((shlf,g)=><React.Fragment key={g}>
                                                //             {this.state.actualFieldStructuresNew.mapfieldObj?.map((fieldObj, index) => {
                                                                
                                                //                 var textContent = `${shlf?.gap} ${shlf?.uom}`;
                                                //                 var textWidth = textContent.length * 7;
                                                //                 //if(fieldObj.id !== fld.mpFieldId) return null; // bawantha
                                                //                 if(fieldObj.field_id !== fld.masterFieldId) return null; // lahiru
                                                //                 return(
                                                //                 <g key={index}>
                                                //                     {fieldObj.field_shelves.map((shelf, i) => {
                                                //                         // var textContent =  `${shelf?.gap} ${shelf?.uom === "meters" ? "m" : shelf?.uom}`;
                                                //                         // var textWidth = textContent.length * 7;
                                                                        
                                                //                         // get the free spacing 
                                                //                         const freeSpacing = this.getFreeSpaceByFieldIdAndRank(fieldObj?.actualFieldId, shelf?.rank);
                                                //                         var textWidth = freeSpacing.length * 10;
                                                //                         if(shlf?.rank != shelf?.rank) return null;

                                                //                         return(
                                                //                             <g direction={"ltr"} key={shelf.shelf_id}>
                                                //                             {/* Shelf Rectangle */}
                                                //                             <rect 
                                                //                                 width={textWidth + 10}
                                                //                                 height={15}   
                                                //                                 x={fieldObj.x + (fieldObj.drawWidth / 2) - (textWidth + 7)/2} // Centering
                                                //                                 y={shlf.y + shlf.drawHeight + 4} 
                                                //                                 fill="white" 
                                                //                                 stroke="blue" 
                                                //                                 strokeWidth="1"
                                                //                             />
                                                //                             <text 
                                                //                                 x={fieldObj.x + (fieldObj.drawWidth/2)} 
                                                //                                 y={(shlf.y + shlf.drawHeight + 17)} 
                                                //                                 fontSize="16" 
                                                //                                 fontWeight="normal" 
                                                //                                 fill="black" 
                                                //                                 textAnchor="middle"
                                                //                             >
                                                //                             {freeSpacing}
                                                //                             </text>
                                                //                         </g>
                                                //                         )
                                                                    
                                                //                 })}
                                                //                 </g>
                                                // )               })}
                                                //             </React.Fragment>
                                                //             ):<></>}
                                                //     </React.Fragment>
                                            })}


                                                {this.state.getModuleViewSettings?.fieldLeftAddFieldsNumber && (
                                                    <>
                                                    <rect 
                                                    x="0" 
                                                    y={this.state.fullscreenheight+10}
                                                    width={this.state.mapFields2?.svgWidth} 
                                                    height="40" 
                                                    fill="#808040" 
                                                />
                                                

                                                {this.state.getModuleViewSettings?.fieldLeftAddFieldsNumber&&this.state.actualFieldStructuresNew.mapfieldObj?.map((field, index) => {
                                                    const centerX = field.x + (field.drawWidth / 2);

                                                    return (
                                                        <React.Fragment key={`left-number-${index}`}>
                                                            <rect 
                                                                x={centerX - 15}
                                                                y={this.state.fullscreenheight+15}
                                                                width="50" 
                                                                height="30" 
                                                                fill="white" 
                                                                stroke="#000000" 
                                                                strokeWidth="1"
                                                            />
                                                            <text 
                                                                x={centerX+10}
                                                                y={this.state.fullscreenheight+30}
                                                                fontSize="18" 
                                                                fontWeight="normal" 
                                                                fill="black" 
                                                                textAnchor="middle" 
                                                                dominantBaseline="middle"
                                                            >
                                                                {index + 1}
                                                            </text>
                                                        </React.Fragment>
                                                    );
                                                })}
                                                    </>
                                                )}

                                                
                                                {this.state.getModuleViewSettings?.fieldLeftFieldWidth&&this.state.actualFieldStructuresNew.mapfieldObj?.map((field, index) => {
                                                   const fieldBottom = this.state.fullscreenheight + 50;
                                                    return (
                                                        <React.Fragment key={`left-dimension-${index}`}>
                                                            {/* Dimension lines */}
                                                            {true === true && (
                                                                <>
                                                                <line
                                                                x1={field.x} 
                                                                y1={fieldBottom + 10} 
                                                                x2={field.x + field.drawWidth} 
                                                                y2={fieldBottom + 10} 
                                                                stroke="black" 
                                                                strokeWidth="1"
                                                            />
                                                            
                                                            {/* Left arrow */}
                                                            <path 
                                                                d={`M${field.x},${fieldBottom + 10} l5,-5 l0,10 l-5,-5`} 
                                                                fill="black"
                                                            />
                                                            
                                                            {/* Right arrow */}
                                                            <path 
                                                                d={`M${field.x + field.drawWidth},${fieldBottom + 10} l-5,-5 l0,10 l5,-5`} 
                                                                fill="black"
                                                            />
                                                        
                                                            
                                                            {/* Dimension text */}
                                                            <text 
                                                                x={field.x + (field.drawWidth / 2)} 
                                                                y={fieldBottom + 25} 
                                                                fontSize="16" 
                                                                textAnchor="middle"
                                                                direction={"ltr"} 
                                                            >
                                                                 {`${parseFloat(field.width).toFixed(2)} ${field?.field_uom === "meters" ? "m" : field?.field_uom}`}
                                                            </text>
                                                            
                                                            {/* Zero marker for first field */}
                                                            {index === 0 && (
                                                                <text 
                                                                    x={field.x - 5} 
                                                                    y={fieldBottom + 25} 
                                                                    fontSize="16" 
                                                                    textAnchor="end"
                                                                >
                                                                    0
                                                                </text>
                                                            )}
                                                                </>
                                                            )}
                                                            
                                                        </React.Fragment>
                                                    );
                                                })}

                                                {/* shelf number */}
                                                {this.state.getModuleViewSettings?.fieldLeftAddLeftShelfNo &&
                                                this.state.fullscreenobjs.fields &&
                                                Object.keys(this.state.fullscreenobjs.fields).length > 0 &&
                                                Object.keys(this.state.fullscreenobjs.fields).map((Fld, f) => {
                                                    const fld = this.state.fullscreenobjs.fields[Fld];
                                                    // NEW CODE - 2025 NOV
                                                    return <React.Fragment key={f}>
                                                    {fld.shelf.length > 0 ? fld.shelf.map((shlf, g) => {
                                                        return (
                                                            <g key={g}>
                                                                <rect
                                                                    x={fld.x}
                                                                    y={shlf.y + shlf.drawHeight}
                                                                    width={20}
                                                                    height={14}
                                                                    fill="white"
                                                                    stroke="black"
                                                                    strokeWidth="1"
                                                                />
                                                                <text
                                                                    x={fld.x + 10}
                                                                    y={shlf.y + shlf.drawHeight + 12}
                                                                    fontSize="16"
                                                                    fontWeight="normal"
                                                                    fill="blue"
                                                                    textAnchor="middle"
                                                                >
                                                                    {shlf.rank}
                                                                </text>
                                                            </g>
                                                        )
                                                    }):<></>}
                                                </React.Fragment>
                                                // OLD CODE
                                                // if (!fld?.shelf?.length) return null;

                                                    // return (
                                                    //     <React.Fragment key={f}>
                                                    //         {this.state.actualFieldStructuresNew.mapfieldObj
                                                    //             ?.filter((fieldObj) => fieldObj.id === fld.mpFieldId)
                                                    //             .map((fieldObj, index) => {
                                                    //                 if (!fieldObj?.field_shelves?.length) return null;

                                                    //                 return fld.shelf.map((shlf, i) => {
                                                    //                     const shelf = fieldObj.field_shelves[i];
                                                    //                     if (!shlf?.rank || !shelf) return null;

                                                    //                     return (
                                                    //                         <g key={shelf.shelf_id}>
                                                    //                             <rect
                                                    //                                 x={fieldObj.x}
                                                    //                                 y={shlf.y + shlf.drawHeight}
                                                    //                                 width={20}
                                                    //                                 height={14}
                                                    //                                 fill="white"
                                                    //                                 stroke="black"
                                                    //                                 strokeWidth="1"
                                                    //                             />
                                                    //                             <text
                                                    //                                 x={fieldObj.x + 10}
                                                    //                                 y={shlf.y + shlf.drawHeight + 12}
                                                    //                                 fontSize="16"
                                                    //                                 fontWeight="normal"
                                                    //                                 fill="blue"
                                                    //                                 textAnchor="middle"
                                                    //                             >
                                                    //                                 {shlf.rank}
                                                    //                             </text>
                                                    //                         </g>
                                                    //                     );
                                                    //                 });
                                                    //             })}
                                                    //     </React.Fragment>
                                                    // );
                                                })}
                                        </svg>
                                        <svg id="rigthside" className="rigthside"viewBox={"0 0 "+this.state.fullscreensvgdrawDiemention.drawWidth+" "+(this.state.fullscreenheight+100)} width={this.state.fullscreensvgdrawDiemention.drawWidth} style={{  borderRight: '0px solid rgb(81, 40, 160)' , borderLeft:'0px solid rgb(81, 40, 160)' , borderBottom:'0px solid rgb(81, 40, 160)'}}
                                        version="1.1" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">  {/* height={this.state.fullscreenheight-40} */}

                                                <rect 
                                                        x="0" 
                                                        y="0" 
                                                        width={this.state.fullscreensvgdrawDiemention.drawWidth} 
                                                        height={this.state.fullscreenheight} 
                                                        style={{ fill: 'white'}} 
                                                    />
                                            {(this.state.fullscreenobjs.fields&&Object.keys(this.state.fullscreenobjs.fields).length>0)&&Object.keys(this.state.fullscreenobjs.fields).map((Fld,f)=>{
                                                    var fld=this.state.fullscreenobjs.fields[Fld]
                                                    return<React.Fragment key={f}>
                                                        <rect className=""  width={fld.drawWidth} height={fld.drawHeight} x={fld.x } y={fld.y } style={{ strokeWidth: 0, stroke: (this.props.dmode?'#2CC990':'#5128a0'), fill: 'transparent' }} 
                                                        />
                                                         {fld.separators&&fld.separators.length>0?fld.separators.map((sprtr,sp)=> <React.Fragment key={sp}> {sprtr.isCategoryEnd?<line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight}  />:<line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight} strokeWidth={4} stroke={(this.props.dmode?'#2CC990':'#9da09d')} />} </React.Fragment>)
                                                        // {fld.separators&&fld.separators.length>0?fld.separators.map((sprtr,sp)=> <React.Fragment key={sp}>  <line x1={sprtr.drawX} y1={fld.y} x2={sprtr.drawX} y2={fld.y+fld.drawHeight} strokeWidth={4} stroke={(props.dmode?'#2CC990':'#5128a0')} /></React.Fragment>)
                                                        :<></>}
                                                        {fld.shelf.length>0?fld.shelf.map((shlf,g)=><React.Fragment key={g}>
                                                                <line x1={shlf.previewguid.startX} y1={shlf.y} x2={shlf.previewguid.startX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />
                                                                <line x1={shlf.previewguid.endX} y1={shlf.y} x2={shlf.previewguid.endX} y2={shlf.y+shlf.drawHeight} strokeWidth={2} stroke="green" strokeDasharray="4" />
    
                                                                <rect className={"sftrect"} width={shlf.drawWidth} height={shlf.drawHeight} x={shlf.x } y={shlf.y +0} style={{ strokeWidth: 1, stroke: (this.props.dmode?'#2CC990':'#9da09d'), fill: shlf.isDisable?'#897CA3':'transparent' }} 
                                                                />
                                                                <rect width={shlf.drawWidth} height={shlf.drawGap} x={shlf.x} y={(shlf.y + 0)+(shlf.drawHeight?shlf.drawHeight:0)} style={{ strokeWidth: 1, stroke: (this.props.dmode?'#2CC990':'#9da09d'), fill: (this.props.dmode?'#2CC990':'#9da09d') }} />
                                                            </React.Fragment>
                                                        ):<></>}
                                                    </React.Fragment>
                                                })}
                                            
                                             {/* Peg Board */}
                                                {/* Render all drawing rects */}
                                                {this.state.scalePegBoardObj && this.state.scalePegBoardObj.length > 0 && 
                                                        this.state.scalePegBoardObj.map((peg, index) => {
                                                            return(
                                                            <rect 
                                                                key={peg?.id}
                                                                x={peg?.pegDrawingRect?.drawX} 
                                                                y={peg?.pegDrawingRect?.drawY-40} 
                                                                width={peg?.pegDrawingRect?.drawRectWidth} 
                                                                height={peg?.pegDrawingRect?.drawRectHeight} 
                                                                fill="#808040" 
                                                                stroke="#000" 
                                                                strokeDasharray={[2,2]} 
                                                                strokeWidth={2}>
                                                            </rect>
                                                        )})
                                                    }
                                                {/* render all added peg holes in rect*/}
                                                {this.state.scalePegBoardObj && this.state.scalePegBoardObj.length > 0 &&
                                                        this.state.scalePegBoardObj.map((peg, index) => (    
                                                            peg?.pegCoordinations && peg?.pegCoordinations.length > 0 && peg?.pegCoordinations?.map((hole, index) => (
                                                                <circle key={hole?.refCode} cx={hole?.drawX} cy={hole?.drawY-40} r={2} fill="white" stroke="black" />
                                                            ))
                                                        ))
                                                }


                                            {(this.state.fullscreenobjs&&Object.keys(this.state.fullscreenobjs.products).length>0)?Object.keys(this.state.fullscreenobjs.products).map((Prod,prodt)=>{
                                                var product=this.state.mapproductList2New[Prod]
                                                
                                                let filedWiseGroupIdText = this.getFieldWiseGroupId(product?.id);
                                                const maxProductCount = this.validateProductHeight(product);
                                                const maxHeigth = this.validateProductFieldHeight(product);
                                                const hanggedProduct = product?.isHanged ? true : false;
                                                const isStack = maxProductCount > 0 ? false : true;
                                                const lastIndex2 = maxProductCount 
                                                // var cintrlprodloc = this.state.currentInternalDraggableProd;
                                                // var cimgcolor = (cintrlprodloc && cintrlprodloc.prod.id===product.id?true:false);
                                                // var productSheflItem = (product.field_custom_id ?mapFields[product.field_custom_id].shelf.find(x => x.rank === product.shelfrank):null)
                                                // Price tag calculations for wide view - use pegDrawX/pegDrawY for positioning
                                                const hasPriceTagWide = product?.hasPriceTag;
                                                // priceTagHeight and priceTagGap are always in cm, multiply by fullScreenRatio for wide view
                                                const priceTagHeightPxWide = hasPriceTagWide ? ((product?.priceTagHeight || 0) * this.state.fullScreenRatio) : 0;
                                                const gapPxWide = hasPriceTagWide ? ((product?.priceTagGap || 0) * this.state.fullScreenRatio) : 0;
                                                // Price tag X centered on peg hole
                                                const priceTagXWide = product?.pegDrawX - (product.drawWidth / 2);
                                                // Price tag Y position (with -40 offset to match peg hole drawing, centered on peg hole)
                                                const priceTagYWide = (product?.pegDrawY - 40) - (priceTagHeightPxWide/2);
                                                // Product positioned below price tag (priceTagY + priceTagHeight + gap)
                                                const productDisplayXWide = (product?.isHanged && hasPriceTagWide) ? product?.pegDrawX - (product.drawWidth / 2) : product.x;
                                                const productDisplayYWide = (product?.isHanged && hasPriceTagWide) ? priceTagYWide + priceTagHeightPxWide + gapPxWide : product.y;

                                                // Create modified product object with adjusted X and Y for rendering
                                                const displayProductWide = (product?.isHanged && hasPriceTagWide) ? { ...product, x: productDisplayXWide, y: productDisplayYWide } : product;
                                                return <React.Fragment key={prodt}>
                                                        { !product.isDelete&&<>
                                                            {/* Price Tag for hanged products - wide view - centered on peg hole */}
                                                            {(product?.isHanged && product?.hasPriceTag) && (() => {
                                                                // priceTagHeight and priceTagGap are always in cm, multiply by fullScreenRatio
                                                                const priceTagHeightPxWideFS = (product?.priceTagHeight || 0) * this.state.fullScreenRatio;
                                                                const gapPxWideFS = (product?.priceTagGap || 0) * this.state.fullScreenRatio;
                                                                // Price tag X centered on peg hole
                                                                const priceTagX = product?.pegDrawX - (product.drawWidth / 2);
                                                                // Price tag Y centered on peg hole (with -40 offset to match peg hole drawing)
                                                                const priceTagY = (product?.pegDrawY - 40) - (priceTagHeightPxWideFS/2);

                                                                return (
                                                                    <g key={`price-tag-wide-${product?.pegRefCode || product?.id}`}>
                                                                        {/* Price Tag rectangle - centered on peg hole */}
                                                                        <rect
                                                                            x={priceTagX}
                                                                            y={priceTagY}
                                                                            width={product.drawWidth}
                                                                            height={priceTagHeightPxWideFS}
                                                                            fill="white"
                                                                            stroke="#000000"
                                                                            strokeWidth={1}
                                                                        />
                                                                        {/* Price text */}
                                                                        <text
                                                                            x={product?.pegDrawX}
                                                                            y={priceTagY + (priceTagHeightPxWideFS / 2) + 3}
                                                                            fill="#000000"
                                                                            fontSize={8}
                                                                            fontWeight="bold"
                                                                            textAnchor="middle"
                                                                        >
                                                                            {/* {product?.sell_price} */}
                                                                            
                                                                        </text>
                                                                    </g>
                                                                );
                                                            })()}
                                                            <RenderProdImage prodObj={displayProductWide}
                                                                isPriceTag={true}
                                                                fullScreenRatio={this.state.fullScreenRatio}
                                                                isStack={isStack} 
                                                                 topLabel={this.state.getModuleViewSettings?.fieldRightAboveProduct === null ? null : filedWiseGroupIdText ? filedWiseGroupIdText : null}
                                                                 lastIndex2={lastIndex2}
                                                                //  middleLabel={this.state.getModuleViewSettings?.fieldRightProductFace === null ? null : product?.productLabel?.showText ? `${product?.productLabel?.shortText}`: ''}
                                                                //middleLabel={product?.productLabel?.showText ? `${product?.productLabel?.shortText}`: ''} 
                                                                productFace={this.state.getModuleViewSettings?.fieldRightProductFace === null ? null :  filedWiseGroupIdText ? filedWiseGroupIdText : null} 
                                                                 bottomLabel={this.state.getModuleViewSettings?.fieldRightBelowProduct === null ? null : filedWiseGroupIdText ? filedWiseGroupIdText : null } />
                                                            {product.isStackable &&this.state.IsShowStackables && !hanggedProduct ? (
                                                               maxHeigth===1 ? (<foreignObject   x={product.x} y={product.y-8} width={product.drawWidth} height={20}>
                                                                
                                                                {!(product?.groupId && (this.state.getModuleViewSettings?.fieldRightAboveProduct === null ? null : product?.groupId)) && (
                                                                <div style={{textAlign: "center"}}>
                                                                    <FeatherIcon icon="chevrons-up" color={"#ED327A"} size={14} />
                                                                </div>
                                                                )}
                                                            </foreignObject>):(
                                                                [Array.from({length:maxProductCount}).map((_,i)=>{
                                                                    const index = i + 1
                                                                    return(
                                                                        <RenderStackProdImage2 stackCount={maxProductCount} prodObj={product} index={index} topLabel={this.state.getModuleViewSettings?.fieldRightAboveProduct === null ? null : filedWiseGroupIdText ? filedWiseGroupIdText : null}
                                                                        lastIndex2 = {lastIndex2}
                                                                        // middleLabel={this.state.getModuleViewSettings?.fieldRightProductFace === null ? null : product?.productLabel?.showText ? `${product?.productLabel?.shortText}`: ''} 
                                                                        //middleLabel={product?.productLabel?.showText ? `${product?.productLabel?.shortText}`: ''} 
                                                                        productFace={this.state.getModuleViewSettings?.fieldRightProductFace === null ? null : filedWiseGroupIdText ? filedWiseGroupIdText : null}
                                                                        bottomLabel={this.state.getModuleViewSettings?.fieldRightBelowProduct === null ? null : filedWiseGroupIdText ? filedWiseGroupIdText : null } />
                                                                    )

                                                                })]

                                                                )
                                                            ):<></>}

                                                        </>}
                                                </React.Fragment>
                                            }):<></>
                                            }

                                            {/* shelf details */}
                                            {(this.state.getModuleViewSettings?.fieldRightShelf&& this.state.fullscreenobjs.fields&&Object.keys(this.state.fullscreenobjs.fields).length>0)&&Object.keys(this.state.fullscreenobjs.fields).map((Fld, f)=>{
                                                    var fld = this.state.fullscreenobjs.fields[Fld];
                                                    //NEW CODE - 2025 NOV
                                                    return <React.Fragment key={f}>
                                                        {fld.shelf.length > 0 ? fld.shelf.map((shlf, g) => {

                                                            // get the free spacing 
                                                            const freeSpacing = this.getFreeSpaceByFieldIdAndRank(fld?.actualFieldId, shlf?.rank);
                                                            var textWidth     = freeSpacing.length * 10;

                                                            return (
                                                                <g direction={"ltr"} key={g}>
                                                                    {/* Shelf Rectangle */}
                                                                    <rect 
                                                                        width={textWidth + 10} // Add padding around text
                                                                        height={15}   
                                                                        x={fld.x + (fld.drawWidth / 2) - (textWidth + 7)/2} // Centering
                                                                        y={shlf.y + shlf.drawHeight + 4} 
                                                                        fill="white" 
                                                                        stroke="blue" 
                                                                        strokeWidth="1"
                                                                    />
                                                                    <text 
                                                                        x={fld.x + (fld.drawWidth/2)} 
                                                                        y={(shlf.y + shlf.drawHeight + 17)} 
                                                                        fontSize="16" 
                                                                        fontWeight="normal" 
                                                                        fill="black" 
                                                                        textAnchor="middle"
                                                                    >
                                                                    {freeSpacing}
                                                                    </text>
                                                                </g>
                                                            )
                                                        }):<></>}
                                                    </React.Fragment>
                                                    //OLD CODE
                                                    // return<React.Fragment key={f}>
                                                    //         {fld.shelf.length>0?fld.shelf.map((shlf,g)=><React.Fragment key={g}>
                                                    //         {this.state.actualFieldStructuresNew.mapfieldObj?.map((fieldObj, index) => {
                                                    //             var textContent = `${shlf?.gap} ${shlf?.uom}`;
                                                    //             var textWidth = textContent.length * 7;
                                                    //             //if(fieldObj.id !== fld.mpFieldId) return null; // bawantha
                                                    //             if(fieldObj.field_id !== fld.masterFieldId) return null; // lahiru
                                                    //             return(
                                                    //             <g key={index}>
                                                    //                 {fieldObj.field_shelves.map((shelf) => {
                                                    //                     // var textContent = `${shelf?.gap} ${shelf?.uom === "meters" ? "m" : shelf?.uom}`;
                                                                       

                                                    //                     // get the free spacing 
                                                    //                     const freeSpacing = this.getFreeSpaceByFieldIdAndRank(fieldObj?.actualFieldId, shelf?.rank);
                                                    //                     var textWidth = freeSpacing.length * 10;
                                                    //                     if(shlf?.rank != shelf?.rank) return null;

                                                    //                     return(
                                                    //                         <g direction={"ltr"} key={shelf.shelf_id}>
                                                    //                         {/* Shelf Rectangle */}
                                                    //                         <rect 
                                                    //                             width={textWidth + 10} // Add padding around text
                                                    //                             height={15}   
                                                    //                             x={fieldObj.x + (fieldObj.drawWidth / 2) - (textWidth + 7)/2} // Centering
                                                    //                             y={shlf.y + shlf.drawHeight + 4} 
                                                    //                             fill="white" 
                                                    //                             stroke="blue" 
                                                    //                             strokeWidth="1"
                                                    //                         />
                                                    //                         <text 
                                                    //                             x={fieldObj.x + (fieldObj.drawWidth/2)} 
                                                    //                             y={(shlf.y + shlf.drawHeight + 17)} 
                                                    //                             fontSize="16" 
                                                    //                             fontWeight="normal" 
                                                    //                             fill="black" 
                                                    //                             textAnchor="middle"
                                                    //                         >
                                                    //                         {freeSpacing}
                                                    //                         </text>
                                                    //                     </g>
                                                    //                     )
                                                                    
                                                    //             })}
                                                    //             </g>
                                                    //            )})}
                                                    //         </React.Fragment>
                                                    //         ):<></>}
                                                    // </React.Fragment>
                                                })}

                                                {this.state.getModuleViewSettings?.fieldRightAddFieldsNumber && (
                                                    <>
                                                    <rect 
                                                    x="0" 
                                                    y={this.state.fullscreenheight+10}
                                                    width={this.state.mapFields2?.svgWidth} 
                                                    height="40" 
                                                    fill="#808040" 
                                                />
                                                

                                                {this.state.getModuleViewSettings?.fieldRightAddFieldsNumber&&this.state.actualFieldStructuresNew.mapfieldObj?.map((field, index) => {
                                                    const centerX = field.x + (field.drawWidth / 2);

                                                    return (
                                                        <React.Fragment key={`right-number-${index}`}>
                                                            <rect 
                                                                x={centerX - 15}
                                                                y={this.state.fullscreenheight+15}
                                                                width="50" 
                                                                height="30" 
                                                                fill="white" 
                                                                stroke="#000000" 
                                                                strokeWidth="1"
                                                            />
                                                            <text 
                                                                x={centerX+10}
                                                                y={this.state.fullscreenheight+30}
                                                                fontSize="18" 
                                                                fontWeight="normal" 
                                                                fill="black" 
                                                                textAnchor="middle" 
                                                                dominantBaseline="middle"
                                                            >
                                                                {index + 1}
                                                            </text>
                                                        </React.Fragment>
                                                    );
                                                })}
                                                    </>
                                                )}

                                                
                                                {this.state.getModuleViewSettings?.fieldRightFieldWidth&&this.state.actualFieldStructuresNew.mapfieldObj?.map((field, index) => {
                                                   const fieldBottom = this.state.fullscreenheight + 50;
                                                    return (
                                                        <React.Fragment key={`right-dimension-${index}`}>
                                                            {/* Dimension lines */}
                                                            {true === true && (
                                                                <>
                                                                <line
                                                                x1={field.x} 
                                                                y1={fieldBottom + 10} 
                                                                x2={field.x + field.drawWidth} 
                                                                y2={fieldBottom + 10} 
                                                                stroke="black" 
                                                                strokeWidth="1"
                                                            />
                                                            
                                                            {/* Left arrow */}
                                                            <path 
                                                                d={`M${field.x},${fieldBottom + 10} l5,-5 l0,10 l-5,-5`} 
                                                                fill="black"
                                                            />
                                                            
                                                            {/* Right arrow */}
                                                            <path 
                                                                d={`M${field.x + field.drawWidth},${fieldBottom + 10} l-5,-5 l0,10 l5,-5`} 
                                                                fill="black"
                                                            />
                                                        
                                                            
                                                            {/* Dimension text */}
                                                            <text 
                                                                x={field.x + (field.drawWidth / 2)} 
                                                                y={fieldBottom + 25} 
                                                                fontSize="16" 
                                                                textAnchor="middle"
                                                                direction={"ltr"}
                                                            >
                                                                 {`${parseFloat(field.width).toFixed(2)} ${field?.field_uom === "meters" ? "m" : field?.field_uom}`}
                                                            </text>
                                                            
                                                            {/* Zero marker for first field */}
                                                            {index === 0 && (
                                                                <text 
                                                                    x={field.x - 5} 
                                                                    y={fieldBottom + 25} 
                                                                    fontSize="16" 
                                                                    textAnchor="end"
                                                                >
                                                                    0
                                                                </text>
                                                            )}
                                                                </>
                                                            )}
                                                            
                                                        </React.Fragment>
                                                    );
                                                })}
                                                {/* shelf number */}
                                                {this.state.getModuleViewSettings?.fieldRightAddLeftShelfNo &&
                                                this.state.fullscreenobjs.fields &&
                                                Object.keys(this.state.fullscreenobjs.fields).length > 0 &&
                                                Object.keys(this.state.fullscreenobjs.fields).map((Fld, f) => {
                                                    const fld = this.state.fullscreenobjs.fields[Fld];
                                                    //NEW CODE - 2025 NOV
                                                    return <React.Fragment key={f}>
                                                    {fld.shelf.length > 0 ? fld.shelf.map((shlf, g) => {
                                                        return (
                                                            <g key={g}>
                                                                <rect
                                                                    x={fld.x}
                                                                    y={shlf.y + shlf.drawHeight}
                                                                    width={20}
                                                                    height={14}
                                                                    fill="white"
                                                                    stroke="black"
                                                                    strokeWidth="1"
                                                                />
                                                                <text
                                                                    x={fld.x + 10}
                                                                    y={shlf.y + shlf.drawHeight + 12}
                                                                    fontSize="16"
                                                                    fontWeight="normal"
                                                                    fill="blue"
                                                                    textAnchor="middle"
                                                                >
                                                                    {shlf.rank}
                                                                </text>
                                                            </g>
                                                        )
                                                    }):<></>}
                                                </React.Fragment>
                                                //OLD CODE
                                                // if (!fld?.shelf?.length) return null;

                                                // return (
                                                //     <React.Fragment key={f}>
                                                //         {this.state.actualFieldStructuresNew.mapfieldObj
                                                //             ?.filter((fieldObj) => fieldObj.id === fld.mpFieldId)
                                                //             .map((fieldObj, index) => {
                                                //                 if (!fieldObj?.field_shelves?.length) return null;

                                                //                 return fld.shelf.map((shlf, i) => {
                                                //                     const shelf = fieldObj.field_shelves[i];
                                                //                     if (!shlf?.rank || !shelf) return null;

                                                //                     return (
                                                //                         <g key={shelf.shelf_id}>
                                                //                             <rect
                                                //                                 x={fieldObj.x}
                                                //                                 y={shlf.y + shlf.drawHeight}
                                                //                                 width={20}
                                                //                                 height={14}
                                                //                                 fill="white"
                                                //                                 stroke="black"
                                                //                                 strokeWidth="1"
                                                //                             />
                                                //                             <text
                                                //                                 x={fieldObj.x + 10}
                                                //                                 y={shlf.y + shlf.drawHeight + 12}
                                                //                                 fontSize="16"
                                                //                                 fontWeight="normal"
                                                //                                 fill="blue"
                                                //                                 textAnchor="middle"
                                                //                             >
                                                //                                 {shlf.rank}
                                                //                             </text>
                                                //                         </g>
                                                //                     );
                                                //                 });
                                                //             })}
                                                //     </React.Fragment>
                                                // );
                                                })}
                                        </svg>
                                    </Col>
                                    }
                                </div>
                            </Col>
                            <canvas id="simcatfull-canvas" style={{display: "none"}}></canvas>
                            <canvas id="simcatfull-canvas-wide" style={{display: "none"}}></canvas>
                            <canvas id="simcatfull-canvas-left" style={{display: "none"}}></canvas>
                            <canvas id="simcatfull-canvas-right" style={{display: "none"}}></canvas>
                            <PrintCoverPageView
                                simType={this.props.simType}
                                defSaveObj={this.props.defSaveObj}
                                t={this.props.t} isRTL={this.props.isRTL}
                                mainid="simcatprint-wrapper"
                                subid="simcat-cover"
                                originatedMpName={this.props.originatedMpName}
                                originatedMpId={this.props.originatedMpId}
                                chaindetails={(this.props.signedobj && this.props.signedobj.signinDetails?this.props.signedobj.signinDetails.chain:null)}
                                department={this.props.defSaveObj}
                                signedobj={this.props.signedobj}
                                searchobj={this.props.simulateSearchObj}
                                fieldCount={this.props.simulateCount > 0?this.props.simulateCount:0}
                                isCatview={true}
                                categoryName={(this.state.selectedCatRect && this.state.selectedCatRect.selectedCat && this.state.selectedCatRect.selectedCat)?getNameorIdorColorofBox(this.state.selectedCatRect.selectedCat,"name"):""}
                                isFieldWisePDFPrint={this.state.isFieldWisePDFPrint}
                                clusterData={this.props.clusterData}
                                EditionName={this.props.EditionName}
                                selectedClusterId={this.props.selectedClusterId}
                                fieldCountVal = {this.props.simulationObj?.fieldList?.length}
                                simulationObj={this.props.simulationObj}
                                />
                        </Modal.Body>

                        {this.state.printloading?<Col style={{background:"#f0f0f0",width:"100%",position:"absolute",height: "100%",}}></Col>:<></>}
                    </Modal>

                    <AcViewModal showmodal={this.state.loadinggif} message={this.props.t('PLEASE_WAIT')} />
                    <AcViewModal showmodal={this.state.loadinggif2} message={this.props.t('PLEASE_WAIT')} />
                    <AcViewModal showmodal={this.state.isDisabled} message={this.props.t('PLEASE_WAIT')} />
                    <MpDropProdAlertBox
                        selectedwarningdropprod={this.state.selectedwarningdropprod}
                        isshow={this.state.isProductDropwarn}
                        icon={<MPWarnIcon width={127} height={107} />}
                        ListTitle={this.props.t("UnabletoDropProductbecuse")}
                        successBoderText={this.props.t("OKAY_NOTED")}
                        successBoderAction={this.cannotDropWarningHandle}
                        List={this.state.dropWarningList}
                        handleShowHide={this.cannotDropWarningHandle}
                        handleopenDetailmodal={this.handleopenDetailmodal}
                        reloadProdWarnModalDetails={this.reloadProdWarnModalDetails}
                         />
                    {/* {this.state.selectedProduct && this.state.isShowPreviewModal===true?
                        <Productpreview t={this.props.t} isRTL={this.props.isRTL}
                            isshow={this.state.isShowPreviewModal}
                            showFullSidebar={true}
                            handleSaveProduct={this.handleSaveProduct}
                            selectedProduct={this.state.selectedProduct}
                            tagslist={this.state.tagslist}
                            toggleProductEditModal={this.toggleProductEditModal}
                            loadedTagsList={this.state.loadedTagsList}
                            handleImagePreviewModal={this.handlePreviewModal}
                        />
                        :<></>
                    } */}
                      {this.state.selectedProduct && this.state.isShowPreviewModal===true?
                        <Modal  show={this.state.isShowPreviewModal} className="prod-edit new-product-update-modal" dir={this.props.isRTL} onHide={()=>this.toggleProductEditModal()} backdrop="static" animation={false}>
                            <Modal.Body style={{padding:"30px", background:"#F4F6F7"}}>
                            {
                                    this.state.isShowPreviewModal === true ?
                                    <>
                                        <AddNewItemComponent
                                            productSearchText={this.state.productSearchText}
                                            getSimulationcall={this.props.getSimulationcall}
                                            selectedwarningdropprod={this.state.selectedwarningdropprod}
                                            isFromSimulation={true}
                                            mpstate={this.props.mpstate}
                                            t={this.props.t}
                                            isRTL={this.props.isRTL}
                                            // prodState={this.state.extended_prodObj}
                                            prodState={ {prodDetails:this.state.selectedProduct}}
                                            ismodal={true}
                                            hidemodal={this.toggleProductEditModal}
                                            subcategorylist={this.state.subcategorylist}
                                            brands={this.state.allBrands}
                                            hidedelete={false}
                                            size="sm"
                                        />
                                    </>:
                                    <></>
                            }
                            </Modal.Body>
                        </Modal>:<></>
                      }
                    {
                        this.state.showWarningModal && <Modal  show={this.state.showWarningModal} className="" dir={this.props.isRTL} onHide={()=>this.setState({showWarningModal : false})} animation={false}>
                        {/* <Modal.Header closeButton>
                            <Modal.Title>
                                <span style={{fontWeight: 600, fontSize: 15 }} className="">{this.props.t("ICON_KEY")}</span>
                            </Modal.Title>
                        </Modal.Header> */}
                        <Modal.Body style={{padding:"30px", }}>
                            <Row>
                                <Col sm={1}>
                                <img
                                    src={warningImage}
                                    width={15}
                                    height={15}
                                />
                                </Col>
                                <Col sm={10}>{this.props.t("DIMENTION_CHANGE")}</Col>
                            </Row>
                            <Row>
                                <Col sm={1}>
                                <img
                                    src={warningImageRed}
                                    width={15}
                                    height={15}
                                />
                                </Col>
                                <Col sm={10}>{this.props.t("PRODUCT_DELETE")}</Col>
                            </Row>                          
                        </Modal.Body>
                    </Modal>
                    }


                    {/* <FullscreenSimModal isShowFullscreen={this.state.isShowFullscreen} setFullscreenShow={this.setFullscreenShow} /> */}
                    {this.state.isSetFullScreenEditModal?
                        <FullScreenEditModal
                            actualFieldStructures={this.props.actualFieldStructures}
                            allCategoryData={this.props.allCategoryData}
                            productEditWarningsList={productEditWarningsList}
                            isopenfromAffectedSimList={this.props.isopenfromAffectedSimList}

                            importedDataObj={this.props.importedDataObj}
                            updateImportedDataObj={this.props.updateImportedDataObj}

                            isAuiViewsAllow={isAuiViewsAllow}
                            fieldArrayId={this.props.fieldArrayId}
                            selectFieldArrayId={this.props.selectFieldArrayId}  
                            isStoreReset={this.props.isStoreReset}
                            originatedMpName={this.props.originatedMpName}
                            originatedMpId={this.props.originatedMpId}
                            storeId={this.props.storeId}
                            reloadSimAndTag={this.props.reloadSimAndTag}
                            reloadSimAndStore={this.props.reloadSimAndStore}
                            tagStoreGroup={this.props.tagStoreGroup}
                            toggleLoadingModal={this.props.toggleLoadingModal}
                            selectedTagGroup={this.props.selectedTagGroup}
                            editionId={this.props.editionId}
                            EditionName={this.props.EditionName}
                            setCopyArrangementPrevAfter={this.props.setCopyArrangementPrevAfter}
                            simOption={this.props.simOption}
                            simulateCount={this.props.simulateCount}
                            newSnapshotId={this.props.newSnapshotId}
                            mapobjectsdraw={this.mapobjectsdraw}
                            isFullScreenEdit={true}
                            selectedTagList={this.props.selectedTagList}
                            openOneCategory={this.props.openOneCategory}
                            isSetFullScreenEditModal={this.state.isSetFullScreenEditModal}
                            simType={this.props.simType}
                            handleFullscreenEdit={this.handleFullscreenEdit}
                            mpstate={this.props.mpstate}
                            bottomFieldCount={this.props.bottomFieldCount} isopenfirsttime={this.props.isopenfirsttime}
                            defSaveObj={this.props.defSaveObj}
                            departmentName={this.props.departmentName}
                            getsimulatepayload={this.props.getsimulatepayload}
                            selectedCatRect={this.state.selectedCatRect}//selectedCatRect={this.props.selectedCatRect}
                            signedobj={this.props.signedobj}
                            toggleopenfirsttime={this.props.toggleopenfirsttime}
                            toggleOneCategory={this.props.toggleOneCategory}
                            haveChnagesinCat={this.props.haveChnagesinCat} isRTL={this.props.isRTL}
                            handlebackinsaveChnages={this.props.handlebackinsaveChnages}
                            handlehaveChnagesinCat={this.props.handlehaveChnagesinCat}
                            simulationObj={this.props.simulationObj}
                            notReleatedProdList={this.props.notReleatedProdList}
                            simulateSearchObj={this.props.simulateSearchObj}
                            updateSaveReloadStatus={this.props.updateSaveReloadStatus}
                            sendmarkStackableCall={this.props.sendmarkStackableCall}
                            dmode={this.props.dmode}
                            isSalesCycle={this.props.isSalesCycle}
                            isSCycle={this.props.isSCycle}
                            mapFields={this.props.mapFields}
                            mapCategories={this.props.mapCategories}
                            mapProducts={this.props.mapProducts}
                            productsWithAnomaly={this.props.productsWithAnomaly}
                            getProductAnomalies={this.props.getProductAnomalies}
                            changeSaleCycleActive={this.props.changeSaleCycleActive}
                            disableSalesCycleState={this.props.disableSalesCycleState}
                            sendmarkStackableCallParent={this.sendmarkStackableCall}
                            handleFullscreenEditMethodcall={this.handleFullscreenEditMethodcall}
                            isShowFromPreview={this.props.isShowFromPreview}
                            selectedSimPreviewObj={this.props.selectedSimPreviewObj}
                            isPrintPending={this.props.isPrintPending}
                            isPDFPrintPending={this.props.isPDFPrintPending}
                            isFieldWisePDFPrint={this.props.isFieldWisePDFPrint}
                            togglePrintPending={this.props.togglePrintPending}
                            getSimulationcall={this.props.getSimulationcall}
                            handleacknowledgeSimulationWarning={this.props.handleacknowledgeSimulationWarning}
                            isNewProdSim={this.props.isNewProdSim}
                            isChainSaleCycle={this.props.isChainSaleCycle}
                            updateIsChainSaleCycle={this.props.updateIsChainSaleCycle}
                            isSaleCycleUpdated={this.props.isSaleCycleUpdated}
                            updateIsSaleCycleUpdated={this.props.updateIsSaleCycleUpdated}
                            selectedScProductId={this.state.selectedScProductId}
                            loadData = {this.props.loadData}
                            getSimulatePlanogram ={this.props.getSimulatePlanogram}
                            pegList={this.state.pegList}
                            mapPegProducts={this.state.pegProductList}
                            pegProductOriginalList={this.props.pegProductOriginalList}

                            clusterData={this.props.clusterData}
                            selectedClusterId={this.props.selectedClusterId}
                            saleStartDate={this.props.saleStartDate}
                            clusterId={this.props.clusterId}
                            saleEndDate={this.props.saleEndDate}
                            createdDate={this.props.createdDate}
                        />
                        :<></>}
                </Col>

                <TakeBackOverlapWarn t={this.props.t} isRTL={this.props.isRTL}
                    isShowTakeBackError={this.state.isShowTakeBackError}
                    takeBackErrorObj={this.state.takeBackErrorObj}
                    toggleTakebackWarnModal={this.toggleTakebackWarnModal}
                    />

                {this.props.isShowFromPreview?<NewProdStrategyApplyModal t={this.props.t} isRTL={this.props.isRTL}
                    isShowStrategyModal={this.state.isShowStrategyModal}
                    selectedSaveProds={this.state.selectedSaveProds}
                    chainOptionToAll={this.chainOptionToAll}
                    continueNewProdApply={this.continueNewProdApply}
                    handleChangeStrategy={this.handleChangeStrategy}
                    handleImagePreviewModal={this.handleImagePreviewModal}
                    toggleStrategyApplyModal={this.toggleStrategyApplyModal}
                    toggleStrategyHelpDrop={this.toggleStrategyHelpDrop}
                    />:<></>}
                
                {/* 2025 SEP - DU EDIT CR */}
                {this.state.showDUEditComponent ?
                    <DisplayUnitEdit
                        showDUEditComponent = {this.state.showDUEditComponent}
                        hideDUEditComponent = {() => this.setState({showDUEditComponent: false})}
                        isRTL = {this.props.isRTL}
                        dmode = {this.props.dmode}
                        distanceFromTop = {this.state.distanceFromTop}
                        mapFields = {this.state.mapFields}
                        svgdrawDiemention = {this.state.svgdrawDiemention}
                        svgViewId = {this.state.svgViewId}
                        catDivHeight = {this.state.catDivHeight}
                        displayRatio={this.state.displayRatio}
                        pegBoardList = {this.state.pegList}
                        mapProducts = {this.state.mapproductList}
                        topProductHeights = {this.state.topProductHeights}
                        onSave = {this.handleDUEditSave}
                        spacefromtopsvgdraw = {this.state.spacefromtopsvgdraw}
                        markablestackable = {this.state.markablestackable}
                        IsShowStackables = {this.state.IsShowStackables}
                        selectedScProductId = {this.state.selectedScProductId}
                        displayUOM = {this.state.displayUOM}
                    />
                : <></>}


                <FieldArrayConfirmModal
                    show={this.state.isShowShelfDifferentCopyArrangementModal}
                    setShow={this.clearInitialShelfMismtachWarning}
                    data={this.state.setUnsavedChangesModalData}
                    closeButtonLabel="btnnames.close"
                    hideConfirmButton={true}
                />

            </Col>
        )
    }
}
//comment below  this if component breack
function ProdRectView(props) {
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const prod = props.prod;
    const isshowview = (props.viewtype === "LIST"?false:true);
    const trans = props.t;
    return (
      <>
        <div ref={target} onMouseOver={() => setShow(isshowview)} onMouseOut={() => setShow(false)}>
          {props.children}
        </div>
        <Overlay target={target.current} transition={false} show={show} 
        // placement={props.isRTL==="rtl"?"left":"right"}
        placement='top'
        >
          {(props) => (
            <Tooltip {...props}>
              <><small style={{fontSize:"0.75rem"}}>{prod.barcode&&prod.barcode}</small><br/>{(prod.brandName&&prod.brandName!==""&&prod.brandName!=="-"?(prod.brandName+" "):(i18n.t("notavailable")+" "))+prod.productName}<br/>
              <small style={{fontSize:"0.75rem"}}><i>{trans?trans('WIDTH'):"Width"} {prod.width+""+convertUomtoSym(prod.uom)}, {trans?trans('HEIGHT'):"Height"} {prod.height+""+convertUomtoSym(prod.uom)}</i></small></>
            </Tooltip>
          )}
        </Overlay>
      </>
    );
}

export function ContextMenu(props) {
    var xPos = props.xpos; //x position
    var yPos = props.ypos; //y position

  const popupRef = React.useRef(null);
  const [adjustedXPos, setAdjustedXPos] = React.useState(xPos);
  const [adjustedXposRTL, setAdjustedXposRTL] = React.useState(xPos);
  const [adjustedYPos, setAdjustedYPos] = React.useState(yPos);
  const [firstInputDisabled, setFirstInputDisabled] = useState(false);
  const [secondInputDisabled, setSecondInputDisabled] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [firstValue, setFirstValue] = useState("");
const [secondValue, setSecondValue] = useState("");

  React.useLayoutEffect(() => {
    if (popupRef.current) {
      const popupRect = popupRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const parentRect = props.parentRef.current.getBoundingClientRect();


    // adjust y position to prevent overflow on the bottom of the sim
    let newYPos = yPos;
    const popupBottom = yPos + popupRect.height;
    const parentBottom = parentRect.bottom;

    if (popupBottom > parentBottom) {
    newYPos = yPos - (popupBottom - parentBottom);
    if (newYPos < 0) newYPos = 0;
    }
    
    setAdjustedYPos(newYPos);

      if(props.isRTL === "rtl") {
        if(!props.isFullScreenAUI && props.simType === "AUI"){
            const overflowLeft = xPos < 0;
            const overflowRight = xPos + popupRect.width > parentRect?.width;

            let newXPosRTL = xPos;
            if (overflowLeft) {
                newXPosRTL = 0;
            } else if (overflowRight) {
                newXPosRTL = parentRect?.width - popupRect.width;
                if (newXPosRTL < 0) newXPosRTL = 0;
            }
            setAdjustedXposRTL(newXPosRTL);
        } else {
            let newXPosRTL = xPos;
            
            // check if popup would overflow to the left
            if (xPos < parentRect?.left) {
                // if popup would overflow left, position it at left edge of parent
                newXPosRTL = parentRect?.left;
            }
            
            // check if it would overflow to the right
            if (xPos + popupRect.width > parentRect?.right) {
                newXPosRTL = parentRect?.right - popupRect.width;
            }

            setAdjustedXposRTL(newXPosRTL);
        }
      }else{
        // Adjust x position to prevent overflow
        const newXPos = Math.min(xPos, parentRect?.width - popupRect.width);
        setAdjustedXPos(newXPos < 0 ? 0 : newXPos); // Ensure it doesn't go off-screen on the left 
      }
    }
  }, [xPos, yPos , props.isRTL, props.parentRef]);

  //handle click a button. 2-delete, type: 2-expand, 3-close
  const handleClick = (type,event) => {
      if(type === 1){
          props.handledelete();
      } if(type === 2){
          props.handlexpand();
      } else if(type === 4){
          props.handledeleteall();
      } else if(type === 5){
        props.handledeleteall();
    } else{
          props.handlclose();
      }
  }

  // handle group selection copy cut and delete
  // 1 - copy , 2 - cut , 3 - delete
  const handleGroupClck = (type, event) => {
    if(type === 1){
        props.handleBlockCut(true);
    }
    if(type === 2){
        props.handleBlockCut();
    }
    if( type === 3){
        props.handleBlockDelete(false,true);
    }
  }

  const handleCutItem = (iscopy,isFromDelete) => {
      props.cutContextItem(iscopy, props.currentprod,isFromDelete);
  }
  const viewproduct = (prod) => {
    let cprod = JSON.parse(JSON.stringify(prod)); // Deep copy
    cprod.id = cprod.productId;
    props.handleopenDetailmodal(cprod);
}

  let proddetails = (props.currentprod && props.currentprod.prod?props.currentprod.prod:null);
  return (<>
    <div ref={popupRef} className="pdunit-prodcontext-menu simcontext-menu" onContextMenu={(e)=>{ e.preventDefault()}} style={{ zIndex:'99999', top: adjustedYPos, left: props.isRTL === "rtl" ? adjustedXposRTL : adjustedXPos,
           }}>
    {/* top: yPos, left: (xPos-(props.isRTL==="rtl"?-380:0) */}
        <span className="viewmenu-span" id="contextm_close" onClick={() => handleClick(3)}><XIcon size={16} /></span>
        {props.currentprod?<Row>
            <Col xs={2}><div className="thumb-div" style={{padding:"2px"}} onClick={()=>props.handlePreviewModal(props.currentprod.prod,true)}>
                    <img src={props.currentprod.prod.imageUrl} className={proddetails?(proddetails.width >= proddetails.height?"img-resize-ver":"img-resize-hor"):""} alt="" style={{width:"95%"}}/>
                </div>
            </Col>
            <Col xs={10} style={{paddingTop:"10px"}}>
           
                <h4>
                    <small id="contextm_bcode">{props.currentprod&&props.currentprod.prod?<CopyToClipboard text={props.currentprod.prod.barcode} onCopy={() => props.copyToClipboard()}><span className="copy-hover">{props.currentprod.prod.barcode}</span></CopyToClipboard>:"-"}</small><br/>
                    <span className='SelNameLable' onClick={()=>proddetails?.isProductDelete ? null : viewproduct(props.currentprod.prod)}>{props.currentprod&&props.currentprod.prod?(props.currentprod.prod.name):"-"}</span><br/><br/>

                    {aiSimulationUser.includes(props?.userData?.id?.toString()) && (
                        <>
                            <span className='SelNameLable'>Sell Price - {props.currentprod&&props.currentprod.prod?(props.currentprod.prod?.sell_price):"-"}</span><br/>
                            <span className='SelNameLable'>Profit - {props.currentprod&&props.currentprod.prod?(props.currentprod.prod?.totalProfit):"-"}</span><br/>
                            <span className='SelNameLable'>Volume - {props.currentprod&&props.currentprod.prod?(`${props.currentprod.prod.height * props.currentprod.prod.width * props.currentprod.prod.depth}`):"-"}{props.currentprod.prod?.uom}<sup>3</sup></span><br/>
                            <span className='SelNameLable'>Dimension - {`W - ${props.currentprod.prod?.width} | H - ${props.currentprod.prod?.height} | D - ${props.currentprod.prod?.depth}`}</span><br/>
                        </>
                    )}
                </h4>
            </Col>
        </Row>:<></>}

        <hr style={{marginBottom:"22px",marginTop:"6px"}}/>
        <ul 
        className="list-inline" 
        style={{
            textAlign:(props.isRTL==="rtl"?"left":"right"), 
            paddingRight: "0px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }}>
            {/* Expand button commented due to new CR */}
            {props.currentprod && (props.currentprod?.prod?.isHanged == undefined || !props.currentprod?.prod?.isHanged) &&  !proddetails?.isProductDelete ? (
            <li className={"list-inline-item "+(props.isRTL==="rtl"?"float-right":"float-left")} id="contextm_expand" onClick={() => handleClick(2)}><Button variant={(props.isexpand?"success":"secondary")} size="sm"><PlusIcon size={12}/> {i18n.t("expand")}</Button></li>
            ) : (
            <li className={"list-inline-item "+(props.isRTL==="rtl"?"float-right":"float-left")} id="contextm_expand"></li>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {proddetails?.isProductDelete ? null : <li className="list-inline-item no-hover" onClick={() => {props?.isGroupContexMenu ? handleGroupClck(1) : handleCutItem(true)}}><Button variant="secondary" size="sm" title={"Copy"}><FeatherIcon icon={"copy"} size={12} /></Button></li>}
                {proddetails?.isProductDelete ? null : <li className="list-inline-item no-hover" onClick={() => {props?.isGroupContexMenu ? handleGroupClck(2) : handleCutItem()}}><Button variant="secondary" size="sm" title={"Cut"}><FeatherIcon icon={"scissors"} size={12} /></Button></li>}

                <li className="list-inline-item no-hover" id="contextm_delete"
                // onClick={() => handleClick(1)}
                onClick={() => {props?.isGroupContexMenu ? handleGroupClck(3) : handleCutItem(false,true)}}
                ><Button variant="danger" size="sm"><TrashIcon size={12}/></Button></li>
                {/* <li className="list-inline-item" id="contextm_deleteall" style={(props.isRTL==="rtl"?{marginRight:"8px"}:{})} onClick={() => handleClick(4)}><Button variant="danger" size="sm"><TrashIcon size={12}/> {i18n.t("btnnames.all")}</Button></li> */}
            </div>
        </ul>
        {props.currentprod && (props.currentprod?.prod?.isHanged == undefined || !props.currentprod?.prod?.isHanged) && !proddetails?.isProductDelete &&  (
        <ul 
        className="list-inline" 
        style={{
            textAlign:(props.isRTL==="rtl"?"left":"right"), 
            paddingRight: "0px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop:"5px"
        }}>
            <li style={{display:'flex', width:'100%', justifyContent:'space-between', cursor:'default' }}>
                <div style={{borderRadius: 20, border: '1px solid #5128a0', width: 130, height: 30, overflow: 'hidden', justifyContent:'center', alignContent:'center'}}>
                    <input
                        id="newInput"
                        type="text"
                        className="form-control"
                        placeholder={props.placeHolderText}
                        style={{
                            width:130, 
                            height: 20, 
                            border: "none", 
                            boxShadow: "none", 
                            outline:"none",
                            appearance: "textfield",
                            MozAppearance: "textfield",
                            WebkitAppearance: "none",
                        }}
                        disabled={firstInputDisabled || hasSubmitted}
                        value={firstValue}
                        onChange={(e) => {
                            const val = e.target.value;
                            setFirstValue(val);
                        
                            if (!hasSubmitted) {
                              // Disable second only if something typed
                              setSecondInputDisabled(val !== "");
                            }
                          }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                            const value = e.target.value.trim();
                            if (!isNaN(value) && value !== "") {
                                const numericValue = parseFloat(value);
                                if (!Number.isInteger(numericValue)) {
                                    alertService.error(props.integerErrorMessage);
                                    return;
                                }
                                if (numericValue < 0) {
                                    // Trigger a different function for negative values
                                    alertService.error(props.validPositiveNumberErrorMessage);
                                    return;
                                    //props.handleExpandNegativeNumberInput(numericValue);
                                } else {
                                    // Trigger the regular function for non-negative values
                                    props.handleExpandNumberInput(numericValue);
                                    setHasSubmitted(true);
                                    setFirstInputDisabled(true);
                                }
                            } else {
                                alertService.error(props.validNumberErrorMessage);
                            }
                            }
                        }}
                    />
                    
                </div>
                {props.currentprod && props?.currentprod?.prod?.isStackable && (
                    <div style={{borderRadius: 20, border: '1px solid #5128a0', width: 130, height: 30, overflow: 'hidden', justifyContent:'center', alignContent:'center'}}>
                    <input
                        id="newInput"
                        type="text"
                        className="form-control"
                        placeholder={props.StackplaceHolderText}
                        style={{
                            width:130, 
                            height: 20, 
                            border: "none", 
                            boxShadow: "none", 
                            outline:"none",
                            appearance: "textfield",
                            MozAppearance: "textfield",
                            WebkitAppearance: "none",
                        }}
                        disabled={secondInputDisabled || hasSubmitted}
                        value={secondValue}
                        onChange={(e) => {
                            const val = e.target.value;
                            setSecondValue(val);
                        
                            if (!hasSubmitted) {
                              setFirstInputDisabled(val !== "");
                            }
                          }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                            const value = e.target.value.trim();
                            if (!isNaN(value) && value !== "") {
                                const numericValue = parseFloat(value);
                                if (!Number.isInteger(numericValue)) {
                                    alertService.error(props.integerErrorMessage);
                                    return;
                                }
                                if (numericValue < 0) {
                                    // Trigger a different function for negative values
                                    alertService.error(props.validPositiveNumberErrorMessage);
                                    return;
                                    //props.handleExpandNegativeNumberInput(numericValue);
                                }else if((props.currentprod.prod.maxStackableCount>0)&&numericValue > props.currentprod.prod.maxStackableCount){
                                    alertService.error(`${props.stackvalidNumberErrorMessage} `+props.currentprod.prod.maxStackableCount);
                                    return;
                                }else {
                                    // Trigger the regular function for non-negative values
                                    props.handleExpandStackInput(numericValue);
                                    setHasSubmitted(true);
                                    setSecondInputDisabled(true);
                                }
                            } else {
                                alertService.error(props.validNumberErrorMessage);
                            }
                            }
                        }}
                    />
                    
                </div>
                )  }
                
            </li>
        </ul>
        )}
    </div>
  </>);
}
const mapStateToProps = (state) => ({
  signedobj: state.signState,
  shouldDownloadAfterRefresh: state.simulateAll.shouldDownloadAfterRefresh,
});

const mapDispatchToProps = dispatch => ({
    setMPCategoryChanges: (payload) => dispatch(MPCategoryChangesSetAction(payload)),
    setMPStackableProdListArray: (payload) => dispatch(mpstackableMarkListAction(payload)),
    setMpEditStackHistory: (payload) => dispatch(mpEditStackHistorySetAction(payload)),
    setMpFullscreenchngesobj: (payload) => dispatch(mpAftersaveFullScreenObjSetAction(payload)),
    // setMpClipBoardsforCats: (payload) => dispatch(mpsetClipBoardandotherforCatSetAction(payload)),
    setSimulationNewProductSearchDetails:(payload) => dispatch(SimulationNewProductSearchDetailsSetAction(payload)),
    setShouldDownloadAfterRefresh: (value) => dispatch(setShouldDownloadAfterRefresh(value)),
});
export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(EditSimulateCategory)))
